
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec150"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec150"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gpPIU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "unByKey", function () { return $bf371a50d25c0daf$export$b7ef3f8527533384; });
$parcel$export(module.exports, "default", function () { return $bf371a50d25c0daf$export$2e2bcd8739ae039; });

var $gNCG1 = parcelRequire("gNCG1");

var $cFmyb = parcelRequire("cFmyb");

var $1dBX3 = parcelRequire("1dBX3");
var $bf371a50d25c0daf$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ var $bf371a50d25c0daf$var$Observable = /** @class */ function(_super) {
    $bf371a50d25c0daf$var$__extends(Observable, _super);
    function Observable() {
        var _this = _super.call(this) || this;
        _this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ _this.onInternal;
        _this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ _this.onceInternal;
        _this.un = /** @type {ObservableOnSignature<void>} */ _this.unInternal;
        /**
         * @private
         * @type {number}
         */ _this.revision_ = 0;
        return _this;
    }
    /**
     * Increases the revision counter and dispatches a 'change' event.
     * @api
     */ Observable.prototype.changed = function() {
        ++this.revision_;
        this.dispatchEvent((0, $cFmyb.default).CHANGE);
    };
    /**
     * Get the version number for this object.  Each time the object is modified,
     * its version number will be incremented.
     * @return {number} Revision.
     * @api
     */ Observable.prototype.getRevision = function() {
        return this.revision_;
    };
    /**
     * @param {string|Array<string>} type Type.
     * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
     * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
     * @protected
     */ Observable.prototype.onInternal = function(type, listener) {
        if (Array.isArray(type)) {
            var len = type.length;
            var keys = new Array(len);
            for(var i = 0; i < len; ++i)keys[i] = (0, $1dBX3.listen)(this, type[i], listener);
            return keys;
        } else return (0, $1dBX3.listen)(this, /** @type {string} */ type, listener);
    };
    /**
     * @param {string|Array<string>} type Type.
     * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
     * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
     * @protected
     */ Observable.prototype.onceInternal = function(type, listener) {
        var key;
        if (Array.isArray(type)) {
            var len = type.length;
            key = new Array(len);
            for(var i = 0; i < len; ++i)key[i] = (0, $1dBX3.listenOnce)(this, type[i], listener);
        } else key = (0, $1dBX3.listenOnce)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    };
    /**
     * Unlisten for a certain type of event.
     * @param {string|Array<string>} type Type.
     * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
     * @protected
     */ Observable.prototype.unInternal = function(type, listener) {
        var key = /** @type {Object} */ listener.ol_key;
        if (key) $bf371a50d25c0daf$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(var i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    };
    return Observable;
}((0, $gNCG1.default));
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $bf371a50d25c0daf$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $bf371a50d25c0daf$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $bf371a50d25c0daf$var$Observable.prototype.un;
function $bf371a50d25c0daf$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(var i = 0, ii = key.length; i < ii; ++i)(0, $1dBX3.unlistenByKey)(key[i]);
    else (0, $1dBX3.unlistenByKey)(/** @type {import("./events.js").EventsKey} */ key);
}
var $bf371a50d25c0daf$export$2e2bcd8739ae039 = $bf371a50d25c0daf$var$Observable;

});
parcelRegister("gNCG1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3af395cfd3bd2cf$export$2e2bcd8739ae039; });

var $fy27o = parcelRequire("fy27o");

var $bNM9R = parcelRequire("bNM9R");

var $c8IGo = parcelRequire("c8IGo");

var $9zTj4 = parcelRequire("9zTj4");
var $c3af395cfd3bd2cf$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ var $c3af395cfd3bd2cf$var$Target = /** @class */ function(_super) {
    $c3af395cfd3bd2cf$var$__extends(Target, _super);
    /**
     * @param {*} [opt_target] Default event target for dispatched events.
     */ function Target(opt_target) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {*}
         */ _this.eventTarget_ = opt_target;
        /**
         * @private
         * @type {Object<string, number>}
         */ _this.pendingRemovals_ = null;
        /**
         * @private
         * @type {Object<string, number>}
         */ _this.dispatching_ = null;
        /**
         * @private
         * @type {Object<string, Array<import("../events.js").Listener>>}
         */ _this.listeners_ = null;
        return _this;
    }
    /**
     * @param {string} type Type.
     * @param {import("../events.js").Listener} listener Listener.
     */ Target.prototype.addEventListener = function(type, listener) {
        if (!type || !listener) return;
        var listeners = this.listeners_ || (this.listeners_ = {});
        var listenersForType = listeners[type] || (listeners[type] = []);
        if (listenersForType.indexOf(listener) === -1) listenersForType.push(listener);
    };
    /**
     * Dispatches an event and calls all listeners listening for events
     * of this type. The event parameter can either be a string or an
     * Object with a `type` property.
     *
     * @param {import("./Event.js").default|string} event Event object.
     * @return {boolean|undefined} `false` if anyone called preventDefault on the
     *     event object or if any of the listeners returned false.
     * @api
     */ Target.prototype.dispatchEvent = function(event) {
        var isString = typeof event === 'string';
        var type = isString ? event : event.type;
        var listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        var evt = isString ? new (0, $bNM9R.default)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        var dispatching = this.dispatching_ || (this.dispatching_ = {});
        var pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        var propagate;
        for(var i = 0, ii = listeners.length; i < ii; ++i){
            if ('handleEvent' in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            var pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $c8IGo.VOID));
            delete dispatching[type];
        }
        return propagate;
    };
    /**
     * Clean up.
     */ Target.prototype.disposeInternal = function() {
        this.listeners_ && (0, $9zTj4.clear)(this.listeners_);
    };
    /**
     * Get the listeners for a specified event type. Listeners are returned in the
     * order that they will be called in.
     *
     * @param {string} type Type.
     * @return {Array<import("../events.js").Listener>|undefined} Listeners.
     */ Target.prototype.getListeners = function(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    };
    /**
     * @param {string} [opt_type] Type. If not provided,
     *     `true` will be returned if this event target has any listeners.
     * @return {boolean} Has listeners.
     */ Target.prototype.hasListener = function(opt_type) {
        if (!this.listeners_) return false;
        return opt_type ? opt_type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    };
    /**
     * @param {string} type Type.
     * @param {import("../events.js").Listener} listener Listener.
     */ Target.prototype.removeEventListener = function(type, listener) {
        var listeners = this.listeners_ && this.listeners_[type];
        if (listeners) {
            var index = listeners.indexOf(listener);
            if (index !== -1) {
                if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                    // make listener a no-op, and remove later in #dispatchEvent()
                    listeners[index] = (0, $c8IGo.VOID);
                    ++this.pendingRemovals_[type];
                } else {
                    listeners.splice(index, 1);
                    if (listeners.length === 0) delete this.listeners_[type];
                }
            }
        }
    };
    return Target;
}((0, $fy27o.default));
var $c3af395cfd3bd2cf$export$2e2bcd8739ae039 = $c3af395cfd3bd2cf$var$Target;

});
parcelRegister("fy27o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b51baca7c9a083b4$export$2e2bcd8739ae039; });
/**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ var $b51baca7c9a083b4$var$Disposable = /** @class */ function() {
    function Disposable() {
        /**
         * The object has already been disposed.
         * @type {boolean}
         * @protected
         */ this.disposed = false;
    }
    /**
     * Clean up.
     */ Disposable.prototype.dispose = function() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    };
    /**
     * Extension point for disposable objects.
     * @protected
     */ Disposable.prototype.disposeInternal = function() {};
    return Disposable;
}();
var $b51baca7c9a083b4$export$2e2bcd8739ae039 = $b51baca7c9a083b4$var$Disposable;

});

parcelRegister("bNM9R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8979a0822c43cc2b$export$2e2bcd8739ae039; });
/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ var $8979a0822c43cc2b$var$BaseEvent = /** @class */ function() {
    /**
     * @param {string} type Type.
     */ function BaseEvent(type) {
        /**
         * @type {boolean}
         */ this.propagationStopped;
        /**
         * @type {boolean}
         */ this.defaultPrevented;
        /**
         * The event type.
         * @type {string}
         * @api
         */ this.type = type;
        /**
         * The event target.
         * @type {Object}
         * @api
         */ this.target = null;
    }
    /**
     * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
     * will be fired.
     * @api
     */ BaseEvent.prototype.preventDefault = function() {
        this.defaultPrevented = true;
    };
    /**
     * Stop event propagation.
     * @api
     */ BaseEvent.prototype.stopPropagation = function() {
        this.propagationStopped = true;
    };
    return BaseEvent;
}();
function $8979a0822c43cc2b$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $8979a0822c43cc2b$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $8979a0822c43cc2b$export$2e2bcd8739ae039 = $8979a0822c43cc2b$var$BaseEvent;

});

parcelRegister("c8IGo", function(module, exports) {

$parcel$export(module.exports, "TRUE", function () { return $8d68e4745129b487$export$22e23a2304399231; });
$parcel$export(module.exports, "FALSE", function () { return $8d68e4745129b487$export$8f11cee4bdc7e668; });
$parcel$export(module.exports, "VOID", function () { return $8d68e4745129b487$export$1cd1943b3a73bbe8; });
$parcel$export(module.exports, "memoizeOne", function () { return $8d68e4745129b487$export$ff83df6f9971435f; });
/**
 * @module ol/functions
 */ 
var $kzmGH = parcelRequire("kzmGH");
function $8d68e4745129b487$export$22e23a2304399231() {
    return true;
}
function $8d68e4745129b487$export$8f11cee4bdc7e668() {
    return false;
}
function $8d68e4745129b487$export$1cd1943b3a73bbe8() {}
function $8d68e4745129b487$export$ff83df6f9971435f(fn) {
    var called = false;
    /** @type {ReturnType} */ var lastResult;
    /** @type {Array<any>} */ var lastArgs;
    var lastThis;
    return function() {
        var nextArgs = Array.prototype.slice.call(arguments);
        if (!called || this !== lastThis || !(0, $kzmGH.equals)(nextArgs, lastArgs)) {
            called = true;
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $8d68e4745129b487$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        var value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}

});
parcelRegister("kzmGH", function(module, exports) {

$parcel$export(module.exports, "binarySearch", function () { return $ef98acda7dde127d$export$2e0ae67339d5f1ac; });
$parcel$export(module.exports, "numberSafeCompareFunction", function () { return $ef98acda7dde127d$export$4e734a3b32fb971b; });
$parcel$export(module.exports, "linearFindNearest", function () { return $ef98acda7dde127d$export$8a3786cc03fdb777; });
$parcel$export(module.exports, "reverseSubArray", function () { return $ef98acda7dde127d$export$292cfa960964f0e0; });
$parcel$export(module.exports, "extend", function () { return $ef98acda7dde127d$export$8b58be045bf06082; });
$parcel$export(module.exports, "equals", function () { return $ef98acda7dde127d$export$e9bab7fafb253603; });
$parcel$export(module.exports, "isSorted", function () { return $ef98acda7dde127d$export$efa610630f9e181; });
/**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [opt_comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $ef98acda7dde127d$export$2e0ae67339d5f1ac(haystack, needle, opt_comparator) {
    var mid, cmp;
    var comparator = opt_comparator || $ef98acda7dde127d$export$4e734a3b32fb971b;
    var low = 0;
    var high = haystack.length;
    var found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
         * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $ef98acda7dde127d$export$4e734a3b32fb971b(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $ef98acda7dde127d$export$ee2e0f811dca1807(arr, obj) {
    return arr.indexOf(obj) >= 0;
}
function $ef98acda7dde127d$export$8a3786cc03fdb777(arr, target, direction) {
    var n = arr.length;
    if (arr[0] <= target) return 0;
    else if (target <= arr[n - 1]) return n - 1;
    else {
        var i = void 0;
        if (direction > 0) for(i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        else if (direction < 0) for(i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        else for(i = 1; i < n; ++i){
            if (arr[i] == target) return i;
            else if (arr[i] < target) {
                if (typeof direction === 'function') {
                    if (direction(target, arr[i - 1], arr[i]) > 0) return i - 1;
                    else return i;
                } else if (arr[i - 1] - target < target - arr[i]) return i - 1;
                else return i;
            }
        }
        return n - 1;
    }
}
function $ef98acda7dde127d$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        var tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $ef98acda7dde127d$export$8b58be045bf06082(arr, data) {
    var extension = Array.isArray(data) ? data : [
        data
    ];
    var length = extension.length;
    for(var i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $ef98acda7dde127d$export$cd7f480d6b8286c3(arr, obj) {
    var i = arr.indexOf(obj);
    var found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $ef98acda7dde127d$export$71aa6c912b956294(arr, func) {
    var length = arr.length >>> 0;
    var value;
    for(var i = 0; i < length; i++){
        value = arr[i];
        if (func(value, i, arr)) return value;
    }
    return null;
}
function $ef98acda7dde127d$export$e9bab7fafb253603(arr1, arr2) {
    var len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(var i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $ef98acda7dde127d$export$c7d3d1f96a700512(arr, compareFnc) {
    var length = arr.length;
    var tmp = Array(arr.length);
    var i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $ef98acda7dde127d$export$de3a4d4a0d731119(arr, func) {
    var index;
    var found = !arr.every(function(el, idx) {
        index = idx;
        return !func(el, idx, arr);
    });
    return found ? index : -1;
}
function $ef98acda7dde127d$export$efa610630f9e181(arr, opt_func, opt_strict) {
    var compare = opt_func || $ef98acda7dde127d$export$4e734a3b32fb971b;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        var res = compare(arr[index - 1], currentVal);
        return !(res > 0 || opt_strict && res === 0);
    });
}

});


parcelRegister("9zTj4", function(module, exports) {

$parcel$export(module.exports, "assign", function () { return $6f9248ac56828700$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "clear", function () { return $6f9248ac56828700$export$42ffd38884aecdac; });
$parcel$export(module.exports, "getValues", function () { return $6f9248ac56828700$export$a5c4301012ad6f07; });
$parcel$export(module.exports, "isEmpty", function () { return $6f9248ac56828700$export$dd1bc94b04021eeb; });
/**
 * @module ol/obj
 */ /**
 * Polyfill for Object.assign().  Assigns enumerable and own properties from
 * one or more source objects to a target object.
 * See https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign.
 *
 * @param {!Object} target The target object.
 * @param {...Object} var_sources The source object(s).
 * @return {!Object} The modified target object.
 */ var $6f9248ac56828700$export$e6e34fd1f2686227 = typeof Object.assign === 'function' ? Object.assign : function(target, var_sources) {
    if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
    var output = Object(target);
    for(var i = 1, ii = arguments.length; i < ii; ++i){
        var source = arguments[i];
        if (source !== undefined && source !== null) {
            for(var key in source)if (source.hasOwnProperty(key)) output[key] = source[key];
        }
    }
    return output;
};
function $6f9248ac56828700$export$42ffd38884aecdac(object) {
    for(var property in object)delete object[property];
}
var $6f9248ac56828700$export$a5c4301012ad6f07 = typeof Object.values === 'function' ? Object.values : function(object) {
    var values = [];
    for(var property in object)values.push(object[property]);
    return values;
};
function $6f9248ac56828700$export$dd1bc94b04021eeb(object) {
    var property;
    for(property in object)return false;
    return !property;
}

});


parcelRegister("cFmyb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $938ace682f3b3355$export$2e2bcd8739ae039; });
/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $938ace682f3b3355$export$2e2bcd8739ae039 = {
    /**
     * Generic change event. Triggered when the revision counter is increased.
     * @event module:ol/events/Event~BaseEvent#change
     * @api
     */ CHANGE: 'change',
    /**
     * Generic error event. Triggered when an error occurs.
     * @event module:ol/events/Event~BaseEvent#error
     * @api
     */ ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel'
};

});

parcelRegister("1dBX3", function(module, exports) {

$parcel$export(module.exports, "listen", function () { return $0e3471b240f43c04$export$63174c828edd6ff8; });
$parcel$export(module.exports, "listenOnce", function () { return $0e3471b240f43c04$export$8d2a95bc11b44725; });
$parcel$export(module.exports, "unlistenByKey", function () { return $0e3471b240f43c04$export$b0a21c8b3c1c921; });
/**
 * @module ol/events
 */ 
var $9zTj4 = parcelRequire("9zTj4");
function $0e3471b240f43c04$export$63174c828edd6ff8(target, type, listener, opt_this, opt_once) {
    if (opt_this && opt_this !== target) listener = listener.bind(opt_this);
    if (opt_once) {
        var originalListener_1 = listener;
        listener = function() {
            target.removeEventListener(type, listener);
            originalListener_1.apply(this, arguments);
        };
    }
    var eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $0e3471b240f43c04$export$8d2a95bc11b44725(target, type, listener, opt_this) {
    return $0e3471b240f43c04$export$63174c828edd6ff8(target, type, listener, opt_this, true);
}
function $0e3471b240f43c04$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $9zTj4.clear)(key);
    }
}

});


parcelRegister("827vD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "GroupEvent", function () { return $5d9455cb09457c80$export$2f5ff21d758d25a7; });
$parcel$export(module.exports, "default", function () { return $5d9455cb09457c80$export$2e2bcd8739ae039; });

var $1iJu5 = parcelRequire("1iJu5");

var $1IaXJ = parcelRequire("1IaXJ");

var $59kE1 = parcelRequire("59kE1");

var $bNM9R = parcelRequire("bNM9R");

var $cFmyb = parcelRequire("cFmyb");

var $48iCR = parcelRequire("48iCR");

var $3JLp3 = parcelRequire("3JLp3");

var $9zTj4 = parcelRequire("9zTj4");

var $2Jl0K = parcelRequire("2Jl0K");

var $61DUI = parcelRequire("61DUI");

var $1dBX3 = parcelRequire("1dBX3");
var $5d9455cb09457c80$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {'addlayer'|'removelayer'} EventType
 */ /**
 * @classdesc
 * A layer group triggers 'addlayer' and 'removelayer' events when layers are added to or removed from
 * the group or one of its child groups.  When a layer group is added to or removed from another layer group,
 * a single event will be triggered (instead of one per layer in the group added or removed).
 */ var $5d9455cb09457c80$export$2f5ff21d758d25a7 = /** @class */ function(_super) {
    $5d9455cb09457c80$var$__extends(GroupEvent, _super);
    /**
     * @param {EventType} type The event type.
     * @param {BaseLayer} layer The layer.
     */ function GroupEvent(type, layer) {
        var _this = _super.call(this, type) || this;
        /**
         * The added or removed layer.
         * @type {BaseLayer}
         * @api
         */ _this.layer = layer;
        return _this;
    }
    return GroupEvent;
}((0, $bNM9R.default));
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|import("../Collection.js").default<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ var $5d9455cb09457c80$var$Property = {
    LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ var $5d9455cb09457c80$var$LayerGroup = /** @class */ function(_super) {
    $5d9455cb09457c80$var$__extends(LayerGroup, _super);
    /**
     * @param {Options} [opt_options] Layer options.
     */ function LayerGroup(opt_options) {
        var _this = this;
        var options = opt_options || {};
        var baseOptions = /** @type {Options} */ (0, $9zTj4.assign)({}, options);
        delete baseOptions.layers;
        var layers = options.layers;
        _this = _super.call(this, baseOptions) || this;
        /***
         * @type {GroupOnSignature<import("../events").EventsKey>}
         */ _this.on;
        /***
         * @type {GroupOnSignature<import("../events").EventsKey>}
         */ _this.once;
        /***
         * @type {GroupOnSignature<void>}
         */ _this.un;
        /**
         * @private
         * @type {Array<import("../events.js").EventsKey>}
         */ _this.layersListenerKeys_ = [];
        /**
         * @private
         * @type {Object<string, Array<import("../events.js").EventsKey>>}
         */ _this.listenerKeys_ = {};
        _this.addChangeListener($5d9455cb09457c80$var$Property.LAYERS, _this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $1IaXJ.default)(layers.slice(), {
                unique: true
            });
            else (0, $3JLp3.assert)(typeof /** @type {?} */ layers.getArray === 'function', 43); // Expected `layers` to be an array or a `Collection`
        } else layers = new (0, $1IaXJ.default)(undefined, {
            unique: true
        });
        _this.setLayers(layers);
        return _this;
    }
    /**
     * @private
     */ LayerGroup.prototype.handleLayerChange_ = function() {
        this.changed();
    };
    /**
     * @private
     */ LayerGroup.prototype.handleLayersChanged_ = function() {
        this.layersListenerKeys_.forEach((0, $1dBX3.unlistenByKey));
        this.layersListenerKeys_.length = 0;
        var layers = this.getLayers();
        this.layersListenerKeys_.push((0, $1dBX3.listen)(layers, (0, $59kE1.default).ADD, this.handleLayersAdd_, this), (0, $1dBX3.listen)(layers, (0, $59kE1.default).REMOVE, this.handleLayersRemove_, this));
        for(var id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $1dBX3.unlistenByKey));
        (0, $9zTj4.clear)(this.listenerKeys_);
        var layersArray = layers.getArray();
        for(var i = 0, ii = layersArray.length; i < ii; i++){
            var layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $5d9455cb09457c80$export$2f5ff21d758d25a7('addlayer', layer));
        }
        this.changed();
    };
    /**
     * @param {BaseLayer} layer The layer.
     */ LayerGroup.prototype.registerLayerListeners_ = function(layer) {
        var listenerKeys = [
            (0, $1dBX3.listen)(layer, (0, $48iCR.default).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $1dBX3.listen)(layer, (0, $cFmyb.default).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof LayerGroup) listenerKeys.push((0, $1dBX3.listen)(layer, 'addlayer', this.handleLayerGroupAdd_, this), (0, $1dBX3.listen)(layer, 'removelayer', this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $61DUI.getUid)(layer)] = listenerKeys;
    };
    /**
     * @param {GroupEvent} event The layer group event.
     */ LayerGroup.prototype.handleLayerGroupAdd_ = function(event) {
        this.dispatchEvent(new $5d9455cb09457c80$export$2f5ff21d758d25a7('addlayer', event.layer));
    };
    /**
     * @param {GroupEvent} event The layer group event.
     */ LayerGroup.prototype.handleLayerGroupRemove_ = function(event) {
        this.dispatchEvent(new $5d9455cb09457c80$export$2f5ff21d758d25a7('removelayer', event.layer));
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
     * @private
     */ LayerGroup.prototype.handleLayersAdd_ = function(collectionEvent) {
        var layer = /** @type {import("./Base.js").default} */ collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $5d9455cb09457c80$export$2f5ff21d758d25a7('addlayer', layer));
        this.changed();
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
     * @private
     */ LayerGroup.prototype.handleLayersRemove_ = function(collectionEvent) {
        var layer = /** @type {import("./Base.js").default} */ collectionEvent.element;
        var key = (0, $61DUI.getUid)(layer);
        this.listenerKeys_[key].forEach((0, $1dBX3.unlistenByKey));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $5d9455cb09457c80$export$2f5ff21d758d25a7('removelayer', layer));
        this.changed();
    };
    /**
     * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
     * in this group.
     * @return {!import("../Collection.js").default<import("./Base.js").default>} Collection of
     *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
     * @observable
     * @api
     */ LayerGroup.prototype.getLayers = function() {
        return /** @type {!import("../Collection.js").default<import("./Base.js").default>} */ this.get($5d9455cb09457c80$var$Property.LAYERS);
    };
    /**
     * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
     * in this group.
     * @param {!import("../Collection.js").default<import("./Base.js").default>} layers Collection of
     *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
     * @observable
     * @api
     */ LayerGroup.prototype.setLayers = function(layers) {
        var collection = this.getLayers();
        if (collection) {
            var currentLayers = collection.getArray();
            for(var i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $5d9455cb09457c80$export$2f5ff21d758d25a7('removelayer', currentLayers[i]));
        }
        this.set($5d9455cb09457c80$var$Property.LAYERS, layers);
    };
    /**
     * @param {Array<import("./Layer.js").default>} [opt_array] Array of layers (to be modified in place).
     * @return {Array<import("./Layer.js").default>} Array of layers.
     */ LayerGroup.prototype.getLayersArray = function(opt_array) {
        var array = opt_array !== undefined ? opt_array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    };
    /**
     * Get the layer states list and use this groups z-index as the default
     * for all layers in this and nested groups, if it is unset at this point.
     * If opt_states is not provided and this group's z-index is undefined
     * 0 is used a the default z-index.
     * @param {Array<import("./Layer.js").State>} [opt_states] Optional list
     * of layer states (to be modified in place).
     * @return {Array<import("./Layer.js").State>} List of layer states.
     */ LayerGroup.prototype.getLayerStatesArray = function(opt_states) {
        var states = opt_states !== undefined ? opt_states : [];
        var pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        var ownLayerState = this.getLayerState();
        var defaultZIndex = ownLayerState.zIndex;
        if (!opt_states && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(var i = pos, ii = states.length; i < ii; i++){
            var layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $2Jl0K.getIntersection)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    };
    /**
     * @return {import("../source/Source.js").State} Source state.
     */ LayerGroup.prototype.getSourceState = function() {
        return 'ready';
    };
    return LayerGroup;
}((0, $1iJu5.default));
var $5d9455cb09457c80$export$2e2bcd8739ae039 = $5d9455cb09457c80$var$LayerGroup;

});
parcelRegister("1iJu5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f2ac116f6b8656b$export$2e2bcd8739ae039; });

var $aK3Yt = parcelRequire("aK3Yt");

var $3A2O6 = parcelRequire("3A2O6");

var $61DUI = parcelRequire("61DUI");

var $3JLp3 = parcelRequire("3JLp3");

var $9zTj4 = parcelRequire("9zTj4");

var $7aO1A = parcelRequire("7aO1A");
var $0f2ac116f6b8656b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ var $0f2ac116f6b8656b$var$BaseLayer = /** @class */ function(_super) {
    $0f2ac116f6b8656b$var$__extends(BaseLayer, _super);
    /**
     * @param {Options} options Layer options.
     */ function BaseLayer(options) {
        var _this = _super.call(this) || this;
        /***
         * @type {BaseLayerOnSignature<import("../events").EventsKey>}
         */ _this.on;
        /***
         * @type {BaseLayerOnSignature<import("../events").EventsKey>}
         */ _this.once;
        /***
         * @type {BaseLayerOnSignature<void>}
         */ _this.un;
        /**
         * @type {BackgroundColor|false}
         * @private
         */ _this.background_ = options.background;
        /**
         * @type {Object<string, *>}
         */ var properties = (0, $9zTj4.assign)({}, options);
        if (typeof options.properties === 'object') {
            delete properties.properties;
            (0, $9zTj4.assign)(properties, options.properties);
        }
        properties[(0, $3A2O6.default).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $3JLp3.assert)(typeof properties[(0, $3A2O6.default).OPACITY] === 'number', 64); // Layer opacity must be a number
        properties[(0, $3A2O6.default).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $3A2O6.default).Z_INDEX] = options.zIndex;
        properties[(0, $3A2O6.default).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $3A2O6.default).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $3A2O6.default).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $3A2O6.default).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
         * @type {string}
         * @private
         */ _this.className_ = properties.className !== undefined ? properties.className : 'ol-layer';
        delete properties.className;
        _this.setProperties(properties);
        /**
         * @type {import("./Layer.js").State}
         * @private
         */ _this.state_ = null;
        return _this;
    }
    /**
     * Get the background for this layer.
     * @return {BackgroundColor|false} Layer background.
     */ BaseLayer.prototype.getBackground = function() {
        return this.background_;
    };
    /**
     * @return {string} CSS class name.
     */ BaseLayer.prototype.getClassName = function() {
        return this.className_;
    };
    /**
     * This method is not meant to be called by layers or layer renderers because the state
     * is incorrect if the layer is included in a layer group.
     *
     * @param {boolean} [opt_managed] Layer is managed.
     * @return {import("./Layer.js").State} Layer state.
     */ BaseLayer.prototype.getLayerState = function(opt_managed) {
        /** @type {import("./Layer.js").State} */ var state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: opt_managed === undefined ? true : opt_managed
        };
        var zIndex = this.getZIndex();
        state.opacity = (0, $7aO1A.clamp)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    };
    /**
     * @abstract
     * @param {Array<import("./Layer.js").default>} [opt_array] Array of layers (to be
     *     modified in place).
     * @return {Array<import("./Layer.js").default>} Array of layers.
     */ BaseLayer.prototype.getLayersArray = function(opt_array) {
        return (0, $61DUI.abstract)();
    };
    /**
     * @abstract
     * @param {Array<import("./Layer.js").State>} [opt_states] Optional list of layer
     *     states (to be modified in place).
     * @return {Array<import("./Layer.js").State>} List of layer states.
     */ BaseLayer.prototype.getLayerStatesArray = function(opt_states) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
     * will be visible regardless of extent.
     * @return {import("../extent.js").Extent|undefined} The layer extent.
     * @observable
     * @api
     */ BaseLayer.prototype.getExtent = function() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $3A2O6.default).EXTENT);
    };
    /**
     * Return the maximum resolution of the layer.
     * @return {number} The maximum resolution of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getMaxResolution = function() {
        return /** @type {number} */ this.get((0, $3A2O6.default).MAX_RESOLUTION);
    };
    /**
     * Return the minimum resolution of the layer.
     * @return {number} The minimum resolution of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getMinResolution = function() {
        return /** @type {number} */ this.get((0, $3A2O6.default).MIN_RESOLUTION);
    };
    /**
     * Return the minimum zoom level of the layer.
     * @return {number} The minimum zoom level of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getMinZoom = function() {
        return /** @type {number} */ this.get((0, $3A2O6.default).MIN_ZOOM);
    };
    /**
     * Return the maximum zoom level of the layer.
     * @return {number} The maximum zoom level of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getMaxZoom = function() {
        return /** @type {number} */ this.get((0, $3A2O6.default).MAX_ZOOM);
    };
    /**
     * Return the opacity of the layer (between 0 and 1).
     * @return {number} The opacity of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getOpacity = function() {
        return /** @type {number} */ this.get((0, $3A2O6.default).OPACITY);
    };
    /**
     * @abstract
     * @return {import("../source/Source.js").State} Source state.
     */ BaseLayer.prototype.getSourceState = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * Return the visibility of the layer (`true` or `false`).
     * @return {boolean} The visibility of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getVisible = function() {
        return /** @type {boolean} */ this.get((0, $3A2O6.default).VISIBLE);
    };
    /**
     * Return the Z-index of the layer, which is used to order layers before
     * rendering. The default Z-index is 0.
     * @return {number} The Z-index of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.getZIndex = function() {
        return /** @type {number} */ this.get((0, $3A2O6.default).Z_INDEX);
    };
    /**
     * Sets the background color.
     * @param {BackgroundColor} [opt_background] Background color.
     */ BaseLayer.prototype.setBackground = function(opt_background) {
        this.background_ = opt_background;
        this.changed();
    };
    /**
     * Set the extent at which the layer is visible.  If `undefined`, the layer
     * will be visible at all extents.
     * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setExtent = function(extent) {
        this.set((0, $3A2O6.default).EXTENT, extent);
    };
    /**
     * Set the maximum resolution at which the layer is visible.
     * @param {number} maxResolution The maximum resolution of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setMaxResolution = function(maxResolution) {
        this.set((0, $3A2O6.default).MAX_RESOLUTION, maxResolution);
    };
    /**
     * Set the minimum resolution at which the layer is visible.
     * @param {number} minResolution The minimum resolution of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setMinResolution = function(minResolution) {
        this.set((0, $3A2O6.default).MIN_RESOLUTION, minResolution);
    };
    /**
     * Set the maximum zoom (exclusive) at which the layer is visible.
     * Note that the zoom levels for layer visibility are based on the
     * view zoom level, which may be different from a tile source zoom level.
     * @param {number} maxZoom The maximum zoom of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setMaxZoom = function(maxZoom) {
        this.set((0, $3A2O6.default).MAX_ZOOM, maxZoom);
    };
    /**
     * Set the minimum zoom (inclusive) at which the layer is visible.
     * Note that the zoom levels for layer visibility are based on the
     * view zoom level, which may be different from a tile source zoom level.
     * @param {number} minZoom The minimum zoom of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setMinZoom = function(minZoom) {
        this.set((0, $3A2O6.default).MIN_ZOOM, minZoom);
    };
    /**
     * Set the opacity of the layer, allowed values range from 0 to 1.
     * @param {number} opacity The opacity of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setOpacity = function(opacity) {
        (0, $3JLp3.assert)(typeof opacity === 'number', 64); // Layer opacity must be a number
        this.set((0, $3A2O6.default).OPACITY, opacity);
    };
    /**
     * Set the visibility of the layer (`true` or `false`).
     * @param {boolean} visible The visibility of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setVisible = function(visible) {
        this.set((0, $3A2O6.default).VISIBLE, visible);
    };
    /**
     * Set Z-index of the layer, which is used to order layers before rendering.
     * The default Z-index is 0.
     * @param {number} zindex The z-index of the layer.
     * @observable
     * @api
     */ BaseLayer.prototype.setZIndex = function(zindex) {
        this.set((0, $3A2O6.default).Z_INDEX, zindex);
    };
    /**
     * Clean up.
     */ BaseLayer.prototype.disposeInternal = function() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        _super.prototype.disposeInternal.call(this);
    };
    return BaseLayer;
}((0, $aK3Yt.default));
var $0f2ac116f6b8656b$export$2e2bcd8739ae039 = $0f2ac116f6b8656b$var$BaseLayer;

});
parcelRegister("aK3Yt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d21487ee984c1a8$export$2e2bcd8739ae039; });

var $bNM9R = parcelRequire("bNM9R");

var $48iCR = parcelRequire("48iCR");

var $gpPIU = parcelRequire("gpPIU");

var $9zTj4 = parcelRequire("9zTj4");

var $61DUI = parcelRequire("61DUI");
var $7d21487ee984c1a8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Events emitted by {@link module:ol/Object~BaseObject} instances are instances of this type.
 */ var $7d21487ee984c1a8$export$cf395d7c4a2d5a17 = /** @class */ function(_super) {
    $7d21487ee984c1a8$var$__extends(ObjectEvent, _super);
    /**
     * @param {string} type The event type.
     * @param {string} key The property name.
     * @param {*} oldValue The old value for `key`.
     */ function ObjectEvent(type, key, oldValue) {
        var _this = _super.call(this, type) || this;
        /**
         * The name of the property whose value is changing.
         * @type {string}
         * @api
         */ _this.key = key;
        /**
         * The old value. To get the new value use `e.target.get(e.key)` where
         * `e` is the event object.
         * @type {*}
         * @api
         */ _this.oldValue = oldValue;
        return _this;
    }
    return ObjectEvent;
}((0, $bNM9R.default));
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ var $7d21487ee984c1a8$var$BaseObject = /** @class */ function(_super) {
    $7d21487ee984c1a8$var$__extends(BaseObject, _super);
    /**
     * @param {Object<string, *>} [opt_values] An object with key-value pairs.
     */ function BaseObject(opt_values) {
        var _this = _super.call(this) || this;
        /***
         * @type {ObjectOnSignature<import("./events").EventsKey>}
         */ _this.on;
        /***
         * @type {ObjectOnSignature<import("./events").EventsKey>}
         */ _this.once;
        /***
         * @type {ObjectOnSignature<void>}
         */ _this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $61DUI.getUid)(_this);
        /**
         * @private
         * @type {Object<string, *>}
         */ _this.values_ = null;
        if (opt_values !== undefined) _this.setProperties(opt_values);
        return _this;
    }
    /**
     * Gets a value.
     * @param {string} key Key name.
     * @return {*} Value.
     * @api
     */ BaseObject.prototype.get = function(key) {
        var value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    };
    /**
     * Get a list of object property names.
     * @return {Array<string>} List of property names.
     * @api
     */ BaseObject.prototype.getKeys = function() {
        return this.values_ && Object.keys(this.values_) || [];
    };
    /**
     * Get an object of all property names and values.
     * @return {Object<string, *>} Object.
     * @api
     */ BaseObject.prototype.getProperties = function() {
        return this.values_ && (0, $9zTj4.assign)({}, this.values_) || {};
    };
    /**
     * @return {boolean} The object has properties.
     */ BaseObject.prototype.hasProperties = function() {
        return !!this.values_;
    };
    /**
     * @param {string} key Key name.
     * @param {*} oldValue Old value.
     */ BaseObject.prototype.notify = function(key, oldValue) {
        var eventType;
        eventType = "change:".concat(key);
        if (this.hasListener(eventType)) this.dispatchEvent(new $7d21487ee984c1a8$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $48iCR.default).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $7d21487ee984c1a8$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    };
    /**
     * @param {string} key Key name.
     * @param {import("./events.js").Listener} listener Listener.
     */ BaseObject.prototype.addChangeListener = function(key, listener) {
        this.addEventListener("change:".concat(key), listener);
    };
    /**
     * @param {string} key Key name.
     * @param {import("./events.js").Listener} listener Listener.
     */ BaseObject.prototype.removeChangeListener = function(key, listener) {
        this.removeEventListener("change:".concat(key), listener);
    };
    /**
     * Sets a value.
     * @param {string} key Key name.
     * @param {*} value Value.
     * @param {boolean} [opt_silent] Update without triggering an event.
     * @api
     */ BaseObject.prototype.set = function(key, value, opt_silent) {
        var values = this.values_ || (this.values_ = {});
        if (opt_silent) values[key] = value;
        else {
            var oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    };
    /**
     * Sets a collection of key-value pairs.  Note that this changes any existing
     * properties and adds new ones (it does not remove any existing properties).
     * @param {Object<string, *>} values Values.
     * @param {boolean} [opt_silent] Update without triggering an event.
     * @api
     */ BaseObject.prototype.setProperties = function(values, opt_silent) {
        for(var key in values)this.set(key, values[key], opt_silent);
    };
    /**
     * Apply any properties from another object without triggering events.
     * @param {BaseObject} source The source object.
     * @protected
     */ BaseObject.prototype.applyProperties = function(source) {
        if (!source.values_) return;
        (0, $9zTj4.assign)(this.values_ || (this.values_ = {}), source.values_);
    };
    /**
     * Unsets a property.
     * @param {string} key Key name.
     * @param {boolean} [opt_silent] Unset without triggering an event.
     * @api
     */ BaseObject.prototype.unset = function(key, opt_silent) {
        if (this.values_ && key in this.values_) {
            var oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $9zTj4.isEmpty)(this.values_)) this.values_ = null;
            if (!opt_silent) this.notify(key, oldValue);
        }
    };
    return BaseObject;
}((0, $gpPIU.default));
var $7d21487ee984c1a8$export$2e2bcd8739ae039 = $7d21487ee984c1a8$var$BaseObject;

});
parcelRegister("48iCR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30265b77b4881648$export$2e2bcd8739ae039; });
/**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $30265b77b4881648$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
     * Triggered when a property is changed.
     * @event module:ol/Object.ObjectEvent#propertychange
     * @api
     */ PROPERTYCHANGE: 'propertychange'
};

});

parcelRegister("61DUI", function(module, exports) {

$parcel$export(module.exports, "abstract", function () { return $4631cc1e20d938ef$export$817eb92a8194bab0; });
$parcel$export(module.exports, "getUid", function () { return $4631cc1e20d938ef$export$5e82334337e0f204; });
$parcel$export(module.exports, "VERSION", function () { return $4631cc1e20d938ef$export$a4ad2735b021c132; });
/**
 * @module ol/util
 */ /**
 * @return {?} Any return.
 */ function $4631cc1e20d938ef$export$817eb92a8194bab0() {
    return /** @type {?} */ function() {
        throw new Error('Unimplemented abstract method.');
    }();
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ var $4631cc1e20d938ef$var$uidCounter_ = 0;
function $4631cc1e20d938ef$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$4631cc1e20d938ef$var$uidCounter_));
}
var $4631cc1e20d938ef$export$a4ad2735b021c132 = '6.15.1';

});


parcelRegister("3A2O6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29b6e9525d7d52a4$export$2e2bcd8739ae039; });
/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $29b6e9525d7d52a4$export$2e2bcd8739ae039 = {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
    MAP: 'map'
};

});

parcelRegister("3JLp3", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $2b8a58580f163870$export$a7a9523472993e97; });
/**
 * @module ol/asserts
 */ 
var $cFYy4 = parcelRequire("cFYy4");
function $2b8a58580f163870$export$a7a9523472993e97(assertion, errorCode) {
    if (!assertion) throw new (0, $cFYy4.default)(errorCode);
}

});
parcelRegister("cFYy4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93a8480c3ef9105c$export$2e2bcd8739ae039; });

var $61DUI = parcelRequire("61DUI");
var $93a8480c3ef9105c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Error object thrown when an assertion failed. This is an ECMA-262 Error,
 * extended with a `code` property.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error.
 */ var $93a8480c3ef9105c$var$AssertionError = /** @class */ function(_super) {
    $93a8480c3ef9105c$var$__extends(AssertionError, _super);
    /**
     * @param {number} code Error code.
     */ function AssertionError(code) {
        var _this = this;
        var path = (0, $61DUI.VERSION) === 'latest' ? (0, $61DUI.VERSION) : 'v' + (0, $61DUI.VERSION).split('-')[0];
        var message = 'Assertion failed. See https://openlayers.org/en/' + path + '/doc/errors/#' + code + ' for details.';
        _this = _super.call(this, message) || this;
        /**
         * Error code. The meaning of the code can be found on
         * https://openlayers.org/en/latest/doc/errors/ (replace `latest` with
         * the version found in the OpenLayers script's header comment if a version
         * other than the latest is used).
         * @type {number}
         * @api
         */ _this.code = code;
        /**
         * @type {string}
         */ _this.name = 'AssertionError';
        // Re-assign message, see https://github.com/Rich-Harris/buble/issues/40
        _this.message = message;
        return _this;
    }
    return AssertionError;
}(Error);
var $93a8480c3ef9105c$export$2e2bcd8739ae039 = $93a8480c3ef9105c$var$AssertionError;

});


parcelRegister("7aO1A", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $53904564964f5893$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "cosh", function () { return $53904564964f5893$export$2e2fd1ad24e4d350; });
$parcel$export(module.exports, "log2", function () { return $53904564964f5893$export$b9fae0bba9d9094d; });
$parcel$export(module.exports, "squaredSegmentDistance", function () { return $53904564964f5893$export$251bb0a9cef172e6; });
$parcel$export(module.exports, "squaredDistance", function () { return $53904564964f5893$export$88e6ebb4fe54f538; });
$parcel$export(module.exports, "solveLinearSystem", function () { return $53904564964f5893$export$8240f01c446270e6; });
$parcel$export(module.exports, "toDegrees", function () { return $53904564964f5893$export$56cb859c01fa134d; });
$parcel$export(module.exports, "toRadians", function () { return $53904564964f5893$export$cba01ba138429a1d; });
$parcel$export(module.exports, "modulo", function () { return $53904564964f5893$export$ba467bec01d66def; });
$parcel$export(module.exports, "lerp", function () { return $53904564964f5893$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "floor", function () { return $53904564964f5893$export$a3fe094919f356fd; });
$parcel$export(module.exports, "ceil", function () { return $53904564964f5893$export$803ce6b71a0a94b2; });
/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $53904564964f5893$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
var $53904564964f5893$export$2e2fd1ad24e4d350 = function() {
    // Wrapped in a iife, to save the overhead of checking for the native
    // implementation on every invocation.
    var cosh;
    if ('cosh' in Math) // The environment supports the native Math.cosh function, use it…
    cosh = Math.cosh;
    else // … else, use the reference implementation of MDN:
    cosh = function(x) {
        var y = /** @type {Math} */ Math.exp(x);
        return (y + 1 / y) / 2;
    };
    return cosh;
}();
var $53904564964f5893$export$b9fae0bba9d9094d = function() {
    // Wrapped in a iife, to save the overhead of checking for the native
    // implementation on every invocation.
    var log2;
    if ('log2' in Math) // The environment supports the native Math.log2 function, use it…
    log2 = Math.log2;
    else // … else, use the reference implementation of MDN:
    log2 = function(x) {
        return Math.log(x) * Math.LOG2E;
    };
    return log2;
}();
function $53904564964f5893$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $53904564964f5893$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $53904564964f5893$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $53904564964f5893$export$8240f01c446270e6(mat) {
    var n = mat.length;
    for(var i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        var maxRow = i;
        var maxEl = Math.abs(mat[i][i]);
        for(var r = i + 1; r < n; r++){
            var absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        var tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(var j = i + 1; j < n; j++){
            var coef = -mat[j][i] / mat[i][i];
            for(var k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    var x = new Array(n);
    for(var l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(var m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $53904564964f5893$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $53904564964f5893$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $53904564964f5893$export$ba467bec01d66def(a, b) {
    var r = a % b;
    return r * b < 0 ? r + b : r;
}
function $53904564964f5893$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $53904564964f5893$export$a81f732198733497(n, decimals) {
    var factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $53904564964f5893$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($53904564964f5893$export$a81f732198733497(n, decimals));
}
function $53904564964f5893$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($53904564964f5893$export$a81f732198733497(n, decimals));
}
function $53904564964f5893$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($53904564964f5893$export$a81f732198733497(n, decimals));
}

});


parcelRegister("1IaXJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13f267682d1ab289$export$2e2bcd8739ae039; });

var $cFYy4 = parcelRequire("cFYy4");

var $aK3Yt = parcelRequire("aK3Yt");

var $59kE1 = parcelRequire("59kE1");

var $bNM9R = parcelRequire("bNM9R");
var $13f267682d1ab289$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @enum {string}
 * @private
 */ var $13f267682d1ab289$var$Property = {
    LENGTH: 'length'
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/Collection~Collection} instances are instances of this
 * type.
 */ var $13f267682d1ab289$export$a87ae6eb2761ec6d = /** @class */ function(_super) {
    $13f267682d1ab289$var$__extends(CollectionEvent, _super);
    /**
     * @param {import("./CollectionEventType.js").default} type Type.
     * @param {*} [opt_element] Element.
     * @param {number} [opt_index] The index of the added or removed element.
     */ function CollectionEvent(type, opt_element, opt_index) {
        var _this = _super.call(this, type) || this;
        /**
         * The element that is added to or removed from the collection.
         * @type {*}
         * @api
         */ _this.element = opt_element;
        /**
         * The index of the added or removed element.
         * @type {number}
         * @api
         */ _this.index = opt_index;
        return _this;
    }
    return CollectionEvent;
}((0, $bNM9R.default));
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ var $13f267682d1ab289$var$Collection = /** @class */ function(_super) {
    $13f267682d1ab289$var$__extends(Collection, _super);
    /**
     * @param {Array<T>} [opt_array] Array.
     * @param {Options} [opt_options] Collection options.
     */ function Collection(opt_array, opt_options) {
        var _this = _super.call(this) || this;
        /***
         * @type {CollectionOnSignature<import("./events").EventsKey>}
         */ _this.on;
        /***
         * @type {CollectionOnSignature<import("./events").EventsKey>}
         */ _this.once;
        /***
         * @type {CollectionOnSignature<void>}
         */ _this.un;
        var options = opt_options || {};
        /**
         * @private
         * @type {boolean}
         */ _this.unique_ = !!options.unique;
        /**
         * @private
         * @type {!Array<T>}
         */ _this.array_ = opt_array ? opt_array : [];
        if (_this.unique_) for(var i = 0, ii = _this.array_.length; i < ii; ++i)_this.assertUnique_(_this.array_[i], i);
        _this.updateLength_();
        return _this;
    }
    /**
     * Remove all elements from the collection.
     * @api
     */ Collection.prototype.clear = function() {
        while(this.getLength() > 0)this.pop();
    };
    /**
     * Add elements to the collection.  This pushes each item in the provided array
     * to the end of the collection.
     * @param {!Array<T>} arr Array.
     * @return {Collection<T>} This collection.
     * @api
     */ Collection.prototype.extend = function(arr) {
        for(var i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    };
    /**
     * Iterate over each element, calling the provided callback.
     * @param {function(T, number, Array<T>): *} f The function to call
     *     for every element. This function takes 3 arguments (the element, the
     *     index and the array). The return value is ignored.
     * @api
     */ Collection.prototype.forEach = function(f) {
        var array = this.array_;
        for(var i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    };
    /**
     * Get a reference to the underlying Array object. Warning: if the array
     * is mutated, no events will be dispatched by the collection, and the
     * collection's "length" property won't be in sync with the actual length
     * of the array.
     * @return {!Array<T>} Array.
     * @api
     */ Collection.prototype.getArray = function() {
        return this.array_;
    };
    /**
     * Get the element at the provided index.
     * @param {number} index Index.
     * @return {T} Element.
     * @api
     */ Collection.prototype.item = function(index) {
        return this.array_[index];
    };
    /**
     * Get the length of this collection.
     * @return {number} The length of the array.
     * @observable
     * @api
     */ Collection.prototype.getLength = function() {
        return this.get($13f267682d1ab289$var$Property.LENGTH);
    };
    /**
     * Insert an element at the provided index.
     * @param {number} index Index.
     * @param {T} elem Element.
     * @api
     */ Collection.prototype.insertAt = function(index, elem) {
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $13f267682d1ab289$export$a87ae6eb2761ec6d((0, $59kE1.default).ADD, elem, index));
    };
    /**
     * Remove the last element of the collection and return it.
     * Return `undefined` if the collection is empty.
     * @return {T|undefined} Element.
     * @api
     */ Collection.prototype.pop = function() {
        return this.removeAt(this.getLength() - 1);
    };
    /**
     * Insert the provided element at the end of the collection.
     * @param {T} elem Element.
     * @return {number} New length of the collection.
     * @api
     */ Collection.prototype.push = function(elem) {
        if (this.unique_) this.assertUnique_(elem);
        var n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    };
    /**
     * Remove the first occurrence of an element from the collection.
     * @param {T} elem Element.
     * @return {T|undefined} The removed element or undefined if none found.
     * @api
     */ Collection.prototype.remove = function(elem) {
        var arr = this.array_;
        for(var i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    };
    /**
     * Remove the element at the provided index and return it.
     * Return `undefined` if the collection does not contain this index.
     * @param {number} index Index.
     * @return {T|undefined} Value.
     * @api
     */ Collection.prototype.removeAt = function(index) {
        var prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(new $13f267682d1ab289$export$a87ae6eb2761ec6d((0, $59kE1.default).REMOVE, prev, index));
        return prev;
    };
    /**
     * Set the element at the provided index.
     * @param {number} index Index.
     * @param {T} elem Element.
     * @api
     */ Collection.prototype.setAt = function(index, elem) {
        var n = this.getLength();
        if (index < n) {
            if (this.unique_) this.assertUnique_(elem, index);
            var prev = this.array_[index];
            this.array_[index] = elem;
            this.dispatchEvent(new $13f267682d1ab289$export$a87ae6eb2761ec6d((0, $59kE1.default).REMOVE, prev, index));
            this.dispatchEvent(new $13f267682d1ab289$export$a87ae6eb2761ec6d((0, $59kE1.default).ADD, elem, index));
        } else {
            for(var j = n; j < index; ++j)this.insertAt(j, undefined);
            this.insertAt(index, elem);
        }
    };
    /**
     * @private
     */ Collection.prototype.updateLength_ = function() {
        this.set($13f267682d1ab289$var$Property.LENGTH, this.array_.length);
    };
    /**
     * @private
     * @param {T} elem Element.
     * @param {number} [opt_except] Optional index to ignore.
     */ Collection.prototype.assertUnique_ = function(elem, opt_except) {
        for(var i = 0, ii = this.array_.length; i < ii; ++i){
            if (this.array_[i] === elem && i !== opt_except) throw new (0, $cFYy4.default)(58);
        }
    };
    return Collection;
}((0, $aK3Yt.default));
var $13f267682d1ab289$export$2e2bcd8739ae039 = $13f267682d1ab289$var$Collection;

});
parcelRegister("59kE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bfdce98c73da014$export$2e2bcd8739ae039; });
/**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $3bfdce98c73da014$export$2e2bcd8739ae039 = {
    /**
     * Triggered when an item is added to the collection.
     * @event module:ol/Collection.CollectionEvent#add
     * @api
     */ ADD: 'add',
    /**
     * Triggered when an item is removed from the collection.
     * @event module:ol/Collection.CollectionEvent#remove
     * @api
     */ REMOVE: 'remove'
};

});


parcelRegister("2Jl0K", function(module, exports) {

$parcel$export(module.exports, "boundingExtent", function () { return $1fd0151313ddf58e$export$8aceca7c77505534; });
$parcel$export(module.exports, "createEmpty", function () { return $1fd0151313ddf58e$export$fe201bb3bbe031e9; });
$parcel$export(module.exports, "extendCoordinate", function () { return $1fd0151313ddf58e$export$1f820e3920fa5715; });
$parcel$export(module.exports, "createOrUpdate", function () { return $1fd0151313ddf58e$export$958e3e1a02eac4b6; });
$parcel$export(module.exports, "buffer", function () { return $1fd0151313ddf58e$export$ab1029bcae9ddb4a; });
$parcel$export(module.exports, "clone", function () { return $1fd0151313ddf58e$export$9cd59f9826255e47; });
$parcel$export(module.exports, "closestSquaredDistanceXY", function () { return $1fd0151313ddf58e$export$cbe64c389534206f; });
$parcel$export(module.exports, "containsCoordinate", function () { return $1fd0151313ddf58e$export$ac68c24d37ca240f; });
$parcel$export(module.exports, "containsXY", function () { return $1fd0151313ddf58e$export$805bdfd6d6690e97; });
$parcel$export(module.exports, "containsExtent", function () { return $1fd0151313ddf58e$export$be866b1e0809b17e; });
$parcel$export(module.exports, "coordinateRelationship", function () { return $1fd0151313ddf58e$export$f97905ead28c61a8; });
$parcel$export(module.exports, "createOrUpdateEmpty", function () { return $1fd0151313ddf58e$export$3e2152b047719fa1; });
$parcel$export(module.exports, "createOrUpdateFromCoordinate", function () { return $1fd0151313ddf58e$export$4838bf78d04a9440; });
$parcel$export(module.exports, "createOrUpdateFromFlatCoordinates", function () { return $1fd0151313ddf58e$export$be0ab0bf96ca59ca; });
$parcel$export(module.exports, "extendFlatCoordinates", function () { return $1fd0151313ddf58e$export$30570204156ffd18; });
$parcel$export(module.exports, "equals", function () { return $1fd0151313ddf58e$export$e9bab7fafb253603; });
$parcel$export(module.exports, "extend", function () { return $1fd0151313ddf58e$export$8b58be045bf06082; });
$parcel$export(module.exports, "forEachCorner", function () { return $1fd0151313ddf58e$export$f9ed8a3d123a08e2; });
$parcel$export(module.exports, "getBottomLeft", function () { return $1fd0151313ddf58e$export$8d09f5e2e1bf560d; });
$parcel$export(module.exports, "getBottomRight", function () { return $1fd0151313ddf58e$export$e77c1cf70445e168; });
$parcel$export(module.exports, "getTopRight", function () { return $1fd0151313ddf58e$export$b84fa077c8b05295; });
$parcel$export(module.exports, "getTopLeft", function () { return $1fd0151313ddf58e$export$cb1538b07e6964ff; });
$parcel$export(module.exports, "getArea", function () { return $1fd0151313ddf58e$export$520c40045967cb15; });
$parcel$export(module.exports, "isEmpty", function () { return $1fd0151313ddf58e$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "getWidth", function () { return $1fd0151313ddf58e$export$3c49c185de0c2bfc; });
$parcel$export(module.exports, "getHeight", function () { return $1fd0151313ddf58e$export$c08559766941f856; });
$parcel$export(module.exports, "getCenter", function () { return $1fd0151313ddf58e$export$c91255cadecfe081; });
$parcel$export(module.exports, "getCorner", function () { return $1fd0151313ddf58e$export$a1cfd206661d0801; });
$parcel$export(module.exports, "getForViewAndSize", function () { return $1fd0151313ddf58e$export$13ba650faf8308; });
$parcel$export(module.exports, "getRotatedViewport", function () { return $1fd0151313ddf58e$export$4b7a6fb4002cd6ac; });
$parcel$export(module.exports, "getIntersection", function () { return $1fd0151313ddf58e$export$72209efa88586d42; });
$parcel$export(module.exports, "intersects", function () { return $1fd0151313ddf58e$export$7b0a31e10bbff018; });
$parcel$export(module.exports, "returnOrUpdate", function () { return $1fd0151313ddf58e$export$6a4fe494c558c238; });
$parcel$export(module.exports, "intersectsSegment", function () { return $1fd0151313ddf58e$export$a6a5a7a461419425; });
$parcel$export(module.exports, "applyTransform", function () { return $1fd0151313ddf58e$export$9f9dcb98c894b623; });
$parcel$export(module.exports, "wrapX", function () { return $1fd0151313ddf58e$export$39a9ce3624977b84; });
$parcel$export(module.exports, "wrapAndSliceX", function () { return $1fd0151313ddf58e$export$9031237f01de0947; });
/**
 * @module ol/extent
 */ 
var $2mHhe = parcelRequire("2mHhe");

var $3JLp3 = parcelRequire("3JLp3");
function $1fd0151313ddf58e$export$8aceca7c77505534(coordinates) {
    var extent = $1fd0151313ddf58e$export$fe201bb3bbe031e9();
    for(var i = 0, ii = coordinates.length; i < ii; ++i)$1fd0151313ddf58e$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [opt_extent] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $1fd0151313ddf58e$var$_boundingExtentXYs(xs, ys, opt_extent) {
    var minX = Math.min.apply(null, xs);
    var minY = Math.min.apply(null, ys);
    var maxX = Math.max.apply(null, xs);
    var maxY = Math.max.apply(null, ys);
    return $1fd0151313ddf58e$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, opt_extent);
}
function $1fd0151313ddf58e$export$ab1029bcae9ddb4a(extent, value, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0] - value;
        opt_extent[1] = extent[1] - value;
        opt_extent[2] = extent[2] + value;
        opt_extent[3] = extent[3] + value;
        return opt_extent;
    } else return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $1fd0151313ddf58e$export$9cd59f9826255e47(extent, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0];
        opt_extent[1] = extent[1];
        opt_extent[2] = extent[2];
        opt_extent[3] = extent[3];
        return opt_extent;
    } else return extent.slice();
}
function $1fd0151313ddf58e$export$cbe64c389534206f(extent, x, y) {
    var dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $1fd0151313ddf58e$export$ac68c24d37ca240f(extent, coordinate) {
    return $1fd0151313ddf58e$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $1fd0151313ddf58e$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $1fd0151313ddf58e$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $1fd0151313ddf58e$export$f97905ead28c61a8(extent, coordinate) {
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var x = coordinate[0];
    var y = coordinate[1];
    var relationship = (0, $2mHhe.default).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $2mHhe.default).LEFT;
    else if (x > maxX) relationship = relationship | (0, $2mHhe.default).RIGHT;
    if (y < minY) relationship = relationship | (0, $2mHhe.default).BELOW;
    else if (y > maxY) relationship = relationship | (0, $2mHhe.default).ABOVE;
    if (relationship === (0, $2mHhe.default).UNKNOWN) relationship = (0, $2mHhe.default).INTERSECTING;
    return relationship;
}
function $1fd0151313ddf58e$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $1fd0151313ddf58e$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = minX;
        opt_extent[1] = minY;
        opt_extent[2] = maxX;
        opt_extent[3] = maxY;
        return opt_extent;
    } else return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $1fd0151313ddf58e$export$3e2152b047719fa1(opt_extent) {
    return $1fd0151313ddf58e$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, opt_extent);
}
function $1fd0151313ddf58e$export$4838bf78d04a9440(coordinate, opt_extent) {
    var x = coordinate[0];
    var y = coordinate[1];
    return $1fd0151313ddf58e$export$958e3e1a02eac4b6(x, y, x, y, opt_extent);
}
function $1fd0151313ddf58e$export$29e3ad4dbd0cb863(coordinates, opt_extent) {
    var extent = $1fd0151313ddf58e$export$3e2152b047719fa1(opt_extent);
    return $1fd0151313ddf58e$export$795cd48be4d5f252(extent, coordinates);
}
function $1fd0151313ddf58e$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, opt_extent) {
    var extent = $1fd0151313ddf58e$export$3e2152b047719fa1(opt_extent);
    return $1fd0151313ddf58e$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $1fd0151313ddf58e$export$73b4897e93bc5c83(rings, opt_extent) {
    var extent = $1fd0151313ddf58e$export$3e2152b047719fa1(opt_extent);
    return $1fd0151313ddf58e$export$9b319549574402d7(extent, rings);
}
function $1fd0151313ddf58e$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $1fd0151313ddf58e$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $1fd0151313ddf58e$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $1fd0151313ddf58e$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $1fd0151313ddf58e$export$795cd48be4d5f252(extent, coordinates) {
    for(var i = 0, ii = coordinates.length; i < ii; ++i)$1fd0151313ddf58e$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $1fd0151313ddf58e$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$1fd0151313ddf58e$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $1fd0151313ddf58e$export$9b319549574402d7(extent, rings) {
    for(var i = 0, ii = rings.length; i < ii; ++i)$1fd0151313ddf58e$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $1fd0151313ddf58e$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $1fd0151313ddf58e$export$f9ed8a3d123a08e2(extent, callback) {
    var val;
    val = callback($1fd0151313ddf58e$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($1fd0151313ddf58e$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($1fd0151313ddf58e$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($1fd0151313ddf58e$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $1fd0151313ddf58e$export$520c40045967cb15(extent) {
    var area = 0;
    if (!$1fd0151313ddf58e$export$dd1bc94b04021eeb(extent)) area = $1fd0151313ddf58e$export$3c49c185de0c2bfc(extent) * $1fd0151313ddf58e$export$c08559766941f856(extent);
    return area;
}
function $1fd0151313ddf58e$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $1fd0151313ddf58e$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $1fd0151313ddf58e$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $1fd0151313ddf58e$export$a1cfd206661d0801(extent, corner) {
    var coordinate;
    if (corner === 'bottom-left') coordinate = $1fd0151313ddf58e$export$8d09f5e2e1bf560d(extent);
    else if (corner === 'bottom-right') coordinate = $1fd0151313ddf58e$export$e77c1cf70445e168(extent);
    else if (corner === 'top-left') coordinate = $1fd0151313ddf58e$export$cb1538b07e6964ff(extent);
    else if (corner === 'top-right') coordinate = $1fd0151313ddf58e$export$b84fa077c8b05295(extent);
    else (0, $3JLp3.assert)(false, 13); // Invalid corner
    return coordinate;
}
function $1fd0151313ddf58e$export$7d6fa884b32a3751(extent1, extent2) {
    var minX = Math.min(extent1[0], extent2[0]);
    var minY = Math.min(extent1[1], extent2[1]);
    var maxX = Math.max(extent1[2], extent2[2]);
    var maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $1fd0151313ddf58e$export$13ba650faf8308(center, resolution, rotation, size, opt_extent) {
    var _a = $1fd0151313ddf58e$export$4b7a6fb4002cd6ac(center, resolution, rotation, size), x0 = _a[0], y0 = _a[1], x1 = _a[2], y1 = _a[3], x2 = _a[4], y2 = _a[5], x3 = _a[6], y3 = _a[7];
    return $1fd0151313ddf58e$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), opt_extent);
}
function $1fd0151313ddf58e$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    var dx = resolution * size[0] / 2;
    var dy = resolution * size[1] / 2;
    var cosRotation = Math.cos(rotation);
    var sinRotation = Math.sin(rotation);
    var xCos = dx * cosRotation;
    var xSin = dx * sinRotation;
    var yCos = dy * cosRotation;
    var ySin = dy * sinRotation;
    var x = center[0];
    var y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $1fd0151313ddf58e$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $1fd0151313ddf58e$export$f3fe0e9a60cde324(extent1, extent2) {
    var intersection = $1fd0151313ddf58e$export$72209efa88586d42(extent1, extent2);
    return $1fd0151313ddf58e$export$520c40045967cb15(intersection);
}
function $1fd0151313ddf58e$export$72209efa88586d42(extent1, extent2, opt_extent) {
    var intersection = opt_extent ? opt_extent : $1fd0151313ddf58e$export$fe201bb3bbe031e9();
    if ($1fd0151313ddf58e$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $1fd0151313ddf58e$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $1fd0151313ddf58e$export$1bc603050bd777b1(extent) {
    return $1fd0151313ddf58e$export$3c49c185de0c2bfc(extent) + $1fd0151313ddf58e$export$c08559766941f856(extent);
}
function $1fd0151313ddf58e$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $1fd0151313ddf58e$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $1fd0151313ddf58e$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $1fd0151313ddf58e$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $1fd0151313ddf58e$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $1fd0151313ddf58e$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $1fd0151313ddf58e$export$6a4fe494c558c238(extent, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0];
        opt_extent[1] = extent[1];
        opt_extent[2] = extent[2];
        opt_extent[3] = extent[3];
        return opt_extent;
    } else return extent;
}
function $1fd0151313ddf58e$export$80cbab86674143b6(extent, value) {
    var deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    var deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $1fd0151313ddf58e$export$a6a5a7a461419425(extent, start, end) {
    var intersects = false;
    var startRel = $1fd0151313ddf58e$export$f97905ead28c61a8(extent, start);
    var endRel = $1fd0151313ddf58e$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $2mHhe.default).INTERSECTING || endRel === (0, $2mHhe.default).INTERSECTING) intersects = true;
    else {
        var minX = extent[0];
        var minY = extent[1];
        var maxX = extent[2];
        var maxY = extent[3];
        var startX = start[0];
        var startY = start[1];
        var endX = end[0];
        var endY = end[1];
        var slope = (endY - startY) / (endX - startX);
        var x = void 0, y = void 0;
        if (!!(endRel & (0, $2mHhe.default).ABOVE) && !(startRel & (0, $2mHhe.default).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $2mHhe.default).RIGHT) && !(startRel & (0, $2mHhe.default).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $2mHhe.default).BELOW) && !(startRel & (0, $2mHhe.default).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $2mHhe.default).LEFT) && !(startRel & (0, $2mHhe.default).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $1fd0151313ddf58e$export$9f9dcb98c894b623(extent, transformFn, opt_extent, opt_stops) {
    var coordinates = [];
    if (opt_stops > 1) {
        var width = extent[2] - extent[0];
        var height = extent[3] - extent[1];
        for(var i = 0; i < opt_stops; ++i)coordinates.push(extent[0] + width * i / opt_stops, extent[1], extent[2], extent[1] + height * i / opt_stops, extent[2] - width * i / opt_stops, extent[3], extent[0], extent[3] - height * i / opt_stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    var xs = [];
    var ys = [];
    for(var i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $1fd0151313ddf58e$var$_boundingExtentXYs(xs, ys, opt_extent);
}
function $1fd0151313ddf58e$export$39a9ce3624977b84(extent, projection) {
    var projectionExtent = projection.getExtent();
    var center = $1fd0151313ddf58e$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        var worldWidth = $1fd0151313ddf58e$export$3c49c185de0c2bfc(projectionExtent);
        var worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        var offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $1fd0151313ddf58e$export$9031237f01de0947(extent, projection) {
    if (projection.canWrapX()) {
        var projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $1fd0151313ddf58e$export$39a9ce3624977b84(extent, projection);
        var worldWidth = $1fd0151313ddf58e$export$3c49c185de0c2bfc(projectionExtent);
        if ($1fd0151313ddf58e$export$3c49c185de0c2bfc(extent) > worldWidth) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        else if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        else if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}

});
parcelRegister("2mHhe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b8f34be5e651716$export$2e2bcd8739ae039; });
/**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $1b8f34be5e651716$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};

});



parcelRegister("hsGuz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $cb66033c9d7bfc96$export$2e2bcd8739ae039; });

var $aK3Yt = parcelRequire("aK3Yt");

var $9UyUk = parcelRequire("9UyUk");

var $c8IGo = parcelRequire("c8IGo");

var $1dBX3 = parcelRequire("1dBX3");

var $djuby = parcelRequire("djuby");
var $cb66033c9d7bfc96$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * var myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ var $cb66033c9d7bfc96$var$Control = /** @class */ function(_super) {
    $cb66033c9d7bfc96$var$__extends(Control, _super);
    /**
     * @param {Options} options Control options.
     */ function Control(options) {
        var _this = _super.call(this) || this;
        var element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = 'auto';
        /**
         * @protected
         * @type {HTMLElement}
         */ _this.element = element ? element : null;
        /**
         * @private
         * @type {HTMLElement}
         */ _this.target_ = null;
        /**
         * @private
         * @type {import("../PluggableMap.js").default|null}
         */ _this.map_ = null;
        /**
         * @protected
         * @type {!Array<import("../events.js").EventsKey>}
         */ _this.listenerKeys = [];
        if (options.render) _this.render = options.render;
        if (options.target) _this.setTarget(options.target);
        return _this;
    }
    /**
     * Clean up.
     */ Control.prototype.disposeInternal = function() {
        (0, $djuby.removeNode)(this.element);
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Get the map associated with this control.
     * @return {import("../PluggableMap.js").default|null} Map.
     * @api
     */ Control.prototype.getMap = function() {
        return this.map_;
    };
    /**
     * Remove the control from its current map and attach it to the new map.
     * Pass `null` to just remove the control from the current map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default|null} map Map.
     * @api
     */ Control.prototype.setMap = function(map) {
        if (this.map_) (0, $djuby.removeNode)(this.element);
        for(var i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $1dBX3.unlistenByKey)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            var target = this.target_ ? this.target_ : map.getOverlayContainerStopEvent();
            target.appendChild(this.element);
            if (this.render !== (0, $c8IGo.VOID)) this.listenerKeys.push((0, $1dBX3.listen)(map, (0, $9UyUk.default).POSTRENDER, this.render, this));
            map.render();
        }
    };
    /**
     * Renders the control.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @api
     */ Control.prototype.render = function(mapEvent) {};
    /**
     * This function is used to set a target element for the control. It has no
     * effect if it is called after the control has been added to the map (i.e.
     * after `setMap` is called on the control). If no `target` is set in the
     * options passed to the control constructor and if `setTarget` is not called
     * then the control is added to the map's overlay container.
     * @param {HTMLElement|string} target Target.
     * @api
     */ Control.prototype.setTarget = function(target) {
        this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
    };
    return Control;
}((0, $aK3Yt.default));
var $cb66033c9d7bfc96$export$2e2bcd8739ae039 = $cb66033c9d7bfc96$var$Control;

});
parcelRegister("9UyUk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73746bec087b1c0d$export$2e2bcd8739ae039; });
/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $73746bec087b1c0d$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
     * Triggered after a map frame is rendered.
     * @event module:ol/MapEvent~MapEvent#postrender
     * @api
     */ POSTRENDER: 'postrender',
    /**
     * Triggered when the map starts moving.
     * @event module:ol/MapEvent~MapEvent#movestart
     * @api
     */ MOVESTART: 'movestart',
    /**
     * Triggered after the map is moved.
     * @event module:ol/MapEvent~MapEvent#moveend
     * @api
     */ MOVEEND: 'moveend',
    /**
     * Triggered when loading of additional map data (tiles, images, features) starts.
     * @event module:ol/MapEvent~MapEvent#loadstart
     * @api
     */ LOADSTART: 'loadstart',
    /**
     * Triggered when loading of additional map data has completed.
     * @event module:ol/MapEvent~MapEvent#loadend
     * @api
     */ LOADEND: 'loadend'
};

});

parcelRegister("djuby", function(module, exports) {

$parcel$export(module.exports, "createCanvasContext2D", function () { return $9b1476e86480f03e$export$9e05d10eae75c464; });
$parcel$export(module.exports, "releaseCanvas", function () { return $9b1476e86480f03e$export$e918ac6a1026a12a; });
$parcel$export(module.exports, "replaceNode", function () { return $9b1476e86480f03e$export$5542201de9311ab2; });
$parcel$export(module.exports, "removeNode", function () { return $9b1476e86480f03e$export$1d0aa160432dfea5; });
$parcel$export(module.exports, "removeChildren", function () { return $9b1476e86480f03e$export$1e1c9bf5a4ffe0d1; });
$parcel$export(module.exports, "replaceChildren", function () { return $9b1476e86480f03e$export$caeacfe04f52533a; });

var $bInFo = parcelRequire("bInFo");
function $9b1476e86480f03e$export$9e05d10eae75c464(opt_width, opt_height, opt_canvasPool, opt_Context2DSettings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ var canvas;
    if (opt_canvasPool && opt_canvasPool.length) canvas = opt_canvasPool.shift();
    else if (0, $bInFo.WORKER_OFFSCREEN_CANVAS) canvas = new OffscreenCanvas(opt_width || 300, opt_height || 300);
    else canvas = document.createElement('canvas');
    if (opt_width) canvas.width = opt_width;
    if (opt_height) canvas.height = opt_height;
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext('2d', opt_Context2DSettings);
}
function $9b1476e86480f03e$export$e918ac6a1026a12a(context) {
    var canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $9b1476e86480f03e$export$e823f88e4111159a(element) {
    var width = element.offsetWidth;
    var style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $9b1476e86480f03e$export$fc5b8aac72846d1e(element) {
    var height = element.offsetHeight;
    var style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $9b1476e86480f03e$export$5542201de9311ab2(newNode, oldNode) {
    var parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $9b1476e86480f03e$export$1d0aa160432dfea5(node) {
    return node && node.parentNode ? node.parentNode.removeChild(node) : null;
}
function $9b1476e86480f03e$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.removeChild(node.lastChild);
}
function $9b1476e86480f03e$export$caeacfe04f52533a(node, children) {
    var oldChildren = node.childNodes;
    for(var i = 0;; ++i){
        var oldChild = oldChildren[i];
        var newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}

});
parcelRegister("bInFo", function(module, exports) {

$parcel$export(module.exports, "FIREFOX", function () { return $88762972e549c7d8$export$8442bdfd18b7b8a6; });
$parcel$export(module.exports, "WEBKIT", function () { return $88762972e549c7d8$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "MAC", function () { return $88762972e549c7d8$export$76c0a3b101d93136; });
$parcel$export(module.exports, "DEVICE_PIXEL_RATIO", function () { return $88762972e549c7d8$export$6b83a0446fc26f94; });
$parcel$export(module.exports, "WORKER_OFFSCREEN_CANVAS", function () { return $88762972e549c7d8$export$98fcef3dc9973292; });
$parcel$export(module.exports, "IMAGE_DECODE", function () { return $88762972e549c7d8$export$716f8695eedb9bad; });
$parcel$export(module.exports, "PASSIVE_EVENT_LISTENERS", function () { return $88762972e549c7d8$export$f751ce96c6c4e4fc; });
/**
 * @module ol/has
 */ var $88762972e549c7d8$var$ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
var $88762972e549c7d8$export$8442bdfd18b7b8a6 = $88762972e549c7d8$var$ua.indexOf('firefox') !== -1;
var $88762972e549c7d8$export$3227bfbdaa9275de = $88762972e549c7d8$var$ua.indexOf('safari') !== -1 && $88762972e549c7d8$var$ua.indexOf('chrom') == -1;
var $88762972e549c7d8$export$b23eed0e325a206a = $88762972e549c7d8$export$3227bfbdaa9275de && !!($88762972e549c7d8$var$ua.indexOf('version/15.4') >= 0 || $88762972e549c7d8$var$ua.match(/cpu (os|iphone os) 15_4 like mac os x/));
var $88762972e549c7d8$export$39dfd62a25e0fe93 = $88762972e549c7d8$var$ua.indexOf('webkit') !== -1 && $88762972e549c7d8$var$ua.indexOf('edge') == -1;
var $88762972e549c7d8$export$76c0a3b101d93136 = $88762972e549c7d8$var$ua.indexOf('macintosh') !== -1;
var $88762972e549c7d8$export$6b83a0446fc26f94 = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
var $88762972e549c7d8$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line
var $88762972e549c7d8$export$716f8695eedb9bad = typeof Image !== 'undefined' && Image.prototype.decode;
var $88762972e549c7d8$export$f751ce96c6c4e4fc = function() {
    var passive = false;
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function() {
                passive = true;
            }
        });
        window.addEventListener('_', null, options);
        window.removeEventListener('_', null, options);
    } catch (error) {
    // passive not supported
    }
    return passive;
}();

});



parcelRegister("5pUgu", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("19Qft", function(module, exports) {
"use strict";
var $0d7f292c1135c6ad$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5Fsvp = parcelRequire("5Fsvp");

var $0d7f292c1135c6ad$var$form_data_1 = $0d7f292c1135c6ad$var$__importDefault((parcelRequire("1PmG8")));
/**
 * Duck type if NodeJS stream
 * https://github.com/sindresorhus/is-stream/blob/3750505b0727f6df54324784fe369365ef78841e/index.js#L3
 */ var $0d7f292c1135c6ad$var$isExtractableFileEnhanced = function(value) {
    return $5Fsvp.isExtractableFile(value) || value !== null && typeof value === 'object' && typeof value.pipe === 'function';
};
/**
 * Returns Multipart Form if body contains files
 * (https://github.com/jaydenseric/graphql-multipart-request-spec)
 * Otherwise returns JSON
 */ function $0d7f292c1135c6ad$var$createRequestBody(query, variables, operationName) {
    var _a = $5Fsvp.extractFiles({
        query: query,
        variables: variables,
        operationName: operationName
    }, '', $0d7f292c1135c6ad$var$isExtractableFileEnhanced), clone = _a.clone, files = _a.files;
    if (files.size === 0) {
        if (!Array.isArray(query)) return JSON.stringify(clone);
        if (typeof variables !== 'undefined' && !Array.isArray(variables)) throw new Error('Cannot create request body with given variable type, array expected');
        // Batch support
        var payload = query.reduce(function(accu, currentQuery, index) {
            accu.push({
                query: currentQuery,
                variables: variables ? variables[index] : undefined
            });
            return accu;
        }, []);
        return JSON.stringify(payload);
    }
    var Form = typeof FormData === 'undefined' ? $0d7f292c1135c6ad$var$form_data_1.default : FormData;
    var form = new Form();
    form.append('operations', JSON.stringify(clone));
    var map = {};
    var i = 0;
    files.forEach(function(paths) {
        map[++i] = paths;
    });
    form.append('map', JSON.stringify(map));
    i = 0;
    files.forEach(function(paths, file) {
        form.append("" + ++i, file);
    });
    return form;
}
module.exports.default = $0d7f292c1135c6ad$var$createRequestBody;

});
parcelRegister("5Fsvp", function(module, exports) {

$parcel$export(module.exports, "extractFiles", function () { return $4206e4b5b35ed986$export$f5544efc2684376b; }, function (v) { return $4206e4b5b35ed986$export$f5544efc2684376b = v; });
$parcel$export(module.exports, "isExtractableFile", function () { return $4206e4b5b35ed986$export$f892d0f8e65523c3; }, function (v) { return $4206e4b5b35ed986$export$f892d0f8e65523c3 = v; });
var $4206e4b5b35ed986$export$5fcafa2ee375e60a;
var $4206e4b5b35ed986$export$f5544efc2684376b;
var $4206e4b5b35ed986$export$f892d0f8e65523c3;
'use strict';

$4206e4b5b35ed986$export$5fcafa2ee375e60a = (parcelRequire("3JPTT"));

$4206e4b5b35ed986$export$f5544efc2684376b = (parcelRequire("5AefG"));

$4206e4b5b35ed986$export$f892d0f8e65523c3 = (parcelRequire("lvIvg"));

});
parcelRegister("3JPTT", function(module, exports) {
'use strict';
module.exports = function ReactNativeFile(_ref) {
    var uri = _ref.uri, name = _ref.name, type = _ref.type;
    this.uri = uri;
    this.name = name;
    this.type = type;
};

});

parcelRegister("5AefG", function(module, exports) {
'use strict';

var $lvIvg = parcelRequire("lvIvg");
module.exports = function extractFiles(value, path, isExtractableFile) {
    if (path === void 0) path = '';
    if (isExtractableFile === void 0) isExtractableFile = $lvIvg;
    var clone;
    var files = new Map();
    function addFile(paths, file) {
        var storedPaths = files.get(file);
        if (storedPaths) storedPaths.push.apply(storedPaths, paths);
        else files.set(file, paths);
    }
    if (isExtractableFile(value)) {
        clone = null;
        addFile([
            path
        ], value);
    } else {
        var prefix = path ? path + '.' : '';
        if (typeof FileList !== 'undefined' && value instanceof FileList) clone = Array.prototype.map.call(value, function(file, i) {
            addFile([
                '' + prefix + i
            ], file);
            return null;
        });
        else if (Array.isArray(value)) clone = value.map(function(child, i) {
            var result = extractFiles(child, '' + prefix + i, isExtractableFile);
            result.files.forEach(addFile);
            return result.clone;
        });
        else if (value && value.constructor === Object) {
            clone = {};
            for(var i in value){
                var result = extractFiles(value[i], '' + prefix + i, isExtractableFile);
                result.files.forEach(addFile);
                clone[i] = result.clone;
            }
        } else clone = value;
    }
    return {
        clone: clone,
        files: files
    };
};

});
parcelRegister("lvIvg", function(module, exports) {
'use strict';

var $3JPTT = parcelRequire("3JPTT");
module.exports = function isExtractableFile(value) {
    return typeof File !== 'undefined' && value instanceof File || typeof Blob !== 'undefined' && value instanceof Blob || value instanceof $3JPTT;
};

});



parcelRegister("1PmG8", function(module, exports) {
'use strict';
/* eslint-env browser */ module.exports = typeof self === 'object' ? self.FormData : window.FormData;

});


parcelRegister("hWw37", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"ground_level_areas\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753381.243860291,5140974.31767176],[-9753381.637769187,5140992.979440455],[-9753369.298069328,5140993.306319919],[-9753368.96512408,5140974.414518905],[-9753381.243860291,5140974.31767176]]]]}},{\"type\":\"Feature\",\"id\":\"playlab\",\"properties\":{\"closed\":0,\"label\":\"\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753381.243860291,5140974.31767176],[-9753443.665831545,5140972.824343761],[-9753443.862798223,5140991.819458507],[-9753420.567141665,5140992.306296086],[-9753420.567148747,5140992.306295961],[-9753420.687894441,5140999.001281091],[-9753387.699835569,5140999.596228804],[-9753387.58079255,5140992.995651864],[-9753381.54118494,5140993.121868878],[-9753381.243860291,5140974.31767176]]]]}},{\"type\":\"Feature\",\"id\":\"closed1\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753546.807923337,5140966.0729014715],[-9753532.444637734,5140966.352217421],[-9753532.33741366,5140960.838425495],[-9753546.70069926,5140960.5591095425],[-9753546.807923337,5140966.0729014715]]]]}},{\"type\":\"Feature\",\"id\":\"simpson_theater\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753611.200992813,5140981.972424801],[-9753560.881150065,5140982.745915123],[-9753560.275099412,5140943.318953214],[-9753610.59494216,5140942.54546289],[-9753611.200992813,5140981.972424801]]]]}},{\"type\":\"Feature\",\"id\":\"ward_hall\",\"properties\":{\"closed\":0,\"label\":\"Ward\\nHall\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753626.919270078,5141010.751923118],[-9753609.722219383,5141011.164506157],[-9753609.406380795,5140987.5681801615],[-9753626.486563122,5140987.385257899],[-9753626.919270078,5141010.751923118]]]]}},{\"type\":\"Feature\",\"id\":\"closed2\",\"properties\":{\"closed\":1,\"label\":\"\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753587.315453967,5140920.361614636],[-9753587.259829799,5140916.142093269],[-9753592.206484187,5140916.053677055],[-9753592.275179511,5140919.896999737],[-9753598.72846134,5140919.78165416],[-9753599.012813764,5140935.690423886],[-9753587.593088562,5140935.894539389],[-9753587.315453967,5140920.361614636]]]]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753587.59308856,5140935.894539389],[-9753558.699547717,5140936.410980857],[-9753558.478525544,5140920.354442435],[-9753587.308736134,5140919.985769664],[-9753587.59308856,5140935.894539389]]]]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753549.437253296,5140984.169352178],[-9753532.205607746,5140984.513125654],[-9753531.968171606,5140972.611639134],[-9753549.199817158,5140972.267865654],[-9753549.437253296,5140984.169352178]]]]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753531.432117423,5140942.87356321],[-9753548.62079129,5140942.443846363],[-9753548.913477456,5140954.151293045],[-9753531.724803587,5140954.581009892],[-9753531.432117423,5140942.87356321]]]]}},{\"type\":\"Feature\",\"id\":\"egypt\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753519.228158979,5140923.278475001],[-9753519.59428059,5140939.232478564],[-9753515.387039147,5140939.363604525],[-9753515.332058549,5140937.98908925],[-9753508.821000433,5140938.0603840025],[-9753508.70338352,5140931.748300896],[-9753505.972516237,5140931.799223218],[-9753506.713169644,5140958.28621342],[-9753461.77501658,5140958.944973276],[-9753460.915582886,5140924.6535689095],[-9753505.765255148,5140923.529516973],[-9753519.228158979,5140923.278475001]]]]}},{\"type\":\"Feature\",\"id\":\"closed3\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753515.016933883,5140977.036052523],[-9753506.9343322,5140977.091223868],[-9753506.898305384,5140971.813295609],[-9753514.980469296,5140971.693990364],[-9753515.016933883,5140977.036052523]]]]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753498.685083982,5141001.053293168],[-9753498.955639463,5141015.669307359],[-9753470.834333243,5141016.189857866],[-9753470.563777762,5141001.573843675],[-9753498.685083982,5141001.053293168]]]]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753544.233478064,5140984.273168141],[-9753544.32926138,5140989.074306758],[-9753537.93427421,5140989.201887548],[-9753537.838490896,5140984.400748932],[-9753544.233478064,5140984.273168141]]]]}},{\"type\":\"Feature\",\"id\":\"closed4\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753624.678764269,5141024.869982748],[-9753610.062348973,5141025.223595644],[-9753609.722219383,5141011.164506157],[-9753624.338634681,5141010.810893264],[-9753624.678764269,5141024.869982748]]]]}},{\"type\":\"Feature\",\"id\":\"siragusa_center\",\"properties\":{\"closed\":0,\"label\":\"Siragusa\\nCenter\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753498.476899259,5140997.8530512545],[-9753470.779961243,5140998.615181761],[-9753470.716525873,5140987.601693802],[-9753461.936086925,5140987.751903487],[-9753461.741993975,5140976.406288365],[-9753470.522432921,5140976.256078678],[-9753470.420989532,5140970.326251358],[-9753498.051782772,5140969.853562825],[-9753498.476899259,5140997.8530512545]]]]}},{\"type\":\"Feature\",\"id\":\"closed5\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753559.179031802,5141005.116679583],[-9753559.418096673,5141026.8566204645],[-9753526.403705152,5141027.466517548],[-9753526.008417042,5141005.886299415],[-9753559.179031802,5141005.116679583]]]]}},{\"type\":\"Feature\",\"id\":\"closed6\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753559.179031802,5141005.116679579],[-9753526.008417042,5141005.88629941],[-9753525.723044328,5140993.58673549],[-9753558.893659089,5140992.817115659],[-9753559.179031802,5141005.116679579]]]]}},{\"type\":\"Feature\",\"id\":\"closed7\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753549.516814072,5140988.81470502],[-9753544.312766576,5140988.903834539],[-9753544.233205797,5140984.258481696],[-9753549.437253296,5140984.169352173],[-9753549.516814072,5140988.81470502]]]]}},{\"type\":\"Feature\",\"id\":\"closed8\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753537.838490896,5140984.400748932],[-9753537.93427421,5140989.201887548],[-9753532.140695851,5140989.317470159],[-9753532.044912536,5140984.516331541],[-9753537.838490896,5140984.400748932]]]]}},{\"type\":\"Feature\",\"id\":\"closed9\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753599.012813764,5140935.690423886],[-9753598.72846134,5140919.78165416],[-9753592.275179511,5140919.896999737],[-9753592.206484187,5140916.053677055],[-9753587.259584364,5140916.142097656],[-9753587.049200088,5140899.69005047],[-9753604.649909299,5140899.149926858],[-9753604.515620952,5140894.471893979],[-9753624.759478118,5140894.120713468],[-9753625.522063581,5140935.3011915],[-9753599.012813764,5140935.690423886]]]]}},{\"type\":\"Feature\",\"id\":\"closed10\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753553.704878723,5140920.415486513],[-9753553.826860124,5140927.007756019],[-9753549.916715253,5140933.272874499],[-9753524.509273302,5140933.828929628],[-9753523.836598387,5140900.6506909],[-9753553.445342673,5140900.11976732],[-9753553.704878723,5140920.415486513]]]]}},{\"type\":\"Feature\",\"id\":\"closed11\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753519.14901187,5140923.277086448],[-9753460.915582886,5140924.6535689095],[-9753448.614303503,5140924.919546203],[-9753448.530657796,5140921.353597649],[-9753367.85638061,5140923.245957236],[-9753368.67753652,5140958.25313014],[-9753342.406629387,5140958.822250495],[-9753341.26617895,5140897.779787815],[-9753361.498707715,5140897.417278899],[-9753361.622032342,5140903.625476609],[-9753445.57811896,5140902.073252767],[-9753445.283580463,5140883.290759664],[-9753449.225864904,5140883.154818824],[-9753456.476043183,5140883.041534784],[-9753459.73862341,5140882.950907558],[-9753459.240173658,5140856.872922558],[-9753505.233492123,5140855.989307073],[-9753505.754598688,5140882.135262498],[-9753509.017178917,5140882.157919305],[-9753516.31267081,5140881.818067198],[-9753518.159200592,5140881.829395602],[-9753519.14901187,5140923.277086448]]]]}},{\"type\":\"Feature\",\"id\":\"closed12\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753523.935224101,5140903.5151600195],[-9753518.678598115,5140903.5788224535],[-9753518.159200592,5140881.829395602],[-9753520.005730374,5140881.840724006],[-9753520.436209708,5140900.713844344],[-9753523.836598387,5140900.6506909],[-9753523.935224101,5140903.5151600195]]]]}},{\"type\":\"Feature\",\"id\":\"closed13\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753368.96512408,5140974.414518905],[-9753369.298069328,5140993.306319919],[-9753387.58079255,5140992.995651864],[-9753387.699835569,5140999.596228804],[-9753420.687894441,5140999.001281091],[-9753420.567148747,5140992.306295961],[-9753443.862798223,5140991.819458507],[-9753444.650055245,5141029.0512712905],[-9753363.97362249,5141030.378862222],[-9753364.081049304,5141034.211343245],[-9753343.803741354,5141034.615574449],[-9753342.917096583,5140974.881520294],[-9753368.96512408,5140974.414518905]]]]}},{\"type\":\"Feature\",\"id\":\"closed14\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753522.679233609,5141027.53532222],[-9753522.985100504,5141045.864679188],[-9753519.337354554,5141046.023276834],[-9753512.064519465,5141046.091247255],[-9753508.450758737,5141046.102575668],[-9753508.813267648,5141070.3793445],[-9753463.55629541,5141071.251631574],[-9753463.13714448,5141047.031504758],[-9753459.602682568,5141047.07681837],[-9753452.26187706,5141047.212759216],[-9753448.410219848,5141047.258072831],[-9753447.979740513,5141028.996686288],[-9753449.960786344,5141026.1076457435],[-9753449.365952777,5141001.868177838],[-9753470.563777762,5141001.573843675],[-9753470.834333243,5141016.189857866],[-9753498.955639463,5141015.669307359],[-9753498.787372427,5141006.579144477],[-9753520.969043551,5141006.032012816],[-9753521.37501896,5141025.669282852],[-9753522.679233609,5141027.53532222]]]]}},{\"type\":\"Feature\",\"id\":\"closed15\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753520.2191541,5140971.527885755],[-9753520.721523141,5141000.694122868],[-9753501.153650315,5141001.124635879],[-9753501.153650315,5140997.8530512545],[-9753498.476899259,5140997.8530512545],[-9753498.481117005,5140994.950100134],[-9753498.051782772,5140969.853562825],[-9753506.80456921,5140969.52410257],[-9753506.898305384,5140971.813295609],[-9753506.9343322,5140977.091223868],[-9753515.016933883,5140977.036052523],[-9753514.980469296,5140971.693990364],[-9753520.2191541,5140971.527885755]]]]}},{\"type\":\"Feature\",\"id\":\"closed16\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753548.913477456,5140954.151293045],[-9753548.62079129,5140942.443846363],[-9753531.432117423,5140942.87356321],[-9753531.724803587,5140954.581009892],[-9753525.63476936,5140954.8577374015],[-9753525.448883867,5140950.136245953],[-9753519.686433675,5140950.136245953],[-9753519.537725285,5140942.626472157],[-9753524.668164812,5140942.4405866675],[-9753524.482279321,5140938.0536891],[-9753548.61021593,5140937.49603263],[-9753549.576820478,5140937.533209727],[-9753550.060122753,5140937.607563924],[-9753550.989550203,5140937.681918122],[-9753552.030508947,5140938.0536891],[-9753552.662519615,5140938.388282982],[-9753553.443238672,5140938.797231063],[-9753553.85218675,5140939.131824943],[-9753554.298311926,5140939.652304313],[-9753554.818791296,5140940.321492079],[-9753555.339270672,5140941.065034038],[-9753555.93410424,5140942.068815685],[-9753556.231521023,5140943.741785099],[-9753556.30587522,5140946.083942272],[-9753556.157166827,5140947.347963601],[-9753556.343052316,5140948.017151366],[-9753556.045635533,5140949.392703994],[-9753555.859750044,5140950.024714662],[-9753555.56233326,5140950.508016934],[-9753554.930322595,5140951.400267286],[-9753554.335489025,5140952.218163441],[-9753553.10864479,5140953.147590896],[-9753552.365102828,5140953.519361875],[-9753551.510029575,5140953.816778659],[-9753550.543425027,5140954.039841243],[-9753548.913477456,5140954.151293045]]]]}},{\"type\":\"Feature\",\"id\":\"closed17\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753549.199817158,5140972.267865654],[-9753550.952373108,5140972.238030724],[-9753551.528618129,5140972.368150567],[-9753551.937566208,5140972.442504759],[-9753552.40227993,5140972.702744448],[-9753552.736873813,5140972.851452841],[-9753553.424650127,5140973.1116925245],[-9753553.796421109,5140973.278989464],[-9753554.484197421,5140973.743703192],[-9753554.781614205,5140974.11547417],[-9753555.171973735,5140974.505833701],[-9753556.268698122,5140975.788443581],[-9753556.49176071,5140976.8294023285],[-9753556.789177496,5140978.019069461],[-9753556.93788589,5140978.762611424],[-9753556.863531692,5140979.877924361],[-9753556.863531692,5140980.918883109],[-9753556.93788589,5140981.736779265],[-9753556.93788589,5140983.000800595],[-9753556.789177496,5140984.264821927],[-9753556.119989732,5140985.082718086],[-9753555.599510357,5140986.346739419],[-9753554.558551613,5140987.3876981605],[-9753553.294530282,5140987.685114948],[-9753551.510029579,5140988.205594318],[-9753550.1530655,5140988.410068357],[-9753549.516814072,5140988.81470502],[-9753544.32926138,5140989.074306758],[-9753544.233457338,5140984.273168553],[-9753549.437253296,5140984.169352178],[-9753549.199817158,5140972.267865654]]]]}},{\"type\":\"Feature\",\"id\":\"closed18\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753532.140695851,5140989.317470159],[-9753532.122172963,5140990.175980512],[-9753526.173837282,5140990.175980512],[-9753525.8392434,5140972.330973468],[-9753531.968171606,5140972.611639134],[-9753532.140695851,5140989.317470159]]]]}},{\"type\":\"Feature\",\"id\":\"closed19\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753470.75018903,5140993.446205675],[-9753470.779961243,5140998.615181761],[-9753449.135349201,5140998.912598545],[-9753448.610316366,5140970.6413809545],[-9753461.70494226,5140970.370332403],[-9753461.894060446,5140993.63186925],[-9753470.75018903,5140993.446205675]]]]}},{\"type\":\"Feature\",\"id\":\"closed20\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753457.65644564,5140951.586152783],[-9753457.173143364,5140951.511798586],[-9753457.210320463,5140950.396485644],[-9753457.135966267,5140949.095287216],[-9753457.135966267,5140947.9056200795],[-9753457.135966267,5140946.715952941],[-9753457.09878917,5140945.637817097],[-9753457.024434974,5140944.782743843],[-9753456.87572658,5140944.002024785],[-9753456.355247209,5140942.440586671],[-9753455.871944936,5140941.771398907],[-9753455.425819758,5140941.102211142],[-9753455.016871681,5140940.61890887],[-9753454.422038112,5140940.098429494],[-9753453.715673251,5140939.689481419],[-9753453.195193877,5140939.317710438],[-9753452.526006112,5140938.983116553],[-9753451.782464154,5140938.722876868],[-9753450.853036704,5140938.499814282],[-9753450.109494744,5140938.425460086],[-9753449.477484075,5140938.425460086],[-9753448.932056041,5140938.465838566],[-9753448.922863606,5140938.073950552],[-9753449.9793749,5140938.14663185],[-9753450.797271058,5140938.183808953],[-9753451.354927527,5140938.313928795],[-9753452.172823684,5140938.536991379],[-9753453.009308388,5140938.834408164],[-9753453.529787758,5140939.057470749],[-9753454.08744423,5140939.410653182],[-9753454.552157957,5140939.801012714],[-9753455.128402974,5140940.265726439],[-9753455.667470897,5140940.841971455],[-9753456.039241875,5140941.288096634],[-9753456.559721246,5140942.105992788],[-9753456.894315131,5140942.812357649],[-9753457.154554818,5140943.351425575],[-9753457.414794503,5140944.09496753],[-9753457.433383053,5140944.559681258],[-9753457.65644564,5140951.586152783]]]]}},{\"type\":\"Feature\",\"id\":\"closed21\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753609.985691268,5141022.054987026],[-9753610.062348973,5141025.223595644],[-9753624.678764269,5141024.869982748],[-9753624.338634681,5141010.810893264],[-9753626.919270078,5141010.751923118],[-9753627.263055293,5141029.316713676],[-9753607.058847541,5141029.665062087],[-9753607.063939754,5141025.976314691],[-9753607.014230225,5141022.044269695],[-9753609.985691268,5141022.054987026]]]]}},{\"type\":\"Feature\",\"id\":\"closed22\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753604.539362218,5141026.02306495],[-9753559.418096673,5141026.8566204645],[-9753558.795640882,5140988.6006597355],[-9753606.287828093,5140987.718034433],[-9753607.014230225,5141022.044269695],[-9753607.063939754,5141025.976314691],[-9753604.539362218,5141026.02306495]]]]}},{\"type\":\"Feature\",\"id\":\"closed23\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753618.926049689,5140977.282498213],[-9753618.646651533,5140977.287731654],[-9753618.070406513,5140946.523683051],[-9753618.34980467,5140946.518449614],[-9753618.926049689,5140977.282498213]]]]}},{\"type\":\"Feature\",\"id\":\"closed24\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753618.637927074,5140960.035496278],[-9753617.715173637,5140960.285355955],[-9753617.039671266,5140960.967985186],[-9753616.792420276,5140961.9004740175],[-9753617.03967137,5140962.83296282],[-9753617.71517382,5140963.515591973],[-9753618.637927286,5140963.765451547],[-9753619.560680723,5140963.515591869],[-9753620.236183094,5140962.832962639],[-9753620.483434085,5140961.900473807],[-9753620.23618299,5140960.967985004],[-9753619.56068054,5140960.285355851],[-9753618.637927074,5140960.035496278]]]]}},{\"type\":\"Feature\",\"id\":\"closed25\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753508.821000433,5140938.0603840025],[-9753515.332058549,5140937.98908925],[-9753515.517446525,5140944.839251455],[-9753508.94684798,5140944.9447809355],[-9753508.821000433,5140938.0603840025]]]]}},{\"type\":\"Feature\",\"id\":\"closed26\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[]}},{\"type\":\"Feature\",\"id\":\"closed27\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753470.75018903,5140993.446205675],[-9753461.894060446,5140993.63186925],[-9753461.936086925,5140987.751903487],[-9753470.716525873,5140987.601693802],[-9753470.75018903,5140993.446205675]]]]}},{\"type\":\"Feature\",\"id\":\"closed28\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753470.522432921,5140976.256078678],[-9753461.741993975,5140976.406288365],[-9753461.70494226,5140970.370332403],[-9753470.420989532,5140970.326251358],[-9753470.522432921,5140976.256078678]]]]}},{\"type\":\"Feature\",\"id\":\"explorer_cafe\",\"properties\":{\"closed\":0,\"label\":\"Explorer Cafe\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753587.259829799,5140916.142093269],[-9753587.315453967,5140920.361614636],[-9753587.308736136,5140919.985769664],[-9753553.704878723,5140920.415486513],[-9753553.445342673,5140900.11976732],[-9753587.049200088,5140899.69005047],[-9753587.259584364,5140916.142097656],[-9753587.259829799,5140916.142093269]]]]}},{\"type\":\"Feature\",\"id\":\"harris\",\"properties\":{\"closed\":0,\"label\":\"Harris Loan Center\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753606.648121325,5141004.743741971],[-9753559.179031802,5141005.116679579],[-9753558.795640882,5140988.6006597355],[-9753606.287828093,5140987.718034433],[-9753606.287828093,5140987.718034433],[-9753606.287828093,5140987.718034433],[-9753606.648121325,5141004.743741971]]]]}},{\"type\":\"Feature\",\"id\":\"biomechanics\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753450.79727106,5140938.18380895],[-9753368.24546408,5140939.83319996],[-9753367.97110073,5140928.13665707],[-9753450.53066235,5140927.16488676],[-9753450.79727106,5140938.18380895]]]]}},{\"type\":\"Feature\",\"id\":\"underground\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753449.400729496,5140958.421637181],[-9753368.969282648,5140959.519900881],[-9753368.24546408,5140939.83319996],[-9753448.932056041,5140938.465838566],[-9753449.400729496,5140958.421637181]]]]}},{\"type\":\"Feature\",\"properties\":{\"id\":\"visitorservices\",\"closed\":0,\"label\":\"Visitor Services\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753520.31281486,5140976.965585321],[-9753515.016933883,5140977.036052523],[-9753514.980469296,5140971.693990364],[-9753520.2191541,5140971.527885755],[-9753520.31281486,5140976.965585321]]]]}},{\"type\":\"Feature\",\"id\":\"visitorservices\",\"properties\":{\"closed\":0,\"label\":\"Visitor Services\"},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-87.6173637,41.8663277],[-87.6173629,41.8662913],[-87.6173158,41.8662924],[-87.6173161,41.8663282],[-87.6173637,41.8663277]]]}}]}");

});

parcelRegister("g5D4G", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"ground_level_labels\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"id\":\"egypt\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753483.68979099,5140944.760975551]}},{\"type\":\"Feature\",\"id\":\"underground\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753402.28125,5140954.526322099]}},{\"type\":\"Feature\",\"id\":\"simpson_theater\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753585.738046113,5140962.645689007]}},{\"type\":\"Feature\",\"id\":\"playlab\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753409.141499124,5140982.048988507]}},{\"type\":\"Feature\",\"id\":\"harris\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753582.847775519,5140996.542178218]}},{\"type\":\"Feature\",\"id\":\"biomechanics\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753402.451138392,5140929.462015461]}}]}");

});

parcelRegister("gqxYO", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"ground_level_amenities\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"properties\":{\"type\":\"restroom\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753485.468601841,5141008.308355463]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"restroom\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753573.319908632,5140928.243484347]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"picnic_area\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753540.56609772,5140978.178234835]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"picnic_area\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753540.142921865,5140948.21738454]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"first_aid\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753540.989273569,5140986.72638703]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"elevator\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753521.544343192,5140952.554937018]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"guest_services\"},\"geometry\":null},{\"type\":\"Feature\",\"properties\":{\"type\":\"restroom\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753375.231292507,5140983.891108826]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stroller\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753357.79919363,5140959.467022678]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"wheelchair\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753347.35750274,5140959.687284166]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"elevator\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753445.910657259,5140953.820914226]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"picnic_area\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753491.94888244,5140983.780241814]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753521.750354467,5140907.415998525]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753445.721843353,5140965.066300285]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753522.569809346,5140963.50751801]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753523.74965424,5141020.206791695]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"entrance\"},\"geometry\":null},{\"type\":\"Feature\",\"properties\":{\"type\":\"restaurant\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753556.577741833,5140916.176459714]}}]}");

});

parcelRegister("aK4Zw", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"ground_level_flows\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"properties\":{\"id\":\"egypt\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753507.542852473,5140945.093267804],[-9753507.634150794,5140945.090979627],[-9753507.186258966,5140927.220087335],[-9753465.188938258,5140928.272651283],[-9753465.61353363,5140945.214014382],[-9753483.68979099,5140944.760975551],[-9753484.031299507,5140958.387171692]]]},\"id\":\"egypt\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"underground\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753453.03748549,5140951.177420398],[-9753453.043793287,5140951.177272436],[-9753452.824273182,5140941.818809059],[-9753428.12497743,5140942.39817681],[-9753428.39510019,5140953.913905788],[-9753376.78726691,5140955.124463159],[-9753376.19975078,5140930.077790407],[-9753427.835392537,5140928.866580737],[-9753428.031053465,5140937.207892615],[-9753452.53685091,5140936.633063724]]]},\"id\":\"underground\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"simpson_theater\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753559.497490223,5140939.913828289],[-9753613.960944155,5140939.076644539],[-9753614.05008613,5140949.069175865],[-9753600.276121704,5140949.2264196295]]]},\"id\":\"simpson_theater\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"simpson_theater\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753600.796260199,5140973.980160126],[-9753614.407453712,5140973.825097343],[-9753614.568374816,5140984.695413291],[-9753560.43143188,5140985.527578088]]]},\"id\":\"simpson_theater\"}]}");

});

parcelRegister("ahlg0", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"ground_level_pictograms\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"properties\":{\"id\":\"east_entrance\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753319.122814488,5140967.457606696]},\"id\":\"east_entrance\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"bushman\",\"label\":\"Bushman\\nthe\\nGorilla\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753385.819824317,5140964.396295527]},\"id\":\"bushman\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"sarcophagus\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753483.519976422,5140927.813226977]},\"id\":\"sarcophagus\"}]}");

});

parcelRegister("idVDg", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"ground_level_outline\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753624.759478115,5140894.120713461],[-9753627.263055293,5141029.316713676],[-9753607.058847541,5141029.665062087],[-9753607.063939754,5141025.976314691],[-9753522.679233605,5141027.535322215],[-9753522.9851005,5141045.864679184],[-9753508.450758735,5141046.102575664],[-9753508.813267646,5141070.379344492],[-9753463.556295408,5141071.251631579],[-9753463.13714448,5141047.031504756],[-9753448.410219844,5141047.258072832],[-9753447.97974051,5141028.996686283],[-9753363.97362249,5141030.378862222],[-9753364.081583722,5141034.230408727],[-9753343.803741354,5141034.615574449],[-9753342.865740685,5140975.045279594],[-9753335.70518932,5140975.147719682],[-9753335.8661858,5140981.185087659],[-9753315.537617564,5140981.63606781],[-9753314.92856138,5140953.619483319],[-9753335.383196361,5140952.769209048],[-9753335.62469108,5140958.565082306],[-9753342.406629387,5140958.822250495],[-9753341.31149256,5140899.4110779315],[-9753341.26617895,5140897.779787815],[-9753361.498707715,5140897.417278899],[-9753361.521364525,5140899.071225817],[-9753361.622032342,5140903.625476609],[-9753445.578118956,5140902.073252767],[-9753445.283580465,5140883.290759662],[-9753459.738623409,5140882.9509075545],[-9753459.240173655,5140856.872922553],[-9753505.233492121,5140855.989307068],[-9753505.75459869,5140882.135262494],[-9753520.005730372,5140881.840724009],[-9753520.436209707,5140900.713844343],[-9753604.649909299,5140899.149926858],[-9753604.515620952,5140894.47189398],[-9753624.759478115,5140894.120713461]]]]}}]}");

});

parcelRegister("3l695", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"main_level_areas\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"id\":\"mastaba\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753514.85857494,5140930.035147481],[-9753514.71179873,5140921.183687691],[-9753508.722089095,5140921.283009938],[-9753508.868865306,5140930.134469728],[-9753514.85857494,5140930.035147481]]]]}},{\"type\":\"Feature\",\"id\":\"sci_hub\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753461.184043746,5140944.97158919],[-9753460.977674186,5140932.52630362],[-9753448.931702591,5140932.7260516975],[-9753449.138072152,5140945.171337267],[-9753461.184043746,5140944.97158919]]]]}},{\"type\":\"Feature\",\"id\":\"africa\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753525.481762674,5140971.286167441],[-9753525.479755118,5140936.830465356],[-9753605.456204,5140936.202481407],[-9753605.613742506,5140954.770470723],[-9753594.523026718,5140954.857647305],[-9753594.647740528,5140970.74315993],[-9753525.481762674,5140971.286167441]]]]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":0,\"label\":\"Bird Habitats\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753565.572200978,5140936.512132877],[-9753565.274356497,5140920.389487648],[-9753604.959582085,5140919.656250031],[-9753605.26764159,5140935.77870655],[-9753565.572200978,5140936.512132877]]]]}},{\"type\":\"Feature\",\"id\":\"animals\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753604.959582085,5140919.656250031],[-9753524.966332426,5140921.134124917],[-9753524.627231043,5140900.63600694],[-9753604.603639327,5140899.15078613],[-9753604.959582085,5140919.656250031]]]]}},{\"type\":\"Feature\",\"id\":\"mammals\",\"properties\":{\"closed\":0,\"label\":\"\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753604.515620952,5140894.47189398],[-9753624.759478115,5140894.120713461],[-9753627.263055293,5141029.316713676],[-9753607.058847541,5141029.665062087],[-9753604.515620952,5140894.47189398]]],[[[-9753606.274463274,5140988.471249495],[-9753539.710568096,5140989.705241877],[-9753525.799378725,5140989.968110671],[-9753525.670325827,5140971.709801922],[-9753605.92586321,5140970.227081617],[-9753606.274463274,5140988.471249495]]]]}},{\"type\":\"Feature\",\"id\":\"rice_gallery\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753594.82663546,5140970.432230851],[-9753594.53321271,5140954.548938748],[-9753605.622377085,5140954.343975423],[-9753605.92586321,5140970.227081617],[-9753594.82663546,5140970.432230851]]]]}},{\"type\":\"Feature\",\"id\":\"birds\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753527.201100433,5141027.451786725],[-9753526.807377506,5141006.139137039],[-9753606.58549574,5141004.74929742],[-9753606.976939864,5141025.977928204],[-9753527.201100433,5141027.451786725]]]]}},{\"type\":\"Feature\",\"id\":\"nature_walk\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753518.789369285,5140990.142869133],[-9753606.274463274,5140988.471249495],[-9753606.58549574,5141004.74929742],[-9753519.100401746,5141006.420917057],[-9753519.14436121,5141008.721558736],[-9753507.739608236,5141008.9394748155],[-9753507.330137007,5140987.5095820865],[-9753518.73488998,5140987.291666007],[-9753518.789369285,5140990.142869133]]]]}},{\"type\":\"Feature\",\"id\":\"fm_store\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753396.531488653,5140923.725139087],[-9753396.191173151,5140902.877636583],[-9753441.87363708,5140902.131914134],[-9753442.213952582,5140922.979416639],[-9753396.531488653,5140923.725139087]]]]}},{\"type\":\"Feature\",\"id\":\"founders\",\"properties\":{\"closed\":1,\"label\":\"Founders Room\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753445.578118956,5140902.073252767],[-9753445.283580465,5140883.290759662],[-9753449.225864904,5140883.154818824],[-9753456.610879745,5140883.154774622],[-9753459.914564807,5140883.087891281],[-9753460.292563183,5140901.759021652],[-9753445.578118956,5140902.073252767]]]]}},{\"type\":\"Feature\",\"id\":\"pawnee_lodge\",\"properties\":{\"closed\":0,\"label\":\"\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753362.754906638,5140940.078014171],[-9753392.24689001,5140939.591681122],[-9753392.543315366,5140957.750502436],[-9753363.051446784,5140958.243867473],[-9753362.754906638,5140940.078014171]]]]}},{\"type\":\"Feature\",\"id\":\"field_bistro\",\"properties\":{\"closed\":0,\"label\":\"Field Bistro\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753449.413015798,5141000.869047611],[-9753462.787529891,5141000.651824036],[-9753463.215160027,5141026.981126775],[-9753459.215138754,5141027.04609354],[-9753459.404078057,5141038.568583274],[-9753469.355711736,5141038.37472028],[-9753469.614195729,5141046.840071008],[-9753462.978697754,5141047.013395063],[-9753459.602682564,5141047.0768183675],[-9753452.261877062,5141047.21275921],[-9753448.410219844,5141047.258072832],[-9753447.97974051,5141028.996686283],[-9753449.840645934,5141027.19835035],[-9753449.413015798,5141000.869047611]]]]}},{\"type\":\"Feature\",\"id\":\"field_bistro_rooms\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753433.499503914,5141029.234067211],[-9753433.165872103,5141008.882526771],[-9753443.438395854,5141008.714124742],[-9753443.772027666,5141029.065665182],[-9753433.499503914,5141029.234067211]]]]}},{\"type\":\"Feature\",\"id\":\"field_bistro_stairs\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753447.97974051,5141028.996686283],[-9753443.772027666,5141029.065665182],[-9753443.438395854,5141008.714124742],[-9753449.539005365,5141008.626259212],[-9753449.840645934,5141027.19835035],[-9753447.97974051,5141028.996686283]]]]}},{\"type\":\"Feature\",\"id\":\"pawnee_lodge_behind1\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753363.323655961,5140974.919221706],[-9753363.051446784,5140958.243867473],[-9753385.714674208,5140957.86197346],[-9753385.986883385,5140974.537327693],[-9753363.323655961,5140974.919221706]]]]}},{\"type\":\"Feature\",\"id\":\"hall_7\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753392.24689001,5140939.591681122],[-9753434.541683692,5140938.894225285],[-9753442.729595974,5140938.760565463],[-9753443.02613612,5140965.281235252],[-9753385.853386872,5140966.359419478],[-9753385.714674208,5140957.86197346],[-9753392.543315366,5140957.750502436],[-9753392.24689001,5140939.591681122]]]]}},{\"type\":\"Feature\",\"id\":\"museum_store_behind\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753368.157615503,5140924.188315377],[-9753362.675038,5140924.277813201],[-9753362.633718824,5140917.679486449],[-9753367.99578528,5140917.545662514],[-9753367.813858774,5140903.511129395],[-9753396.195996644,5140903.11319719],[-9753396.532466583,5140923.725123123],[-9753368.157615503,5140924.188315377]]]]}},{\"type\":\"Feature\",\"id\":\"kitchen_catering\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753520.005730372,5140881.840724009],[-9753520.47436891,5140902.797743669],[-9753506.010526069,5140903.12118251],[-9753505.541887531,5140882.16416285],[-9753508.794099439,5140882.098321586],[-9753516.444335738,5140881.9475306235],[-9753520.005730372,5140881.840724009]]]]}},{\"type\":\"Feature\",\"id\":\"server_room\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753565.572199995,5140936.512079652],[-9753519.34720153,5140937.366078415],[-9753519.04935705,5140921.243433187],[-9753565.274356497,5140920.389487648],[-9753565.572199995,5140936.512079652]]]]}},{\"type\":\"Feature\",\"id\":\"northwest_stairs\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753522.9851005,5141045.864679184],[-9753519.33735455,5141046.023276834],[-9753512.064519461,5141046.091247251],[-9753508.502986735,5141046.15815577],[-9753508.605609586,5141054.202960782],[-9753500.729767283,5141054.2572769355],[-9753500.695658367,5141037.372917204],[-9753511.748528073,5141037.27151473],[-9753511.65036954,5141025.684425764],[-9753522.646864003,5141025.591237538],[-9753522.9851005,5141045.864679184]]]]}},{\"type\":\"Feature\",\"id\":\"coat_check\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753447.983469244,5140927.816000684],[-9753447.851483073,5140919.73061514],[-9753467.841340588,5140919.404299872],[-9753467.97332676,5140927.489685416],[-9753447.983469244,5140927.816000684]]]]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753525.670325827,5140971.709801922],[-9753525.72298442,5140979.159900819],[-9753512.258045096,5140979.404434448],[-9753512.120521199,5140971.960116587],[-9753525.670325827,5140971.709801922]]]]}},{\"type\":\"Feature\",\"id\":\"hall_5\",\"properties\":{\"closed\":0,\"label\":\"\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753443.02613612,5140965.281235252],[-9753385.853386872,5140966.359419478],[-9753385.986883385,5140974.537327693],[-9753386.278030088,5140992.5232171],[-9753443.371153401,5140991.587663408],[-9753443.02613612,5140965.281235252]]]]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753443.371153401,5140991.587663408],[-9753449.260732198,5140991.492905299],[-9753449.141648842,5140984.09141941],[-9753443.252070045,5140984.186177519],[-9753443.371153401,5140991.587663408]]]]}},{\"type\":\"Feature\",\"id\":\"\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753443.129772538,5140973.183169771],[-9753443.228841383,5140980.736842044],[-9753448.874014251,5140980.662803783],[-9753448.774945406,5140973.10913151],[-9753443.129772538,5140973.183169771]]]]}},{\"type\":\"Feature\",\"id\":\"pawnee_lodge_behind2\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753385.986883385,5140974.537327693],[-9753363.323655961,5140974.919221706],[-9753363.626581868,5140992.89614324],[-9753386.289809292,5140992.514249227],[-9753385.986883385,5140974.537327693]]]]}},{\"type\":\"Feature\",\"id\":\"pawnee_lodge\",\"properties\":{\"closed\":0,\"label\":\"Pawnee Lodge\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753392.24689001,5140939.591681122],[-9753362.754906638,5140940.078014171],[-9753392.24677522,5140939.584649134],[-9753392.24689001,5140939.591681122]]]]}},{\"type\":\"Feature\",\"id\":\"hall_7\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753434.541683692,5140938.894225285],[-9753392.24689001,5140939.591681122],[-9753392.24677522,5140939.584649134],[-9753434.541683692,5140938.894225285]]]]}},{\"type\":\"Feature\",\"id\":\"hall_8\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753362.675038,5140924.277813201],[-9753434.284022221,5140923.108865153],[-9753434.541703094,5140938.894224965],[-9753362.754906638,5140940.078014171],[-9753362.675038,5140924.277813201]]]]}},{\"type\":\"Feature\",\"id\":\"americas\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753362.675038,5140924.277813201],[-9753362.754906638,5140940.078014171],[-9753363.617114542,5140992.896300279],[-9753449.260732198,5140991.492905299],[-9753449.539005365,5141008.626259212],[-9753433.166030396,5141008.892182605],[-9753433.499503914,5141029.234067211],[-9753363.97362249,5141030.333437905],[-9753364.081583722,5141034.230408727],[-9753343.803741354,5141034.615574449],[-9753341.31149256,5140899.4110779315],[-9753361.521346858,5140899.069936143],[-9753361.622032342,5140903.579930438],[-9753367.813858774,5140903.511129395],[-9753367.99578528,5140917.545662514],[-9753362.633718824,5140917.679486449],[-9753362.675038,5140924.277813201]]]]}},{\"type\":\"Feature\",\"id\":\"conn_thread\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753524.620691553,5140941.471910829],[-9753524.772259166,5140948.814341921],[-9753512.971471734,5140949.057942055],[-9753512.81990412,5140941.7155109625],[-9753524.620691553,5140941.471910829]]]]}}]}");

});

parcelRegister("jBI1A", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"main_level_labels\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"id\":\"sci_hub\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753454.357970133,5140938.79385571]}},{\"type\":\"Feature\",\"id\":\"mastaba\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753511.79033202,5140925.659078709]}},{\"type\":\"Feature\",\"id\":\"hall_8\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753405.112261724,5140930.9009200595]}},{\"type\":\"Feature\",\"id\":\"birds\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753560.363374528,5141014.868127718]}},{\"type\":\"Feature\",\"id\":\"africa\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753560.159564102,5140954.168612324]}},{\"type\":\"Feature\",\"id\":\"animals\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753558.58856042,5140907.847204695]}},{\"type\":\"Feature\",\"id\":\"americas\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753400.755518517,5141017.767494932]}},{\"type\":\"Feature\",\"id\":\"hall_7\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753425.809495509,5140948.384924443]}},{\"type\":\"Feature\",\"id\":\"fm_store\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753419.202562867,5140912.928526611]}},{\"type\":\"Feature\",\"id\":\"nature_walk\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753559.940988036,5140998.319427616]}},{\"type\":\"Feature\",\"id\":\"maximo\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753483.03669151,5141011.125253015]}},{\"type\":\"Feature\",\"id\":\"mammals\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753559.959070103,5140981.582581293]}},{\"type\":\"Feature\",\"id\":\"hall_5\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753431.528731154,5140982.831600999]}},{\"type\":\"Feature\",\"id\":\"rice_gallery\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753600.179601952,5140967.6063613845]}},{\"type\":\"Feature\",\"id\":\"pawnee_lodge\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753377.648188157,5140948.916032106]}},{\"type\":\"Feature\",\"id\":\"conn_thread\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753530.748885693,5140942.424736397]}}]}");

});

parcelRegister("3cCOO", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"main_level_amenities\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"properties\":{\"type\":\"restroom\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753519.314022817,5140975.504749831]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753523.618715234,5141019.97026769]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753507.97188618,5141031.658923046]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753463.556859698,5141032.314011931]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753454.580249833,5140965.157691745]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753513.731493384,5140963.912402408]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"elevator\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753521.183278782,5140952.631874231]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"elevator\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753446.954169054,5140953.873326148]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"store\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753437.78256169,5140913.12310745]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"atm\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753485.743257666,5140885.145879988]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753489.154335998,5140900.914789766]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753521.35559553,5140907.215455098]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753603.682074636,5141018.4767636815]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_up\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753364.858743615,5140910.2812014595]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"restaurant\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753456.480729613,5141016.167854316]}}]}");

});

parcelRegister("fU9Pp", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"main_level_flows\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"id\":\"birds\",\"properties\":{},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753513.527798124,5141015.752363338],[-9753597.683908846,5141014.163532016]]]}},{\"type\":\"Feature\",\"id\":\"animals\",\"properties\":{},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753512.605190456,5140908.696684377],[-9753595.443199012,5140907.166365803]]]}},{\"type\":\"Feature\",\"id\":\"africa\",\"properties\":{},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753522.492185583,5140963.637608036],[-9753590.270998942,5140962.385484382],[-9753589.946512932,5140944.8207042115],[-9753522.380848315,5140946.068890223]]]}},{\"type\":\"Feature\",\"id\":\"americas\",\"properties\":{},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753441.024704574,5140930.230001994],[-9753357.047235476,5140931.798873299],[-9753356.580225041,5140906.483729275],[-9753346.211058,5140906.675018299],[-9753348.278336572,5141018.735587054],[-9753429.200153632,5141017.24275206],[-9753428.877633499,5140996.467543021],[-9753456.915628737,5140995.950301788]]]}},{\"type\":\"Feature\",\"id\":\"hall_7\",\"properties\":{\"id\":\"hall_7\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753455.138466632,5140947.720013722],[-9753398.643823106,5140949.00079149],[-9753398.70731005,5140961.763202369],[-9753440.210215932,5140961.173639909]]]}},{\"type\":\"Feature\",\"id\":\"nature_walk\",\"properties\":{},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753513.479440464,5140999.179808604],[-9753602.656095784,5140997.528423689]]]}},{\"type\":\"Feature\",\"id\":\"mammals\",\"properties\":{},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753615.307627132,5140909.67892379],[-9753616.61971829,5140980.533332031],[-9753529.368393824,5140982.14906342]]]}},{\"type\":\"Feature\",\"id\":\"mammals\",\"properties\":{},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753617.383617105,5141021.784732976],[-9753616.700627785,5140984.902536322]]]}},{\"type\":\"Feature\",\"id\":\"animals\",\"properties\":{},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753608.016991979,5140921.309949971],[-9753544.228961019,5140922.491185035],[-9753544.436671322,5140933.70777657],[-9753607.35362318,5140932.542672259]]]}},{\"type\":\"Feature\",\"id\":\"hall_5\",\"properties\":{},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753456.406666253,5140982.372656139],[-9753391.862374734,5140983.563360703],[-9753391.529350076,5140970.725886919],[-9753440.770093296,5140970.11638344]]]}}]}");

});

parcelRegister("fs4wn", function(module, exports) {
module.exports = JSON.parse('{"type":"FeatureCollection","name":"main_level_pictograms","crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:EPSG::3857"}},"features":[{"type":"Feature","properties":{"id":"bird"},"geometry":{"type":"Point","coordinates":[-9753567.089020148,5141026.714857465]},"id":"bird"},{"type":"Feature","id":"maximo","properties":{"id":"maximo","label":"M\xe1ximo\\nthe\\nTitanosaur"},"geometry":{"type":"Point","coordinates":[-9753489.238221748,5140999.8948999485]}},{"type":"Feature","properties":{"id":"elephant"},"geometry":{"type":"Point","coordinates":[-9753475.010555338,5140976.963249381]},"id":"elephant"},{"type":"Feature","properties":{"id":"totems"},"geometry":{"type":"Point","coordinates":[-9753475.68009258,5140945.494998966]},"id":"totems"},{"type":"Feature","properties":{"id":"mask"},"geometry":{"type":"Point","coordinates":[-9753428.877633499,5140996.467543021]},"id":"mask"},{"type":"Feature","properties":{"id":"pawnee_lodge","label":"Pawnee\\nLodge"},"geometry":{"type":"Point","coordinates":[-9753383.931545118,5140948.93249759]},"id":"pawnee_lodge"},{"type":"Feature","properties":{"id":"lion","label":"Tsavo\\nLions"},"geometry":{"type":"Point","coordinates":[-9753626.20118901,5140971.974732949]},"id":"lion"},{"type":"Feature","properties":{"id":"south_entrance"},"geometry":{"type":"Point","coordinates":[-9753482.198635027,5140869.655059936]},"id":"south_entrance"},{"type":"Feature","properties":{"id":"north_entrance"},"geometry":{"type":"Point","coordinates":[-9753485.796646956,5141058.293685325]},"id":"north_entrance"}]}');

});

parcelRegister("eQkfl", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"main_level_outline\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753508.502986735,5141046.15815577],[-9753508.605609586,5141054.202960782],[-9753500.729767283,5141054.2572769355],[-9753500.729767289,5141051.432836938],[-9753499.059230281,5141049.062493043],[-9753472.664776819,5141049.527593544],[-9753470.92087116,5141051.992602007],[-9753470.949682958,5141054.892989617],[-9753463.141685853,5141055.017840738],[-9753462.978697754,5141047.013395063],[-9753448.410219844,5141047.258072832],[-9753447.97974051,5141028.996686283],[-9753363.97362249,5141030.378862222],[-9753364.081583722,5141034.230408727],[-9753343.803741354,5141034.615574449],[-9753341.31149256,5140899.4110779315],[-9753361.521364525,5140899.071225817],[-9753361.622032342,5140903.625476609],[-9753445.578118956,5140902.073252767],[-9753445.283580465,5140883.290759662],[-9753459.914564807,5140883.087891281],[-9753459.755224423,5140875.217314926],[-9753467.119796323,5140875.068218638],[-9753467.279136706,5140882.938794993],[-9753498.128583644,5140882.31424572],[-9753497.967515612,5140874.439387311],[-9753505.392923152,5140874.2890594015],[-9753505.541887531,5140882.16416285],[-9753520.005730372,5140881.840724009],[-9753520.436209707,5140900.713844343],[-9753604.649909299,5140899.149926858],[-9753604.515620952,5140894.47189398],[-9753624.759478115,5140894.120713461],[-9753627.263055293,5141029.316713676],[-9753607.058847541,5141029.665062087],[-9753607.063939754,5141025.976314691],[-9753522.679233605,5141027.535322215],[-9753522.9851005,5141045.864679184],[-9753508.502986735,5141046.15815577]]]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753495.645196902,5141054.437593392],[-9753495.618913233,5141054.437364018],[-9753495.592637572,5141054.436675966],[-9753495.56637792,5141054.435529444],[-9753495.540142277,5141054.4339248035],[-9753495.513938636,5141054.431862532],[-9753495.487774976,5141054.429343259],[-9753495.461659268,5141054.426367749],[-9753495.435599469,5141054.422936912],[-9753495.409603514,5141054.419051791],[-9753495.383679323,5141054.414713569],[-9753495.357834794,5141054.409923568],[-9753495.332077798,5141054.404683248],[-9753495.30641618,5141054.398994205],[-9753495.280857759,5141054.39285817],[-9753495.255410317,5141054.386277014],[-9753495.23008161,5141054.379252743],[-9753495.204879351,5141054.371787493],[-9753495.179811217,5141054.363883541],[-9753495.154884843,5141054.355543293],[-9753495.130107824,5141054.34676929],[-9753495.105487706,5141054.337564205],[-9753495.081031987,5141054.327930842],[-9753495.05674812,5141054.317872134],[-9753495.032643499,5141054.307391147],[-9753495.00872547,5141054.2964910725],[-9753494.985001314,5141054.285175231],[-9753494.96147826,5141054.273447069],[-9753494.938163474,5141054.261310159],[-9753494.915064057,5141054.248768199],[-9753494.892187046,5141054.23582501],[-9753494.869539408,5141054.222484532],[-9753494.847128045,5141054.20875083],[-9753494.82495978,5141054.194628088],[-9753494.803041367,5141054.180120606],[-9753494.781379482,5141054.1652328065],[-9753494.759980725,5141054.149969221],[-9753494.738851614,5141054.134334501],[-9753494.717998585,5141054.118333409],[-9753494.697427988,5141054.101970817],[-9753494.677146092,5141054.085251712],[-9753494.657159071,5141054.068181185],[-9753494.637473019,5141054.050764436],[-9753494.618093928,5141054.0330067715],[-9753494.599027703,5141054.014913599],[-9753494.580280151,5141053.996490431],[-9753494.561856983,5141053.97774288],[-9753494.54376381,5141053.958676654],[-9753494.526006145,5141053.939297563],[-9753494.508589398,5141053.91961151],[-9753494.49151887,5141053.899624491],[-9753494.474799765,5141053.879342594],[-9753494.458437175,5141053.858771998],[-9753494.44243608,5141053.837918968],[-9753494.426801361,5141053.816789857],[-9753494.411537776,5141053.7953910995],[-9753494.396649975,5141053.773729215],[-9753494.382142495,5141053.751810803],[-9753494.368019752,5141053.729642538],[-9753494.35428605,5141053.707231173],[-9753494.340945574,5141053.684583536],[-9753494.328002382,5141053.661706525],[-9753494.315460423,5141053.638607108],[-9753494.303323513,5141053.615292322],[-9753494.291595351,5141053.591769269],[-9753494.28027951,5141053.568045113],[-9753494.269379435,5141053.544127082],[-9753494.258898448,5141053.520022462],[-9753494.24883974,5141053.495738595],[-9753494.239206377,5141053.471282877],[-9753494.230001291,5141053.4466627585],[-9753494.22122729,5141053.421885739],[-9753494.212887041,5141053.396959365],[-9753494.20498309,5141053.371891231],[-9753494.19751784,5141053.346688972],[-9753494.190493567,5141053.321360264],[-9753494.183912411,5141053.295912824],[-9753494.177776378,5141053.270354402],[-9753494.172087334,5141053.244692786],[-9753494.166847015,5141053.218935789],[-9753494.162057014,5141053.193091259],[-9753494.157718793,5141053.167167068],[-9753494.15383367,5141053.141171114],[-9753494.150402833,5141053.115111314],[-9753494.147427324,5141053.088995607],[-9753494.14490805,5141053.062831948],[-9753494.142845778,5141053.036628305],[-9753494.141241137,5141053.010392662],[-9753494.140094617,5141052.984133011],[-9753494.139406564,5141052.957857349],[-9753494.13917719,5141052.931573681],[-9753494.139406564,5141052.905290012],[-9753494.140094617,5141052.8790143505],[-9753494.141241137,5141052.852754699],[-9753494.142845778,5141052.826519056],[-9753494.14490805,5141052.800315414],[-9753494.147427324,5141052.774151755],[-9753494.150402833,5141052.748036047],[-9753494.15383367,5141052.721976248],[-9753494.157718793,5141052.695980293],[-9753494.162057014,5141052.670056102],[-9753494.166847015,5141052.644211573],[-9753494.172087334,5141052.618454576],[-9753494.177776378,5141052.592792959],[-9753494.183912411,5141052.567234538],[-9753494.190493567,5141052.541787097],[-9753494.19751784,5141052.516458389],[-9753494.20498309,5141052.49125613],[-9753494.212887041,5141052.466187996],[-9753494.22122729,5141052.441261622],[-9753494.230001291,5141052.416484603],[-9753494.239206377,5141052.391864484],[-9753494.24883974,5141052.367408766],[-9753494.258898448,5141052.343124899],[-9753494.269379435,5141052.319020279],[-9753494.28027951,5141052.295102248],[-9753494.291595351,5141052.2713780925],[-9753494.303323513,5141052.247855039],[-9753494.315460423,5141052.224540253],[-9753494.328002382,5141052.201440836],[-9753494.340945574,5141052.178563825],[-9753494.35428605,5141052.155916188],[-9753494.368019752,5141052.133504823],[-9753494.382142495,5141052.111336558],[-9753494.396649975,5141052.089418146],[-9753494.411537776,5141052.067756262],[-9753494.426801361,5141052.046357504],[-9753494.44243608,5141052.025228393],[-9753494.458437175,5141052.004375363],[-9753494.474799765,5141051.983804767],[-9753494.49151887,5141051.96352287],[-9753494.508589398,5141051.943535851],[-9753494.526006145,5141051.923849798],[-9753494.54376381,5141051.904470707],[-9753494.561856983,5141051.885404482],[-9753494.580280151,5141051.86665693],[-9753494.599027703,5141051.848233762],[-9753494.618093928,5141051.83014059],[-9753494.637473019,5141051.812382925],[-9753494.657159071,5141051.794966176],[-9753494.677146092,5141051.777895649],[-9753494.697427988,5141051.761176544],[-9753494.717998585,5141051.744813953],[-9753494.738851614,5141051.72881286],[-9753494.759980725,5141051.71317814],[-9753494.781379482,5141051.697914555],[-9753494.803041367,5141051.683026755],[-9753494.82495978,5141051.668519273],[-9753494.847128045,5141051.654396531],[-9753494.869539408,5141051.640662829],[-9753494.892187046,5141051.627322352],[-9753494.915064057,5141051.614379162],[-9753494.938163474,5141051.601837202],[-9753494.96147826,5141051.589700292],[-9753494.985001314,5141051.57797213],[-9753495.00872547,5141051.566656289],[-9753495.032643499,5141051.555756214],[-9753495.05674812,5141051.545275227],[-9753495.081031987,5141051.53521652],[-9753495.105487706,5141051.525583156],[-9753495.130107824,5141051.516378071],[-9753495.154884843,5141051.507604068],[-9753495.179811217,5141051.49926382],[-9753495.204879351,5141051.491359868],[-9753495.23008161,5141051.483894618],[-9753495.255410317,5141051.476870347],[-9753495.280857759,5141051.470289191],[-9753495.30641618,5141051.464153157],[-9753495.332077798,5141051.458464113],[-9753495.357834794,5141051.453223793],[-9753495.383679323,5141051.448433792],[-9753495.409603514,5141051.444095571],[-9753495.435599469,5141051.4402104495],[-9753495.461659268,5141051.436779612],[-9753495.487774976,5141051.433804102],[-9753495.513938636,5141051.431284829],[-9753495.540142277,5141051.429222558],[-9753495.56637792,5141051.427617917],[-9753495.592637572,5141051.426471395],[-9753495.618913233,5141051.425783344],[-9753495.645196902,5141051.425553969],[-9753495.67148057,5141051.425783344],[-9753495.69775623,5141051.426471395],[-9753495.724015884,5141051.427617917],[-9753495.750251526,5141051.429222558],[-9753495.776455168,5141051.431284829],[-9753495.802618828,5141051.433804102],[-9753495.828734536,5141051.436779612],[-9753495.854794335,5141051.4402104495],[-9753495.88079029,5141051.444095571],[-9753495.90671448,5141051.448433792],[-9753495.93255901,5141051.453223793],[-9753495.958316006,5141051.458464113],[-9753495.983977623,5141051.464153157],[-9753496.009536045,5141051.470289191],[-9753496.034983486,5141051.476870347],[-9753496.060312193,5141051.483894618],[-9753496.085514452,5141051.491359868],[-9753496.110582586,5141051.49926382],[-9753496.13550896,5141051.507604068],[-9753496.16028598,5141051.516378071],[-9753496.184906097,5141051.525583156],[-9753496.209361816,5141051.53521652],[-9753496.233645683,5141051.545275227],[-9753496.257750304,5141051.555756214],[-9753496.281668333,5141051.566656289],[-9753496.305392489,5141051.57797213],[-9753496.328915544,5141051.589700292],[-9753496.352230329,5141051.601837202],[-9753496.375329746,5141051.614379162],[-9753496.398206757,5141051.627322352],[-9753496.420854395,5141051.640662829],[-9753496.443265758,5141051.654396531],[-9753496.465434024,5141051.668519273],[-9753496.487352436,5141051.683026755],[-9753496.509014321,5141051.697914555],[-9753496.530413078,5141051.71317814],[-9753496.551542189,5141051.72881286],[-9753496.572395219,5141051.744813953],[-9753496.592965815,5141051.761176544],[-9753496.613247711,5141051.777895649],[-9753496.633234732,5141051.794966176],[-9753496.652920784,5141051.812382925],[-9753496.672299875,5141051.83014059],[-9753496.6913661,5141051.848233762],[-9753496.710113652,5141051.86665693],[-9753496.72853682,5141051.885404482],[-9753496.746629992,5141051.904470707],[-9753496.764387658,5141051.923849798],[-9753496.781804405,5141051.943535851],[-9753496.798874933,5141051.96352287],[-9753496.815594038,5141051.983804767],[-9753496.831956629,5141052.004375363],[-9753496.847957723,5141052.025228393],[-9753496.863592442,5141052.046357504],[-9753496.878856027,5141052.067756262],[-9753496.893743828,5141052.089418146],[-9753496.908251308,5141052.111336558],[-9753496.922374051,5141052.133504823],[-9753496.936107753,5141052.155916188],[-9753496.94944823,5141052.178563825],[-9753496.962391421,5141052.201440836],[-9753496.97493338,5141052.224540253],[-9753496.98707029,5141052.247855039],[-9753496.998798452,5141052.2713780925],[-9753497.010114294,5141052.295102248],[-9753497.021014368,5141052.319020279],[-9753497.031495355,5141052.343124899],[-9753497.041554064,5141052.367408766],[-9753497.051187426,5141052.391864484],[-9753497.060392512,5141052.416484603],[-9753497.069166513,5141052.441261622],[-9753497.077506762,5141052.466187996],[-9753497.085410714,5141052.49125613],[-9753497.092875963,5141052.516458389],[-9753497.099900236,5141052.541787097],[-9753497.106481392,5141052.567234538],[-9753497.112617426,5141052.592792959],[-9753497.11830647,5141052.618454576],[-9753497.123546788,5141052.644211573],[-9753497.12833679,5141052.670056102],[-9753497.13267501,5141052.695980293],[-9753497.136560133,5141052.721976248],[-9753497.13999097,5141052.748036047],[-9753497.142966479,5141052.774151755],[-9753497.145485753,5141052.800315414],[-9753497.147548025,5141052.826519056],[-9753497.149152666,5141052.852754699],[-9753497.150299186,5141052.8790143505],[-9753497.15098724,5141052.905290012],[-9753497.151216613,5141052.931573681],[-9753497.15098724,5141052.957857349],[-9753497.150299186,5141052.984133011],[-9753497.149152666,5141053.010392662],[-9753497.147548025,5141053.036628305],[-9753497.145485753,5141053.062831948],[-9753497.142966479,5141053.088995607],[-9753497.13999097,5141053.115111314],[-9753497.136560133,5141053.141171114],[-9753497.13267501,5141053.167167068],[-9753497.12833679,5141053.193091259],[-9753497.123546788,5141053.218935789],[-9753497.11830647,5141053.244692786],[-9753497.112617426,5141053.270354402],[-9753497.106481392,5141053.295912824],[-9753497.099900236,5141053.321360264],[-9753497.092875963,5141053.346688972],[-9753497.085410714,5141053.371891231],[-9753497.077506762,5141053.396959365],[-9753497.069166513,5141053.421885739],[-9753497.060392512,5141053.4466627585],[-9753497.051187426,5141053.471282877],[-9753497.041554064,5141053.495738595],[-9753497.031495355,5141053.520022462],[-9753497.021014368,5141053.544127082],[-9753497.010114294,5141053.568045113],[-9753496.998798452,5141053.591769269],[-9753496.98707029,5141053.615292322],[-9753496.97493338,5141053.638607108],[-9753496.962391421,5141053.661706525],[-9753496.94944823,5141053.684583536],[-9753496.936107753,5141053.707231173],[-9753496.922374051,5141053.729642538],[-9753496.908251308,5141053.751810803],[-9753496.893743828,5141053.773729215],[-9753496.878856027,5141053.7953910995],[-9753496.863592442,5141053.816789857],[-9753496.847957723,5141053.837918968],[-9753496.831956629,5141053.858771998],[-9753496.815594038,5141053.879342594],[-9753496.798874933,5141053.899624491],[-9753496.781804405,5141053.91961151],[-9753496.764387658,5141053.939297563],[-9753496.746629992,5141053.958676654],[-9753496.72853682,5141053.97774288],[-9753496.710113652,5141053.996490431],[-9753496.6913661,5141054.014913599],[-9753496.672299875,5141054.0330067715],[-9753496.652920784,5141054.050764436],[-9753496.633234732,5141054.068181185],[-9753496.613247711,5141054.085251712],[-9753496.592965815,5141054.101970817],[-9753496.572395219,5141054.118333409],[-9753496.551542189,5141054.134334501],[-9753496.530413078,5141054.149969221],[-9753496.509014321,5141054.1652328065],[-9753496.487352436,5141054.180120606],[-9753496.465434024,5141054.194628088],[-9753496.443265758,5141054.20875083],[-9753496.420854395,5141054.222484532],[-9753496.398206757,5141054.23582501],[-9753496.375329746,5141054.248768199],[-9753496.352230329,5141054.261310159],[-9753496.328915544,5141054.273447069],[-9753496.305392489,5141054.285175231],[-9753496.281668333,5141054.2964910725],[-9753496.257750304,5141054.307391147],[-9753496.233645683,5141054.317872134],[-9753496.209361816,5141054.327930842],[-9753496.184906097,5141054.337564205],[-9753496.16028598,5141054.34676929],[-9753496.13550896,5141054.355543293],[-9753496.110582586,5141054.363883541],[-9753496.085514452,5141054.371787493],[-9753496.060312193,5141054.379252743],[-9753496.034983486,5141054.386277014],[-9753496.009536045,5141054.39285817],[-9753495.983977623,5141054.398994205],[-9753495.958316006,5141054.404683248],[-9753495.93255901,5141054.409923568],[-9753495.90671448,5141054.414713569],[-9753495.88079029,5141054.419051791],[-9753495.854794335,5141054.422936912],[-9753495.828734536,5141054.426367749],[-9753495.802618828,5141054.429343259],[-9753495.776455168,5141054.431862532],[-9753495.750251526,5141054.4339248035],[-9753495.724015884,5141054.435529444],[-9753495.69775623,5141054.436675966],[-9753495.67148057,5141054.437364018],[-9753495.645196902,5141054.437593392]]]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753489.185232624,5141054.557765712],[-9753489.158948956,5141054.5575363375],[-9753489.132673295,5141054.556848286],[-9753489.106413642,5141054.555701764],[-9753489.080178,5141054.554097123],[-9753489.053974358,5141054.552034852],[-9753489.027810698,5141054.549515579],[-9753489.00169499,5141054.546540069],[-9753488.975635191,5141054.543109232],[-9753488.949639237,5141054.539224111],[-9753488.923715046,5141054.534885889],[-9753488.897870516,5141054.530095888],[-9753488.87211352,5141054.524855568],[-9753488.846451903,5141054.5191665245],[-9753488.820893481,5141054.51303049],[-9753488.79544604,5141054.506449334],[-9753488.770117333,5141054.499425063],[-9753488.744915074,5141054.491959813],[-9753488.71984694,5141054.484055861],[-9753488.694920566,5141054.475715613],[-9753488.670143547,5141054.46694161],[-9753488.645523429,5141054.457736525],[-9753488.62106771,5141054.4481031615],[-9753488.596783843,5141054.438044454],[-9753488.572679222,5141054.427563467],[-9753488.548761193,5141054.416663392],[-9753488.525037037,5141054.405347551],[-9753488.501513982,5141054.393619389],[-9753488.478199197,5141054.381482479],[-9753488.45509978,5141054.368940519],[-9753488.432222769,5141054.35599733],[-9753488.40957513,5141054.342656852],[-9753488.387163768,5141054.32892315],[-9753488.364995502,5141054.314800408],[-9753488.34307709,5141054.300292926],[-9753488.321415205,5141054.285405126],[-9753488.300016448,5141054.270141541],[-9753488.278887337,5141054.254506821],[-9753488.258034308,5141054.238505729],[-9753488.23746371,5141054.222143137],[-9753488.217181815,5141054.205424032],[-9753488.197194794,5141054.188353505],[-9753488.177508742,5141054.170936756],[-9753488.158129651,5141054.153179091],[-9753488.139063425,5141054.135085919],[-9753488.120315874,5141054.116662751],[-9753488.101892706,5141054.0979152],[-9753488.083799534,5141054.078848974],[-9753488.066041868,5141054.059469883],[-9753488.04862512,5141054.03978383],[-9753488.031554593,5141054.019796811],[-9753488.014835488,5141053.999514914],[-9753487.998472897,5141053.978944318],[-9753487.982471803,5141053.958091288],[-9753487.966837084,5141053.936962177],[-9753487.951573499,5141053.915563419],[-9753487.936685698,5141053.893901535],[-9753487.922178218,5141053.871983123],[-9753487.908055475,5141053.849814858],[-9753487.894321773,5141053.827403493],[-9753487.880981296,5141053.804755856],[-9753487.868038105,5141053.781878845],[-9753487.855496146,5141053.758779428],[-9753487.843359236,5141053.735464642],[-9753487.831631074,5141053.711941589],[-9753487.820315233,5141053.688217433],[-9753487.809415158,5141053.664299402],[-9753487.798934171,5141053.640194782],[-9753487.788875462,5141053.615910915],[-9753487.7792421,5141053.591455197],[-9753487.770037014,5141053.566835078],[-9753487.761263013,5141053.542058059],[-9753487.752922764,5141053.517131685],[-9753487.745018812,5141053.492063551],[-9753487.737553563,5141053.466861292],[-9753487.73052929,5141053.441532584],[-9753487.723948134,5141053.416085144],[-9753487.7178121,5141053.390526722],[-9753487.712123057,5141053.364865106],[-9753487.706882738,5141053.339108109],[-9753487.702092737,5141053.313263579],[-9753487.697754515,5141053.287339388],[-9753487.693869393,5141053.2613434335],[-9753487.690438556,5141053.235283634],[-9753487.687463047,5141053.209167927],[-9753487.684943773,5141053.1830042675],[-9753487.6828815,5141053.156800625],[-9753487.68127686,5141053.130564982],[-9753487.68013034,5141053.104305331],[-9753487.679442286,5141053.078029669],[-9753487.679212913,5141053.051746001],[-9753487.679442286,5141053.025462332],[-9753487.68013034,5141052.99918667],[-9753487.68127686,5141052.972927019],[-9753487.6828815,5141052.946691376],[-9753487.684943773,5141052.920487734],[-9753487.687463047,5141052.8943240745],[-9753487.690438556,5141052.868208367],[-9753487.693869393,5141052.842148568],[-9753487.697754515,5141052.816152613],[-9753487.702092737,5141052.790228422],[-9753487.706882738,5141052.7643838925],[-9753487.712123057,5141052.7386268955],[-9753487.7178121,5141052.712965279],[-9753487.723948134,5141052.6874068575],[-9753487.73052929,5141052.661959417],[-9753487.737553563,5141052.636630709],[-9753487.745018812,5141052.61142845],[-9753487.752922764,5141052.586360316],[-9753487.761263013,5141052.561433942],[-9753487.770037014,5141052.536656923],[-9753487.7792421,5141052.512036804],[-9753487.788875462,5141052.487581086],[-9753487.798934171,5141052.463297219],[-9753487.809415158,5141052.439192599],[-9753487.820315233,5141052.415274568],[-9753487.831631074,5141052.391550412],[-9753487.843359236,5141052.368027359],[-9753487.855496146,5141052.344712573],[-9753487.868038105,5141052.321613156],[-9753487.880981296,5141052.298736145],[-9753487.894321773,5141052.276088508],[-9753487.908055475,5141052.253677143],[-9753487.922178218,5141052.231508878],[-9753487.936685698,5141052.209590466],[-9753487.951573499,5141052.187928582],[-9753487.966837084,5141052.166529824],[-9753487.982471803,5141052.145400713],[-9753487.998472897,5141052.124547683],[-9753488.014835488,5141052.103977087],[-9753488.031554593,5141052.08369519],[-9753488.04862512,5141052.063708171],[-9753488.066041868,5141052.044022118],[-9753488.083799534,5141052.024643027],[-9753488.101892706,5141052.0055768015],[-9753488.120315874,5141051.98682925],[-9753488.139063425,5141051.968406082],[-9753488.158129651,5141051.95031291],[-9753488.177508742,5141051.932555245],[-9753488.197194794,5141051.915138496],[-9753488.217181815,5141051.898067969],[-9753488.23746371,5141051.881348864],[-9753488.258034308,5141051.8649862725],[-9753488.278887337,5141051.84898518],[-9753488.300016448,5141051.83335046],[-9753488.321415205,5141051.818086875],[-9753488.34307709,5141051.803199075],[-9753488.364995502,5141051.788691593],[-9753488.387163768,5141051.774568851],[-9753488.40957513,5141051.760835149],[-9753488.432222769,5141051.7474946715],[-9753488.45509978,5141051.734551482],[-9753488.478199197,5141051.722009522],[-9753488.501513982,5141051.709872612],[-9753488.525037037,5141051.69814445],[-9753488.548761193,5141051.686828609],[-9753488.572679222,5141051.675928534],[-9753488.596783843,5141051.665447547],[-9753488.62106771,5141051.65538884],[-9753488.645523429,5141051.645755476],[-9753488.670143547,5141051.636550391],[-9753488.694920566,5141051.627776388],[-9753488.71984694,5141051.61943614],[-9753488.744915074,5141051.611532188],[-9753488.770117333,5141051.604066938],[-9753488.79544604,5141051.597042667],[-9753488.820893481,5141051.590461511],[-9753488.846451903,5141051.584325477],[-9753488.87211352,5141051.578636433],[-9753488.897870516,5141051.573396113],[-9753488.923715046,5141051.568606112],[-9753488.949639237,5141051.5642678905],[-9753488.975635191,5141051.560382769],[-9753489.00169499,5141051.556951932],[-9753489.027810698,5141051.553976422],[-9753489.053974358,5141051.551457149],[-9753489.080178,5141051.549394878],[-9753489.106413642,5141051.547790237],[-9753489.132673295,5141051.546643715],[-9753489.158948956,5141051.545955664],[-9753489.185232624,5141051.545726289],[-9753489.211516293,5141051.545955664],[-9753489.237791954,5141051.546643715],[-9753489.264051607,5141051.547790237],[-9753489.290287249,5141051.549394878],[-9753489.31649089,5141051.551457149],[-9753489.34265455,5141051.553976422],[-9753489.368770259,5141051.556951932],[-9753489.394830057,5141051.560382769],[-9753489.420826012,5141051.5642678905],[-9753489.446750203,5141051.568606112],[-9753489.472594732,5141051.573396113],[-9753489.498351729,5141051.578636433],[-9753489.524013346,5141051.584325477],[-9753489.549571767,5141051.590461511],[-9753489.575019209,5141051.597042667],[-9753489.600347916,5141051.604066938],[-9753489.625550175,5141051.611532188],[-9753489.65061831,5141051.61943614],[-9753489.675544683,5141051.627776388],[-9753489.700321702,5141051.636550391],[-9753489.72494182,5141051.645755476],[-9753489.749397539,5141051.65538884],[-9753489.773681406,5141051.665447547],[-9753489.797786027,5141051.675928534],[-9753489.821704056,5141051.686828609],[-9753489.845428212,5141051.69814445],[-9753489.868951267,5141051.709872612],[-9753489.892266052,5141051.722009522],[-9753489.915365469,5141051.734551482],[-9753489.93824248,5141051.7474946715],[-9753489.960890118,5141051.760835149],[-9753489.983301481,5141051.774568851],[-9753490.005469747,5141051.788691593],[-9753490.02738816,5141051.803199075],[-9753490.049050044,5141051.818086875],[-9753490.0704488,5141051.83335046],[-9753490.091577912,5141051.84898518],[-9753490.112430941,5141051.8649862725],[-9753490.133001538,5141051.881348864],[-9753490.153283434,5141051.898067969],[-9753490.173270455,5141051.915138496],[-9753490.192956507,5141051.932555245],[-9753490.212335598,5141051.95031291],[-9753490.231401823,5141051.968406082],[-9753490.250149375,5141051.98682925],[-9753490.268572543,5141052.0055768015],[-9753490.286665715,5141052.024643027],[-9753490.30442338,5141052.044022118],[-9753490.321840128,5141052.063708171],[-9753490.338910656,5141052.08369519],[-9753490.35562976,5141052.103977087],[-9753490.371992351,5141052.124547683],[-9753490.387993446,5141052.145400713],[-9753490.403628165,5141052.166529824],[-9753490.41889175,5141052.187928582],[-9753490.43377955,5141052.209590466],[-9753490.44828703,5141052.231508878],[-9753490.462409774,5141052.253677143],[-9753490.476143476,5141052.276088508],[-9753490.489483953,5141052.298736145],[-9753490.502427144,5141052.321613156],[-9753490.514969103,5141052.344712573],[-9753490.527106013,5141052.368027359],[-9753490.538834175,5141052.391550412],[-9753490.550150016,5141052.415274568],[-9753490.561050091,5141052.439192599],[-9753490.571531078,5141052.463297219],[-9753490.581589786,5141052.487581086],[-9753490.591223149,5141052.512036804],[-9753490.600428235,5141052.536656923],[-9753490.609202236,5141052.561433942],[-9753490.617542485,5141052.586360316],[-9753490.625446437,5141052.61142845],[-9753490.632911686,5141052.636630709],[-9753490.63993596,5141052.661959417],[-9753490.646517115,5141052.6874068575],[-9753490.652653148,5141052.712965279],[-9753490.658342192,5141052.7386268955],[-9753490.663582511,5141052.7643838925],[-9753490.668372512,5141052.790228422],[-9753490.672710733,5141052.816152613],[-9753490.676595856,5141052.842148568],[-9753490.680026693,5141052.868208367],[-9753490.683002202,5141052.8943240745],[-9753490.685521476,5141052.920487734],[-9753490.687583748,5141052.946691376],[-9753490.68918839,5141052.972927019],[-9753490.690334909,5141052.99918667],[-9753490.691022962,5141053.025462332],[-9753490.691252336,5141053.051746001],[-9753490.691022962,5141053.078029669],[-9753490.690334909,5141053.104305331],[-9753490.68918839,5141053.130564982],[-9753490.687583748,5141053.156800625],[-9753490.685521476,5141053.1830042675],[-9753490.683002202,5141053.209167927],[-9753490.680026693,5141053.235283634],[-9753490.676595856,5141053.2613434335],[-9753490.672710733,5141053.287339388],[-9753490.668372512,5141053.313263579],[-9753490.663582511,5141053.339108109],[-9753490.658342192,5141053.364865106],[-9753490.652653148,5141053.390526722],[-9753490.646517115,5141053.416085144],[-9753490.63993596,5141053.441532584],[-9753490.632911686,5141053.466861292],[-9753490.625446437,5141053.492063551],[-9753490.617542485,5141053.517131685],[-9753490.609202236,5141053.542058059],[-9753490.600428235,5141053.566835078],[-9753490.591223149,5141053.591455197],[-9753490.581589786,5141053.615910915],[-9753490.571531078,5141053.640194782],[-9753490.561050091,5141053.664299402],[-9753490.550150016,5141053.688217433],[-9753490.538834175,5141053.711941589],[-9753490.527106013,5141053.735464642],[-9753490.514969103,5141053.758779428],[-9753490.502427144,5141053.781878845],[-9753490.489483953,5141053.804755856],[-9753490.476143476,5141053.827403493],[-9753490.462409774,5141053.849814858],[-9753490.44828703,5141053.871983123],[-9753490.43377955,5141053.893901535],[-9753490.41889175,5141053.915563419],[-9753490.403628165,5141053.936962177],[-9753490.387993446,5141053.958091288],[-9753490.371992351,5141053.978944318],[-9753490.35562976,5141053.999514914],[-9753490.338910656,5141054.019796811],[-9753490.321840128,5141054.03978383],[-9753490.30442338,5141054.059469883],[-9753490.286665715,5141054.078848974],[-9753490.268572543,5141054.0979152],[-9753490.250149375,5141054.116662751],[-9753490.231401823,5141054.135085919],[-9753490.212335598,5141054.153179091],[-9753490.192956507,5141054.170936756],[-9753490.173270455,5141054.188353505],[-9753490.153283434,5141054.205424032],[-9753490.133001538,5141054.222143137],[-9753490.112430941,5141054.238505729],[-9753490.091577912,5141054.254506821],[-9753490.0704488,5141054.270141541],[-9753490.049050044,5141054.285405126],[-9753490.02738816,5141054.300292926],[-9753490.005469747,5141054.314800408],[-9753489.983301481,5141054.32892315],[-9753489.960890118,5141054.342656852],[-9753489.93824248,5141054.35599733],[-9753489.915365469,5141054.368940519],[-9753489.892266052,5141054.381482479],[-9753489.868951267,5141054.393619389],[-9753489.845428212,5141054.405347551],[-9753489.821704056,5141054.416663392],[-9753489.797786027,5141054.427563467],[-9753489.773681406,5141054.438044454],[-9753489.749397539,5141054.4481031615],[-9753489.72494182,5141054.457736525],[-9753489.700321702,5141054.46694161],[-9753489.675544683,5141054.475715613],[-9753489.65061831,5141054.484055861],[-9753489.625550175,5141054.491959813],[-9753489.600347916,5141054.499425063],[-9753489.575019209,5141054.506449334],[-9753489.549571767,5141054.51303049],[-9753489.524013346,5141054.5191665245],[-9753489.498351729,5141054.524855568],[-9753489.472594732,5141054.530095888],[-9753489.446750203,5141054.534885889],[-9753489.420826012,5141054.539224111],[-9753489.394830057,5141054.543109232],[-9753489.368770259,5141054.546540069],[-9753489.34265455,5141054.549515579],[-9753489.31649089,5141054.552034852],[-9753489.290287249,5141054.554097123],[-9753489.264051607,5141054.555701764],[-9753489.237791954,5141054.556848286],[-9753489.211516293,5141054.5575363375],[-9753489.185232624,5141054.557765712]]]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753482.474889262,5141054.692873296],[-9753482.448605593,5141054.692643922],[-9753482.422329932,5141054.69195587],[-9753482.39607028,5141054.690809349],[-9753482.369834637,5141054.689204708],[-9753482.343630996,5141054.687142436],[-9753482.317467336,5141054.684623163],[-9753482.291351628,5141054.681647654],[-9753482.265291829,5141054.678216816],[-9753482.239295874,5141054.674331695],[-9753482.213371683,5141054.669993473],[-9753482.187527154,5141054.665203473],[-9753482.161770158,5141054.659963152],[-9753482.13610854,5141054.654274109],[-9753482.110550119,5141054.648138074],[-9753482.085102677,5141054.641556919],[-9753482.05977397,5141054.634532647],[-9753482.034571711,5141054.627067397],[-9753482.009503577,5141054.619163445],[-9753481.984577203,5141054.610823197],[-9753481.959800184,5141054.602049194],[-9753481.935180066,5141054.592844109],[-9753481.910724347,5141054.583210746],[-9753481.88644048,5141054.573152038],[-9753481.862335859,5141054.562671051],[-9753481.83841783,5141054.551770977],[-9753481.814693674,5141054.5404551355],[-9753481.79117062,5141054.528726974],[-9753481.767855834,5141054.516590063],[-9753481.744756417,5141054.5040481035],[-9753481.721879406,5141054.491104914],[-9753481.699231768,5141054.477764436],[-9753481.676820405,5141054.464030734],[-9753481.65465214,5141054.449907992],[-9753481.632733727,5141054.43540051],[-9753481.611071842,5141054.420512711],[-9753481.589673085,5141054.405249125],[-9753481.568543974,5141054.389614405],[-9753481.547690945,5141054.373613313],[-9753481.527120348,5141054.357250721],[-9753481.506838452,5141054.3405316165],[-9753481.486851431,5141054.323461089],[-9753481.467165379,5141054.30604434],[-9753481.447786288,5141054.288286676],[-9753481.428720063,5141054.270193503],[-9753481.409972511,5141054.251770335],[-9753481.391549343,5141054.233022784],[-9753481.37345617,5141054.213956558],[-9753481.355698505,5141054.194577468],[-9753481.338281758,5141054.174891414],[-9753481.32121123,5141054.154904395],[-9753481.304492125,5141054.134622498],[-9753481.288129535,5141054.114051903],[-9753481.27212844,5141054.093198872],[-9753481.256493721,5141054.072069761],[-9753481.241230136,5141054.050671004],[-9753481.226342335,5141054.02900912],[-9753481.211834855,5141054.007090707],[-9753481.197712112,5141053.984922443],[-9753481.18397841,5141053.9625110775],[-9753481.170637934,5141053.939863441],[-9753481.157694742,5141053.916986429],[-9753481.145152783,5141053.893887012],[-9753481.133015873,5141053.870572226],[-9753481.121287711,5141053.847049173],[-9753481.10997187,5141053.8233250175],[-9753481.099071795,5141053.799406987],[-9753481.088590808,5141053.775302366],[-9753481.0785321,5141053.751018499],[-9753481.068898737,5141053.726562781],[-9753481.059693651,5141053.701942663],[-9753481.05091965,5141053.677165643],[-9753481.042579401,5141053.65223927],[-9753481.03467545,5141053.6271711355],[-9753481.0272102,5141053.601968876],[-9753481.020185927,5141053.576640168],[-9753481.013604771,5141053.551192728],[-9753481.007468738,5141053.5256343065],[-9753481.001779694,5141053.49997269],[-9753480.996539375,5141053.474215693],[-9753480.991749374,5141053.448371164],[-9753480.987411153,5141053.422446973],[-9753480.98352603,5141053.396451018],[-9753480.980095193,5141053.370391218],[-9753480.977119684,5141053.344275511],[-9753480.97460041,5141053.318111852],[-9753480.972538138,5141053.291908209],[-9753480.970933497,5141053.265672566],[-9753480.969786977,5141053.239412915],[-9753480.969098924,5141053.213137253],[-9753480.96886955,5141053.186853585],[-9753480.969098924,5141053.1605699165],[-9753480.969786977,5141053.134294255],[-9753480.970933497,5141053.108034603],[-9753480.972538138,5141053.08179896],[-9753480.97460041,5141053.055595318],[-9753480.977119684,5141053.029431659],[-9753480.980095193,5141053.003315952],[-9753480.98352603,5141052.977256152],[-9753480.987411153,5141052.951260197],[-9753480.991749374,5141052.925336006],[-9753480.996539375,5141052.899491477],[-9753481.001779694,5141052.87373448],[-9753481.007468738,5141052.848072863],[-9753481.013604771,5141052.822514442],[-9753481.020185927,5141052.797067001],[-9753481.0272102,5141052.771738294],[-9753481.03467545,5141052.746536034],[-9753481.042579401,5141052.7214679],[-9753481.05091965,5141052.696541526],[-9753481.059693651,5141052.671764507],[-9753481.068898737,5141052.647144388],[-9753481.0785321,5141052.622688671],[-9753481.088590808,5141052.598404803],[-9753481.099071795,5141052.574300183],[-9753481.10997187,5141052.550382152],[-9753481.121287711,5141052.526657997],[-9753481.133015873,5141052.503134944],[-9753481.145152783,5141052.479820157],[-9753481.157694742,5141052.456720741],[-9753481.170637934,5141052.433843729],[-9753481.18397841,5141052.411196092],[-9753481.197712112,5141052.388784727],[-9753481.211834855,5141052.366616462],[-9753481.226342335,5141052.34469805],[-9753481.241230136,5141052.323036166],[-9753481.256493721,5141052.301637408],[-9753481.27212844,5141052.2805082975],[-9753481.288129535,5141052.259655267],[-9753481.304492125,5141052.239084671],[-9753481.32121123,5141052.218802774],[-9753481.338281758,5141052.198815756],[-9753481.355698505,5141052.179129702],[-9753481.37345617,5141052.1597506115],[-9753481.391549343,5141052.140684386],[-9753481.409972511,5141052.121936834],[-9753481.428720063,5141052.103513666],[-9753481.447786288,5141052.085420494],[-9753481.467165379,5141052.0676628295],[-9753481.486851431,5141052.05024608],[-9753481.506838452,5141052.033175553],[-9753481.527120348,5141052.0164564485],[-9753481.547690945,5141052.000093857],[-9753481.568543974,5141051.984092765],[-9753481.589673085,5141051.968458044],[-9753481.611071842,5141051.953194459],[-9753481.632733727,5141051.938306659],[-9753481.65465214,5141051.923799178],[-9753481.676820405,5141051.909676435],[-9753481.699231768,5141051.895942734],[-9753481.721879406,5141051.882602256],[-9753481.744756417,5141051.869659066],[-9753481.767855834,5141051.857117106],[-9753481.79117062,5141051.844980196],[-9753481.814693674,5141051.833252034],[-9753481.83841783,5141051.821936193],[-9753481.862335859,5141051.811036118],[-9753481.88644048,5141051.800555131],[-9753481.910724347,5141051.790496424],[-9753481.935180066,5141051.780863061],[-9753481.959800184,5141051.771657975],[-9753481.984577203,5141051.762883972],[-9753482.009503577,5141051.7545437245],[-9753482.034571711,5141051.746639772],[-9753482.05977397,5141051.739174522],[-9753482.085102677,5141051.732150251],[-9753482.110550119,5141051.725569095],[-9753482.13610854,5141051.719433061],[-9753482.161770158,5141051.713744017],[-9753482.187527154,5141051.708503697],[-9753482.213371683,5141051.703713696],[-9753482.239295874,5141051.699375475],[-9753482.265291829,5141051.695490354],[-9753482.291351628,5141051.692059516],[-9753482.317467336,5141051.6890840065],[-9753482.343630996,5141051.686564733],[-9753482.369834637,5141051.684502462],[-9753482.39607028,5141051.682897821],[-9753482.422329932,5141051.6817513],[-9753482.448605593,5141051.681063248],[-9753482.474889262,5141051.680833873],[-9753482.50117293,5141051.681063248],[-9753482.52744859,5141051.6817513],[-9753482.553708244,5141051.682897821],[-9753482.579943886,5141051.684502462],[-9753482.606147528,5141051.686564733],[-9753482.632311188,5141051.6890840065],[-9753482.658426896,5141051.692059516],[-9753482.684486695,5141051.695490354],[-9753482.71048265,5141051.699375475],[-9753482.73640684,5141051.703713696],[-9753482.76225137,5141051.708503697],[-9753482.788008366,5141051.713744017],[-9753482.813669983,5141051.719433061],[-9753482.839228405,5141051.725569095],[-9753482.864675846,5141051.732150251],[-9753482.890004553,5141051.739174522],[-9753482.915206812,5141051.746639772],[-9753482.940274946,5141051.7545437245],[-9753482.96520132,5141051.762883972],[-9753482.98997834,5141051.771657975],[-9753483.014598457,5141051.780863061],[-9753483.039054176,5141051.790496424],[-9753483.063338043,5141051.800555131],[-9753483.087442664,5141051.811036118],[-9753483.111360693,5141051.821936193],[-9753483.135084849,5141051.833252034],[-9753483.158607904,5141051.844980196],[-9753483.18192269,5141051.857117106],[-9753483.205022106,5141051.869659066],[-9753483.227899117,5141051.882602256],[-9753483.250546755,5141051.895942734],[-9753483.272958118,5141051.909676435],[-9753483.295126384,5141051.923799178],[-9753483.317044796,5141051.938306659],[-9753483.338706682,5141051.953194459],[-9753483.360105438,5141051.968458044],[-9753483.381234549,5141051.984092765],[-9753483.402087579,5141052.000093857],[-9753483.422658175,5141052.0164564485],[-9753483.442940071,5141052.033175553],[-9753483.462927092,5141052.05024608],[-9753483.482613144,5141052.0676628295],[-9753483.501992235,5141052.085420494],[-9753483.52105846,5141052.103513666],[-9753483.539806012,5141052.121936834],[-9753483.55822918,5141052.140684386],[-9753483.576322353,5141052.1597506115],[-9753483.594080018,5141052.179129702],[-9753483.611496765,5141052.198815756],[-9753483.628567293,5141052.218802774],[-9753483.645286398,5141052.239084671],[-9753483.661648989,5141052.259655267],[-9753483.677650083,5141052.2805082975],[-9753483.693284802,5141052.301637408],[-9753483.708548388,5141052.323036166],[-9753483.723436188,5141052.34469805],[-9753483.737943668,5141052.366616462],[-9753483.752066411,5141052.388784727],[-9753483.765800113,5141052.411196092],[-9753483.77914059,5141052.433843729],[-9753483.792083781,5141052.456720741],[-9753483.80462574,5141052.479820157],[-9753483.81676265,5141052.503134944],[-9753483.828490812,5141052.526657997],[-9753483.839806654,5141052.550382152],[-9753483.850706728,5141052.574300183],[-9753483.861187715,5141052.598404803],[-9753483.871246424,5141052.622688671],[-9753483.880879786,5141052.647144388],[-9753483.890084872,5141052.671764507],[-9753483.898858873,5141052.696541526],[-9753483.907199122,5141052.7214679],[-9753483.915103074,5141052.746536034],[-9753483.922568323,5141052.771738294],[-9753483.929592596,5141052.797067001],[-9753483.936173752,5141052.822514442],[-9753483.942309786,5141052.848072863],[-9753483.94799883,5141052.87373448],[-9753483.953239148,5141052.899491477],[-9753483.95802915,5141052.925336006],[-9753483.96236737,5141052.951260197],[-9753483.966252493,5141052.977256152],[-9753483.96968333,5141053.003315952],[-9753483.97265884,5141053.029431659],[-9753483.975178113,5141053.055595318],[-9753483.977240385,5141053.08179896],[-9753483.978845026,5141053.108034603],[-9753483.979991546,5141053.134294255],[-9753483.9806796,5141053.1605699165],[-9753483.980908973,5141053.186853585],[-9753483.9806796,5141053.213137253],[-9753483.979991546,5141053.239412915],[-9753483.978845026,5141053.265672566],[-9753483.977240385,5141053.291908209],[-9753483.975178113,5141053.318111852],[-9753483.97265884,5141053.344275511],[-9753483.96968333,5141053.370391218],[-9753483.966252493,5141053.396451018],[-9753483.96236737,5141053.422446973],[-9753483.95802915,5141053.448371164],[-9753483.953239148,5141053.474215693],[-9753483.94799883,5141053.49997269],[-9753483.942309786,5141053.5256343065],[-9753483.936173752,5141053.551192728],[-9753483.929592596,5141053.576640168],[-9753483.922568323,5141053.601968876],[-9753483.915103074,5141053.6271711355],[-9753483.907199122,5141053.65223927],[-9753483.898858873,5141053.677165643],[-9753483.890084872,5141053.701942663],[-9753483.880879786,5141053.726562781],[-9753483.871246424,5141053.751018499],[-9753483.861187715,5141053.775302366],[-9753483.850706728,5141053.799406987],[-9753483.839806654,5141053.8233250175],[-9753483.828490812,5141053.847049173],[-9753483.81676265,5141053.870572226],[-9753483.80462574,5141053.893887012],[-9753483.792083781,5141053.916986429],[-9753483.77914059,5141053.939863441],[-9753483.765800113,5141053.9625110775],[-9753483.752066411,5141053.984922443],[-9753483.737943668,5141054.007090707],[-9753483.723436188,5141054.02900912],[-9753483.708548388,5141054.050671004],[-9753483.693284802,5141054.072069761],[-9753483.677650083,5141054.093198872],[-9753483.661648989,5141054.114051903],[-9753483.645286398,5141054.134622498],[-9753483.628567293,5141054.154904395],[-9753483.611496765,5141054.174891414],[-9753483.594080018,5141054.194577468],[-9753483.576322353,5141054.213956558],[-9753483.55822918,5141054.233022784],[-9753483.539806012,5141054.251770335],[-9753483.52105846,5141054.270193503],[-9753483.501992235,5141054.288286676],[-9753483.482613144,5141054.30604434],[-9753483.462927092,5141054.323461089],[-9753483.442940071,5141054.3405316165],[-9753483.422658175,5141054.357250721],[-9753483.402087579,5141054.373613313],[-9753483.381234549,5141054.389614405],[-9753483.360105438,5141054.405249125],[-9753483.338706682,5141054.420512711],[-9753483.317044796,5141054.43540051],[-9753483.295126384,5141054.449907992],[-9753483.272958118,5141054.464030734],[-9753483.250546755,5141054.477764436],[-9753483.227899117,5141054.491104914],[-9753483.205022106,5141054.5040481035],[-9753483.18192269,5141054.516590063],[-9753483.158607904,5141054.528726974],[-9753483.135084849,5141054.5404551355],[-9753483.111360693,5141054.551770977],[-9753483.087442664,5141054.562671051],[-9753483.063338043,5141054.573152038],[-9753483.039054176,5141054.583210746],[-9753483.014598457,5141054.592844109],[-9753482.98997834,5141054.602049194],[-9753482.96520132,5141054.610823197],[-9753482.940274946,5141054.619163445],[-9753482.915206812,5141054.627067397],[-9753482.890004553,5141054.634532647],[-9753482.864675846,5141054.641556919],[-9753482.839228405,5141054.648138074],[-9753482.813669983,5141054.654274109],[-9753482.788008366,5141054.659963152],[-9753482.76225137,5141054.665203473],[-9753482.73640684,5141054.669993473],[-9753482.71048265,5141054.674331695],[-9753482.684486695,5141054.678216816],[-9753482.658426896,5141054.681647654],[-9753482.632311188,5141054.684623163],[-9753482.606147528,5141054.687142436],[-9753482.579943886,5141054.689204708],[-9753482.553708244,5141054.690809349],[-9753482.52744859,5141054.69195587],[-9753482.50117293,5141054.692643922],[-9753482.474889262,5141054.692873296]]]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753476.049773023,5141054.812968927],[-9753476.023489354,5141054.812739553],[-9753475.997213693,5141054.812051501],[-9753475.97095404,5141054.81090498],[-9753475.944718398,5141054.809300339],[-9753475.918514756,5141054.8072380675],[-9753475.892351096,5141054.804718794],[-9753475.866235388,5141054.801743285],[-9753475.84017559,5141054.798312447],[-9753475.814179635,5141054.794427326],[-9753475.788255444,5141054.790089104],[-9753475.762410915,5141054.785299104],[-9753475.736653918,5141054.7800587835],[-9753475.7109923,5141054.77436974],[-9753475.68543388,5141054.768233705],[-9753475.659986438,5141054.76165255],[-9753475.634657731,5141054.754628278],[-9753475.609455472,5141054.747163028],[-9753475.584387338,5141054.739259076],[-9753475.559460964,5141054.730918828],[-9753475.534683945,5141054.722144825],[-9753475.510063827,5141054.71293974],[-9753475.485608108,5141054.703306377],[-9753475.461324241,5141054.693247669],[-9753475.43721962,5141054.6827666825],[-9753475.41330159,5141054.671866608],[-9753475.389577435,5141054.660550767],[-9753475.36605438,5141054.648822605],[-9753475.342739595,5141054.636685695],[-9753475.319640178,5141054.624143735],[-9753475.296763167,5141054.611200545],[-9753475.274115529,5141054.597860067],[-9753475.251704166,5141054.584126365],[-9753475.2295359,5141054.570003623],[-9753475.207617488,5141054.555496141],[-9753475.185955603,5141054.540608342],[-9753475.164556846,5141054.525344756],[-9753475.143427735,5141054.509710036],[-9753475.122574706,5141054.493708944],[-9753475.102004109,5141054.477346352],[-9753475.081722213,5141054.460627248],[-9753475.061735192,5141054.44355672],[-9753475.04204914,5141054.426139971],[-9753475.02267005,5141054.408382307],[-9753475.003603823,5141054.390289134],[-9753474.984856272,5141054.371865966],[-9753474.966433104,5141054.353118415],[-9753474.948339932,5141054.334052189],[-9753474.930582266,5141054.314673099],[-9753474.913165519,5141054.294987045],[-9753474.89609499,5141054.275000026],[-9753474.879375886,5141054.2547181295],[-9753474.863013295,5141054.234147534],[-9753474.847012201,5141054.213294503],[-9753474.831377482,5141054.192165392],[-9753474.816113897,5141054.170766635],[-9753474.801226096,5141054.149104751],[-9753474.786718616,5141054.127186338],[-9753474.772595873,5141054.105018074],[-9753474.758862171,5141054.082606709],[-9753474.745521694,5141054.059959072],[-9753474.732578503,5141054.03708206],[-9753474.720036544,5141054.013982643],[-9753474.707899634,5141053.990667857],[-9753474.696171472,5141053.967144804],[-9753474.68485563,5141053.943420649],[-9753474.673955556,5141053.919502618],[-9753474.66347457,5141053.895397997],[-9753474.65341586,5141053.87111413],[-9753474.643782498,5141053.846658412],[-9753474.634577412,5141053.822038294],[-9753474.625803411,5141053.797261274],[-9753474.617463162,5141053.772334901],[-9753474.60955921,5141053.747266767],[-9753474.602093961,5141053.722064507],[-9753474.595069688,5141053.696735799],[-9753474.588488532,5141053.671288359],[-9753474.582352499,5141053.645729938],[-9753474.576663455,5141053.620068321],[-9753474.571423136,5141053.594311324],[-9753474.566633135,5141053.568466795],[-9753474.562294913,5141053.542542604],[-9753474.558409791,5141053.516546649],[-9753474.554978954,5141053.490486849],[-9753474.552003445,5141053.464371142],[-9753474.549484171,5141053.438207483],[-9753474.547421899,5141053.41200384],[-9753474.545817258,5141053.3857681975],[-9753474.544670738,5141053.359508546],[-9753474.543982685,5141053.333232884],[-9753474.543753311,5141053.306949216],[-9753474.543982685,5141053.280665548],[-9753474.544670738,5141053.254389886],[-9753474.545817258,5141053.228130234],[-9753474.547421899,5141053.201894592],[-9753474.549484171,5141053.175690949],[-9753474.552003445,5141053.14952729],[-9753474.554978954,5141053.123411583],[-9753474.558409791,5141053.097351783],[-9753474.562294913,5141053.071355828],[-9753474.566633135,5141053.045431637],[-9753474.571423136,5141053.019587108],[-9753474.576663455,5141052.993830111],[-9753474.582352499,5141052.968168494],[-9753474.588488532,5141052.942610073],[-9753474.595069688,5141052.917162633],[-9753474.602093961,5141052.891833925],[-9753474.60955921,5141052.866631665],[-9753474.617463162,5141052.841563531],[-9753474.625803411,5141052.816637157],[-9753474.634577412,5141052.791860138],[-9753474.643782498,5141052.7672400195],[-9753474.65341586,5141052.742784302],[-9753474.66347457,5141052.718500434],[-9753474.673955556,5141052.694395814],[-9753474.68485563,5141052.670477783],[-9753474.696171472,5141052.646753628],[-9753474.707899634,5141052.623230575],[-9753474.720036544,5141052.5999157885],[-9753474.732578503,5141052.576816372],[-9753474.745521694,5141052.55393936],[-9753474.758862171,5141052.531291723],[-9753474.772595873,5141052.508880358],[-9753474.786718616,5141052.486712093],[-9753474.801226096,5141052.464793681],[-9753474.816113897,5141052.443131797],[-9753474.831377482,5141052.421733039],[-9753474.847012201,5141052.400603929],[-9753474.863013295,5141052.379750898],[-9753474.879375886,5141052.359180302],[-9753474.89609499,5141052.338898405],[-9753474.913165519,5141052.318911387],[-9753474.930582266,5141052.299225333],[-9753474.948339932,5141052.279846243],[-9753474.966433104,5141052.260780017],[-9753474.984856272,5141052.2420324655],[-9753475.003603823,5141052.223609298],[-9753475.02267005,5141052.205516125],[-9753475.04204914,5141052.187758461],[-9753475.061735192,5141052.1703417115],[-9753475.081722213,5141052.153271184],[-9753475.102004109,5141052.13655208],[-9753475.122574706,5141052.120189488],[-9753475.143427735,5141052.104188396],[-9753475.164556846,5141052.088553675],[-9753475.185955603,5141052.07329009],[-9753475.207617488,5141052.058402291],[-9753475.2295359,5141052.043894809],[-9753475.251704166,5141052.0297720665],[-9753475.274115529,5141052.016038365],[-9753475.296763167,5141052.002697887],[-9753475.319640178,5141051.989754697],[-9753475.342739595,5141051.977212737],[-9753475.36605438,5141051.965075827],[-9753475.389577435,5141051.953347665],[-9753475.41330159,5141051.942031824],[-9753475.43721962,5141051.931131749],[-9753475.461324241,5141051.9206507625],[-9753475.485608108,5141051.910592055],[-9753475.510063827,5141051.900958692],[-9753475.534683945,5141051.8917536065],[-9753475.559460964,5141051.8829796035],[-9753475.584387338,5141051.874639356],[-9753475.609455472,5141051.866735403],[-9753475.634657731,5141051.859270154],[-9753475.659986438,5141051.852245882],[-9753475.68543388,5141051.845664727],[-9753475.7109923,5141051.839528692],[-9753475.736653918,5141051.833839648],[-9753475.762410915,5141051.828599328],[-9753475.788255444,5141051.823809328],[-9753475.814179635,5141051.819471106],[-9753475.84017559,5141051.815585985],[-9753475.866235388,5141051.812155147],[-9753475.892351096,5141051.809179638],[-9753475.918514756,5141051.806660364],[-9753475.944718398,5141051.804598093],[-9753475.97095404,5141051.802993452],[-9753475.997213693,5141051.801846931],[-9753476.023489354,5141051.801158879],[-9753476.049773023,5141051.800929504],[-9753476.07605669,5141051.801158879],[-9753476.102332352,5141051.801846931],[-9753476.128592005,5141051.802993452],[-9753476.154827647,5141051.804598093],[-9753476.181031289,5141051.806660364],[-9753476.207194949,5141051.809179638],[-9753476.233310657,5141051.812155147],[-9753476.259370456,5141051.815585985],[-9753476.28536641,5141051.819471106],[-9753476.311290601,5141051.823809328],[-9753476.33713513,5141051.828599328],[-9753476.362892127,5141051.833839648],[-9753476.388553744,5141051.839528692],[-9753476.414112166,5141051.845664727],[-9753476.439559607,5141051.852245882],[-9753476.464888314,5141051.859270154],[-9753476.490090573,5141051.866735403],[-9753476.515158707,5141051.874639356],[-9753476.540085081,5141051.8829796035],[-9753476.5648621,5141051.8917536065],[-9753476.589482218,5141051.900958692],[-9753476.613937937,5141051.910592055],[-9753476.638221804,5141051.9206507625],[-9753476.662326425,5141051.931131749],[-9753476.686244454,5141051.942031824],[-9753476.70996861,5141051.953347665],[-9753476.733491665,5141051.965075827],[-9753476.75680645,5141051.977212737],[-9753476.779905867,5141051.989754697],[-9753476.802782878,5141052.002697887],[-9753476.825430516,5141052.016038365],[-9753476.84784188,5141052.0297720665],[-9753476.870010145,5141052.043894809],[-9753476.891928557,5141052.058402291],[-9753476.913590442,5141052.07329009],[-9753476.934989199,5141052.088553675],[-9753476.95611831,5141052.104188396],[-9753476.97697134,5141052.120189488],[-9753476.997541936,5141052.13655208],[-9753477.017823832,5141052.153271184],[-9753477.037810853,5141052.1703417115],[-9753477.057496905,5141052.187758461],[-9753477.076875996,5141052.205516125],[-9753477.095942222,5141052.223609298],[-9753477.114689773,5141052.2420324655],[-9753477.133112941,5141052.260780017],[-9753477.151206113,5141052.279846243],[-9753477.168963779,5141052.299225333],[-9753477.186380526,5141052.318911387],[-9753477.203451054,5141052.338898405],[-9753477.220170159,5141052.359180302],[-9753477.23653275,5141052.379750898],[-9753477.252533844,5141052.400603929],[-9753477.268168563,5141052.421733039],[-9753477.283432148,5141052.443131797],[-9753477.298319949,5141052.464793681],[-9753477.312827429,5141052.486712093],[-9753477.326950172,5141052.508880358],[-9753477.340683874,5141052.531291723],[-9753477.35402435,5141052.55393936],[-9753477.366967542,5141052.576816372],[-9753477.379509501,5141052.5999157885],[-9753477.391646411,5141052.623230575],[-9753477.403374573,5141052.646753628],[-9753477.414690414,5141052.670477783],[-9753477.425590489,5141052.694395814],[-9753477.436071476,5141052.718500434],[-9753477.446130184,5141052.742784302],[-9753477.455763547,5141052.7672400195],[-9753477.464968633,5141052.791860138],[-9753477.473742634,5141052.816637157],[-9753477.482082883,5141052.841563531],[-9753477.489986835,5141052.866631665],[-9753477.497452084,5141052.891833925],[-9753477.504476357,5141052.917162633],[-9753477.511057513,5141052.942610073],[-9753477.517193547,5141052.968168494],[-9753477.52288259,5141052.993830111],[-9753477.52812291,5141053.019587108],[-9753477.53291291,5141053.045431637],[-9753477.537251132,5141053.071355828],[-9753477.541136254,5141053.097351783],[-9753477.544567091,5141053.123411583],[-9753477.5475426,5141053.14952729],[-9753477.550061874,5141053.175690949],[-9753477.552124146,5141053.201894592],[-9753477.553728787,5141053.228130234],[-9753477.554875307,5141053.254389886],[-9753477.55556336,5141053.280665548],[-9753477.555792734,5141053.306949216],[-9753477.55556336,5141053.333232884],[-9753477.554875307,5141053.359508546],[-9753477.553728787,5141053.3857681975],[-9753477.552124146,5141053.41200384],[-9753477.550061874,5141053.438207483],[-9753477.5475426,5141053.464371142],[-9753477.544567091,5141053.490486849],[-9753477.541136254,5141053.516546649],[-9753477.537251132,5141053.542542604],[-9753477.53291291,5141053.568466795],[-9753477.52812291,5141053.594311324],[-9753477.52288259,5141053.620068321],[-9753477.517193547,5141053.645729938],[-9753477.511057513,5141053.671288359],[-9753477.504476357,5141053.696735799],[-9753477.497452084,5141053.722064507],[-9753477.489986835,5141053.747266767],[-9753477.482082883,5141053.772334901],[-9753477.473742634,5141053.797261274],[-9753477.464968633,5141053.822038294],[-9753477.455763547,5141053.846658412],[-9753477.446130184,5141053.87111413],[-9753477.436071476,5141053.895397997],[-9753477.425590489,5141053.919502618],[-9753477.414690414,5141053.943420649],[-9753477.403374573,5141053.967144804],[-9753477.391646411,5141053.990667857],[-9753477.379509501,5141054.013982643],[-9753477.366967542,5141054.03708206],[-9753477.35402435,5141054.059959072],[-9753477.340683874,5141054.082606709],[-9753477.326950172,5141054.105018074],[-9753477.312827429,5141054.127186338],[-9753477.298319949,5141054.149104751],[-9753477.283432148,5141054.170766635],[-9753477.268168563,5141054.192165392],[-9753477.252533844,5141054.213294503],[-9753477.23653275,5141054.234147534],[-9753477.220170159,5141054.2547181295],[-9753477.203451054,5141054.275000026],[-9753477.186380526,5141054.294987045],[-9753477.168963779,5141054.314673099],[-9753477.151206113,5141054.334052189],[-9753477.133112941,5141054.353118415],[-9753477.114689773,5141054.371865966],[-9753477.095942222,5141054.390289134],[-9753477.076875996,5141054.408382307],[-9753477.057496905,5141054.426139971],[-9753477.037810853,5141054.44355672],[-9753477.017823832,5141054.460627248],[-9753476.997541936,5141054.477346352],[-9753476.97697134,5141054.493708944],[-9753476.95611831,5141054.509710036],[-9753476.934989199,5141054.525344756],[-9753476.913590442,5141054.540608342],[-9753476.891928557,5141054.555496141],[-9753476.870010145,5141054.570003623],[-9753476.84784188,5141054.584126365],[-9753476.825430516,5141054.597860067],[-9753476.802782878,5141054.611200545],[-9753476.779905867,5141054.624143735],[-9753476.75680645,5141054.636685695],[-9753476.733491665,5141054.648822605],[-9753476.70996861,5141054.660550767],[-9753476.686244454,5141054.671866608],[-9753476.662326425,5141054.6827666825],[-9753476.638221804,5141054.693247669],[-9753476.613937937,5141054.703306377],[-9753476.589482218,5141054.71293974],[-9753476.5648621,5141054.722144825],[-9753476.540085081,5141054.730918828],[-9753476.515158707,5141054.739259076],[-9753476.490090573,5141054.747163028],[-9753476.464888314,5141054.754628278],[-9753476.439559607,5141054.76165255],[-9753476.414112166,5141054.768233705],[-9753476.388553744,5141054.77436974],[-9753476.362892127,5141054.7800587835],[-9753476.33713513,5141054.785299104],[-9753476.311290601,5141054.790089104],[-9753476.28536641,5141054.794427326],[-9753476.259370456,5141054.798312447],[-9753476.233310657,5141054.801743285],[-9753476.207194949,5141054.804718794],[-9753476.181031289,5141054.8072380675],[-9753476.154827647,5141054.809300339],[-9753476.128592005,5141054.81090498],[-9753476.102332352,5141054.812051501],[-9753476.07605669,5141054.812739553],[-9753476.049773023,5141054.812968927]]]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753492.314964885,5140877.716839688],[-9753492.288681217,5140877.716610313],[-9753492.262405556,5140877.715922262],[-9753492.236145902,5140877.71477574],[-9753492.20991026,5140877.713171099],[-9753492.183706619,5140877.711108828],[-9753492.157542959,5140877.708589555],[-9753492.13142725,5140877.705614045],[-9753492.105367452,5140877.7021832075],[-9753492.079371497,5140877.698298086],[-9753492.053447306,5140877.693959865],[-9753492.027602777,5140877.689169864],[-9753492.00184578,5140877.683929544],[-9753491.976184163,5140877.6782405],[-9753491.950625742,5140877.672104466],[-9753491.9251783,5140877.66552331],[-9753491.899849594,5140877.658499039],[-9753491.874647334,5140877.651033789],[-9753491.8495792,5140877.643129837],[-9753491.824652826,5140877.634789589],[-9753491.799875807,5140877.626015586],[-9753491.77525569,5140877.616810501],[-9753491.75079997,5140877.607177137],[-9753491.726516103,5140877.59711843],[-9753491.702411482,5140877.586637443],[-9753491.678493453,5140877.575737368],[-9753491.654769298,5140877.564421527],[-9753491.631246243,5140877.552693365],[-9753491.607931457,5140877.540556455],[-9753491.58483204,5140877.528014495],[-9753491.56195503,5140877.515071305],[-9753491.539307391,5140877.501730828],[-9753491.516896028,5140877.487997126],[-9753491.494727762,5140877.473874384],[-9753491.47280935,5140877.459366902],[-9753491.451147465,5140877.444479102],[-9753491.429748708,5140877.429215517],[-9753491.408619598,5140877.413580797],[-9753491.387766568,5140877.397579704],[-9753491.367195971,5140877.381217113],[-9753491.346914075,5140877.364498008],[-9753491.326927055,5140877.347427481],[-9753491.307241002,5140877.330010732],[-9753491.287861912,5140877.312253067],[-9753491.268795686,5140877.294159895],[-9753491.250048134,5140877.275736727],[-9753491.231624966,5140877.256989175],[-9753491.213531794,5140877.23792295],[-9753491.195774129,5140877.218543859],[-9753491.178357381,5140877.198857806],[-9753491.161286853,5140877.178870787],[-9753491.144567749,5140877.15858889],[-9753491.128205158,5140877.138018294],[-9753491.112204064,5140877.117165264],[-9753491.096569344,5140877.096036153],[-9753491.081305759,5140877.074637395],[-9753491.066417959,5140877.052975511],[-9753491.051910479,5140877.031057099],[-9753491.037787735,5140877.008888834],[-9753491.024054034,5140876.986477469],[-9753491.010713557,5140876.963829832],[-9753490.997770365,5140876.940952821],[-9753490.985228406,5140876.917853404],[-9753490.973091496,5140876.894538618],[-9753490.961363334,5140876.871015565],[-9753490.950047493,5140876.847291409],[-9753490.939147418,5140876.823373378],[-9753490.928666431,5140876.799268758],[-9753490.918607723,5140876.774984891],[-9753490.90897436,5140876.750529173],[-9753490.899769275,5140876.725909054],[-9753490.890995273,5140876.701132035],[-9753490.882655025,5140876.676205661],[-9753490.874751072,5140876.651137527],[-9753490.867285823,5140876.625935268],[-9753490.86026155,5140876.60060656],[-9753490.853680395,5140876.575159119],[-9753490.84754436,5140876.549600698],[-9753490.841855317,5140876.5239390815],[-9753490.836614998,5140876.498182084],[-9753490.831824997,5140876.472337555],[-9753490.827486776,5140876.446413364],[-9753490.823601654,5140876.420417409],[-9753490.820170816,5140876.39435761],[-9753490.817195307,5140876.368241902],[-9753490.814676033,5140876.342078243],[-9753490.812613761,5140876.315874601],[-9753490.81100912,5140876.289638958],[-9753490.8098626,5140876.2633793065],[-9753490.809174547,5140876.237103645],[-9753490.808945173,5140876.210819976],[-9753490.809174547,5140876.184536308],[-9753490.8098626,5140876.158260646],[-9753490.81100912,5140876.132000995],[-9753490.812613761,5140876.105765352],[-9753490.814676033,5140876.079561709],[-9753490.817195307,5140876.05339805],[-9753490.820170816,5140876.027282343],[-9753490.823601654,5140876.001222543],[-9753490.827486776,5140875.975226589],[-9753490.831824997,5140875.949302398],[-9753490.836614998,5140875.923457868],[-9753490.841855317,5140875.897700871],[-9753490.84754436,5140875.872039255],[-9753490.853680395,5140875.846480833],[-9753490.86026155,5140875.821033393],[-9753490.867285823,5140875.795704685],[-9753490.874751072,5140875.770502426],[-9753490.882655025,5140875.745434292],[-9753490.890995273,5140875.720507918],[-9753490.899769275,5140875.6957308985],[-9753490.90897436,5140875.67111078],[-9753490.918607723,5140875.646655062],[-9753490.928666431,5140875.622371195],[-9753490.939147418,5140875.598266575],[-9753490.950047493,5140875.574348544],[-9753490.961363334,5140875.550624388],[-9753490.973091496,5140875.527101335],[-9753490.985228406,5140875.503786549],[-9753490.997770365,5140875.480687132],[-9753491.010713557,5140875.457810121],[-9753491.024054034,5140875.435162484],[-9753491.037787735,5140875.412751119],[-9753491.051910479,5140875.390582854],[-9753491.066417959,5140875.368664442],[-9753491.081305759,5140875.3470025575],[-9753491.096569344,5140875.3256038],[-9753491.112204064,5140875.304474689],[-9753491.128205158,5140875.283621659],[-9753491.144567749,5140875.263051063],[-9753491.161286853,5140875.242769166],[-9753491.178357381,5140875.222782147],[-9753491.195774129,5140875.203096094],[-9753491.213531794,5140875.183717003],[-9753491.231624966,5140875.164650777],[-9753491.250048134,5140875.145903226],[-9753491.268795686,5140875.127480058],[-9753491.287861912,5140875.109386886],[-9753491.307241002,5140875.091629221],[-9753491.326927055,5140875.074212472],[-9753491.346914075,5140875.057141945],[-9753491.367195971,5140875.04042284],[-9753491.387766568,5140875.024060248],[-9753491.408619598,5140875.008059156],[-9753491.429748708,5140874.992424436],[-9753491.451147465,5140874.977160851],[-9753491.47280935,5140874.962273051],[-9753491.494727762,5140874.947765569],[-9753491.516896028,5140874.933642827],[-9753491.539307391,5140874.919909125],[-9753491.56195503,5140874.906568647],[-9753491.58483204,5140874.893625458],[-9753491.607931457,5140874.881083498],[-9753491.631246243,5140874.868946588],[-9753491.654769298,5140874.857218426],[-9753491.678493453,5140874.8459025845],[-9753491.702411482,5140874.83500251],[-9753491.726516103,5140874.824521523],[-9753491.75079997,5140874.814462815],[-9753491.77525569,5140874.804829452],[-9753491.799875807,5140874.795624367],[-9753491.824652826,5140874.786850364],[-9753491.8495792,5140874.778510116],[-9753491.874647334,5140874.770606164],[-9753491.899849594,5140874.763140914],[-9753491.9251783,5140874.756116643],[-9753491.950625742,5140874.749535487],[-9753491.976184163,5140874.743399452],[-9753492.00184578,5140874.737710409],[-9753492.027602777,5140874.732470089],[-9753492.053447306,5140874.727680088],[-9753492.079371497,5140874.723341866],[-9753492.105367452,5140874.719456745],[-9753492.13142725,5140874.716025908],[-9753492.157542959,5140874.713050398],[-9753492.183706619,5140874.710531125],[-9753492.20991026,5140874.7084688535],[-9753492.236145902,5140874.706864213],[-9753492.262405556,5140874.705717691],[-9753492.288681217,5140874.705029639],[-9753492.314964885,5140874.704800265],[-9753492.341248553,5140874.705029639],[-9753492.367524214,5140874.705717691],[-9753492.393783867,5140874.706864213],[-9753492.42001951,5140874.7084688535],[-9753492.446223151,5140874.710531125],[-9753492.47238681,5140874.713050398],[-9753492.498502519,5140874.716025908],[-9753492.524562318,5140874.719456745],[-9753492.550558273,5140874.723341866],[-9753492.576482464,5140874.727680088],[-9753492.602326993,5140874.732470089],[-9753492.628083989,5140874.737710409],[-9753492.653745607,5140874.743399452],[-9753492.679304028,5140874.749535487],[-9753492.70475147,5140874.756116643],[-9753492.730080176,5140874.763140914],[-9753492.755282436,5140874.770606164],[-9753492.78035057,5140874.778510116],[-9753492.805276943,5140874.786850364],[-9753492.830053963,5140874.795624367],[-9753492.85467408,5140874.804829452],[-9753492.8791298,5140874.814462815],[-9753492.903413666,5140874.824521523],[-9753492.927518288,5140874.83500251],[-9753492.951436317,5140874.8459025845],[-9753492.975160472,5140874.857218426],[-9753492.998683527,5140874.868946588],[-9753493.021998312,5140874.881083498],[-9753493.04509773,5140874.893625458],[-9753493.06797474,5140874.906568647],[-9753493.090622379,5140874.919909125],[-9753493.113033742,5140874.933642827],[-9753493.135202007,5140874.947765569],[-9753493.15712042,5140874.962273051],[-9753493.178782305,5140874.977160851],[-9753493.200181061,5140874.992424436],[-9753493.221310172,5140875.008059156],[-9753493.242163202,5140875.024060248],[-9753493.262733798,5140875.04042284],[-9753493.283015694,5140875.057141945],[-9753493.303002715,5140875.074212472],[-9753493.322688768,5140875.091629221],[-9753493.342067858,5140875.109386886],[-9753493.361134084,5140875.127480058],[-9753493.379881635,5140875.145903226],[-9753493.398304803,5140875.164650777],[-9753493.416397976,5140875.183717003],[-9753493.434155641,5140875.203096094],[-9753493.451572388,5140875.222782147],[-9753493.468642917,5140875.242769166],[-9753493.485362021,5140875.263051063],[-9753493.501724612,5140875.283621659],[-9753493.517725706,5140875.304474689],[-9753493.533360425,5140875.3256038],[-9753493.54862401,5140875.3470025575],[-9753493.563511811,5140875.368664442],[-9753493.578019291,5140875.390582854],[-9753493.592142034,5140875.412751119],[-9753493.605875736,5140875.435162484],[-9753493.619216213,5140875.457810121],[-9753493.632159404,5140875.480687132],[-9753493.644701364,5140875.503786549],[-9753493.656838274,5140875.527101335],[-9753493.668566436,5140875.550624388],[-9753493.679882277,5140875.574348544],[-9753493.690782351,5140875.598266575],[-9753493.701263338,5140875.622371195],[-9753493.711322047,5140875.646655062],[-9753493.72095541,5140875.67111078],[-9753493.730160495,5140875.6957308985],[-9753493.738934496,5140875.720507918],[-9753493.747274745,5140875.745434292],[-9753493.755178697,5140875.770502426],[-9753493.762643946,5140875.795704685],[-9753493.76966822,5140875.821033393],[-9753493.776249375,5140875.846480833],[-9753493.782385409,5140875.872039255],[-9753493.788074452,5140875.897700871],[-9753493.793314772,5140875.923457868],[-9753493.798104772,5140875.949302398],[-9753493.802442994,5140875.975226589],[-9753493.806328116,5140876.001222543],[-9753493.809758954,5140876.027282343],[-9753493.812734462,5140876.05339805],[-9753493.815253736,5140876.079561709],[-9753493.817316009,5140876.105765352],[-9753493.81892065,5140876.132000995],[-9753493.82006717,5140876.158260646],[-9753493.820755223,5140876.184536308],[-9753493.820984596,5140876.210819976],[-9753493.820755223,5140876.237103645],[-9753493.82006717,5140876.2633793065],[-9753493.81892065,5140876.289638958],[-9753493.817316009,5140876.315874601],[-9753493.815253736,5140876.342078243],[-9753493.812734462,5140876.368241902],[-9753493.809758954,5140876.39435761],[-9753493.806328116,5140876.420417409],[-9753493.802442994,5140876.446413364],[-9753493.798104772,5140876.472337555],[-9753493.793314772,5140876.498182084],[-9753493.788074452,5140876.5239390815],[-9753493.782385409,5140876.549600698],[-9753493.776249375,5140876.575159119],[-9753493.76966822,5140876.60060656],[-9753493.762643946,5140876.625935268],[-9753493.755178697,5140876.651137527],[-9753493.747274745,5140876.676205661],[-9753493.738934496,5140876.701132035],[-9753493.730160495,5140876.725909054],[-9753493.72095541,5140876.750529173],[-9753493.711322047,5140876.774984891],[-9753493.701263338,5140876.799268758],[-9753493.690782351,5140876.823373378],[-9753493.679882277,5140876.847291409],[-9753493.668566436,5140876.871015565],[-9753493.656838274,5140876.894538618],[-9753493.644701364,5140876.917853404],[-9753493.632159404,5140876.940952821],[-9753493.619216213,5140876.963829832],[-9753493.605875736,5140876.986477469],[-9753493.592142034,5140877.008888834],[-9753493.578019291,5140877.031057099],[-9753493.563511811,5140877.052975511],[-9753493.54862401,5140877.074637395],[-9753493.533360425,5140877.096036153],[-9753493.517725706,5140877.117165264],[-9753493.501724612,5140877.138018294],[-9753493.485362021,5140877.15858889],[-9753493.468642917,5140877.178870787],[-9753493.451572388,5140877.198857806],[-9753493.434155641,5140877.218543859],[-9753493.416397976,5140877.23792295],[-9753493.398304803,5140877.256989175],[-9753493.379881635,5140877.275736727],[-9753493.361134084,5140877.294159895],[-9753493.342067858,5140877.312253067],[-9753493.322688768,5140877.330010732],[-9753493.303002715,5140877.347427481],[-9753493.283015694,5140877.364498008],[-9753493.262733798,5140877.381217113],[-9753493.242163202,5140877.397579704],[-9753493.221310172,5140877.413580797],[-9753493.200181061,5140877.429215517],[-9753493.178782305,5140877.444479102],[-9753493.15712042,5140877.459366902],[-9753493.135202007,5140877.473874384],[-9753493.113033742,5140877.487997126],[-9753493.090622379,5140877.501730828],[-9753493.06797474,5140877.515071305],[-9753493.04509773,5140877.528014495],[-9753493.021998312,5140877.540556455],[-9753492.998683527,5140877.552693365],[-9753492.975160472,5140877.564421527],[-9753492.951436317,5140877.575737368],[-9753492.927518288,5140877.586637443],[-9753492.903413666,5140877.59711843],[-9753492.8791298,5140877.607177137],[-9753492.85467408,5140877.616810501],[-9753492.830053963,5140877.626015586],[-9753492.805276943,5140877.634789589],[-9753492.78035057,5140877.643129837],[-9753492.755282436,5140877.651033789],[-9753492.730080176,5140877.658499039],[-9753492.70475147,5140877.66552331],[-9753492.679304028,5140877.672104466],[-9753492.653745607,5140877.6782405],[-9753492.628083989,5140877.683929544],[-9753492.602326993,5140877.689169864],[-9753492.576482464,5140877.693959865],[-9753492.550558273,5140877.698298086],[-9753492.524562318,5140877.7021832075],[-9753492.498502519,5140877.705614045],[-9753492.47238681,5140877.708589555],[-9753492.446223151,5140877.711108828],[-9753492.42001951,5140877.713171099],[-9753492.393783867,5140877.71477574],[-9753492.367524214,5140877.715922262],[-9753492.341248553,5140877.716610313],[-9753492.314964885,5140877.716839688]]]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753485.886984937,5140877.826719686],[-9753485.860701269,5140877.826490312],[-9753485.834425608,5140877.82580226],[-9753485.808165954,5140877.824655739],[-9753485.781930313,5140877.823051098],[-9753485.75572667,5140877.820988826],[-9753485.72956301,5140877.818469553],[-9753485.703447303,5140877.815494044],[-9753485.677387504,5140877.812063206],[-9753485.651391549,5140877.808178085],[-9753485.625467358,5140877.803839863],[-9753485.599622829,5140877.799049863],[-9753485.573865833,5140877.793809542],[-9753485.548204215,5140877.788120499],[-9753485.522645794,5140877.781984464],[-9753485.497198353,5140877.775403309],[-9753485.471869646,5140877.768379037],[-9753485.446667386,5140877.760913787],[-9753485.421599252,5140877.753009835],[-9753485.396672878,5140877.744669587],[-9753485.371895859,5140877.735895584],[-9753485.347275741,5140877.726690499],[-9753485.322820023,5140877.717057136],[-9753485.298536155,5140877.706998428],[-9753485.274431534,5140877.696517441],[-9753485.250513505,5140877.685617367],[-9753485.22678935,5140877.674301526],[-9753485.203266295,5140877.662573364],[-9753485.17995151,5140877.6504364535],[-9753485.156852093,5140877.6378944935],[-9753485.133975081,5140877.624951304],[-9753485.111327443,5140877.611610826],[-9753485.08891608,5140877.597877124],[-9753485.066747814,5140877.583754382],[-9753485.044829402,5140877.5692469],[-9753485.023167517,5140877.554359101],[-9753485.00176876,5140877.539095515],[-9753484.98063965,5140877.523460795],[-9753484.95978662,5140877.507459703],[-9753484.939216023,5140877.491097111],[-9753484.918934127,5140877.4743780065],[-9753484.898947107,5140877.457307479],[-9753484.879261054,5140877.43989073],[-9753484.859881964,5140877.422133066],[-9753484.840815738,5140877.404039893],[-9753484.822068186,5140877.385616725],[-9753484.803645018,5140877.366869174],[-9753484.785551846,5140877.347802948],[-9753484.76779418,5140877.328423858],[-9753484.750377433,5140877.308737804],[-9753484.733306905,5140877.288750785],[-9753484.7165878,5140877.2684688885],[-9753484.70022521,5140877.247898293],[-9753484.684224116,5140877.227045262],[-9753484.668589396,5140877.205916151],[-9753484.653325811,5140877.184517394],[-9753484.63843801,5140877.16285551],[-9753484.62393053,5140877.140937097],[-9753484.609807787,5140877.118768833],[-9753484.596074086,5140877.096357468],[-9753484.582733609,5140877.073709831],[-9753484.569790417,5140877.050832819],[-9753484.557248458,5140877.027733402],[-9753484.545111548,5140877.004418616],[-9753484.533383386,5140876.980895563],[-9753484.522067545,5140876.9571714075],[-9753484.51116747,5140876.933253377],[-9753484.500686483,5140876.909148756],[-9753484.490627775,5140876.884864889],[-9753484.480994413,5140876.860409171],[-9753484.471789327,5140876.835789053],[-9753484.463015325,5140876.811012033],[-9753484.454675077,5140876.78608566],[-9753484.446771124,5140876.761017526],[-9753484.439305875,5140876.735815266],[-9753484.432281602,5140876.710486558],[-9753484.425700447,5140876.685039118],[-9753484.419564413,5140876.659480697],[-9753484.41387537,5140876.63381908],[-9753484.40863505,5140876.608062083],[-9753484.40384505,5140876.582217554],[-9753484.399506828,5140876.556293363],[-9753484.395621706,5140876.530297408],[-9753484.392190868,5140876.504237608],[-9753484.38921536,5140876.478121901],[-9753484.386696085,5140876.451958242],[-9753484.384633813,5140876.425754599],[-9753484.383029172,5140876.399518956],[-9753484.381882653,5140876.373259305],[-9753484.381194599,5140876.346983643],[-9753484.380965225,5140876.320699975],[-9753484.381194599,5140876.294416307],[-9753484.381882653,5140876.268140645],[-9753484.383029172,5140876.241880993],[-9753484.384633813,5140876.2156453505],[-9753484.386696085,5140876.189441708],[-9753484.38921536,5140876.163278049],[-9753484.392190868,5140876.137162342],[-9753484.395621706,5140876.111102542],[-9753484.399506828,5140876.085106587],[-9753484.40384505,5140876.059182396],[-9753484.40863505,5140876.033337867],[-9753484.41387537,5140876.00758087],[-9753484.419564413,5140875.981919253],[-9753484.425700447,5140875.956360832],[-9753484.432281602,5140875.9309133915],[-9753484.439305875,5140875.905584684],[-9753484.446771124,5140875.880382424],[-9753484.454675077,5140875.85531429],[-9753484.463015325,5140875.830387916],[-9753484.471789327,5140875.805610897],[-9753484.480994413,5140875.7809907785],[-9753484.490627775,5140875.756535061],[-9753484.500686483,5140875.732251193],[-9753484.51116747,5140875.708146573],[-9753484.522067545,5140875.684228542],[-9753484.533383386,5140875.660504387],[-9753484.545111548,5140875.636981334],[-9753484.557248458,5140875.613666547],[-9753484.569790417,5140875.590567131],[-9753484.582733609,5140875.567690119],[-9753484.596074086,5140875.545042482],[-9753484.609807787,5140875.522631117],[-9753484.62393053,5140875.500462852],[-9753484.63843801,5140875.47854444],[-9753484.653325811,5140875.456882556],[-9753484.668589396,5140875.435483798],[-9753484.684224116,5140875.414354688],[-9753484.70022521,5140875.393501657],[-9753484.7165878,5140875.372931061],[-9753484.733306905,5140875.352649164],[-9753484.750377433,5140875.332662146],[-9753484.76779418,5140875.312976092],[-9753484.785551846,5140875.293597002],[-9753484.803645018,5140875.274530776],[-9753484.822068186,5140875.2557832245],[-9753484.840815738,5140875.2373600565],[-9753484.859881964,5140875.219266884],[-9753484.879261054,5140875.20150922],[-9753484.898947107,5140875.18409247],[-9753484.918934127,5140875.167021943],[-9753484.939216023,5140875.1503028385],[-9753484.95978662,5140875.133940247],[-9753484.98063965,5140875.117939155],[-9753485.00176876,5140875.102304434],[-9753485.023167517,5140875.087040849],[-9753485.044829402,5140875.0721530495],[-9753485.066747814,5140875.057645568],[-9753485.08891608,5140875.043522825],[-9753485.111327443,5140875.029789124],[-9753485.133975081,5140875.016448646],[-9753485.156852093,5140875.003505456],[-9753485.17995151,5140874.990963496],[-9753485.203266295,5140874.978826586],[-9753485.22678935,5140874.967098424],[-9753485.250513505,5140874.955782583],[-9753485.274431534,5140874.944882508],[-9753485.298536155,5140874.934401521],[-9753485.322820023,5140874.924342814],[-9753485.347275741,5140874.914709451],[-9753485.371895859,5140874.905504365],[-9753485.396672878,5140874.896730362],[-9753485.421599252,5140874.8883901145],[-9753485.446667386,5140874.880486162],[-9753485.471869646,5140874.8730209125],[-9753485.497198353,5140874.865996641],[-9753485.522645794,5140874.8594154855],[-9753485.548204215,5140874.853279451],[-9753485.573865833,5140874.847590407],[-9753485.599622829,5140874.842350087],[-9753485.625467358,5140874.8375600865],[-9753485.651391549,5140874.833221865],[-9753485.677387504,5140874.829336744],[-9753485.703447303,5140874.825905906],[-9753485.72956301,5140874.822930397],[-9753485.75572667,5140874.820411123],[-9753485.781930313,5140874.818348852],[-9753485.808165954,5140874.816744211],[-9753485.834425608,5140874.81559769],[-9753485.860701269,5140874.814909638],[-9753485.886984937,5140874.814680263],[-9753485.913268605,5140874.814909638],[-9753485.939544266,5140874.81559769],[-9753485.96580392,5140874.816744211],[-9753485.992039561,5140874.818348852],[-9753486.018243203,5140874.820411123],[-9753486.044406863,5140874.822930397],[-9753486.070522571,5140874.825905906],[-9753486.09658237,5140874.829336744],[-9753486.122578325,5140874.833221865],[-9753486.148502516,5140874.8375600865],[-9753486.174347045,5140874.842350087],[-9753486.200104041,5140874.847590407],[-9753486.225765659,5140874.853279451],[-9753486.25132408,5140874.8594154855],[-9753486.276771521,5140874.865996641],[-9753486.302100228,5140874.8730209125],[-9753486.327302488,5140874.880486162],[-9753486.352370622,5140874.8883901145],[-9753486.377296995,5140874.896730362],[-9753486.402074015,5140874.905504365],[-9753486.426694132,5140874.914709451],[-9753486.451149851,5140874.924342814],[-9753486.475433718,5140874.934401521],[-9753486.49953834,5140874.944882508],[-9753486.523456369,5140874.955782583],[-9753486.547180524,5140874.967098424],[-9753486.57070358,5140874.978826586],[-9753486.594018364,5140874.990963496],[-9753486.617117781,5140875.003505456],[-9753486.639994793,5140875.016448646],[-9753486.66264243,5140875.029789124],[-9753486.685053794,5140875.043522825],[-9753486.70722206,5140875.057645568],[-9753486.729140472,5140875.0721530495],[-9753486.750802357,5140875.087040849],[-9753486.772201113,5140875.102304434],[-9753486.793330224,5140875.117939155],[-9753486.814183254,5140875.133940247],[-9753486.83475385,5140875.1503028385],[-9753486.855035746,5140875.167021943],[-9753486.875022767,5140875.18409247],[-9753486.89470882,5140875.20150922],[-9753486.91408791,5140875.219266884],[-9753486.933154136,5140875.2373600565],[-9753486.951901687,5140875.2557832245],[-9753486.970324855,5140875.274530776],[-9753486.988418028,5140875.293597002],[-9753487.006175693,5140875.312976092],[-9753487.02359244,5140875.332662146],[-9753487.040662969,5140875.352649164],[-9753487.057382073,5140875.372931061],[-9753487.073744664,5140875.393501657],[-9753487.089745758,5140875.414354688],[-9753487.105380477,5140875.435483798],[-9753487.120644063,5140875.456882556],[-9753487.135531863,5140875.47854444],[-9753487.150039343,5140875.500462852],[-9753487.164162086,5140875.522631117],[-9753487.177895788,5140875.545042482],[-9753487.191236265,5140875.567690119],[-9753487.204179456,5140875.590567131],[-9753487.216721416,5140875.613666547],[-9753487.228858326,5140875.636981334],[-9753487.240586488,5140875.660504387],[-9753487.251902329,5140875.684228542],[-9753487.262802403,5140875.708146573],[-9753487.27328339,5140875.732251193],[-9753487.283342099,5140875.756535061],[-9753487.292975461,5140875.7809907785],[-9753487.302180547,5140875.805610897],[-9753487.310954548,5140875.830387916],[-9753487.319294797,5140875.85531429],[-9753487.32719875,5140875.880382424],[-9753487.334663998,5140875.905584684],[-9753487.341688272,5140875.9309133915],[-9753487.348269427,5140875.956360832],[-9753487.35440546,5140875.981919253],[-9753487.360094504,5140876.00758087],[-9753487.365334824,5140876.033337867],[-9753487.370124824,5140876.059182396],[-9753487.374463046,5140876.085106587],[-9753487.378348168,5140876.111102542],[-9753487.381779006,5140876.137162342],[-9753487.384754514,5140876.163278049],[-9753487.387273788,5140876.189441708],[-9753487.38933606,5140876.2156453505],[-9753487.390940702,5140876.241880993],[-9753487.392087221,5140876.268140645],[-9753487.392775275,5140876.294416307],[-9753487.393004648,5140876.320699975],[-9753487.392775275,5140876.346983643],[-9753487.392087221,5140876.373259305],[-9753487.390940702,5140876.399518956],[-9753487.38933606,5140876.425754599],[-9753487.387273788,5140876.451958242],[-9753487.384754514,5140876.478121901],[-9753487.381779006,5140876.504237608],[-9753487.378348168,5140876.530297408],[-9753487.374463046,5140876.556293363],[-9753487.370124824,5140876.582217554],[-9753487.365334824,5140876.608062083],[-9753487.360094504,5140876.63381908],[-9753487.35440546,5140876.659480697],[-9753487.348269427,5140876.685039118],[-9753487.341688272,5140876.710486558],[-9753487.334663998,5140876.735815266],[-9753487.32719875,5140876.761017526],[-9753487.319294797,5140876.78608566],[-9753487.310954548,5140876.811012033],[-9753487.302180547,5140876.835789053],[-9753487.292975461,5140876.860409171],[-9753487.283342099,5140876.884864889],[-9753487.27328339,5140876.909148756],[-9753487.262802403,5140876.933253377],[-9753487.251902329,5140876.9571714075],[-9753487.240586488,5140876.980895563],[-9753487.228858326,5140877.004418616],[-9753487.216721416,5140877.027733402],[-9753487.204179456,5140877.050832819],[-9753487.191236265,5140877.073709831],[-9753487.177895788,5140877.096357468],[-9753487.164162086,5140877.118768833],[-9753487.150039343,5140877.140937097],[-9753487.135531863,5140877.16285551],[-9753487.120644063,5140877.184517394],[-9753487.105380477,5140877.205916151],[-9753487.089745758,5140877.227045262],[-9753487.073744664,5140877.247898293],[-9753487.057382073,5140877.2684688885],[-9753487.040662969,5140877.288750785],[-9753487.02359244,5140877.308737804],[-9753487.006175693,5140877.328423858],[-9753486.988418028,5140877.347802948],[-9753486.970324855,5140877.366869174],[-9753486.951901687,5140877.385616725],[-9753486.933154136,5140877.404039893],[-9753486.91408791,5140877.422133066],[-9753486.89470882,5140877.43989073],[-9753486.875022767,5140877.457307479],[-9753486.855035746,5140877.4743780065],[-9753486.83475385,5140877.491097111],[-9753486.814183254,5140877.507459703],[-9753486.793330224,5140877.523460795],[-9753486.772201113,5140877.539095515],[-9753486.750802357,5140877.554359101],[-9753486.729140472,5140877.5692469],[-9753486.70722206,5140877.583754382],[-9753486.685053794,5140877.597877124],[-9753486.66264243,5140877.611610826],[-9753486.639994793,5140877.624951304],[-9753486.617117781,5140877.6378944935],[-9753486.594018364,5140877.6504364535],[-9753486.57070358,5140877.662573364],[-9753486.547180524,5140877.674301526],[-9753486.523456369,5140877.685617367],[-9753486.49953834,5140877.696517441],[-9753486.475433718,5140877.706998428],[-9753486.451149851,5140877.717057136],[-9753486.426694132,5140877.726690499],[-9753486.402074015,5140877.735895584],[-9753486.377296995,5140877.744669587],[-9753486.352370622,5140877.753009835],[-9753486.327302488,5140877.760913787],[-9753486.302100228,5140877.768379037],[-9753486.276771521,5140877.775403309],[-9753486.25132408,5140877.781984464],[-9753486.225765659,5140877.788120499],[-9753486.200104041,5140877.793809542],[-9753486.174347045,5140877.799049863],[-9753486.148502516,5140877.803839863],[-9753486.122578325,5140877.808178085],[-9753486.09658237,5140877.812063206],[-9753486.070522571,5140877.815494044],[-9753486.044406863,5140877.818469553],[-9753486.018243203,5140877.820988826],[-9753485.992039561,5140877.823051098],[-9753485.96580392,5140877.824655739],[-9753485.939544266,5140877.82580226],[-9753485.913268605,5140877.826490312],[-9753485.886984937,5140877.826719686]]]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753479.165991656,5140877.973226353],[-9753479.139707988,5140877.972996978],[-9753479.113432327,5140877.972308926],[-9753479.087172674,5140877.971162405],[-9753479.060937032,5140877.969557764],[-9753479.03473339,5140877.967495493],[-9753479.00856973,5140877.964976219],[-9753478.982454022,5140877.96200071],[-9753478.956394223,5140877.958569872],[-9753478.930398269,5140877.954684751],[-9753478.904474078,5140877.9503465295],[-9753478.878629548,5140877.945556529],[-9753478.852872552,5140877.940316209],[-9753478.827210935,5140877.934627165],[-9753478.801652513,5140877.9284911305],[-9753478.776205072,5140877.921909975],[-9753478.750876365,5140877.9148857035],[-9753478.725674106,5140877.907420454],[-9753478.700605972,5140877.899516501],[-9753478.675679598,5140877.891176254],[-9753478.650902579,5140877.882402251],[-9753478.626282461,5140877.873197165],[-9753478.601826742,5140877.863563802],[-9753478.577542875,5140877.853505095],[-9753478.553438254,5140877.843024108],[-9753478.529520225,5140877.832124033],[-9753478.50579607,5140877.820808192],[-9753478.482273014,5140877.80908003],[-9753478.458958229,5140877.79694312],[-9753478.435858812,5140877.78440116],[-9753478.4129818,5140877.77145797],[-9753478.390334163,5140877.758117492],[-9753478.3679228,5140877.7443837905],[-9753478.345754534,5140877.730261048],[-9753478.323836122,5140877.7157535665],[-9753478.302174237,5140877.700865767],[-9753478.28077548,5140877.685602182],[-9753478.25964637,5140877.669967461],[-9753478.23879334,5140877.653966369],[-9753478.218222743,5140877.637603777],[-9753478.197940847,5140877.620884673],[-9753478.177953826,5140877.603814146],[-9753478.158267774,5140877.586397396],[-9753478.138888683,5140877.568639732],[-9753478.119822457,5140877.5505465595],[-9753478.101074906,5140877.5321233915],[-9753478.082651738,5140877.51337584],[-9753478.064558566,5140877.494309614],[-9753478.0468009,5140877.474930524],[-9753478.029384153,5140877.45524447],[-9753478.012313625,5140877.435257452],[-9753477.99559452,5140877.414975555],[-9753477.97923193,5140877.394404959],[-9753477.963230835,5140877.373551928],[-9753477.947596116,5140877.352422818],[-9753477.93233253,5140877.33102406],[-9753477.91744473,5140877.309362176],[-9753477.90293725,5140877.287443764],[-9753477.888814507,5140877.265275499],[-9753477.875080805,5140877.242864134],[-9753477.861740328,5140877.220216497],[-9753477.848797137,5140877.197339485],[-9753477.836255178,5140877.1742400685],[-9753477.824118268,5140877.150925282],[-9753477.812390106,5140877.127402229],[-9753477.801074265,5140877.103678074],[-9753477.79017419,5140877.079760043],[-9753477.779693203,5140877.055655423],[-9753477.769634495,5140877.031371555],[-9753477.760001132,5140877.0069158375],[-9753477.750796046,5140876.982295719],[-9753477.742022045,5140876.9575187],[-9753477.733681796,5140876.932592326],[-9753477.725777844,5140876.907524192],[-9753477.718312595,5140876.882321932],[-9753477.711288322,5140876.8569932245],[-9753477.704707166,5140876.831545784],[-9753477.698571132,5140876.805987363],[-9753477.692882089,5140876.780325746],[-9753477.68764177,5140876.754568749],[-9753477.682851769,5140876.72872422],[-9753477.678513547,5140876.702800029],[-9753477.674628425,5140876.676804074],[-9753477.671197588,5140876.650744274],[-9753477.668222079,5140876.624628567],[-9753477.665702805,5140876.598464908],[-9753477.663640533,5140876.5722612655],[-9753477.662035892,5140876.546025623],[-9753477.660889372,5140876.519765971],[-9753477.660201319,5140876.493490309],[-9753477.659971945,5140876.467206641],[-9753477.660201319,5140876.440922973],[-9753477.660889372,5140876.414647311],[-9753477.662035892,5140876.38838766],[-9753477.663640533,5140876.362152017],[-9753477.665702805,5140876.335948374],[-9753477.668222079,5140876.309784715],[-9753477.671197588,5140876.283669008],[-9753477.674628425,5140876.257609208],[-9753477.678513547,5140876.231613253],[-9753477.682851769,5140876.205689062],[-9753477.68764177,5140876.179844533],[-9753477.692882089,5140876.154087536],[-9753477.698571132,5140876.128425919],[-9753477.704707166,5140876.102867498],[-9753477.711288322,5140876.077420058],[-9753477.718312595,5140876.05209135],[-9753477.725777844,5140876.02688909],[-9753477.733681796,5140876.001820956],[-9753477.742022045,5140875.976894583],[-9753477.750796046,5140875.952117563],[-9753477.760001132,5140875.927497445],[-9753477.769634495,5140875.903041727],[-9753477.779693203,5140875.87875786],[-9753477.79017419,5140875.854653239],[-9753477.801074265,5140875.8307352085],[-9753477.812390106,5140875.807011053],[-9753477.824118268,5140875.783488],[-9753477.836255178,5140875.760173214],[-9753477.848797137,5140875.737073797],[-9753477.861740328,5140875.714196785],[-9753477.875080805,5140875.691549148],[-9753477.888814507,5140875.669137783],[-9753477.90293725,5140875.646969519],[-9753477.91744473,5140875.625051106],[-9753477.93233253,5140875.603389222],[-9753477.947596116,5140875.581990465],[-9753477.963230835,5140875.560861354],[-9753477.97923193,5140875.540008323],[-9753477.99559452,5140875.5194377275],[-9753478.012313625,5140875.499155831],[-9753478.029384153,5140875.479168812],[-9753478.0468009,5140875.459482758],[-9753478.064558566,5140875.440103668],[-9753478.082651738,5140875.421037442],[-9753478.101074906,5140875.402289891],[-9753478.119822457,5140875.383866723],[-9753478.138888683,5140875.36577355],[-9753478.158267774,5140875.348015886],[-9753478.177953826,5140875.330599137],[-9753478.197940847,5140875.313528609],[-9753478.218222743,5140875.296809505],[-9753478.23879334,5140875.280446913],[-9753478.25964637,5140875.264445821],[-9753478.28077548,5140875.248811101],[-9753478.302174237,5140875.233547515],[-9753478.323836122,5140875.218659716],[-9753478.345754534,5140875.204152234],[-9753478.3679228,5140875.190029492],[-9753478.390334163,5140875.17629579],[-9753478.4129818,5140875.162955312],[-9753478.435858812,5140875.1500121225],[-9753478.458958229,5140875.1374701625],[-9753478.482273014,5140875.125333252],[-9753478.50579607,5140875.11360509],[-9753478.529520225,5140875.102289249],[-9753478.553438254,5140875.091389175],[-9753478.577542875,5140875.080908188],[-9753478.601826742,5140875.07084948],[-9753478.626282461,5140875.061216117],[-9753478.650902579,5140875.052011032],[-9753478.675679598,5140875.043237029],[-9753478.700605972,5140875.034896781],[-9753478.725674106,5140875.026992829],[-9753478.750876365,5140875.019527579],[-9753478.776205072,5140875.012503307],[-9753478.801652513,5140875.005922152],[-9753478.827210935,5140874.999786117],[-9753478.852872552,5140874.994097074],[-9753478.878629548,5140874.988856753],[-9753478.904474078,5140874.984066753],[-9753478.930398269,5140874.979728531],[-9753478.956394223,5140874.97584341],[-9753478.982454022,5140874.972412572],[-9753479.00856973,5140874.969437063],[-9753479.03473339,5140874.96691779],[-9753479.060937032,5140874.964855518],[-9753479.087172674,5140874.963250877],[-9753479.113432327,5140874.962104356],[-9753479.139707988,5140874.961416304],[-9753479.165991656,5140874.96118693],[-9753479.192275325,5140874.961416304],[-9753479.218550986,5140874.962104356],[-9753479.244810639,5140874.963250877],[-9753479.27104628,5140874.964855518],[-9753479.297249923,5140874.96691779],[-9753479.323413583,5140874.969437063],[-9753479.34952929,5140874.972412572],[-9753479.37558909,5140874.97584341],[-9753479.401585044,5140874.979728531],[-9753479.427509235,5140874.984066753],[-9753479.453353764,5140874.988856753],[-9753479.47911076,5140874.994097074],[-9753479.504772378,5140874.999786117],[-9753479.5303308,5140875.005922152],[-9753479.55577824,5140875.012503307],[-9753479.581106948,5140875.019527579],[-9753479.606309207,5140875.026992829],[-9753479.631377341,5140875.034896781],[-9753479.656303715,5140875.043237029],[-9753479.681080734,5140875.052011032],[-9753479.705700852,5140875.061216117],[-9753479.73015657,5140875.07084948],[-9753479.754440438,5140875.080908188],[-9753479.77854506,5140875.091389175],[-9753479.802463088,5140875.102289249],[-9753479.826187244,5140875.11360509],[-9753479.849710299,5140875.125333252],[-9753479.873025084,5140875.1374701625],[-9753479.8961245,5140875.1500121225],[-9753479.919001512,5140875.162955312],[-9753479.94164915,5140875.17629579],[-9753479.964060513,5140875.190029492],[-9753479.986228779,5140875.204152234],[-9753480.008147191,5140875.218659716],[-9753480.029809076,5140875.233547515],[-9753480.051207833,5140875.248811101],[-9753480.072336944,5140875.264445821],[-9753480.093189973,5140875.280446913],[-9753480.11376057,5140875.296809505],[-9753480.134042466,5140875.313528609],[-9753480.154029487,5140875.330599137],[-9753480.17371554,5140875.348015886],[-9753480.19309463,5140875.36577355],[-9753480.212160856,5140875.383866723],[-9753480.230908407,5140875.402289891],[-9753480.249331575,5140875.421037442],[-9753480.267424747,5140875.440103668],[-9753480.285182413,5140875.459482758],[-9753480.30259916,5140875.479168812],[-9753480.319669688,5140875.499155831],[-9753480.336388793,5140875.5194377275],[-9753480.352751384,5140875.540008323],[-9753480.368752478,5140875.560861354],[-9753480.384387197,5140875.581990465],[-9753480.399650782,5140875.603389222],[-9753480.414538583,5140875.625051106],[-9753480.429046063,5140875.646969519],[-9753480.443168806,5140875.669137783],[-9753480.456902508,5140875.691549148],[-9753480.470242985,5140875.714196785],[-9753480.483186176,5140875.737073797],[-9753480.495728135,5140875.760173214],[-9753480.507865045,5140875.783488],[-9753480.519593207,5140875.807011053],[-9753480.530909048,5140875.8307352085],[-9753480.541809123,5140875.854653239],[-9753480.55229011,5140875.87875786],[-9753480.562348818,5140875.903041727],[-9753480.57198218,5140875.927497445],[-9753480.581187267,5140875.952117563],[-9753480.589961268,5140875.976894583],[-9753480.598301517,5140876.001820956],[-9753480.606205469,5140876.02688909],[-9753480.613670718,5140876.05209135],[-9753480.620694991,5140876.077420058],[-9753480.627276147,5140876.102867498],[-9753480.63341218,5140876.128425919],[-9753480.639101224,5140876.154087536],[-9753480.644341543,5140876.179844533],[-9753480.649131544,5140876.205689062],[-9753480.653469766,5140876.231613253],[-9753480.657354888,5140876.257609208],[-9753480.660785725,5140876.283669008],[-9753480.663761234,5140876.309784715],[-9753480.666280508,5140876.335948374],[-9753480.66834278,5140876.362152017],[-9753480.669947421,5140876.38838766],[-9753480.67109394,5140876.414647311],[-9753480.671781994,5140876.440922973],[-9753480.672011368,5140876.467206641],[-9753480.671781994,5140876.493490309],[-9753480.67109394,5140876.519765971],[-9753480.669947421,5140876.546025623],[-9753480.66834278,5140876.5722612655],[-9753480.666280508,5140876.598464908],[-9753480.663761234,5140876.624628567],[-9753480.660785725,5140876.650744274],[-9753480.657354888,5140876.676804074],[-9753480.653469766,5140876.702800029],[-9753480.649131544,5140876.72872422],[-9753480.644341543,5140876.754568749],[-9753480.639101224,5140876.780325746],[-9753480.63341218,5140876.805987363],[-9753480.627276147,5140876.831545784],[-9753480.620694991,5140876.8569932245],[-9753480.613670718,5140876.882321932],[-9753480.606205469,5140876.907524192],[-9753480.598301517,5140876.932592326],[-9753480.589961268,5140876.9575187],[-9753480.581187267,5140876.982295719],[-9753480.57198218,5140877.0069158375],[-9753480.562348818,5140877.031371555],[-9753480.55229011,5140877.055655423],[-9753480.541809123,5140877.079760043],[-9753480.530909048,5140877.103678074],[-9753480.519593207,5140877.127402229],[-9753480.507865045,5140877.150925282],[-9753480.495728135,5140877.1742400685],[-9753480.483186176,5140877.197339485],[-9753480.470242985,5140877.220216497],[-9753480.456902508,5140877.242864134],[-9753480.443168806,5140877.265275499],[-9753480.429046063,5140877.287443764],[-9753480.414538583,5140877.309362176],[-9753480.399650782,5140877.33102406],[-9753480.384387197,5140877.352422818],[-9753480.368752478,5140877.373551928],[-9753480.352751384,5140877.394404959],[-9753480.336388793,5140877.414975555],[-9753480.319669688,5140877.435257452],[-9753480.30259916,5140877.45524447],[-9753480.285182413,5140877.474930524],[-9753480.267424747,5140877.494309614],[-9753480.249331575,5140877.51337584],[-9753480.230908407,5140877.5321233915],[-9753480.212160856,5140877.5505465595],[-9753480.19309463,5140877.568639732],[-9753480.17371554,5140877.586397396],[-9753480.154029487,5140877.603814146],[-9753480.134042466,5140877.620884673],[-9753480.11376057,5140877.637603777],[-9753480.093189973,5140877.653966369],[-9753480.072336944,5140877.669967461],[-9753480.051207833,5140877.685602182],[-9753480.029809076,5140877.700865767],[-9753480.008147191,5140877.7157535665],[-9753479.986228779,5140877.730261048],[-9753479.964060513,5140877.7443837905],[-9753479.94164915,5140877.758117492],[-9753479.919001512,5140877.77145797],[-9753479.8961245,5140877.78440116],[-9753479.873025084,5140877.79694312],[-9753479.849710299,5140877.80908003],[-9753479.826187244,5140877.820808192],[-9753479.802463088,5140877.832124033],[-9753479.77854506,5140877.843024108],[-9753479.754440438,5140877.853505095],[-9753479.73015657,5140877.863563802],[-9753479.705700852,5140877.873197165],[-9753479.681080734,5140877.882402251],[-9753479.656303715,5140877.891176254],[-9753479.631377341,5140877.899516501],[-9753479.606309207,5140877.907420454],[-9753479.581106948,5140877.9148857035],[-9753479.55577824,5140877.921909975],[-9753479.5303308,5140877.9284911305],[-9753479.504772378,5140877.934627165],[-9753479.47911076,5140877.940316209],[-9753479.453353764,5140877.945556529],[-9753479.427509235,5140877.9503465295],[-9753479.401585044,5140877.954684751],[-9753479.37558909,5140877.958569872],[-9753479.34952929,5140877.96200071],[-9753479.323413583,5140877.964976219],[-9753479.297249923,5140877.967495493],[-9753479.27104628,5140877.969557764],[-9753479.244810639,5140877.971162405],[-9753479.218550986,5140877.972308926],[-9753479.192275325,5140877.972996978],[-9753479.165991656,5140877.973226353]]]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753472.756325042,5140878.1014196845],[-9753472.730041374,5140878.10119031],[-9753472.703765713,5140878.100502258],[-9753472.67750606,5140878.099355737],[-9753472.651270417,5140878.097751096],[-9753472.625066776,5140878.095688825],[-9753472.598903116,5140878.093169551],[-9753472.572787408,5140878.090194042],[-9753472.546727609,5140878.086763204],[-9753472.520731654,5140878.082878083],[-9753472.494807463,5140878.078539861],[-9753472.468962934,5140878.073749861],[-9753472.443205938,5140878.0685095405],[-9753472.41754432,5140878.062820497],[-9753472.391985899,5140878.056684462],[-9753472.366538458,5140878.050103307],[-9753472.34120975,5140878.043079035],[-9753472.316007491,5140878.0356137855],[-9753472.290939357,5140878.027709833],[-9753472.266012983,5140878.019369585],[-9753472.241235964,5140878.010595582],[-9753472.216615846,5140878.001390497],[-9753472.192160128,5140877.991757134],[-9753472.16787626,5140877.981698426],[-9753472.14377164,5140877.9712174395],[-9753472.11985361,5140877.960317365],[-9753472.096129455,5140877.949001524],[-9753472.0726064,5140877.937273362],[-9753472.049291614,5140877.925136452],[-9753472.026192198,5140877.912594492],[-9753472.003315186,5140877.899651302],[-9753471.980667548,5140877.886310824],[-9753471.958256185,5140877.872577122],[-9753471.93608792,5140877.85845438],[-9753471.914169507,5140877.843946898],[-9753471.892507622,5140877.829059099],[-9753471.871108865,5140877.8137955135],[-9753471.849979755,5140877.798160793],[-9753471.829126725,5140877.782159701],[-9753471.808556128,5140877.765797109],[-9753471.788274232,5140877.749078005],[-9753471.768287212,5140877.732007477],[-9753471.74860116,5140877.714590728],[-9753471.729222069,5140877.696833064],[-9753471.710155843,5140877.678739891],[-9753471.691408291,5140877.660316723],[-9753471.672985123,5140877.641569172],[-9753471.654891951,5140877.622502946],[-9753471.637134286,5140877.603123856],[-9753471.619717538,5140877.583437802],[-9753471.60264701,5140877.5634507835],[-9753471.585927906,5140877.543168887],[-9753471.569565315,5140877.522598291],[-9753471.55356422,5140877.50174526],[-9753471.537929501,5140877.4806161495],[-9753471.522665916,5140877.459217392],[-9753471.507778116,5140877.437555508],[-9753471.493270636,5140877.415637095],[-9753471.479147892,5140877.393468831],[-9753471.46541419,5140877.371057466],[-9753471.452073714,5140877.348409829],[-9753471.439130522,5140877.325532817],[-9753471.426588563,5140877.3024334],[-9753471.414451653,5140877.279118614],[-9753471.402723491,5140877.255595561],[-9753471.39140765,5140877.231871406],[-9753471.380507575,5140877.207953375],[-9753471.370026588,5140877.1838487545],[-9753471.35996788,5140877.159564887],[-9753471.350334518,5140877.135109169],[-9753471.341129432,5140877.110489051],[-9753471.33235543,5140877.085712031],[-9753471.324015182,5140877.060785658],[-9753471.31611123,5140877.035717524],[-9753471.30864598,5140877.010515264],[-9753471.301621707,5140876.985186556],[-9753471.295040552,5140876.959739116],[-9753471.288904518,5140876.934180695],[-9753471.283215474,5140876.908519078],[-9753471.277975155,5140876.882762081],[-9753471.273185154,5140876.856917552],[-9753471.268846933,5140876.830993361],[-9753471.26496181,5140876.804997406],[-9753471.261530973,5140876.778937606],[-9753471.258555464,5140876.752821899],[-9753471.25603619,5140876.72665824],[-9753471.253973918,5140876.700454597],[-9753471.252369277,5140876.6742189545],[-9753471.251222758,5140876.647959303],[-9753471.250534704,5140876.621683641],[-9753471.25030533,5140876.595399973],[-9753471.250534704,5140876.569116305],[-9753471.251222758,5140876.542840643],[-9753471.252369277,5140876.516580991],[-9753471.253973918,5140876.490345349],[-9753471.25603619,5140876.464141706],[-9753471.258555464,5140876.437978047],[-9753471.261530973,5140876.41186234],[-9753471.26496181,5140876.38580254],[-9753471.268846933,5140876.359806585],[-9753471.273185154,5140876.333882394],[-9753471.277975155,5140876.308037865],[-9753471.283215474,5140876.282280868],[-9753471.288904518,5140876.256619251],[-9753471.295040552,5140876.23106083],[-9753471.301621707,5140876.20561339],[-9753471.30864598,5140876.180284682],[-9753471.31611123,5140876.155082422],[-9753471.324015182,5140876.130014288],[-9753471.33235543,5140876.1050879145],[-9753471.341129432,5140876.080310895],[-9753471.350334518,5140876.055690777],[-9753471.35996788,5140876.031235059],[-9753471.370026588,5140876.006951191],[-9753471.380507575,5140875.982846571],[-9753471.39140765,5140875.95892854],[-9753471.402723491,5140875.935204385],[-9753471.414451653,5140875.911681332],[-9753471.426588563,5140875.888366546],[-9753471.439130522,5140875.865267129],[-9753471.452073714,5140875.842390117],[-9753471.46541419,5140875.81974248],[-9753471.479147892,5140875.797331115],[-9753471.493270636,5140875.7751628505],[-9753471.507778116,5140875.753244438],[-9753471.522665916,5140875.731582554],[-9753471.537929501,5140875.7101837965],[-9753471.55356422,5140875.689054686],[-9753471.569565315,5140875.668201655],[-9753471.585927906,5140875.647631059],[-9753471.60264701,5140875.6273491625],[-9753471.619717538,5140875.607362144],[-9753471.637134286,5140875.58767609],[-9753471.654891951,5140875.568297],[-9753471.672985123,5140875.549230774],[-9753471.691408291,5140875.530483223],[-9753471.710155843,5140875.512060055],[-9753471.729222069,5140875.493966882],[-9753471.74860116,5140875.476209218],[-9753471.768287212,5140875.4587924685],[-9753471.788274232,5140875.441721941],[-9753471.808556128,5140875.425002837],[-9753471.829126725,5140875.408640245],[-9753471.849979755,5140875.392639153],[-9753471.871108865,5140875.3770044325],[-9753471.892507622,5140875.361740847],[-9753471.914169507,5140875.346853048],[-9753471.93608792,5140875.332345566],[-9753471.958256185,5140875.318222824],[-9753471.980667548,5140875.304489122],[-9753472.003315186,5140875.291148644],[-9753472.026192198,5140875.278205454],[-9753472.049291614,5140875.265663494],[-9753472.0726064,5140875.253526584],[-9753472.096129455,5140875.241798422],[-9753472.11985361,5140875.230482581],[-9753472.14377164,5140875.219582506],[-9753472.16787626,5140875.20910152],[-9753472.192160128,5140875.199042812],[-9753472.216615846,5140875.189409449],[-9753472.241235964,5140875.180204364],[-9753472.266012983,5140875.1714303605],[-9753472.290939357,5140875.163090113],[-9753472.316007491,5140875.1551861605],[-9753472.34120975,5140875.147720911],[-9753472.366538458,5140875.140696639],[-9753472.391985899,5140875.134115484],[-9753472.41754432,5140875.127979449],[-9753472.443205938,5140875.122290405],[-9753472.468962934,5140875.117050085],[-9753472.494807463,5140875.112260085],[-9753472.520731654,5140875.107921863],[-9753472.546727609,5140875.104036742],[-9753472.572787408,5140875.100605904],[-9753472.598903116,5140875.097630395],[-9753472.625066776,5140875.095111121],[-9753472.651270417,5140875.09304885],[-9753472.67750606,5140875.091444209],[-9753472.703765713,5140875.090297688],[-9753472.730041374,5140875.089609636],[-9753472.756325042,5140875.0893802615],[-9753472.78260871,5140875.089609636],[-9753472.808884371,5140875.090297688],[-9753472.835144024,5140875.091444209],[-9753472.861379666,5140875.09304885],[-9753472.887583308,5140875.095111121],[-9753472.913746968,5140875.097630395],[-9753472.939862676,5140875.100605904],[-9753472.965922475,5140875.104036742],[-9753472.99191843,5140875.107921863],[-9753473.01784262,5140875.112260085],[-9753473.04368715,5140875.117050085],[-9753473.069444146,5140875.122290405],[-9753473.095105764,5140875.127979449],[-9753473.120664185,5140875.134115484],[-9753473.146111626,5140875.140696639],[-9753473.171440333,5140875.147720911],[-9753473.196642593,5140875.1551861605],[-9753473.221710727,5140875.163090113],[-9753473.2466371,5140875.1714303605],[-9753473.27141412,5140875.180204364],[-9753473.296034237,5140875.189409449],[-9753473.320489956,5140875.199042812],[-9753473.344773823,5140875.20910152],[-9753473.368878445,5140875.219582506],[-9753473.392796474,5140875.230482581],[-9753473.41652063,5140875.241798422],[-9753473.440043684,5140875.253526584],[-9753473.46335847,5140875.265663494],[-9753473.486457886,5140875.278205454],[-9753473.509334898,5140875.291148644],[-9753473.531982535,5140875.304489122],[-9753473.554393899,5140875.318222824],[-9753473.576562164,5140875.332345566],[-9753473.598480577,5140875.346853048],[-9753473.620142462,5140875.361740847],[-9753473.641541218,5140875.3770044325],[-9753473.66267033,5140875.392639153],[-9753473.683523359,5140875.408640245],[-9753473.704093955,5140875.425002837],[-9753473.724375851,5140875.441721941],[-9753473.744362872,5140875.4587924685],[-9753473.764048925,5140875.476209218],[-9753473.783428015,5140875.493966882],[-9753473.80249424,5140875.512060055],[-9753473.821241792,5140875.530483223],[-9753473.83966496,5140875.549230774],[-9753473.857758133,5140875.568297],[-9753473.875515798,5140875.58767609],[-9753473.892932545,5140875.607362144],[-9753473.910003074,5140875.6273491625],[-9753473.926722178,5140875.647631059],[-9753473.943084769,5140875.668201655],[-9753473.959085863,5140875.689054686],[-9753473.974720582,5140875.7101837965],[-9753473.989984168,5140875.731582554],[-9753474.004871968,5140875.753244438],[-9753474.019379448,5140875.7751628505],[-9753474.033502191,5140875.797331115],[-9753474.047235893,5140875.81974248],[-9753474.06057637,5140875.842390117],[-9753474.073519561,5140875.865267129],[-9753474.08606152,5140875.888366546],[-9753474.09819843,5140875.911681332],[-9753474.109926593,5140875.935204385],[-9753474.121242434,5140875.95892854],[-9753474.132142508,5140875.982846571],[-9753474.142623495,5140876.006951191],[-9753474.152682204,5140876.031235059],[-9753474.162315566,5140876.055690777],[-9753474.171520652,5140876.080310895],[-9753474.180294653,5140876.1050879145],[-9753474.188634902,5140876.130014288],[-9753474.196538854,5140876.155082422],[-9753474.204004103,5140876.180284682],[-9753474.211028377,5140876.20561339],[-9753474.217609532,5140876.23106083],[-9753474.223745566,5140876.256619251],[-9753474.22943461,5140876.282280868],[-9753474.234674929,5140876.308037865],[-9753474.23946493,5140876.333882394],[-9753474.243803151,5140876.359806585],[-9753474.247688273,5140876.38580254],[-9753474.25111911,5140876.41186234],[-9753474.25409462,5140876.437978047],[-9753474.256613893,5140876.464141706],[-9753474.258676166,5140876.490345349],[-9753474.260280807,5140876.516580991],[-9753474.261427326,5140876.542840643],[-9753474.26211538,5140876.569116305],[-9753474.262344753,5140876.595399973],[-9753474.26211538,5140876.621683641],[-9753474.261427326,5140876.647959303],[-9753474.260280807,5140876.6742189545],[-9753474.258676166,5140876.700454597],[-9753474.256613893,5140876.72665824],[-9753474.25409462,5140876.752821899],[-9753474.25111911,5140876.778937606],[-9753474.247688273,5140876.804997406],[-9753474.243803151,5140876.830993361],[-9753474.23946493,5140876.856917552],[-9753474.234674929,5140876.882762081],[-9753474.22943461,5140876.908519078],[-9753474.223745566,5140876.934180695],[-9753474.217609532,5140876.959739116],[-9753474.211028377,5140876.985186556],[-9753474.204004103,5140877.010515264],[-9753474.196538854,5140877.035717524],[-9753474.188634902,5140877.060785658],[-9753474.180294653,5140877.085712031],[-9753474.171520652,5140877.110489051],[-9753474.162315566,5140877.135109169],[-9753474.152682204,5140877.159564887],[-9753474.142623495,5140877.1838487545],[-9753474.132142508,5140877.207953375],[-9753474.121242434,5140877.231871406],[-9753474.109926593,5140877.255595561],[-9753474.09819843,5140877.279118614],[-9753474.08606152,5140877.3024334],[-9753474.073519561,5140877.325532817],[-9753474.06057637,5140877.348409829],[-9753474.047235893,5140877.371057466],[-9753474.033502191,5140877.393468831],[-9753474.019379448,5140877.415637095],[-9753474.004871968,5140877.437555508],[-9753473.989984168,5140877.459217392],[-9753473.974720582,5140877.4806161495],[-9753473.959085863,5140877.50174526],[-9753473.943084769,5140877.522598291],[-9753473.926722178,5140877.543168887],[-9753473.910003074,5140877.5634507835],[-9753473.892932545,5140877.583437802],[-9753473.875515798,5140877.603123856],[-9753473.857758133,5140877.622502946],[-9753473.83966496,5140877.641569172],[-9753473.821241792,5140877.660316723],[-9753473.80249424,5140877.678739891],[-9753473.783428015,5140877.696833064],[-9753473.764048925,5140877.714590728],[-9753473.744362872,5140877.732007477],[-9753473.724375851,5140877.749078005],[-9753473.704093955,5140877.765797109],[-9753473.683523359,5140877.782159701],[-9753473.66267033,5140877.798160793],[-9753473.641541218,5140877.8137955135],[-9753473.620142462,5140877.829059099],[-9753473.598480577,5140877.843946898],[-9753473.576562164,5140877.85845438],[-9753473.554393899,5140877.872577122],[-9753473.531982535,5140877.886310824],[-9753473.509334898,5140877.899651302],[-9753473.486457886,5140877.912594492],[-9753473.46335847,5140877.925136452],[-9753473.440043684,5140877.937273362],[-9753473.41652063,5140877.949001524],[-9753473.392796474,5140877.960317365],[-9753473.368878445,5140877.9712174395],[-9753473.344773823,5140877.981698426],[-9753473.320489956,5140877.991757134],[-9753473.296034237,5140878.001390497],[-9753473.27141412,5140878.010595582],[-9753473.2466371,5140878.019369585],[-9753473.221710727,5140878.027709833],[-9753473.196642593,5140878.0356137855],[-9753473.171440333,5140878.043079035],[-9753473.146111626,5140878.050103307],[-9753473.120664185,5140878.056684462],[-9753473.095105764,5140878.062820497],[-9753473.069444146,5140878.0685095405],[-9753473.04368715,5140878.073749861],[-9753473.01784262,5140878.078539861],[-9753472.99191843,5140878.082878083],[-9753472.965922475,5140878.086763204],[-9753472.939862676,5140878.090194042],[-9753472.913746968,5140878.093169551],[-9753472.887583308,5140878.095688825],[-9753472.861379666,5140878.097751096],[-9753472.835144024,5140878.099355737],[-9753472.808884371,5140878.100502258],[-9753472.78260871,5140878.10119031],[-9753472.756325042,5140878.1014196845]]]]}}]}");

});

parcelRegister("bUglM", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"upper_level_areas\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"id\":\"conservation_lab\",\"properties\":{\"closed\":0,\"label\":\"Regenstein Pacific Lab\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753599.200317003,5140953.798656464],[-9753598.770972107,5140935.889577066],[-9753577.933835749,5140936.276317338],[-9753588.185153423,5140954.028448995],[-9753599.200317003,5140953.798656464]]]]}},{\"type\":\"Feature\",\"id\":\"restoring_earth\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753600.42630049,5141026.099048308],[-9753526.289699156,5141027.46862366],[-9753525.897439897,5141006.235203935],[-9753562.965740563,5141005.550416259],[-9753600.034041231,5141004.865628583],[-9753600.42630049,5141026.099048308]]]]}},{\"type\":\"Feature\",\"id\":\"pacific\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753599.832634939,5140988.417339081],[-9753525.8629542,5140989.783830795],[-9753525.528373422,5140971.67260988],[-9753570.321762247,5140970.845030345],[-9753599.498054162,5140970.306118168],[-9753599.832634939,5140988.417339081]]]]}},{\"type\":\"Feature\",\"id\":\"traveling_pacific\",\"properties\":{\"closed\":0,\"label\":\"\\n\\n\\n\\nTraveling the Pacific\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753588.528955238,5140970.508676611],[-9753570.321762247,5140970.845030345],[-9753570.018032,5140954.38411283],[-9753525.016417347,5140955.215457955],[-9753524.959296541,5140952.123446679],[-9753524.685011651,5140937.27610767],[-9753577.933835749,5140936.276317338],[-9753588.185153423,5140954.028448995],[-9753588.528955238,5140970.508676611]]]]}},{\"type\":\"Feature\",\"id\":\"maori_house\",\"properties\":{\"closed\":0,\"label\":\"Maori House\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753622.10631534,5140958.046617024],[-9753612.610966777,5140956.9457070455],[-9753615.167930026,5140934.891899032],[-9753624.663278589,5140935.99280901],[-9753622.10631534,5140958.046617024]]]]}},{\"type\":\"Feature\",\"id\":\"closed_next_to_maori\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753524.685011651,5140937.27610767],[-9753518.638476979,5140937.387809375],[-9753518.219073404,5140914.68503815],[-9753524.311992569,5140914.572479553],[-9753524.056330007,5140900.646576322],[-9753604.649909299,5140899.149926858],[-9753604.516244208,5140894.50584267],[-9753624.759478118,5140894.120713468],[-9753625.489116332,5140933.522002735],[-9753609.661470719,5140931.440229899],[-9753609.982805323,5140941.922618041],[-9753599.064995041,5140942.342610193],[-9753598.770972107,5140935.889577066],[-9753524.685011651,5140937.27610767]]]]}},{\"type\":\"Feature\",\"id\":\"closed1\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753600.034041231,5141004.865628583],[-9753562.965740563,5141005.550416259],[-9753525.894270694,5141006.235264038],[-9753526.014684154,5141012.584658619],[-9753520.284074204,5141012.6933371015],[-9753520.069549505,5141001.066048587],[-9753520.067451742,5141000.9324910045],[-9753519.912953973,5140992.538362299],[-9753519.762144716,5140984.363799927],[-9753525.761062024,5140984.253278819],[-9753525.8629542,5140989.783830795],[-9753600.034041231,5140988.417339081],[-9753600.034041231,5141004.865628583]]]]}},{\"type\":\"Feature\",\"id\":\"tibet\",\"properties\":{\"closed\":0,\"label\":\"Tibet\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753520.284074204,5141012.6933371015],[-9753517.587421004,5141012.743154191],[-9753517.6013836,5141013.498964701],[-9753515.144337356,5141015.644353565],[-9753509.719959898,5141015.687633172],[-9753507.432001466,5141009.450503003],[-9753506.63591793,5141009.40367456],[-9753506.153431676,5140983.631807086],[-9753507.799481427,5140982.162119808],[-9753509.680681145,5140981.574244897],[-9753511.385518387,5140981.397882423],[-9753513.234765373,5140981.2065810105],[-9753515.794580223,5140981.926969843],[-9753518.71653314,5140982.39988974],[-9753519.724052994,5140982.396721891],[-9753519.762144716,5140984.363799927],[-9753519.912953973,5140992.538362299],[-9753520.067451742,5141000.9324910045],[-9753520.069549505,5141001.066048587],[-9753520.284074204,5141012.6933371015]]]]}},{\"type\":\"Feature\",\"id\":\"evolving_planet\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753443.295667004,5140979.253517448],[-9753453.785705153,5140979.081549479],[-9753453.88409655,5140985.08342012],[-9753443.3940584,5140985.255388089],[-9753443.48531504,5140990.822038816],[-9753379.976766158,5140991.86316336],[-9753379.87056468,5140985.38487822],[-9753378.699916195,5140985.404069194],[-9753378.847128272,5140992.95692705],[-9753450.111412527,5140991.949805213],[-9753450.335162358,5141007.438363596],[-9753380.97224724,5141008.6156721525],[-9753380.83541513,5141000.998115007],[-9753376.384712847,5140996.480843554],[-9753373.13373521,5140996.574683759],[-9753369.311517015,5140992.947708333],[-9753369.019724095,5140985.502951102],[-9753363.309901692,5140985.420200053],[-9753363.620260395,5140999.577578478],[-9753363.979787868,5140999.565291671],[-9753363.79639282,5140993.166864396],[-9753369.075874263,5140993.114591099],[-9753380.40780789,5141003.407351909],[-9753380.52397071,5141008.60296575],[-9753374.41564617,5141008.737503039],[-9753374.417425498,5141009.638021217],[-9753443.696929036,5141008.408259262],[-9753444.149875514,5141029.05947096],[-9753370.673806524,5141030.263996679],[-9753370.47025958,5141009.727321573],[-9753363.873807576,5141009.746837548],[-9753364.081583722,5141034.230408727],[-9753343.845329542,5141034.614892678],[-9753342.424586864,5140959.796443607],[-9753362.593281955,5140959.38559472],[-9753362.943379886,5140974.169955638],[-9753443.19076375,5140972.854423752],[-9753443.295667004,5140979.253517448]]]]}},{\"type\":\"Feature\",\"id\":\"china\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753368.527696764,5140951.011873181],[-9753368.470600817,5140947.529023151],[-9753368.356865827,5140940.5911939945],[-9753442.47161045,5140939.376197254],[-9753442.756066456,5140956.728000421],[-9753368.641321834,5140957.942997161],[-9753368.527696764,5140951.011873181]]]]}},{\"type\":\"Feature\",\"id\":\"plants\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753367.876117466,5140916.309872022],[-9753361.817016518,5140916.407305178],[-9753362.213543849,5140941.066253186],[-9753342.085296191,5140941.3899247525],[-9753341.536207095,5140911.601841323],[-9753361.73451952,5140911.277043083],[-9753361.76533312,5140913.193256356],[-9753367.824181268,5140913.095827265],[-9753367.66934444,5140903.513830308],[-9753441.581126742,5140902.319479492],[-9753441.906073706,5140922.428654245],[-9753367.994291404,5140923.623005061],[-9753367.876117466,5140916.309872022]]]]}},{\"type\":\"Feature\",\"id\":\"gems\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753520.436209708,5140900.713844344],[-9753506.025473244,5140901.042540614],[-9753505.59499391,5140882.169420276],[-9753520.005730374,5140881.840724006],[-9753520.436209708,5140900.713844344]]]]}},{\"type\":\"Feature\",\"id\":\"jades\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753445.57811896,5140902.073252767],[-9753445.283580463,5140883.290759664],[-9753459.740397729,5140883.064054444],[-9753460.034936225,5140901.846547548],[-9753445.57811896,5140902.073252767]]]]}},{\"type\":\"Feature\",\"id\":\"closed2\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753361.73451952,5140911.277043083],[-9753341.536207095,5140911.601841323],[-9753341.311492564,5140899.411077929],[-9753361.521364525,5140899.071225817],[-9753361.73451952,5140911.277043083]]]]}},{\"type\":\"Feature\",\"id\":\"closed3\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753442.47161045,5140939.376197254],[-9753368.356865827,5140940.5911939945],[-9753368.470600817,5140947.529023151],[-9753362.320717324,5140947.647303684],[-9753361.817016518,5140916.407305178],[-9753367.876117466,5140916.309872022],[-9753367.994291404,5140923.623005061],[-9753441.906073706,5140922.428654245],[-9753442.47161045,5140939.376197254]]]]}},{\"type\":\"Feature\",\"id\":\"closed4\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753443.19076375,5140972.854423752],[-9753362.943379886,5140974.169955638],[-9753362.593281955,5140959.38559472],[-9753362.547194472,5140958.04108785],[-9753362.377436217,5140951.130160965],[-9753368.527696764,5140951.011873181],[-9753368.641321834,5140957.942997161],[-9753442.756066456,5140956.728000421],[-9753443.19076375,5140972.854423752]]]]}},{\"type\":\"Feature\",\"id\":\"closed5\",\"properties\":{\"closed\":1,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753362.593281955,5140959.38559472],[-9753342.424586864,5140959.796443607],[-9753342.398344086,5140958.372772923],[-9753362.547194472,5140958.04108785],[-9753362.593281955,5140959.38559472]]]]}},{\"type\":\"Feature\",\"id\":\"closed6\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753522.985100504,5141045.864679188],[-9753500.989227334,5141046.23173022],[-9753500.836293887,5141037.067051736],[-9753522.832167057,5141036.700000703],[-9753522.985100504,5141045.864679188]]]]}},{\"type\":\"Feature\",\"id\":\"brooker_gallery\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753448.410219848,5141047.258072831],[-9753448.19498018,5141038.127379559],[-9753470.057296634,5141037.612014778],[-9753470.272536302,5141046.74270805],[-9753448.410219848,5141047.258072831]]]]}},{\"type\":\"Feature\",\"id\":\"closed7\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753518.905160245,5140973.402544048],[-9753513.262714231,5140973.506780752],[-9753512.899464836,5140953.843696497],[-9753518.54191085,5140953.739459793],[-9753518.570659408,5140955.295650509],[-9753518.87316698,5140971.6707139285],[-9753518.905160245,5140973.402544048]]]]}},{\"type\":\"Feature\",\"id\":\"dna_lab\",\"properties\":{\"closed\":0,\"label\":\"DNA\\nLab\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753513.262714231,5140973.506780752],[-9753506.710129926,5140973.627831054],[-9753506.346880531,5140953.964746799],[-9753512.899464836,5140953.843696497],[-9753513.262714231,5140973.506780752]]]]}},{\"type\":\"Feature\",\"id\":\"closed8\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753570.321762247,5140970.845030345],[-9753525.528373422,5140971.67260988],[-9753518.87316698,5140971.6707139285],[-9753518.570659408,5140955.295650509],[-9753525.016417347,5140955.215457955],[-9753570.018032,5140954.38411283],[-9753570.321762247,5140970.845030345]]]]}},{\"type\":\"Feature\",\"id\":\"closed9\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753473.906379094,5140902.1737272795],[-9753473.919390358,5140902.024578352],[-9753473.999190103,5140901.418591406],[-9753474.12151021,5140900.819737526],[-9753474.285742048,5140900.230996426],[-9753474.491068453,5140899.655297507],[-9753474.73646778,5140899.09550527],[-9753475.020719,5140898.554405073],[-9753475.34240776,5140898.034689265],[-9753475.699933436,5140897.538943797],[-9753476.09151709,5140897.069635348],[-9753476.51521032,5140896.629099054],[-9753476.968904953,5140896.219526891],[-9753477.450343546,5140895.842956765],[-9753477.434391463,5140894.349722409],[-9753480.90034361,5140894.257860358],[-9753480.914858678,5140895.37934748],[-9753479.391819835,5140895.701486242],[-9753478.380059978,5140896.207366171],[-9753477.826001007,5140896.761425141],[-9753476.88650971,5140897.604558356],[-9753476.043376496,5140898.688586776],[-9753475.489317525,5140900.06168944],[-9753475.200243281,5140900.8325540945],[-9753474.959348075,5140901.579329228],[-9753474.832319997,5140905.605066906],[-9753477.624641545,5140905.580551205],[-9753477.633284844,5140902.398372922],[-9753477.690468572,5140901.382010915],[-9753477.776438147,5140901.049522146],[-9753478.211433334,5140900.326674165],[-9753478.698591897,5140899.566772779],[-9753479.74742725,5140898.746573464],[-9753480.772504251,5140898.281926436],[-9753481.906629872,5140898.003535022],[-9753483.093091143,5140897.925320433],[-9753484.272558011,5140898.051193859],[-9753485.38605018,5140898.374860887],[-9753486.377886474,5140898.880136258],[-9753487.198469236,5140899.541753225],[-9753487.80676449,5140900.326627039],[-9753488.61810616,5140901.916582514],[-9753488.851751642,5140905.375764044],[-9753491.38103761,5140905.354686661],[-9753491.171595328,5140901.772045392],[-9753490.545857823,5140899.864713884],[-9753490.10767339,5140899.0640249085],[-9753489.89346243,5140898.623490273],[-9753489.647793287,5140898.262770991],[-9753489.383622097,5140897.915373078],[-9753489.101669764,5140897.582244557],[-9753488.80270572,5140897.264294516],[-9753488.487545818,5140896.962390618],[-9753488.157050105,5140896.677356739],[-9753487.812120484,5140896.409970717],[-9753487.453698244,5140896.16096223],[-9753487.082761496,5140895.931010806],[-9753486.700322501,5140895.720743967],[-9753486.307424909,5140895.530735518],[-9753485.077889942,5140895.255540776],[-9753485.095270645,5140894.156548486],[-9753488.041087056,5140894.148054565],[-9753488.073034419,5140895.641031568],[-9753488.575307172,5140896.009066979],[-9753489.049852604,5140896.412222796],[-9753489.494220143,5140896.848417101],[-9753489.90611505,5140897.315397365],[-9753490.283410277,5140897.810752077],[-9753490.624157457,5140898.331923202],[-9753490.92659695,5140898.876219383],[-9753491.189166944,5140899.44082985],[-9753491.410511516,5140900.022838923],[-9753491.589487629,5140900.619241078],[-9753491.725171043,5140901.226956466],[-9753491.816861082,5140901.842846812],[-9753497.483246459,5140901.738175935],[-9753499.779377181,5141026.030225943],[-9753470.719322216,5141026.5670719035],[-9753468.423191493,5140902.275021896],[-9753473.906379094,5140902.1737272795]]]]}},{\"type\":\"Feature\",\"id\":\"closed10\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753504.397878932,5140882.159310702],[-9753499.119832681,5140882.252865437],[-9753498.99721111,5140875.334965191],[-9753504.27525736,5140875.241410456],[-9753504.397878932,5140882.159310702]]]]}},{\"type\":\"Feature\",\"id\":\"open1\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753466.51956527,5140882.830713606],[-9753461.060609734,5140882.927475005],[-9753460.9388513,5140876.0582701815],[-9753466.397806836,5140875.961508783],[-9753466.51956527,5140882.830713606]]]]}},{\"type\":\"Feature\",\"id\":\"closed11\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753510.790122272,5141001.078208223],[-9753513.514231075,5141001.035421173],[-9753520.067451742,5141000.9324910045],[-9753520.106674759,5141003.429689738],[-9753513.553454092,5141003.532619907],[-9753513.696034048,5141012.610210549],[-9753510.971925247,5141012.652997598],[-9753510.82934529,5141003.5754069565],[-9753510.790122272,5141001.078208223]]],[[[-9753510.697438769,5140995.1773585025],[-9753510.658271732,5140992.683723801],[-9753510.517993158,5140983.752654494],[-9753513.242101958,5140983.709867445],[-9753513.382380534,5140992.640936752],[-9753519.912953973,5140992.538362299],[-9753519.95212101,5140995.031997001],[-9753513.421547571,5140995.134571454],[-9753510.697438769,5140995.1773585025]]]]}},{\"type\":\"Feature\",\"id\":\"spirit_stone_garden\",\"properties\":{\"closed\":0,\"label\":\"Spirit Stone\\nGarden\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753362.320717324,5140947.647303684],[-9753362.377436217,5140951.130160965],[-9753362.547194472,5140958.04108785],[-9753342.398344086,5140958.372772923],[-9753342.085296191,5140941.3899247525],[-9753362.213543849,5140941.066253186],[-9753362.320717324,5140947.647303684]]]]}},{\"type\":\"Feature\",\"id\":\"open2\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753500.836293887,5141037.067051736],[-9753500.766616715,5141033.295350742],[-9753494.62398725,5141033.408827672],[-9753494.693664422,5141037.180528666],[-9753500.836293887,5141037.067051736]]]]}},{\"type\":\"Feature\",\"id\":\"open3\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753470.057296634,5141037.612014778],[-9753469.990467625,5141033.994487954],[-9753476.12198987,5141033.881216215],[-9753476.18881888,5141037.498743039],[-9753470.057296634,5141037.612014778]]]]}},{\"type\":\"Feature\",\"id\":\"fossil_lab\",\"properties\":{\"closed\":0,\"label\":\"Fossil\\nLab\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753450.411208188,5141011.734952981],[-9753454.695231298,5141011.734952981],[-9753454.695231298,5141006.14709675],[-9753458.047945036,5141002.421859263],[-9753451.435648497,5140995.995824598],[-9753450.131815376,5140995.949259129],[-9753450.411208188,5141011.734952981]]]]}},{\"type\":\"Feature\",\"id\":\"open4\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753461.620387089,5140989.242931941],[-9753453.948645273,5140989.368698295],[-9753453.712041825,5140974.935898862],[-9753461.38378364,5140974.810132507],[-9753461.620387089,5140989.242931941]]]]}},{\"type\":\"Feature\",\"id\":\"closed12\",\"properties\":{\"closed\":2,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753370.673806524,5141030.263996679],[-9753364.048887642,5141030.3776238635],[-9753363.873807576,5141009.746837548],[-9753370.47025958,5141009.727321573],[-9753370.673806524,5141030.263996679]]]]}},{\"type\":\"Feature\",\"id\":\"marae_gallery\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753626.387010373,5140982.00929684],[-9753612.219799701,5140982.271017261],[-9753611.99011877,5140970.0602744715],[-9753626.160802094,5140969.793727563],[-9753626.39057255,5140982.009229836],[-9753626.387010373,5140982.00929684]]]]}},{\"type\":\"Feature\",\"id\":\"comer_gallery\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753626.387010373,5140982.00929684],[-9753612.219799701,5140982.00929684],[-9753612.219799701,5141008.251237071],[-9753619.943532616,5141015.974969987],[-9753627.015989017,5141015.9765625],[-9753626.387010373,5140982.00929684]]]]}},{\"type\":\"Feature\",\"id\":\"hoffman\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753448.923616,5140938.326334272],[-9753448.549106322,5140915.149996649],[-9753460.948412627,5140914.949634526],[-9753461.321614731,5140938.04505372],[-9753448.923616,5140938.326334272]]]]}},{\"type\":\"Feature\",\"id\":\"meteorites\",\"properties\":{\"closed\":0,\"label\":\"Meteorites\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753466.728468187,5140901.2581461165],[-9753466.729337282,5140901.303615586],[-9753474.047740191,5140901.168311072],[-9753477.434391463,5140894.349722409],[-9753466.63501788,5140894.5493840035],[-9753466.728468187,5140901.2581461165]]],[[[-9753499.652535178,5140900.602610167],[-9753492.224569239,5140900.7405499555],[-9753488.041087056,5140894.148054565],[-9753499.48349231,5140894.074198688],[-9753499.652535178,5140900.602610167]]],[[[-9753518.889366735,5140940.49910068],[-9753506.427456005,5140940.783345943],[-9753505.634909218,5140906.03642633],[-9753518.096819948,5140905.752181067],[-9753518.889366735,5140940.49910068]]]]}},{\"type\":\"Feature\",\"id\":\"pacific_marketplace\",\"properties\":{\"closed\":0,\"label\":\"Pacific\\nMarketplace\"},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753588.528955238,5140970.508676611],[-9753588.185153423,5140954.028448995],[-9753604.892911477,5140953.6799005605],[-9753605.23950286,5140970.189281314],[-9753588.528955238,5140970.508676611]]]]}},{\"type\":\"Feature\",\"id\":\"north_lounge\",\"properties\":{\"closed\":0,\"label\":null},\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753494.693664422,5141037.180528666],[-9753476.18881888,5141037.498743039],[-9753475.999157643,5141026.469536978],[-9753494.504003186,5141026.151322605],[-9753494.693664422,5141037.180528666]]]]}}]}");

});

parcelRegister("9p6EU", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"upper_level_labels\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"id\":\"restoring_earth\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753548.230638964,5141014.814040667]}},{\"type\":\"Feature\",\"id\":\"pacific\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753547.954493625,5140980.372427206]}},{\"type\":\"Feature\",\"id\":\"evolving_planet\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753418.095792701,5141019.29764095]}},{\"type\":\"Feature\",\"id\":\"china\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753424.314138172,5140948.318745065]}},{\"type\":\"Feature\",\"id\":\"plants\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753423.288191639,5140913.21563791]}},{\"type\":\"Feature\",\"id\":\"jades\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753444.028104778,5140892.304086741]}},{\"type\":\"Feature\",\"id\":\"gems\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753521.822038451,5140891.065686973]}},{\"type\":\"Feature\",\"id\":\"hoffman\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753468.875462547,5140926.756945307]}},{\"type\":\"Feature\",\"id\":\"comer_gallery\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753622.33637829,5140995.532506266]}},{\"type\":\"Feature\",\"id\":\"marae_gallery\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753622.10631534,5140958.046617024]}},{\"type\":\"Feature\",\"id\":\"sue\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753397.06503626,5141000.451720538]}},{\"type\":\"Feature\",\"id\":\"brooker_gallery\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753459.233758241,5141042.435043804]}},{\"type\":\"Feature\",\"id\":\"searle_lounge\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753485.465985898,5141022.216576614]}},{\"type\":\"Feature\",\"id\":\"maori_house\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753618.637122683,5140946.469258027]}},{\"type\":\"Feature\",\"id\":\"conservation_lab\",\"properties\":{},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753590.74593376,5140944.082844877]}}]}");

});

parcelRegister("jq6OK", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"upper_level_amenities\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"properties\":{\"type\":\"restroom_female\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753497.730140567,5141035.237939704]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"restroom_male\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753473.089643253,5141035.746615496]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"store\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753457.666214457,5140982.0894154]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"elevator\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753439.539570265,5140953.43172601]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"restroom_female\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753463.688776206,5140879.32009448]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"elevator\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753521.761307439,5140951.741074014]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753603.44665459,5141020.293263434]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753523.58235728,5141023.322387284]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753507.951155886,5141031.493801811]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753462.252888804,5141032.213023931]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753521.284427516,5140908.230195204]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753482.72305687,5140896.61199171]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753444.659609228,5140908.451494319]}},{\"type\":\"Feature\",\"properties\":{\"type\":\"stairs_down\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753365.084405726,5140908.559183305]}}]}");

});

parcelRegister("iwyia", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"upper_level_flows\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"properties\":{\"id\":\"evolving_planet\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753452.917340655,5141018.536599553],[-9753443.800053287,5141018.733865103],[-9753372.611154342,5141020.295263132],[-9753372.235940496,5141003.188119226],[-9753360.343167216,5141003.448965414],[-9753360.927149085,5141030.074480134],[-9753346.27437401,5141030.395861904],[-9753344.79449657,5140962.923735097],[-9753358.486908596,5140962.623417136],[-9753359.005755201,5140983.728923803],[-9753370.031911802,5140983.487085262],[-9753370.096915571,5140989.001097969],[-9753382.365076538,5141000.197967534],[-9753382.465660445,5141005.825956087],[-9753441.679927025,5141004.756591206],[-9753441.524555137,5140996.969505],[-9753382.753430802,5140998.025195117],[-9753372.745620731,5140989.2084019175],[-9753372.583002428,5140983.320136213],[-9753451.282049444,5140982.068689609]]]},\"id\":\"evolving_planet\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"restoring_earth\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753514.380928978,5141021.492198718],[-9753518.679737257,5141015.469339833],[-9753598.686611425,5141013.695165955]]]},\"id\":\"restoring_earth\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"pacific\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753513.95889204,5140945.137056733],[-9753577.697528655,5140943.9441779535],[-9753577.925654542,5140956.133541389],[-9753603.71979548,5140955.593069016],[-9753603.859955082,5140968.594200067],[-9753577.966041328,5140969.136539705],[-9753578.268863581,5140979.80508892],[-9753522.719157623,5140980.844710558]]]},\"id\":\"pacific\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"china\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753450.562027287,5140947.888451408],[-9753360.825392326,5140949.359545126]]]},\"id\":\"china\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"jades\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753464.289922126,5140905.184086834],[-9753464.063821392,5140893.354907503],[-9753457.386832016,5140893.48253023],[-9753457.48492825,5140898.614747139],[-9753448.027833499,5140898.795508291],[-9753447.782740153,5140885.972669907],[-9753456.73679947,5140885.80152368],[-9753456.812107291,5140889.7414923925],[-9753463.649166377,5140889.610810122],[-9753463.579437716,5140885.962733213]]]},\"id\":\"jades\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"gems\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753501.803129716,5140903.561905522],[-9753501.623190537,5140894.533652699],[-9753507.896323921,5140894.408624912],[-9753507.98201351,5140898.708007033],[-9753518.165604318,5140898.505041171],[-9753517.874998817,5140883.924226176],[-9753507.449295307,5140884.132017505],[-9753507.544179978,5140888.892752854],[-9753501.573076572,5140889.011760982],[-9753501.501054924,5140885.398153081]]]},\"id\":\"gems\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"plants\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753450.038483743,5140912.777108131],[-9753351.329736616,5140914.39528579],[-9753351.792164888,5140942.603384688]]]},\"id\":\"plants\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"comer_gallery\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753609.76457138,5140985.835593981],[-9753624.058665572,5140985.570907383],[-9753624.438665276,5141006.092352868],[-9753610.834111579,5141006.344271106]]]},\"id\":\"comer_gallery\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"marae_gallery\"},\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[-9753623.679754268,5140967.074199479],[-9753623.9093627,5140979.473314544],[-9753608.715375543,5140979.754678782]]]},\"id\":\"marae_gallery\"}]}");

});

parcelRegister("c4azL", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"upper_level_pictograms\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"properties\":{\"id\":\"stone_lion\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753455.007197991,5140963.491790502]},\"id\":\"stone_lion\"},{\"type\":\"Feature\",\"id\":\"sue\",\"properties\":{\"id\":\"sue\",\"label\":\"SUE the T. rex\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753415.70459409,5140999.929715652]}},{\"type\":\"Feature\",\"properties\":{\"id\":\"trike\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753360.544303231,5140993.9080106765]},\"id\":\"trike\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"maori_house\",\"label\":\"Maori\\nHouse\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753618.928280002,5140942.947180382]},\"id\":\"maori_house\"}]}");

});

parcelRegister("88e73", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"upper_level_outline\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-9753499.119832681,5140882.252865437],[-9753498.99721111,5140875.334965191],[-9753504.27525736,5140875.241410456],[-9753504.397878932,5140882.159310702],[-9753505.75459869,5140882.135262494],[-9753520.005730372,5140881.840724009],[-9753520.436209707,5140900.713844343],[-9753604.649909299,5140899.149926858],[-9753604.515620952,5140894.47189398],[-9753624.759478115,5140894.120713461],[-9753627.263055293,5141029.316713676],[-9753607.058847541,5141029.665062087],[-9753607.063939754,5141025.976314691],[-9753522.679233605,5141027.535322215],[-9753522.9851005,5141045.864679184],[-9753500.989227334,5141046.23173022],[-9753500.836293887,5141037.067051736],[-9753470.057296634,5141037.612014778],[-9753470.272536302,5141046.74270805],[-9753448.410219844,5141047.258072832],[-9753447.97974051,5141028.996686283],[-9753363.97362249,5141030.378862222],[-9753364.081583722,5141034.230408727],[-9753343.803741354,5141034.615574449],[-9753342.425458858,5140959.843749279],[-9753341.31149256,5140899.4110779315],[-9753361.521364525,5140899.071225817],[-9753361.622032342,5140903.625476609],[-9753445.578118956,5140902.073252767],[-9753445.283580465,5140883.290759662],[-9753459.738623409,5140882.9509075545],[-9753461.060609734,5140882.927475005],[-9753460.9388513,5140876.0582701815],[-9753466.397806836,5140875.961508783],[-9753466.51956527,5140882.830713606],[-9753499.119832681,5140882.252865437]]]]}}]}");

});

parcelRegister("fwaDN", function(module, exports) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"name\":\"upper_level_easter\",\"crs\":{\"type\":\"name\",\"properties\":{\"name\":\"urn:ogc:def:crs:EPSG::3857\"}},\"features\":[{\"type\":\"Feature\",\"properties\":{\"id\":\"tardigrade\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753367.994291404,5140923.623005061]},\"id\":\"tardigrade\"},{\"type\":\"Feature\",\"properties\":{\"id\":\"eye_of_the_lion\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[-9753455.007197991,5140963.491790502]},\"id\":\"eye_of_the_lion\"}]}");

});

parcelRegister("2AGdU", function(module, exports) {
module.exports = $parcel$resolve("taUvU");

});

parcelRegister("dxhQh", function(module, exports) {
module.exports = $parcel$resolve("7btVQ");

});

parcelRegister("90N3t", function(module, exports) {
module.exports = $parcel$resolve("eYfKA");

});

parcelRegister("7tgBd", function(module, exports) {
module.exports = $parcel$resolve("hyWU0");

});

parcelRegister("eNxXC", function(module, exports) {
module.exports = $parcel$resolve("eXqhT");

});

parcelRegister("cZ3ts", function(module, exports) {
module.exports = $parcel$resolve("gFDK6");

});

parcelRegister("bSt4G", function(module, exports) {
module.exports = $parcel$resolve("m1aV9");

});

parcelRegister("9aQ7c", function(module, exports) {
module.exports = $parcel$resolve("8PWfv");

});

parcelRegister("9JHfT", function(module, exports) {
module.exports = $parcel$resolve("eo2a8");

});

parcelRegister("jb1md", function(module, exports) {
module.exports = $parcel$resolve("lzgkH");

});

parcelRegister("1k6qE", function(module, exports) {
module.exports = $parcel$resolve("hmxPY");

});

parcelRegister("1DlVp", function(module, exports) {
module.exports = $parcel$resolve("5xr59");

});

parcelRegister("kaL7w", function(module, exports) {
module.exports = $parcel$resolve("2QlPi");

});

parcelRegister("DczzH", function(module, exports) {
module.exports = $parcel$resolve("jR9X7");

});

parcelRegister("8cFji", function(module, exports) {
module.exports = $parcel$resolve("3LHkL");

});

parcelRegister("384Xa", function(module, exports) {
module.exports = $parcel$resolve("8kqpb");

});

parcelRegister("iRhd6", function(module, exports) {
module.exports = $parcel$resolve("4DNVz");

});

parcelRegister("18Ryp", function(module, exports) {
module.exports = $parcel$resolve("6rJmi");

});

parcelRegister("9fa7R", function(module, exports) {
module.exports = $parcel$resolve("6NdmJ");

});

parcelRegister("6Awgk", function(module, exports) {
module.exports = $parcel$resolve("4i7hZ");

});

parcelRegister("1qupS", function(module, exports) {
module.exports = $parcel$resolve("im1Bd");

});

parcelRegister("lPfbX", function(module, exports) {
module.exports = $parcel$resolve("6LbLU");

});

parcelRegister("5xWGq", function(module, exports) {
module.exports = $parcel$resolve("7Iw9q");

});

parcelRegister("bqkno", function(module, exports) {
module.exports = $parcel$resolve("jA36K");

});

parcelRegister("9GflJ", function(module, exports) {
module.exports = $parcel$resolve("hyOfJ");

});

parcelRegister("2c5rJ", function(module, exports) {
module.exports = $parcel$resolve("2LUzy");

});

parcelRegister("lCHsg", function(module, exports) {
module.exports = $parcel$resolve("fcHnB");

});

parcelRegister("cALjL", function(module, exports) {
module.exports = $parcel$resolve("dWGx6");

});

parcelRegister("hpcON", function(module, exports) {
module.exports = $parcel$resolve("9YQUY");

});

var $222d41d1613bcc0f$exports = {};
$parcel$extendImportMap({
    "taUvU": "atm.d057ca95.svg",
    "7btVQ": "picnic_area.eb4bbc8b.svg",
    "eYfKA": "elevator.f73714ac.svg",
    "hyWU0": "first_aid.1f673138.svg",
    "eXqhT": "guest_services.ae83872d.svg",
    "gFDK6": "restaurant.1e678800.svg",
    "m1aV9": "restroom.8c3209aa.svg",
    "8PWfv": "restroom_female.c8fc07ae.svg",
    "eo2a8": "restroom_male.c75e65b6.svg",
    "lzgkH": "stairs_down.e5a05770.svg",
    "hmxPY": "stairs_up.fe20d36e.svg",
    "5xr59": "stairs_up_down.b15bab30.svg",
    "2QlPi": "store.53dc25b8.svg",
    "jR9X7": "stroller.2bcbb14f.svg",
    "3LHkL": "wheelchair.02fe6ee1.svg",
    "8kqpb": "tardigrade.62214d3e.svg",
    "4DNVz": "bird.f0d51a0c.svg",
    "6rJmi": "maximo.5f6b3e16.svg",
    "6NdmJ": "lion.30b823db.svg",
    "4i7hZ": "totems.f359dfc3.svg",
    "im1Bd": "elephant.2914d77d.svg",
    "6LbLU": "mask.008299db.svg",
    "7Iw9q": "pawnee_lodge.d56bd90f.svg",
    "jA36K": "bushman.9c9b5dd0.svg",
    "hyOfJ": "sarcophagus.b60da030.svg",
    "2LUzy": "sue.bbd07ec5.svg",
    "fcHnB": "trike.48fb1108.svg",
    "dWGx6": "stone_lion.5463ec13.svg",
    "9YQUY": "maori_house.6c6f0d17.svg"
});


var $fy27o = parcelRequire("fy27o");

var $c8IGo = parcelRequire("c8IGo");

var $61DUI = parcelRequire("61DUI");
/**
 * @module ol/transform
 */ 
var $bInFo = parcelRequire("bInFo");

var $3JLp3 = parcelRequire("3JLp3");
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ var $04c1ab69f17a669b$var$tmp_ = new Array(6);
function $04c1ab69f17a669b$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $04c1ab69f17a669b$export$aad8462122ac592b(transform) {
    return $04c1ab69f17a669b$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $04c1ab69f17a669b$export$2060d2db72cce88f(transform1, transform2) {
    var a1 = transform1[0];
    var b1 = transform1[1];
    var c1 = transform1[2];
    var d1 = transform1[3];
    var e1 = transform1[4];
    var f1 = transform1[5];
    var a2 = transform2[0];
    var b2 = transform2[1];
    var c2 = transform2[2];
    var d2 = transform2[3];
    var e2 = transform2[4];
    var f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $04c1ab69f17a669b$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $04c1ab69f17a669b$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $04c1ab69f17a669b$export$5635d7ef4b8fee1c(transform, coordinate) {
    var x = coordinate[0];
    var y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $04c1ab69f17a669b$export$bb628a54ab399bc9(transform, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    return $04c1ab69f17a669b$export$2060d2db72cce88f(transform, $04c1ab69f17a669b$export$adaa4cf7ef1b65be($04c1ab69f17a669b$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $04c1ab69f17a669b$export$dcdf75081b88279d(transform, x, y) {
    return $04c1ab69f17a669b$export$2060d2db72cce88f(transform, $04c1ab69f17a669b$export$adaa4cf7ef1b65be($04c1ab69f17a669b$var$tmp_, x, 0, 0, y, 0, 0));
}
function $04c1ab69f17a669b$export$3e4e33ea14aeb531(target, x, y) {
    return $04c1ab69f17a669b$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $04c1ab69f17a669b$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $04c1ab69f17a669b$export$2060d2db72cce88f(transform, $04c1ab69f17a669b$export$adaa4cf7ef1b65be($04c1ab69f17a669b$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $04c1ab69f17a669b$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    var sin = Math.sin(angle);
    var cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $04c1ab69f17a669b$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $04c1ab69f17a669b$export$f84e8e69fd4488a5($04c1ab69f17a669b$export$f672e0b6f7222cd7($04c1ab69f17a669b$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $04c1ab69f17a669b$export$6897c284b6f9f4dc(source) {
    return $04c1ab69f17a669b$export$bd70ea2a93c0fa4(source, source);
}
function $04c1ab69f17a669b$export$bd70ea2a93c0fa4(target, source) {
    var det = $04c1ab69f17a669b$export$a04698f914c55ed9(source);
    (0, $3JLp3.assert)(det !== 0, 32); // Transformation matrix cannot be inverted
    var a = source[0];
    var b = source[1];
    var c = source[2];
    var d = source[3];
    var e = source[4];
    var f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $04c1ab69f17a669b$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {HTMLElement}
 * @private
 */ var $04c1ab69f17a669b$var$transformStringDiv;
function $04c1ab69f17a669b$export$f84e8e69fd4488a5(mat) {
    var transformString = 'matrix(' + mat.join(', ') + ')';
    if (0, $bInFo.WORKER_OFFSCREEN_CANVAS) return transformString;
    var node = $04c1ab69f17a669b$var$transformStringDiv || ($04c1ab69f17a669b$var$transformStringDiv = document.createElement('div'));
    node.style.transform = transformString;
    return node.style.transform;
}



var $2Jl0K = parcelRequire("2Jl0K");
/**
 * @module ol/style/IconImageCache
 */ /**
 * @module ol/color
 */ 
var $3JLp3 = parcelRequire("3JLp3");

var $7aO1A = parcelRequire("7aO1A");
/**
 * A color represented as a short array [red, green, blue, alpha].
 * red, green, and blue should be integers in the range 0..255 inclusive.
 * alpha should be a float in the range 0..1 inclusive. If no alpha value is
 * given then `1` will be used.
 * @typedef {Array<number>} Color
 * @api
 */ /**
 * This RegExp matches # followed by 3, 4, 6, or 8 hex digits.
 * @const
 * @type {RegExp}
 * @private
 */ var $520f75f61db85ab0$var$HEX_COLOR_RE_ = /^#([a-f0-9]{3}|[a-f0-9]{4}(?:[a-f0-9]{2}){0,2})$/i;
/**
 * Regular expression for matching potential named color style strings.
 * @const
 * @type {RegExp}
 * @private
 */ var $520f75f61db85ab0$var$NAMED_COLOR_RE_ = /^([a-z]*)$|^hsla?\(.*\)$/i;
function $520f75f61db85ab0$export$590567be997858b6(color) {
    if (typeof color === 'string') return color;
    else return $520f75f61db85ab0$export$f84e8e69fd4488a5(color);
}
/**
 * Return named color as an rgba string.
 * @param {string} color Named color.
 * @return {string} Rgb string.
 */ function $520f75f61db85ab0$var$fromNamed(color) {
    var el = document.createElement('div');
    el.style.color = color;
    if (el.style.color !== '') {
        document.body.appendChild(el);
        var rgb = getComputedStyle(el).color;
        document.body.removeChild(el);
        return rgb;
    } else return '';
}
var $520f75f61db85ab0$export$3004f64547af360e = function() {
    // We maintain a small cache of parsed strings.  To provide cheap LRU-like
    // semantics, whenever the cache grows too large we simply delete an
    // arbitrary 25% of the entries.
    /**
     * @const
     * @type {number}
     */ var MAX_CACHE_SIZE = 1024;
    /**
     * @type {Object<string, Color>}
     */ var cache = {};
    /**
     * @type {number}
     */ var cacheSize = 0;
    return(/**
     * @param {string} s String.
     * @return {Color} Color.
     */ function(s) {
        var color;
        if (cache.hasOwnProperty(s)) color = cache[s];
        else {
            if (cacheSize >= MAX_CACHE_SIZE) {
                var i = 0;
                for(var key in cache)if ((i++ & 3) === 0) {
                    delete cache[key];
                    --cacheSize;
                }
            }
            color = $520f75f61db85ab0$var$fromStringInternal_(s);
            cache[s] = color;
            ++cacheSize;
        }
        return color;
    });
}();
function $520f75f61db85ab0$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    else return $520f75f61db85ab0$export$3004f64547af360e(color);
}
/**
 * @param {string} s String.
 * @private
 * @return {Color} Color.
 */ function $520f75f61db85ab0$var$fromStringInternal_(s) {
    var r, g, b, a, color;
    if ($520f75f61db85ab0$var$NAMED_COLOR_RE_.exec(s)) s = $520f75f61db85ab0$var$fromNamed(s);
    if ($520f75f61db85ab0$var$HEX_COLOR_RE_.exec(s)) {
        // hex
        var n = s.length - 1; // number of hex digits
        var d = void 0; // number of digits per channel
        if (n <= 4) d = 1;
        else d = 2;
        var hasAlpha = n === 4 || n === 8;
        r = parseInt(s.substr(1 + 0 * d, d), 16);
        g = parseInt(s.substr(1 + 1 * d, d), 16);
        b = parseInt(s.substr(1 + 2 * d, d), 16);
        if (hasAlpha) a = parseInt(s.substr(1 + 3 * d, d), 16);
        else a = 255;
        if (d == 1) {
            r = (r << 4) + r;
            g = (g << 4) + g;
            b = (b << 4) + b;
            if (hasAlpha) a = (a << 4) + a;
        }
        color = [
            r,
            g,
            b,
            a / 255
        ];
    } else if (s.indexOf('rgba(') == 0) {
        // rgba()
        color = s.slice(5, -1).split(',').map(Number);
        $520f75f61db85ab0$export$a3295358bff77e(color);
    } else if (s.indexOf('rgb(') == 0) {
        // rgb()
        color = s.slice(4, -1).split(',').map(Number);
        color.push(1);
        $520f75f61db85ab0$export$a3295358bff77e(color);
    } else (0, $3JLp3.assert)(false, 14); // Invalid color
    return color;
}
function $520f75f61db85ab0$export$a3295358bff77e(color) {
    color[0] = (0, $7aO1A.clamp)(color[0] + 0.5 | 0, 0, 255);
    color[1] = (0, $7aO1A.clamp)(color[1] + 0.5 | 0, 0, 255);
    color[2] = (0, $7aO1A.clamp)(color[2] + 0.5 | 0, 0, 255);
    color[3] = (0, $7aO1A.clamp)(color[3], 0, 1);
    return color;
}
function $520f75f61db85ab0$export$f84e8e69fd4488a5(color) {
    var r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    var g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    var b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    var a = color[3] === undefined ? 1 : Math.round(color[3] * 100) / 100;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
function $520f75f61db85ab0$export$40dd713d7775a0b1(s) {
    if ($520f75f61db85ab0$var$NAMED_COLOR_RE_.test(s)) s = $520f75f61db85ab0$var$fromNamed(s);
    return $520f75f61db85ab0$var$HEX_COLOR_RE_.test(s) || s.indexOf('rgba(') === 0 || s.indexOf('rgb(') === 0;
}


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ var $cb8fc27afe912dc5$var$IconImageCache = /** @class */ function() {
    function IconImageCache() {
        /**
         * @type {!Object<string, import("./IconImage.js").default>}
         * @private
         */ this.cache_ = {};
        /**
         * @type {number}
         * @private
         */ this.cacheSize_ = 0;
        /**
         * @type {number}
         * @private
         */ this.maxCacheSize_ = 32;
    }
    /**
     * FIXME empty description for jsdoc
     */ IconImageCache.prototype.clear = function() {
        this.cache_ = {};
        this.cacheSize_ = 0;
    };
    /**
     * @return {boolean} Can expire cache.
     */ IconImageCache.prototype.canExpireCache = function() {
        return this.cacheSize_ > this.maxCacheSize_;
    };
    /**
     * FIXME empty description for jsdoc
     */ IconImageCache.prototype.expire = function() {
        if (this.canExpireCache()) {
            var i = 0;
            for(var key in this.cache_){
                var iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    --this.cacheSize_;
                }
            }
        }
    };
    /**
     * @param {string} src Src.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../color.js").Color} color Color.
     * @return {import("./IconImage.js").default} Icon image.
     */ IconImageCache.prototype.get = function(src, crossOrigin, color) {
        var key = $cb8fc27afe912dc5$var$getKey(src, crossOrigin, color);
        return key in this.cache_ ? this.cache_[key] : null;
    };
    /**
     * @param {string} src Src.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../color.js").Color} color Color.
     * @param {import("./IconImage.js").default} iconImage Icon image.
     */ IconImageCache.prototype.set = function(src, crossOrigin, color, iconImage) {
        var key = $cb8fc27afe912dc5$var$getKey(src, crossOrigin, color);
        this.cache_[key] = iconImage;
        ++this.cacheSize_;
    };
    /**
     * Set the cache size of the icon cache. Default is `32`. Change this value when
     * your map uses more than 32 different icon images and you are not caching icon
     * styles on the application level.
     * @param {number} maxCacheSize Cache max size.
     * @api
     */ IconImageCache.prototype.setSize = function(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    };
    return IconImageCache;
}();
/**
 * @param {string} src Src.
 * @param {?string} crossOrigin Cross origin.
 * @param {import("../color.js").Color} color Color.
 * @return {string} Cache key.
 */ function $cb8fc27afe912dc5$var$getKey(src, crossOrigin, color) {
    var colorString = color ? (0, $520f75f61db85ab0$export$590567be997858b6)(color) : 'null';
    return crossOrigin + ':' + src + ':' + colorString;
}
var $cb8fc27afe912dc5$export$2e2bcd8739ae039 = $cb8fc27afe912dc5$var$IconImageCache;
var $cb8fc27afe912dc5$export$747ccdf771a87ab8 = new $cb8fc27afe912dc5$var$IconImageCache();



var $1iJu5 = parcelRequire("1iJu5");

var $cFmyb = parcelRequire("cFmyb");

var $3A2O6 = parcelRequire("3A2O6");
/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $91e6c6ef4a46bd39$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
     * Triggered before a layer is rendered.
     * @event module:ol/render/Event~RenderEvent#prerender
     * @api
     */ PRERENDER: 'prerender',
    /**
     * Triggered after a layer is rendered.
     * @event module:ol/render/Event~RenderEvent#postrender
     * @api
     */ POSTRENDER: 'postrender',
    /**
     * Triggered before layers are composed.  When dispatched by the map, the event object will not have
     * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
     * WebGL layers currently dispatch this event.
     * @event module:ol/render/Event~RenderEvent#precompose
     * @api
     */ PRECOMPOSE: 'precompose',
    /**
     * Triggered after layers are composed.  When dispatched by the map, the event object will not have
     * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
     * WebGL layers currently dispatch this event.
     * @event module:ol/render/Event~RenderEvent#postcompose
     * @api
     */ POSTCOMPOSE: 'postcompose',
    /**
     * Triggered when rendering is complete, i.e. all sources and tiles have
     * finished loading for the current viewport, and all tiles are faded in.
     * The event object will not have a `context` set.
     * @event module:ol/render/Event~RenderEvent#rendercomplete
     * @api
     */ RENDERCOMPLETE: 'rendercomplete'
};



var $3JLp3 = parcelRequire("3JLp3");

var $9zTj4 = parcelRequire("9zTj4");

var $1dBX3 = parcelRequire("1dBX3");
var $93a49300d1913509$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {function(import("../PluggableMap.js").FrameState):HTMLElement} RenderFunction
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:source', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:source'|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../PluggableMap.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with {@link import("../PluggableMap.js").default#addLayer map.addLayer()}. Components
 * like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * {@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 *
 * Please note that for performance reasons several layers might get rendered to
 * the same HTML element, which will cause {@link import("../PluggableMap.js").default#forEachLayerAtPixel map.forEachLayerAtPixel()} to
 * give false positives. To avoid this, apply different `className` properties to the
 * layers at creation time.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @api
 */ var $93a49300d1913509$var$Layer = /** @class */ function(_super) {
    $93a49300d1913509$var$__extends(Layer, _super);
    /**
     * @param {Options<SourceType>} options Layer options.
     */ function Layer(options) {
        var _this = this;
        var baseOptions = (0, $9zTj4.assign)({}, options);
        delete baseOptions.source;
        _this = _super.call(this, baseOptions) || this;
        /***
         * @type {LayerOnSignature<import("../events").EventsKey>}
         */ _this.on;
        /***
         * @type {LayerOnSignature<import("../events").EventsKey>}
         */ _this.once;
        /***
         * @type {LayerOnSignature<void>}
         */ _this.un;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */ _this.mapPrecomposeKey_ = null;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */ _this.mapRenderKey_ = null;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */ _this.sourceChangeKey_ = null;
        /**
         * @private
         * @type {RendererType}
         */ _this.renderer_ = null;
        /**
         * @protected
         * @type {boolean}
         */ _this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) _this.render = options.render;
        if (options.map) _this.setMap(options.map);
        _this.addChangeListener((0, $3A2O6.default).SOURCE, _this.handleSourcePropertyChange_);
        var source = options.source ? /** @type {SourceType} */ options.source : null;
        _this.setSource(source);
        return _this;
    }
    /**
     * @param {Array<import("./Layer.js").default>} [opt_array] Array of layers (to be modified in place).
     * @return {Array<import("./Layer.js").default>} Array of layers.
     */ Layer.prototype.getLayersArray = function(opt_array) {
        var array = opt_array ? opt_array : [];
        array.push(this);
        return array;
    };
    /**
     * @param {Array<import("./Layer.js").State>} [opt_states] Optional list of layer states (to be modified in place).
     * @return {Array<import("./Layer.js").State>} List of layer states.
     */ Layer.prototype.getLayerStatesArray = function(opt_states) {
        var states = opt_states ? opt_states : [];
        states.push(this.getLayerState());
        return states;
    };
    /**
     * Get the layer source.
     * @return {SourceType|null} The layer source (or `null` if not yet set).
     * @observable
     * @api
     */ Layer.prototype.getSource = function() {
        return /** @type {SourceType} */ this.get((0, $3A2O6.default).SOURCE) || null;
    };
    /**
     * @return {SourceType|null} The source being rendered.
     */ Layer.prototype.getRenderSource = function() {
        return this.getSource();
    };
    /**
     * @return {import("../source/Source.js").State} Source state.
     */ Layer.prototype.getSourceState = function() {
        var source = this.getSource();
        return !source ? 'undefined' : source.getState();
    };
    /**
     * @private
     */ Layer.prototype.handleSourceChange_ = function() {
        this.changed();
    };
    /**
     * @private
     */ Layer.prototype.handleSourcePropertyChange_ = function() {
        if (this.sourceChangeKey_) {
            (0, $1dBX3.unlistenByKey)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        var source = this.getSource();
        if (source) this.sourceChangeKey_ = (0, $1dBX3.listen)(source, (0, $cFmyb.default).CHANGE, this.handleSourceChange_, this);
        this.changed();
    };
    /**
     * @param {import("../pixel").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with
     * an array of features.
     */ Layer.prototype.getFeatures = function(pixel) {
        if (!this.renderer_) return new Promise(function(resolve) {
            return resolve([]);
        });
        return this.renderer_.getFeatures(pixel);
    };
    /**
     * @param {import("../pixel").Pixel} pixel Pixel.
     * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
     */ Layer.prototype.getData = function(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    };
    /**
     * In charge to manage the rendering of the layer. One layer type is
     * bounded with one layer renderer.
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target which the renderer may (but need not) use
     * for rendering its content.
     * @return {HTMLElement} The rendered element.
     */ Layer.prototype.render = function(frameState, target) {
        var layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
    };
    /**
     * Called when a layer is not visible during a map render.
     */ Layer.prototype.unrender = function() {
        this.rendered = false;
    };
    /**
     * For use inside the library only.
     * @param {import("../PluggableMap.js").default|null} map Map.
     */ Layer.prototype.setMapInternal = function(map) {
        if (!map) this.unrender();
        this.set((0, $3A2O6.default).MAP, map);
    };
    /**
     * For use inside the library only.
     * @return {import("../PluggableMap.js").default|null} Map.
     */ Layer.prototype.getMapInternal = function() {
        return this.get((0, $3A2O6.default).MAP);
    };
    /**
     * Sets the layer to be rendered on top of other layers on a map. The map will
     * not manage this layer in its layers collection, and the callback in
     * {@link module:ol/Map~Map#forEachLayerAtPixel} will receive `null` as layer. This
     * is useful for temporary layers. To remove an unmanaged layer from the map,
     * use `#setMap(null)`.
     *
     * To add the layer to a map and have it managed by the map, use
     * {@link module:ol/Map~Map#addLayer} instead.
     * @param {import("../PluggableMap.js").default|null} map Map.
     * @api
     */ Layer.prototype.setMap = function(map) {
        if (this.mapPrecomposeKey_) {
            (0, $1dBX3.unlistenByKey)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $1dBX3.unlistenByKey)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $1dBX3.listen)(map, (0, $91e6c6ef4a46bd39$export$2e2bcd8739ae039).PRECOMPOSE, function(evt) {
                var renderEvent = /** @type {import("../render/Event.js").default} */ evt;
                var layerStatesArray = renderEvent.frameState.layerStatesArray;
                var layerState = this.getLayerState(false);
                // A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.
                (0, $3JLp3.assert)(!layerStatesArray.some(function(arrayLayerState) {
                    return arrayLayerState.layer === layerState.layer;
                }), 67);
                layerStatesArray.push(layerState);
            }, this);
            this.mapRenderKey_ = (0, $1dBX3.listen)(this, (0, $cFmyb.default).CHANGE, map.render, map);
            this.changed();
        }
    };
    /**
     * Set the layer source.
     * @param {SourceType|null} source The layer source.
     * @observable
     * @api
     */ Layer.prototype.setSource = function(source) {
        this.set((0, $3A2O6.default).SOURCE, source);
    };
    /**
     * Get the renderer for this layer.
     * @return {RendererType|null} The layer renderer.
     */ Layer.prototype.getRenderer = function() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    };
    /**
     * @return {boolean} The layer has a renderer.
     */ Layer.prototype.hasRenderer = function() {
        return !!this.renderer_;
    };
    /**
     * Create a renderer for this layer.
     * @return {RendererType} A layer renderer.
     * @protected
     */ Layer.prototype.createRenderer = function() {
        return null;
    };
    /**
     * Clean up.
     */ Layer.prototype.disposeInternal = function() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
        this.setSource(null);
        _super.prototype.disposeInternal.call(this);
    };
    return Layer;
}((0, $1iJu5.default));
function $93a49300d1913509$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    var resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    var zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $93a49300d1913509$export$2e2bcd8739ae039 = $93a49300d1913509$var$Layer;


/**
 * @module ol/coordinate
 */ 
var $2Jl0K = parcelRequire("2Jl0K");

var $7aO1A = parcelRequire("7aO1A");
/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [opt_precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $1e6c443737261be3$export$24be126cb0a7bbeb(number, width, opt_precision) {
    var numberString = opt_precision !== undefined ? number.toFixed(opt_precision) : '' + number;
    var decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
function $1e6c443737261be3$export$66e1c0999abad646(v1, v2) {
    var s1 = ('' + v1).split('.');
    var s2 = ('' + v2).split('.');
    for(var i = 0; i < Math.max(s1.length, s2.length); i++){
        var n1 = parseInt(s1[i] || '0', 10);
        var n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $12736e582a1ee05c$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $12736e582a1ee05c$export$cbe80a3fcd2b99b7(coordinate, circle) {
    var r = circle.getRadius();
    var center = circle.getCenter();
    var x0 = center[0];
    var y0 = center[1];
    var x1 = coordinate[0];
    var y1 = coordinate[1];
    var dx = x1 - x0;
    var dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    var d = Math.sqrt(dx * dx + dy * dy);
    var x = x0 + r * dx / d;
    var y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $12736e582a1ee05c$export$18cdd31d17f97131(coordinate, segment) {
    var x0 = coordinate[0];
    var y0 = coordinate[1];
    var start = segment[0];
    var end = segment[1];
    var x1 = start[0];
    var y1 = start[1];
    var x2 = end[0];
    var y2 = end[1];
    var dx = x2 - x1;
    var dy = y2 - y1;
    var along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    var x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $12736e582a1ee05c$export$35ad6765fe262b6(opt_fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $12736e582a1ee05c$export$9ff8f16060979e0a(coordinate, opt_fractionDigits);
    });
}
function $12736e582a1ee05c$export$6eb0ac5f024d8590(hemispheres, degrees, opt_fractionDigits) {
    var normalizedDegrees = (0, $7aO1A.modulo)(degrees + 180, 360) - 180;
    var x = Math.abs(3600 * normalizedDegrees);
    var dflPrecision = opt_fractionDigits || 0;
    var precision = Math.pow(10, dflPrecision);
    var deg = Math.floor(x / 3600);
    var min = Math.floor((x - deg * 3600) / 60);
    var sec = x - deg * 3600 - min * 60;
    sec = Math.ceil(sec * precision) / precision;
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    return deg + '\u00b0 ' + (0, $1e6c443737261be3$export$24be126cb0a7bbeb)(min, 2) + '\u2032 ' + (0, $1e6c443737261be3$export$24be126cb0a7bbeb)(sec, 2, dflPrecision) + '\u2033' + (normalizedDegrees == 0 ? '' : ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0));
}
function $12736e582a1ee05c$export$d9468344d3651243(coordinate, template, opt_fractionDigits) {
    if (coordinate) return template.replace('{x}', coordinate[0].toFixed(opt_fractionDigits)).replace('{y}', coordinate[1].toFixed(opt_fractionDigits));
    else return '';
}
function $12736e582a1ee05c$export$e9bab7fafb253603(coordinate1, coordinate2) {
    var equals = true;
    for(var i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $12736e582a1ee05c$export$bb628a54ab399bc9(coordinate, angle) {
    var cosAngle = Math.cos(angle);
    var sinAngle = Math.sin(angle);
    var x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    var y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $12736e582a1ee05c$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $12736e582a1ee05c$export$88e6ebb4fe54f538(coord1, coord2) {
    var dx = coord1[0] - coord2[0];
    var dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $12736e582a1ee05c$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($12736e582a1ee05c$export$88e6ebb4fe54f538(coord1, coord2));
}
function $12736e582a1ee05c$export$6985570514055196(coordinate, segment) {
    return $12736e582a1ee05c$export$88e6ebb4fe54f538(coordinate, $12736e582a1ee05c$export$18cdd31d17f97131(coordinate, segment));
}
function $12736e582a1ee05c$export$c883fd238161f841(coordinate, opt_fractionDigits) {
    if (coordinate) return $12736e582a1ee05c$export$6eb0ac5f024d8590('NS', coordinate[1], opt_fractionDigits) + ' ' + $12736e582a1ee05c$export$6eb0ac5f024d8590('EW', coordinate[0], opt_fractionDigits);
    else return '';
}
function $12736e582a1ee05c$export$9ff8f16060979e0a(coordinate, opt_fractionDigits) {
    return $12736e582a1ee05c$export$d9468344d3651243(coordinate, '{x}, {y}', opt_fractionDigits);
}
function $12736e582a1ee05c$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        var worldWidth = (0, $2Jl0K.getWidth)(projection.getExtent());
        var worldsAway = $12736e582a1ee05c$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $12736e582a1ee05c$export$24e2b27d1ff0c1d5(coordinate, projection, opt_sourceExtentWidth) {
    var projectionExtent = projection.getExtent();
    var worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        var sourceExtentWidth = opt_sourceExtentWidth || (0, $2Jl0K.getWidth)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}


var $26be036978f4d4e2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 * @template T
 */ /**
 * @abstract
 */ var $26be036978f4d4e2$var$MapRenderer = /** @class */ function(_super) {
    $26be036978f4d4e2$var$__extends(MapRenderer, _super);
    /**
     * @param {import("../PluggableMap.js").default} map Map.
     */ function MapRenderer(map) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */ _this.map_ = map;
        return _this;
    }
    /**
     * @abstract
     * @param {import("../render/EventType.js").default} type Event type.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     */ MapRenderer.prototype.dispatchRenderEvent = function(type, frameState) {
        (0, $61DUI.abstract)();
    };
    /**
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @protected
     */ MapRenderer.prototype.calculateMatrices2D = function(frameState) {
        var viewState = frameState.viewState;
        var coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        var pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $04c1ab69f17a669b$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $04c1ab69f17a669b$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
    };
    /**
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {boolean} checkWrapped Check for wrapped geometries.
     * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {S} thisArg Value to use as `this` when executing `callback`.
     * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
     * @return {T|undefined} Callback result.
     * @template S,T,U
     */ MapRenderer.prototype.forEachFeatureAtCoordinate = function(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        var result;
        var viewState = frameState.viewState;
        /**
         * @param {boolean} managed Managed layer.
         * @param {import("../Feature.js").FeatureLike} feature Feature.
         * @param {import("../layer/Layer.js").default} layer Layer.
         * @param {import("../geom/Geometry.js").default} geometry Geometry.
         * @return {T|undefined} Callback result.
         */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        var projection = viewState.projection;
        var translatedCoordinate = (0, $12736e582a1ee05c$export$39a9ce3624977b84)(coordinate.slice(), projection);
        var offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            var projectionExtent = projection.getExtent();
            var worldWidth = (0, $2Jl0K.getWidth)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        var layerStates = frameState.layerStatesArray;
        var numLayers = layerStates.length;
        var matches = /** @type {Array<HitMatch<T>>} */ [];
        var tmpCoord = [];
        for(var i = 0; i < offsets.length; i++)for(var j = numLayers - 1; j >= 0; --j){
            var layerState = layerStates[j];
            var layer = layerState.layer;
            if (layer.hasRenderer() && (0, $93a49300d1913509$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                var layerRenderer = layer.getRenderer();
                var source = layer.getSource();
                if (layerRenderer && source) {
                    var coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    var callback_1 = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback_1, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        var order = 1 / matches.length;
        matches.forEach(function(m, i) {
            return m.distanceSq += i * order;
        });
        matches.sort(function(a, b) {
            return a.distanceSq - b.distanceSq;
        });
        matches.some(function(m) {
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    };
    /**
     * @abstract
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../layer/Layer.js").default<import("../source/Source").default>, (Uint8ClampedArray|Uint8Array)): T} callback Layer
     *     callback.
     * @param {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @return {T|undefined} Callback result.
     * @template T
     */ MapRenderer.prototype.forEachLayerAtPixel = function(pixel, frameState, hitTolerance, callback, layerFilter) {
        return (0, $61DUI.abstract)();
    };
    /**
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {boolean} checkWrapped Check for wrapped geometries.
     * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
     * @return {boolean} Is there a feature at the given coordinate?
     * @template U
     */ MapRenderer.prototype.hasFeatureAtCoordinate = function(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        var hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $c8IGo.TRUE), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    };
    /**
     * @return {import("../PluggableMap.js").default} Map.
     */ MapRenderer.prototype.getMap = function() {
        return this.map_;
    };
    /**
     * Render.
     * @abstract
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     */ MapRenderer.prototype.renderFrame = function(frameState) {
        (0, $61DUI.abstract)();
    };
    /**
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */ MapRenderer.prototype.scheduleExpireIconCache = function(frameState) {
        if ((0, $cb8fc27afe912dc5$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($26be036978f4d4e2$var$expireIconCache);
    };
    return MapRenderer;
}((0, $fy27o.default));
/**
 * @param {import("../PluggableMap.js").default} map Map.
 * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
 */ function $26be036978f4d4e2$var$expireIconCache(map, frameState) {
    (0, $cb8fc27afe912dc5$export$747ccdf771a87ab8).expire();
}
var $26be036978f4d4e2$export$2e2bcd8739ae039 = $26be036978f4d4e2$var$MapRenderer;



var $48iCR = parcelRequire("48iCR");
/**
 * @module ol/render/Event
 */ 
var $bNM9R = parcelRequire("bNM9R");
var $2c154b5b5f327c1b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2c154b5b5f327c1b$var$RenderEvent = /** @class */ function(_super) {
    $2c154b5b5f327c1b$var$__extends(RenderEvent, _super);
    /**
     * @param {import("./EventType.js").default} type Type.
     * @param {import("../transform.js").Transform} [opt_inversePixelTransform] Transform for
     *     CSS pixels to rendered pixels.
     * @param {import("../PluggableMap.js").FrameState} [opt_frameState] Frame state.
     * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [opt_context] Context.
     */ function RenderEvent(type, opt_inversePixelTransform, opt_frameState, opt_context) {
        var _this = _super.call(this, type) || this;
        /**
         * Transform from CSS pixels (relative to the top-left corner of the map viewport)
         * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
         * @type {import("../transform.js").Transform|undefined}
         * @api
         */ _this.inversePixelTransform = opt_inversePixelTransform;
        /**
         * An object representing the current render frame state.
         * @type {import("../PluggableMap.js").FrameState|undefined}
         * @api
         */ _this.frameState = opt_frameState;
        /**
         * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
         * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
         * context.
         * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
         * @api
         */ _this.context = opt_context;
        return _this;
    }
    return RenderEvent;
}((0, $bNM9R.default));
var $2c154b5b5f327c1b$export$2e2bcd8739ae039 = $2c154b5b5f327c1b$var$RenderEvent;



/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ var $d7810add910403af$export$981241db82723ce2 = 'ol-hidden';
var $d7810add910403af$export$99b49471b0394319 = 'ol-selectable';
var $d7810add910403af$export$1afde3d6e16a7b29 = 'ol-unselectable';
var $d7810add910403af$export$68eede0dd8c6c1da = 'ol-unsupported';
var $d7810add910403af$export$4d4f8be70b656192 = 'ol-control';
var $d7810add910403af$export$e16017ac68d14492 = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ var $d7810add910403af$var$fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z]+?)\\s*$'
].join(''), 'i');
var $d7810add910403af$var$fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family'
];
var $d7810add910403af$export$5abde8a6aec4a131 = function(fontSpec) {
    var match = fontSpec.match($d7810add910403af$var$fontRegEx);
    if (!match) return null;
    var style = /** @type {FontParameters} */ {
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: 'normal',
        variant: 'normal'
    };
    for(var i = 0, ii = $d7810add910403af$var$fontRegExMatchIndex.length; i < ii; ++i){
        var value = match[i + 1];
        if (value !== undefined) style[$d7810add910403af$var$fontRegExMatchIndex[i]] = value;
    }
    style.families = style.family.split(/,\s?/);
    return style;
};


/**
 * @module ol/render/canvas
 */ 
var $aK3Yt = parcelRequire("aK3Yt");

var $gNCG1 = parcelRequire("gNCG1");

var $bInFo = parcelRequire("bInFo");

var $9zTj4 = parcelRequire("9zTj4");

var $djuby = parcelRequire("djuby");

var $da04304be4865188$export$3847dfea4f8d4dfa = '10px sans-serif';
var $da04304be4865188$export$c495d52ee3fd74b2 = '#000';
var $da04304be4865188$export$17bd0c38d6ae694e = 'round';
var $da04304be4865188$export$e21b4112fdc612fc = [];
var $da04304be4865188$export$e06efc2409049f76 = 0;
var $da04304be4865188$export$365eb9648cf19bd0 = 'round';
var $da04304be4865188$export$80c1c01844597b7b = 10;
var $da04304be4865188$export$1eb2eaecacf2031e = '#000';
var $da04304be4865188$export$94d53b95641b5766 = 'center';
var $da04304be4865188$export$cf2279a1bff62eb = 'middle';
var $da04304be4865188$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
var $da04304be4865188$export$79661f132c62010e = 1;
var $da04304be4865188$export$1d36981fcadac93b = new (0, $aK3Yt.default)();
var $da04304be4865188$export$18212182f4e22723 = new (0, $gNCG1.default)();
$da04304be4865188$export$18212182f4e22723.setSize = function() {
    console.warn('labelCache is deprecated.'); //eslint-disable-line
};
/**
 * @type {CanvasRenderingContext2D}
 */ var $da04304be4865188$var$measureContext = null;
/**
 * @type {string}
 */ var $da04304be4865188$var$measureFont;
var $da04304be4865188$export$7fdcec604f0b1fa7 = {};
var $da04304be4865188$export$a534074a28fa87ff = function() {
    var retries = 100;
    var size = '32px ';
    var referenceFonts = [
        'monospace',
        'serif'
    ];
    var len = referenceFonts.length;
    var text = 'wmytzilWMYTZIL@#/&?$%10\uF013';
    var interval, referenceWidth;
    /**
     * @param {string} fontStyle Css font-style
     * @param {string} fontWeight Css font-weight
     * @param {*} fontFamily Css font-family
     * @return {boolean} Font with style and weight is available
     */ function isAvailable(fontStyle, fontWeight, fontFamily) {
        var available = true;
        for(var i = 0; i < len; ++i){
            var referenceFont = referenceFonts[i];
            referenceWidth = $da04304be4865188$export$4ea92329b673abd1(fontStyle + ' ' + fontWeight + ' ' + size + referenceFont, text);
            if (fontFamily != referenceFont) {
                var width = $da04304be4865188$export$4ea92329b673abd1(fontStyle + ' ' + fontWeight + ' ' + size + fontFamily + ',' + referenceFont, text);
                // If width and referenceWidth are the same, then the fallback was used
                // instead of the font we wanted, so the font is not available.
                available = available && width != referenceWidth;
            }
        }
        if (available) return true;
        return false;
    }
    function check() {
        var done = true;
        var fonts = $da04304be4865188$export$1d36981fcadac93b.getKeys();
        for(var i = 0, ii = fonts.length; i < ii; ++i){
            var font = fonts[i];
            if ($da04304be4865188$export$1d36981fcadac93b.get(font) < retries) {
                if (isAvailable.apply(this, font.split('\n'))) {
                    (0, $9zTj4.clear)($da04304be4865188$export$7fdcec604f0b1fa7);
                    // Make sure that loaded fonts are picked up by Safari
                    $da04304be4865188$var$measureContext = null;
                    $da04304be4865188$var$measureFont = undefined;
                    $da04304be4865188$export$1d36981fcadac93b.set(font, retries);
                } else {
                    $da04304be4865188$export$1d36981fcadac93b.set(font, $da04304be4865188$export$1d36981fcadac93b.get(font) + 1, true);
                    done = false;
                }
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function(fontSpec) {
        var font = (0, $d7810add910403af$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        var families = font.families;
        for(var i = 0, ii = families.length; i < ii; ++i){
            var family = families[i];
            var key = font.style + '\n' + font.weight + '\n' + family;
            if ($da04304be4865188$export$1d36981fcadac93b.get(key) === undefined) {
                $da04304be4865188$export$1d36981fcadac93b.set(key, retries, true);
                if (!isAvailable(font.style, font.weight, family)) {
                    $da04304be4865188$export$1d36981fcadac93b.set(key, 0, true);
                    if (interval === undefined) interval = setInterval(check, 32);
                }
            }
        }
    };
}();
var $da04304be4865188$export$4feaf6852ff92513 = function() {
    /**
     * @type {HTMLDivElement}
     */ var measureElement;
    return function(fontSpec) {
        var height = $da04304be4865188$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $bInFo.WORKER_OFFSCREEN_CANVAS) {
                var font = (0, $d7810add910403af$export$5abde8a6aec4a131)(fontSpec);
                var metrics = $da04304be4865188$var$measureText(fontSpec, "\u017Dg");
                var lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement('div');
                    measureElement.innerHTML = 'M';
                    measureElement.style.minHeight = '0';
                    measureElement.style.maxHeight = 'none';
                    measureElement.style.height = 'auto';
                    measureElement.style.padding = '0';
                    measureElement.style.border = 'none';
                    measureElement.style.position = 'absolute';
                    measureElement.style.display = 'block';
                    measureElement.style.left = '-99999px';
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $da04304be4865188$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $da04304be4865188$var$measureText(font, text) {
    if (!$da04304be4865188$var$measureContext) $da04304be4865188$var$measureContext = (0, $djuby.createCanvasContext2D)(1, 1);
    if (font != $da04304be4865188$var$measureFont) {
        $da04304be4865188$var$measureContext.font = font;
        $da04304be4865188$var$measureFont = $da04304be4865188$var$measureContext.font;
    }
    return $da04304be4865188$var$measureContext.measureText(text);
}
function $da04304be4865188$export$4ea92329b673abd1(font, text) {
    return $da04304be4865188$var$measureText(font, text).width;
}
function $da04304be4865188$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    var width = text.split('\n').reduce(function(prev, curr) {
        return Math.max(prev, $da04304be4865188$export$4ea92329b673abd1(font, curr));
    }, 0);
    cache[text] = width;
    return width;
}
function $da04304be4865188$export$7d7c13020df1e791(baseStyle, chunks) {
    var widths = [];
    var heights = [];
    var lineWidths = [];
    var width = 0;
    var lineWidth = 0;
    var height = 0;
    var lineHeight = 0;
    for(var i = 0, ii = chunks.length; i <= ii; i += 2){
        var text = chunks[i];
        if (text === '\n' || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            continue;
        }
        var font = chunks[i + 1] || baseStyle.font;
        var currentWidth = $da04304be4865188$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        var currentHeight = $da04304be4865188$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $da04304be4865188$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $da04304be4865188$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) context.globalAlpha *= opacity;
    if (transform) context.setTransform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $da04304be4865188$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */ function $da04304be4865188$var$executeLabelInstructions(label, context) {
    var contextInstructions = label.contextInstructions;
    for(var i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}




var $1dBX3 = parcelRequire("1dBX3");

var $djuby = parcelRequire("djuby");
var $7a85a4f30d8e86c6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ var $7a85a4f30d8e86c6$var$CompositeMapRenderer = /** @class */ function(_super) {
    $7a85a4f30d8e86c6$var$__extends(CompositeMapRenderer, _super);
    /**
     * @param {import("../PluggableMap.js").default} map Map.
     */ function CompositeMapRenderer(map) {
        var _this = _super.call(this, map) || this;
        /**
         * @type {import("../events.js").EventsKey}
         */ _this.fontChangeListenerKey_ = (0, $1dBX3.listen)((0, $da04304be4865188$export$1d36981fcadac93b), (0, $48iCR.default).PROPERTYCHANGE, map.redrawText.bind(map));
        /**
         * @private
         * @type {HTMLDivElement}
         */ _this.element_ = document.createElement('div');
        var style = _this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        _this.element_.className = (0, $d7810add910403af$export$1afde3d6e16a7b29) + ' ol-layers';
        var container = map.getViewport();
        container.insertBefore(_this.element_, container.firstChild || null);
        /**
         * @private
         * @type {Array<HTMLElement>}
         */ _this.children_ = [];
        /**
         * @private
         * @type {boolean}
         */ _this.renderedVisible_ = true;
        return _this;
    }
    /**
     * @param {import("../render/EventType.js").default} type Event type.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     */ CompositeMapRenderer.prototype.dispatchRenderEvent = function(type, frameState) {
        var map = this.getMap();
        if (map.hasListener(type)) {
            var event_1 = new (0, $2c154b5b5f327c1b$export$2e2bcd8739ae039)(type, undefined, frameState);
            map.dispatchEvent(event_1);
        }
    };
    CompositeMapRenderer.prototype.disposeInternal = function() {
        (0, $1dBX3.unlistenByKey)(this.fontChangeListenerKey_);
        this.element_.parentNode.removeChild(this.element_);
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Render.
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     */ CompositeMapRenderer.prototype.renderFrame = function(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $91e6c6ef4a46bd39$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        var layerStatesArray = frameState.layerStatesArray.sort(function(a, b) {
            return a.zIndex - b.zIndex;
        });
        var viewState = frameState.viewState;
        this.children_.length = 0;
        /**
         * @type {Array<import("../layer/BaseVector.js").default>}
         */ var declutterLayers = [];
        var previousElement = null;
        for(var i = 0, ii = layerStatesArray.length; i < ii; ++i){
            var layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            var layer = layerState.layer;
            var sourceState = layer.getSourceState();
            if (!(0, $93a49300d1913509$export$acb1e9cb9ce4ca56)(layerState, viewState) || sourceState != 'ready' && sourceState != 'undefined') {
                layer.unrender();
                continue;
            }
            var element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            if ('getDeclutter' in layer) declutterLayers.push(/** @type {import("../layer/BaseVector.js").default} */ layer);
        }
        for(var i = declutterLayers.length - 1; i >= 0; --i)declutterLayers[i].renderDeclutter(frameState);
        (0, $djuby.replaceChildren)(this.element_, this.children_);
        this.dispatchRenderEvent((0, $91e6c6ef4a46bd39$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    };
    /**
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../layer/Layer.js").default<import("../source/Source").default>, (Uint8ClampedArray|Uint8Array)): T} callback Layer
     *     callback.
     * @param {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @return {T|undefined} Callback result.
     * @template T
     */ CompositeMapRenderer.prototype.forEachLayerAtPixel = function(pixel, frameState, hitTolerance, callback, layerFilter) {
        var viewState = frameState.viewState;
        var layerStates = frameState.layerStatesArray;
        var numLayers = layerStates.length;
        for(var i = numLayers - 1; i >= 0; --i){
            var layerState = layerStates[i];
            var layer = layerState.layer;
            if (layer.hasRenderer() && (0, $93a49300d1913509$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter(layer)) {
                var layerRenderer = layer.getRenderer();
                var data = layerRenderer.getDataAtPixel(pixel, frameState, hitTolerance);
                if (data) {
                    var result = callback(layer, data);
                    if (result) return result;
                }
            }
        }
        return undefined;
    };
    return CompositeMapRenderer;
}((0, $26be036978f4d4e2$export$2e2bcd8739ae039));
var $7a85a4f30d8e86c6$export$2e2bcd8739ae039 = $7a85a4f30d8e86c6$var$CompositeMapRenderer;



var $aK3Yt = parcelRequire("aK3Yt");

var $1IaXJ = parcelRequire("1IaXJ");

var $59kE1 = parcelRequire("59kE1");

var $cFmyb = parcelRequire("cFmyb");


var $827vD = parcelRequire("827vD");

var $bNM9R = parcelRequire("bNM9R");
var $187787b2a6a7ea44$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map event.
 */ var $187787b2a6a7ea44$var$MapEvent = /** @class */ function(_super) {
    $187787b2a6a7ea44$var$__extends(MapEvent, _super);
    /**
     * @param {string} type Event type.
     * @param {import("./PluggableMap.js").default} map Map.
     * @param {?import("./PluggableMap.js").FrameState} [opt_frameState] Frame state.
     */ function MapEvent(type, map, opt_frameState) {
        var _this = _super.call(this, type) || this;
        /**
         * The map where the event occurred.
         * @type {import("./PluggableMap.js").default}
         * @api
         */ _this.map = map;
        /**
         * The frame state at the time of the event.
         * @type {?import("./PluggableMap.js").FrameState}
         * @api
         */ _this.frameState = opt_frameState !== undefined ? opt_frameState : null;
        return _this;
    }
    return MapEvent;
}((0, $bNM9R.default));
var $187787b2a6a7ea44$export$2e2bcd8739ae039 = $187787b2a6a7ea44$var$MapEvent;


var $88b67309459b310d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */ var $88b67309459b310d$var$MapBrowserEvent = /** @class */ function(_super) {
    $88b67309459b310d$var$__extends(MapBrowserEvent, _super);
    /**
     * @param {string} type Event type.
     * @param {import("./PluggableMap.js").default} map Map.
     * @param {EVENT} originalEvent Original event.
     * @param {boolean} [opt_dragging] Is the map currently being dragged?
     * @param {import("./PluggableMap.js").FrameState} [opt_frameState] Frame state.
     * @param {Array<PointerEvent>} [opt_activePointers] Active pointers.
     */ function MapBrowserEvent(type, map, originalEvent, opt_dragging, opt_frameState, opt_activePointers) {
        var _this = _super.call(this, type, map, opt_frameState) || this;
        /**
         * The original browser event.
         * @const
         * @type {EVENT}
         * @api
         */ _this.originalEvent = originalEvent;
        /**
         * The map pixel relative to the viewport corresponding to the original browser event.
         * @type {?import("./pixel.js").Pixel}
         */ _this.pixel_ = null;
        /**
         * The coordinate in the user projection corresponding to the original browser event.
         * @type {?import("./coordinate.js").Coordinate}
         */ _this.coordinate_ = null;
        /**
         * Indicates if the map is currently being dragged. Only set for
         * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
         *
         * @type {boolean}
         * @api
         */ _this.dragging = opt_dragging !== undefined ? opt_dragging : false;
        /**
         * @type {Array<PointerEvent>|undefined}
         */ _this.activePointers = opt_activePointers;
        return _this;
    }
    Object.defineProperty(MapBrowserEvent.prototype, "pixel", {
        /**
         * The map pixel relative to the viewport corresponding to the original event.
         * @type {import("./pixel.js").Pixel}
         * @api
         */ get: function() {
            if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
            return this.pixel_;
        },
        set: function(pixel) {
            this.pixel_ = pixel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MapBrowserEvent.prototype, "coordinate", {
        /**
         * The coordinate corresponding to the original browser event.  This will be in the user
         * projection if one is set.  Otherwise it will be in the view projection.
         * @type {import("./coordinate.js").Coordinate}
         * @api
         */ get: function() {
            if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
            return this.coordinate_;
        },
        set: function(coordinate) {
            this.coordinate_ = coordinate;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Prevents the default browser action.
     * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
     * @api
     */ MapBrowserEvent.prototype.preventDefault = function() {
        _super.prototype.preventDefault.call(this);
        if ('preventDefault' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    };
    /**
     * Prevents further propagation of the current event.
     * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
     * @api
     */ MapBrowserEvent.prototype.stopPropagation = function() {
        _super.prototype.stopPropagation.call(this);
        if ('stopPropagation' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    };
    return MapBrowserEvent;
}((0, $187787b2a6a7ea44$export$2e2bcd8739ae039));
var $88b67309459b310d$export$2e2bcd8739ae039 = $88b67309459b310d$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 
var $cFmyb = parcelRequire("cFmyb");

/**
 * @module ol/MapBrowserEventType
 */ 
var $cFmyb = parcelRequire("cFmyb");
var /**
 * Constants for event names.
 * @enum {string}
 */ $39a924385cecd177$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
     * A true single click with no dragging and no double click. Note that this
     * event is delayed by 250 ms to ensure that it is not a double click.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
     * @api
     */ SINGLECLICK: 'singleclick',
    /**
     * A click with no dragging. A double click will fire two of this.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
     * @api
     */ CLICK: (0, $cFmyb.default).CLICK,
    /**
     * A true double click, with no dragging.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
     * @api
     */ DBLCLICK: (0, $cFmyb.default).DBLCLICK,
    /**
     * Triggered when a pointer is dragged.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
     * @api
     */ POINTERDRAG: 'pointerdrag',
    /**
     * Triggered when a pointer is moved. Note that on touch devices this is
     * triggered when the map is panned, so is not the same as mousemove.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
     * @api
     */ POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};


/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $a4a8db35606260c6$export$2e2bcd8739ae039 = {
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};



var $gNCG1 = parcelRequire("gNCG1");

var $bInFo = parcelRequire("bInFo");

var $c8IGo = parcelRequire("c8IGo");

var $9zTj4 = parcelRequire("9zTj4");

var $1dBX3 = parcelRequire("1dBX3");
var $7697e90dbe4e7e44$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7697e90dbe4e7e44$var$MapBrowserEventHandler = /** @class */ function(_super) {
    $7697e90dbe4e7e44$var$__extends(MapBrowserEventHandler, _super);
    /**
     * @param {import("./PluggableMap.js").default} map The map with the viewport to listen to events on.
     * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
     */ function MapBrowserEventHandler(map, moveTolerance) {
        var _this = _super.call(this, map) || this;
        /**
         * This is the element that we will listen to the real events on.
         * @type {import("./PluggableMap.js").default}
         * @private
         */ _this.map_ = map;
        /**
         * @type {any}
         * @private
         */ _this.clickTimeoutId_;
        /**
         * Emulate dblclick and singleclick. Will be true when only one pointer is active.
         * @type {boolean}
         */ _this.emulateClicks_ = false;
        /**
         * @type {boolean}
         * @private
         */ _this.dragging_ = false;
        /**
         * @type {!Array<import("./events.js").EventsKey>}
         * @private
         */ _this.dragListenerKeys_ = [];
        /**
         * @type {number}
         * @private
         */ _this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
         * The most recent "down" type event (or null if none have occurred).
         * Set on pointerdown.
         * @type {PointerEvent|null}
         * @private
         */ _this.down_ = null;
        var element = _this.map_.getViewport();
        /**
         * @type {Array<PointerEvent>}
         * @private
         */ _this.activePointers_ = [];
        /**
         * @type {!Object<number, Event>}
         * @private
         */ _this.trackedTouches_ = {};
        _this.element_ = element;
        /**
         * @type {?import("./events.js").EventsKey}
         * @private
         */ _this.pointerdownListenerKey_ = (0, $1dBX3.listen)(element, (0, $a4a8db35606260c6$export$2e2bcd8739ae039).POINTERDOWN, _this.handlePointerDown_, _this);
        /**
         * @type {PointerEvent}
         * @private
         */ _this.originalPointerMoveEvent_;
        /**
         * @type {?import("./events.js").EventsKey}
         * @private
         */ _this.relayedListenerKey_ = (0, $1dBX3.listen)(element, (0, $a4a8db35606260c6$export$2e2bcd8739ae039).POINTERMOVE, _this.relayMoveEvent_, _this);
        /**
         * @private
         */ _this.boundHandleTouchMove_ = _this.handleTouchMove_.bind(_this);
        _this.element_.addEventListener((0, $cFmyb.default).TOUCHMOVE, _this.boundHandleTouchMove_, (0, $bInFo.PASSIVE_EVENT_LISTENERS) ? {
            passive: false
        } : false);
        return _this;
    }
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.emulateClick_ = function(pointerEvent) {
        var newEvent = new (0, $88b67309459b310d$export$2e2bcd8739ae039)((0, $39a924385cecd177$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $88b67309459b310d$export$2e2bcd8739ae039)((0, $39a924385cecd177$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(/** @this {MapBrowserEventHandler} */ (function() {
            this.clickTimeoutId_ = undefined;
            var newEvent = new (0, $88b67309459b310d$export$2e2bcd8739ae039)((0, $39a924385cecd177$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }).bind(this), 250);
    };
    /**
     * Keeps track on how many pointers are currently active.
     *
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.updateActivePointers_ = function(pointerEvent) {
        var event = pointerEvent;
        var id = event.pointerId;
        if (event.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(var pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERDOWN || event.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = (0, $9zTj4.getValues)(this.trackedTouches_);
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.handlePointerUp_ = function(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        var newEvent = new (0, $88b67309459b310d$export$2e2bcd8739ae039)((0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $1dBX3.unlistenByKey));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @return {boolean} If the left mouse button was pressed.
     * @private
     */ MapBrowserEventHandler.prototype.isMouseActionButton_ = function(pointerEvent) {
        return pointerEvent.button === 0;
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.handlePointerDown_ = function(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        var newEvent = new (0, $88b67309459b310d$export$2e2bcd8739ae039)((0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // Store a copy of the down event
        this.down_ = /** @type {PointerEvent} */ {};
        for(var property in pointerEvent){
            var value = pointerEvent[property];
            this.down_[property] = typeof value === 'function' ? (0, $c8IGo.VOID) : value;
        }
        if (this.dragListenerKeys_.length === 0) {
            var doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $1dBX3.listen)(doc, (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $1dBX3.listen)(doc, (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
             * `pointerEventHandler_` and not `documentPointerEventHandler_` like
             * the `pointerup` and `pointermove` listeners.
             *
             * The reason for this is the following: `TouchSource.vacuumTouches_()`
             * issues `pointercancel` events, when there was no `touchend` for a
             * `touchstart`. Now, let's say a first `touchstart` is registered on
             * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
             * But `documentPointerEventHandler_` doesn't know about the first
             * `touchstart`. If there is no `touchend` for the `touchstart`, we can
             * only receive a `touchcancel` from `pointerEventHandler_`, because it is
             * only registered there.
             */ (0, $1dBX3.listen)(this.element_, (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $1dBX3.listen)(this.element_.getRootNode(), (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
        }
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.handlePointerMove_ = function(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            var newEvent = new (0, $88b67309459b310d$export$2e2bcd8739ae039)((0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    };
    /**
     * Wrap and relay a pointermove event.
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */ MapBrowserEventHandler.prototype.relayMoveEvent_ = function(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        var dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $88b67309459b310d$export$2e2bcd8739ae039)((0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERMOVE, this.map_, pointerEvent, dragging));
    };
    /**
     * Flexible handling of a `touch-action: none` css equivalent: because calling
     * `preventDefault()` on a `pointermove` event does not stop native page scrolling
     * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
     * when an interaction (currently `DragPan` handles the event.
     * @param {TouchEvent} event Event.
     * @private
     */ MapBrowserEventHandler.prototype.handleTouchMove_ = function(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events.
        var originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== 'boolean' || event.cancelable === true)) event.preventDefault();
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @return {boolean} Is moving.
     * @private
     */ MapBrowserEventHandler.prototype.isMoving_ = function(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    };
    /**
     * Clean up.
     */ MapBrowserEventHandler.prototype.disposeInternal = function() {
        if (this.relayedListenerKey_) {
            (0, $1dBX3.unlistenByKey)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $cFmyb.default).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $1dBX3.unlistenByKey)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $1dBX3.unlistenByKey));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        _super.prototype.disposeInternal.call(this);
    };
    return MapBrowserEventHandler;
}((0, $gNCG1.default));
var $7697e90dbe4e7e44$export$2e2bcd8739ae039 = $7697e90dbe4e7e44$var$MapBrowserEventHandler;





var $9UyUk = parcelRequire("9UyUk");
/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $6a407377901e6ead$export$2e2bcd8739ae039 = {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view'
};



var $48iCR = parcelRequire("48iCR");



var $cFmyb = parcelRequire("cFmyb");
/**
 * @module ol/structs/PriorityQueue
 */ 
var $3JLp3 = parcelRequire("3JLp3");

var $9zTj4 = parcelRequire("9zTj4");
var $024457096dedd27a$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ var $024457096dedd27a$var$PriorityQueue = /** @class */ function() {
    /**
     * @param {function(T): number} priorityFunction Priority function.
     * @param {function(T): string} keyFunction Key function.
     */ function PriorityQueue(priorityFunction, keyFunction) {
        /**
         * @type {function(T): number}
         * @private
         */ this.priorityFunction_ = priorityFunction;
        /**
         * @type {function(T): string}
         * @private
         */ this.keyFunction_ = keyFunction;
        /**
         * @type {Array<T>}
         * @private
         */ this.elements_ = [];
        /**
         * @type {Array<number>}
         * @private
         */ this.priorities_ = [];
        /**
         * @type {!Object<string, boolean>}
         * @private
         */ this.queuedElements_ = {};
    }
    /**
     * FIXME empty description for jsdoc
     */ PriorityQueue.prototype.clear = function() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $9zTj4.clear)(this.queuedElements_);
    };
    /**
     * Remove and return the highest-priority element. O(log N).
     * @return {T} Element.
     */ PriorityQueue.prototype.dequeue = function() {
        var elements = this.elements_;
        var priorities = this.priorities_;
        var element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = elements.pop();
            priorities[0] = priorities.pop();
            this.siftUp_(0);
        }
        var elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    };
    /**
     * Enqueue an element. O(log N).
     * @param {T} element Element.
     * @return {boolean} The element was added to the queue.
     */ PriorityQueue.prototype.enqueue = function(element) {
        (0, $3JLp3.assert)(!(this.keyFunction_(element) in this.queuedElements_), 31); // Tried to enqueue an `element` that was already added to the queue
        var priority = this.priorityFunction_(element);
        if (priority != $024457096dedd27a$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    };
    /**
     * @return {number} Count.
     */ PriorityQueue.prototype.getCount = function() {
        return this.elements_.length;
    };
    /**
     * Gets the index of the left child of the node at the given index.
     * @param {number} index The index of the node to get the left child for.
     * @return {number} The index of the left child.
     * @private
     */ PriorityQueue.prototype.getLeftChildIndex_ = function(index) {
        return index * 2 + 1;
    };
    /**
     * Gets the index of the right child of the node at the given index.
     * @param {number} index The index of the node to get the right child for.
     * @return {number} The index of the right child.
     * @private
     */ PriorityQueue.prototype.getRightChildIndex_ = function(index) {
        return index * 2 + 2;
    };
    /**
     * Gets the index of the parent of the node at the given index.
     * @param {number} index The index of the node to get the parent for.
     * @return {number} The index of the parent.
     * @private
     */ PriorityQueue.prototype.getParentIndex_ = function(index) {
        return index - 1 >> 1;
    };
    /**
     * Make this a heap. O(N).
     * @private
     */ PriorityQueue.prototype.heapify_ = function() {
        var i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    };
    /**
     * @return {boolean} Is empty.
     */ PriorityQueue.prototype.isEmpty = function() {
        return this.elements_.length === 0;
    };
    /**
     * @param {string} key Key.
     * @return {boolean} Is key queued.
     */ PriorityQueue.prototype.isKeyQueued = function(key) {
        return key in this.queuedElements_;
    };
    /**
     * @param {T} element Element.
     * @return {boolean} Is queued.
     */ PriorityQueue.prototype.isQueued = function(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    };
    /**
     * @param {number} index The index of the node to move down.
     * @private
     */ PriorityQueue.prototype.siftUp_ = function(index) {
        var elements = this.elements_;
        var priorities = this.priorities_;
        var count = elements.length;
        var element = elements[index];
        var priority = priorities[index];
        var startIndex = index;
        while(index < count >> 1){
            var lIndex = this.getLeftChildIndex_(index);
            var rIndex = this.getRightChildIndex_(index);
            var smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    };
    /**
     * @param {number} startIndex The index of the root.
     * @param {number} index The index of the node to move up.
     * @private
     */ PriorityQueue.prototype.siftDown_ = function(startIndex, index) {
        var elements = this.elements_;
        var priorities = this.priorities_;
        var element = elements[index];
        var priority = priorities[index];
        while(index > startIndex){
            var parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    };
    /**
     * FIXME empty description for jsdoc
     */ PriorityQueue.prototype.reprioritize = function() {
        var priorityFunction = this.priorityFunction_;
        var elements = this.elements_;
        var priorities = this.priorities_;
        var index = 0;
        var n = elements.length;
        var element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $024457096dedd27a$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    };
    return PriorityQueue;
}();
var $024457096dedd27a$export$2e2bcd8739ae039 = $024457096dedd27a$var$PriorityQueue;


/**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $b662dbd74afc801f$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
     * Indicates that tile loading failed
     * @type {number}
     */ ERROR: 3,
    EMPTY: 4
};


var $dffd9e2300ce6cad$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
 */ var $dffd9e2300ce6cad$var$TileQueue = /** @class */ function(_super) {
    $dffd9e2300ce6cad$var$__extends(TileQueue, _super);
    /**
     * @param {PriorityFunction} tilePriorityFunction Tile priority function.
     * @param {function(): ?} tileChangeCallback Function called on each tile change event.
     */ function TileQueue(tilePriorityFunction, tileChangeCallback) {
        var _this = _super.call(this, /**
         * @param {Array} element Element.
         * @return {number} Priority.
         */ function(element) {
            return tilePriorityFunction.apply(null, element);
        }, /**
         * @param {Array} element Element.
         * @return {string} Key.
         */ function(element) {
            return /** @type {import("./Tile.js").default} */ element[0].getKey();
        }) || this;
        /** @private */ _this.boundHandleTileChange_ = _this.handleTileChange.bind(_this);
        /**
         * @private
         * @type {function(): ?}
         */ _this.tileChangeCallback_ = tileChangeCallback;
        /**
         * @private
         * @type {number}
         */ _this.tilesLoading_ = 0;
        /**
         * @private
         * @type {!Object<string,boolean>}
         */ _this.tilesLoadingKeys_ = {};
        return _this;
    }
    /**
     * @param {Array} element Element.
     * @return {boolean} The element was added to the queue.
     */ TileQueue.prototype.enqueue = function(element) {
        var added = _super.prototype.enqueue.call(this, element);
        if (added) {
            var tile = element[0];
            tile.addEventListener((0, $cFmyb.default).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    };
    /**
     * @return {number} Number of tiles loading.
     */ TileQueue.prototype.getTilesLoading = function() {
        return this.tilesLoading_;
    };
    /**
     * @param {import("./events/Event.js").default} event Event.
     * @protected
     */ TileQueue.prototype.handleTileChange = function(event) {
        var tile = /** @type {import("./Tile.js").default} */ event.target;
        var state = tile.getState();
        if (state === (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED || state === (0, $b662dbd74afc801f$export$2e2bcd8739ae039).ERROR || state === (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY) {
            tile.removeEventListener((0, $cFmyb.default).CHANGE, this.boundHandleTileChange_);
            var tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    };
    /**
     * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
     * @param {number} maxNewLoads Maximum number of new tiles to load.
     */ TileQueue.prototype.loadMoreTiles = function(maxTotalLoading, maxNewLoads) {
        var newLoads = 0;
        var state, tile, tileKey;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            tile = /** @type {import("./Tile.js").default} */ this.dequeue()[0];
            tileKey = tile.getKey();
            state = tile.getState();
            if (state === (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    };
    return TileQueue;
}((0, $024457096dedd27a$export$2e2bcd8739ae039));
var $dffd9e2300ce6cad$export$2e2bcd8739ae039 = $dffd9e2300ce6cad$var$TileQueue;
function $dffd9e2300ce6cad$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $024457096dedd27a$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $024457096dedd27a$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    var center = frameState.viewState.center;
    var deltaX = tileCenter[0] - center[0];
    var deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}



var $aK3Yt = parcelRequire("aK3Yt");
/**
 * @module ol/proj/Units
 */ /**
 * Projection units: `'degrees'`, `'ft'`, `'m'`, `'pixels'`, `'tile-pixels'` or
 * `'us-ft'`.
 * @enum {string}
 */ var $bcf733fece57bacd$var$Units = {
    /**
     * Radians
     * @api
     */ RADIANS: 'radians',
    /**
     * Degrees
     * @api
     */ DEGREES: 'degrees',
    /**
     * Feet
     * @api
     */ FEET: 'ft',
    /**
     * Meters
     * @api
     */ METERS: 'm',
    /**
     * Pixels
     * @api
     */ PIXELS: 'pixels',
    /**
     * Tile Pixels
     * @api
     */ TILE_PIXELS: 'tile-pixels',
    /**
     * US Feet
     * @api
     */ USFEET: 'us-ft'
};
/**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ var $bcf733fece57bacd$var$unitByCode = {
    '9001': $bcf733fece57bacd$var$Units.METERS,
    '9002': $bcf733fece57bacd$var$Units.FEET,
    '9003': $bcf733fece57bacd$var$Units.USFEET,
    '9101': $bcf733fece57bacd$var$Units.RADIANS,
    '9102': $bcf733fece57bacd$var$Units.DEGREES
};
function $bcf733fece57bacd$export$7f58726df3255edc(code) {
    return $bcf733fece57bacd$var$unitByCode[code];
}
var $bcf733fece57bacd$export$1482081eec883108 = {};
// use the radius of the Normal sphere
$bcf733fece57bacd$export$1482081eec883108[$bcf733fece57bacd$var$Units.RADIANS] = 6370997 / (2 * Math.PI);
$bcf733fece57bacd$export$1482081eec883108[$bcf733fece57bacd$var$Units.DEGREES] = 2 * Math.PI * 6370997 / 360;
$bcf733fece57bacd$export$1482081eec883108[$bcf733fece57bacd$var$Units.FEET] = 0.3048;
$bcf733fece57bacd$export$1482081eec883108[$bcf733fece57bacd$var$Units.METERS] = 1;
$bcf733fece57bacd$export$1482081eec883108[$bcf733fece57bacd$var$Units.USFEET] = 1200 / 3937;
var $bcf733fece57bacd$export$2e2bcd8739ae039 = $bcf733fece57bacd$var$Units;


/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $ac276e5fd318403e$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $994a9d82d1fc09ff$export$2e2bcd8739ae039 = {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ var $abdd446e0816dd65$export$e98a216cdcc847dc = 42;
var $abdd446e0816dd65$export$6b8cb5cd370bd90c = 256;


/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ 

/**
 * @module ol/proj/Projection
 */ 
/**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").default|string} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link module:ol/proj/Units~METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {function(number, import("../coordinate.js").Coordinate):number} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution getPointResolution()} function will be used.
 */ /**
 * @classdesc
 * Projection definition class. One of these is created for each projection
 * supported in the application and stored in the {@link module:ol/proj} namespace.
 * You can use these in applications, but this is not required, as API params
 * and options use {@link module:ol/proj~ProjectionLike} which means the simple string
 * code will suffice.
 *
 * You can use {@link module:ol/proj.get} to retrieve the object for a particular
 * projection.
 *
 * The library includes definitions for `EPSG:4326` and `EPSG:3857`, together
 * with the following aliases:
 * * `EPSG:4326`: CRS:84, urn:ogc:def:crs:EPSG:6.6:4326,
 *     urn:ogc:def:crs:OGC:1.3:CRS84, urn:ogc:def:crs:OGC:2:84,
 *     http://www.opengis.net/gml/srs/epsg.xml#4326,
 *     urn:x-ogc:def:crs:EPSG:4326
 * * `EPSG:3857`: EPSG:102100, EPSG:102113, EPSG:900913,
 *     urn:ogc:def:crs:EPSG:6.18:3:3857,
 *     http://www.opengis.net/gml/srs/epsg.xml#3857
 *
 * If you use [proj4js](https://github.com/proj4js/proj4js), aliases can
 * be added using `proj4.defs()`. After all required projection definitions are
 * added, call the {@link module:ol/proj/proj4.register} function.
 *
 * @api
 */ var $fdd3161c66955e7f$var$Projection = /** @class */ function() {
    /**
     * @param {Options} options Projection options.
     */ function Projection(options) {
        /**
         * @private
         * @type {string}
         */ this.code_ = options.code;
        /**
         * Units of projected coordinates. When set to `TILE_PIXELS`, a
         * `this.extent_` and `this.worldExtent_` must be configured properly for each
         * tile.
         * @private
         * @type {import("./Units.js").default}
         */ this.units_ = /** @type {import("./Units.js").default} */ options.units;
        /**
         * Validity extent of the projection in projected coordinates. For projections
         * with `TILE_PIXELS` units, this is the extent of the tile in
         * tile pixel space.
         * @private
         * @type {import("../extent.js").Extent}
         */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
         * Extent of the world in EPSG:4326. For projections with
         * `TILE_PIXELS` units, this is the extent of the tile in
         * projected coordinate space.
         * @private
         * @type {import("../extent.js").Extent}
         */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
         * @private
         * @type {string}
         */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
         * @private
         * @type {boolean}
         */ this.global_ = options.global !== undefined ? options.global : false;
        /**
         * @private
         * @type {boolean}
         */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
         * @private
         * @type {function(number, import("../coordinate.js").Coordinate):number|undefined}
         */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
         * @private
         * @type {import("../tilegrid/TileGrid.js").default}
         */ this.defaultTileGrid_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
     * @return {boolean} The projection is suitable for wrapping the x-axis
     */ Projection.prototype.canWrapX = function() {
        return this.canWrapX_;
    };
    /**
     * Get the code for this projection, e.g. 'EPSG:4326'.
     * @return {string} Code.
     * @api
     */ Projection.prototype.getCode = function() {
        return this.code_;
    };
    /**
     * Get the validity extent for this projection.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ Projection.prototype.getExtent = function() {
        return this.extent_;
    };
    /**
     * Get the units of this projection.
     * @return {import("./Units.js").default} Units.
     * @api
     */ Projection.prototype.getUnits = function() {
        return this.units_;
    };
    /**
     * Get the amount of meters per unit of this projection.  If the projection is
     * not configured with `metersPerUnit` or a units identifier, the return is
     * `undefined`.
     * @return {number|undefined} Meters.
     * @api
     */ Projection.prototype.getMetersPerUnit = function() {
        return this.metersPerUnit_ || (0, $bcf733fece57bacd$export$1482081eec883108)[this.units_];
    };
    /**
     * Get the world extent for this projection.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ Projection.prototype.getWorldExtent = function() {
        return this.worldExtent_;
    };
    /**
     * Get the axis orientation of this projection.
     * Example values are:
     * enu - the default easting, northing, elevation.
     * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
     *     or south orientated transverse mercator.
     * wnu - westing, northing, up - some planetary coordinate systems have
     *     "west positive" coordinate systems
     * @return {string} Axis orientation.
     * @api
     */ Projection.prototype.getAxisOrientation = function() {
        return this.axisOrientation_;
    };
    /**
     * Is this projection a global projection which spans the whole world?
     * @return {boolean} Whether the projection is global.
     * @api
     */ Projection.prototype.isGlobal = function() {
        return this.global_;
    };
    /**
     * Set if the projection is a global projection which spans the whole world
     * @param {boolean} global Whether the projection is global.
     * @api
     */ Projection.prototype.setGlobal = function(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    };
    /**
     * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
     */ Projection.prototype.getDefaultTileGrid = function() {
        return this.defaultTileGrid_;
    };
    /**
     * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
     */ Projection.prototype.setDefaultTileGrid = function(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    };
    /**
     * Set the validity extent for this projection.
     * @param {import("../extent.js").Extent} extent Extent.
     * @api
     */ Projection.prototype.setExtent = function(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    };
    /**
     * Set the world extent for this projection.
     * @param {import("../extent.js").Extent} worldExtent World extent
     *     [minlon, minlat, maxlon, maxlat].
     * @api
     */ Projection.prototype.setWorldExtent = function(worldExtent) {
        this.worldExtent_ = worldExtent;
    };
    /**
     * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
     * for this projection.
     * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
     * @api
     */ Projection.prototype.setGetPointResolution = function(func) {
        this.getPointResolutionFunc_ = func;
    };
    /**
     * Get the custom point resolution function for this projection (if set).
     * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
     * resolution function (if set).
     */ Projection.prototype.getPointResolutionFunc = function() {
        return this.getPointResolutionFunc_;
    };
    return Projection;
}();
var $fdd3161c66955e7f$export$2e2bcd8739ae039 = $fdd3161c66955e7f$var$Projection;




var $7aO1A = parcelRequire("7aO1A");
var $f8b93063dcbc6d68$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f8b93063dcbc6d68$export$2d2c9be8b5b863f = 6378137;
var $f8b93063dcbc6d68$export$f3928063e5e96d35 = Math.PI * $f8b93063dcbc6d68$export$2d2c9be8b5b863f;
var $f8b93063dcbc6d68$export$21e6da8a7375dfe8 = [
    -$f8b93063dcbc6d68$export$f3928063e5e96d35,
    -$f8b93063dcbc6d68$export$f3928063e5e96d35,
    $f8b93063dcbc6d68$export$f3928063e5e96d35,
    $f8b93063dcbc6d68$export$f3928063e5e96d35
];
var $f8b93063dcbc6d68$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
var $f8b93063dcbc6d68$export$d26945d1ad52feeb = $f8b93063dcbc6d68$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ var $f8b93063dcbc6d68$var$EPSG3857Projection = /** @class */ function(_super) {
    $f8b93063dcbc6d68$var$__extends(EPSG3857Projection, _super);
    /**
     * @param {string} code Code.
     */ function EPSG3857Projection(code) {
        return _super.call(this, {
            code: code,
            units: (0, $bcf733fece57bacd$export$2e2bcd8739ae039).METERS,
            extent: $f8b93063dcbc6d68$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $f8b93063dcbc6d68$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / (0, $7aO1A.cosh)(point[1] / $f8b93063dcbc6d68$export$2d2c9be8b5b863f);
            }
        }) || this;
    }
    return EPSG3857Projection;
}((0, $fdd3161c66955e7f$export$2e2bcd8739ae039));
var $f8b93063dcbc6d68$export$b508d7ad9a891c1b = [
    new $f8b93063dcbc6d68$var$EPSG3857Projection('EPSG:3857'),
    new $f8b93063dcbc6d68$var$EPSG3857Projection('EPSG:102100'),
    new $f8b93063dcbc6d68$var$EPSG3857Projection('EPSG:102113'),
    new $f8b93063dcbc6d68$var$EPSG3857Projection('EPSG:900913'),
    new $f8b93063dcbc6d68$var$EPSG3857Projection('http://www.opengis.net/def/crs/EPSG/0/3857'),
    new $f8b93063dcbc6d68$var$EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
];
function $f8b93063dcbc6d68$export$1ff8bb36c0983070(input, opt_output, opt_dimension) {
    var length = input.length;
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var output = opt_output;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(var i = 0; i < length; i += dimension){
        output[i] = $f8b93063dcbc6d68$export$f3928063e5e96d35 * input[i] / 180;
        var y = $f8b93063dcbc6d68$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $f8b93063dcbc6d68$export$d26945d1ad52feeb) y = $f8b93063dcbc6d68$export$d26945d1ad52feeb;
        else if (y < -$f8b93063dcbc6d68$export$d26945d1ad52feeb) y = -$f8b93063dcbc6d68$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $f8b93063dcbc6d68$export$8c71322ec28ed6b4(input, opt_output, opt_dimension) {
    var length = input.length;
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var output = opt_output;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(var i = 0; i < length; i += dimension){
        output[i] = 180 * input[i] / $f8b93063dcbc6d68$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $f8b93063dcbc6d68$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}




var $342d831fc9a40882$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $342d831fc9a40882$export$2d2c9be8b5b863f = 6378137;
var $342d831fc9a40882$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
var $342d831fc9a40882$export$1482081eec883108 = Math.PI * $342d831fc9a40882$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ var $342d831fc9a40882$var$EPSG4326Projection = /** @class */ function(_super) {
    $342d831fc9a40882$var$__extends(EPSG4326Projection, _super);
    /**
     * @param {string} code Code.
     * @param {string} [opt_axisOrientation] Axis orientation.
     */ function EPSG4326Projection(code, opt_axisOrientation) {
        return _super.call(this, {
            code: code,
            units: (0, $bcf733fece57bacd$export$2e2bcd8739ae039).DEGREES,
            extent: $342d831fc9a40882$export$21e6da8a7375dfe8,
            axisOrientation: opt_axisOrientation,
            global: true,
            metersPerUnit: $342d831fc9a40882$export$1482081eec883108,
            worldExtent: $342d831fc9a40882$export$21e6da8a7375dfe8
        }) || this;
    }
    return EPSG4326Projection;
}((0, $fdd3161c66955e7f$export$2e2bcd8739ae039));
var $342d831fc9a40882$export$b508d7ad9a891c1b = [
    new $342d831fc9a40882$var$EPSG4326Projection('CRS:84'),
    new $342d831fc9a40882$var$EPSG4326Projection('EPSG:4326', 'neu'),
    new $342d831fc9a40882$var$EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new $342d831fc9a40882$var$EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new $342d831fc9a40882$var$EPSG4326Projection('http://www.opengis.net/def/crs/OGC/1.3/CRS84'),
    new $342d831fc9a40882$var$EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
    new $342d831fc9a40882$var$EPSG4326Projection('http://www.opengis.net/def/crs/EPSG/0/4326', 'neu')
];


/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ var $1440639c844ededb$var$cache = {};
function $1440639c844ededb$export$42ffd38884aecdac() {
    $1440639c844ededb$var$cache = {};
}
function $1440639c844ededb$export$3988ae62b71be9a3(code) {
    return $1440639c844ededb$var$cache[code] || $1440639c844ededb$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
function $1440639c844ededb$export$e16d8520af44a096(code, projection) {
    $1440639c844ededb$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ 
var $9zTj4 = parcelRequire("9zTj4");
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ var $7f05289fe376b444$var$transforms = {};
function $7f05289fe376b444$export$42ffd38884aecdac() {
    $7f05289fe376b444$var$transforms = {};
}
function $7f05289fe376b444$export$e16d8520af44a096(source, destination, transformFn) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    if (!(sourceCode in $7f05289fe376b444$var$transforms)) $7f05289fe376b444$var$transforms[sourceCode] = {};
    $7f05289fe376b444$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $7f05289fe376b444$export$cd7f480d6b8286c3(source, destination) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    var transform = $7f05289fe376b444$var$transforms[sourceCode][destinationCode];
    delete $7f05289fe376b444$var$transforms[sourceCode][destinationCode];
    if ((0, $9zTj4.isEmpty)($7f05289fe376b444$var$transforms[sourceCode])) delete $7f05289fe376b444$var$transforms[sourceCode];
    return transform;
}
function $7f05289fe376b444$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    var transform;
    if (sourceCode in $7f05289fe376b444$var$transforms && destinationCode in $7f05289fe376b444$var$transforms[sourceCode]) transform = $7f05289fe376b444$var$transforms[sourceCode][destinationCode];
    return transform;
}



var $2Jl0K = parcelRequire("2Jl0K");

var $7aO1A = parcelRequire("7aO1A");

/**
 * @module ol/sphere
 */ 
var $7aO1A = parcelRequire("7aO1A");
var $50cf26750e1d3b86$export$63f2df7bd7371262 = 6371008.8;
function $50cf26750e1d3b86$export$79376507b09a66f(c1, c2, opt_radius) {
    var radius = opt_radius || $50cf26750e1d3b86$export$63f2df7bd7371262;
    var lat1 = (0, $7aO1A.toRadians)(c1[1]);
    var lat2 = (0, $7aO1A.toRadians)(c2[1]);
    var deltaLatBy2 = (lat2 - lat1) / 2;
    var deltaLonBy2 = (0, $7aO1A.toRadians)(c2[0] - c1[0]) / 2;
    var a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $50cf26750e1d3b86$var$getLengthInternal(coordinates, radius) {
    var length = 0;
    for(var i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $50cf26750e1d3b86$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $50cf26750e1d3b86$export$f0d11c074a923179(geometry, opt_options) {
    var options = opt_options || {};
    var radius = options.radius || $50cf26750e1d3b86$export$63f2df7bd7371262;
    var projection = options.projection || 'EPSG:3857';
    var type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    var length = 0;
    var coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
            break;
        case 'LineString':
        case 'LinearRing':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $50cf26750e1d3b86$var$getLengthInternal(coordinates, radius);
            break;
        case 'MultiLineString':
        case 'Polygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $50cf26750e1d3b86$var$getLengthInternal(coordinates[i], radius);
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $50cf26750e1d3b86$var$getLengthInternal(coords[j], radius);
            }
            break;
        case 'GeometryCollection':
            var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
            for(i = 0, ii = geometries.length; i < ii; ++i)length += $50cf26750e1d3b86$export$f0d11c074a923179(geometries[i], opt_options);
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $50cf26750e1d3b86$var$getAreaInternal(coordinates, radius) {
    var area = 0;
    var len = coordinates.length;
    var x1 = coordinates[len - 1][0];
    var y1 = coordinates[len - 1][1];
    for(var i = 0; i < len; i++){
        var x2 = coordinates[i][0];
        var y2 = coordinates[i][1];
        area += (0, $7aO1A.toRadians)(x2 - x1) * (2 + Math.sin((0, $7aO1A.toRadians)(y1)) + Math.sin((0, $7aO1A.toRadians)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $50cf26750e1d3b86$export$520c40045967cb15(geometry, opt_options) {
    var options = opt_options || {};
    var radius = options.radius || $50cf26750e1d3b86$export$63f2df7bd7371262;
    var projection = options.projection || 'EPSG:3857';
    var type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    var area = 0;
    var coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
        case 'LineString':
        case 'MultiLineString':
        case 'LinearRing':
            break;
        case 'Polygon':
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($50cf26750e1d3b86$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($50cf26750e1d3b86$var$getAreaInternal(coordinates[i], radius));
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($50cf26750e1d3b86$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($50cf26750e1d3b86$var$getAreaInternal(coords[j], radius));
            }
            break;
        case 'GeometryCollection':
            var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
            for(i = 0, ii = geometries.length; i < ii; ++i)area += $50cf26750e1d3b86$export$520c40045967cb15(geometries[i], opt_options);
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return area;
}
function $50cf26750e1d3b86$export$cc800923e997bb8(c1, distance, bearing, opt_radius) {
    var radius = opt_radius || $50cf26750e1d3b86$export$63f2df7bd7371262;
    var lat1 = (0, $7aO1A.toRadians)(c1[1]);
    var lon1 = (0, $7aO1A.toRadians)(c1[0]);
    var dByR = distance / radius;
    var lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    var lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $7aO1A.toDegrees)(lon),
        (0, $7aO1A.toDegrees)(lat)
    ];
}


var $d3bc250abc15fbce$var$showCoordinateWarning = true;
function $d3bc250abc15fbce$export$ed949affbc7c4223(opt_disable) {
    var hide = opt_disable === undefined ? true : opt_disable;
    $d3bc250abc15fbce$var$showCoordinateWarning = !hide;
}
function $d3bc250abc15fbce$export$dd516654c5f598fb(input, opt_output, opt_dimension) {
    var output;
    if (opt_output !== undefined) {
        for(var i = 0, ii = input.length; i < ii; ++i)opt_output[i] = input[i];
        output = opt_output;
    } else output = input.slice();
    return output;
}
function $d3bc250abc15fbce$export$83e8ab53904f8022(input, opt_output, opt_dimension) {
    if (opt_output !== undefined && input !== opt_output) {
        for(var i = 0, ii = input.length; i < ii; ++i)opt_output[i] = input[i];
        input = opt_output;
    }
    return input;
}
function $d3bc250abc15fbce$export$59ae956cd3e343f7(projection) {
    (0, $1440639c844ededb$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $7f05289fe376b444$export$e16d8520af44a096)(projection, projection, $d3bc250abc15fbce$export$dd516654c5f598fb);
}
function $d3bc250abc15fbce$export$638ad73f7aafb913(projections) {
    projections.forEach($d3bc250abc15fbce$export$59ae956cd3e343f7);
}
function $d3bc250abc15fbce$export$3988ae62b71be9a3(projectionLike) {
    return typeof projectionLike === 'string' ? (0, $1440639c844ededb$export$3988ae62b71be9a3)(/** @type {string} */ projectionLike) : /** @type {Projection} */ projectionLike || null;
}
function $d3bc250abc15fbce$export$2d8f7b4eec383d44(projection, resolution, point, opt_units) {
    projection = $d3bc250abc15fbce$export$3988ae62b71be9a3(projection);
    var pointResolution;
    var getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (opt_units && opt_units !== projection.getUnits()) {
            var metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $bcf733fece57bacd$export$1482081eec883108)[opt_units];
        }
    } else {
        var units = projection.getUnits();
        if (units == (0, $bcf733fece57bacd$export$2e2bcd8739ae039).DEGREES && !opt_units || opt_units == (0, $bcf733fece57bacd$export$2e2bcd8739ae039).DEGREES) pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            var toEPSG4326_1 = $d3bc250abc15fbce$export$e3c4995a701c26a3(projection, $d3bc250abc15fbce$export$3988ae62b71be9a3('EPSG:4326'));
            if (toEPSG4326_1 === $d3bc250abc15fbce$export$83e8ab53904f8022 && units !== (0, $bcf733fece57bacd$export$2e2bcd8739ae039).DEGREES) // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                var vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326_1(vertices, vertices, 2);
                var width = (0, $50cf26750e1d3b86$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                var height = (0, $50cf26750e1d3b86$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            var metersPerUnit = opt_units ? (0, $bcf733fece57bacd$export$1482081eec883108)[opt_units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $d3bc250abc15fbce$export$eeb8392580a05a37(projections) {
    $d3bc250abc15fbce$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $7f05289fe376b444$export$e16d8520af44a096)(source, destination, $d3bc250abc15fbce$export$dd516654c5f598fb);
        });
    });
}
function $d3bc250abc15fbce$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $7f05289fe376b444$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $7f05289fe376b444$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $d3bc250abc15fbce$export$4860237d10380594() {
    (0, $1440639c844ededb$export$42ffd38884aecdac)();
    (0, $7f05289fe376b444$export$42ffd38884aecdac)();
}
function $d3bc250abc15fbce$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $d3bc250abc15fbce$export$3988ae62b71be9a3(defaultCode);
    else if (typeof projection === 'string') return $d3bc250abc15fbce$export$3988ae62b71be9a3(projection);
    else return /** @type {Projection} */ projection;
}
function $d3bc250abc15fbce$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [opt_output] Output.
     * @param {number} [opt_dimension] Dimension.
     * @return {Array<number>} Output.
     */ function(input, opt_output, opt_dimension) {
        var length = input.length;
        var dimension = opt_dimension !== undefined ? opt_dimension : 2;
        var output = opt_output !== undefined ? opt_output : new Array(length);
        for(var i = 0; i < length; i += dimension){
            var point = coordTransform(input.slice(i, i + dimension));
            var pointLength = point.length;
            for(var j = 0, jj = dimension; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $d3bc250abc15fbce$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    var sourceProj = $d3bc250abc15fbce$export$3988ae62b71be9a3(source);
    var destProj = $d3bc250abc15fbce$export$3988ae62b71be9a3(destination);
    (0, $7f05289fe376b444$export$e16d8520af44a096)(sourceProj, destProj, $d3bc250abc15fbce$export$6b4aafd331159e0d(forward));
    (0, $7f05289fe376b444$export$e16d8520af44a096)(destProj, sourceProj, $d3bc250abc15fbce$export$6b4aafd331159e0d(inverse));
}
function $d3bc250abc15fbce$export$b15d9668511529b9(coordinate, opt_projection) {
    $d3bc250abc15fbce$export$ed949affbc7c4223();
    return $d3bc250abc15fbce$export$51186ad6e864892a(coordinate, 'EPSG:4326', opt_projection !== undefined ? opt_projection : 'EPSG:3857');
}
function $d3bc250abc15fbce$export$3fb495868742d370(coordinate, opt_projection) {
    var lonLat = $d3bc250abc15fbce$export$51186ad6e864892a(coordinate, opt_projection !== undefined ? opt_projection : 'EPSG:3857', 'EPSG:4326');
    var lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $7aO1A.modulo)(lon + 180, 360) - 180;
    return lonLat;
}
function $d3bc250abc15fbce$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    var equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    else {
        var transformFunc = $d3bc250abc15fbce$export$e3c4995a701c26a3(projection1, projection2);
        return transformFunc === $d3bc250abc15fbce$export$dd516654c5f598fb && equalUnits;
    }
}
function $d3bc250abc15fbce$export$e3c4995a701c26a3(sourceProjection, destinationProjection) {
    var sourceCode = sourceProjection.getCode();
    var destinationCode = destinationProjection.getCode();
    var transformFunc = (0, $7f05289fe376b444$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (!transformFunc) transformFunc = $d3bc250abc15fbce$export$83e8ab53904f8022;
    return transformFunc;
}
function $d3bc250abc15fbce$export$fce0c6cfca85ed96(source, destination) {
    var sourceProjection = $d3bc250abc15fbce$export$3988ae62b71be9a3(source);
    var destinationProjection = $d3bc250abc15fbce$export$3988ae62b71be9a3(destination);
    return $d3bc250abc15fbce$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $d3bc250abc15fbce$export$51186ad6e864892a(coordinate, source, destination) {
    var transformFunc = $d3bc250abc15fbce$export$fce0c6cfca85ed96(source, destination);
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $d3bc250abc15fbce$export$751c68e0e0efff79(extent, source, destination, opt_stops) {
    var transformFunc = $d3bc250abc15fbce$export$fce0c6cfca85ed96(source, destination);
    return (0, $2Jl0K.applyTransform)(extent, transformFunc, undefined, opt_stops);
}
function $d3bc250abc15fbce$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    var transformFunc = $d3bc250abc15fbce$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ var $d3bc250abc15fbce$var$userProjection = null;
function $d3bc250abc15fbce$export$d0aeadbeac54116e(projection) {
    $d3bc250abc15fbce$var$userProjection = $d3bc250abc15fbce$export$3988ae62b71be9a3(projection);
}
function $d3bc250abc15fbce$export$1ae11279759d4e8f() {
    $d3bc250abc15fbce$var$userProjection = null;
}
function $d3bc250abc15fbce$export$3973b77d5f6f2790() {
    return $d3bc250abc15fbce$var$userProjection;
}
function $d3bc250abc15fbce$export$aa7494edfbe36197() {
    $d3bc250abc15fbce$export$d0aeadbeac54116e('EPSG:4326');
}
function $d3bc250abc15fbce$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$d3bc250abc15fbce$var$userProjection) return coordinate;
    return $d3bc250abc15fbce$export$51186ad6e864892a(coordinate, sourceProjection, $d3bc250abc15fbce$var$userProjection);
}
function $d3bc250abc15fbce$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$d3bc250abc15fbce$var$userProjection) {
        if ($d3bc250abc15fbce$var$showCoordinateWarning && !(0, $12736e582a1ee05c$export$e9bab7fafb253603)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $d3bc250abc15fbce$var$showCoordinateWarning = false;
            // eslint-disable-next-line no-console
            console.warn('Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.');
        }
        return coordinate;
    }
    return $d3bc250abc15fbce$export$51186ad6e864892a(coordinate, $d3bc250abc15fbce$var$userProjection, destProjection);
}
function $d3bc250abc15fbce$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$d3bc250abc15fbce$var$userProjection) return extent;
    return $d3bc250abc15fbce$export$751c68e0e0efff79(extent, sourceProjection, $d3bc250abc15fbce$var$userProjection);
}
function $d3bc250abc15fbce$export$494be3a3a25689ca(extent, destProjection) {
    if (!$d3bc250abc15fbce$var$userProjection) return extent;
    return $d3bc250abc15fbce$export$751c68e0e0efff79(extent, $d3bc250abc15fbce$var$userProjection, destProjection);
}
function $d3bc250abc15fbce$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$d3bc250abc15fbce$var$userProjection) return resolution;
    var sourceUnits = $d3bc250abc15fbce$export$3988ae62b71be9a3(sourceProjection).getUnits();
    var userUnits = $d3bc250abc15fbce$var$userProjection.getUnits();
    return sourceUnits && userUnits ? resolution * (0, $bcf733fece57bacd$export$1482081eec883108)[sourceUnits] / (0, $bcf733fece57bacd$export$1482081eec883108)[userUnits] : resolution;
}
function $d3bc250abc15fbce$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$d3bc250abc15fbce$var$userProjection) return resolution;
    var sourceUnits = $d3bc250abc15fbce$export$3988ae62b71be9a3(destProjection).getUnits();
    var userUnits = $d3bc250abc15fbce$var$userProjection.getUnits();
    return sourceUnits && userUnits ? resolution * (0, $bcf733fece57bacd$export$1482081eec883108)[userUnits] / (0, $bcf733fece57bacd$export$1482081eec883108)[sourceUnits] : resolution;
}
function $d3bc250abc15fbce$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        var transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            var sourceExtent = sourceProj.getExtent();
            var sourceExtentWidth = (0, $2Jl0K.getWidth)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $12736e582a1ee05c$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $7aO1A.clamp)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $7aO1A.clamp)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $2Jl0K.getWidth)(destProj.getExtent());
        return transformed;
    };
}
function $d3bc250abc15fbce$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $d3bc250abc15fbce$export$eeb8392580a05a37((0, $f8b93063dcbc6d68$export$b508d7ad9a891c1b));
    $d3bc250abc15fbce$export$eeb8392580a05a37((0, $342d831fc9a40882$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $d3bc250abc15fbce$export$4856f21c2f184f24((0, $342d831fc9a40882$export$b508d7ad9a891c1b), (0, $f8b93063dcbc6d68$export$b508d7ad9a891c1b), (0, $f8b93063dcbc6d68$export$1ff8bb36c0983070), (0, $f8b93063dcbc6d68$export$8c71322ec28ed6b4));
}
$d3bc250abc15fbce$export$86eed449eb2dcac4();



var $c8IGo = parcelRequire("c8IGo");


var $3JLp3 = parcelRequire("3JLp3");

var $9zTj4 = parcelRequire("9zTj4");
/**
 * @module ol/centerconstraint
 */ 
var $7aO1A = parcelRequire("7aO1A");
function $90017e35853d4679$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [opt_centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, opt_isMoving, opt_centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        var viewWidth = onlyCenter ? 0 : size[0] * resolution;
        var viewHeight = onlyCenter ? 0 : size[1] * resolution;
        var shiftX = opt_centerShift ? opt_centerShift[0] : 0;
        var shiftY = opt_centerShift ? opt_centerShift[1] : 0;
        var minX = extent[0] + viewWidth / 2 + shiftX;
        var maxX = extent[2] - viewWidth / 2 + shiftX;
        var minY = extent[1] + viewHeight / 2 + shiftY;
        var maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        var x = (0, $7aO1A.clamp)(center[0], minX, maxX);
        var y = (0, $7aO1A.clamp)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (opt_isMoving && smooth && resolution) {
            var ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $90017e35853d4679$export$f883a24d5edde77c(center) {
    return center;
}



var $7aO1A = parcelRequire("7aO1A");
/**
 * @module ol/resolutionconstraint
 */ 
var $7aO1A = parcelRequire("7aO1A");

var $2Jl0K = parcelRequire("2Jl0K");

var $kzmGH = parcelRequire("kzmGH");
/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $93e76560ea94c6e3$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    var xResolution = (0, $2Jl0K.getWidth)(maxExtent) / viewportSize[0];
    var yResolution = (0, $2Jl0K.getHeight)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $93e76560ea94c6e3$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    var result = Math.min(resolution, maxResolution);
    var ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $7aO1A.clamp)(result, minResolution / 2, maxResolution * 2);
}
function $93e76560ea94c6e3$export$d65a517690fc4385(resolutions, opt_smooth, opt_maxExtent, opt_showFullExtent) {
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, opt_isMoving) {
        if (resolution !== undefined) {
            var maxResolution = resolutions[0];
            var minResolution = resolutions[resolutions.length - 1];
            var cappedMaxRes = opt_maxExtent ? $93e76560ea94c6e3$var$getViewportClampedResolution(maxResolution, opt_maxExtent, size, opt_showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (opt_isMoving) {
                var smooth = opt_smooth !== undefined ? opt_smooth : true;
                if (!smooth) return (0, $7aO1A.clamp)(resolution, minResolution, cappedMaxRes);
                return $93e76560ea94c6e3$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            var capped = Math.min(cappedMaxRes, resolution);
            var z = Math.floor((0, $kzmGH.linearFindNearest)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        } else return undefined;
    });
}
function $93e76560ea94c6e3$export$22ac0f6b219de91a(power, maxResolution, opt_minResolution, opt_smooth, opt_maxExtent, opt_showFullExtent) {
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, opt_isMoving) {
        if (resolution !== undefined) {
            var cappedMaxRes = opt_maxExtent ? $93e76560ea94c6e3$var$getViewportClampedResolution(maxResolution, opt_maxExtent, size, opt_showFullExtent) : maxResolution;
            var minResolution = opt_minResolution !== undefined ? opt_minResolution : 0;
            // during interacting or animating, allow intermediary values
            if (opt_isMoving) {
                var smooth = opt_smooth !== undefined ? opt_smooth : true;
                if (!smooth) return (0, $7aO1A.clamp)(resolution, minResolution, cappedMaxRes);
                return $93e76560ea94c6e3$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            var tolerance = 1e-9;
            var minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            var offset = -direction * (0.5 - tolerance) + 0.5;
            var capped = Math.min(cappedMaxRes, resolution);
            var cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            var zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            var newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $7aO1A.clamp)(newResolution, minResolution, cappedMaxRes);
        } else return undefined;
    });
}
function $93e76560ea94c6e3$export$1c4e6da9b4b066fe(maxResolution, minResolution, opt_smooth, opt_maxExtent, opt_showFullExtent) {
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, opt_isMoving) {
        if (resolution !== undefined) {
            var cappedMaxRes = opt_maxExtent ? $93e76560ea94c6e3$var$getViewportClampedResolution(maxResolution, opt_maxExtent, size, opt_showFullExtent) : maxResolution;
            var smooth = opt_smooth !== undefined ? opt_smooth : true;
            if (!smooth || !opt_isMoving) return (0, $7aO1A.clamp)(resolution, minResolution, cappedMaxRes);
            return $93e76560ea94c6e3$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        } else return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
var $7aO1A = parcelRequire("7aO1A");
function $ca456328cb3fb311$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    else return undefined;
}
function $ca456328cb3fb311$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    else return undefined;
}
function $ca456328cb3fb311$export$9ba78806de831083(n) {
    var theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, opt_isMoving) {
        if (opt_isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        } else return undefined;
    });
}
function $ca456328cb3fb311$export$17a6e6f3448b17e8(opt_tolerance) {
    var tolerance = opt_tolerance || (0, $7aO1A.toRadians)(5);
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, opt_isMoving) {
        if (opt_isMoving) return rotation;
        if (rotation !== undefined) {
            if (Math.abs(rotation) <= tolerance) return 0;
            else return rotation;
        } else return undefined;
    });
}


/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $c2ae491963dea068$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $c2ae491963dea068$export$57636bb43b1ccbb0(t) {
    return 1 - $c2ae491963dea068$export$929e5a82286172a6(1 - t);
}
function $c2ae491963dea068$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $c2ae491963dea068$export$45db2fc2f15997e7(t) {
    return t;
}
function $c2ae491963dea068$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $c2ae491963dea068$export$9b47139b511b56e4(2 * t);
    else return 1 - $c2ae491963dea068$export$9b47139b511b56e4(2 * (t - 0.5));
}



var $2Jl0K = parcelRequire("2Jl0K");

var $kzmGH = parcelRequire("kzmGH");
/**
 * @module ol/geom/GeometryLayout
 */ /**
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available. Supported values are `'XY'`,
 * `'XYZ'`, `'XYM'`, `'XYZM'`.
 * @enum {string}
 */ var $a46a42327f86f965$export$2e2bcd8739ae039 = {
    XY: 'XY',
    XYZ: 'XYZ',
    XYM: 'XYM',
    XYZM: 'XYZM'
};




var $aK3Yt = parcelRequire("aK3Yt");


var $61DUI = parcelRequire("61DUI");


var $2Jl0K = parcelRequire("2Jl0K");


var $c8IGo = parcelRequire("c8IGo");
/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */ function $d8ffc49c60e9d646$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var x = flatCoordinates[j];
        var y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}
function $d8ffc49c60e9d646$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}
function $d8ffc49c60e9d646$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}
function $d8ffc49c60e9d646$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (opt_dest && dest.length != i) dest.length = i;
    return dest;
}


var $7dc792b36df3ca45$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ var $7dc792b36df3ca45$var$tmpTransform = (0, $04c1ab69f17a669b$export$185802fd694ee1f5)();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ var $7dc792b36df3ca45$var$Geometry = /** @class */ function(_super) {
    $7dc792b36df3ca45$var$__extends(Geometry, _super);
    function Geometry() {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */ _this.extent_ = (0, $2Jl0K.createEmpty)();
        /**
         * @private
         * @type {number}
         */ _this.extentRevision_ = -1;
        /**
         * @protected
         * @type {number}
         */ _this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
         * @protected
         * @type {number}
         */ _this.simplifiedGeometryRevision = 0;
        /**
         * Get a transformed and simplified version of the geometry.
         * @abstract
         * @param {number} revision The geometry revision.
         * @param {number} squaredTolerance Squared tolerance.
         * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
         * @return {Geometry} Simplified geometry.
         */ _this.simplifyTransformedInternal = (0, $c8IGo.memoizeOne)(function(revision, squaredTolerance, opt_transform) {
            if (!opt_transform) return this.getSimplifiedGeometry(squaredTolerance);
            var clone = this.clone();
            clone.applyTransform(opt_transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
        return _this;
    }
    /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ Geometry.prototype.simplifyTransformed = function(squaredTolerance, opt_transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, opt_transform);
    };
    /**
     * Make a complete copy of the geometry.
     * @abstract
     * @return {!Geometry} Clone.
     */ Geometry.prototype.clone = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * @abstract
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ Geometry.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        return (0, $61DUI.abstract)();
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */ Geometry.prototype.containsXY = function(x, y) {
        var coord = this.getClosestPoint([
            x,
            y
        ]);
        return coord[0] === x && coord[1] === y;
    };
    /**
     * Return the closest point of the geometry to the passed point as
     * {@link module:ol/coordinate~Coordinate coordinate}.
     * @param {import("../coordinate.js").Coordinate} point Point.
     * @param {import("../coordinate.js").Coordinate} [opt_closestPoint] Closest point.
     * @return {import("../coordinate.js").Coordinate} Closest point.
     * @api
     */ Geometry.prototype.getClosestPoint = function(point, opt_closestPoint) {
        var closestPoint = opt_closestPoint ? opt_closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    };
    /**
     * Returns true if this geometry includes the specified coordinate. If the
     * coordinate is on the boundary of the geometry, returns false.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains coordinate.
     * @api
     */ Geometry.prototype.intersectsCoordinate = function(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    };
    /**
     * @abstract
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */ Geometry.prototype.computeExtent = function(extent) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Get the extent of the geometry.
     * @param {import("../extent.js").Extent} [opt_extent] Extent.
     * @return {import("../extent.js").Extent} extent Extent.
     * @api
     */ Geometry.prototype.getExtent = function(opt_extent) {
        if (this.extentRevision_ != this.getRevision()) {
            var extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $2Jl0K.createOrUpdateEmpty)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $2Jl0K.returnOrUpdate)(this.extent_, opt_extent);
    };
    /**
     * Rotate the geometry around a given coordinate. This modifies the geometry
     * coordinates in place.
     * @abstract
     * @param {number} angle Rotation angle in radians.
     * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
     * @api
     */ Geometry.prototype.rotate = function(angle, anchor) {
        (0, $61DUI.abstract)();
    };
    /**
     * Scale the geometry (with an optional origin).  This modifies the geometry
     * coordinates in place.
     * @abstract
     * @param {number} sx The scaling factor in the x-direction.
     * @param {number} [opt_sy] The scaling factor in the y-direction (defaults to sx).
     * @param {import("../coordinate.js").Coordinate} [opt_anchor] The scale origin (defaults to the center
     *     of the geometry extent).
     * @api
     */ Geometry.prototype.scale = function(sx, opt_sy, opt_anchor) {
        (0, $61DUI.abstract)();
    };
    /**
     * Create a simplified version of this geometry.  For linestrings, this uses
     * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
     * algorithm.  For polygons, a quantization-based
     * simplification is used to preserve topology.
     * @param {number} tolerance The tolerance distance for simplification.
     * @return {Geometry} A new, simplified version of the original geometry.
     * @api
     */ Geometry.prototype.simplify = function(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    };
    /**
     * Create a simplified version of this geometry using the Douglas Peucker
     * algorithm.
     * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
     * @abstract
     * @param {number} squaredTolerance Squared tolerance.
     * @return {Geometry} Simplified geometry.
     */ Geometry.prototype.getSimplifiedGeometry = function(squaredTolerance) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Get the type of this geometry.
     * @abstract
     * @return {Type} Geometry type.
     */ Geometry.prototype.getType = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * Apply a transform function to the coordinates of the geometry.
     * The geometry is modified in place.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     * @abstract
     * @param {import("../proj.js").TransformFunction} transformFn Transform function.
     * Called with a flat array of geometry coordinates.
     */ Geometry.prototype.applyTransform = function(transformFn) {
        (0, $61DUI.abstract)();
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @abstract
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     */ Geometry.prototype.intersectsExtent = function(extent) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Translate the geometry.  This modifies the geometry coordinates in place.  If
     * instead you want a new geometry, first `clone()` this geometry.
     * @abstract
     * @param {number} deltaX Delta X.
     * @param {number} deltaY Delta Y.
     * @api
     */ Geometry.prototype.translate = function(deltaX, deltaY) {
        (0, $61DUI.abstract)();
    };
    /**
     * Transform each coordinate of the geometry from one coordinate reference
     * system to another. The geometry is modified in place.
     * For example, a line will be transformed to a line and a circle to a circle.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     *
     * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
     *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
     * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
     *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
     * @return {Geometry} This geometry.  Note that original geometry is
     *     modified in place.
     * @api
     */ Geometry.prototype.transform = function(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ var sourceProj = (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(source);
        var transformFn = sourceProj.getUnits() == (0, $bcf733fece57bacd$export$2e2bcd8739ae039).TILE_PIXELS ? function(inCoordinates, outCoordinates, stride) {
            var pixelExtent = sourceProj.getExtent();
            var projectedExtent = sourceProj.getWorldExtent();
            var scale = (0, $2Jl0K.getHeight)(projectedExtent) / (0, $2Jl0K.getHeight)(pixelExtent);
            (0, $04c1ab69f17a669b$export$f672e0b6f7222cd7)($7dc792b36df3ca45$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $d8ffc49c60e9d646$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $7dc792b36df3ca45$var$tmpTransform, outCoordinates);
            return (0, $d3bc250abc15fbce$export$fce0c6cfca85ed96)(sourceProj, destination)(inCoordinates, outCoordinates, stride);
        } : (0, $d3bc250abc15fbce$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    };
    return Geometry;
}((0, $aK3Yt.default));
var $7dc792b36df3ca45$export$2e2bcd8739ae039 = $7dc792b36df3ca45$var$Geometry;




var $61DUI = parcelRequire("61DUI");

var $2Jl0K = parcelRequire("2Jl0K");

var $29fd4fdf263dcdf4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ var $29fd4fdf263dcdf4$var$SimpleGeometry = /** @class */ function(_super) {
    $29fd4fdf263dcdf4$var$__extends(SimpleGeometry, _super);
    function SimpleGeometry() {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {import("./GeometryLayout.js").default}
         */ _this.layout = (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY;
        /**
         * @protected
         * @type {number}
         */ _this.stride = 2;
        /**
         * @protected
         * @type {Array<number>}
         */ _this.flatCoordinates = null;
        return _this;
    }
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */ SimpleGeometry.prototype.computeExtent = function(extent) {
        return (0, $2Jl0K.createOrUpdateFromFlatCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    };
    /**
     * @abstract
     * @return {Array<*> | null} Coordinates.
     */ SimpleGeometry.prototype.getCoordinates = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * Return the first coordinate of the geometry.
     * @return {import("../coordinate.js").Coordinate} First coordinate.
     * @api
     */ SimpleGeometry.prototype.getFirstCoordinate = function() {
        return this.flatCoordinates.slice(0, this.stride);
    };
    /**
     * @return {Array<number>} Flat coordinates.
     */ SimpleGeometry.prototype.getFlatCoordinates = function() {
        return this.flatCoordinates;
    };
    /**
     * Return the last coordinate of the geometry.
     * @return {import("../coordinate.js").Coordinate} Last point.
     * @api
     */ SimpleGeometry.prototype.getLastCoordinate = function() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    };
    /**
     * Return the {@link module:ol/geom/GeometryLayout layout} of the geometry.
     * @return {import("./GeometryLayout.js").default} Layout.
     * @api
     */ SimpleGeometry.prototype.getLayout = function() {
        return this.layout;
    };
    /**
     * Create a simplified version of this geometry using the Douglas Peucker algorithm.
     * @param {number} squaredTolerance Squared tolerance.
     * @return {SimpleGeometry} Simplified geometry.
     */ SimpleGeometry.prototype.getSimplifiedGeometry = function(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        var simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        var simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        else {
            // Simplification did not actually remove any coordinates.  We now know
            // that any calls to getSimplifiedGeometry with a squaredTolerance less
            // than or equal to the current squaredTolerance will also not have any
            // effect.  This allows us to short circuit simplification (saving CPU
            // cycles) and prevents the cache of simplified geometries from filling
            // up with useless identical copies of this geometry (saving memory).
            this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
            return this;
        }
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {SimpleGeometry} Simplified geometry.
     * @protected
     */ SimpleGeometry.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        return this;
    };
    /**
     * @return {number} Stride.
     */ SimpleGeometry.prototype.getStride = function() {
        return this.stride;
    };
    /**
     * @param {import("./GeometryLayout.js").default} layout Layout.
     * @param {Array<number>} flatCoordinates Flat coordinates.
     */ SimpleGeometry.prototype.setFlatCoordinates = function(layout, flatCoordinates) {
        this.stride = $29fd4fdf263dcdf4$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    };
    /**
     * @abstract
     * @param {!Array<*>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */ SimpleGeometry.prototype.setCoordinates = function(coordinates, opt_layout) {
        (0, $61DUI.abstract)();
    };
    /**
     * @param {import("./GeometryLayout.js").default|undefined} layout Layout.
     * @param {Array<*>} coordinates Coordinates.
     * @param {number} nesting Nesting.
     * @protected
     */ SimpleGeometry.prototype.setLayout = function(layout, coordinates, nesting) {
        /** @type {number} */ var stride;
        if (layout) stride = $29fd4fdf263dcdf4$export$6af0c1b4a8549a43(layout);
        else {
            for(var i = 0; i < nesting; ++i)if (coordinates.length === 0) {
                this.layout = (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY;
                this.stride = 2;
                return;
            } else coordinates = /** @type {Array} */ coordinates[0];
            stride = coordinates.length;
            layout = $29fd4fdf263dcdf4$var$getLayoutForStride(stride);
        }
        this.layout = layout;
        this.stride = stride;
    };
    /**
     * Apply a transform function to the coordinates of the geometry.
     * The geometry is modified in place.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     * @param {import("../proj.js").TransformFunction} transformFn Transform function.
     * Called with a flat array of geometry coordinates.
     * @api
     */ SimpleGeometry.prototype.applyTransform = function(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.stride);
            this.changed();
        }
    };
    /**
     * Rotate the geometry around a given coordinate. This modifies the geometry
     * coordinates in place.
     * @param {number} angle Rotation angle in counter-clockwise radians.
     * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
     * @api
     */ SimpleGeometry.prototype.rotate = function(angle, anchor) {
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            (0, $d8ffc49c60e9d646$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    };
    /**
     * Scale the geometry (with an optional origin).  This modifies the geometry
     * coordinates in place.
     * @param {number} sx The scaling factor in the x-direction.
     * @param {number} [opt_sy] The scaling factor in the y-direction (defaults to sx).
     * @param {import("../coordinate.js").Coordinate} [opt_anchor] The scale origin (defaults to the center
     *     of the geometry extent).
     * @api
     */ SimpleGeometry.prototype.scale = function(sx, opt_sy, opt_anchor) {
        var sy = opt_sy;
        if (sy === undefined) sy = sx;
        var anchor = opt_anchor;
        if (!anchor) anchor = (0, $2Jl0K.getCenter)(this.getExtent());
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            (0, $d8ffc49c60e9d646$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    };
    /**
     * Translate the geometry.  This modifies the geometry coordinates in place.  If
     * instead you want a new geometry, first `clone()` this geometry.
     * @param {number} deltaX Delta X.
     * @param {number} deltaY Delta Y.
     * @api
     */ SimpleGeometry.prototype.translate = function(deltaX, deltaY) {
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            (0, $d8ffc49c60e9d646$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    };
    return SimpleGeometry;
}((0, $7dc792b36df3ca45$export$2e2bcd8739ae039));
/**
 * @param {number} stride Stride.
 * @return {import("./GeometryLayout.js").default} layout Layout.
 */ function $29fd4fdf263dcdf4$var$getLayoutForStride(stride) {
    var layout;
    if (stride == 2) layout = (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY;
    else if (stride == 3) layout = (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYZ;
    else if (stride == 4) layout = (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYZM;
    return /** @type {import("./GeometryLayout.js").default} */ layout;
}
function $29fd4fdf263dcdf4$export$6af0c1b4a8549a43(layout) {
    var stride;
    if (layout == (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY) stride = 2;
    else if (layout == (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYZ || layout == (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYM) stride = 3;
    else if (layout == (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYZM) stride = 4;
    return /** @type {number} */ stride;
}
function $29fd4fdf263dcdf4$export$a3767472617c7861(simpleGeometry, transform, opt_dest) {
    var flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    else {
        var stride = simpleGeometry.getStride();
        return (0, $d8ffc49c60e9d646$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, opt_dest);
    }
}
var $29fd4fdf263dcdf4$export$2e2bcd8739ae039 = $29fd4fdf263dcdf4$var$SimpleGeometry;


/**
 * @module ol/geom/flat/closest
 */ 
var $7aO1A = parcelRequire("7aO1A");
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $361a43425a99a2db$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    var x1 = flatCoordinates[offset1];
    var y1 = flatCoordinates[offset1 + 1];
    var dx = flatCoordinates[offset2] - x1;
    var dy = flatCoordinates[offset2 + 1] - y1;
    var offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(var i = 0; i < stride; ++i)closestPoint[i] = (0, $7aO1A.lerp)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(var i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $361a43425a99a2db$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        var squaredDelta = (0, $7aO1A.squaredDistance)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $361a43425a99a2db$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        max = $361a43425a99a2db$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $361a43425a99a2db$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        max = $361a43425a99a2db$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $361a43425a99a2db$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    if (offset == end) return minSquaredDistance;
    var i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $7aO1A.squaredDistance)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        } else return minSquaredDistance;
    }
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [
        NaN,
        NaN
    ];
    var index = offset + stride;
    while(index < end){
        $361a43425a99a2db$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $7aO1A.squaredDistance)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $361a43425a99a2db$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $7aO1A.squaredDistance)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $361a43425a99a2db$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [
        NaN,
        NaN
    ];
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        minSquaredDistance = $361a43425a99a2db$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $361a43425a99a2db$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [
        NaN,
        NaN
    ];
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        minSquaredDistance = $361a43425a99a2db$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}



var $2Jl0K = parcelRequire("2Jl0K");
/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $63fb5fb55d4eceae$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(var i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $63fb5fb55d4eceae$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(var i = 0, ii = coordinates.length; i < ii; ++i){
        var coordinate = coordinates[i];
        for(var j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $63fb5fb55d4eceae$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, opt_ends) {
    var ends = opt_ends ? opt_ends : [];
    var i = 0;
    for(var j = 0, jj = coordinatess.length; j < jj; ++j){
        var end = $63fb5fb55d4eceae$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $63fb5fb55d4eceae$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, opt_endss) {
    var endss = opt_endss ? opt_endss : [];
    var i = 0;
    for(var j = 0, jj = coordinatesss.length; j < jj; ++j){
        var ends = $63fb5fb55d4eceae$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

var $7aO1A = parcelRequire("7aO1A");
function $2c00e3f050ec1bce$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, opt_simplifiedFlatCoordinates) {
    var simplifiedFlatCoordinates = opt_simplifiedFlatCoordinates !== undefined ? opt_simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $2c00e3f050ec1bce$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $2c00e3f050ec1bce$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $2c00e3f050ec1bce$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    var n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ var markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ var stack = [
        offset,
        end - stride
    ];
    var index = 0;
    while(stack.length > 0){
        var last = stack.pop();
        var first = stack.pop();
        var maxSquaredDistance = 0;
        var x1 = flatCoordinates[first];
        var y1 = flatCoordinates[first + 1];
        var x2 = flatCoordinates[last];
        var y2 = flatCoordinates[last + 1];
        for(var i = first + stride; i < last; i += stride){
            var x = flatCoordinates[i];
            var y = flatCoordinates[i + 1];
            var squaredDistance_1 = (0, $7aO1A.squaredSegmentDistance)(x, y, x1, y1, x2, y2);
            if (squaredDistance_1 > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance_1;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(var i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $2c00e3f050ec1bce$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        simplifiedOffset = $2c00e3f050ec1bce$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $2c00e3f050ec1bce$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        var simplifiedEnds = [];
        simplifiedOffset = $2c00e3f050ec1bce$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $2c00e3f050ec1bce$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    var x2 = x1;
    var y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $7aO1A.squaredDistance)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $2c00e3f050ec1bce$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $2c00e3f050ec1bce$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    var x1 = $2c00e3f050ec1bce$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    var y1 = $2c00e3f050ec1bce$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    var x2, y2;
    do {
        x2 = $2c00e3f050ec1bce$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $2c00e3f050ec1bce$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        var x3 = $2c00e3f050ec1bce$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        var y3 = $2c00e3f050ec1bce$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        var dx1 = x2 - x1;
        var dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        var dx2 = x3 - x1;
        var dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $2c00e3f050ec1bce$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        simplifiedOffset = $2c00e3f050ec1bce$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $2c00e3f050ec1bce$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        var simplifiedEnds = [];
        simplifiedOffset = $2c00e3f050ec1bce$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [opt_coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $f2531bda6eeb448c$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, opt_coordinates) {
    var coordinates = opt_coordinates !== undefined ? opt_coordinates : [];
    var i = 0;
    for(var j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $f2531bda6eeb448c$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, opt_coordinatess) {
    var coordinatess = opt_coordinatess !== undefined ? opt_coordinatess : [];
    var i = 0;
    for(var j = 0, jj = ends.length; j < jj; ++j){
        var end = ends[j];
        coordinatess[i++] = $f2531bda6eeb448c$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $f2531bda6eeb448c$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, opt_coordinatesss) {
    var coordinatesss = opt_coordinatesss !== undefined ? opt_coordinatesss : [];
    var i = 0;
    for(var j = 0, jj = endss.length; j < jj; ++j){
        var ends = endss[j];
        coordinatesss[i++] = $f2531bda6eeb448c$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $94a20b0959033b1b$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    var twiceArea = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        twiceArea += y1 * x2 - x1 * y2;
        x1 = x2;
        y1 = y2;
    }
    return twiceArea / 2;
}
function $94a20b0959033b1b$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    var area = 0;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        area += $94a20b0959033b1b$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $94a20b0959033b1b$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    var area = 0;
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        area += $94a20b0959033b1b$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


var $a3079b043d6d17fb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ var $a3079b043d6d17fb$var$LinearRing = /** @class */ function(_super) {
    $a3079b043d6d17fb$var$__extends(LinearRing, _super);
    /**
     * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */ function LinearRing(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDeltaRevision_ = -1;
        if (opt_layout !== undefined && !Array.isArray(coordinates[0])) _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
        else _this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, opt_layout);
        return _this;
    }
    /**
     * Make a complete copy of the geometry.
     * @return {!LinearRing} Clone.
     * @api
     */ LinearRing.prototype.clone = function() {
        return new LinearRing(this.flatCoordinates.slice(), this.layout);
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ LinearRing.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $2Jl0K.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $361a43425a99a2db$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $361a43425a99a2db$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * Return the area of the linear ring on projected plane.
     * @return {number} Area (on projected plane).
     * @api
     */ LinearRing.prototype.getArea = function() {
        return (0, $94a20b0959033b1b$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * Return the coordinates of the linear ring.
     * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
     * @api
     */ LinearRing.prototype.getCoordinates = function() {
        return (0, $f2531bda6eeb448c$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {LinearRing} Simplified LinearRing.
     * @protected
     */ LinearRing.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $2c00e3f050ec1bce$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LinearRing(simplifiedFlatCoordinates, (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./Geometry.js").Type} Geometry type.
     * @api
     */ LinearRing.prototype.getType = function() {
        return 'LinearRing';
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ LinearRing.prototype.intersectsExtent = function(extent) {
        return false;
    };
    /**
     * Set the coordinates of the linear ring.
     * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */ LinearRing.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $63fb5fb55d4eceae$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return LinearRing;
}((0, $29fd4fdf263dcdf4$export$2e2bcd8739ae039));
var $a3079b043d6d17fb$export$2e2bcd8739ae039 = $a3079b043d6d17fb$var$LinearRing;




var $2Jl0K = parcelRequire("2Jl0K");


var $7aO1A = parcelRequire("7aO1A");
var $112514a365e4f8fa$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ var $112514a365e4f8fa$var$Point = /** @class */ function(_super) {
    $112514a365e4f8fa$var$__extends(Point, _super);
    /**
     * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */ function Point(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        _this.setCoordinates(coordinates, opt_layout);
        return _this;
    }
    /**
     * Make a complete copy of the geometry.
     * @return {!Point} Clone.
     * @api
     */ Point.prototype.clone = function() {
        var point = new Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ Point.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        var flatCoordinates = this.flatCoordinates;
        var squaredDistance = (0, $7aO1A.squaredDistance)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            var stride = this.stride;
            for(var i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        } else return minSquaredDistance;
    };
    /**
     * Return the coordinate of the point.
     * @return {import("../coordinate.js").Coordinate} Coordinates.
     * @api
     */ Point.prototype.getCoordinates = function() {
        return !this.flatCoordinates ? [] : this.flatCoordinates.slice();
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */ Point.prototype.computeExtent = function(extent) {
        return (0, $2Jl0K.createOrUpdateFromCoordinate)(this.flatCoordinates, extent);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./Geometry.js").Type} Geometry type.
     * @api
     */ Point.prototype.getType = function() {
        return 'Point';
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ Point.prototype.intersectsExtent = function(extent) {
        return (0, $2Jl0K.containsXY)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    };
    /**
     * @param {!Array<*>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */ Point.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $63fb5fb55d4eceae$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return Point;
}((0, $29fd4fdf263dcdf4$export$2e2bcd8739ae039));
var $112514a365e4f8fa$export$2e2bcd8739ae039 = $112514a365e4f8fa$var$Point;





var $2Jl0K = parcelRequire("2Jl0K");


var $kzmGH = parcelRequire("kzmGH");
/**
 * @module ol/geom/flat/interiorpoint
 */ /**
 * @module ol/geom/flat/contains
 */ 
var $2Jl0K = parcelRequire("2Jl0K");
function $7d0e7eb0e3a76e58$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    var outside = (0, $2Jl0K.forEachCorner)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$7d0e7eb0e3a76e58$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $7d0e7eb0e3a76e58$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    var wn = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $7d0e7eb0e3a76e58$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$7d0e7eb0e3a76e58$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(var i = 1, ii = ends.length; i < ii; ++i){
        if ($7d0e7eb0e3a76e58$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $7d0e7eb0e3a76e58$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if ($7d0e7eb0e3a76e58$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}



var $kzmGH = parcelRequire("kzmGH");
function $c255a8ea33a1a6b5$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, opt_dest) {
    var i, ii, x, x1, x2, y1, y2;
    var y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ var intersections = [];
    // Calculate intersections with the horizontal line
    for(var r = 0, rr = ends.length; r < rr; ++r){
        var end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    var pointX = NaN;
    var maxSegmentLength = -Infinity;
    intersections.sort((0, $kzmGH.numberSafeCompareFunction));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        var segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $7d0e7eb0e3a76e58$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (opt_dest) {
        opt_dest.push(pointX, y, maxSegmentLength);
        return opt_dest;
    } else return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $c255a8ea33a1a6b5$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    var interiorPoints = [];
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        interiorPoints = $c255a8ea33a1a6b5$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}



/**
 * @module ol/geom/flat/intersectsextent
 */ 
var $2Jl0K = parcelRequire("2Jl0K");
/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $ea0949c2dbc314fd$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    var ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}



function $9fc1bfe0d9ae3906$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent) {
    var coordinatesExtent = (0, $2Jl0K.extendFlatCoordinates)((0, $2Jl0K.createEmpty)(), flatCoordinates, offset, end, stride);
    if (!(0, $2Jl0K.intersects)(extent, coordinatesExtent)) return false;
    if ((0, $2Jl0K.containsExtent)(extent, coordinatesExtent)) return true;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2]) return true;
    if (coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $ea0949c2dbc314fd$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $2Jl0K.intersectsSegment)(extent, point1, point2);
    });
}
function $9fc1bfe0d9ae3906$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        if ($9fc1bfe0d9ae3906$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $9fc1bfe0d9ae3906$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($9fc1bfe0d9ae3906$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $7d0e7eb0e3a76e58$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $7d0e7eb0e3a76e58$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $7d0e7eb0e3a76e58$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $7d0e7eb0e3a76e58$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $9fc1bfe0d9ae3906$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$9fc1bfe0d9ae3906$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(var i = 1, ii = ends.length; i < ii; ++i)if ((0, $7d0e7eb0e3a76e58$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$9fc1bfe0d9ae3906$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $9fc1bfe0d9ae3906$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if ($9fc1bfe0d9ae3906$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $4cfbb453753c0b6b$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(var i = 0; i < stride; ++i){
            var tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $22012b047d8e53b3$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    var edge = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $22012b047d8e53b3$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, opt_right) {
    var right = opt_right !== undefined ? opt_right : false;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        var isClockwise = $22012b047d8e53b3$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $22012b047d8e53b3$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, opt_right) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if (!$22012b047d8e53b3$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, opt_right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $22012b047d8e53b3$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, opt_right) {
    var right = opt_right !== undefined ? opt_right : false;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        var isClockwise = $22012b047d8e53b3$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        var reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $4cfbb453753c0b6b$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $22012b047d8e53b3$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, opt_right) {
    for(var i = 0, ii = endss.length; i < ii; ++i)offset = $22012b047d8e53b3$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, opt_right);
    return offset;
}
function $22012b047d8e53b3$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    var endss = [];
    var offset = 0;
    var prevEndIndex = 0;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        if (!$22012b047d8e53b3$export$318f2842ed17e094(flatCoordinates, offset, end, 2)) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}





var $7aO1A = parcelRequire("7aO1A");


var $c59228195e440f9b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ var $c59228195e440f9b$var$Polygon = /** @class */ function(_super) {
    $c59228195e440f9b$var$__extends(Polygon, _super);
    /**
     * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
     *     Array of linear rings that define the polygon. The first linear ring of the
     *     array defines the outer-boundary or surface of the polygon. Each subsequent
     *     linear ring defines a hole in the surface of the polygon. A linear ring is
     *     an array of vertices' coordinates where the first coordinate and the last are
     *     equivalent. (For internal use, flat coordinates in combination with
     *     `opt_layout` and `opt_ends` are also accepted.)
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @param {Array<number>} [opt_ends] Ends (for internal use with flat coordinates).
     */ function Polygon(coordinates, opt_layout, opt_ends) {
        var _this = _super.call(this) || this;
        /**
         * @type {Array<number>}
         * @private
         */ _this.ends_ = [];
        /**
         * @private
         * @type {number}
         */ _this.flatInteriorPointRevision_ = -1;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */ _this.flatInteriorPoint_ = null;
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDeltaRevision_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.orientedRevision_ = -1;
        /**
         * @private
         * @type {Array<number>}
         */ _this.orientedFlatCoordinates_ = null;
        if (opt_layout !== undefined && opt_ends) {
            _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
            _this.ends_ = opt_ends;
        } else _this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, opt_layout);
        return _this;
    }
    /**
     * Append the passed linear ring to this polygon.
     * @param {LinearRing} linearRing Linear ring.
     * @api
     */ Polygon.prototype.appendLinearRing = function(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $kzmGH.extend)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!Polygon} Clone.
     * @api
     */ Polygon.prototype.clone = function() {
        var polygon = new Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ Polygon.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $2Jl0K.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $361a43425a99a2db$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $361a43425a99a2db$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */ Polygon.prototype.containsXY = function(x, y) {
        return (0, $7d0e7eb0e3a76e58$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    };
    /**
     * Return the area of the polygon on projected plane.
     * @return {number} Area (on projected plane).
     * @api
     */ Polygon.prototype.getArea = function() {
        return (0, $94a20b0959033b1b$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    };
    /**
     * Get the coordinate array for this geometry.  This array has the structure
     * of a GeoJSON coordinate array for polygons.
     *
     * @param {boolean} [opt_right] Orient coordinates according to the right-hand
     *     rule (counter-clockwise for exterior and clockwise for interior rings).
     *     If `false`, coordinates will be oriented according to the left-hand rule
     *     (clockwise for exterior and counter-clockwise for interior rings).
     *     By default, coordinate orientation will depend on how the geometry was
     *     constructed.
     * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
     * @api
     */ Polygon.prototype.getCoordinates = function(opt_right) {
        var flatCoordinates;
        if (opt_right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $22012b047d8e53b3$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, opt_right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $f2531bda6eeb448c$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    };
    /**
     * @return {Array<number>} Ends.
     */ Polygon.prototype.getEnds = function() {
        return this.ends_;
    };
    /**
     * @return {Array<number>} Interior point.
     */ Polygon.prototype.getFlatInteriorPoint = function() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            var flatCenter = (0, $2Jl0K.getCenter)(this.getExtent());
            this.flatInteriorPoint_ = (0, $c255a8ea33a1a6b5$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return this.flatInteriorPoint_;
    };
    /**
     * Return an interior point of the polygon.
     * @return {Point} Interior point as XYM coordinate, where M is the
     * length of the horizontal intersection that the point belongs to.
     * @api
     */ Polygon.prototype.getInteriorPoint = function() {
        return new (0, $112514a365e4f8fa$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYM);
    };
    /**
     * Return the number of rings of the polygon,  this includes the exterior
     * ring and any interior rings.
     *
     * @return {number} Number of rings.
     * @api
     */ Polygon.prototype.getLinearRingCount = function() {
        return this.ends_.length;
    };
    /**
     * Return the Nth linear ring of the polygon geometry. Return `null` if the
     * given index is out of range.
     * The exterior linear ring is available at index `0` and the interior rings
     * at index `1` and beyond.
     *
     * @param {number} index Index.
     * @return {LinearRing|null} Linear ring.
     * @api
     */ Polygon.prototype.getLinearRing = function(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $a3079b043d6d17fb$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    };
    /**
     * Return the linear rings of the polygon.
     * @return {Array<LinearRing>} Linear rings.
     * @api
     */ Polygon.prototype.getLinearRings = function() {
        var layout = this.layout;
        var flatCoordinates = this.flatCoordinates;
        var ends = this.ends_;
        var linearRings = [];
        var offset = 0;
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var linearRing = new (0, $a3079b043d6d17fb$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    };
    /**
     * @return {Array<number>} Oriented flat coordinates.
     */ Polygon.prototype.getOrientedFlatCoordinates = function() {
        if (this.orientedRevision_ != this.getRevision()) {
            var flatCoordinates = this.flatCoordinates;
            if ((0, $22012b047d8e53b3$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $22012b047d8e53b3$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return this.orientedFlatCoordinates_;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {Polygon} Simplified Polygon.
     * @protected
     */ Polygon.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $2c00e3f050ec1bce$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new Polygon(simplifiedFlatCoordinates, (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY, simplifiedEnds);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./Geometry.js").Type} Geometry type.
     * @api
     */ Polygon.prototype.getType = function() {
        return 'Polygon';
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ Polygon.prototype.intersectsExtent = function(extent) {
        return (0, $9fc1bfe0d9ae3906$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    };
    /**
     * Set the coordinates of the polygon.
     * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */ Polygon.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        var ends = (0, $63fb5fb55d4eceae$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    };
    return Polygon;
}((0, $29fd4fdf263dcdf4$export$2e2bcd8739ae039));
var $c59228195e440f9b$export$2e2bcd8739ae039 = $c59228195e440f9b$var$Polygon;
function $c59228195e440f9b$export$f99d756c6d81ae3f(center, radius, opt_n, opt_sphereRadius) {
    var n = opt_n ? opt_n : 32;
    /** @type {Array<number>} */ var flatCoordinates = [];
    for(var i = 0; i < n; ++i)(0, $kzmGH.extend)(flatCoordinates, (0, $50cf26750e1d3b86$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, opt_sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $c59228195e440f9b$var$Polygon(flatCoordinates, (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY, [
        flatCoordinates.length
    ]);
}
function $c59228195e440f9b$export$c16b671815801c75(extent) {
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $c59228195e440f9b$var$Polygon(flatCoordinates, (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY, [
        flatCoordinates.length
    ]);
}
function $c59228195e440f9b$export$2451009d645fb8c2(circle, opt_sides, opt_angle) {
    var sides = opt_sides ? opt_sides : 32;
    var stride = circle.getStride();
    var layout = circle.getLayout();
    var center = circle.getCenter();
    var arrayLength = stride * (sides + 1);
    var flatCoordinates = new Array(arrayLength);
    for(var i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(var j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    var ends = [
        flatCoordinates.length
    ];
    var polygon = new $c59228195e440f9b$var$Polygon(flatCoordinates, layout, ends);
    $c59228195e440f9b$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), opt_angle);
    return polygon;
}
function $c59228195e440f9b$export$87d6a1539a56e47f(polygon, center, radius, opt_angle) {
    var flatCoordinates = polygon.getFlatCoordinates();
    var stride = polygon.getStride();
    var sides = flatCoordinates.length / stride - 1;
    var startAngle = opt_angle ? opt_angle : 0;
    for(var i = 0; i <= sides; ++i){
        var offset = i * stride;
        var angle = startAngle + (0, $7aO1A.modulo)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}


var $2412fb7b3f599275$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to fit
 * the extent into. Default is the current size of the first map in the DOM that
 * uses this view, or `[100, 100]` if no such map is found.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center.
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ var $2412fb7b3f599275$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `opt_anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */ var $2412fb7b3f599275$var$View = /** @class */ function(_super) {
    $2412fb7b3f599275$var$__extends(View, _super);
    /**
     * @param {ViewOptions} [opt_options] View options.
     */ function View(opt_options) {
        var _this = _super.call(this) || this;
        /***
         * @type {ViewOnSignature<import("./events").EventsKey>}
         */ _this.on;
        /***
         * @type {ViewOnSignature<import("./events").EventsKey>}
         */ _this.once;
        /***
         * @type {ViewOnSignature<void>}
         */ _this.un;
        var options = (0, $9zTj4.assign)({}, opt_options);
        /**
         * @private
         * @type {Array<number>}
         */ _this.hints_ = [
            0,
            0
        ];
        /**
         * @private
         * @type {Array<Array<Animation>>}
         */ _this.animations_ = [];
        /**
         * @private
         * @type {number|undefined}
         */ _this.updateAnimationKey_;
        /**
         * @private
         * @const
         * @type {import("./proj/Projection.js").default}
         */ _this.projection_ = (0, $d3bc250abc15fbce$export$549167224996a0fb)(options.projection, 'EPSG:3857');
        /**
         * @private
         * @type {import("./size.js").Size}
         */ _this.viewportSize_ = [
            100,
            100
        ];
        /**
         * @private
         * @type {import("./coordinate.js").Coordinate|undefined}
         */ _this.targetCenter_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ _this.targetResolution_;
        /**
         * @private
         * @type {number|undefined}
         */ _this.targetRotation_;
        /**
         * @private
         * @type {import("./coordinate.js").Coordinate}
         */ _this.nextCenter_ = null;
        /**
         * @private
         * @type {number}
         */ _this.nextResolution_;
        /**
         * @private
         * @type {number}
         */ _this.nextRotation_;
        /**
         * @private
         * @type {import("./coordinate.js").Coordinate|undefined}
         */ _this.cancelAnchor_ = undefined;
        if (options.projection) (0, $d3bc250abc15fbce$export$ed949affbc7c4223)();
        if (options.center) options.center = (0, $d3bc250abc15fbce$export$d4b8ec0b96db1ee2)(options.center, _this.projection_);
        if (options.extent) options.extent = (0, $d3bc250abc15fbce$export$494be3a3a25689ca)(options.extent, _this.projection_);
        _this.applyOptions_(options);
        return _this;
    }
    /**
     * Set up the view with the given options.
     * @param {ViewOptions} options View options.
     */ View.prototype.applyOptions_ = function(options) {
        var properties = (0, $9zTj4.assign)({}, options);
        for(var key in 0, $994a9d82d1fc09ff$export$2e2bcd8739ae039)delete properties[key];
        this.setProperties(properties, true);
        var resolutionConstraintInfo = $2412fb7b3f599275$export$c68d65f9148da196(options);
        /**
         * @private
         * @type {number}
         */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
         * @private
         * @type {number}
         */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
         * @private
         * @type {number}
         */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
         * @private
         * @type {Array<number>|undefined}
         */ this.resolutions_ = options.resolutions;
        /**
         * @type {Array<number>|undefined}
         * @private
         */ this.padding_ = options.padding;
        /**
         * @private
         * @type {number}
         */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        var centerConstraint = $2412fb7b3f599275$export$964345001ee9ac52(options);
        var resolutionConstraint = resolutionConstraintInfo.constraint;
        var rotationConstraint = $2412fb7b3f599275$export$4eeaa08dd550e3c0(options);
        /**
         * @private
         * @type {Constraints}
         */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    };
    Object.defineProperty(View.prototype, "padding", {
        /**
         * Padding (in css pixels).
         * If the map viewport is partially covered with other content (overlays) along
         * its edges, this setting allows to shift the center of the viewport away from that
         * content. The order of the values in the array is top, right, bottom, left.
         * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
         * @type {Array<number>|undefined}
         * @api
         */ get: function() {
            return this.padding_;
        },
        set: function(padding) {
            var oldPadding = this.padding_;
            this.padding_ = padding;
            var center = this.getCenter();
            if (center) {
                var newPadding = padding || [
                    0,
                    0,
                    0,
                    0
                ];
                oldPadding = oldPadding || [
                    0,
                    0,
                    0,
                    0
                ];
                var resolution = this.getResolution();
                var offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
                var offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
                this.setCenterInternal([
                    center[0] + offsetX,
                    center[1] - offsetY
                ]);
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Get an updated version of the view options used to construct the view.  The
     * current resolution (or zoom), center, and rotation are applied to any stored
     * options.  The provided options can be used to apply new min/max zoom or
     * resolution limits.
     * @param {ViewOptions} newOptions New options to be applied.
     * @return {ViewOptions} New options updated with the current view state.
     */ View.prototype.getUpdatedOptions_ = function(newOptions) {
        var options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return (0, $9zTj4.assign)({}, options, newOptions);
    };
    /**
     * Animate the view.  The view's center, zoom (or resolution), and rotation
     * can be animated for smooth transitions between view states.  For example,
     * to animate the view to a new zoom level:
     *
     *     view.animate({zoom: view.getZoom() + 1});
     *
     * By default, the animation lasts one second and uses in-and-out easing.  You
     * can customize this behavior by including `duration` (in milliseconds) and
     * `easing` options (see {@link module:ol/easing}).
     *
     * To chain together multiple animations, call the method with multiple
     * animation objects.  For example, to first zoom and then pan:
     *
     *     view.animate({zoom: 10}, {center: [0, 0]});
     *
     * If you provide a function as the last argument to the animate method, it
     * will get called at the end of an animation series.  The callback will be
     * called with `true` if the animation series completed on its own or `false`
     * if it was cancelled.
     *
     * Animations are cancelled by user interactions (e.g. dragging the map) or by
     * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
     * (or another method that calls one of these).
     *
     * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
     *     options.  Multiple animations can be run in series by passing multiple
     *     options objects.  To run multiple animations in parallel, call the method
     *     multiple times.  An optional callback can be provided as a final
     *     argument.  The callback will be called with a boolean indicating whether
     *     the animation completed without being cancelled.
     * @api
     */ View.prototype.animate = function(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; ++i){
            var options = arguments[i];
            if (options.center) {
                options = (0, $9zTj4.assign)({}, options);
                options.center = (0, $d3bc250abc15fbce$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = (0, $9zTj4.assign)({}, options);
                options.anchor = (0, $d3bc250abc15fbce$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    };
    /**
     * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
     */ View.prototype.animateInternal = function(var_args) {
        var animationCount = arguments.length;
        var callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        var i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            var state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $2412fb7b3f599275$var$animationCallback(callback, true);
            return;
        }
        var start = Date.now();
        var center = this.targetCenter_.slice();
        var resolution = this.targetResolution_;
        var rotation = this.targetRotation_;
        var series = [];
        for(; i < animationCount; ++i){
            var options = /** @type {AnimationOptions} */ arguments[i];
            var animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $c2ae491963dea068$export$9b47139b511b56e4),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                var delta = (0, $7aO1A.modulo)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($2412fb7b3f599275$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $ac276e5fd318403e$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    };
    /**
     * Determine if the view is being animated.
     * @return {boolean} The view is being animated.
     * @api
     */ View.prototype.getAnimating = function() {
        return this.hints_[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).ANIMATING] > 0;
    };
    /**
     * Determine if the user is interacting with the view, such as panning or zooming.
     * @return {boolean} The view is being interacted with.
     * @api
     */ View.prototype.getInteracting = function() {
        return this.hints_[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).INTERACTING] > 0;
    };
    /**
     * Cancel any ongoing animations.
     * @api
     */ View.prototype.cancelAnimations = function() {
        this.setHint((0, $ac276e5fd318403e$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).ANIMATING]);
        var anchor;
        for(var i = 0, ii = this.animations_.length; i < ii; ++i){
            var series = this.animations_[i];
            if (series[0].callback) $2412fb7b3f599275$var$animationCallback(series[0].callback, false);
            if (!anchor) for(var j = 0, jj = series.length; j < jj; ++j){
                var animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    };
    /**
     * Update all animations.
     */ View.prototype.updateAnimations_ = function() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        var now = Date.now();
        var more = false;
        for(var i = this.animations_.length - 1; i >= 0; --i){
            var series = this.animations_[i];
            var seriesComplete = true;
            for(var j = 0, jj = series.length; j < jj; ++j){
                var animation = series[j];
                if (animation.complete) continue;
                var elapsed = now - animation.start;
                var fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                var progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    var x0 = animation.sourceCenter[0];
                    var y0 = animation.sourceCenter[1];
                    var x1 = animation.targetCenter[0];
                    var y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    var x = x0 + progress * (x1 - x0);
                    var y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    var resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        var size = this.getViewportSize_(this.getRotation());
                        var constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    var rotation = progress === 1 ? (0, $7aO1A.modulo)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        var constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $ac276e5fd318403e$export$2e2bcd8739ae039).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                var callback = series[0].callback;
                if (callback) $2412fb7b3f599275$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    };
    /**
     * @param {number} rotation Target rotation.
     * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
     * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
     */ View.prototype.calculateCenterRotate = function(rotation, anchor) {
        var center;
        var currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $12736e582a1ee05c$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $12736e582a1ee05c$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    };
    /**
     * @param {number} resolution Target resolution.
     * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
     * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
     */ View.prototype.calculateCenterZoom = function(resolution, anchor) {
        var center;
        var currentCenter = this.getCenterInternal();
        var currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            var x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            var y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    };
    /**
     * Returns the current viewport size.
     * @private
     * @param {number} [opt_rotation] Take into account the rotation of the viewport when giving the size
     * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
     */ View.prototype.getViewportSize_ = function(opt_rotation) {
        var size = this.viewportSize_;
        if (opt_rotation) {
            var w = size[0];
            var h = size[1];
            return [
                Math.abs(w * Math.cos(opt_rotation)) + Math.abs(h * Math.sin(opt_rotation)),
                Math.abs(w * Math.sin(opt_rotation)) + Math.abs(h * Math.cos(opt_rotation))
            ];
        } else return size;
    };
    /**
     * Stores the viewport size on the view. The viewport size is not read every time from the DOM
     * to avoid performance hit and layout reflow.
     * This should be done on map size change.
     * Note: the constraints are not resolved during an animation to avoid stopping it
     * @param {import("./size.js").Size} [opt_size] Viewport size; if undefined, [100, 100] is assumed
     */ View.prototype.setViewportSize = function(opt_size) {
        this.viewportSize_ = Array.isArray(opt_size) ? opt_size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    };
    /**
     * Get the view center.
     * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
     * @observable
     * @api
     */ View.prototype.getCenter = function() {
        var center = this.getCenterInternal();
        if (!center) return center;
        return (0, $d3bc250abc15fbce$export$698f563af1ba02a5)(center, this.getProjection());
    };
    /**
     * Get the view center without transforming to user projection.
     * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
     */ View.prototype.getCenterInternal = function() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).CENTER);
    };
    /**
     * @return {Constraints} Constraints.
     */ View.prototype.getConstraints = function() {
        return this.constraints_;
    };
    /**
     * @return {boolean} Resolution constraint is set
     */ View.prototype.getConstrainResolution = function() {
        return this.get('constrainResolution');
    };
    /**
     * @param {Array<number>} [opt_hints] Destination array.
     * @return {Array<number>} Hint.
     */ View.prototype.getHints = function(opt_hints) {
        if (opt_hints !== undefined) {
            opt_hints[0] = this.hints_[0];
            opt_hints[1] = this.hints_[1];
            return opt_hints;
        } else return this.hints_.slice();
    };
    /**
     * Calculate the extent for the current view state and the passed size.
     * The size is the pixel dimensions of the box into which the calculated extent
     * should fit. In most cases you want to get the extent of the entire map,
     * that is `map.getSize()`.
     * @param {import("./size.js").Size} [opt_size] Box pixel size. If not provided, the size
     * of the map that uses this view will be used.
     * @return {import("./extent.js").Extent} Extent.
     * @api
     */ View.prototype.calculateExtent = function(opt_size) {
        var extent = this.calculateExtentInternal(opt_size);
        return (0, $d3bc250abc15fbce$export$96bfd09e2cffb006)(extent, this.getProjection());
    };
    /**
     * @param {import("./size.js").Size} [opt_size] Box pixel size. If not provided,
     * the map's last known viewport size will be used.
     * @return {import("./extent.js").Extent} Extent.
     */ View.prototype.calculateExtentInternal = function(opt_size) {
        var size = opt_size || this.getViewportSizeMinusPadding_();
        var center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $3JLp3.assert)(center, 1); // The view center is not defined
        var resolution = /** @type {!number} */ this.getResolution();
        (0, $3JLp3.assert)(resolution !== undefined, 2); // The view resolution is not defined
        var rotation = /** @type {!number} */ this.getRotation();
        (0, $3JLp3.assert)(rotation !== undefined, 3); // The view rotation is not defined
        return (0, $2Jl0K.getForViewAndSize)(center, resolution, rotation, size);
    };
    /**
     * Get the maximum resolution of the view.
     * @return {number} The maximum resolution of the view.
     * @api
     */ View.prototype.getMaxResolution = function() {
        return this.maxResolution_;
    };
    /**
     * Get the minimum resolution of the view.
     * @return {number} The minimum resolution of the view.
     * @api
     */ View.prototype.getMinResolution = function() {
        return this.minResolution_;
    };
    /**
     * Get the maximum zoom level for the view.
     * @return {number} The maximum zoom level.
     * @api
     */ View.prototype.getMaxZoom = function() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    };
    /**
     * Set a new maximum zoom level for the view.
     * @param {number} zoom The maximum zoom level.
     * @api
     */ View.prototype.setMaxZoom = function(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    };
    /**
     * Get the minimum zoom level for the view.
     * @return {number} The minimum zoom level.
     * @api
     */ View.prototype.getMinZoom = function() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    };
    /**
     * Set a new minimum zoom level for the view.
     * @param {number} zoom The minimum zoom level.
     * @api
     */ View.prototype.setMinZoom = function(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    };
    /**
     * Set whether the view should allow intermediary zoom levels.
     * @param {boolean} enabled Whether the resolution is constrained.
     * @api
     */ View.prototype.setConstrainResolution = function(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    };
    /**
     * Get the view projection.
     * @return {import("./proj/Projection.js").default} The projection of the view.
     * @api
     */ View.prototype.getProjection = function() {
        return this.projection_;
    };
    /**
     * Get the view resolution.
     * @return {number|undefined} The resolution of the view.
     * @observable
     * @api
     */ View.prototype.getResolution = function() {
        return /** @type {number|undefined} */ this.get((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).RESOLUTION);
    };
    /**
     * Get the resolutions for the view. This returns the array of resolutions
     * passed to the constructor of the View, or undefined if none were given.
     * @return {Array<number>|undefined} The resolutions of the view.
     * @api
     */ View.prototype.getResolutions = function() {
        return this.resolutions_;
    };
    /**
     * Get the resolution for a provided extent (in map units) and size (in pixels).
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {import("./size.js").Size} [opt_size] Box pixel size.
     * @return {number} The resolution at which the provided extent will render at
     *     the given size.
     * @api
     */ View.prototype.getResolutionForExtent = function(extent, opt_size) {
        return this.getResolutionForExtentInternal((0, $d3bc250abc15fbce$export$494be3a3a25689ca)(extent, this.getProjection()), opt_size);
    };
    /**
     * Get the resolution for a provided extent (in map units) and size (in pixels).
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {import("./size.js").Size} [opt_size] Box pixel size.
     * @return {number} The resolution at which the provided extent will render at
     *     the given size.
     */ View.prototype.getResolutionForExtentInternal = function(extent, opt_size) {
        var size = opt_size || this.getViewportSizeMinusPadding_();
        var xResolution = (0, $2Jl0K.getWidth)(extent) / size[0];
        var yResolution = (0, $2Jl0K.getHeight)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    };
    /**
     * Return a function that returns a value between 0 and 1 for a
     * resolution. Exponential scaling is assumed.
     * @param {number} [opt_power] Power.
     * @return {function(number): number} Resolution for value function.
     */ View.prototype.getResolutionForValueFunction = function(opt_power) {
        var power = opt_power || 2;
        var maxResolution = this.getConstrainedResolution(this.maxResolution_);
        var minResolution = this.minResolution_;
        var max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
         * @param {number} value Value.
         * @return {number} Resolution.
         */ function(value) {
            var resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    };
    /**
     * Get the view rotation.
     * @return {number} The rotation of the view in radians.
     * @observable
     * @api
     */ View.prototype.getRotation = function() {
        return /** @type {number} */ this.get((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).ROTATION);
    };
    /**
     * Return a function that returns a resolution for a value between
     * 0 and 1. Exponential scaling is assumed.
     * @param {number} [opt_power] Power.
     * @return {function(number): number} Value for resolution function.
     */ View.prototype.getValueForResolutionFunction = function(opt_power) {
        var logPower = Math.log(opt_power || 2);
        var maxResolution = this.getConstrainedResolution(this.maxResolution_);
        var minResolution = this.minResolution_;
        var max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
         * @param {number} resolution Resolution.
         * @return {number} Value.
         */ function(resolution) {
            var value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    };
    /**
     * Returns the size of the viewport minus padding.
     * @private
     * @param {number} [opt_rotation] Take into account the rotation of the viewport when giving the size
     * @return {import("./size.js").Size} Viewport size reduced by the padding.
     */ View.prototype.getViewportSizeMinusPadding_ = function(opt_rotation) {
        var size = this.getViewportSize_(opt_rotation);
        var padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    };
    /**
     * @return {State} View state.
     */ View.prototype.getState = function() {
        var projection = this.getProjection();
        var resolution = this.getResolution();
        var rotation = this.getRotation();
        var center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        var padding = this.padding_;
        if (padding) {
            var reducedSize = this.getViewportSizeMinusPadding_();
            center = $2412fb7b3f599275$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    };
    /**
     * Get the current zoom level. This method may return non-integer zoom levels
     * if the view does not constrain the resolution, or if an interaction or
     * animation is underway.
     * @return {number|undefined} Zoom.
     * @api
     */ View.prototype.getZoom = function() {
        var zoom;
        var resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    };
    /**
     * Get the zoom level for a resolution.
     * @param {number} resolution The resolution.
     * @return {number|undefined} The zoom level for the provided resolution.
     * @api
     */ View.prototype.getZoomForResolution = function(resolution) {
        var offset = this.minZoom_ || 0;
        var max, zoomFactor;
        if (this.resolutions_) {
            var nearest = (0, $kzmGH.linearFindNearest)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    };
    /**
     * Get the resolution for a zoom level.
     * @param {number} zoom Zoom level.
     * @return {number} The view resolution for the provided zoom level.
     * @api
     */ View.prototype.getResolutionForZoom = function(zoom) {
        if (this.resolutions_) {
            if (this.resolutions_.length <= 1) return 0;
            var baseLevel = (0, $7aO1A.clamp)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            var zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $7aO1A.clamp)(zoom - baseLevel, 0, 1));
        } else return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    };
    /**
     * Fit the given geometry or extent based on the given map size and border.
     * The size is pixel dimensions of the box to fit the extent into.
     * In most cases you will want to use the map size, that is `map.getSize()`.
     * Takes care of the map angle.
     * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
     *     extent to fit the view to.
     * @param {FitOptions} [opt_options] Options.
     * @api
     */ View.prototype.fit = function(geometryOrExtent, opt_options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ var geometry;
        (0, $3JLp3.assert)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === 'function', 24); // Invalid extent or geometry provided as `geometry`
        if (Array.isArray(geometryOrExtent)) {
            (0, $3JLp3.assert)(!(0, $2Jl0K.isEmpty)(geometryOrExtent), 25); // Cannot fit empty extent provided as `geometry`
            var extent = (0, $d3bc250abc15fbce$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
            geometry = (0, $c59228195e440f9b$export$c16b671815801c75)(extent);
        } else if (geometryOrExtent.getType() === 'Circle') {
            var extent = (0, $d3bc250abc15fbce$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $c59228195e440f9b$export$c16b671815801c75)(extent);
            geometry.rotate(this.getRotation(), (0, $2Jl0K.getCenter)(extent));
        } else {
            var userProjection = (0, $d3bc250abc15fbce$export$3973b77d5f6f2790)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, opt_options);
    };
    /**
     * Calculate rotated extent
     * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
     * @return {import("./extent").Extent} The rotated extent for the geometry.
     */ View.prototype.rotatedExtentForGeometry = function(geometry) {
        var rotation = this.getRotation();
        var cosAngle = Math.cos(rotation);
        var sinAngle = Math.sin(-rotation);
        var coords = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        var minRotX = Infinity;
        var minRotY = Infinity;
        var maxRotX = -Infinity;
        var maxRotY = -Infinity;
        for(var i = 0, ii = coords.length; i < ii; i += stride){
            var rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            var rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    };
    /**
     * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
     * @param {FitOptions} [opt_options] Options.
     */ View.prototype.fitInternal = function(geometry, opt_options) {
        var options = opt_options || {};
        var size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        var padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        var nearest = options.nearest !== undefined ? options.nearest : false;
        var minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        var rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        var resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        var rotation = this.getRotation();
        var sinAngle = Math.sin(rotation);
        var cosAngle = Math.cos(rotation);
        var centerRot = (0, $2Jl0K.getCenter)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        var centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        var centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        var center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        var callback = options.callback ? options.callback : (0, $c8IGo.VOID);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $2412fb7b3f599275$var$animationCallback(callback, true);
        }
    };
    /**
     * Center on coordinate and view position.
     * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("./size.js").Size} size Box pixel size.
     * @param {import("./pixel.js").Pixel} position Position on the view to center on.
     * @api
     */ View.prototype.centerOn = function(coordinate, size, position) {
        this.centerOnInternal((0, $d3bc250abc15fbce$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
    };
    /**
     * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("./size.js").Size} size Box pixel size.
     * @param {import("./pixel.js").Pixel} position Position on the view to center on.
     */ View.prototype.centerOnInternal = function(coordinate, size, position) {
        this.setCenterInternal($2412fb7b3f599275$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    };
    /**
     * Calculates the shift between map and viewport center.
     * @param {import("./coordinate.js").Coordinate} center Center.
     * @param {number} resolution Resolution.
     * @param {number} rotation Rotation.
     * @param {import("./size.js").Size} size Size.
     * @return {Array<number>|undefined} Center shift.
     */ View.prototype.calculateCenterShift = function(center, resolution, rotation, size) {
        var centerShift;
        var padding = this.padding_;
        if (padding && center) {
            var reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            var shiftedCenter = $2412fb7b3f599275$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    };
    /**
     * @return {boolean} Is defined.
     */ View.prototype.isDef = function() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    };
    /**
     * Adds relative coordinates to the center of the view. Any extent constraint will apply.
     * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
     * @api
     */ View.prototype.adjustCenter = function(deltaCoordinates) {
        var center = (0, $d3bc250abc15fbce$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    };
    /**
     * Adds relative coordinates to the center of the view. Any extent constraint will apply.
     * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
     */ View.prototype.adjustCenterInternal = function(deltaCoordinates) {
        var center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    };
    /**
     * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
     * constraint will apply.
     * @param {number} ratio The ratio to apply on the view resolution.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     * @api
     */ View.prototype.adjustResolution = function(ratio, opt_anchor) {
        var anchor = opt_anchor && (0, $d3bc250abc15fbce$export$d4b8ec0b96db1ee2)(opt_anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    };
    /**
     * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
     * constraint will apply.
     * @param {number} ratio The ratio to apply on the view resolution.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     */ View.prototype.adjustResolutionInternal = function(ratio, opt_anchor) {
        var isMoving = this.getAnimating() || this.getInteracting();
        var size = this.getViewportSize_(this.getRotation());
        var newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (opt_anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, opt_anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    };
    /**
     * Adds a value to the view zoom level, optionally using an anchor. Any resolution
     * constraint will apply.
     * @param {number} delta Relative value to add to the zoom level.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     * @api
     */ View.prototype.adjustZoom = function(delta, opt_anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), opt_anchor);
    };
    /**
     * Adds a value to the view rotation, optionally using an anchor. Any rotation
     * constraint will apply.
     * @param {number} delta Relative value to add to the zoom rotation, in radians.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The rotation center.
     * @api
     */ View.prototype.adjustRotation = function(delta, opt_anchor) {
        if (opt_anchor) opt_anchor = (0, $d3bc250abc15fbce$export$d4b8ec0b96db1ee2)(opt_anchor, this.getProjection());
        this.adjustRotationInternal(delta, opt_anchor);
    };
    /**
     * @param {number} delta Relative value to add to the zoom rotation, in radians.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The rotation center.
     */ View.prototype.adjustRotationInternal = function(delta, opt_anchor) {
        var isMoving = this.getAnimating() || this.getInteracting();
        var newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (opt_anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, opt_anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    };
    /**
     * Set the center of the current view. Any extent constraint will apply.
     * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
     * @observable
     * @api
     */ View.prototype.setCenter = function(center) {
        this.setCenterInternal(center ? (0, $d3bc250abc15fbce$export$d4b8ec0b96db1ee2)(center, this.getProjection()) : center);
    };
    /**
     * Set the center using the view projection (not the user projection).
     * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
     */ View.prototype.setCenterInternal = function(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    };
    /**
     * @param {import("./ViewHint.js").default} hint Hint.
     * @param {number} delta Delta.
     * @return {number} New value.
     */ View.prototype.setHint = function(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    };
    /**
     * Set the resolution for this view. Any resolution constraint will apply.
     * @param {number|undefined} resolution The resolution of the view.
     * @observable
     * @api
     */ View.prototype.setResolution = function(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    };
    /**
     * Set the rotation for this view. Any rotation constraint will apply.
     * @param {number} rotation The rotation of the view in radians.
     * @observable
     * @api
     */ View.prototype.setRotation = function(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    };
    /**
     * Zoom to a specific zoom level. Any resolution constrain will apply.
     * @param {number} zoom Zoom level.
     * @api
     */ View.prototype.setZoom = function(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    };
    /**
     * Recompute rotation/resolution/center based on target values.
     * Note: we have to compute rotation first, then resolution and center considering that
     * parameters can influence one another in case a view extent constraint is present.
     * @param {boolean} [opt_doNotCancelAnims] Do not cancel animations.
     * @param {boolean} [opt_forceMoving] Apply constraints as if the view is moving.
     * @private
     */ View.prototype.applyTargetState_ = function(opt_doNotCancelAnims, opt_forceMoving) {
        var isMoving = this.getAnimating() || this.getInteracting() || opt_forceMoving;
        // compute rotation
        var newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        var size = this.getViewportSize_(newRotation);
        var newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        var newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).ROTATION, newRotation);
        if (this.get((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) {
            this.set((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).RESOLUTION, newResolution);
            this.set('zoom', this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).CENTER) || !(0, $12736e582a1ee05c$export$e9bab7fafb253603)(this.get((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $994a9d82d1fc09ff$export$2e2bcd8739ae039).CENTER, newCenter);
        if (this.getAnimating() && !opt_doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    };
    /**
     * If any constraints need to be applied, an animation will be triggered.
     * This is typically done on interaction end.
     * Note: calling this with a duration of 0 will apply the constrained values straight away,
     * without animation.
     * @param {number} [opt_duration] The animation duration in ms.
     * @param {number} [opt_resolutionDirection] Which direction to zoom.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     */ View.prototype.resolveConstraints = function(opt_duration, opt_resolutionDirection, opt_anchor) {
        var duration = opt_duration !== undefined ? opt_duration : 200;
        var direction = opt_resolutionDirection || 0;
        var newRotation = this.constraints_.rotation(this.targetRotation_);
        var size = this.getViewportSize_(newRotation);
        var newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        var newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        var anchor = opt_anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $12736e582a1ee05c$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $c2ae491963dea068$export$57636bb43b1ccbb0),
                anchor: anchor
            });
        }
    };
    /**
     * Notify the View that an interaction has started.
     * The view state will be resolved to a stable one if needed
     * (depending on its constraints).
     * @api
     */ View.prototype.beginInteraction = function() {
        this.resolveConstraints(0);
        this.setHint((0, $ac276e5fd318403e$export$2e2bcd8739ae039).INTERACTING, 1);
    };
    /**
     * Notify the View that an interaction has ended. The view state will be resolved
     * to a stable one if needed (depending on its constraints).
     * @param {number} [opt_duration] Animation duration in ms.
     * @param {number} [opt_resolutionDirection] Which direction to zoom.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     * @api
     */ View.prototype.endInteraction = function(opt_duration, opt_resolutionDirection, opt_anchor) {
        var anchor = opt_anchor && (0, $d3bc250abc15fbce$export$d4b8ec0b96db1ee2)(opt_anchor, this.getProjection());
        this.endInteractionInternal(opt_duration, opt_resolutionDirection, anchor);
    };
    /**
     * Notify the View that an interaction has ended. The view state will be resolved
     * to a stable one if needed (depending on its constraints).
     * @param {number} [opt_duration] Animation duration in ms.
     * @param {number} [opt_resolutionDirection] Which direction to zoom.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     */ View.prototype.endInteractionInternal = function(opt_duration, opt_resolutionDirection, opt_anchor) {
        this.setHint((0, $ac276e5fd318403e$export$2e2bcd8739ae039).INTERACTING, -1);
        this.resolveConstraints(opt_duration, opt_resolutionDirection, opt_anchor);
    };
    /**
     * Get a valid position for the view center according to the current constraints.
     * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
     * @param {number} [opt_targetResolution] Target resolution. If not supplied, the current one will be used.
     * This is useful to guess a valid center position at a different zoom level.
     * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
     */ View.prototype.getConstrainedCenter = function(targetCenter, opt_targetResolution) {
        var size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, opt_targetResolution || this.getResolution(), size);
    };
    /**
     * Get a valid zoom level according to the current view constraints.
     * @param {number|undefined} targetZoom Target zoom.
     * @param {number} [opt_direction=0] Indicate which resolution should be used
     * by a renderer if the view resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @return {number|undefined} Valid zoom level.
     */ View.prototype.getConstrainedZoom = function(targetZoom, opt_direction) {
        var targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, opt_direction));
    };
    /**
     * Get a valid resolution according to the current view constraints.
     * @param {number|undefined} targetResolution Target resolution.
     * @param {number} [opt_direction=0] Indicate which resolution should be used
     * by a renderer if the view resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @return {number|undefined} Valid resolution.
     */ View.prototype.getConstrainedResolution = function(targetResolution, opt_direction) {
        var direction = opt_direction || 0;
        var size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    };
    return View;
}((0, $aK3Yt.default));
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $2412fb7b3f599275$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $2412fb7b3f599275$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        var smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $90017e35853d4679$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    var projection = (0, $d3bc250abc15fbce$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        var extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $90017e35853d4679$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $90017e35853d4679$export$f883a24d5edde77c;
}
function $2412fb7b3f599275$export$c68d65f9148da196(options) {
    var resolutionConstraint;
    var maxResolution;
    var minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    var defaultMaxZoom = 28;
    var defaultZoomFactor = 2;
    var minZoom = options.minZoom !== undefined ? options.minZoom : $2412fb7b3f599275$var$DEFAULT_MIN_ZOOM;
    var maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    var zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    var multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    var smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    var showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    var projection = (0, $d3bc250abc15fbce$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    var projExtent = projection.getExtent();
    var constrainOnlyCenter = options.constrainOnlyCenter;
    var extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        var resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $93e76560ea94c6e3$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $93e76560ea94c6e3$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        var size = !projExtent ? 360 * (0, $bcf733fece57bacd$export$1482081eec883108)[(0, $bcf733fece57bacd$export$2e2bcd8739ae039).DEGREES] / projection.getMetersPerUnit() : Math.max((0, $2Jl0K.getWidth)(projExtent), (0, $2Jl0K.getHeight)(projExtent));
        var defaultMaxResolution = size / (0, $abdd446e0816dd65$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $2412fb7b3f599275$var$DEFAULT_MIN_ZOOM);
        var defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $2412fb7b3f599275$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $93e76560ea94c6e3$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $93e76560ea94c6e3$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $2412fb7b3f599275$export$4eeaa08dd550e3c0(options) {
    var enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        var constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $ca456328cb3fb311$export$17a6e6f3448b17e8)();
        else if (constrainRotation === false) return 0, $ca456328cb3fb311$export$f883a24d5edde77c;
        else if (typeof constrainRotation === 'number') return (0, $ca456328cb3fb311$export$9ba78806de831083)(constrainRotation);
        else return 0, $ca456328cb3fb311$export$f883a24d5edde77c;
    } else return 0, $ca456328cb3fb311$export$e20fbacbb41798b;
}
function $2412fb7b3f599275$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $12736e582a1ee05c$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $2412fb7b3f599275$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    var cosAngle = Math.cos(-rotation);
    var sinAngle = Math.sin(-rotation);
    var rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    var rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    var centerX = rotX * cosAngle - rotY * sinAngle;
    var centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $2412fb7b3f599275$export$2e2bcd8739ae039 = $2412fb7b3f599275$var$View;




var $bInFo = parcelRequire("bInFo");

var $c8IGo = parcelRequire("c8IGo");


var $3JLp3 = parcelRequire("3JLp3");

var $2Jl0K = parcelRequire("2Jl0K");


var $61DUI = parcelRequire("61DUI");
/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [opt_size] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $defec9fd2d3eaefa$export$ab1029bcae9ddb4a(size, num, opt_size) {
    if (opt_size === undefined) opt_size = [
        0,
        0
    ];
    opt_size[0] = size[0] + 2 * num;
    opt_size[1] = size[1] + 2 * num;
    return opt_size;
}
function $defec9fd2d3eaefa$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $defec9fd2d3eaefa$export$dcdf75081b88279d(size, ratio, opt_size) {
    if (opt_size === undefined) opt_size = [
        0,
        0
    ];
    opt_size[0] = size[0] * ratio + 0.5 | 0;
    opt_size[1] = size[1] * ratio + 0.5 | 0;
    return opt_size;
}
function $defec9fd2d3eaefa$export$a71a825ff42fb8e1(size, opt_size) {
    if (Array.isArray(size)) return size;
    else {
        if (opt_size === undefined) opt_size = [
            size,
            size
        ];
        else {
            opt_size[0] = size;
            opt_size[1] = size;
        }
        return opt_size;
    }
}



var $1dBX3 = parcelRequire("1dBX3");

var $djuby = parcelRequire("djuby");
var $87c438a1b4e0406a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {import("rbush").default} declutterTree DeclutterTree.
 * @property {null|import("./extent.js").Extent} extent Extent.
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(PluggableMap, ?FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} PluggableMapOnSignature
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $87c438a1b4e0406a$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $93a49300d1913509$export$2e2bcd8739ae039)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $827vD.default)) layer.getLayers().forEach($87c438a1b4e0406a$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {PluggableMap} map Map.
 */ function $87c438a1b4e0406a$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $93a49300d1913509$export$2e2bcd8739ae039)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $827vD.default)) {
        var layers = layer.getLayers().getArray();
        for(var i = 0, ii = layers.length; i < ii; ++i)$87c438a1b4e0406a$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ var $87c438a1b4e0406a$var$PluggableMap = /** @class */ function(_super) {
    $87c438a1b4e0406a$var$__extends(PluggableMap, _super);
    /**
     * @param {MapOptions} options Map options.
     */ function PluggableMap(options) {
        var _this = _super.call(this) || this;
        /***
         * @type {PluggableMapOnSignature<import("./events").EventsKey>}
         */ _this.on;
        /***
         * @type {PluggableMapOnSignature<import("./events").EventsKey>}
         */ _this.once;
        /***
         * @type {PluggableMapOnSignature<void>}
         */ _this.un;
        var optionsInternal = $87c438a1b4e0406a$var$createOptionsInternal(options);
        /**
         * @private
         * @type {boolean|undefined}
         */ _this.renderComplete_;
        /**
         * @private
         * @type {boolean}
         */ _this.loaded_ = true;
        /** @private */ _this.boundHandleBrowserEvent_ = _this.handleBrowserEvent.bind(_this);
        /**
         * @type {number}
         * @private
         */ _this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
         * @private
         * @type {number}
         */ _this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $bInFo.DEVICE_PIXEL_RATIO);
        /**
         * @private
         * @type {*}
         */ _this.postRenderTimeoutHandle_;
        /**
         * @private
         * @type {number|undefined}
         */ _this.animationDelayKey_;
        /**
         * @private
         */ _this.animationDelay_ = /** @this {PluggableMap} */ (function() {
            this.animationDelayKey_ = undefined;
            this.renderFrame_(Date.now());
        }).bind(_this);
        /**
         * @private
         * @type {import("./transform.js").Transform}
         */ _this.coordinateToPixelTransform_ = (0, $04c1ab69f17a669b$export$185802fd694ee1f5)();
        /**
         * @private
         * @type {import("./transform.js").Transform}
         */ _this.pixelToCoordinateTransform_ = (0, $04c1ab69f17a669b$export$185802fd694ee1f5)();
        /**
         * @private
         * @type {number}
         */ _this.frameIndex_ = 0;
        /**
         * @private
         * @type {?FrameState}
         */ _this.frameState_ = null;
        /**
         * The extent at the previous 'moveend' event.
         * @private
         * @type {import("./extent.js").Extent}
         */ _this.previousExtent_ = null;
        /**
         * @private
         * @type {?import("./events.js").EventsKey}
         */ _this.viewPropertyListenerKey_ = null;
        /**
         * @private
         * @type {?import("./events.js").EventsKey}
         */ _this.viewChangeListenerKey_ = null;
        /**
         * @private
         * @type {?Array<import("./events.js").EventsKey>}
         */ _this.layerGroupPropertyListenerKeys_ = null;
        /**
         * @private
         * @type {!HTMLElement}
         */ _this.viewport_ = document.createElement('div');
        _this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
        _this.viewport_.style.position = 'relative';
        _this.viewport_.style.overflow = 'hidden';
        _this.viewport_.style.width = '100%';
        _this.viewport_.style.height = '100%';
        /**
         * @private
         * @type {!HTMLElement}
         */ _this.overlayContainer_ = document.createElement('div');
        _this.overlayContainer_.style.position = 'absolute';
        _this.overlayContainer_.style.zIndex = '0';
        _this.overlayContainer_.style.width = '100%';
        _this.overlayContainer_.style.height = '100%';
        _this.overlayContainer_.style.pointerEvents = 'none';
        _this.overlayContainer_.className = 'ol-overlaycontainer';
        _this.viewport_.appendChild(_this.overlayContainer_);
        /**
         * @private
         * @type {!HTMLElement}
         */ _this.overlayContainerStopEvent_ = document.createElement('div');
        _this.overlayContainerStopEvent_.style.position = 'absolute';
        _this.overlayContainerStopEvent_.style.zIndex = '0';
        _this.overlayContainerStopEvent_.style.width = '100%';
        _this.overlayContainerStopEvent_.style.height = '100%';
        _this.overlayContainerStopEvent_.style.pointerEvents = 'none';
        _this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
        _this.viewport_.appendChild(_this.overlayContainerStopEvent_);
        /**
         * @private
         * @type {MapBrowserEventHandler}
         */ _this.mapBrowserEventHandler_ = null;
        /**
         * @private
         * @type {number}
         */ _this.moveTolerance_ = options.moveTolerance;
        /**
         * @private
         * @type {HTMLElement|Document}
         */ _this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
         * @private
         * @type {?Array<import("./events.js").EventsKey>}
         */ _this.targetChangeHandlerKeys_ = null;
        /**
         * @type {Collection<import("./control/Control.js").default>}
         * @protected
         */ _this.controls = optionsInternal.controls || new (0, $1IaXJ.default)();
        /**
         * @type {Collection<import("./interaction/Interaction.js").default>}
         * @protected
         */ _this.interactions = optionsInternal.interactions || new (0, $1IaXJ.default)();
        /**
         * @type {Collection<import("./Overlay.js").default>}
         * @private
         */ _this.overlays_ = optionsInternal.overlays;
        /**
         * A lookup of overlays by id.
         * @private
         * @type {Object<string, import("./Overlay.js").default>}
         */ _this.overlayIdIndex_ = {};
        /**
         * @type {import("./renderer/Map.js").default|null}
         * @private
         */ _this.renderer_ = null;
        /**
         * @private
         * @type {!Array<PostRenderFunction>}
         */ _this.postRenderFunctions_ = [];
        /**
         * @private
         * @type {TileQueue}
         */ _this.tileQueue_ = new (0, $dffd9e2300ce6cad$export$2e2bcd8739ae039)(_this.getTilePriority.bind(_this), _this.handleTileChange_.bind(_this));
        _this.addChangeListener((0, $6a407377901e6ead$export$2e2bcd8739ae039).LAYERGROUP, _this.handleLayerGroupChanged_);
        _this.addChangeListener((0, $6a407377901e6ead$export$2e2bcd8739ae039).VIEW, _this.handleViewChanged_);
        _this.addChangeListener((0, $6a407377901e6ead$export$2e2bcd8739ae039).SIZE, _this.handleSizeChanged_);
        _this.addChangeListener((0, $6a407377901e6ead$export$2e2bcd8739ae039).TARGET, _this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        _this.setProperties(optionsInternal.values);
        var map = _this;
        if (options.view && !(options.view instanceof (0, $2412fb7b3f599275$export$2e2bcd8739ae039))) options.view.then(function(viewOptions) {
            map.setView(new (0, $2412fb7b3f599275$export$2e2bcd8739ae039)(viewOptions));
        });
        _this.controls.addEventListener((0, $59kE1.default).ADD, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            event.element.setMap(this);
        }).bind(_this));
        _this.controls.addEventListener((0, $59kE1.default).REMOVE, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            event.element.setMap(null);
        }).bind(_this));
        _this.interactions.addEventListener((0, $59kE1.default).ADD, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            event.element.setMap(this);
        }).bind(_this));
        _this.interactions.addEventListener((0, $59kE1.default).REMOVE, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            event.element.setMap(null);
        }).bind(_this));
        _this.overlays_.addEventListener((0, $59kE1.default).ADD, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            this.addOverlayInternal_(/** @type {import("./Overlay.js").default} */ event.element);
        }).bind(_this));
        _this.overlays_.addEventListener((0, $59kE1.default).REMOVE, /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */ (function(event) {
            var overlay = /** @type {import("./Overlay.js").default} */ event.element;
            var id = overlay.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        }).bind(_this));
        _this.controls.forEach(/**
         * @param {import("./control/Control.js").default} control Control.
         * @this {PluggableMap}
         */ (function(control) {
            control.setMap(this);
        }).bind(_this));
        _this.interactions.forEach(/**
         * @param {import("./interaction/Interaction.js").default} interaction Interaction.
         * @this {PluggableMap}
         */ (function(interaction) {
            interaction.setMap(this);
        }).bind(_this));
        _this.overlays_.forEach(_this.addOverlayInternal_.bind(_this));
        return _this;
    }
    /**
     * @abstract
     * @return {import("./renderer/Map.js").default} The map renderer
     */ PluggableMap.prototype.createRenderer = function() {
        throw new Error('Use a map type that has a createRenderer method');
    };
    /**
     * Add the given control to the map.
     * @param {import("./control/Control.js").default} control Control.
     * @api
     */ PluggableMap.prototype.addControl = function(control) {
        this.getControls().push(control);
    };
    /**
     * Add the given interaction to the map. If you want to add an interaction
     * at another point of the collection use `getInteractions()` and the methods
     * available on {@link module:ol/Collection~Collection}. This can be used to
     * stop the event propagation from the handleEvent function. The interactions
     * get to handle the events in the reverse order of this collection.
     * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
     * @api
     */ PluggableMap.prototype.addInteraction = function(interaction) {
        this.getInteractions().push(interaction);
    };
    /**
     * Adds the given layer to the top of this map. If you want to add a layer
     * elsewhere in the stack, use `getLayers()` and the methods available on
     * {@link module:ol/Collection~Collection}.
     * @param {import("./layer/Base.js").default} layer Layer.
     * @api
     */ PluggableMap.prototype.addLayer = function(layer) {
        var layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    };
    /**
     * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
     * @private
     */ PluggableMap.prototype.handleLayerAdd_ = function(event) {
        $87c438a1b4e0406a$var$setLayerMapProperty(event.layer, this);
    };
    /**
     * Add the given overlay to the map.
     * @param {import("./Overlay.js").default} overlay Overlay.
     * @api
     */ PluggableMap.prototype.addOverlay = function(overlay) {
        this.getOverlays().push(overlay);
    };
    /**
     * This deals with map's overlay collection changes.
     * @param {import("./Overlay.js").default} overlay Overlay.
     * @private
     */ PluggableMap.prototype.addOverlayInternal_ = function(overlay) {
        var id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    };
    /**
     *
     * Clean up.
     */ PluggableMap.prototype.disposeInternal = function() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.setTarget(null);
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Detect features that intersect a pixel on the viewport, and execute a
     * callback with each intersecting feature. Layers included in the detection can
     * be configured through the `layerFilter` option in `opt_options`.
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
     *     called with two arguments. The first argument is one
     *     {@link module:ol/Feature~Feature feature} or
     *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
     *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
     *     unmanaged layers. To stop detection, callback functions can return a
     *     truthy value.
     * @param {AtPixelOptions} [opt_options] Optional options.
     * @return {T|undefined} Callback result, i.e. the return value of last
     * callback execution, or the first truthy callback return value.
     * @template T
     * @api
     */ PluggableMap.prototype.forEachFeatureAtPixel = function(pixel, callback, opt_options) {
        if (!this.frameState_ || !this.renderer_) return;
        var coordinate = this.getCoordinateFromPixelInternal(pixel);
        opt_options = opt_options !== undefined ? opt_options : {};
        var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance : 0;
        var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : (0, $c8IGo.TRUE);
        var checkWrapped = opt_options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    };
    /**
     * Get all features that intersect a pixel on the viewport.
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {AtPixelOptions} [opt_options] Optional options.
     * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
     * an empty array if none were found.
     * @api
     */ PluggableMap.prototype.getFeaturesAtPixel = function(pixel, opt_options) {
        var features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, opt_options);
        return features;
    };
    /**
     * Get all layers from all layer groups.
     * @return {Array<import("./layer/Layer.js").default>} Layers.
     * @api
     */ PluggableMap.prototype.getAllLayers = function() {
        var layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $827vD.default)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    };
    /**
     * Please the `layer.getData()` method for {@link module:ol/layer/Tile~TileLayer#getData tile layers} or
     * {@link module:ol/layer/Image~ImageLayer#getData image layers} instead of using this method.
     *
     * Detect layers that have a color value at a pixel on the viewport, and
     * execute a callback with each matching layer. Layers included in the
     * detection can be configured through `opt_layerFilter`.
     *
     * Note: In maps with more than one layer, this method will typically return pixel data
     * representing the composed image of all layers visible at the given pixel – because layers
     * will generally share the same rendering context.  To force layers to render separately, and
     * to get pixel data representing only one layer at a time, you can assign each layer a unique
     * `className` in its constructor.
     *
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {function(this: S, import("./layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback
     *     Layer callback. This callback will receive two arguments: first is the
     *     {@link module:ol/layer/Layer~Layer layer}, second argument is an array representing
     *     [R, G, B, A] pixel values (0 - 255) and will be `null` for layer types
     *     that do not currently support this argument. To stop detection, callback
     *     functions can return a truthy value.
     * @param {AtPixelOptions} [opt_options] Configuration options.
     * @return {T|undefined} Callback result, i.e. the return value of last
     * callback execution, or the first truthy callback return value.
     * @template S,T
     * @api
     * @deprecated
     */ PluggableMap.prototype.forEachLayerAtPixel = function(pixel, callback, opt_options) {
        if (!this.frameState_ || !this.renderer_) return;
        var options = opt_options || {};
        var hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        var layerFilter = options.layerFilter || (0, $c8IGo.TRUE);
        return this.renderer_.forEachLayerAtPixel(pixel, this.frameState_, hitTolerance, callback, layerFilter);
    };
    /**
     * Detect if features intersect a pixel on the viewport. Layers included in the
     * detection can be configured through `opt_layerFilter`.
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {AtPixelOptions} [opt_options] Optional options.
     * @return {boolean} Is there a feature at the given pixel?
     * @api
     */ PluggableMap.prototype.hasFeatureAtPixel = function(pixel, opt_options) {
        if (!this.frameState_ || !this.renderer_) return false;
        var coordinate = this.getCoordinateFromPixelInternal(pixel);
        opt_options = opt_options !== undefined ? opt_options : {};
        var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : (0, $c8IGo.TRUE);
        var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance : 0;
        var checkWrapped = opt_options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    };
    /**
     * Returns the coordinate in user projection for a browser event.
     * @param {MouseEvent} event Event.
     * @return {import("./coordinate.js").Coordinate} Coordinate.
     * @api
     */ PluggableMap.prototype.getEventCoordinate = function(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    };
    /**
     * Returns the coordinate in view projection for a browser event.
     * @param {MouseEvent} event Event.
     * @return {import("./coordinate.js").Coordinate} Coordinate.
     */ PluggableMap.prototype.getEventCoordinateInternal = function(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    };
    /**
     * Returns the map pixel position for a browser event relative to the viewport.
     * @param {UIEvent} event Event.
     * @return {import("./pixel.js").Pixel} Pixel.
     * @api
     */ PluggableMap.prototype.getEventPixel = function(event) {
        var viewportPosition = this.viewport_.getBoundingClientRect();
        var eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            eventPosition.clientX - viewportPosition.left,
            eventPosition.clientY - viewportPosition.top
        ];
    };
    /**
     * Get the target in which this map is rendered.
     * Note that this returns what is entered as an option or in setTarget:
     * if that was an element, it returns an element; if a string, it returns that.
     * @return {HTMLElement|string|undefined} The Element or id of the Element that the
     *     map is rendered in.
     * @observable
     * @api
     */ PluggableMap.prototype.getTarget = function() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $6a407377901e6ead$export$2e2bcd8739ae039).TARGET);
    };
    /**
     * Get the DOM element into which this map is rendered. In contrast to
     * `getTarget` this method always return an `Element`, or `null` if the
     * map has no target.
     * @return {HTMLElement} The element that the map is rendered in.
     * @api
     */ PluggableMap.prototype.getTargetElement = function() {
        var target = this.getTarget();
        if (target !== undefined) return typeof target === 'string' ? document.getElementById(target) : target;
        else return null;
    };
    /**
     * Get the coordinate for a given pixel.  This returns a coordinate in the
     * user projection.
     * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
     * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
     * @api
     */ PluggableMap.prototype.getCoordinateFromPixel = function(pixel) {
        return (0, $d3bc250abc15fbce$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    };
    /**
     * Get the coordinate for a given pixel.  This returns a coordinate in the
     * map view projection.
     * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
     * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
     */ PluggableMap.prototype.getCoordinateFromPixelInternal = function(pixel) {
        var frameState = this.frameState_;
        if (!frameState) return null;
        else return (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    };
    /**
     * Get the map controls. Modifying this collection changes the controls
     * associated with the map.
     * @return {Collection<import("./control/Control.js").default>} Controls.
     * @api
     */ PluggableMap.prototype.getControls = function() {
        return this.controls;
    };
    /**
     * Get the map overlays. Modifying this collection changes the overlays
     * associated with the map.
     * @return {Collection<import("./Overlay.js").default>} Overlays.
     * @api
     */ PluggableMap.prototype.getOverlays = function() {
        return this.overlays_;
    };
    /**
     * Get an overlay by its identifier (the value returned by overlay.getId()).
     * Note that the index treats string and numeric identifiers as the same. So
     * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
     * @param {string|number} id Overlay identifier.
     * @return {import("./Overlay.js").default} Overlay.
     * @api
     */ PluggableMap.prototype.getOverlayById = function(id) {
        var overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    };
    /**
     * Get the map interactions. Modifying this collection changes the interactions
     * associated with the map.
     *
     * Interactions are used for e.g. pan, zoom and rotate.
     * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
     * @api
     */ PluggableMap.prototype.getInteractions = function() {
        return this.interactions;
    };
    /**
     * Get the layergroup associated with this map.
     * @return {LayerGroup} A layer group containing the layers in this map.
     * @observable
     * @api
     */ PluggableMap.prototype.getLayerGroup = function() {
        return /** @type {LayerGroup} */ this.get((0, $6a407377901e6ead$export$2e2bcd8739ae039).LAYERGROUP);
    };
    /**
     * Clear any existing layers and add layers to the map.
     * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
     * @api
     */ PluggableMap.prototype.setLayers = function(layers) {
        var group = this.getLayerGroup();
        if (layers instanceof (0, $1IaXJ.default)) {
            group.setLayers(layers);
            return;
        }
        var collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    };
    /**
     * Get the collection of layers associated with this map.
     * @return {!Collection<import("./layer/Base.js").default>} Layers.
     * @api
     */ PluggableMap.prototype.getLayers = function() {
        var layers = this.getLayerGroup().getLayers();
        return layers;
    };
    /**
     * @return {boolean} Layers have sources that are still loading.
     */ PluggableMap.prototype.getLoadingOrNotReady = function() {
        var layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(var i = 0, ii = layerStatesArray.length; i < ii; ++i){
            var state = layerStatesArray[i];
            if (!state.visible) continue;
            var renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            var source = /** @type {import("./layer/Layer.js").default} */ state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    };
    /**
     * Get the pixel for a coordinate.  This takes a coordinate in the user
     * projection and returns the corresponding pixel.
     * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
     * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
     * @api
     */ PluggableMap.prototype.getPixelFromCoordinate = function(coordinate) {
        var viewCoordinate = (0, $d3bc250abc15fbce$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    };
    /**
     * Get the pixel for a coordinate.  This takes a coordinate in the map view
     * projection and returns the corresponding pixel.
     * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
     * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
     */ PluggableMap.prototype.getPixelFromCoordinateInternal = function(coordinate) {
        var frameState = this.frameState_;
        if (!frameState) return null;
        else return (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    };
    /**
     * Get the map renderer.
     * @return {import("./renderer/Map.js").default|null} Renderer
     */ PluggableMap.prototype.getRenderer = function() {
        return this.renderer_;
    };
    /**
     * Get the size of this map.
     * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
     * @observable
     * @api
     */ PluggableMap.prototype.getSize = function() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $6a407377901e6ead$export$2e2bcd8739ae039).SIZE);
    };
    /**
     * Get the view associated with this map. A view manages properties such as
     * center and resolution.
     * @return {View} The view that controls this map.
     * @observable
     * @api
     */ PluggableMap.prototype.getView = function() {
        return /** @type {View} */ this.get((0, $6a407377901e6ead$export$2e2bcd8739ae039).VIEW);
    };
    /**
     * Get the element that serves as the map viewport.
     * @return {HTMLElement} Viewport.
     * @api
     */ PluggableMap.prototype.getViewport = function() {
        return this.viewport_;
    };
    /**
     * Get the element that serves as the container for overlays.  Elements added to
     * this container will let mousedown and touchstart events through to the map,
     * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
     * events.
     * @return {!HTMLElement} The map's overlay container.
     */ PluggableMap.prototype.getOverlayContainer = function() {
        return this.overlayContainer_;
    };
    /**
     * Get the element that serves as a container for overlays that don't allow
     * event propagation. Elements added to this container won't let mousedown and
     * touchstart events through to the map, so clicks and gestures on an overlay
     * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @return {!HTMLElement} The map's overlay container that stops events.
     */ PluggableMap.prototype.getOverlayContainerStopEvent = function() {
        return this.overlayContainerStopEvent_;
    };
    /**
     * @return {!Document} The document where the map is displayed.
     */ PluggableMap.prototype.getOwnerDocument = function() {
        var targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    };
    /**
     * @param {import("./Tile.js").default} tile Tile.
     * @param {string} tileSourceKey Tile source key.
     * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
     * @param {number} tileResolution Tile resolution.
     * @return {number} Tile priority.
     */ PluggableMap.prototype.getTilePriority = function(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $dffd9e2300ce6cad$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    };
    /**
     * @param {UIEvent} browserEvent Browser event.
     * @param {string} [opt_type] Type.
     */ PluggableMap.prototype.handleBrowserEvent = function(browserEvent, opt_type) {
        var type = opt_type || browserEvent.type;
        var mapBrowserEvent = new (0, $88b67309459b310d$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    };
    /**
     * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
     */ PluggableMap.prototype.handleMapBrowserEvent = function(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        var originalEvent = /** @type {PointerEvent} */ mapBrowserEvent.originalEvent;
        var eventType = originalEvent.type;
        if (eventType === (0, $a4a8db35606260c6$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $cFmyb.default).WHEEL || eventType === (0, $cFmyb.default).KEYDOWN) {
            var doc = this.getOwnerDocument();
            var rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            var target = /** @type {Node} */ originalEvent.target;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !(rootNode === doc ? doc.documentElement : rootNode).contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            var interactionsArray = this.getInteractions().getArray().slice();
            for(var i = interactionsArray.length - 1; i >= 0; i--){
                var interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                var cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    };
    /**
     * @protected
     */ PluggableMap.prototype.handlePostRender = function() {
        var frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        var tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            var maxTotalLoading = this.maxTilesLoading_;
            var maxNewLoads = maxTotalLoading;
            if (frameState) {
                var hints = frameState.viewHints;
                if (hints[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).INTERACTING]) {
                    var lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_ === true) {
                if (this.hasListener((0, $91e6c6ef4a46bd39$export$2e2bcd8739ae039).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $91e6c6ef4a46bd39$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $187787b2a6a7ea44$export$2e2bcd8739ae039)((0, $9UyUk.default).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $187787b2a6a7ea44$export$2e2bcd8739ae039)((0, $9UyUk.default).LOADSTART, this, frameState));
            }
        }
        var postRenderFunctions = this.postRenderFunctions_;
        for(var i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    };
    /**
     * @private
     */ PluggableMap.prototype.handleSizeChanged_ = function() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    };
    /**
     * @private
     */ PluggableMap.prototype.handleTargetChanged_ = function() {
        if (this.mapBrowserEventHandler_) {
            for(var i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $1dBX3.unlistenByKey)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $cFmyb.default).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $cFmyb.default).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            (0, $djuby.removeNode)(this.viewport_);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        var targetElement = this.getTargetElement();
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = this.createRenderer();
            this.mapBrowserEventHandler_ = new (0, $7697e90dbe4e7e44$export$2e2bcd8739ae039)(this, this.moveTolerance_);
            for(var key in 0, $39a924385cecd177$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $39a924385cecd177$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
            this.viewport_.addEventListener((0, $cFmyb.default).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
            this.viewport_.addEventListener((0, $cFmyb.default).WHEEL, this.boundHandleBrowserEvent_, (0, $bInFo.PASSIVE_EVENT_LISTENERS) ? {
                passive: false
            } : false);
            var defaultView = this.getOwnerDocument().defaultView;
            var keyboardEventTarget = !this.keyboardEventTarget_ ? targetElement : this.keyboardEventTarget_;
            this.targetChangeHandlerKeys_ = [
                (0, $1dBX3.listen)(keyboardEventTarget, (0, $cFmyb.default).KEYDOWN, this.handleBrowserEvent, this),
                (0, $1dBX3.listen)(keyboardEventTarget, (0, $cFmyb.default).KEYPRESS, this.handleBrowserEvent, this),
                (0, $1dBX3.listen)(defaultView, (0, $cFmyb.default).RESIZE, this.updateSize, this)
            ];
        }
        this.updateSize();
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    };
    /**
     * @private
     */ PluggableMap.prototype.handleTileChange_ = function() {
        this.render();
    };
    /**
     * @private
     */ PluggableMap.prototype.handleViewPropertyChanged_ = function() {
        this.render();
    };
    /**
     * @private
     */ PluggableMap.prototype.handleViewChanged_ = function() {
        if (this.viewPropertyListenerKey_) {
            (0, $1dBX3.unlistenByKey)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $1dBX3.unlistenByKey)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        var view = this.getView();
        if (view) {
            this.updateViewportSize_();
            this.viewPropertyListenerKey_ = (0, $1dBX3.listen)(view, (0, $48iCR.default).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $1dBX3.listen)(view, (0, $cFmyb.default).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    };
    /**
     * @private
     */ PluggableMap.prototype.handleLayerGroupChanged_ = function() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $1dBX3.unlistenByKey));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        var layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $827vD.GroupEvent)('addlayer', layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $1dBX3.listen)(layerGroup, (0, $48iCR.default).PROPERTYCHANGE, this.render, this),
                (0, $1dBX3.listen)(layerGroup, (0, $cFmyb.default).CHANGE, this.render, this),
                (0, $1dBX3.listen)(layerGroup, 'addlayer', this.handleLayerAdd_, this),
                (0, $1dBX3.listen)(layerGroup, 'removelayer', this.handleLayerRemove_, this)
            ];
        }
        this.render();
    };
    /**
     * @return {boolean} Is rendered.
     */ PluggableMap.prototype.isRendered = function() {
        return !!this.frameState_;
    };
    /**
     * Requests an immediate render in a synchronous manner.
     * @api
     */ PluggableMap.prototype.renderSync = function() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    };
    /**
     * Redraws all text after new fonts have loaded
     */ PluggableMap.prototype.redrawText = function() {
        var layerStates = this.getLayerGroup().getLayerStatesArray();
        for(var i = 0, ii = layerStates.length; i < ii; ++i){
            var layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    };
    /**
     * Request a map rendering (at the next animation frame).
     * @api
     */ PluggableMap.prototype.render = function() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    };
    /**
     * Remove the given control from the map.
     * @param {import("./control/Control.js").default} control Control.
     * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
     *     if the control was not found).
     * @api
     */ PluggableMap.prototype.removeControl = function(control) {
        return this.getControls().remove(control);
    };
    /**
     * Remove the given interaction from the map.
     * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
     * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
     *     undefined if the interaction was not found).
     * @api
     */ PluggableMap.prototype.removeInteraction = function(interaction) {
        return this.getInteractions().remove(interaction);
    };
    /**
     * Removes the given layer from the map.
     * @param {import("./layer/Base.js").default} layer Layer.
     * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
     *     layer was not found).
     * @api
     */ PluggableMap.prototype.removeLayer = function(layer) {
        var layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    };
    /**
     * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
     * @private
     */ PluggableMap.prototype.handleLayerRemove_ = function(event) {
        $87c438a1b4e0406a$var$removeLayerMapProperty(event.layer);
    };
    /**
     * Remove the given overlay from the map.
     * @param {import("./Overlay.js").default} overlay Overlay.
     * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
     *     if the overlay was not found).
     * @api
     */ PluggableMap.prototype.removeOverlay = function(overlay) {
        return this.getOverlays().remove(overlay);
    };
    /**
     * @param {number} time Time.
     * @private
     */ PluggableMap.prototype.renderFrame_ = function(time) {
        var _this = this;
        var size = this.getSize();
        var view = this.getView();
        var previousFrameState = this.frameState_;
        /** @type {?FrameState} */ var frameState = null;
        if (size !== undefined && (0, $defec9fd2d3eaefa$export$622c471beb1693c7)(size) && view && view.isDef()) {
            var viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            var viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutterTree: null,
                extent: (0, $2Jl0K.getForViewAndSize)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $61DUI.getUid)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                var rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $2Jl0K.getForViewAndSize)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        /** @type {import("./renderer/Map.js").default} */ this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                var moveStart = !this.previousExtent_ || !(0, $2Jl0K.isEmpty)(this.previousExtent_) && !(0, $2Jl0K.equals)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $187787b2a6a7ea44$export$2e2bcd8739ae039)((0, $9UyUk.default).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $2Jl0K.createOrUpdateEmpty)(this.previousExtent_);
                }
            }
            var idle = this.previousExtent_ && !frameState.viewHints[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).INTERACTING] && !(0, $2Jl0K.equals)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $187787b2a6a7ea44$export$2e2bcd8739ae039)((0, $9UyUk.default).MOVEEND, this, frameState));
                (0, $2Jl0K.clone)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $187787b2a6a7ea44$export$2e2bcd8739ae039)((0, $9UyUk.default).POSTRENDER, this, frameState));
        this.renderComplete_ = this.hasListener((0, $9UyUk.default).LOADSTART) || this.hasListener((0, $9UyUk.default).LOADEND) || this.hasListener((0, $91e6c6ef4a46bd39$export$2e2bcd8739ae039).RENDERCOMPLETE) ? !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady() : undefined;
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(function() {
            _this.postRenderTimeoutHandle_ = undefined;
            _this.handlePostRender();
        }, 0);
    };
    /**
     * Sets the layergroup of this map.
     * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
     * @observable
     * @api
     */ PluggableMap.prototype.setLayerGroup = function(layerGroup) {
        var oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $827vD.GroupEvent)('removelayer', oldLayerGroup));
        this.set((0, $6a407377901e6ead$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    };
    /**
     * Set the size of this map.
     * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
     * @observable
     * @api
     */ PluggableMap.prototype.setSize = function(size) {
        this.set((0, $6a407377901e6ead$export$2e2bcd8739ae039).SIZE, size);
    };
    /**
     * Set the target element to render this map into.
     * @param {HTMLElement|string} [target] The Element or id of the Element
     *     that the map is rendered in.
     * @observable
     * @api
     */ PluggableMap.prototype.setTarget = function(target) {
        this.set((0, $6a407377901e6ead$export$2e2bcd8739ae039).TARGET, target);
    };
    /**
     * Set the view for this map.
     * @param {View|Promise<import("./View.js").ViewOptions>} view The view that controls this map.
     * It is also possible to pass a promise that resolves to options for constructing a view.  This
     * alternative allows view properties to be resolved by sources or other components that load
     * view-related metadata.
     * @observable
     * @api
     */ PluggableMap.prototype.setView = function(view) {
        if (!view || view instanceof (0, $2412fb7b3f599275$export$2e2bcd8739ae039)) {
            this.set((0, $6a407377901e6ead$export$2e2bcd8739ae039).VIEW, view);
            return;
        }
        this.set((0, $6a407377901e6ead$export$2e2bcd8739ae039).VIEW, new (0, $2412fb7b3f599275$export$2e2bcd8739ae039)());
        var map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $2412fb7b3f599275$export$2e2bcd8739ae039)(viewOptions));
        });
    };
    /**
     * Force a recalculation of the map viewport size.  This should be called when
     * third-party code changes the size of the map viewport.
     * @api
     */ PluggableMap.prototype.updateSize = function() {
        var targetElement = this.getTargetElement();
        var size = undefined;
        if (targetElement) {
            var computedStyle = getComputedStyle(targetElement);
            var width = targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']);
            var height = targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth']);
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    width,
                    height
                ];
                if (!(0, $defec9fd2d3eaefa$export$622c471beb1693c7)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) // eslint-disable-next-line
                console.warn("No map visible because the map container's width or height are 0.");
            }
        }
        this.setSize(size);
        this.updateViewportSize_();
    };
    /**
     * Recomputes the viewport size and save it on the view object (if any)
     * @private
     */ PluggableMap.prototype.updateViewportSize_ = function() {
        var view = this.getView();
        if (view) {
            var size = undefined;
            var computedStyle = getComputedStyle(this.viewport_);
            if (computedStyle.width && computedStyle.height) size = [
                parseInt(computedStyle.width, 10),
                parseInt(computedStyle.height, 10)
            ];
            view.setViewportSize(size);
        }
    };
    return PluggableMap;
}((0, $aK3Yt.default));
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $87c438a1b4e0406a$var$createOptionsInternal(options) {
    /**
     * @type {HTMLElement|Document}
     */ var keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
     * @type {Object<string, *>}
     */ var values = {};
    var layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === 'function' ? /** @type {LayerGroup} */ options.layers : new (0, $827vD.default)({
        layers: /** @type {Collection} */ options.layers
    });
    values[(0, $6a407377901e6ead$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $6a407377901e6ead$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $6a407377901e6ead$export$2e2bcd8739ae039).VIEW] = options.view instanceof (0, $2412fb7b3f599275$export$2e2bcd8739ae039) ? options.view : new (0, $2412fb7b3f599275$export$2e2bcd8739ae039)();
    var controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $1IaXJ.default)(options.controls.slice());
        else {
            (0, $3JLp3.assert)(typeof /** @type {?} */ options.controls.getArray === 'function', 47); // Expected `controls` to be an array or an `import("./Collection.js").Collection`
            controls = /** @type {Collection} */ options.controls;
        }
    }
    var interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $1IaXJ.default)(options.interactions.slice());
        else {
            (0, $3JLp3.assert)(typeof /** @type {?} */ options.interactions.getArray === 'function', 48); // Expected `interactions` to be an array or an `import("./Collection.js").Collection`
            interactions = /** @type {Collection} */ options.interactions;
        }
    }
    var overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $1IaXJ.default)(options.overlays.slice());
        else {
            (0, $3JLp3.assert)(typeof /** @type {?} */ options.overlays.getArray === 'function', 49); // Expected `overlays` to be an array or an `import("./Collection.js").Collection`
            overlays = options.overlays;
        }
    } else overlays = new (0, $1IaXJ.default)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $87c438a1b4e0406a$export$2e2bcd8739ae039 = $87c438a1b4e0406a$var$PluggableMap;



var $9zTj4 = parcelRequire("9zTj4");
/**
 * @module ol/control
 */ 
var $hsGuz = parcelRequire("hsGuz");

var $cFmyb = parcelRequire("cFmyb");


var $kzmGH = parcelRequire("kzmGH");


var $djuby = parcelRequire("djuby");
var $a302bca812250dec$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ var $a302bca812250dec$var$Attribution = /** @class */ function(_super) {
    $a302bca812250dec$var$__extends(Attribution, _super);
    /**
     * @param {Options} [opt_options] Attribution options.
     */ function Attribution(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        }) || this;
        /**
         * @private
         * @type {HTMLElement}
         */ _this.ulElement_ = document.createElement('ul');
        /**
         * @private
         * @type {boolean}
         */ _this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
         * @private
         * @type {boolean}
         */ _this.userCollapsed_ = _this.collapsed_;
        /**
         * @private
         * @type {boolean}
         */ _this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
         * @private
         * @type {boolean}
         */ _this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!_this.collapsible_) _this.collapsed_ = false;
        var className = options.className !== undefined ? options.className : 'ol-attribution';
        var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        var expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
        var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u203A';
        var collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collapse';
        if (typeof collapseLabel === 'string') {
            /**
             * @private
             * @type {HTMLElement}
             */ _this.collapseLabel_ = document.createElement('span');
            _this.collapseLabel_.textContent = collapseLabel;
            _this.collapseLabel_.className = collapseClassName;
        } else _this.collapseLabel_ = collapseLabel;
        var label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
             * @private
             * @type {HTMLElement}
             */ _this.label_ = document.createElement('span');
            _this.label_.textContent = label;
            _this.label_.className = expandClassName;
        } else _this.label_ = label;
        var activeLabel = _this.collapsible_ && !_this.collapsed_ ? _this.collapseLabel_ : _this.label_;
        /**
         * @private
         * @type {HTMLElement}
         */ _this.toggleButton_ = document.createElement('button');
        _this.toggleButton_.setAttribute('type', 'button');
        _this.toggleButton_.setAttribute('aria-expanded', String(!_this.collapsed_));
        _this.toggleButton_.title = tipLabel;
        _this.toggleButton_.appendChild(activeLabel);
        _this.toggleButton_.addEventListener((0, $cFmyb.default).CLICK, _this.handleClick_.bind(_this), false);
        var cssClasses = className + ' ' + (0, $d7810add910403af$export$1afde3d6e16a7b29) + ' ' + (0, $d7810add910403af$export$4d4f8be70b656192) + (_this.collapsed_ && _this.collapsible_ ? ' ' + (0, $d7810add910403af$export$e16017ac68d14492) : '') + (_this.collapsible_ ? '' : ' ol-uncollapsible');
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(_this.toggleButton_);
        element.appendChild(_this.ulElement_);
        /**
         * A list of currently rendered resolutions.
         * @type {Array<string>}
         * @private
         */ _this.renderedAttributions_ = [];
        /**
         * @private
         * @type {boolean}
         */ _this.renderedVisible_ = true;
        return _this;
    }
    /**
     * Collect a list of visible attributions and set the collapsible state.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @return {Array<string>} Attributions.
     * @private
     */ Attribution.prototype.collectSourceAttributions_ = function(frameState) {
        /**
         * Used to determine if an attribution already exists.
         * @type {!Object<string, boolean>}
         */ var lookup = {};
        /**
         * A list of visible attributions.
         * @type {Array<string>}
         */ var visibleAttributions = [];
        var collapsible = true;
        var layerStatesArray = frameState.layerStatesArray;
        for(var i = 0, ii = layerStatesArray.length; i < ii; ++i){
            var layerState = layerStatesArray[i];
            if (!(0, $93a49300d1913509$export$acb1e9cb9ce4ca56)(layerState, frameState.viewState)) continue;
            var source = /** @type {import("../layer/Layer.js").default} */ layerState.layer.getSource();
            if (!source) continue;
            var attributionGetter = source.getAttributions();
            if (!attributionGetter) continue;
            var attributions = attributionGetter(frameState);
            if (!attributions) continue;
            collapsible = collapsible && source.getAttributionsCollapsible() !== false;
            if (Array.isArray(attributions)) {
                for(var j = 0, jj = attributions.length; j < jj; ++j)if (!(attributions[j] in lookup)) {
                    visibleAttributions.push(attributions[j]);
                    lookup[attributions[j]] = true;
                }
            } else if (!(attributions in lookup)) {
                visibleAttributions.push(attributions);
                lookup[attributions] = true;
            }
        }
        if (!this.overrideCollapsible_) this.setCollapsible(collapsible);
        return visibleAttributions;
    };
    /**
     * @private
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     */ Attribution.prototype.updateElement_ = function(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        var attributions = this.collectSourceAttributions_(frameState);
        var visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if ((0, $kzmGH.equals)(attributions, this.renderedAttributions_)) return;
        (0, $djuby.removeChildren)(this.ulElement_);
        // append the attributions
        for(var i = 0, ii = attributions.length; i < ii; ++i){
            var element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    };
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */ Attribution.prototype.handleClick_ = function(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    };
    /**
     * @private
     */ Attribution.prototype.handleToggle_ = function() {
        this.element.classList.toggle((0, $d7810add910403af$export$e16017ac68d14492));
        if (this.collapsed_) (0, $djuby.replaceNode)(this.collapseLabel_, this.label_);
        else (0, $djuby.replaceNode)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
    };
    /**
     * Return `true` if the attribution is collapsible, `false` otherwise.
     * @return {boolean} True if the widget is collapsible.
     * @api
     */ Attribution.prototype.getCollapsible = function() {
        return this.collapsible_;
    };
    /**
     * Set whether the attribution should be collapsible.
     * @param {boolean} collapsible True if the widget is collapsible.
     * @api
     */ Attribution.prototype.setCollapsible = function(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) this.handleToggle_();
    };
    /**
     * Collapse or expand the attribution according to the passed parameter. Will
     * not do anything if the attribution isn't collapsible or if the current
     * collapsed state is already the one requested.
     * @param {boolean} collapsed True if the widget is collapsed.
     * @api
     */ Attribution.prototype.setCollapsed = function(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    };
    /**
     * Return `true` when the attribution is currently collapsed or `false`
     * otherwise.
     * @return {boolean} True if the widget is collapsed.
     * @api
     */ Attribution.prototype.getCollapsed = function() {
        return this.collapsed_;
    };
    /**
     * Update the attribution element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */ Attribution.prototype.render = function(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    };
    return Attribution;
}((0, $hsGuz.default));
var $a302bca812250dec$export$2e2bcd8739ae039 = $a302bca812250dec$var$Attribution;



var $1IaXJ = parcelRequire("1IaXJ");

var $hsGuz = parcelRequire("hsGuz");

var $cFmyb = parcelRequire("cFmyb");


var $303797b83c7bae6b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ var $303797b83c7bae6b$var$Rotate = /** @class */ function(_super) {
    $303797b83c7bae6b$var$__extends(Rotate, _super);
    /**
     * @param {Options} [opt_options] Rotate options.
     */ function Rotate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        }) || this;
        var className = options.className !== undefined ? options.className : 'ol-rotate';
        var label = options.label !== undefined ? options.label : '\u21E7';
        var compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
        /**
         * @type {HTMLElement}
         * @private
         */ _this.label_ = null;
        if (typeof label === 'string') {
            _this.label_ = document.createElement('span');
            _this.label_.className = compassClassName;
            _this.label_.textContent = label;
        } else {
            _this.label_ = label;
            _this.label_.classList.add(compassClassName);
        }
        var tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        var button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(_this.label_);
        button.addEventListener((0, $cFmyb.default).CLICK, _this.handleClick_.bind(_this), false);
        var cssClasses = className + ' ' + (0, $d7810add910403af$export$1afde3d6e16a7b29) + ' ' + (0, $d7810add910403af$export$4d4f8be70b656192);
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(button);
        _this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
         * @type {number}
         * @private
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
         * @type {boolean}
         * @private
         */ _this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
         * @private
         * @type {number|undefined}
         */ _this.rotation_ = undefined;
        if (_this.autoHide_) _this.element.classList.add((0, $d7810add910403af$export$981241db82723ce2));
        return _this;
    }
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */ Rotate.prototype.handleClick_ = function(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    };
    /**
     * @private
     */ Rotate.prototype.resetNorth_ = function() {
        var map = this.getMap();
        var view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        var rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $c2ae491963dea068$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    };
    /**
     * Update the rotate control element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */ Rotate.prototype.render = function(mapEvent) {
        var frameState = mapEvent.frameState;
        if (!frameState) return;
        var rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            var transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                var contains = this.element.classList.contains((0, $d7810add910403af$export$981241db82723ce2));
                if (!contains && rotation === 0) this.element.classList.add((0, $d7810add910403af$export$981241db82723ce2));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $d7810add910403af$export$981241db82723ce2));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    };
    return Rotate;
}((0, $hsGuz.default));
var $303797b83c7bae6b$export$2e2bcd8739ae039 = $303797b83c7bae6b$var$Rotate;



var $hsGuz = parcelRequire("hsGuz");

var $cFmyb = parcelRequire("cFmyb");


var $fea8b78478fa4759$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ var $fea8b78478fa4759$var$Zoom = /** @class */ function(_super) {
    $fea8b78478fa4759$var$__extends(Zoom, _super);
    /**
     * @param {Options} [opt_options] Zoom options.
     */ function Zoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            target: options.target
        }) || this;
        var className = options.className !== undefined ? options.className : 'ol-zoom';
        var delta = options.delta !== undefined ? options.delta : 1;
        var zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
        var zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
        var zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        var zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2013';
        var zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        var zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
        var inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $cFmyb.default).CLICK, _this.handleClick_.bind(_this, delta), false);
        var outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $cFmyb.default).CLICK, _this.handleClick_.bind(_this, -delta), false);
        var cssClasses = className + ' ' + (0, $d7810add910403af$export$1afde3d6e16a7b29) + ' ' + (0, $d7810add910403af$export$4d4f8be70b656192);
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
         * @type {number}
         * @private
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * @param {number} delta Zoom delta.
     * @param {MouseEvent} event The event to handle
     * @private
     */ Zoom.prototype.handleClick_ = function(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    };
    /**
     * @param {number} delta Zoom delta.
     * @private
     */ Zoom.prototype.zoomByDelta_ = function(delta) {
        var map = this.getMap();
        var view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        var currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            var newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $c2ae491963dea068$export$57636bb43b1ccbb0)
                });
            } else view.setZoom(newZoom);
        }
    };
    return Zoom;
}((0, $hsGuz.default));
var $fea8b78478fa4759$export$2e2bcd8739ae039 = $fea8b78478fa4759$var$Zoom;









function $84cb1fa596e4ae73$export$ebe90cb607ad99e(opt_options) {
    var options = opt_options ? opt_options : {};
    var controls = new (0, $1IaXJ.default)();
    var zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $fea8b78478fa4759$export$2e2bcd8739ae039)(options.zoomOptions));
    var rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $303797b83c7bae6b$export$2e2bcd8739ae039)(options.rotateOptions));
    var attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $a302bca812250dec$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}


/**
 * @module ol/interaction
 */ 
var $1IaXJ = parcelRequire("1IaXJ");

var $aK3Yt = parcelRequire("aK3Yt");
/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $39e17cfcf879d614$export$2e2bcd8739ae039 = {
    ACTIVE: 'active'
};



var $ea3f0e79150889b8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ var $ea3f0e79150889b8$var$Interaction = /** @class */ function(_super) {
    $ea3f0e79150889b8$var$__extends(Interaction, _super);
    /**
     * @param {InteractionOptions} [opt_options] Options.
     */ function Interaction(opt_options) {
        var _this = _super.call(this) || this;
        /***
         * @type {InteractionOnSignature<import("../events").EventsKey>}
         */ _this.on;
        /***
         * @type {InteractionOnSignature<import("../events").EventsKey>}
         */ _this.once;
        /***
         * @type {InteractionOnSignature<void>}
         */ _this.un;
        if (opt_options && opt_options.handleEvent) _this.handleEvent = opt_options.handleEvent;
        /**
         * @private
         * @type {import("../PluggableMap.js").default|null}
         */ _this.map_ = null;
        _this.setActive(true);
        return _this;
    }
    /**
     * Return whether the interaction is currently active.
     * @return {boolean} `true` if the interaction is active, `false` otherwise.
     * @observable
     * @api
     */ Interaction.prototype.getActive = function() {
        return /** @type {boolean} */ this.get((0, $39e17cfcf879d614$export$2e2bcd8739ae039).ACTIVE);
    };
    /**
     * Get the map associated with this interaction.
     * @return {import("../PluggableMap.js").default|null} Map.
     * @api
     */ Interaction.prototype.getMap = function() {
        return this.map_;
    };
    /**
     * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @api
     */ Interaction.prototype.handleEvent = function(mapBrowserEvent) {
        return true;
    };
    /**
     * Activate or deactivate the interaction.
     * @param {boolean} active Active.
     * @observable
     * @api
     */ Interaction.prototype.setActive = function(active) {
        this.set((0, $39e17cfcf879d614$export$2e2bcd8739ae039).ACTIVE, active);
    };
    /**
     * Remove the interaction from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default|null} map Map.
     */ Interaction.prototype.setMap = function(map) {
        this.map_ = map;
    };
    return Interaction;
}((0, $aK3Yt.default));
function $ea3f0e79150889b8$export$4c486572e961a974(view, delta, opt_duration) {
    var currentCenter = view.getCenterInternal();
    if (currentCenter) {
        var center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: opt_duration !== undefined ? opt_duration : 250,
            easing: (0, $c2ae491963dea068$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $ea3f0e79150889b8$export$ace321ff2a8016ef(view, delta, opt_anchor, opt_duration) {
    var currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    var newZoom = view.getConstrainedZoom(currentZoom + delta);
    var newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: opt_anchor,
        duration: opt_duration !== undefined ? opt_duration : 250,
        easing: (0, $c2ae491963dea068$export$57636bb43b1ccbb0)
    });
}
var $ea3f0e79150889b8$export$2e2bcd8739ae039 = $ea3f0e79150889b8$var$Interaction;



var $3df464bfb61d4cf3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ var $3df464bfb61d4cf3$var$DoubleClickZoom = /** @class */ function(_super) {
    $3df464bfb61d4cf3$var$__extends(DoubleClickZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function DoubleClickZoom(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {number}
         */ _this.delta_ = options.delta ? options.delta : 1;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
     * doubleclick) and eventually zooms the map.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     */ DoubleClickZoom.prototype.handleEvent = function(mapBrowserEvent) {
        var stopEvent = false;
        if (mapBrowserEvent.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).DBLCLICK) {
            var browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            var map = mapBrowserEvent.map;
            var anchor = mapBrowserEvent.coordinate;
            var delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            var view = map.getView();
            (0, $ea3f0e79150889b8$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    };
    return DoubleClickZoom;
}((0, $ea3f0e79150889b8$export$2e2bcd8739ae039));
var $3df464bfb61d4cf3$export$2e2bcd8739ae039 = $3df464bfb61d4cf3$var$DoubleClickZoom;




var $56152f51d97b61e4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ var $56152f51d97b61e4$var$PointerInteraction = /** @class */ function(_super) {
    $56152f51d97b61e4$var$__extends(PointerInteraction, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function PointerInteraction(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, /** @type {import("./Interaction.js").InteractionOptions} */ options) || this;
        if (options.handleDownEvent) _this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) _this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) _this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) _this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) _this.stopDown = options.stopDown;
        /**
         * @type {boolean}
         * @protected
         */ _this.handlingDownUpSequence = false;
        /**
         * @type {Array<PointerEvent>}
         * @protected
         */ _this.targetPointers = [];
        return _this;
    }
    /**
     * Returns the current number of pointers involved in the interaction,
     * e.g. `2` when two fingers are used.
     * @return {number} The number of pointers.
     * @api
     */ PointerInteraction.prototype.getPointerCount = function() {
        return this.targetPointers.length;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     * @protected
     */ PointerInteraction.prototype.handleDownEvent = function(mapBrowserEvent) {
        return false;
    };
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @protected
     */ PointerInteraction.prototype.handleDragEvent = function(mapBrowserEvent) {};
    /**
     * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
     * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
     * detected.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @api
     */ PointerInteraction.prototype.handleEvent = function(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        var stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERUP) {
                var handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERDOWN) {
                var handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    };
    /**
     * Handle pointer move events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @protected
     */ PointerInteraction.prototype.handleMoveEvent = function(mapBrowserEvent) {};
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     * @protected
     */ PointerInteraction.prototype.handleUpEvent = function(mapBrowserEvent) {
        return false;
    };
    /**
     * This function is used to determine if "down" events should be propagated
     * to other interactions or should be stopped.
     * @param {boolean} handled Was the event handled by the interaction?
     * @return {boolean} Should the `down` event be stopped?
     */ PointerInteraction.prototype.stopDown = function(handled) {
        return handled;
    };
    /**
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @private
     */ PointerInteraction.prototype.updateTrackedPointers_ = function(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    };
    return PointerInteraction;
}((0, $ea3f0e79150889b8$export$2e2bcd8739ae039));
function $56152f51d97b61e4$export$e2a20c553f6c85ce(pointerEvents) {
    var length = pointerEvents.length;
    var clientX = 0;
    var clientY = 0;
    for(var i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return [
        clientX / length,
        clientY / length
    ];
}
var $56152f51d97b61e4$export$2e2bcd8739ae039 = $56152f51d97b61e4$var$PointerInteraction;



var $c8IGo = parcelRequire("c8IGo");
/**
 * @module ol/events/condition
 */ 

var $c8IGo = parcelRequire("c8IGo");

var $bInFo = parcelRequire("bInFo");

var $3JLp3 = parcelRequire("3JLp3");
function $78f2be16b327ffab$export$84bf76cd7afc7469(var_args) {
    var conditions = arguments;
    /**
     * @param {import("../MapBrowserEvent.js").default} event Event.
     * @return {boolean} All conditions passed.
     */ return function(event) {
        var pass = true;
        for(var i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
var $78f2be16b327ffab$export$573409992e89967e = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $78f2be16b327ffab$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
var $78f2be16b327ffab$export$d7ddd398f22d79ef = function(event) {
    var targetElement = event.map.getTargetElement();
    var activeElement = event.map.getOwnerDocument().activeElement;
    return targetElement.contains(activeElement);
};
var $78f2be16b327ffab$export$ae2cdf064e3b0c55 = function(event) {
    return event.map.getTargetElement().hasAttribute('tabindex') ? $78f2be16b327ffab$export$d7ddd398f22d79ef(event) : true;
};
var $78f2be16b327ffab$export$ba9e5d519bc326ca = (0, $c8IGo.TRUE);
var $78f2be16b327ffab$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).CLICK;
};
var $78f2be16b327ffab$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    var originalEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.button == 0 && !((0, $bInFo.WEBKIT) && (0, $bInFo.MAC) && originalEvent.ctrlKey);
};
var $78f2be16b327ffab$export$b3e22bcfd64c1022 = (0, $c8IGo.FALSE);
var $78f2be16b327ffab$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
var $78f2be16b327ffab$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).SINGLECLICK;
};
var $78f2be16b327ffab$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $39a924385cecd177$export$2e2bcd8739ae039).DBLCLICK;
};
var $78f2be16b327ffab$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $78f2be16b327ffab$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $bInFo.MAC) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $78f2be16b327ffab$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
var $78f2be16b327ffab$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    var tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA' && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
var $78f2be16b327ffab$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $3JLp3.assert)(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent.pointerType == 'mouse';
};
var $78f2be16b327ffab$export$e74de664a571d084 = function(mapBrowserEvent) {
    var pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $3JLp3.assert)(pointerEvt !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === 'touch';
};
var $78f2be16b327ffab$export$cd1707283a23f059 = function(mapBrowserEvent) {
    var pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $3JLp3.assert)(pointerEvt !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === 'pen';
};
var $78f2be16b327ffab$export$189f0d593022b199 = function(mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $3JLp3.assert)(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    return pointerEvent.isPrimary && pointerEvent.button === 0;
};




var $20d0fd25ef0b3af1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ var $20d0fd25ef0b3af1$var$DragPan = /** @class */ function(_super) {
    $20d0fd25ef0b3af1$var$__extends(DragPan, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function DragPan(opt_options) {
        var _this = _super.call(this, {
            stopDown: (0, $c8IGo.FALSE)
        }) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {import("../Kinetic.js").default|undefined}
         */ _this.kinetic_ = options.kinetic;
        /**
         * @type {import("../pixel.js").Pixel}
         */ _this.lastCentroid = null;
        /**
         * @type {number}
         */ _this.lastPointersCount_;
        /**
         * @type {boolean}
         */ _this.panning_ = false;
        var condition = options.condition ? options.condition : (0, $78f2be16b327ffab$export$84bf76cd7afc7469)((0, $78f2be16b327ffab$export$fdc892d0d8fe3bfb), (0, $78f2be16b327ffab$export$189f0d593022b199));
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.onFocusOnly ? (0, $78f2be16b327ffab$export$84bf76cd7afc7469)((0, $78f2be16b327ffab$export$ae2cdf064e3b0c55), condition) : condition;
        /**
         * @private
         * @type {boolean}
         */ _this.noKinetic_ = false;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ DragPan.prototype.handleDragEvent = function(mapBrowserEvent) {
        if (!this.panning_) {
            this.panning_ = true;
            this.getMap().getView().beginInteraction();
        }
        var targetPointers = this.targetPointers;
        var centroid = (0, $56152f51d97b61e4$export$e2a20c553f6c85ce)(targetPointers);
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                var delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                var map = mapBrowserEvent.map;
                var view = map.getView();
                (0, $12736e582a1ee05c$export$dcdf75081b88279d)(delta, view.getResolution());
                (0, $12736e582a1ee05c$export$bb628a54ab399bc9)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragPan.prototype.handleUpEvent = function(mapBrowserEvent) {
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                var distance = this.kinetic_.getDistance();
                var angle = this.kinetic_.getAngle();
                var center = view.getCenterInternal();
                var centerpx = map.getPixelFromCoordinateInternal(center);
                var dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $c2ae491963dea068$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        } else {
            if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
            // after one finger up, tiny drag, second finger up
            this.kinetic_.begin();
            this.lastCentroid = null;
            return true;
        }
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragPan.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        } else return false;
    };
    return DragPan;
}((0, $56152f51d97b61e4$export$2e2bcd8739ae039));
var $20d0fd25ef0b3af1$export$2e2bcd8739ae039 = $20d0fd25ef0b3af1$var$DragPan;




var $c8IGo = parcelRequire("c8IGo");


var $810f45f510b068bb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ var $810f45f510b068bb$var$DragRotate = /** @class */ function(_super) {
    $810f45f510b068bb$var$__extends(DragRotate, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function DragRotate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            stopDown: (0, $c8IGo.FALSE)
        }) || this;
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.condition ? options.condition : (0, $78f2be16b327ffab$export$4e5f01653f9f1f82);
        /**
         * @private
         * @type {number|undefined}
         */ _this.lastAngle_ = undefined;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ DragRotate.prototype.handleDragEvent = function(mapBrowserEvent) {
        if (!(0, $78f2be16b327ffab$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (view.getConstraints().rotation === (0, $ca456328cb3fb311$export$e20fbacbb41798b)) return;
        var size = map.getSize();
        var offset = mapBrowserEvent.pixel;
        var theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            var delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragRotate.prototype.handleUpEvent = function(mapBrowserEvent) {
        if (!(0, $78f2be16b327ffab$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragRotate.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (!(0, $78f2be16b327ffab$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $78f2be16b327ffab$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            var map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        } else return false;
    };
    return DragRotate;
}((0, $56152f51d97b61e4$export$2e2bcd8739ae039));
var $810f45f510b068bb$export$2e2bcd8739ae039 = $810f45f510b068bb$var$DragRotate;



var $bNM9R = parcelRequire("bNM9R");

/**
 * @module ol/render/Box
 */ 
var $fy27o = parcelRequire("fy27o");

var $49afdf7a326e216e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $49afdf7a326e216e$var$RenderBox = /** @class */ function(_super) {
    $49afdf7a326e216e$var$__extends(RenderBox, _super);
    /**
     * @param {string} className CSS class name.
     */ function RenderBox(className) {
        var _this = _super.call(this) || this;
        /**
         * @type {import("../geom/Polygon.js").default}
         * @private
         */ _this.geometry_ = null;
        /**
         * @type {HTMLDivElement}
         * @private
         */ _this.element_ = document.createElement('div');
        _this.element_.style.position = 'absolute';
        _this.element_.style.pointerEvents = 'auto';
        _this.element_.className = 'ol-box ' + className;
        /**
         * @private
         * @type {import("../PluggableMap.js").default|null}
         */ _this.map_ = null;
        /**
         * @private
         * @type {import("../pixel.js").Pixel}
         */ _this.startPixel_ = null;
        /**
         * @private
         * @type {import("../pixel.js").Pixel}
         */ _this.endPixel_ = null;
        return _this;
    }
    /**
     * Clean up.
     */ RenderBox.prototype.disposeInternal = function() {
        this.setMap(null);
    };
    /**
     * @private
     */ RenderBox.prototype.render_ = function() {
        var startPixel = this.startPixel_;
        var endPixel = this.endPixel_;
        var px = 'px';
        var style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    };
    /**
     * @param {import("../PluggableMap.js").default|null} map Map.
     */ RenderBox.prototype.setMap = function(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            var style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    };
    /**
     * @param {import("../pixel.js").Pixel} startPixel Start pixel.
     * @param {import("../pixel.js").Pixel} endPixel End pixel.
     */ RenderBox.prototype.setPixels = function(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    };
    /**
     * Creates or updates the cached geometry.
     */ RenderBox.prototype.createOrUpdateGeometry = function() {
        var startPixel = this.startPixel_;
        var endPixel = this.endPixel_;
        var pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        var coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $c59228195e440f9b$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    };
    /**
     * @return {import("../geom/Polygon.js").default} Geometry.
     */ RenderBox.prototype.getGeometry = function() {
        return this.geometry_;
    };
    return RenderBox;
}((0, $fy27o.default));
var $49afdf7a326e216e$export$2e2bcd8739ae039 = $49afdf7a326e216e$var$RenderBox;



var $767f8dd125a4e0b7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ var $767f8dd125a4e0b7$var$DragBoxEventType = {
    /**
     * Triggered upon drag box start.
     * @event DragBoxEvent#boxstart
     * @api
     */ BOXSTART: 'boxstart',
    /**
     * Triggered on drag when box is active.
     * @event DragBoxEvent#boxdrag
     * @api
     */ BOXDRAG: 'boxdrag',
    /**
     * Triggered upon drag box end.
     * @event DragBoxEvent#boxend
     * @api
     */ BOXEND: 'boxend',
    /**
     * Triggered upon drag box canceled.
     * @event DragBoxEvent#boxcancel
     * @api
     */ BOXCANCEL: 'boxcancel'
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/DragBox~DragBox} instances are instances of
 * this type.
 */ var $767f8dd125a4e0b7$export$7053c33c051365ea = /** @class */ function(_super) {
    $767f8dd125a4e0b7$var$__extends(DragBoxEvent, _super);
    /**
     * @param {string} type The event type.
     * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
     */ function DragBoxEvent(type, coordinate, mapBrowserEvent) {
        var _this = _super.call(this, type) || this;
        /**
         * The coordinate of the drag event.
         * @const
         * @type {import("../coordinate.js").Coordinate}
         * @api
         */ _this.coordinate = coordinate;
        /**
         * @const
         * @type {import("../MapBrowserEvent.js").default}
         * @api
         */ _this.mapBrowserEvent = mapBrowserEvent;
        return _this;
    }
    return DragBoxEvent;
}((0, $bNM9R.default));
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ var $767f8dd125a4e0b7$var$DragBox = /** @class */ function(_super) {
    $767f8dd125a4e0b7$var$__extends(DragBox, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function DragBox(opt_options) {
        var _this = _super.call(this) || this;
        /***
         * @type {DragBoxOnSignature<import("../events").EventsKey>}
         */ _this.on;
        /***
         * @type {DragBoxOnSignature<import("../events").EventsKey>}
         */ _this.once;
        /***
         * @type {DragBoxOnSignature<void>}
         */ _this.un;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("../render/Box.js").default}
         * @private
         */ _this.box_ = new (0, $49afdf7a326e216e$export$2e2bcd8739ae039)(options.className || 'ol-dragbox');
        /**
         * @type {number}
         * @private
         */ _this.minArea_ = options.minArea !== undefined ? options.minArea : 64;
        if (options.onBoxEnd) _this.onBoxEnd = options.onBoxEnd;
        /**
         * @type {import("../pixel.js").Pixel}
         * @private
         */ _this.startPixel_ = null;
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.condition ? options.condition : (0, $78f2be16b327ffab$export$1238ad6b5e7fff70);
        /**
         * @private
         * @type {EndCondition}
         */ _this.boxEndCondition_ = options.boxEndCondition ? options.boxEndCondition : _this.defaultBoxEndCondition;
        return _this;
    }
    /**
     * The default condition for determining whether the boxend event
     * should fire.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
     *     leading to the box end.
     * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
     * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
     * @return {boolean} Whether or not the boxend condition should be fired.
     */ DragBox.prototype.defaultBoxEndCondition = function(mapBrowserEvent, startPixel, endPixel) {
        var width = endPixel[0] - startPixel[0];
        var height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    };
    /**
     * Returns geometry of last drawn box.
     * @return {import("../geom/Polygon.js").default} Geometry.
     * @api
     */ DragBox.prototype.getGeometry = function() {
        return this.box_.getGeometry();
    };
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ DragBox.prototype.handleDragEvent = function(mapBrowserEvent) {
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $767f8dd125a4e0b7$export$7053c33c051365ea($767f8dd125a4e0b7$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragBox.prototype.handleUpEvent = function(mapBrowserEvent) {
        this.box_.setMap(null);
        var completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $767f8dd125a4e0b7$export$7053c33c051365ea(completeBox ? $767f8dd125a4e0b7$var$DragBoxEventType.BOXEND : $767f8dd125a4e0b7$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        return false;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ DragBox.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $767f8dd125a4e0b7$export$7053c33c051365ea($767f8dd125a4e0b7$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        } else return false;
    };
    /**
     * Function to execute just before `onboxend` is fired
     * @param {import("../MapBrowserEvent.js").default} event Event.
     */ DragBox.prototype.onBoxEnd = function(event) {};
    return DragBox;
}((0, $56152f51d97b61e4$export$2e2bcd8739ae039));
var $767f8dd125a4e0b7$export$2e2bcd8739ae039 = $767f8dd125a4e0b7$var$DragBox;




var $e9b73d5dcae72ff1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ var $e9b73d5dcae72ff1$var$DragZoom = /** @class */ function(_super) {
    $e9b73d5dcae72ff1$var$__extends(DragZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function DragZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var condition = options.condition ? options.condition : (0, $78f2be16b327ffab$export$5d31fe68a477cfbb);
        _this = _super.call(this, {
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea
        }) || this;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
         * @private
         * @type {boolean}
         */ _this.out_ = options.out !== undefined ? options.out : false;
        return _this;
    }
    /**
     * Function to execute just before `onboxend` is fired
     * @param {import("../MapBrowserEvent.js").default} event Event.
     */ DragZoom.prototype.onBoxEnd = function(event) {
        var map = this.getMap();
        var view = /** @type {!import("../View.js").default} */ map.getView();
        var geometry = this.getGeometry();
        if (this.out_) {
            var rotatedExtent = view.rotatedExtentForGeometry(geometry);
            var resolution = view.getResolutionForExtentInternal(rotatedExtent);
            var factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $c2ae491963dea068$export$57636bb43b1ccbb0)
        });
    };
    return DragZoom;
}((0, $767f8dd125a4e0b7$export$2e2bcd8739ae039));
var $e9b73d5dcae72ff1$export$2e2bcd8739ae039 = $e9b73d5dcae72ff1$var$DragZoom;



var $cFmyb = parcelRequire("cFmyb");

/**
 * @module ol/events/KeyCode
 */ /**
 * @enum {number}
 * @const
 */ var $78440669cd443094$export$2e2bcd8739ae039 = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};




var $f11ab6200257a423$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ var $f11ab6200257a423$var$KeyboardPan = /** @class */ function(_super) {
    $f11ab6200257a423$var$__extends(KeyboardPan, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function KeyboardPan(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options || {};
        /**
         * @private
         * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
         * @return {boolean} Combined condition result.
         */ _this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $78f2be16b327ffab$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $78f2be16b327ffab$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.condition !== undefined ? options.condition : _this.defaultCondition_;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
         * @private
         * @type {number}
         */ _this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
        return _this;
    }
    /**
     * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
     * `KeyEvent`, and decides the direction to pan to (if an arrow key was
     * pressed).
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @this {KeyboardPan}
     */ KeyboardPan.prototype.handleEvent = function(mapBrowserEvent) {
        var stopEvent = false;
        if (mapBrowserEvent.type == (0, $cFmyb.default).KEYDOWN) {
            var keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            var keyCode = keyEvent.keyCode;
            if (this.condition_(mapBrowserEvent) && (keyCode == (0, $78440669cd443094$export$2e2bcd8739ae039).DOWN || keyCode == (0, $78440669cd443094$export$2e2bcd8739ae039).LEFT || keyCode == (0, $78440669cd443094$export$2e2bcd8739ae039).RIGHT || keyCode == (0, $78440669cd443094$export$2e2bcd8739ae039).UP)) {
                var map = mapBrowserEvent.map;
                var view = map.getView();
                var mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                var deltaX = 0, deltaY = 0;
                if (keyCode == (0, $78440669cd443094$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                else if (keyCode == (0, $78440669cd443094$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                else if (keyCode == (0, $78440669cd443094$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                var delta = [
                    deltaX,
                    deltaY
                ];
                (0, $12736e582a1ee05c$export$bb628a54ab399bc9)(delta, view.getRotation());
                (0, $ea3f0e79150889b8$export$4c486572e961a974)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    };
    return KeyboardPan;
}((0, $ea3f0e79150889b8$export$2e2bcd8739ae039));
var $f11ab6200257a423$export$2e2bcd8739ae039 = $f11ab6200257a423$var$KeyboardPan;



var $cFmyb = parcelRequire("cFmyb");


var $451979b9d4d67768$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ var $451979b9d4d67768$var$KeyboardZoom = /** @class */ function(_super) {
    $451979b9d4d67768$var$__extends(KeyboardZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function KeyboardZoom(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.condition ? options.condition : (0, $78f2be16b327ffab$export$e5570ca80cd8fd54);
        /**
         * @private
         * @type {number}
         */ _this.delta_ = options.delta ? options.delta : 1;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 100;
        return _this;
    }
    /**
     * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
     * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
     * key pressed was '+' or '-').
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @this {KeyboardZoom}
     */ KeyboardZoom.prototype.handleEvent = function(mapBrowserEvent) {
        var stopEvent = false;
        if (mapBrowserEvent.type == (0, $cFmyb.default).KEYDOWN || mapBrowserEvent.type == (0, $cFmyb.default).KEYPRESS) {
            var keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            var charCode = keyEvent.charCode;
            if (this.condition_(mapBrowserEvent) && (charCode == '+'.charCodeAt(0) || charCode == '-'.charCodeAt(0))) {
                var map = mapBrowserEvent.map;
                var delta = charCode == '+'.charCodeAt(0) ? this.delta_ : -this.delta_;
                var view = map.getView();
                (0, $ea3f0e79150889b8$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    };
    return KeyboardZoom;
}((0, $ea3f0e79150889b8$export$2e2bcd8739ae039));
var $451979b9d4d67768$export$2e2bcd8739ae039 = $451979b9d4d67768$var$KeyboardZoom;


/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ var $60df354283a7bd2c$var$Kinetic = /** @class */ function() {
    /**
     * @param {number} decay Rate of decay (must be negative).
     * @param {number} minVelocity Minimum velocity (pixels/millisecond).
     * @param {number} delay Delay to consider to calculate the kinetic
     *     initial values (milliseconds).
     */ function Kinetic(decay, minVelocity, delay) {
        /**
         * @private
         * @type {number}
         */ this.decay_ = decay;
        /**
         * @private
         * @type {number}
         */ this.minVelocity_ = minVelocity;
        /**
         * @private
         * @type {number}
         */ this.delay_ = delay;
        /**
         * @private
         * @type {Array<number>}
         */ this.points_ = [];
        /**
         * @private
         * @type {number}
         */ this.angle_ = 0;
        /**
         * @private
         * @type {number}
         */ this.initialVelocity_ = 0;
    }
    /**
     * FIXME empty description for jsdoc
     */ Kinetic.prototype.begin = function() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     */ Kinetic.prototype.update = function(x, y) {
        this.points_.push(x, y, Date.now());
    };
    /**
     * @return {boolean} Whether we should do kinetic animation.
     */ Kinetic.prototype.end = function() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        var delay = Date.now() - this.delay_;
        var lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        var firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        var duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        var dx = this.points_[lastIndex] - this.points_[firstIndex];
        var dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    };
    /**
     * @return {number} Total distance travelled (pixels).
     */ Kinetic.prototype.getDistance = function() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    };
    /**
     * @return {number} Angle of the kinetic panning animation (radians).
     */ Kinetic.prototype.getAngle = function() {
        return this.angle_;
    };
    return Kinetic;
}();
var $60df354283a7bd2c$export$2e2bcd8739ae039 = $60df354283a7bd2c$var$Kinetic;



var $cFmyb = parcelRequire("cFmyb");


var $bInFo = parcelRequire("bInFo");


var $7aO1A = parcelRequire("7aO1A");
var $4cd2ab0771ae356b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4cd2ab0771ae356b$export$9484bbecc3c49a2e = {
    TRACKPAD: 'trackpad',
    WHEEL: 'wheel'
};
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ var $4cd2ab0771ae356b$var$MouseWheelZoom = /** @class */ function(_super) {
    $4cd2ab0771ae356b$var$__extends(MouseWheelZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function MouseWheelZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, /** @type {import("./Interaction.js").InteractionOptions} */ options) || this;
        /**
         * @private
         * @type {number}
         */ _this.totalDelta_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.lastDelta_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
         * @private
         * @type {number}
         */ _this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
         * @private
         * @type {boolean}
         */ _this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
         * @private
         * @type {boolean}
         */ _this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        var condition = options.condition ? options.condition : (0, $78f2be16b327ffab$export$ba9e5d519bc326ca);
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */ _this.condition_ = options.onFocusOnly ? (0, $78f2be16b327ffab$export$84bf76cd7afc7469)((0, $78f2be16b327ffab$export$ae2cdf064e3b0c55), condition) : condition;
        /**
         * @private
         * @type {?import("../coordinate.js").Coordinate}
         */ _this.lastAnchor_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ _this.startTime_ = undefined;
        /**
         * @private
         * @type {?}
         */ _this.timeoutId_;
        /**
         * @private
         * @type {Mode|undefined}
         */ _this.mode_ = undefined;
        /**
         * Trackpad events separated by this delay will be considered separate
         * interactions.
         * @type {number}
         */ _this.trackpadEventGap_ = 400;
        /**
         * @type {?}
         */ _this.trackpadTimeoutId_;
        /**
         * The number of delta values per zoom level
         * @private
         * @type {number}
         */ _this.deltaPerZoom_ = 300;
        return _this;
    }
    /**
     * @private
     */ MouseWheelZoom.prototype.endInteraction_ = function() {
        this.trackpadTimeoutId_ = undefined;
        var map = this.getMap();
        if (!map) return;
        var view = map.getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_);
    };
    /**
     * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
     * zooms the map.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     */ MouseWheelZoom.prototype.handleEvent = function(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        var type = mapBrowserEvent.type;
        if (type !== (0, $cFmyb.default).WHEEL) return true;
        var map = mapBrowserEvent.map;
        var wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.coordinate;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        var delta;
        if (mapBrowserEvent.type == (0, $cFmyb.default).WHEEL) {
            delta = wheelEvent.deltaY;
            if ((0, $bInFo.FIREFOX) && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) delta /= (0, $bInFo.DEVICE_PIXEL_RATIO);
            if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 40;
        }
        if (delta === 0) return false;
        else this.lastDelta_ = delta;
        var now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? $4cd2ab0771ae356b$export$9484bbecc3c49a2e.TRACKPAD : $4cd2ab0771ae356b$export$9484bbecc3c49a2e.WHEEL;
        var view = map.getView();
        if (this.mode_ === $4cd2ab0771ae356b$export$9484bbecc3c49a2e.TRACKPAD && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        var timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    };
    /**
     * @private
     * @param {import("../PluggableMap.js").default} map Map.
     */ MouseWheelZoom.prototype.handleWheelZoom_ = function(map) {
        var view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        var delta = -(0, $7aO1A.clamp)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $ea3f0e79150889b8$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    };
    /**
     * Enable or disable using the mouse's location as an anchor when zooming
     * @param {boolean} useAnchor true to zoom to the mouse's location, false
     * to zoom to the center of the map
     * @api
     */ MouseWheelZoom.prototype.setMouseAnchor = function(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    };
    return MouseWheelZoom;
}((0, $ea3f0e79150889b8$export$2e2bcd8739ae039));
var $4cd2ab0771ae356b$export$2e2bcd8739ae039 = $4cd2ab0771ae356b$var$MouseWheelZoom;




var $c8IGo = parcelRequire("c8IGo");

var $1a2377d4a0a5fcf5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ var $1a2377d4a0a5fcf5$var$PinchRotate = /** @class */ function(_super) {
    $1a2377d4a0a5fcf5$var$__extends(PinchRotate, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function PinchRotate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $c8IGo.FALSE);
        _this = _super.call(this, pointerOptions) || this;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */ _this.anchor_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ _this.lastAngle_ = undefined;
        /**
         * @private
         * @type {boolean}
         */ _this.rotating_ = false;
        /**
         * @private
         * @type {number}
         */ _this.rotationDelta_ = 0.0;
        /**
         * @private
         * @type {number}
         */ _this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ PinchRotate.prototype.handleDragEvent = function(mapBrowserEvent) {
        var rotationDelta = 0.0;
        var touch0 = this.targetPointers[0];
        var touch1 = this.targetPointers[1];
        // angle between touches
        var angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            var delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (view.getConstraints().rotation === (0, $ca456328cb3fb311$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        var viewportPosition = map.getViewport().getBoundingClientRect();
        var centroid = (0, $56152f51d97b61e4$export$e2a20c553f6c85ce)(this.targetPointers);
        centroid[0] -= viewportPosition.left;
        centroid[1] -= viewportPosition.top;
        this.anchor_ = map.getCoordinateFromPixelInternal(centroid);
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ PinchRotate.prototype.handleUpEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        } else return true;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ PinchRotate.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            var map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        } else return false;
    };
    return PinchRotate;
}((0, $56152f51d97b61e4$export$2e2bcd8739ae039));
var $1a2377d4a0a5fcf5$export$2e2bcd8739ae039 = $1a2377d4a0a5fcf5$var$PinchRotate;




var $c8IGo = parcelRequire("c8IGo");
var $5182097c9a165950$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ var $5182097c9a165950$var$PinchZoom = /** @class */ function(_super) {
    $5182097c9a165950$var$__extends(PinchZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function PinchZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $c8IGo.FALSE);
        _this = _super.call(this, pointerOptions) || this;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */ _this.anchor_ = null;
        /**
         * @private
         * @type {number}
         */ _this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
         * @private
         * @type {number|undefined}
         */ _this.lastDistance_ = undefined;
        /**
         * @private
         * @type {number}
         */ _this.lastScaleDelta_ = 1;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */ PinchZoom.prototype.handleDragEvent = function(mapBrowserEvent) {
        var scaleDelta = 1.0;
        var touch0 = this.targetPointers[0];
        var touch1 = this.targetPointers[1];
        var dx = touch0.clientX - touch1.clientX;
        var dy = touch0.clientY - touch1.clientY;
        // distance between touches
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        var viewportPosition = map.getViewport().getBoundingClientRect();
        var centroid = (0, $56152f51d97b61e4$export$e2a20c553f6c85ce)(this.targetPointers);
        centroid[0] -= viewportPosition.left;
        centroid[1] -= viewportPosition.top;
        this.anchor_ = map.getCoordinateFromPixelInternal(centroid);
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ PinchZoom.prototype.handleUpEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            var direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        } else return true;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */ PinchZoom.prototype.handleDownEvent = function(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            var map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        } else return false;
    };
    return PinchZoom;
}((0, $56152f51d97b61e4$export$2e2bcd8739ae039));
var $5182097c9a165950$export$2e2bcd8739ae039 = $5182097c9a165950$var$PinchZoom;













function $743928848f7f47be$export$ebe90cb607ad99e(opt_options) {
    var options = opt_options ? opt_options : {};
    var interactions = new (0, $1IaXJ.default)();
    var kinetic = new (0, $60df354283a7bd2c$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    var altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $810f45f510b068bb$export$2e2bcd8739ae039)());
    var doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $3df464bfb61d4cf3$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    var dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $20d0fd25ef0b3af1$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    var pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $1a2377d4a0a5fcf5$export$2e2bcd8739ae039)());
    var pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $5182097c9a165950$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    var keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $f11ab6200257a423$export$2e2bcd8739ae039)());
        interactions.push(new (0, $451979b9d4d67768$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    var mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $4cd2ab0771ae356b$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    var shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $e9b73d5dcae72ff1$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}


var $3b011be35c8c50b9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map';
 *     import View from 'ol/View';
 *     import TileLayer from 'ol/layer/Tile';
 *     import OSM from 'ol/source/OSM';
 *
 *     var map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM()
 *         })
 *       ],
 *       target: 'map'
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @api
 */ var $3b011be35c8c50b9$var$Map = /** @class */ function(_super) {
    $3b011be35c8c50b9$var$__extends(Map, _super);
    /**
     * @param {import("./PluggableMap.js").MapOptions} options Map options.
     */ function Map(options) {
        options = (0, $9zTj4.assign)({}, options);
        if (!options.controls) options.controls = (0, $84cb1fa596e4ae73$export$ebe90cb607ad99e)();
        if (!options.interactions) options.interactions = (0, $743928848f7f47be$export$ebe90cb607ad99e)({
            onFocusOnly: true
        });
        return _super.call(this, options) || this;
    }
    Map.prototype.createRenderer = function() {
        return new (0, $7a85a4f30d8e86c6$export$2e2bcd8739ae039)(this);
    };
    return Map;
}((0, $87c438a1b4e0406a$export$2e2bcd8739ae039));
var $3b011be35c8c50b9$export$2e2bcd8739ae039 = $3b011be35c8c50b9$var$Map;


var $a3fba972a31f119a$exports = {};



(function(global, factory) {
    $a3fba972a31f119a$exports = factory((parcelRequire("hsGuz")), (parcelRequire("gpPIU")), (parcelRequire("827vD")));
})($a3fba972a31f119a$exports, function(Control, ol_Observable, LayerGroup) {
    'use strict';
    Control = 'default' in Control ? Control['default'] : Control;
    LayerGroup = 'default' in LayerGroup ? LayerGroup['default'] : LayerGroup;
    var classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);
        if (desc === undefined) {
            var parent = Object.getPrototypeOf(object);
            if (parent === null) return undefined;
            else return get(parent, property, receiver);
        } else if ("value" in desc) return desc.value;
        else {
            var getter = desc.get;
            if (getter === undefined) return undefined;
            return getter.call(receiver);
        }
    };
    var inherits = function(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    var possibleConstructorReturn = function(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    /**
 * @protected
 */ var CSS_PREFIX = 'layer-switcher-';
    /**
 * OpenLayers LayerSwitcher Control, displays a list of layers and groups
 * associated with a map which have a `title` property.
 *
 * To be shown in the LayerSwitcher panel layers must have a `title` property;
 * base map layers should have a `type` property set to `base`. Group layers
 * (`LayerGroup`) can be used to visually group layers together; a group
 * with a `fold` property set to either `'open'` or `'close'` will be displayed
 * with a toggle.
 *
 * See [BaseLayerOptions](#baselayeroptions) for a full list of LayerSwitcher
 * properties for layers (`TileLayer`, `ImageLayer`, `VectorTile` etc.) and
 * [GroupLayerOptions](#grouplayeroptions) for group layer (`LayerGroup`)
 * LayerSwitcher properties.
 *
 * Layer and group properties can either be set by adding extra properties
 * to their options when they are created or via their set method.
 *
 * Specify a `title` for a Layer by adding a `title` property to it's options object:
 * ```javascript
 * var lyr = new ol.layer.Tile({
 *   // Specify a title property which will be displayed by the layer switcher
 *   title: 'OpenStreetMap',
 *   visible: true,
 *   source: new ol.source.OSM()
 * })
 * ```
 *
 * Alternatively the properties can be set via the `set` method after a layer has been created:
 * ```javascript
 * var lyr = new ol.layer.Tile({
 *   visible: true,
 *   source: new ol.source.OSM()
 * })
 * // Specify a title property which will be displayed by the layer switcher
 * lyr.set('title', 'OpenStreetMap');
 * ```
 *
 * To create a LayerSwitcher and add it to a map, create a new instance then pass it to the map's [`addControl` method](https://openlayers.org/en/latest/apidoc/module-ol_PluggableMap-PluggableMap.html#addControl).
 * ```javascript
 * var layerSwitcher = new LayerSwitcher({
 *   reverse: true,
 *   groupSelectStyle: 'group'
 * });
 * map.addControl(layerSwitcher);
 * ```
 *
 * @constructor
 * @extends {ol/control/Control~Control}
 * @param opt_options LayerSwitcher options, see  [LayerSwitcher Options](#options) and [RenderOptions](#renderoptions) which LayerSwitcher `Options` extends for more details.
 */ var LayerSwitcher = function(_Control) {
        inherits(LayerSwitcher, _Control);
        function LayerSwitcher(opt_options) {
            classCallCheck(this, LayerSwitcher);
            var options = Object.assign({}, opt_options);
            // TODO Next: Rename to showButtonTitle
            var tipLabel = options.tipLabel ? options.tipLabel : 'Legend';
            // TODO Next: Rename to hideButtonTitle
            var collapseTipLabel = options.collapseTipLabel ? options.collapseTipLabel : 'Collapse legend';
            var element = document.createElement('div');
            var _this = possibleConstructorReturn(this, (LayerSwitcher.__proto__ || Object.getPrototypeOf(LayerSwitcher)).call(this, {
                element: element,
                target: options.target
            }));
            _this.activationMode = options.activationMode || 'mouseover';
            _this.startActive = options.startActive === true;
            // TODO Next: Rename to showButtonContent
            var label = options.label !== undefined ? options.label : '';
            // TODO Next: Rename to hideButtonContent
            var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\xBB';
            _this.groupSelectStyle = LayerSwitcher.getGroupSelectStyle(options.groupSelectStyle);
            _this.reverse = options.reverse !== false;
            _this.mapListeners = [];
            _this.hiddenClassName = 'ol-unselectable ol-control layer-switcher';
            if (LayerSwitcher.isTouchDevice_()) _this.hiddenClassName += ' touch';
            _this.shownClassName = 'shown';
            element.className = _this.hiddenClassName;
            var button = document.createElement('button');
            button.setAttribute('title', tipLabel);
            button.setAttribute('aria-label', tipLabel);
            element.appendChild(button);
            _this.panel = document.createElement('div');
            _this.panel.className = 'panel';
            element.appendChild(_this.panel);
            LayerSwitcher.enableTouchScroll_(_this.panel);
            button.textContent = label;
            element.classList.add(CSS_PREFIX + 'group-select-style-' + _this.groupSelectStyle);
            element.classList.add(CSS_PREFIX + 'activation-mode-' + _this.activationMode);
            if (_this.activationMode === 'click') {
                // TODO Next: Remove in favour of layer-switcher-activation-mode-click
                element.classList.add('activationModeClick');
                if (_this.startActive) {
                    button.textContent = collapseLabel;
                    button.setAttribute('title', collapseTipLabel);
                    button.setAttribute('aria-label', collapseTipLabel);
                }
                button.onclick = function(e) {
                    var evt = e || window.event;
                    if (_this.element.classList.contains(_this.shownClassName)) {
                        _this.hidePanel();
                        button.textContent = label;
                        button.setAttribute('title', tipLabel);
                        button.setAttribute('aria-label', tipLabel);
                    } else {
                        _this.showPanel();
                        button.textContent = collapseLabel;
                        button.setAttribute('title', collapseTipLabel);
                        button.setAttribute('aria-label', collapseTipLabel);
                    }
                    evt.preventDefault();
                };
            } else {
                button.onmouseover = function() {
                    _this.showPanel();
                };
                button.onclick = function(e) {
                    var evt = e || window.event;
                    _this.showPanel();
                    evt.preventDefault();
                };
                _this.panel.onmouseout = function(evt) {
                    if (!_this.panel.contains(evt.relatedTarget)) _this.hidePanel();
                };
            }
            return _this;
        }
        /**
     * Set the map instance the control is associated with.
     * @param map The map instance.
     */ createClass(LayerSwitcher, [
            {
                key: 'setMap',
                value: function setMap(map) {
                    var _this2 = this;
                    // Clean up listeners associated with the previous map
                    for(var i = 0; i < this.mapListeners.length; i++)ol_Observable.unByKey(this.mapListeners[i]);
                    this.mapListeners.length = 0;
                    // Wire up listeners etc. and store reference to new map
                    get(LayerSwitcher.prototype.__proto__ || Object.getPrototypeOf(LayerSwitcher.prototype), 'setMap', this).call(this, map);
                    if (map) {
                        if (this.startActive) this.showPanel();
                        else this.renderPanel();
                        if (this.activationMode !== 'click') this.mapListeners.push(map.on('pointerdown', function() {
                            _this2.hidePanel();
                        }));
                    }
                }
            },
            {
                key: 'showPanel',
                value: function showPanel() {
                    if (!this.element.classList.contains(this.shownClassName)) {
                        this.element.classList.add(this.shownClassName);
                        this.renderPanel();
                    }
                }
            },
            {
                key: 'hidePanel',
                value: function hidePanel() {
                    if (this.element.classList.contains(this.shownClassName)) this.element.classList.remove(this.shownClassName);
                }
            },
            {
                key: 'renderPanel',
                value: function renderPanel() {
                    this.dispatchEvent('render');
                    LayerSwitcher.renderPanel(this.getMap(), this.panel, {
                        groupSelectStyle: this.groupSelectStyle,
                        reverse: this.reverse
                    });
                    this.dispatchEvent('rendercomplete');
                }
            }
        ], [
            {
                key: 'renderPanel',
                value: function renderPanel(map, panel, options) {
                    // Create the event.
                    var render_event = new Event('render');
                    // Dispatch the event.
                    panel.dispatchEvent(render_event);
                    options = options || {};
                    options.groupSelectStyle = LayerSwitcher.getGroupSelectStyle(options.groupSelectStyle);
                    LayerSwitcher.ensureTopVisibleBaseLayerShown(map, options.groupSelectStyle);
                    while(panel.firstChild)panel.removeChild(panel.firstChild);
                    // Reset indeterminate state for all layers and groups before
                    // applying based on groupSelectStyle
                    LayerSwitcher.forEachRecursive(map, function(l, _idx, _a) {
                        l.set('indeterminate', false);
                    });
                    if (options.groupSelectStyle === 'children' || options.groupSelectStyle === 'none') // Set visibile and indeterminate state of groups based on
                    // their children's visibility
                    LayerSwitcher.setGroupVisibility(map);
                    else if (options.groupSelectStyle === 'group') // Set child indetermiate state based on their parent's visibility
                    LayerSwitcher.setChildVisibility(map);
                    var ul = document.createElement('ul');
                    panel.appendChild(ul);
                    // passing two map arguments instead of lyr as we're passing the map as the root of the layers tree
                    LayerSwitcher.renderLayers_(map, map, ul, options, function render(_changedLyr) {
                        LayerSwitcher.renderPanel(map, panel, options);
                    });
                    // Create the event.
                    var rendercomplete_event = new Event('rendercomplete');
                    // Dispatch the event.
                    panel.dispatchEvent(rendercomplete_event);
                }
            },
            {
                key: 'isBaseGroup',
                value: function isBaseGroup(grp) {
                    if (grp instanceof LayerGroup) {
                        var lyrs = grp.getLayers().getArray();
                        return lyrs.length && lyrs[0].get('type') === 'base';
                    } else return false;
                }
            },
            {
                key: 'setGroupVisibility',
                value: function setGroupVisibility(map) {
                    // Get a list of groups, with the deepest first
                    var groups = LayerSwitcher.getGroupsAndLayers(map, function(l) {
                        return l instanceof LayerGroup && !l.get('combine') && !LayerSwitcher.isBaseGroup(l);
                    }).reverse();
                    // console.log(groups.map(g => g.get('title')));
                    groups.forEach(function(grp) {
                        // TODO Can we use getLayersArray, is it public in the esm build?
                        var descendantVisibility = grp.getLayersArray().map(function(l) {
                            var state = l.getVisible();
                            // console.log('>', l.get('title'), state);
                            return state;
                        });
                        // console.log(descendantVisibility);
                        if (descendantVisibility.every(function(v) {
                            return v === true;
                        })) {
                            grp.setVisible(true);
                            grp.set('indeterminate', false);
                        } else if (descendantVisibility.every(function(v) {
                            return v === false;
                        })) {
                            grp.setVisible(false);
                            grp.set('indeterminate', false);
                        } else {
                            grp.setVisible(true);
                            grp.set('indeterminate', true);
                        }
                    });
                }
            },
            {
                key: 'setChildVisibility',
                value: function setChildVisibility(map) {
                    // console.log('setChildVisibility');
                    var groups = LayerSwitcher.getGroupsAndLayers(map, function(l) {
                        return l instanceof LayerGroup && !l.get('combine') && !LayerSwitcher.isBaseGroup(l);
                    });
                    groups.forEach(function(grp) {
                        var group = grp;
                        // console.log(group.get('title'));
                        var groupVisible = group.getVisible();
                        var groupIndeterminate = group.get('indeterminate');
                        group.getLayers().getArray().forEach(function(l) {
                            l.set('indeterminate', false);
                            if ((!groupVisible || groupIndeterminate) && l.getVisible()) l.set('indeterminate', true);
                        });
                    });
                }
            },
            {
                key: 'ensureTopVisibleBaseLayerShown',
                value: function ensureTopVisibleBaseLayerShown(map, groupSelectStyle) {
                    var lastVisibleBaseLyr = void 0;
                    LayerSwitcher.forEachRecursive(map, function(lyr, _idx, _arr) {
                        if (lyr.get('type') === 'base' && lyr.getVisible()) lastVisibleBaseLyr = lyr;
                    });
                    if (lastVisibleBaseLyr) LayerSwitcher.setVisible_(map, lastVisibleBaseLyr, true, groupSelectStyle);
                }
            },
            {
                key: 'getGroupsAndLayers',
                value: function getGroupsAndLayers(grp, filterFn) {
                    var layers = [];
                    filterFn = filterFn || function(_lyr, _idx, _arr) {
                        return true;
                    };
                    LayerSwitcher.forEachRecursive(grp, function(lyr, idx, arr) {
                        if (lyr.get('title')) {
                            if (filterFn(lyr, idx, arr)) layers.push(lyr);
                        }
                    });
                    return layers;
                }
            },
            {
                key: 'setVisible_',
                value: function setVisible_(map, lyr, visible, groupSelectStyle) {
                    // console.log(lyr.get('title'), visible, groupSelectStyle);
                    lyr.setVisible(visible);
                    if (visible && lyr.get('type') === 'base') // Hide all other base layers regardless of grouping
                    LayerSwitcher.forEachRecursive(map, function(l, _idx, _arr) {
                        if (l != lyr && l.get('type') === 'base') l.setVisible(false);
                    });
                    if (lyr instanceof LayerGroup && !lyr.get('combine') && groupSelectStyle === 'children') lyr.getLayers().forEach(function(l) {
                        LayerSwitcher.setVisible_(map, l, lyr.getVisible(), groupSelectStyle);
                    });
                }
            },
            {
                key: 'renderLayer_',
                value: function renderLayer_(map, lyr, idx, options, render) {
                    var li = document.createElement('li');
                    var lyrTitle = lyr.get('title');
                    var checkboxId = LayerSwitcher.uuid();
                    var label = document.createElement('label');
                    if (lyr instanceof LayerGroup && !lyr.get('combine')) {
                        var isBaseGroup = LayerSwitcher.isBaseGroup(lyr);
                        li.classList.add('group');
                        if (isBaseGroup) li.classList.add(CSS_PREFIX + 'base-group');
                        // Group folding
                        if (lyr.get('fold')) {
                            li.classList.add(CSS_PREFIX + 'fold');
                            li.classList.add(CSS_PREFIX + lyr.get('fold'));
                            var btn = document.createElement('button');
                            btn.onclick = function(e) {
                                var evt = e || window.event;
                                LayerSwitcher.toggleFold_(lyr, li);
                                evt.preventDefault();
                            };
                            li.appendChild(btn);
                        }
                        if (!isBaseGroup && options.groupSelectStyle != 'none') {
                            var input = document.createElement('input');
                            input.type = 'checkbox';
                            input.id = checkboxId;
                            input.checked = lyr.getVisible();
                            input.indeterminate = lyr.get('indeterminate');
                            input.onchange = function(e) {
                                var target = e.target;
                                LayerSwitcher.setVisible_(map, lyr, target.checked, options.groupSelectStyle);
                                render(lyr);
                            };
                            li.appendChild(input);
                            label.htmlFor = checkboxId;
                        }
                        label.innerHTML = lyrTitle;
                        li.appendChild(label);
                        var ul = document.createElement('ul');
                        li.appendChild(ul);
                        LayerSwitcher.renderLayers_(map, lyr, ul, options, render);
                    } else {
                        li.className = 'layer';
                        var _input = document.createElement('input');
                        if (lyr.get('type') === 'base') {
                            _input.type = 'radio';
                            _input.name = 'base';
                        } else _input.type = 'checkbox';
                        _input.id = checkboxId;
                        _input.checked = lyr.get('visible');
                        _input.indeterminate = lyr.get('indeterminate');
                        _input.onchange = function(e) {
                            var target = e.target;
                            LayerSwitcher.setVisible_(map, lyr, target.checked, options.groupSelectStyle);
                            render(lyr);
                        };
                        li.appendChild(_input);
                        label.htmlFor = checkboxId;
                        label.innerHTML = lyrTitle;
                        var rsl = map.getView().getResolution();
                        if (rsl > lyr.getMaxResolution() || rsl < lyr.getMinResolution()) label.className += ' disabled';
                        li.appendChild(label);
                    }
                    return li;
                }
            },
            {
                key: 'renderLayers_',
                value: function renderLayers_(map, lyr, elm, options, render) {
                    var lyrs = lyr.getLayers().getArray().slice();
                    if (options.reverse) lyrs = lyrs.reverse();
                    for(var i = 0, l; i < lyrs.length; i++){
                        l = lyrs[i];
                        if (l.get('title')) elm.appendChild(LayerSwitcher.renderLayer_(map, l, i, options, render));
                    }
                }
            },
            {
                key: 'forEachRecursive',
                value: function forEachRecursive(lyr, fn) {
                    lyr.getLayers().forEach(function(lyr, idx, a) {
                        fn(lyr, idx, a);
                        if (lyr instanceof LayerGroup) LayerSwitcher.forEachRecursive(lyr, fn);
                    });
                }
            },
            {
                key: 'uuid',
                value: function uuid() {
                    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
                        return v.toString(16);
                    });
                }
            },
            {
                key: 'enableTouchScroll_',
                value: function enableTouchScroll_(elm) {
                    if (LayerSwitcher.isTouchDevice_()) {
                        var scrollStartPos = 0;
                        elm.addEventListener('touchstart', function(event) {
                            scrollStartPos = this.scrollTop + event.touches[0].pageY;
                        }, false);
                        elm.addEventListener('touchmove', function(event) {
                            this.scrollTop = scrollStartPos - event.touches[0].pageY;
                        }, false);
                    }
                }
            },
            {
                key: 'isTouchDevice_',
                value: function isTouchDevice_() {
                    try {
                        document.createEvent('TouchEvent');
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
            },
            {
                key: 'toggleFold_',
                value: function toggleFold_(lyr, li) {
                    li.classList.remove(CSS_PREFIX + lyr.get('fold'));
                    lyr.set('fold', lyr.get('fold') === 'open' ? 'close' : 'open');
                    li.classList.add(CSS_PREFIX + lyr.get('fold'));
                }
            },
            {
                key: 'getGroupSelectStyle',
                value: function getGroupSelectStyle(groupSelectStyle) {
                    return [
                        'none',
                        'children',
                        'group'
                    ].indexOf(groupSelectStyle) >= 0 ? groupSelectStyle : 'children';
                }
            }
        ]);
        return LayerSwitcher;
    }(Control);
    if (window['ol'] && window['ol']['control']) window['ol']['control']['LayerSwitcher'] = LayerSwitcher;
    return LayerSwitcher;
});


/**
 * @module ol/format/GeoJSON
 */ 
var $aK3Yt = parcelRequire("aK3Yt");

var $cFmyb = parcelRequire("cFmyb");

var $3JLp3 = parcelRequire("3JLp3");

var $1dBX3 = parcelRequire("1dBX3");
var $92e93536945a317f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template Geometry
 * @typedef {Object<string, *> & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature';
 * import Polygon from 'ol/geom/Polygon';
 * import Point from 'ol/geom/Point';
 *
 * var feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon'
 * });
 *
 * // get the polygon geometry
 * var poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * var point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 */ var $92e93536945a317f$var$Feature = /** @class */ function(_super) {
    $92e93536945a317f$var$__extends(Feature, _super);
    /**
     * @param {Geometry|ObjectWithGeometry<Geometry>} [opt_geometryOrProperties]
     *     You may pass a Geometry object directly, or an object literal containing
     *     properties. If you pass an object literal, you may include a Geometry
     *     associated with a `geometry` key.
     */ function Feature(opt_geometryOrProperties) {
        var _this = _super.call(this) || this;
        /***
         * @type {FeatureOnSignature<import("./events").EventsKey>}
         */ _this.on;
        /***
         * @type {FeatureOnSignature<import("./events").EventsKey>}
         */ _this.once;
        /***
         * @type {FeatureOnSignature<void>}
         */ _this.un;
        /**
         * @private
         * @type {number|string|undefined}
         */ _this.id_ = undefined;
        /**
         * @type {string}
         * @private
         */ _this.geometryName_ = 'geometry';
        /**
         * User provided style.
         * @private
         * @type {import("./style/Style.js").StyleLike}
         */ _this.style_ = null;
        /**
         * @private
         * @type {import("./style/Style.js").StyleFunction|undefined}
         */ _this.styleFunction_ = undefined;
        /**
         * @private
         * @type {?import("./events.js").EventsKey}
         */ _this.geometryChangeKey_ = null;
        _this.addChangeListener(_this.geometryName_, _this.handleGeometryChanged_);
        if (opt_geometryOrProperties) {
            if (typeof /** @type {?} */ opt_geometryOrProperties.getSimplifiedGeometry === 'function') {
                var geometry = /** @type {Geometry} */ opt_geometryOrProperties;
                _this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ var properties = opt_geometryOrProperties;
                _this.setProperties(properties);
            }
        }
        return _this;
    }
    /**
     * Clone this feature. If the original feature has a geometry it
     * is also cloned. The feature id is not set in the clone.
     * @return {Feature<Geometry>} The clone.
     * @api
     */ Feature.prototype.clone = function() {
        var clone = /** @type {Feature<Geometry>} */ new Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        var geometry = this.getGeometry();
        if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
        var style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    };
    /**
     * Get the feature's default geometry.  A feature may have any number of named
     * geometries.  The "default" geometry (the one that is rendered by default) is
     * set when calling {@link module:ol/Feature~Feature#setGeometry}.
     * @return {Geometry|undefined} The default geometry for the feature.
     * @api
     * @observable
     */ Feature.prototype.getGeometry = function() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    };
    /**
     * Get the feature identifier.  This is a stable identifier for the feature and
     * is either set when reading data from a remote source or set explicitly by
     * calling {@link module:ol/Feature~Feature#setId}.
     * @return {number|string|undefined} Id.
     * @api
     */ Feature.prototype.getId = function() {
        return this.id_;
    };
    /**
     * Get the name of the feature's default geometry.  By default, the default
     * geometry is named `geometry`.
     * @return {string} Get the property name associated with the default geometry
     *     for this feature.
     * @api
     */ Feature.prototype.getGeometryName = function() {
        return this.geometryName_;
    };
    /**
     * Get the feature's style. Will return what was provided to the
     * {@link module:ol/Feature~Feature#setStyle} method.
     * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
     * @api
     */ Feature.prototype.getStyle = function() {
        return this.style_;
    };
    /**
     * Get the feature's style function.
     * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
     * representing the current style of this feature.
     * @api
     */ Feature.prototype.getStyleFunction = function() {
        return this.styleFunction_;
    };
    /**
     * @private
     */ Feature.prototype.handleGeometryChange_ = function() {
        this.changed();
    };
    /**
     * @private
     */ Feature.prototype.handleGeometryChanged_ = function() {
        if (this.geometryChangeKey_) {
            (0, $1dBX3.unlistenByKey)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        var geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $1dBX3.listen)(geometry, (0, $cFmyb.default).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    };
    /**
     * Set the default geometry for the feature.  This will update the property
     * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
     * @param {Geometry|undefined} geometry The new geometry.
     * @api
     * @observable
     */ Feature.prototype.setGeometry = function(geometry) {
        this.set(this.geometryName_, geometry);
    };
    /**
     * Set the style for the feature to override the layer style.  This can be a
     * single style object, an array of styles, or a function that takes a
     * resolution and returns an array of styles. To unset the feature style, call
     * `setStyle()` without arguments or a falsey value.
     * @param {import("./style/Style.js").StyleLike} [opt_style] Style for this feature.
     * @api
     * @fires module:ol/events/Event~BaseEvent#event:change
     */ Feature.prototype.setStyle = function(opt_style) {
        this.style_ = opt_style;
        this.styleFunction_ = !opt_style ? undefined : $92e93536945a317f$export$bb06ddfd5d66e02e(opt_style);
        this.changed();
    };
    /**
     * Set the feature id.  The feature id is considered stable and may be used when
     * requesting features or comparing identifiers returned from a remote source.
     * The feature id can be used with the
     * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
     * @param {number|string|undefined} id The feature id.
     * @api
     * @fires module:ol/events/Event~BaseEvent#event:change
     */ Feature.prototype.setId = function(id) {
        this.id_ = id;
        this.changed();
    };
    /**
     * Set the property name to be used when getting the feature's default geometry.
     * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
     * this name will be returned.
     * @param {string} name The property name of the default geometry.
     * @api
     */ Feature.prototype.setGeometryName = function(name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    };
    return Feature;
}((0, $aK3Yt.default));
function $92e93536945a317f$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === 'function') return obj;
    else {
        /**
         * @type {Array<import("./style/Style.js").default>}
         */ var styles_1;
        if (Array.isArray(obj)) styles_1 = obj;
        else {
            (0, $3JLp3.assert)(typeof /** @type {?} */ obj.getZIndex === 'function', 41); // Expected an `import("./style/Style.js").Style` or an array of `import("./style/Style.js").Style`
            var style = /** @type {import("./style/Style.js").default} */ obj;
            styles_1 = [
                style
            ];
        }
        return function() {
            return styles_1;
        };
    }
}
var $92e93536945a317f$export$2e2bcd8739ae039 = $92e93536945a317f$var$Feature;



var $cFmyb = parcelRequire("cFmyb");


var $2Jl0K = parcelRequire("2Jl0K");

var $1dBX3 = parcelRequire("1dBX3");
var $11ca4d4f4e4e4159$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry~Geometry} objects.
 *
 * @api
 */ var $11ca4d4f4e4e4159$var$GeometryCollection = /** @class */ function(_super) {
    $11ca4d4f4e4e4159$var$__extends(GeometryCollection, _super);
    /**
     * @param {Array<Geometry>} [opt_geometries] Geometries.
     */ function GeometryCollection(opt_geometries) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {Array<Geometry>}
         */ _this.geometries_ = opt_geometries ? opt_geometries : null;
        /**
         * @type {Array<import("../events.js").EventsKey>}
         */ _this.changeEventsKeys_ = [];
        _this.listenGeometriesChange_();
        return _this;
    }
    /**
     * @private
     */ GeometryCollection.prototype.unlistenGeometriesChange_ = function() {
        this.changeEventsKeys_.forEach((0, $1dBX3.unlistenByKey));
        this.changeEventsKeys_.length = 0;
    };
    /**
     * @private
     */ GeometryCollection.prototype.listenGeometriesChange_ = function() {
        if (!this.geometries_) return;
        for(var i = 0, ii = this.geometries_.length; i < ii; ++i)this.changeEventsKeys_.push((0, $1dBX3.listen)(this.geometries_[i], (0, $cFmyb.default).CHANGE, this.changed, this));
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!GeometryCollection} Clone.
     * @api
     */ GeometryCollection.prototype.clone = function() {
        var geometryCollection = new GeometryCollection(null);
        geometryCollection.setGeometries(this.geometries_);
        geometryCollection.applyProperties(this);
        return geometryCollection;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ GeometryCollection.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $2Jl0K.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        var geometries = this.geometries_;
        for(var i = 0, ii = geometries.length; i < ii; ++i)minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        return minSquaredDistance;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */ GeometryCollection.prototype.containsXY = function(x, y) {
        var geometries = this.geometries_;
        for(var i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].containsXY(x, y)) return true;
        }
        return false;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */ GeometryCollection.prototype.computeExtent = function(extent) {
        (0, $2Jl0K.createOrUpdateEmpty)(extent);
        var geometries = this.geometries_;
        for(var i = 0, ii = geometries.length; i < ii; ++i)(0, $2Jl0K.extend)(extent, geometries[i].getExtent());
        return extent;
    };
    /**
     * Return the geometries that make up this geometry collection.
     * @return {Array<Geometry>} Geometries.
     * @api
     */ GeometryCollection.prototype.getGeometries = function() {
        return $11ca4d4f4e4e4159$var$cloneGeometries(this.geometries_);
    };
    /**
     * @return {Array<Geometry>} Geometries.
     */ GeometryCollection.prototype.getGeometriesArray = function() {
        return this.geometries_;
    };
    /**
     * @return {Array<Geometry>} Geometries.
     */ GeometryCollection.prototype.getGeometriesArrayRecursive = function() {
        /** @type {Array<Geometry>} */ var geometriesArray = [];
        var geometries = this.geometries_;
        for(var i = 0, ii = geometries.length; i < ii; ++i)if (geometries[i].getType() === this.getType()) geometriesArray = geometriesArray.concat(/** @type {GeometryCollection} */ geometries[i].getGeometriesArrayRecursive());
        else geometriesArray.push(geometries[i]);
        return geometriesArray;
    };
    /**
     * Create a simplified version of this geometry using the Douglas Peucker algorithm.
     * @param {number} squaredTolerance Squared tolerance.
     * @return {GeometryCollection} Simplified GeometryCollection.
     */ GeometryCollection.prototype.getSimplifiedGeometry = function(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        var simplifiedGeometries = [];
        var geometries = this.geometries_;
        var simplified = false;
        for(var i = 0, ii = geometries.length; i < ii; ++i){
            var geometry = geometries[i];
            var simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) simplified = true;
        }
        if (simplified) {
            var simplifiedGeometryCollection = new GeometryCollection(null);
            simplifiedGeometryCollection.setGeometriesArray(simplifiedGeometries);
            return simplifiedGeometryCollection;
        } else {
            this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
            return this;
        }
    };
    /**
     * Get the type of this geometry.
     * @return {import("./Geometry.js").Type} Geometry type.
     * @api
     */ GeometryCollection.prototype.getType = function() {
        return 'GeometryCollection';
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ GeometryCollection.prototype.intersectsExtent = function(extent) {
        var geometries = this.geometries_;
        for(var i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].intersectsExtent(extent)) return true;
        }
        return false;
    };
    /**
     * @return {boolean} Is empty.
     */ GeometryCollection.prototype.isEmpty = function() {
        return this.geometries_.length === 0;
    };
    /**
     * Rotate the geometry around a given coordinate. This modifies the geometry
     * coordinates in place.
     * @param {number} angle Rotation angle in radians.
     * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
     * @api
     */ GeometryCollection.prototype.rotate = function(angle, anchor) {
        var geometries = this.geometries_;
        for(var i = 0, ii = geometries.length; i < ii; ++i)geometries[i].rotate(angle, anchor);
        this.changed();
    };
    /**
     * Scale the geometry (with an optional origin).  This modifies the geometry
     * coordinates in place.
     * @abstract
     * @param {number} sx The scaling factor in the x-direction.
     * @param {number} [opt_sy] The scaling factor in the y-direction (defaults to sx).
     * @param {import("../coordinate.js").Coordinate} [opt_anchor] The scale origin (defaults to the center
     *     of the geometry extent).
     * @api
     */ GeometryCollection.prototype.scale = function(sx, opt_sy, opt_anchor) {
        var anchor = opt_anchor;
        if (!anchor) anchor = (0, $2Jl0K.getCenter)(this.getExtent());
        var geometries = this.geometries_;
        for(var i = 0, ii = geometries.length; i < ii; ++i)geometries[i].scale(sx, opt_sy, anchor);
        this.changed();
    };
    /**
     * Set the geometries that make up this geometry collection.
     * @param {Array<Geometry>} geometries Geometries.
     * @api
     */ GeometryCollection.prototype.setGeometries = function(geometries) {
        this.setGeometriesArray($11ca4d4f4e4e4159$var$cloneGeometries(geometries));
    };
    /**
     * @param {Array<Geometry>} geometries Geometries.
     */ GeometryCollection.prototype.setGeometriesArray = function(geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    };
    /**
     * Apply a transform function to the coordinates of the geometry.
     * The geometry is modified in place.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     * @param {import("../proj.js").TransformFunction} transformFn Transform function.
     * Called with a flat array of geometry coordinates.
     * @api
     */ GeometryCollection.prototype.applyTransform = function(transformFn) {
        var geometries = this.geometries_;
        for(var i = 0, ii = geometries.length; i < ii; ++i)geometries[i].applyTransform(transformFn);
        this.changed();
    };
    /**
     * Translate the geometry.  This modifies the geometry coordinates in place.  If
     * instead you want a new geometry, first `clone()` this geometry.
     * @param {number} deltaX Delta X.
     * @param {number} deltaY Delta Y.
     * @api
     */ GeometryCollection.prototype.translate = function(deltaX, deltaY) {
        var geometries = this.geometries_;
        for(var i = 0, ii = geometries.length; i < ii; ++i)geometries[i].translate(deltaX, deltaY);
        this.changed();
    };
    /**
     * Clean up.
     */ GeometryCollection.prototype.disposeInternal = function() {
        this.unlistenGeometriesChange_();
        _super.prototype.disposeInternal.call(this);
    };
    return GeometryCollection;
}((0, $7dc792b36df3ca45$export$2e2bcd8739ae039));
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */ function $11ca4d4f4e4e4159$var$cloneGeometries(geometries) {
    var clonedGeometries = [];
    for(var i = 0, ii = geometries.length; i < ii; ++i)clonedGeometries.push(geometries[i].clone());
    return clonedGeometries;
}
var $11ca4d4f4e4e4159$export$2e2bcd8739ae039 = $11ca4d4f4e4e4159$var$GeometryCollection;


/**
 * @module ol/format/Feature
 */ 

var $61DUI = parcelRequire("61DUI");

var $9zTj4 = parcelRequire("9zTj4");

/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @typedef {'arraybuffer' | 'json' | 'text' | 'xml'} Type
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @abstract
 * @api
 */ var $5736954797f97c6f$var$FeatureFormat = /** @class */ function() {
    function FeatureFormat() {
        /**
         * @protected
         * @type {import("../proj/Projection.js").default|undefined}
         */ this.dataProjection = undefined;
        /**
         * @protected
         * @type {import("../proj/Projection.js").default|undefined}
         */ this.defaultFeatureProjection = undefined;
        /**
         * A list media types supported by the format in descending order of preference.
         * @type {Array<string>}
         */ this.supportedMediaTypes = null;
    }
    /**
     * Adds the data projection to the read options.
     * @param {Document|Element|Object|string} source Source.
     * @param {ReadOptions} [opt_options] Options.
     * @return {ReadOptions|undefined} Options.
     * @protected
     */ FeatureFormat.prototype.getReadOptions = function(source, opt_options) {
        var options;
        if (opt_options) {
            var dataProjection = opt_options.dataProjection ? (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(opt_options.dataProjection) : this.readProjection(source);
            if (opt_options.extent && dataProjection && dataProjection.getUnits() === (0, $bcf733fece57bacd$export$2e2bcd8739ae039).TILE_PIXELS) {
                dataProjection = (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(dataProjection);
                dataProjection.setWorldExtent(opt_options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: opt_options.featureProjection
            };
        }
        return this.adaptOptions(options);
    };
    /**
     * Sets the `dataProjection` on the options, if no `dataProjection`
     * is set.
     * @param {WriteOptions|ReadOptions|undefined} options
     *     Options.
     * @protected
     * @return {WriteOptions|ReadOptions|undefined}
     *     Updated options.
     */ FeatureFormat.prototype.adaptOptions = function(options) {
        return (0, $9zTj4.assign)({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection
        }, options);
    };
    /**
     * @abstract
     * @return {Type} The format type.
     */ FeatureFormat.prototype.getType = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * Read a single feature from a source.
     *
     * @abstract
     * @param {Document|Element|Object|string} source Source.
     * @param {ReadOptions} [opt_options] Read options.
     * @return {import("../Feature.js").FeatureLike} Feature.
     */ FeatureFormat.prototype.readFeature = function(source, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Read all features from a source.
     *
     * @abstract
     * @param {Document|Element|ArrayBuffer|Object|string} source Source.
     * @param {ReadOptions} [opt_options] Read options.
     * @return {Array<import("../Feature.js").FeatureLike>} Features.
     */ FeatureFormat.prototype.readFeatures = function(source, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Read a single geometry from a source.
     *
     * @abstract
     * @param {Document|Element|Object|string} source Source.
     * @param {ReadOptions} [opt_options] Read options.
     * @return {import("../geom/Geometry.js").default} Geometry.
     */ FeatureFormat.prototype.readGeometry = function(source, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Read the projection from a source.
     *
     * @abstract
     * @param {Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default|undefined} Projection.
     */ FeatureFormat.prototype.readProjection = function(source) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Encode a feature in this format.
     *
     * @abstract
     * @param {import("../Feature.js").default} feature Feature.
     * @param {WriteOptions} [opt_options] Write options.
     * @return {string|ArrayBuffer} Result.
     */ FeatureFormat.prototype.writeFeature = function(feature, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Encode an array of features in this format.
     *
     * @abstract
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {WriteOptions} [opt_options] Write options.
     * @return {string|ArrayBuffer} Result.
     */ FeatureFormat.prototype.writeFeatures = function(features, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Write a single geometry in this format.
     *
     * @abstract
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {WriteOptions} [opt_options] Write options.
     * @return {string|ArrayBuffer} Result.
     */ FeatureFormat.prototype.writeGeometry = function(geometry, opt_options) {
        return (0, $61DUI.abstract)();
    };
    return FeatureFormat;
}();
var $5736954797f97c6f$export$2e2bcd8739ae039 = $5736954797f97c6f$var$FeatureFormat;
function $5736954797f97c6f$export$7beeea566b560d4(geometry, write, opt_options) {
    var featureProjection = opt_options ? (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(opt_options.featureProjection) : null;
    var dataProjection = opt_options ? (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(opt_options.dataProjection) : null;
    var transformed;
    if (featureProjection && dataProjection && !(0, $d3bc250abc15fbce$export$fe091d73a555748b)(featureProjection, dataProjection)) transformed = (write ? geometry.clone() : geometry).transform(write ? featureProjection : dataProjection, write ? dataProjection : featureProjection);
    else transformed = geometry;
    if (write && opt_options && /** @type {WriteOptions} */ opt_options.decimals !== undefined) {
        var power_1 = Math.pow(10, /** @type {WriteOptions} */ opt_options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
         * @param {Array<number>} coordinates Coordinates.
         * @return {Array<number>} Transformed coordinates.
         */ var transform = function(coordinates) {
            for(var i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power_1) / power_1;
            return coordinates;
        };
        if (transformed === geometry) transformed = geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function $5736954797f97c6f$export$d3e9e4b1c7f2405c(extent, opt_options) {
    var featureProjection = opt_options ? (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(opt_options.featureProjection) : null;
    var dataProjection = opt_options ? (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(opt_options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, $d3bc250abc15fbce$export$fe091d73a555748b)(featureProjection, dataProjection)) return (0, $d3bc250abc15fbce$export$751c68e0e0efff79)(extent, dataProjection, featureProjection);
    else return extent;
}



var $61DUI = parcelRequire("61DUI");
var $8329f196b52e51c4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @abstract
 */ var $8329f196b52e51c4$var$JSONFeature = /** @class */ function(_super) {
    $8329f196b52e51c4$var$__extends(JSONFeature, _super);
    function JSONFeature() {
        return _super.call(this) || this;
    }
    /**
     * @return {import("./Feature.js").Type} Format.
     */ JSONFeature.prototype.getType = function() {
        return 'json';
    };
    /**
     * Read a feature.  Only works for a single feature. Use `readFeatures` to
     * read a feature collection.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../Feature.js").default} Feature.
     * @api
     */ JSONFeature.prototype.readFeature = function(source, opt_options) {
        return this.readFeatureFromObject($8329f196b52e51c4$var$getObject(source), this.getReadOptions(source, opt_options));
    };
    /**
     * Read all features.  Works with both a single feature and a feature
     * collection.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {Array<import("../Feature.js").default>} Features.
     * @api
     */ JSONFeature.prototype.readFeatures = function(source, opt_options) {
        return this.readFeaturesFromObject($8329f196b52e51c4$var$getObject(source), this.getReadOptions(source, opt_options));
    };
    /**
     * @abstract
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../Feature.js").default} Feature.
     */ JSONFeature.prototype.readFeatureFromObject = function(object, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * @abstract
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<import("../Feature.js").default>} Features.
     */ JSONFeature.prototype.readFeaturesFromObject = function(object, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Read a geometry.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../geom/Geometry.js").default} Geometry.
     * @api
     */ JSONFeature.prototype.readGeometry = function(source, opt_options) {
        return this.readGeometryFromObject($8329f196b52e51c4$var$getObject(source), this.getReadOptions(source, opt_options));
    };
    /**
     * @abstract
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */ JSONFeature.prototype.readGeometryFromObject = function(object, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Read the projection.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default} Projection.
     * @api
     */ JSONFeature.prototype.readProjection = function(source) {
        return this.readProjectionFromObject($8329f196b52e51c4$var$getObject(source));
    };
    /**
     * @abstract
     * @param {Object} object Object.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */ JSONFeature.prototype.readProjectionFromObject = function(object) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Encode a feature as string.
     *
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded feature.
     * @api
     */ JSONFeature.prototype.writeFeature = function(feature, opt_options) {
        return JSON.stringify(this.writeFeatureObject(feature, opt_options));
    };
    /**
     * @abstract
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {Object} Object.
     */ JSONFeature.prototype.writeFeatureObject = function(feature, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Encode an array of features as string.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded features.
     * @api
     */ JSONFeature.prototype.writeFeatures = function(features, opt_options) {
        return JSON.stringify(this.writeFeaturesObject(features, opt_options));
    };
    /**
     * @abstract
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {Object} Object.
     */ JSONFeature.prototype.writeFeaturesObject = function(features, opt_options) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Encode a geometry as string.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded geometry.
     * @api
     */ JSONFeature.prototype.writeGeometry = function(geometry, opt_options) {
        return JSON.stringify(this.writeGeometryObject(geometry, opt_options));
    };
    /**
     * @abstract
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {Object} Object.
     */ JSONFeature.prototype.writeGeometryObject = function(geometry, opt_options) {
        return (0, $61DUI.abstract)();
    };
    return JSONFeature;
}((0, $5736954797f97c6f$export$2e2bcd8739ae039));
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */ function $8329f196b52e51c4$var$getObject(source) {
    if (typeof source === 'string') {
        var object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    } else if (source !== null) return source;
    else return null;
}
var $8329f196b52e51c4$export$2e2bcd8739ae039 = $8329f196b52e51c4$var$JSONFeature;






var $2Jl0K = parcelRequire("2Jl0K");



var $kzmGH = parcelRequire("kzmGH");


/**
 * @module ol/geom/flat/interpolate
 */ 
var $kzmGH = parcelRequire("kzmGH");

var $7aO1A = parcelRequire("7aO1A");
function $9c6bb9bbc92e0d70$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, opt_dest, opt_dimension) {
    var o, t;
    var n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        var x1 = flatCoordinates[offset];
        var y1 = flatCoordinates[offset + 1];
        var length_1 = 0;
        var cumulativeLengths = [
            0
        ];
        for(var i = offset + stride; i < end; i += stride){
            var x2 = flatCoordinates[i];
            var y2 = flatCoordinates[i + 1];
            length_1 += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length_1);
            x1 = x2;
            y1 = y2;
        }
        var target = fraction * length_1;
        var index = (0, $kzmGH.binarySearch)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var dest = opt_dest ? opt_dest : new Array(dimension);
    for(var i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $7aO1A.lerp)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $9c6bb9bbc92e0d70$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    var coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    } else if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    var lo = offset / stride;
    var hi = end / stride;
    while(lo < hi){
        var mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    var m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    var m1 = flatCoordinates[(lo + 1) * stride - 1];
    var t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(var i = 0; i < stride - 1; ++i)coordinate.push((0, $7aO1A.lerp)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $9c6bb9bbc92e0d70$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $9c6bb9bbc92e0d70$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    var coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        } else return null;
    }
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        else if (m <= flatCoordinates[end - 1]) return $9c6bb9bbc92e0d70$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}



/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $09978a897c458dd0$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    var length = 0;
    for(var i = offset + stride; i < end; i += stride){
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $09978a897c458dd0$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    var perimeter = $09978a897c458dd0$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    var dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    var dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}


var $55206fe375bd4802$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ var $55206fe375bd4802$var$LineString = /** @class */ function(_super) {
    $55206fe375bd4802$var$__extends(LineString, _super);
    /**
     * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */ function LineString(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */ _this.flatMidpoint_ = null;
        /**
         * @private
         * @type {number}
         */ _this.flatMidpointRevision_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDeltaRevision_ = -1;
        if (opt_layout !== undefined && !Array.isArray(coordinates[0])) _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
        else _this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, opt_layout);
        return _this;
    }
    /**
     * Append the passed coordinate to the coordinates of the linestring.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @api
     */ LineString.prototype.appendCoordinate = function(coordinate) {
        if (!this.flatCoordinates) this.flatCoordinates = coordinate.slice();
        else (0, $kzmGH.extend)(this.flatCoordinates, coordinate);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!LineString} Clone.
     * @api
     */ LineString.prototype.clone = function() {
        var lineString = new LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ LineString.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $2Jl0K.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $361a43425a99a2db$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $361a43425a99a2db$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * Iterate over each segment, calling the provided callback.
     * If the callback returns a truthy value the function returns that
     * value immediately. Otherwise the function returns `false`.
     *
     * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
     *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
     * @return {T|boolean} Value.
     * @template T,S
     * @api
     */ LineString.prototype.forEachSegment = function(callback) {
        return (0, $ea0949c2dbc314fd$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    };
    /**
     * Returns the coordinate at `m` using linear interpolation, or `null` if no
     * such coordinate exists.
     *
     * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
     * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
     * M will return the first coordinate and Ms greater than the last M will
     * return the last coordinate.
     *
     * @param {number} m M.
     * @param {boolean} [opt_extrapolate] Extrapolate. Default is `false`.
     * @return {import("../coordinate.js").Coordinate|null} Coordinate.
     * @api
     */ LineString.prototype.getCoordinateAtM = function(m, opt_extrapolate) {
        if (this.layout != (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYM && this.layout != (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYZM) return null;
        var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
        return (0, $9c6bb9bbc92e0d70$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    };
    /**
     * Return the coordinates of the linestring.
     * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
     * @api
     */ LineString.prototype.getCoordinates = function() {
        return (0, $f2531bda6eeb448c$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * Return the coordinate at the provided fraction along the linestring.
     * The `fraction` is a number between 0 and 1, where 0 is the start of the
     * linestring and 1 is the end.
     * @param {number} fraction Fraction.
     * @param {import("../coordinate.js").Coordinate} [opt_dest] Optional coordinate whose values will
     *     be modified. If not provided, a new coordinate will be returned.
     * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
     * @api
     */ LineString.prototype.getCoordinateAt = function(fraction, opt_dest) {
        return (0, $9c6bb9bbc92e0d70$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, opt_dest, this.stride);
    };
    /**
     * Return the length of the linestring on projected plane.
     * @return {number} Length (on projected plane).
     * @api
     */ LineString.prototype.getLength = function() {
        return (0, $09978a897c458dd0$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * @return {Array<number>} Flat midpoint.
     */ LineString.prototype.getFlatMidpoint = function() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return this.flatMidpoint_;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {LineString} Simplified LineString.
     * @protected
     */ LineString.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $2c00e3f050ec1bce$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LineString(simplifiedFlatCoordinates, (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./Geometry.js").Type} Geometry type.
     * @api
     */ LineString.prototype.getType = function() {
        return 'LineString';
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ LineString.prototype.intersectsExtent = function(extent) {
        return (0, $9fc1bfe0d9ae3906$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    };
    /**
     * Set the coordinates of the linestring.
     * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */ LineString.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $63fb5fb55d4eceae$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return LineString;
}((0, $29fd4fdf263dcdf4$export$2e2bcd8739ae039));
var $55206fe375bd4802$export$2e2bcd8739ae039 = $55206fe375bd4802$var$LineString;







var $2Jl0K = parcelRequire("2Jl0K");



var $kzmGH = parcelRequire("kzmGH");



var $2baabf99cb35abca$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ var $2baabf99cb35abca$var$MultiLineString = /** @class */ function(_super) {
    $2baabf99cb35abca$var$__extends(MultiLineString, _super);
    /**
     * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
     *     Coordinates or LineString geometries. (For internal use, flat coordinates in
     *     combination with `opt_layout` and `opt_ends` are also accepted.)
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @param {Array<number>} [opt_ends] Flat coordinate ends for internal use.
     */ function MultiLineString(coordinates, opt_layout, opt_ends) {
        var _this = _super.call(this) || this;
        /**
         * @type {Array<number>}
         * @private
         */ _this.ends_ = [];
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) _this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, opt_layout);
        else if (opt_layout !== undefined && opt_ends) {
            _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
            _this.ends_ = opt_ends;
        } else {
            var layout = _this.getLayout();
            var lineStrings = /** @type {Array<LineString>} */ coordinates;
            var flatCoordinates = [];
            var ends = [];
            for(var i = 0, ii = lineStrings.length; i < ii; ++i){
                var lineString = lineStrings[i];
                if (i === 0) layout = lineString.getLayout();
                (0, $kzmGH.extend)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            _this.setFlatCoordinates(layout, flatCoordinates);
            _this.ends_ = ends;
        }
        return _this;
    }
    /**
     * Append the passed linestring to the multilinestring.
     * @param {LineString} lineString LineString.
     * @api
     */ MultiLineString.prototype.appendLineString = function(lineString) {
        if (!this.flatCoordinates) this.flatCoordinates = lineString.getFlatCoordinates().slice();
        else (0, $kzmGH.extend)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!MultiLineString} Clone.
     * @api
     */ MultiLineString.prototype.clone = function() {
        var multiLineString = new MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ MultiLineString.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $2Jl0K.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $361a43425a99a2db$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $361a43425a99a2db$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * Returns the coordinate at `m` using linear interpolation, or `null` if no
     * such coordinate exists.
     *
     * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
     * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
     * M will return the first coordinate and Ms greater than the last M will
     * return the last coordinate.
     *
     * `opt_interpolate` controls interpolation between consecutive LineStrings
     * within the MultiLineString. If `opt_interpolate` is `true` the coordinates
     * will be linearly interpolated between the last coordinate of one LineString
     * and the first coordinate of the next LineString.  If `opt_interpolate` is
     * `false` then the function will return `null` for Ms falling between
     * LineStrings.
     *
     * @param {number} m M.
     * @param {boolean} [opt_extrapolate] Extrapolate. Default is `false`.
     * @param {boolean} [opt_interpolate] Interpolate. Default is `false`.
     * @return {import("../coordinate.js").Coordinate|null} Coordinate.
     * @api
     */ MultiLineString.prototype.getCoordinateAtM = function(m, opt_extrapolate, opt_interpolate) {
        if (this.layout != (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYM && this.layout != (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYZM || this.flatCoordinates.length === 0) return null;
        var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
        var interpolate = opt_interpolate !== undefined ? opt_interpolate : false;
        return (0, $9c6bb9bbc92e0d70$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    };
    /**
     * Return the coordinates of the multilinestring.
     * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
     * @api
     */ MultiLineString.prototype.getCoordinates = function() {
        return (0, $f2531bda6eeb448c$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    };
    /**
     * @return {Array<number>} Ends.
     */ MultiLineString.prototype.getEnds = function() {
        return this.ends_;
    };
    /**
     * Return the linestring at the specified index.
     * @param {number} index Index.
     * @return {LineString} LineString.
     * @api
     */ MultiLineString.prototype.getLineString = function(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $55206fe375bd4802$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    };
    /**
     * Return the linestrings of this multilinestring.
     * @return {Array<LineString>} LineStrings.
     * @api
     */ MultiLineString.prototype.getLineStrings = function() {
        var flatCoordinates = this.flatCoordinates;
        var ends = this.ends_;
        var layout = this.layout;
        /** @type {Array<LineString>} */ var lineStrings = [];
        var offset = 0;
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var lineString = new (0, $55206fe375bd4802$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    };
    /**
     * @return {Array<number>} Flat midpoints.
     */ MultiLineString.prototype.getFlatMidpoints = function() {
        var midpoints = [];
        var flatCoordinates = this.flatCoordinates;
        var offset = 0;
        var ends = this.ends_;
        var stride = this.stride;
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var midpoint = (0, $9c6bb9bbc92e0d70$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $kzmGH.extend)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {MultiLineString} Simplified MultiLineString.
     * @protected
     */ MultiLineString.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $2c00e3f050ec1bce$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new MultiLineString(simplifiedFlatCoordinates, (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY, simplifiedEnds);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./Geometry.js").Type} Geometry type.
     * @api
     */ MultiLineString.prototype.getType = function() {
        return 'MultiLineString';
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ MultiLineString.prototype.intersectsExtent = function(extent) {
        return (0, $9fc1bfe0d9ae3906$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    };
    /**
     * Set the coordinates of the multilinestring.
     * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
     * @param {GeometryLayout} [opt_layout] Layout.
     * @api
     */ MultiLineString.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        var ends = (0, $63fb5fb55d4eceae$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    };
    return MultiLineString;
}((0, $29fd4fdf263dcdf4$export$2e2bcd8739ae039));
var $2baabf99cb35abca$export$2e2bcd8739ae039 = $2baabf99cb35abca$var$MultiLineString;





var $2Jl0K = parcelRequire("2Jl0K");


var $kzmGH = parcelRequire("kzmGH");


var $7aO1A = parcelRequire("7aO1A");
var $2033e15e1dc7c9a3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ var $2033e15e1dc7c9a3$var$MultiPoint = /** @class */ function(_super) {
    $2033e15e1dc7c9a3$var$__extends(MultiPoint, _super);
    /**
     * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */ function MultiPoint(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        if (opt_layout && !Array.isArray(coordinates[0])) _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
        else _this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, opt_layout);
        return _this;
    }
    /**
     * Append the passed point to this multipoint.
     * @param {Point} point Point.
     * @api
     */ MultiPoint.prototype.appendPoint = function(point) {
        if (!this.flatCoordinates) this.flatCoordinates = point.getFlatCoordinates().slice();
        else (0, $kzmGH.extend)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!MultiPoint} Clone.
     * @api
     */ MultiPoint.prototype.clone = function() {
        var multiPoint = new MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ MultiPoint.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $2Jl0K.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        var flatCoordinates = this.flatCoordinates;
        var stride = this.stride;
        for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            var squaredDistance = (0, $7aO1A.squaredDistance)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(var j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    };
    /**
     * Return the coordinates of the multipoint.
     * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
     * @api
     */ MultiPoint.prototype.getCoordinates = function() {
        return (0, $f2531bda6eeb448c$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * Return the point at the specified index.
     * @param {number} index Index.
     * @return {Point} Point.
     * @api
     */ MultiPoint.prototype.getPoint = function(index) {
        var n = !this.flatCoordinates ? 0 : this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $112514a365e4f8fa$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    };
    /**
     * Return the points of this multipoint.
     * @return {Array<Point>} Points.
     * @api
     */ MultiPoint.prototype.getPoints = function() {
        var flatCoordinates = this.flatCoordinates;
        var layout = this.layout;
        var stride = this.stride;
        /** @type {Array<Point>} */ var points = [];
        for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            var point = new (0, $112514a365e4f8fa$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    };
    /**
     * Get the type of this geometry.
     * @return {import("./Geometry.js").Type} Geometry type.
     * @api
     */ MultiPoint.prototype.getType = function() {
        return 'MultiPoint';
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ MultiPoint.prototype.intersectsExtent = function(extent) {
        var flatCoordinates = this.flatCoordinates;
        var stride = this.stride;
        for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            var x = flatCoordinates[i];
            var y = flatCoordinates[i + 1];
            if ((0, $2Jl0K.containsXY)(extent, x, y)) return true;
        }
        return false;
    };
    /**
     * Set the coordinates of the multipoint.
     * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */ MultiPoint.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $63fb5fb55d4eceae$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return MultiPoint;
}((0, $29fd4fdf263dcdf4$export$2e2bcd8739ae039));
var $2033e15e1dc7c9a3$export$2e2bcd8739ae039 = $2033e15e1dc7c9a3$var$MultiPoint;








var $2Jl0K = parcelRequire("2Jl0K");


var $kzmGH = parcelRequire("kzmGH");





/**
 * @module ol/geom/flat/center
 */ 
var $2Jl0K = parcelRequire("2Jl0K");
function $9e710762a0996f67$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    var flatCenters = [];
    var extent = (0, $2Jl0K.createEmpty)();
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        extent = (0, $2Jl0K.createOrUpdateFromFlatCoordinates)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}




var $7abcd05811d53b15$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ var $7abcd05811d53b15$var$MultiPolygon = /** @class */ function(_super) {
    $7abcd05811d53b15$var$__extends(MultiPolygon, _super);
    /**
     * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` and `opt_endss` are also accepted.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @param {Array<Array<number>>} [opt_endss] Array of ends for internal use with flat coordinates.
     */ function MultiPolygon(coordinates, opt_layout, opt_endss) {
        var _this = _super.call(this) || this;
        /**
         * @type {Array<Array<number>>}
         * @private
         */ _this.endss_ = [];
        /**
         * @private
         * @type {number}
         */ _this.flatInteriorPointsRevision_ = -1;
        /**
         * @private
         * @type {Array<number>}
         */ _this.flatInteriorPoints_ = null;
        /**
         * @private
         * @type {number}
         */ _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.maxDeltaRevision_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.orientedRevision_ = -1;
        /**
         * @private
         * @type {Array<number>}
         */ _this.orientedFlatCoordinates_ = null;
        if (!opt_endss && !Array.isArray(coordinates[0])) {
            var layout = _this.getLayout();
            var polygons = /** @type {Array<Polygon>} */ coordinates;
            var flatCoordinates = [];
            var endss = [];
            for(var i = 0, ii = polygons.length; i < ii; ++i){
                var polygon = polygons[i];
                if (i === 0) layout = polygon.getLayout();
                var offset = flatCoordinates.length;
                var ends = polygon.getEnds();
                for(var j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $kzmGH.extend)(flatCoordinates, polygon.getFlatCoordinates());
                endss.push(ends);
            }
            opt_layout = layout;
            coordinates = flatCoordinates;
            opt_endss = endss;
        }
        if (opt_layout !== undefined && opt_endss) {
            _this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ coordinates);
            _this.endss_ = opt_endss;
        } else _this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, opt_layout);
        return _this;
    }
    /**
     * Append the passed polygon to this multipolygon.
     * @param {Polygon} polygon Polygon.
     * @api
     */ MultiPolygon.prototype.appendPolygon = function(polygon) {
        /** @type {Array<number>} */ var ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            var offset = this.flatCoordinates.length;
            (0, $kzmGH.extend)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(var i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!MultiPolygon} Clone.
     * @api
     */ MultiPolygon.prototype.clone = function() {
        var len = this.endss_.length;
        var newEndss = new Array(len);
        for(var i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        var multiPolygon = new MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */ MultiPolygon.prototype.closestPointXY = function(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $2Jl0K.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $361a43425a99a2db$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $361a43425a99a2db$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */ MultiPolygon.prototype.containsXY = function(x, y) {
        return (0, $7d0e7eb0e3a76e58$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    };
    /**
     * Return the area of the multipolygon on projected plane.
     * @return {number} Area (on projected plane).
     * @api
     */ MultiPolygon.prototype.getArea = function() {
        return (0, $94a20b0959033b1b$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    };
    /**
     * Get the coordinate array for this geometry.  This array has the structure
     * of a GeoJSON coordinate array for multi-polygons.
     *
     * @param {boolean} [opt_right] Orient coordinates according to the right-hand
     *     rule (counter-clockwise for exterior and clockwise for interior rings).
     *     If `false`, coordinates will be oriented according to the left-hand rule
     *     (clockwise for exterior and counter-clockwise for interior rings).
     *     By default, coordinate orientation will depend on how the geometry was
     *     constructed.
     * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
     * @api
     */ MultiPolygon.prototype.getCoordinates = function(opt_right) {
        var flatCoordinates;
        if (opt_right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $22012b047d8e53b3$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, opt_right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $f2531bda6eeb448c$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
    };
    /**
     * @return {Array<Array<number>>} Endss.
     */ MultiPolygon.prototype.getEndss = function() {
        return this.endss_;
    };
    /**
     * @return {Array<number>} Flat interior points.
     */ MultiPolygon.prototype.getFlatInteriorPoints = function() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            var flatCenters = (0, $9e710762a0996f67$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $c255a8ea33a1a6b5$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return this.flatInteriorPoints_;
    };
    /**
     * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
     * @return {MultiPoint} Interior points as XYM coordinates, where M is
     * the length of the horizontal intersection that the point belongs to.
     * @api
     */ MultiPolygon.prototype.getInteriorPoints = function() {
        return new (0, $2033e15e1dc7c9a3$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), (0, $a46a42327f86f965$export$2e2bcd8739ae039).XYM);
    };
    /**
     * @return {Array<number>} Oriented flat coordinates.
     */ MultiPolygon.prototype.getOrientedFlatCoordinates = function() {
        if (this.orientedRevision_ != this.getRevision()) {
            var flatCoordinates = this.flatCoordinates;
            if ((0, $22012b047d8e53b3$export$a1d138f4bd85f4b4)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $22012b047d8e53b3$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return this.orientedFlatCoordinates_;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {MultiPolygon} Simplified MultiPolygon.
     * @protected
     */ MultiPolygon.prototype.getSimplifiedGeometryInternal = function(squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $2c00e3f050ec1bce$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new MultiPolygon(simplifiedFlatCoordinates, (0, $a46a42327f86f965$export$2e2bcd8739ae039).XY, simplifiedEndss);
    };
    /**
     * Return the polygon at the specified index.
     * @param {number} index Index.
     * @return {Polygon} Polygon.
     * @api
     */ MultiPolygon.prototype.getPolygon = function(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        var offset;
        if (index === 0) offset = 0;
        else {
            var prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        var ends = this.endss_[index].slice();
        var end = ends[ends.length - 1];
        if (offset !== 0) for(var i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $c59228195e440f9b$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    };
    /**
     * Return the polygons of this multipolygon.
     * @return {Array<Polygon>} Polygons.
     * @api
     */ MultiPolygon.prototype.getPolygons = function() {
        var layout = this.layout;
        var flatCoordinates = this.flatCoordinates;
        var endss = this.endss_;
        var polygons = [];
        var offset = 0;
        for(var i = 0, ii = endss.length; i < ii; ++i){
            var ends = endss[i].slice();
            var end = ends[ends.length - 1];
            if (offset !== 0) for(var j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            var polygon = new (0, $c59228195e440f9b$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    };
    /**
     * Get the type of this geometry.
     * @return {import("./Geometry.js").Type} Geometry type.
     * @api
     */ MultiPolygon.prototype.getType = function() {
        return 'MultiPolygon';
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */ MultiPolygon.prototype.intersectsExtent = function(extent) {
        return (0, $9fc1bfe0d9ae3906$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    };
    /**
     * Set the coordinates of the multipolygon.
     * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */ MultiPolygon.prototype.setCoordinates = function(coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        var endss = (0, $63fb5fb55d4eceae$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            var lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    };
    return MultiPolygon;
}((0, $29fd4fdf263dcdf4$export$2e2bcd8739ae039));
var $7abcd05811d53b15$export$2e2bcd8739ae039 = $7abcd05811d53b15$var$MultiPolygon;





var $3JLp3 = parcelRequire("3JLp3");

var $9zTj4 = parcelRequire("9zTj4");


var $263b744d74718533$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */ /**
 * @typedef {Object} Options
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @api
 */ var $263b744d74718533$var$GeoJSON = /** @class */ function(_super) {
    $263b744d74718533$var$__extends(GeoJSON, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function GeoJSON(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this) || this;
        /**
         * @type {import("../proj/Projection.js").default}
         */ _this.dataProjection = (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(options.dataProjection ? options.dataProjection : 'EPSG:4326');
        if (options.featureProjection) /**
             * @type {import("../proj/Projection.js").default}
             */ _this.defaultFeatureProjection = (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(options.featureProjection);
        /**
         * Name of the geometry attribute for features.
         * @type {string|undefined}
         * @private
         */ _this.geometryName_ = options.geometryName;
        /**
         * Look for the geometry name in the feature GeoJSON
         * @type {boolean|undefined}
         * @private
         */ _this.extractGeometryName_ = options.extractGeometryName;
        _this.supportedMediaTypes = [
            'application/geo+json',
            'application/vnd.geo+json'
        ];
        return _this;
    }
    /**
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../Feature.js").default} Feature.
     */ GeoJSON.prototype.readFeatureFromObject = function(object, opt_options) {
        /**
         * @type {GeoJSONFeature}
         */ var geoJSONFeature = null;
        if (object['type'] === 'Feature') geoJSONFeature = /** @type {GeoJSONFeature} */ object;
        else geoJSONFeature = {
            'type': 'Feature',
            'geometry': /** @type {GeoJSONGeometry} */ object,
            'properties': null
        };
        var geometry = $263b744d74718533$var$readGeometry(geoJSONFeature['geometry'], opt_options);
        var feature = new (0, $92e93536945a317f$export$2e2bcd8739ae039)();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        else if (this.extractGeometryName_ && true) feature.setGeometryName(geoJSONFeature['geometry_name']);
        feature.setGeometry(geometry);
        if ('id' in geoJSONFeature) feature.setId(geoJSONFeature['id']);
        if (geoJSONFeature['properties']) feature.setProperties(geoJSONFeature['properties'], true);
        return feature;
    };
    /**
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<Feature>} Features.
     */ GeoJSON.prototype.readFeaturesFromObject = function(object, opt_options) {
        var geoJSONObject = /** @type {GeoJSONObject} */ object;
        /** @type {Array<import("../Feature.js").default>} */ var features = null;
        if (geoJSONObject['type'] === 'FeatureCollection') {
            var geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ object;
            features = [];
            var geoJSONFeatures = geoJSONFeatureCollection['features'];
            for(var i = 0, ii = geoJSONFeatures.length; i < ii; ++i)features.push(this.readFeatureFromObject(geoJSONFeatures[i], opt_options));
        } else features = [
            this.readFeatureFromObject(object, opt_options)
        ];
        return features;
    };
    /**
     * @param {GeoJSONGeometry} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */ GeoJSON.prototype.readGeometryFromObject = function(object, opt_options) {
        return $263b744d74718533$var$readGeometry(object, opt_options);
    };
    /**
     * @param {Object} object Object.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */ GeoJSON.prototype.readProjectionFromObject = function(object) {
        var crs = object['crs'];
        var projection;
        if (crs) {
            if (crs['type'] == 'name') projection = (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(crs['properties']['name']);
            else if (crs['type'] === 'EPSG') projection = (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)('EPSG:' + crs['properties']['code']);
            else (0, $3JLp3.assert)(false, 36); // Unknown SRS type
        } else projection = this.dataProjection;
        return /** @type {import("../proj/Projection.js").default} */ projection;
    };
    /**
     * Encode a feature as a GeoJSON Feature object.
     *
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {GeoJSONFeature} Object.
     * @api
     */ GeoJSON.prototype.writeFeatureObject = function(feature, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        /** @type {GeoJSONFeature} */ var object = {
            'type': 'Feature',
            geometry: null,
            properties: null
        };
        var id = feature.getId();
        if (id !== undefined) object.id = id;
        if (!feature.hasProperties()) return object;
        var properties = feature.getProperties();
        var geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = $263b744d74718533$var$writeGeometry(geometry, opt_options);
            delete properties[feature.getGeometryName()];
        }
        if (!(0, $9zTj4.isEmpty)(properties)) object.properties = properties;
        return object;
    };
    /**
     * Encode an array of features as a GeoJSON object.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {GeoJSONFeatureCollection} GeoJSON Object.
     * @api
     */ GeoJSON.prototype.writeFeaturesObject = function(features, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        var objects = [];
        for(var i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], opt_options));
        return {
            type: 'FeatureCollection',
            features: objects
        };
    };
    /**
     * Encode a geometry as a GeoJSON object.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
     * @api
     */ GeoJSON.prototype.writeGeometryObject = function(geometry, opt_options) {
        return $263b744d74718533$var$writeGeometry(geometry, this.adaptOptions(opt_options));
    };
    return GeoJSON;
}((0, $8329f196b52e51c4$export$2e2bcd8739ae039));
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $263b744d74718533$var$readGeometry(object, opt_options) {
    if (!object) return null;
    /**
     * @type {import("../geom/Geometry.js").default}
     */ var geometry;
    switch(object['type']){
        case 'Point':
            geometry = $263b744d74718533$var$readPointGeometry(/** @type {GeoJSONPoint} */ object);
            break;
        case 'LineString':
            geometry = $263b744d74718533$var$readLineStringGeometry(/** @type {GeoJSONLineString} */ object);
            break;
        case 'Polygon':
            geometry = $263b744d74718533$var$readPolygonGeometry(/** @type {GeoJSONPolygon} */ object);
            break;
        case 'MultiPoint':
            geometry = $263b744d74718533$var$readMultiPointGeometry(/** @type {GeoJSONMultiPoint} */ object);
            break;
        case 'MultiLineString':
            geometry = $263b744d74718533$var$readMultiLineStringGeometry(/** @type {GeoJSONMultiLineString} */ object);
            break;
        case 'MultiPolygon':
            geometry = $263b744d74718533$var$readMultiPolygonGeometry(/** @type {GeoJSONMultiPolygon} */ object);
            break;
        case 'GeometryCollection':
            geometry = $263b744d74718533$var$readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ object);
            break;
        default:
            throw new Error('Unsupported GeoJSON type: ' + object['type']);
    }
    return (0, $5736954797f97c6f$export$7beeea566b560d4)(geometry, false, opt_options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
 * @return {GeometryCollection} Geometry collection.
 */ function $263b744d74718533$var$readGeometryCollectionGeometry(object, opt_options) {
    var geometries = object['geometries'].map(/**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("../geom/Geometry.js").default} geometry Geometry.
     */ function(geometry) {
        return $263b744d74718533$var$readGeometry(geometry, opt_options);
    });
    return new (0, $11ca4d4f4e4e4159$export$2e2bcd8739ae039)(geometries);
}
/**
 * @param {GeoJSONPoint} object Object.
 * @return {Point} Point.
 */ function $263b744d74718533$var$readPointGeometry(object) {
    return new (0, $112514a365e4f8fa$export$2e2bcd8739ae039)(object['coordinates']);
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {LineString} LineString.
 */ function $263b744d74718533$var$readLineStringGeometry(object) {
    return new (0, $55206fe375bd4802$export$2e2bcd8739ae039)(object['coordinates']);
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {MultiLineString} MultiLineString.
 */ function $263b744d74718533$var$readMultiLineStringGeometry(object) {
    return new (0, $2baabf99cb35abca$export$2e2bcd8739ae039)(object['coordinates']);
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {MultiPoint} MultiPoint.
 */ function $263b744d74718533$var$readMultiPointGeometry(object) {
    return new (0, $2033e15e1dc7c9a3$export$2e2bcd8739ae039)(object['coordinates']);
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {MultiPolygon} MultiPolygon.
 */ function $263b744d74718533$var$readMultiPolygonGeometry(object) {
    return new (0, $7abcd05811d53b15$export$2e2bcd8739ae039)(object['coordinates']);
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {Polygon} Polygon.
 */ function $263b744d74718533$var$readPolygonGeometry(object) {
    return new (0, $c59228195e440f9b$export$2e2bcd8739ae039)(object['coordinates']);
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $263b744d74718533$var$writeGeometry(geometry, opt_options) {
    geometry = (0, $5736954797f97c6f$export$7beeea566b560d4)(geometry, true, opt_options);
    var type = geometry.getType();
    /** @type {GeoJSONGeometry} */ var geoJSON;
    switch(type){
        case 'Point':
            geoJSON = $263b744d74718533$var$writePointGeometry(/** @type {Point} */ geometry, opt_options);
            break;
        case 'LineString':
            geoJSON = $263b744d74718533$var$writeLineStringGeometry(/** @type {LineString} */ geometry, opt_options);
            break;
        case 'Polygon':
            geoJSON = $263b744d74718533$var$writePolygonGeometry(/** @type {Polygon} */ geometry, opt_options);
            break;
        case 'MultiPoint':
            geoJSON = $263b744d74718533$var$writeMultiPointGeometry(/** @type {MultiPoint} */ geometry, opt_options);
            break;
        case 'MultiLineString':
            geoJSON = $263b744d74718533$var$writeMultiLineStringGeometry(/** @type {MultiLineString} */ geometry, opt_options);
            break;
        case 'MultiPolygon':
            geoJSON = $263b744d74718533$var$writeMultiPolygonGeometry(/** @type {MultiPolygon} */ geometry, opt_options);
            break;
        case 'GeometryCollection':
            geoJSON = $263b744d74718533$var$writeGeometryCollectionGeometry(/** @type {GeometryCollection} */ geometry, opt_options);
            break;
        case 'Circle':
            geoJSON = {
                type: 'GeometryCollection',
                geometries: []
            };
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return geoJSON;
}
/**
 * @param {GeometryCollection} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */ function $263b744d74718533$var$writeGeometryCollectionGeometry(geometry, opt_options) {
    var geometries = geometry.getGeometriesArray().map(function(geometry) {
        var options = (0, $9zTj4.assign)({}, opt_options);
        delete options.featureProjection;
        return $263b744d74718533$var$writeGeometry(geometry, options);
    });
    return {
        type: 'GeometryCollection',
        geometries: geometries
    };
}
/**
 * @param {LineString} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $263b744d74718533$var$writeLineStringGeometry(geometry, opt_options) {
    return {
        type: 'LineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {MultiLineString} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $263b744d74718533$var$writeMultiLineStringGeometry(geometry, opt_options) {
    return {
        type: 'MultiLineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {MultiPoint} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $263b744d74718533$var$writeMultiPointGeometry(geometry, opt_options) {
    return {
        type: 'MultiPoint',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {MultiPolygon} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $263b744d74718533$var$writeMultiPolygonGeometry(geometry, opt_options) {
    var right;
    if (opt_options) right = opt_options.rightHanded;
    return {
        type: 'MultiPolygon',
        coordinates: geometry.getCoordinates(right)
    };
}
/**
 * @param {Point} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $263b744d74718533$var$writePointGeometry(geometry, opt_options) {
    return {
        type: 'Point',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {Polygon} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $263b744d74718533$var$writePolygonGeometry(geometry, opt_options) {
    var right;
    if (opt_options) right = opt_options.rightHanded;
    return {
        type: 'Polygon',
        coordinates: geometry.getCoordinates(right)
    };
}
var $263b744d74718533$export$2e2bcd8739ae039 = $263b744d74718533$var$GeoJSON;


/**
 * @module ol/source/OSM
 */ /**
 * @module ol/source/XYZ
 */ 
var $cFmyb = parcelRequire("cFmyb");

var $gNCG1 = parcelRequire("gNCG1");

var $cFmyb = parcelRequire("cFmyb");


var $61DUI = parcelRequire("61DUI");

var $b13314a55e94df73$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A function that takes an {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   var xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     var data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes an {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ var $b13314a55e94df73$var$Tile = /** @class */ function(_super) {
    $b13314a55e94df73$var$__extends(Tile, _super);
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("./TileState.js").default} state State.
     * @param {Options} [opt_options] Tile options.
     */ function Tile(tileCoord, state, opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("./tilecoord.js").TileCoord}
         */ _this.tileCoord = tileCoord;
        /**
         * @protected
         * @type {import("./TileState.js").default}
         */ _this.state = state;
        /**
         * An "interim" tile for this tile. The interim tile may be used while this
         * one is loading, for "smooth" transitions when changing params/dimensions
         * on the source.
         * @type {Tile}
         */ _this.interimTile = null;
        /**
         * A key assigned to the tile. This is used by the tile source to determine
         * if this tile can effectively be used, or if a new tile should be created
         * and this one be used as an interim tile for this new tile.
         * @type {string}
         */ _this.key = '';
        /**
         * The duration for the opacity transition.
         * @type {number}
         */ _this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
         * Lookup of start times for rendering transitions.  If the start time is
         * equal to -1, the transition is complete.
         * @type {Object<string, number>}
         */ _this.transitionStarts_ = {};
        /**
         * @type {boolean}
         */ _this.interpolate = !!options.interpolate;
        return _this;
    }
    /**
     * @protected
     */ Tile.prototype.changed = function() {
        this.dispatchEvent((0, $cFmyb.default).CHANGE);
    };
    /**
     * Called by the tile cache when the tile is removed from the cache due to expiry
     */ Tile.prototype.release = function() {};
    /**
     * @return {string} Key.
     */ Tile.prototype.getKey = function() {
        return this.key + '/' + this.tileCoord;
    };
    /**
     * Get the interim tile most suitable for rendering using the chain of interim
     * tiles. This corresponds to the  most recent tile that has been loaded, if no
     * such tile exists, the original tile is returned.
     * @return {!Tile} Best tile for rendering.
     */ Tile.prototype.getInterimTile = function() {
        if (!this.interimTile) //empty chain
        return this;
        var tile = this.interimTile;
        // find the first loaded tile and return it. Since the chain is sorted in
        // decreasing order of creation time, there is no need to search the remainder
        // of the list (all those tiles correspond to older requests and will be
        // cleaned up by refreshInterimChain)
        do {
            if (tile.getState() == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED) {
                // Show tile immediately instead of fading it in after loading, because
                // the interim tile is in place already
                this.transition_ = 0;
                return tile;
            }
            tile = tile.interimTile;
        }while (tile);
        // we can not find a better tile
        return this;
    };
    /**
     * Goes through the chain of interim tiles and discards sections of the chain
     * that are no longer relevant.
     */ Tile.prototype.refreshInterimChain = function() {
        if (!this.interimTile) return;
        var tile = this.interimTile;
        /**
         * @type {Tile}
         */ var prev = this;
        do {
            if (tile.getState() == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED) {
                //we have a loaded tile, we can discard the rest of the list
                //we would could abort any LOADING tile request
                //older than this tile (i.e. any LOADING tile following this entry in the chain)
                tile.interimTile = null;
                break;
            } else if (tile.getState() == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADING) //keep this LOADING tile any loaded tiles later in the chain are
            //older than this tile, so we're still interested in the request
            prev = tile;
            else if (tile.getState() == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE) //the head of the list is the most current tile, we don't need
            //to start any other requests for this chain
            prev.interimTile = tile.interimTile;
            else prev = tile;
            tile = prev.interimTile;
        }while (tile);
    };
    /**
     * Get the tile coordinate for this tile.
     * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
     * @api
     */ Tile.prototype.getTileCoord = function() {
        return this.tileCoord;
    };
    /**
     * @return {import("./TileState.js").default} State.
     */ Tile.prototype.getState = function() {
        return this.state;
    };
    /**
     * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
     * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
     * when the tile cannot be loaded. Otherwise the tile cannot be removed from
     * the tile queue and will block other requests.
     * @param {import("./TileState.js").default} state State.
     * @api
     */ Tile.prototype.setState = function(state) {
        if (this.state !== (0, $b662dbd74afc801f$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error('Tile load sequence violation');
        this.state = state;
        this.changed();
    };
    /**
     * Load the image or retry if loading previously failed.
     * Loading is taken care of by the tile queue, and calling this method is
     * only needed for preloading or for reloading in case of an error.
     * @abstract
     * @api
     */ Tile.prototype.load = function() {
        (0, $61DUI.abstract)();
    };
    /**
     * Get the alpha value for rendering.
     * @param {string} id An id for the renderer.
     * @param {number} time The render frame time.
     * @return {number} A number between 0 and 1.
     */ Tile.prototype.getAlpha = function(id, time) {
        if (!this.transition_) return 1;
        var start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        var delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $c2ae491963dea068$export$929e5a82286172a6)(delta / this.transition_);
    };
    /**
     * Determine if a tile is in an alpha transition.  A tile is considered in
     * transition if tile.getAlpha() has not yet been called or has been called
     * and returned 1.
     * @param {string} id An id for the renderer.
     * @return {boolean} The tile is in transition.
     */ Tile.prototype.inTransition = function(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    };
    /**
     * Mark a transition as complete.
     * @param {string} id An id for the renderer.
     */ Tile.prototype.endTransition = function(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    };
    return Tile;
}((0, $gNCG1.default));
var $b13314a55e94df73$export$2e2bcd8739ae039 = $b13314a55e94df73$var$Tile;




var $djuby = parcelRequire("djuby");

var $cFmyb = parcelRequire("cFmyb");

var $gNCG1 = parcelRequire("gNCG1");

var $cFmyb = parcelRequire("cFmyb");

var $61DUI = parcelRequire("61DUI");
var $f4cef90621c5d8c2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @abstract
 */ var $f4cef90621c5d8c2$var$ImageBase = /** @class */ function(_super) {
    $f4cef90621c5d8c2$var$__extends(ImageBase, _super);
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number|undefined} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./ImageState.js").default} state State.
     */ function ImageBase(extent, resolution, pixelRatio, state) {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {import("./extent.js").Extent}
         */ _this.extent = extent;
        /**
         * @private
         * @type {number}
         */ _this.pixelRatio_ = pixelRatio;
        /**
         * @protected
         * @type {number|undefined}
         */ _this.resolution = resolution;
        /**
         * @protected
         * @type {import("./ImageState.js").default}
         */ _this.state = state;
        return _this;
    }
    /**
     * @protected
     */ ImageBase.prototype.changed = function() {
        this.dispatchEvent((0, $cFmyb.default).CHANGE);
    };
    /**
     * @return {import("./extent.js").Extent} Extent.
     */ ImageBase.prototype.getExtent = function() {
        return this.extent;
    };
    /**
     * @abstract
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     */ ImageBase.prototype.getImage = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * @return {number} PixelRatio.
     */ ImageBase.prototype.getPixelRatio = function() {
        return this.pixelRatio_;
    };
    /**
     * @return {number} Resolution.
     */ ImageBase.prototype.getResolution = function() {
        return /** @type {number} */ this.resolution;
    };
    /**
     * @return {import("./ImageState.js").default} State.
     */ ImageBase.prototype.getState = function() {
        return this.state;
    };
    /**
     * Load not yet loaded URI.
     * @abstract
     */ ImageBase.prototype.load = function() {
        (0, $61DUI.abstract)();
    };
    return ImageBase;
}((0, $gNCG1.default));
var $f4cef90621c5d8c2$export$2e2bcd8739ae039 = $f4cef90621c5d8c2$var$ImageBase;


/**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $a7eed36cc9f4d31d$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};



var $bInFo = parcelRequire("bInFo");

var $2Jl0K = parcelRequire("2Jl0K");

var $1dBX3 = parcelRequire("1dBX3");
var $1548b965f58c9226$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(ImageWrapper, string): void} LoadFunction
 * @api
 */ var $1548b965f58c9226$var$ImageWrapper = /** @class */ function(_super) {
    $1548b965f58c9226$var$__extends(ImageWrapper, _super);
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number|undefined} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {string} src Image source URI.
     * @param {?string} crossOrigin Cross origin.
     * @param {LoadFunction} imageLoadFunction Image load function.
     */ function ImageWrapper(extent, resolution, pixelRatio, src, crossOrigin, imageLoadFunction) {
        var _this = _super.call(this, extent, resolution, pixelRatio, (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).IDLE) || this;
        /**
         * @private
         * @type {string}
         */ _this.src_ = src;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement}
         */ _this.image_ = new Image();
        if (crossOrigin !== null) _this.image_.crossOrigin = crossOrigin;
        /**
         * @private
         * @type {?function():void}
         */ _this.unlisten_ = null;
        /**
         * @protected
         * @type {import("./ImageState.js").default}
         */ _this.state = (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).IDLE;
        /**
         * @private
         * @type {LoadFunction}
         */ _this.imageLoadFunction_ = imageLoadFunction;
        return _this;
    }
    /**
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @api
     */ ImageWrapper.prototype.getImage = function() {
        return this.image_;
    };
    /**
     * Tracks loading or read errors.
     *
     * @private
     */ ImageWrapper.prototype.handleImageError_ = function() {
        this.state = (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Tracks successful image load.
     *
     * @private
     */ ImageWrapper.prototype.handleImageLoad_ = function() {
        if (this.resolution === undefined) this.resolution = (0, $2Jl0K.getHeight)(this.extent) / this.image_.height;
        this.state = (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Load the image or retry if loading previously failed.
     * Loading is taken care of by the tile queue, and calling this method is
     * only needed for preloading or for reloading in case of an error.
     * @api
     */ ImageWrapper.prototype.load = function() {
        if (this.state == (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).IDLE || this.state == (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.imageLoadFunction_(this, this.src_);
            this.unlisten_ = $1548b965f58c9226$export$bc96ecc7c2a50764(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    };
    /**
     * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image.
     */ ImageWrapper.prototype.setImage = function(image) {
        this.image_ = image;
        this.resolution = (0, $2Jl0K.getHeight)(this.extent) / this.image_.height;
    };
    /**
     * Discards event handlers which listen for load completion or errors.
     *
     * @private
     */ ImageWrapper.prototype.unlistenImage_ = function() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    };
    return ImageWrapper;
}((0, $f4cef90621c5d8c2$export$2e2bcd8739ae039));
function $1548b965f58c9226$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    var img = /** @type {HTMLImageElement} */ image;
    var listening = true;
    var decoding = false;
    var loaded = false;
    var listenerKeys = [
        (0, $1dBX3.listenOnce)(img, (0, $cFmyb.default).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $bInFo.IMAGE_DECODE)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $1dBX3.listenOnce)(img, (0, $cFmyb.default).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $1dBX3.unlistenByKey));
    };
}
var $1548b965f58c9226$export$2e2bcd8739ae039 = $1548b965f58c9226$var$ImageWrapper;


var $101762da51c85679$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $101762da51c85679$var$ImageTile = /** @class */ function(_super) {
    $101762da51c85679$var$__extends(ImageTile, _super);
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("./TileState.js").default} state State.
     * @param {string} src Image source URI.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
     * @param {import("./Tile.js").Options} [opt_options] Tile options.
     */ function ImageTile(tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options) {
        var _this = _super.call(this, tileCoord, state, opt_options) || this;
        /**
         * @private
         * @type {?string}
         */ _this.crossOrigin_ = crossOrigin;
        /**
         * Image URI
         *
         * @private
         * @type {string}
         */ _this.src_ = src;
        _this.key = src;
        /**
         * @private
         * @type {HTMLImageElement|HTMLCanvasElement}
         */ _this.image_ = new Image();
        if (crossOrigin !== null) _this.image_.crossOrigin = crossOrigin;
        /**
         * @private
         * @type {?function():void}
         */ _this.unlisten_ = null;
        /**
         * @private
         * @type {import("./Tile.js").LoadFunction}
         */ _this.tileLoadFunction_ = tileLoadFunction;
        return _this;
    }
    /**
     * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @api
     */ ImageTile.prototype.getImage = function() {
        return this.image_;
    };
    /**
     * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
     * @param {HTMLCanvasElement|HTMLImageElement} element Element.
     */ ImageTile.prototype.setImage = function(element) {
        this.image_ = element;
        this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Tracks loading or read errors.
     *
     * @private
     */ ImageTile.prototype.handleImageError_ = function() {
        this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $101762da51c85679$var$getBlankImage();
        this.changed();
    };
    /**
     * Tracks successful image load.
     *
     * @private
     */ ImageTile.prototype.handleImageLoad_ = function() {
        var image = /** @type {HTMLImageElement} */ this.image_;
        if (image.naturalWidth && image.naturalHeight) this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED;
        else this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Load not yet loaded URI.
     * @api
     */ ImageTile.prototype.load = function() {
        if (this.state == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        }
        if (this.state == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $1548b965f58c9226$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    };
    /**
     * Discards event handlers which listen for load completion or errors.
     *
     * @private
     */ ImageTile.prototype.unlistenImage_ = function() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    };
    return ImageTile;
}((0, $b13314a55e94df73$export$2e2bcd8739ae039));
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $101762da51c85679$var$getBlankImage() {
    var ctx = (0, $djuby.createCanvasContext2D)(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $101762da51c85679$export$2e2bcd8739ae039 = $101762da51c85679$var$ImageTile;


/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ var $24791bdbb0fcec54$export$3ecb4bcfa5aae855 = 0.5;
var $24791bdbb0fcec54$export$584433cc24140052 = true;



var $cFmyb = parcelRequire("cFmyb");


/**
 * @module ol/reproj/Triangulation
 */ 
var $2Jl0K = parcelRequire("2Jl0K");


var $7aO1A = parcelRequire("7aO1A");
/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ var $f8d7fb3b7b09b61d$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ var $f8d7fb3b7b09b61d$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ var $f8d7fb3b7b09b61d$var$Triangulation = /** @class */ function() {
    /**
     * @param {import("../proj/Projection.js").default} sourceProj Source projection.
     * @param {import("../proj/Projection.js").default} targetProj Target projection.
     * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
     * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
     * @param {number} errorThreshold Acceptable error (in source units).
     * @param {?number} opt_destinationResolution The (optional) resolution of the destination.
     */ function Triangulation(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, opt_destinationResolution) {
        /**
         * @type {import("../proj/Projection.js").default}
         * @private
         */ this.sourceProj_ = sourceProj;
        /**
         * @type {import("../proj/Projection.js").default}
         * @private
         */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ var transformInvCache = {};
        var transformInv = (0, $d3bc250abc15fbce$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
         * @param {import("../coordinate.js").Coordinate} c A coordinate.
         * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
         * @private
         */ this.transformInv_ = function(c) {
            var key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
         * @type {import("../extent.js").Extent}
         * @private
         */ this.maxSourceExtent_ = maxSourceExtent;
        /**
         * @type {number}
         * @private
         */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
         * @type {Array<Triangle>}
         * @private
         */ this.triangles_ = [];
        /**
         * Indicates that the triangulation crosses edge of the source projection.
         * @type {boolean}
         * @private
         */ this.wrapsXInSource_ = false;
        /**
         * @type {boolean}
         * @private
         */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $2Jl0K.getWidth)(maxSourceExtent) == (0, $2Jl0K.getWidth)(this.sourceProj_.getExtent());
        /**
         * @type {?number}
         * @private
         */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $2Jl0K.getWidth)(this.sourceProj_.getExtent()) : null;
        /**
         * @type {?number}
         * @private
         */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $2Jl0K.getWidth)(this.targetProj_.getExtent()) : null;
        var destinationTopLeft = (0, $2Jl0K.getTopLeft)(targetExtent);
        var destinationTopRight = (0, $2Jl0K.getTopRight)(targetExtent);
        var destinationBottomRight = (0, $2Jl0K.getBottomRight)(targetExtent);
        var destinationBottomLeft = (0, $2Jl0K.getBottomLeft)(targetExtent);
        var sourceTopLeft = this.transformInv_(destinationTopLeft);
        var sourceTopRight = this.transformInv_(destinationTopRight);
        var sourceBottomRight = this.transformInv_(destinationBottomRight);
        var sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
         * The maxSubdivision controls how many splittings of the target area can
         * be done. The idea here is to do a linear mapping of the target areas
         * but the actual overal reprojection (can be) extremely non-linear. The
         * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
         * tile size. However this function is also called to remap canvas rendered
         * layers which can be much larger. This calculation increases the maxSubdivision
         * value by the right factor so that each 256x256 pixel area has
         * MAX_SUBDIVISION divisions.
         */ var maxSubdivision = $f8d7fb3b7b09b61d$var$MAX_SUBDIVISION + (opt_destinationResolution ? Math.max(0, Math.ceil((0, $7aO1A.log2)((0, $2Jl0K.getArea)(targetExtent) / (opt_destinationResolution * opt_destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            var leftBound_1 = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound_1 = Math.min(leftBound_1, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((function(triangle) {
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound_1 > this.sourceWorldWidth_ / 2) {
                    var newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound_1 > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound_1 > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound_1 > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    var minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    var maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            }).bind(this));
        }
        transformInvCache = {};
    }
    /**
     * Adds triangle to the triangulation.
     * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
     * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
     * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
     * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
     * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
     * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
     * @private
     */ Triangulation.prototype.addTriangle_ = function(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    };
    /**
     * Adds quad (points in clock-wise order) to the triangulation
     * (and reprojects the vertices) if valid.
     * Performs quad subdivision if needed to increase precision.
     *
     * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
     * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
     * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
     * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
     * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
     * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
     * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
     * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
     * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
     * @private
     */ Triangulation.prototype.addQuad_ = function(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        var sourceQuadExtent = (0, $2Jl0K.boundingExtent)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        var sourceCoverageX = this.sourceWorldWidth_ ? (0, $2Jl0K.getWidth)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        var sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        var wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        var needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                var targetQuadExtent = (0, $2Jl0K.boundingExtent)([
                    a,
                    b,
                    c,
                    d
                ]);
                var targetCoverageX = (0, $2Jl0K.getWidth)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $f8d7fb3b7b09b61d$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $f8d7fb3b7b09b61d$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $2Jl0K.intersects)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        var isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                var center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                var centerSrc = this.transformInv_(center);
                var dx = void 0;
                if (wrapsX) {
                    var centerSrcEstimX = ((0, $7aO1A.modulo)(aSrc[0], sourceWorldWidth) + (0, $7aO1A.modulo)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $7aO1A.modulo)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                var dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                var centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    var bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    var bcSrc = this.transformInv_(bc);
                    var da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    var daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    var ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    var abSrc = this.transformInv_(ab);
                    var cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    var cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    };
    /**
     * Calculates extent of the `source` coordinates from all the triangles.
     *
     * @return {import("../extent.js").Extent} Calculated extent.
     */ Triangulation.prototype.calculateSourceExtent = function() {
        var extent = (0, $2Jl0K.createEmpty)();
        this.triangles_.forEach(function(triangle, i, arr) {
            var src = triangle.source;
            (0, $2Jl0K.extendCoordinate)(extent, src[0]);
            (0, $2Jl0K.extendCoordinate)(extent, src[1]);
            (0, $2Jl0K.extendCoordinate)(extent, src[2]);
        });
        return extent;
    };
    /**
     * @return {Array<Triangle>} Array of the calculated triangles.
     */ Triangulation.prototype.getTriangles = function() {
        return this.triangles_;
    };
    return Triangulation;
}();
var $f8d7fb3b7b09b61d$export$2e2bcd8739ae039 = $f8d7fb3b7b09b61d$var$Triangulation;


/**
 * @module ol/reproj
 */ /**
 * @module ol/renderer/canvas/common
 */ /**
 * Context options to disable image smoothing.
 * @type {Object}
 */ var $9ef11b9472017ba4$export$ab6c91696bd3263e = {
    imageSmoothingEnabled: false,
    msImageSmoothingEnabled: false
};
var $9ef11b9472017ba4$export$75f39f0ce198f93f = {
    imageSmoothingEnabled: true,
    msImageSmoothingEnabled: true
};



var $9zTj4 = parcelRequire("9zTj4");

var $2Jl0K = parcelRequire("2Jl0K");

var $djuby = parcelRequire("djuby");


var $7aO1A = parcelRequire("7aO1A");
var $5593e24cca20c5dc$var$brokenDiagonalRendering_;
var $5593e24cca20c5dc$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $5593e24cca20c5dc$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $5593e24cca20c5dc$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * IE also doesn't. Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $5593e24cca20c5dc$var$isBrokenDiagonalRendering() {
    if ($5593e24cca20c5dc$var$brokenDiagonalRendering_ === undefined) {
        var ctx = document.createElement('canvas').getContext('2d');
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        $5593e24cca20c5dc$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $5593e24cca20c5dc$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        var data = ctx.getImageData(0, 0, 3, 3).data;
        $5593e24cca20c5dc$var$brokenDiagonalRendering_ = $5593e24cca20c5dc$var$verifyBrokenDiagonalRendering(data, 0) || $5593e24cca20c5dc$var$verifyBrokenDiagonalRendering(data, 4) || $5593e24cca20c5dc$var$verifyBrokenDiagonalRendering(data, 8);
    }
    return $5593e24cca20c5dc$var$brokenDiagonalRendering_;
}
function $5593e24cca20c5dc$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    var sourceCenter = (0, $d3bc250abc15fbce$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    var sourceResolution = (0, $d3bc250abc15fbce$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    var targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    var sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    var sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $2Jl0K.containsCoordinate)(sourceExtent, sourceCenter)) {
        var compensationFactor = (0, $d3bc250abc15fbce$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $5593e24cca20c5dc$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    var targetCenter = (0, $2Jl0K.getCenter)(targetExtent);
    var sourceResolution = $5593e24cca20c5dc$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $2Jl0K.forEachCorner)(targetExtent, function(corner) {
        sourceResolution = $5593e24cca20c5dc$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $5593e24cca20c5dc$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, opt_renderEdges, opt_interpolate) {
    var context = (0, $djuby.createCanvasContext2D)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $5593e24cca20c5dc$export$a166f0857c555517);
    if (!opt_interpolate) (0, $9zTj4.assign)(context, (0, $9ef11b9472017ba4$export$ab6c91696bd3263e));
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    var sourceDataExtent = (0, $2Jl0K.createEmpty)();
    sources.forEach(function(src, i, arr) {
        (0, $2Jl0K.extend)(sourceDataExtent, src.extent);
    });
    var canvasWidthInUnits = (0, $2Jl0K.getWidth)(sourceDataExtent);
    var canvasHeightInUnits = (0, $2Jl0K.getHeight)(sourceDataExtent);
    var stitchContext = (0, $djuby.createCanvasContext2D)(Math.round(pixelRatio * canvasWidthInUnits / sourceResolution), Math.round(pixelRatio * canvasHeightInUnits / sourceResolution));
    if (!opt_interpolate) (0, $9zTj4.assign)(stitchContext, (0, $9ef11b9472017ba4$export$ab6c91696bd3263e));
    var stitchScale = pixelRatio / sourceResolution;
    sources.forEach(function(src, i, arr) {
        var xPos = src.extent[0] - sourceDataExtent[0];
        var yPos = -(src.extent[3] - sourceDataExtent[3]);
        var srcWidth = (0, $2Jl0K.getWidth)(src.extent);
        var srcHeight = (0, $2Jl0K.getHeight)(src.extent);
        // This test should never fail -- but it does. Need to find a fix the upstream condition
        if (src.image.width > 0 && src.image.height > 0) stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, xPos * stitchScale, yPos * stitchScale, srcWidth * stitchScale, srcHeight * stitchScale);
    });
    var targetTopLeft = (0, $2Jl0K.getTopLeft)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
         * Resulting matrix can be used to transform coordinate
         * from `sourceProjection` to destination pixels.
         *
         * To optimize number of context calls and increase numerical stability,
         * we also do the following operations:
         * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
         * here before solving the linear system so [ui, vi] are pixel coordinates.
         *
         * Src points: xi, yi
         * Dst points: ui, vi
         * Affine coefficients: aij
         *
         * | x0 y0 1  0  0 0 |   |a00|   |u0|
         * | x1 y1 1  0  0 0 |   |a01|   |u1|
         * | x2 y2 1  0  0 0 | x |a02| = |u2|
         * |  0  0 0 x0 y0 1 |   |a10|   |v0|
         * |  0  0 0 x1 y1 1 |   |a11|   |v1|
         * |  0  0 0 x2 y2 1 |   |a12|   |v2|
         */ var source = triangle.source;
        var target = triangle.target;
        var x0 = source[0][0], y0 = source[0][1];
        var x1 = source[1][0], y1 = source[1][1];
        var x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        var u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        var v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        var u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        var v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        var u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        var v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        var sourceNumericalShiftX = x0;
        var sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        var augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        var affineCoefs = (0, $7aO1A.solveLinearSystem)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($5593e24cca20c5dc$var$isBrokenDiagonalRendering() || !opt_interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            var steps = 4;
            var ud = u0 - u1;
            var vd = v0 - v1;
            for(var step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        context.scale(sourceResolution / pixelRatio, -sourceResolution / pixelRatio);
        context.drawImage(stitchContext.canvas, 0, 0);
        context.restore();
    });
    if (opt_renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            var target = triangle.target;
            var u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            var v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            var u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            var v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            var u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            var v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}



var $7aO1A = parcelRequire("7aO1A");

var $2Jl0K = parcelRequire("2Jl0K");

var $1dBX3 = parcelRequire("1dBX3");

var $djuby = parcelRequire("djuby");
var $c0536ebcb9f53884$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {function(number, number, number, number) : import("../Tile.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ var $c0536ebcb9f53884$var$ReprojTile = /** @class */ function(_super) {
    $c0536ebcb9f53884$var$__extends(ReprojTile, _super);
    /**
     * @param {import("../proj/Projection.js").default} sourceProj Source projection.
     * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
     * @param {import("../proj/Projection.js").default} targetProj Target projection.
     * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
     * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
     * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
     * @param {number} pixelRatio Pixel ratio.
     * @param {number} gutter Gutter of the source tiles.
     * @param {FunctionType} getTileFunction
     *     Function returning source tiles (z, x, y, pixelRatio).
     * @param {number} [opt_errorThreshold] Acceptable reprojection error (in px).
     * @param {boolean} [opt_renderEdges] Render reprojection edges.
     * @param {boolean} [opt_interpolate] Use linear interpolation when resampling.
     */ function ReprojTile(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, opt_errorThreshold, opt_renderEdges, opt_interpolate) {
        var _this = _super.call(this, tileCoord, (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE, {
            interpolate: !!opt_interpolate
        }) || this;
        /**
         * @private
         * @type {boolean}
         */ _this.renderEdges_ = opt_renderEdges !== undefined ? opt_renderEdges : false;
        /**
         * @private
         * @type {number}
         */ _this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {number}
         */ _this.gutter_ = gutter;
        /**
         * @private
         * @type {HTMLCanvasElement}
         */ _this.canvas_ = null;
        /**
         * @private
         * @type {import("../tilegrid/TileGrid.js").default}
         */ _this.sourceTileGrid_ = sourceTileGrid;
        /**
         * @private
         * @type {import("../tilegrid/TileGrid.js").default}
         */ _this.targetTileGrid_ = targetTileGrid;
        /**
         * @private
         * @type {import("../tilecoord.js").TileCoord}
         */ _this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
         * @private
         * @type {!Array<import("../Tile.js").default>}
         */ _this.sourceTiles_ = [];
        /**
         * @private
         * @type {?Array<import("../events.js").EventsKey>}
         */ _this.sourcesListenerKeys_ = null;
        /**
         * @private
         * @type {number}
         */ _this.sourceZ_ = 0;
        var targetExtent = targetTileGrid.getTileCoordExtent(_this.wrappedTileCoord_);
        var maxTargetExtent = _this.targetTileGrid_.getExtent();
        var maxSourceExtent = _this.sourceTileGrid_.getExtent();
        var limitedTargetExtent = maxTargetExtent ? (0, $2Jl0K.getIntersection)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $2Jl0K.getArea)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            _this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY;
            return _this;
        }
        var sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $2Jl0K.getIntersection)(maxSourceExtent, sourceProjExtent);
        }
        var targetResolution = targetTileGrid.getResolution(_this.wrappedTileCoord_[0]);
        var sourceResolution = (0, $5593e24cca20c5dc$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            _this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY;
            return _this;
        }
        var errorThresholdInPixels = opt_errorThreshold !== undefined ? opt_errorThreshold : (0, $24791bdbb0fcec54$export$3ecb4bcfa5aae855);
        /**
         * @private
         * @type {!import("./Triangulation.js").default}
         */ _this.triangulation_ = new (0, $f8d7fb3b7b09b61d$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (_this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            _this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY;
            return _this;
        }
        _this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        var sourceExtent = _this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $7aO1A.clamp)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $7aO1A.clamp)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $2Jl0K.getIntersection)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $2Jl0K.getArea)(sourceExtent)) _this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY;
        else {
            var sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(sourceExtent, _this.sourceZ_);
            for(var srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(var srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                var tile = getTileFunction(_this.sourceZ_, srcX, srcY, pixelRatio);
                if (tile) _this.sourceTiles_.push(tile);
            }
            if (_this.sourceTiles_.length === 0) _this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY;
        }
        return _this;
    }
    /**
     * Get the HTML Canvas element for this tile.
     * @return {HTMLCanvasElement} Canvas.
     */ ReprojTile.prototype.getImage = function() {
        return this.canvas_;
    };
    /**
     * @private
     */ ReprojTile.prototype.reproject_ = function() {
        var sources = [];
        this.sourceTiles_.forEach((function(tile, i, arr) {
            if (tile && tile.getState() == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED) sources.push({
                extent: this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord),
                image: tile.getImage()
            });
        }).bind(this));
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).ERROR;
        else {
            var z = this.wrappedTileCoord_[0];
            var size = this.targetTileGrid_.getTileSize(z);
            var width = typeof size === 'number' ? size : size[0];
            var height = typeof size === 'number' ? size : size[1];
            var targetResolution = this.targetTileGrid_.getResolution(z);
            var sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            var targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $5593e24cca20c5dc$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    };
    /**
     * Load not yet loaded URI.
     */ ReprojTile.prototype.load = function() {
        if (this.state == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADING;
            this.changed();
            var leftToLoad_1 = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach((function(tile, i, arr) {
                var state = tile.getState();
                if (state == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE || state == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad_1++;
                    var sourceListenKey_1 = (0, $1dBX3.listen)(tile, (0, $cFmyb.default).CHANGE, function(e) {
                        var state = tile.getState();
                        if (state == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED || state == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).ERROR || state == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY) {
                            (0, $1dBX3.unlistenByKey)(sourceListenKey_1);
                            leftToLoad_1--;
                            if (leftToLoad_1 === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    }, this);
                    this.sourcesListenerKeys_.push(sourceListenKey_1);
                }
            }).bind(this));
            if (leftToLoad_1 === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function(tile, i, arr) {
                var state = tile.getState();
                if (state == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE) tile.load();
            });
        }
    };
    /**
     * @private
     */ ReprojTile.prototype.unlistenSources_ = function() {
        this.sourcesListenerKeys_.forEach((0, $1dBX3.unlistenByKey));
        this.sourcesListenerKeys_ = null;
    };
    /**
     * Remove from the cache due to expiry
     */ ReprojTile.prototype.release = function() {
        if (this.canvas_) {
            (0, $djuby.releaseCanvas)(this.canvas_.getContext('2d'));
            (0, $5593e24cca20c5dc$export$a166f0857c555517).push(this.canvas_);
            this.canvas_ = null;
        }
        _super.prototype.release.call(this);
    };
    return ReprojTile;
}((0, $b13314a55e94df73$export$2e2bcd8739ae039));
var $c0536ebcb9f53884$export$2e2bcd8739ae039 = $c0536ebcb9f53884$var$ReprojTile;


/**
 * @module ol/structs/LRUCache
 */ 
var $3JLp3 = parcelRequire("3JLp3");
/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Object} newer Newer.
 * @property {Object} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ var $1891ee0f64b84b33$var$LRUCache = /** @class */ function() {
    /**
     * @param {number} [opt_highWaterMark] High water mark.
     */ function LRUCache(opt_highWaterMark) {
        /**
         * Desired max cache size after expireCache(). If set to 0, no cache entries
         * will be pruned at all.
         * @type {number}
         */ this.highWaterMark = opt_highWaterMark !== undefined ? opt_highWaterMark : 2048;
        /**
         * @private
         * @type {number}
         */ this.count_ = 0;
        /**
         * @private
         * @type {!Object<string, Entry>}
         */ this.entries_ = {};
        /**
         * @private
         * @type {?Entry}
         */ this.oldest_ = null;
        /**
         * @private
         * @type {?Entry}
         */ this.newest_ = null;
    }
    /**
     * @return {boolean} Can expire cache.
     */ LRUCache.prototype.canExpireCache = function() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    };
    /**
     * Expire the cache.
     * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
     */ LRUCache.prototype.expireCache = function(keep) {
        while(this.canExpireCache())this.pop();
    };
    /**
     * FIXME empty description for jsdoc
     */ LRUCache.prototype.clear = function() {
        this.count_ = 0;
        this.entries_ = {};
        this.oldest_ = null;
        this.newest_ = null;
    };
    /**
     * @param {string} key Key.
     * @return {boolean} Contains key.
     */ LRUCache.prototype.containsKey = function(key) {
        return this.entries_.hasOwnProperty(key);
    };
    /**
     * @param {function(T, string, LRUCache<T>): ?} f The function
     *     to call for every entry from the oldest to the newer. This function takes
     *     3 arguments (the entry value, the entry key and the LRUCache object).
     *     The return value is ignored.
     */ LRUCache.prototype.forEach = function(f) {
        var entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    };
    /**
     * @param {string} key Key.
     * @param {*} [opt_options] Options (reserved for subclasses).
     * @return {T} Value.
     */ LRUCache.prototype.get = function(key, opt_options) {
        var entry = this.entries_[key];
        (0, $3JLp3.assert)(entry !== undefined, 15); // Tried to get a value for a key that does not exist in the cache
        if (entry === this.newest_) return entry.value_;
        else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    };
    /**
     * Remove an entry from the cache.
     * @param {string} key The entry key.
     * @return {T} The removed entry.
     */ LRUCache.prototype.remove = function(key) {
        var entry = this.entries_[key];
        (0, $3JLp3.assert)(entry !== undefined, 15); // Tried to get a value for a key that does not exist in the cache
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    };
    /**
     * @return {number} Count.
     */ LRUCache.prototype.getCount = function() {
        return this.count_;
    };
    /**
     * @return {Array<string>} Keys.
     */ LRUCache.prototype.getKeys = function() {
        var keys = new Array(this.count_);
        var i = 0;
        var entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    };
    /**
     * @return {Array<T>} Values.
     */ LRUCache.prototype.getValues = function() {
        var values = new Array(this.count_);
        var i = 0;
        var entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    };
    /**
     * @return {T} Last value.
     */ LRUCache.prototype.peekLast = function() {
        return this.oldest_.value_;
    };
    /**
     * @return {string} Last key.
     */ LRUCache.prototype.peekLastKey = function() {
        return this.oldest_.key_;
    };
    /**
     * Get the key of the newest item in the cache.  Throws if the cache is empty.
     * @return {string} The newest key.
     */ LRUCache.prototype.peekFirstKey = function() {
        return this.newest_.key_;
    };
    /**
     * Return an entry without updating least recently used time.
     * @param {string} key Key.
     * @return {T} Value.
     */ LRUCache.prototype.peek = function(key) {
        if (!this.containsKey(key)) return undefined;
        return this.entries_[key].value_;
    };
    /**
     * @return {T} value Value.
     */ LRUCache.prototype.pop = function() {
        var entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    };
    /**
     * @param {string} key Key.
     * @param {T} value Value.
     */ LRUCache.prototype.replace = function(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    };
    /**
     * @param {string} key Key.
     * @param {T} value Value.
     */ LRUCache.prototype.set = function(key, value) {
        (0, $3JLp3.assert)(!(key in this.entries_), 16); // Tried to set a value for a key that is used already
        var entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    };
    /**
     * Set a maximum number of entries for the cache.
     * @param {number} size Cache size.
     * @api
     */ LRUCache.prototype.setSize = function(size) {
        this.highWaterMark = size;
    };
    return LRUCache;
}();
var $1891ee0f64b84b33$export$2e2bcd8739ae039 = $1891ee0f64b84b33$var$LRUCache;


/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [opt_tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ function $dbbff40153ca9e51$export$958e3e1a02eac4b6(z, x, y, opt_tileCoord) {
    if (opt_tileCoord !== undefined) {
        opt_tileCoord[0] = z;
        opt_tileCoord[1] = x;
        opt_tileCoord[2] = y;
        return opt_tileCoord;
    } else return [
        z,
        x,
        y
    ];
}
function $dbbff40153ca9e51$export$92d0df0f1d25c63c(z, x, y) {
    return z + '/' + x + '/' + y;
}
function $dbbff40153ca9e51$export$a47fb462a08de82f(tileCoord) {
    return $dbbff40153ca9e51$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $dbbff40153ca9e51$export$7f760414a8e3d2b5(tileKey) {
    var _a = tileKey.substring(tileKey.lastIndexOf('/') + 1, tileKey.length).split(',').map(Number), z = _a[0], x = _a[1], y = _a[2];
    return $dbbff40153ca9e51$export$92d0df0f1d25c63c(z, x, y);
}
function $dbbff40153ca9e51$export$a807b7874eb66454(key) {
    return key.split('/').map(Number);
}
function $dbbff40153ca9e51$export$d6af199866bfb566(tileCoord) {
    return (tileCoord[1] << tileCoord[0]) + tileCoord[2];
}
function $dbbff40153ca9e51$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    var z = tileCoord[0];
    var x = tileCoord[1];
    var y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    var tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    else return tileRange.containsXY(x, y);
}


var $55b0a576a8ff2994$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $55b0a576a8ff2994$var$TileCache = /** @class */ function(_super) {
    $55b0a576a8ff2994$var$__extends(TileCache, _super);
    function TileCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */ TileCache.prototype.expireCache = function(usedTiles) {
        while(this.canExpireCache()){
            var tile = this.peekLast();
            if (tile.getKey() in usedTiles) break;
            else this.pop().release();
        }
    };
    /**
     * Prune all tiles from the cache that don't have the same z as the newest tile.
     */ TileCache.prototype.pruneExceptNewestZ = function() {
        if (this.getCount() === 0) return;
        var key = this.peekFirstKey();
        var tileCoord = (0, $dbbff40153ca9e51$export$a807b7874eb66454)(key);
        var z = tileCoord[0];
        this.forEach((function(tile) {
            if (tile.tileCoord[0] !== z) {
                this.remove((0, $dbbff40153ca9e51$export$a47fb462a08de82f)(tile.tileCoord));
                tile.release();
            }
        }).bind(this));
    };
    return TileCache;
}((0, $1891ee0f64b84b33$export$2e2bcd8739ae039));
var $55b0a576a8ff2994$export$2e2bcd8739ae039 = $55b0a576a8ff2994$var$TileCache;



/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $c10060fbd57e75dc$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
     * Triggered when a tile starts loading.
     * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
     * @api
     */ TILELOADSTART: 'tileloadstart',
    /**
     * Triggered when a tile finishes loading, either when its data is loaded,
     * or when loading was aborted because the tile is no longer needed.
     * @event module:ol/source/Tile.TileSourceEvent#tileloadend
     * @api
     */ TILELOADEND: 'tileloadend',
    /**
     * Triggered if tile loading results in an error.
     * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
     * @api
     */ TILELOADERROR: 'tileloaderror'
};



var $bNM9R = parcelRequire("bNM9R");

var $aK3Yt = parcelRequire("aK3Yt");

var $61DUI = parcelRequire("61DUI");

var $1bd7756853fd0f39$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link module:ol/PluggableMap~FrameState} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../PluggableMap.js").FrameState): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * * a simple string (e.g. `'© Acme Inc.'`)
 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ var $1bd7756853fd0f39$var$Source = /** @class */ function(_super) {
    $1bd7756853fd0f39$var$__extends(Source, _super);
    /**
     * @param {Options} options Source options.
     */ function Source(options) {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {import("../proj/Projection.js").default|null}
         */ _this.projection = (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(options.projection);
        /**
         * @private
         * @type {?Attribution}
         */ _this.attributions_ = $1bd7756853fd0f39$var$adaptAttributions(options.attributions);
        /**
         * @private
         * @type {boolean}
         */ _this.attributionsCollapsible_ = options.attributionsCollapsible !== undefined ? options.attributionsCollapsible : true;
        /**
         * This source is currently loading data. Sources that defer loading to the
         * map's tile queue never set this to `true`.
         * @type {boolean}
         */ _this.loading = false;
        /**
         * @private
         * @type {import("./Source.js").State}
         */ _this.state_ = options.state !== undefined ? options.state : 'ready';
        /**
         * @private
         * @type {boolean}
         */ _this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
         * @private
         * @type {boolean}
         */ _this.interpolate_ = !!options.interpolate;
        /**
         * @protected
         * @type {function(import("../View.js").ViewOptions):void}
         */ _this.viewResolver = null;
        /**
         * @protected
         * @type {function(Error):void}
         */ _this.viewRejector = null;
        var self = _this;
        /**
         * @private
         * @type {Promise<import("../View.js").ViewOptions>}
         */ _this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
        return _this;
    }
    /**
     * Get the attribution function for the source.
     * @return {?Attribution} Attribution function.
     * @api
     */ Source.prototype.getAttributions = function() {
        return this.attributions_;
    };
    /**
     * @return {boolean} Attributions are collapsible.
     * @api
     */ Source.prototype.getAttributionsCollapsible = function() {
        return this.attributionsCollapsible_;
    };
    /**
     * Get the projection of the source.
     * @return {import("../proj/Projection.js").default|null} Projection.
     * @api
     */ Source.prototype.getProjection = function() {
        return this.projection;
    };
    /**
     * @abstract
     * @return {Array<number>|null} Resolutions.
     */ Source.prototype.getResolutions = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
     */ Source.prototype.getView = function() {
        return this.viewPromise_;
    };
    /**
     * Get the state of the source, see {@link import("./Source.js").State} for possible states.
     * @return {import("./Source.js").State} State.
     * @api
     */ Source.prototype.getState = function() {
        return this.state_;
    };
    /**
     * @return {boolean|undefined} Wrap X.
     */ Source.prototype.getWrapX = function() {
        return this.wrapX_;
    };
    /**
     * @return {boolean} Use linear interpolation when resampling.
     */ Source.prototype.getInterpolate = function() {
        return this.interpolate_;
    };
    /**
     * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
     * @api
     */ Source.prototype.refresh = function() {
        this.changed();
    };
    /**
     * Set the attributions of the source.
     * @param {AttributionLike|undefined} attributions Attributions.
     *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
     *     or `undefined`.
     * @api
     */ Source.prototype.setAttributions = function(attributions) {
        this.attributions_ = $1bd7756853fd0f39$var$adaptAttributions(attributions);
        this.changed();
    };
    /**
     * Set the state of the source.
     * @param {import("./Source.js").State} state State.
     */ Source.prototype.setState = function(state) {
        this.state_ = state;
        this.changed();
    };
    return Source;
}((0, $aK3Yt.default));
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $1bd7756853fd0f39$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (Array.isArray(attributionLike)) return function(frameState) {
        return attributionLike;
    };
    if (typeof attributionLike === 'function') return attributionLike;
    return function(frameState) {
        return [
            attributionLike
        ];
    };
}
var $1bd7756853fd0f39$export$2e2bcd8739ae039 = $1bd7756853fd0f39$var$Source;





var $61DUI = parcelRequire("61DUI");

var $3JLp3 = parcelRequire("3JLp3");


/**
 * @module ol/tilegrid
 */ /**
 * @module ol/tilegrid/TileGrid
 */ /**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ var $58f9ac1efbf3c5ef$var$TileRange = /** @class */ function() {
    /**
     * @param {number} minX Minimum X.
     * @param {number} maxX Maximum X.
     * @param {number} minY Minimum Y.
     * @param {number} maxY Maximum Y.
     */ function TileRange(minX, maxX, minY, maxY) {
        /**
         * @type {number}
         */ this.minX = minX;
        /**
         * @type {number}
         */ this.maxX = maxX;
        /**
         * @type {number}
         */ this.minY = minY;
        /**
         * @type {number}
         */ this.maxY = maxY;
    }
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @return {boolean} Contains tile coordinate.
     */ TileRange.prototype.contains = function(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    };
    /**
     * @param {TileRange} tileRange Tile range.
     * @return {boolean} Contains.
     */ TileRange.prototype.containsTileRange = function(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    };
    /**
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @return {boolean} Contains coordinate.
     */ TileRange.prototype.containsXY = function(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    };
    /**
     * @param {TileRange} tileRange Tile range.
     * @return {boolean} Equals.
     */ TileRange.prototype.equals = function(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    };
    /**
     * @param {TileRange} tileRange Tile range.
     */ TileRange.prototype.extend = function(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    };
    /**
     * @return {number} Height.
     */ TileRange.prototype.getHeight = function() {
        return this.maxY - this.minY + 1;
    };
    /**
     * @return {import("./size.js").Size} Size.
     */ TileRange.prototype.getSize = function() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    };
    /**
     * @return {number} Width.
     */ TileRange.prototype.getWidth = function() {
        return this.maxX - this.minX + 1;
    };
    /**
     * @param {TileRange} tileRange Tile range.
     * @return {boolean} Intersects.
     */ TileRange.prototype.intersects = function(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    };
    return TileRange;
}();
function $58f9ac1efbf3c5ef$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    } else return new $58f9ac1efbf3c5ef$var$TileRange(minX, maxX, minY, maxY);
}
var $58f9ac1efbf3c5ef$export$2e2bcd8739ae039 = $58f9ac1efbf3c5ef$var$TileRange;




var $3JLp3 = parcelRequire("3JLp3");

var $7aO1A = parcelRequire("7aO1A");

var $2Jl0K = parcelRequire("2Jl0K");



var $kzmGH = parcelRequire("kzmGH");

/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ var $a77ce920ea550f23$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ var $a77ce920ea550f23$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ var $a77ce920ea550f23$var$TileGrid = /** @class */ function() {
    /**
     * @param {Options} options Tile grid options.
     */ function TileGrid(options) {
        /**
         * @protected
         * @type {number}
         */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
         * @private
         * @type {!Array<number>}
         */ this.resolutions_ = options.resolutions;
        (0, $3JLp3.assert)((0, $kzmGH.isSorted)(this.resolutions_, function(a, b) {
            return b - a;
        }, true), 17); // `resolutions` must be sorted in descending order
        // check if we've got a consistent zoom factor and origin
        var zoomFactor;
        if (!options.origins) for(var i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
         * @private
         * @type {number|undefined}
         */ this.zoomFactor_ = zoomFactor;
        /**
         * @protected
         * @type {number}
         */ this.maxZoom = this.resolutions_.length - 1;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate|null}
         */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
         * @private
         * @type {Array<import("../coordinate.js").Coordinate>}
         */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $3JLp3.assert)(this.origins_.length == this.resolutions_.length, 20); // Number of `origins` and `resolutions` must be equal
        }
        var extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $2Jl0K.getTopLeft)(extent);
        (0, $3JLp3.assert)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 18); // Either `origin` or `origins` must be configured, never both
        /**
         * @private
         * @type {Array<number|import("../size.js").Size>}
         */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $3JLp3.assert)(this.tileSizes_.length == this.resolutions_.length, 19); // Number of `tileSizes` and `resolutions` must be equal
        }
        /**
         * @private
         * @type {number|import("../size.js").Size}
         */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $abdd446e0816dd65$export$6b8cb5cd370bd90c) : null;
        (0, $3JLp3.assert)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 22); // Either `tileSize` or `tileSizes` must be configured, never both
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */ this.extent_ = extent !== undefined ? extent : null;
        /**
         * @private
         * @type {Array<import("../TileRange.js").default>}
         */ this.fullTileRanges_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ this.tmpSize_ = [
            0,
            0
        ];
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map(function(size, z) {
            var tileRange = new (0, $58f9ac1efbf3c5ef$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                var restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        }, this);
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
     * Call a function with each tile coordinate for a given extent and zoom level.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} zoom Integer zoom level.
     * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
     * @api
     */ TileGrid.prototype.forEachTileCoord = function(extent, zoom, callback) {
        var tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(var i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(var j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
     * @param {import("../TileRange.js").default} [opt_tileRange] Temporary import("../TileRange.js").default object.
     * @param {import("../extent.js").Extent} [opt_extent] Temporary import("../extent.js").Extent object.
     * @return {boolean} Callback succeeded.
     */ TileGrid.prototype.forEachTileCoordParentTileRange = function(tileCoord, callback, opt_tileRange, opt_extent) {
        var tileRange, x, y;
        var tileCoordExtent = null;
        var z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent);
        while(z >= this.minZoom){
            if (this.zoomFactor_ === 2) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $58f9ac1efbf3c5ef$export$958e3e1a02eac4b6)(x, x, y, y, opt_tileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, opt_tileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    };
    /**
     * Get the extent for this tile grid, if it was configured.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ TileGrid.prototype.getExtent = function() {
        return this.extent_;
    };
    /**
     * Get the maximum zoom level for the grid.
     * @return {number} Max zoom.
     * @api
     */ TileGrid.prototype.getMaxZoom = function() {
        return this.maxZoom;
    };
    /**
     * Get the minimum zoom level for the grid.
     * @return {number} Min zoom.
     * @api
     */ TileGrid.prototype.getMinZoom = function() {
        return this.minZoom;
    };
    /**
     * Get the origin for the grid at the given zoom level.
     * @param {number} z Integer zoom level.
     * @return {import("../coordinate.js").Coordinate} Origin.
     * @api
     */ TileGrid.prototype.getOrigin = function(z) {
        if (this.origin_) return this.origin_;
        else return this.origins_[z];
    };
    /**
     * Get the resolution for the given zoom level.
     * @param {number} z Integer zoom level.
     * @return {number} Resolution.
     * @api
     */ TileGrid.prototype.getResolution = function(z) {
        return this.resolutions_[z];
    };
    /**
     * Get the list of resolutions for the tile grid.
     * @return {Array<number>} Resolutions.
     * @api
     */ TileGrid.prototype.getResolutions = function() {
        return this.resolutions_;
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../TileRange.js").default} [opt_tileRange] Temporary import("../TileRange.js").default object.
     * @param {import("../extent.js").Extent} [opt_extent] Temporary import("../extent.js").Extent object.
     * @return {import("../TileRange.js").default|null} Tile range.
     */ TileGrid.prototype.getTileCoordChildTileRange = function(tileCoord, opt_tileRange, opt_extent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                var minX = tileCoord[1] * 2;
                var minY = tileCoord[2] * 2;
                return (0, $58f9ac1efbf3c5ef$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, opt_tileRange);
            }
            var tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, opt_tileRange);
        }
        return null;
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {number} z Integer zoom level.
     * @param {import("../TileRange.js").default} [opt_tileRange] Temporary import("../TileRange.js").default object.
     * @return {import("../TileRange.js").default|null} Tile range.
     */ TileGrid.prototype.getTileRangeForTileCoordAndZ = function(tileCoord, z, opt_tileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        var tileCoordZ = tileCoord[0];
        var tileCoordX = tileCoord[1];
        var tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $58f9ac1efbf3c5ef$export$958e3e1a02eac4b6)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, opt_tileRange);
        if (this.zoomFactor_) {
            var factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            var minX = Math.floor(tileCoordX * factor);
            var minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $58f9ac1efbf3c5ef$export$958e3e1a02eac4b6)(minX, minX, minY, minY, opt_tileRange);
            var maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            var maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $58f9ac1efbf3c5ef$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, opt_tileRange);
        }
        var tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, opt_tileRange);
    };
    /**
     * Get the extent for a tile range.
     * @param {number} z Integer zoom level.
     * @param {import("../TileRange.js").default} tileRange Tile range.
     * @param {import("../extent.js").Extent} [opt_extent] Temporary import("../extent.js").Extent object.
     * @return {import("../extent.js").Extent} Extent.
     */ TileGrid.prototype.getTileRangeExtent = function(z, tileRange, opt_extent) {
        var origin = this.getOrigin(z);
        var resolution = this.getResolution(z);
        var tileSize = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        var minX = origin[0] + tileRange.minX * tileSize[0] * resolution;
        var maxX = origin[0] + (tileRange.maxX + 1) * tileSize[0] * resolution;
        var minY = origin[1] + tileRange.minY * tileSize[1] * resolution;
        var maxY = origin[1] + (tileRange.maxY + 1) * tileSize[1] * resolution;
        return (0, $2Jl0K.createOrUpdate)(minX, minY, maxX, maxY, opt_extent);
    };
    /**
     * Get a tile range for the given extent and integer zoom level.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} z Integer zoom level.
     * @param {import("../TileRange.js").default} [opt_tileRange] Temporary tile range object.
     * @return {import("../TileRange.js").default} Tile range.
     */ TileGrid.prototype.getTileRangeForExtentAndZ = function(extent, z, opt_tileRange) {
        var tileCoord = $a77ce920ea550f23$var$tmpTileCoord;
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, tileCoord);
        var minX = tileCoord[1];
        var minY = tileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, tileCoord);
        return (0, $58f9ac1efbf3c5ef$export$958e3e1a02eac4b6)(minX, tileCoord[1], minY, tileCoord[2], opt_tileRange);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @return {import("../coordinate.js").Coordinate} Tile center.
     */ TileGrid.prototype.getTileCoordCenter = function(tileCoord) {
        var origin = this.getOrigin(tileCoord[0]);
        var resolution = this.getResolution(tileCoord[0]);
        var tileSize = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    };
    /**
     * Get the extent of a tile coordinate.
     *
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../extent.js").Extent} [opt_extent] Temporary extent object.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ TileGrid.prototype.getTileCoordExtent = function(tileCoord, opt_extent) {
        var origin = this.getOrigin(tileCoord[0]);
        var resolution = this.getResolution(tileCoord[0]);
        var tileSize = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        var minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        var minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        var maxX = minX + tileSize[0] * resolution;
        var maxY = minY + tileSize[1] * resolution;
        return (0, $2Jl0K.createOrUpdate)(minX, minY, maxX, maxY, opt_extent);
    };
    /**
     * Get the tile coordinate for the given map coordinate and resolution.  This
     * method considers that coordinates that intersect tile boundaries should be
     * assigned the higher tile coordinate.
     *
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} resolution Resolution.
     * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @api
     */ TileGrid.prototype.getTileCoordForCoordAndResolution = function(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    };
    /**
     * Note that this method should not be called for resolutions that correspond
     * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
     * @param {number} x X.
     * @param {number} y Y.
     * @param {number} resolution Resolution (for a non-integer zoom level).
     * @param {boolean} reverseIntersectionPolicy Instead of letting edge
     *     intersections go to the higher tile coordinate, let edge intersections
     *     go to the lower tile coordinate.
     * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @private
     */ TileGrid.prototype.getTileCoordForXYAndResolution_ = function(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        var z = this.getZForResolution(resolution);
        var scale = resolution / this.getResolution(z);
        var origin = this.getOrigin(z);
        var tileSize = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        var tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        var tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $7aO1A.ceil)(tileCoordX, $a77ce920ea550f23$var$DECIMALS) - 1;
            tileCoordY = (0, $7aO1A.ceil)(tileCoordY, $a77ce920ea550f23$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $7aO1A.floor)(tileCoordX, $a77ce920ea550f23$var$DECIMALS);
            tileCoordY = (0, $7aO1A.floor)(tileCoordY, $a77ce920ea550f23$var$DECIMALS);
        }
        return (0, $dbbff40153ca9e51$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    };
    /**
     * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
     * they should have separate implementations.  This method is for integer zoom
     * levels.  The other method should only be called for resolutions corresponding
     * to non-integer zoom levels.
     * @param {number} x Map x coordinate.
     * @param {number} y Map y coordinate.
     * @param {number} z Integer zoom level.
     * @param {boolean} reverseIntersectionPolicy Instead of letting edge
     *     intersections go to the higher tile coordinate, let edge intersections
     *     go to the lower tile coordinate.
     * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @private
     */ TileGrid.prototype.getTileCoordForXYAndZ_ = function(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        var origin = this.getOrigin(z);
        var resolution = this.getResolution(z);
        var tileSize = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        var tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        var tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $7aO1A.ceil)(tileCoordX, $a77ce920ea550f23$var$DECIMALS) - 1;
            tileCoordY = (0, $7aO1A.ceil)(tileCoordY, $a77ce920ea550f23$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $7aO1A.floor)(tileCoordX, $a77ce920ea550f23$var$DECIMALS);
            tileCoordY = (0, $7aO1A.floor)(tileCoordY, $a77ce920ea550f23$var$DECIMALS);
        }
        return (0, $dbbff40153ca9e51$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    };
    /**
     * Get a tile coordinate given a map coordinate and zoom level.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} z Zoom level.
     * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @api
     */ TileGrid.prototype.getTileCoordForCoordAndZ = function(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @return {number} Tile resolution.
     */ TileGrid.prototype.getTileCoordResolution = function(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    };
    /**
     * Get the tile size for a zoom level. The type of the return value matches the
     * `tileSize` or `tileSizes` that the tile grid was configured with. To always
     * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
     * @param {number} z Z.
     * @return {number|import("../size.js").Size} Tile size.
     * @api
     */ TileGrid.prototype.getTileSize = function(z) {
        if (this.tileSize_) return this.tileSize_;
        else return this.tileSizes_[z];
    };
    /**
     * @param {number} z Zoom level.
     * @return {import("../TileRange.js").default} Extent tile range for the specified zoom level.
     */ TileGrid.prototype.getFullTileRange = function(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        else return this.fullTileRanges_[z];
    };
    /**
     * @param {number} resolution Resolution.
     * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
     *     If 0, the nearest resolution will be used.
     *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
     *     nearest lower resolution (higher Z) will be used. Default is 0.
     *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
     *
     * For example to change tile Z at the midpoint of zoom levels
     * ```js
     * function(value, high, low) {
     *   return value - low * Math.sqrt(high / low);
     * }
     * ```
     * @return {number} Z.
     * @api
     */ TileGrid.prototype.getZForResolution = function(resolution, opt_direction) {
        var z = (0, $kzmGH.linearFindNearest)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $7aO1A.clamp)(z, this.minZoom, this.maxZoom);
    };
    /**
     * The tile with the provided tile coordinate intersects the given viewport.
     * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
     * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
     * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
     */ TileGrid.prototype.tileCoordIntersectsViewport = function(tileCoord, viewport) {
        return (0, $9fc1bfe0d9ae3906$export$830a0dafbb2ef1c5)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    };
    /**
     * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
     * @private
     */ TileGrid.prototype.calculateTileRanges_ = function(extent) {
        var length = this.resolutions_.length;
        var fullTileRanges = new Array(length);
        for(var z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    };
    return TileGrid;
}();
var $a77ce920ea550f23$export$2e2bcd8739ae039 = $a77ce920ea550f23$var$TileGrid;






var $2Jl0K = parcelRequire("2Jl0K");

function $e7ff674aba025e93$export$1f4812384df8a9c5(projection) {
    var tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $e7ff674aba025e93$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $e7ff674aba025e93$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    var z = tileCoord[0];
    var center = tileGrid.getTileCoordCenter(tileCoord);
    var projectionExtent = $e7ff674aba025e93$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $2Jl0K.containsCoordinate)(projectionExtent, center)) {
        var worldWidth = (0, $2Jl0K.getWidth)(projectionExtent);
        var worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    } else return tileCoord;
}
function $e7ff674aba025e93$export$ce88871416242df8(extent, opt_maxZoom, opt_tileSize, opt_corner) {
    var corner = opt_corner !== undefined ? opt_corner : 'top-left';
    var resolutions = $e7ff674aba025e93$var$resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize);
    return new (0, $a77ce920ea550f23$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $2Jl0K.getCorner)(extent, corner),
        resolutions: resolutions,
        tileSize: opt_tileSize
    });
}
function $e7ff674aba025e93$export$38500bbeccc864ff(opt_options) {
    var xyzOptions = opt_options || {};
    var extent = xyzOptions.extent || (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)('EPSG:3857').getExtent();
    var gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $e7ff674aba025e93$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $a77ce920ea550f23$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [opt_maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [opt_tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [opt_maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $e7ff674aba025e93$var$resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize, opt_maxResolution) {
    var maxZoom = opt_maxZoom !== undefined ? opt_maxZoom : (0, $abdd446e0816dd65$export$e98a216cdcc847dc);
    var height = (0, $2Jl0K.getHeight)(extent);
    var width = (0, $2Jl0K.getWidth)(extent);
    var tileSize = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(opt_tileSize !== undefined ? opt_tileSize : (0, $abdd446e0816dd65$export$6b8cb5cd370bd90c));
    var maxResolution = opt_maxResolution > 0 ? opt_maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    var length = maxZoom + 1;
    var resolutions = new Array(length);
    for(var z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $e7ff674aba025e93$export$a251b12f5601c16f(projection, opt_maxZoom, opt_tileSize, opt_corner) {
    var extent = $e7ff674aba025e93$export$7b5b6ef8fd55fac4(projection);
    return $e7ff674aba025e93$export$ce88871416242df8(extent, opt_maxZoom, opt_tileSize, opt_corner);
}
function $e7ff674aba025e93$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(projection);
    var extent = projection.getExtent();
    if (!extent) {
        var half = 180 * (0, $bcf733fece57bacd$export$1482081eec883108)[(0, $bcf733fece57bacd$export$2e2bcd8739ae039).DEGREES] / projection.getMetersPerUnit();
        extent = (0, $2Jl0K.createOrUpdate)(-half, -half, half, half);
    }
    return extent;
}



var $9347b5d9b9fe0c79$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] CacheSize.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 * @abstract
 * @api
 */ var $9347b5d9b9fe0c79$var$TileSource = /** @class */ function(_super) {
    $9347b5d9b9fe0c79$var$__extends(TileSource, _super);
    /**
     * @param {Options} options SourceTile source options.
     */ function TileSource(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        }) || this;
        /***
         * @type {TileSourceOnSignature<import("../events").EventsKey>}
         */ _this.on;
        /***
         * @type {TileSourceOnSignature<import("../events").EventsKey>}
         */ _this.once;
        /***
         * @type {TileSourceOnSignature<void>}
         */ _this.un;
        /**
         * @private
         * @type {boolean}
         */ _this.opaque_ = options.opaque !== undefined ? options.opaque : false;
        /**
         * @private
         * @type {number}
         */ _this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
         * @type {import("../tilegrid/TileGrid.js").default|null}
         */ _this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        var tileSize = [
            256,
            256
        ];
        if (_this.tileGrid) (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(_this.tileGrid.getTileSize(_this.tileGrid.getMinZoom()), tileSize);
        /**
         * @protected
         * @type {import("../TileCache.js").default}
         */ _this.tileCache = new (0, $55b0a576a8ff2994$export$2e2bcd8739ae039)(options.cacheSize || 0);
        /**
         * @protected
         * @type {import("../size.js").Size}
         */ _this.tmpSize = [
            0,
            0
        ];
        /**
         * @private
         * @type {string}
         */ _this.key_ = options.key || '';
        /**
         * @protected
         * @type {import("../Tile.js").Options}
         */ _this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
         * zDirection hint, read by the renderer. Indicates which resolution should be used
         * by a renderer if the views resolution does not match any resolution of the tile source.
         * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
         * will be used. If -1, the nearest higher resolution will be used.
         * @type {number|import("../array.js").NearestDirectionFunction}
         */ _this.zDirection = options.zDirection ? options.zDirection : 0;
        return _this;
    }
    /**
     * @return {boolean} Can expire cache.
     */ TileSource.prototype.canExpireCache = function() {
        return this.tileCache.canExpireCache();
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */ TileSource.prototype.expireCache = function(projection, usedTiles) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (tileCache) tileCache.expireCache(usedTiles);
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {number} z Zoom level.
     * @param {import("../TileRange.js").default} tileRange Tile range.
     * @param {function(import("../Tile.js").default):(boolean|void)} callback Called with each
     *     loaded tile.  If the callback returns `false`, the tile will not be
     *     considered loaded.
     * @return {boolean} The tile range is fully covered with loaded tiles.
     */ TileSource.prototype.forEachLoadedTile = function(projection, z, tileRange, callback) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (!tileCache) return false;
        var covered = true;
        var tile, tileCoordKey, loaded;
        for(var x = tileRange.minX; x <= tileRange.maxX; ++x)for(var y = tileRange.minY; y <= tileRange.maxY; ++y){
            tileCoordKey = (0, $dbbff40153ca9e51$export$92d0df0f1d25c63c)(z, x, y);
            loaded = false;
            if (tileCache.containsKey(tileCoordKey)) {
                tile = /** @type {!import("../Tile.js").default} */ tileCache.get(tileCoordKey);
                loaded = tile.getState() === (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED;
                if (loaded) loaded = callback(tile) !== false;
            }
            if (!loaded) covered = false;
        }
        return covered;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {number} Gutter.
     */ TileSource.prototype.getGutterForProjection = function(projection) {
        return 0;
    };
    /**
     * Return the key to be used for all tiles in the source.
     * @return {string} The key for all tiles.
     */ TileSource.prototype.getKey = function() {
        return this.key_;
    };
    /**
     * Set the value to be used as the key for all tiles in the source.
     * @param {string} key The key for tiles.
     * @protected
     */ TileSource.prototype.setKey = function(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {boolean} Opaque.
     */ TileSource.prototype.getOpaque = function(projection) {
        return this.opaque_;
    };
    /**
     * @return {Array<number>|null} Resolutions.
     */ TileSource.prototype.getResolutions = function() {
        if (!this.tileGrid) return null;
        return this.tileGrid.getResolutions();
    };
    /**
     * @abstract
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../Tile.js").default} Tile.
     */ TileSource.prototype.getTile = function(z, x, y, pixelRatio, projection) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Return the tile grid of the tile source.
     * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
     * @api
     */ TileSource.prototype.getTileGrid = function() {
        return this.tileGrid;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
     */ TileSource.prototype.getTileGridForProjection = function(projection) {
        if (!this.tileGrid) return (0, $e7ff674aba025e93$export$1f4812384df8a9c5)(projection);
        else return this.tileGrid;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../TileCache.js").default} Tile cache.
     * @protected
     */ TileSource.prototype.getTileCacheForProjection = function(projection) {
        var sourceProjection = this.getProjection();
        (0, $3JLp3.assert)(sourceProjection === null || (0, $d3bc250abc15fbce$export$fe091d73a555748b)(sourceProjection, projection), 68 // A VectorTile source can only be rendered if it has a projection compatible with the view projection.
        );
        return this.tileCache;
    };
    /**
     * Get the tile pixel ratio for this source. Subclasses may override this
     * method, which is meant to return a supported pixel ratio that matches the
     * provided `pixelRatio` as close as possible.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Tile pixel ratio.
     */ TileSource.prototype.getTilePixelRatio = function(pixelRatio) {
        return this.tilePixelRatio_;
    };
    /**
     * @param {number} z Z.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../size.js").Size} Tile size.
     */ TileSource.prototype.getTilePixelSize = function(z, pixelRatio, projection) {
        var tileGrid = this.getTileGridForProjection(projection);
        var tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        var tileSize = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        else return (0, $defec9fd2d3eaefa$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    };
    /**
     * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
     * is outside the resolution and extent range of the tile grid, `null` will be
     * returned.
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../proj/Projection.js").default} [opt_projection] Projection.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
     *     null if no tile URL should be created for the passed `tileCoord`.
     */ TileSource.prototype.getTileCoordForTileUrlFunction = function(tileCoord, opt_projection) {
        var projection = opt_projection !== undefined ? opt_projection : this.getProjection();
        var tileGrid = this.getTileGridForProjection(projection);
        if (this.getWrapX() && projection.isGlobal()) tileCoord = (0, $e7ff674aba025e93$export$39a9ce3624977b84)(tileGrid, tileCoord, projection);
        return (0, $dbbff40153ca9e51$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    };
    /**
     * Remove all cached tiles from the source. The next render cycle will fetch new tiles.
     * @api
     */ TileSource.prototype.clear = function() {
        this.tileCache.clear();
    };
    TileSource.prototype.refresh = function() {
        this.clear();
        _super.prototype.refresh.call(this);
    };
    /**
     * Increases the cache size if needed
     * @param {number} tileCount Minimum number of tiles needed.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */ TileSource.prototype.updateCacheSize = function(tileCount, projection) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (tileCount > tileCache.highWaterMark) tileCache.highWaterMark = tileCount;
    };
    /**
     * Marks a tile coord as being used, without triggering a load.
     * @abstract
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */ TileSource.prototype.useTile = function(z, x, y, projection) {};
    return TileSource;
}((0, $1bd7756853fd0f39$export$2e2bcd8739ae039));
/**
 * @classdesc
 * Events emitted by {@link module:ol/source/Tile~TileSource} instances are instances of this
 * type.
 */ var $9347b5d9b9fe0c79$export$c571855c51e6c4b6 = /** @class */ function(_super) {
    $9347b5d9b9fe0c79$var$__extends(TileSourceEvent, _super);
    /**
     * @param {string} type Type.
     * @param {import("../Tile.js").default} tile The tile.
     */ function TileSourceEvent(type, tile) {
        var _this = _super.call(this, type) || this;
        /**
         * The tile related to the event.
         * @type {import("../Tile.js").default}
         * @api
         */ _this.tile = tile;
        return _this;
    }
    return TileSourceEvent;
}((0, $bNM9R.default));
var $9347b5d9b9fe0c79$export$2e2bcd8739ae039 = $9347b5d9b9fe0c79$var$TileSource;



/**
 * @module ol/tileurlfunction
 */ 
var $3JLp3 = parcelRequire("3JLp3");

var $7aO1A = parcelRequire("7aO1A");

function $7067d6f7a7f8ee2d$export$f0ecb46e90798741(template, tileGrid) {
    var zRegEx = /\{z\}/g;
    var xRegEx = /\{x\}/g;
    var yRegEx = /\{y\}/g;
    var dashYRegEx = /\{-y\}/g;
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        else return template.replace(zRegEx, tileCoord[0].toString()).replace(xRegEx, tileCoord[1].toString()).replace(yRegEx, tileCoord[2].toString()).replace(dashYRegEx, function() {
            var z = tileCoord[0];
            var range = tileGrid.getFullTileRange(z);
            (0, $3JLp3.assert)(range, 55); // The {-y} placeholder requires a tile grid with extent
            var y = range.getHeight() - tileCoord[2] - 1;
            return y.toString();
        });
    });
}
function $7067d6f7a7f8ee2d$export$436f44dbcc31fea3(templates, tileGrid) {
    var len = templates.length;
    var tileUrlFunctions = new Array(len);
    for(var i = 0; i < len; ++i)tileUrlFunctions[i] = $7067d6f7a7f8ee2d$export$f0ecb46e90798741(templates[i], tileGrid);
    return $7067d6f7a7f8ee2d$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $7067d6f7a7f8ee2d$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        else {
            var h = (0, $dbbff40153ca9e51$export$d6af199866bfb566)(tileCoord);
            var index = (0, $7aO1A.modulo)(h, tileUrlFunctions.length);
            return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
        }
    });
}
function $7067d6f7a7f8ee2d$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}
function $7067d6f7a7f8ee2d$export$2a1fa079bfd73dde(url) {
    var urls = [];
    var match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        var startCharCode = match[1].charCodeAt(0);
        var stopCharCode = match[2].charCodeAt(0);
        var charCode = void 0;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        var stop_1 = parseInt(match[2], 10);
        for(var i = parseInt(match[1], 10); i <= stop_1; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}




var $61DUI = parcelRequire("61DUI");
var $17a75554b270d15e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Cache size.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] TileUrlFunction.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Base class for sources providing tiles divided into a tile grid over http.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ var $17a75554b270d15e$var$UrlTile = /** @class */ function(_super) {
    $17a75554b270d15e$var$__extends(UrlTile, _super);
    /**
     * @param {Options} options Image tile options.
     */ function UrlTile(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        }) || this;
        /**
         * @private
         * @type {boolean}
         */ _this.generateTileUrlFunction_ = _this.tileUrlFunction === UrlTile.prototype.tileUrlFunction;
        /**
         * @protected
         * @type {import("../Tile.js").LoadFunction}
         */ _this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) _this.tileUrlFunction = options.tileUrlFunction;
        /**
         * @protected
         * @type {!Array<string>|null}
         */ _this.urls = null;
        if (options.urls) _this.setUrls(options.urls);
        else if (options.url) _this.setUrl(options.url);
        /**
         * @private
         * @type {!Object<string, boolean>}
         */ _this.tileLoadingKeys_ = {};
        return _this;
    }
    /**
     * Return the tile load function of the source.
     * @return {import("../Tile.js").LoadFunction} TileLoadFunction
     * @api
     */ UrlTile.prototype.getTileLoadFunction = function() {
        return this.tileLoadFunction;
    };
    /**
     * Return the tile URL function of the source.
     * @return {import("../Tile.js").UrlFunction} TileUrlFunction
     * @api
     */ UrlTile.prototype.getTileUrlFunction = function() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    };
    /**
     * Return the URLs used for this source.
     * When a tileUrlFunction is used instead of url or urls,
     * null will be returned.
     * @return {!Array<string>|null} URLs.
     * @api
     */ UrlTile.prototype.getUrls = function() {
        return this.urls;
    };
    /**
     * Handle tile change events.
     * @param {import("../events/Event.js").default} event Event.
     * @protected
     */ UrlTile.prototype.handleTileChange = function(event) {
        var tile = /** @type {import("../Tile.js").default} */ event.target;
        var uid = (0, $61DUI.getUid)(tile);
        var tileState = tile.getState();
        var type;
        if (tileState == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $c10060fbd57e75dc$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).ERROR ? (0, $c10060fbd57e75dc$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED ? (0, $c10060fbd57e75dc$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $9347b5d9b9fe0c79$export$c571855c51e6c4b6)(type, tile));
    };
    /**
     * Set the tile load function of the source.
     * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
     * @api
     */ UrlTile.prototype.setTileLoadFunction = function(tileLoadFunction) {
        this.tileCache.clear();
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    };
    /**
     * Set the tile URL function of the source.
     * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
     * @param {string} [key] Optional new tile key for the source.
     * @api
     */ UrlTile.prototype.setTileUrlFunction = function(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        this.tileCache.pruneExceptNewestZ();
        if (typeof key !== 'undefined') this.setKey(key);
        else this.changed();
    };
    /**
     * Set the URL to use for requests.
     * @param {string} url URL.
     * @api
     */ UrlTile.prototype.setUrl = function(url) {
        var urls = (0, $7067d6f7a7f8ee2d$export$2a1fa079bfd73dde)(url);
        this.urls = urls;
        this.setUrls(urls);
    };
    /**
     * Set the URLs to use for requests.
     * @param {Array<string>} urls URLs.
     * @api
     */ UrlTile.prototype.setUrls = function(urls) {
        this.urls = urls;
        var key = urls.join('\n');
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $7067d6f7a7f8ee2d$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ UrlTile.prototype.tileUrlFunction = function(tileCoord, pixelRatio, projection) {
        return undefined;
    };
    /**
     * Marks a tile coord as being used, without triggering a load.
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     */ UrlTile.prototype.useTile = function(z, x, y) {
        var tileCoordKey = (0, $dbbff40153ca9e51$export$92d0df0f1d25c63c)(z, x, y);
        if (this.tileCache.containsKey(tileCoordKey)) this.tileCache.get(tileCoordKey);
    };
    return UrlTile;
}((0, $9347b5d9b9fe0c79$export$2e2bcd8739ae039));
var $17a75554b270d15e$export$2e2bcd8739ae039 = $17a75554b270d15e$var$UrlTile;







var $61DUI = parcelRequire("61DUI");
var $d8e615cd85c742f0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Deprecated.  Use the `interpolate` option instead.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Base class for sources providing images divided into a tile grid.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ var $d8e615cd85c742f0$var$TileImage = /** @class */ function(_super) {
    $d8e615cd85c742f0$var$__extends(TileImage, _super);
    /**
     * @param {!Options} options Image tile options.
     */ function TileImage(options) {
        var _this = this;
        var interpolate = options.imageSmoothing !== undefined ? options.imageSmoothing : true;
        if (options.interpolate !== undefined) interpolate = options.interpolate;
        _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $d8e615cd85c742f0$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        }) || this;
        /**
         * @protected
         * @type {?string}
         */ _this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
         * @protected
         * @type {typeof ImageTile}
         */ _this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $101762da51c85679$export$2e2bcd8739ae039);
        /**
         * @protected
         * @type {!Object<string, TileCache>}
         */ _this.tileCacheForProjection = {};
        /**
         * @protected
         * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
         */ _this.tileGridForProjection = {};
        /**
         * @private
         * @type {number|undefined}
         */ _this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
         * @private
         * @type {boolean}
         */ _this.renderReprojectionEdges_ = false;
        return _this;
    }
    /**
     * @return {boolean} Can expire cache.
     */ TileImage.prototype.canExpireCache = function() {
        if (!(0, $24791bdbb0fcec54$export$584433cc24140052)) return _super.prototype.canExpireCache.call(this);
        if (this.tileCache.canExpireCache()) return true;
        else for(var key in this.tileCacheForProjection){
            if (this.tileCacheForProjection[key].canExpireCache()) return true;
        }
        return false;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */ TileImage.prototype.expireCache = function(projection, usedTiles) {
        if (!(0, $24791bdbb0fcec54$export$584433cc24140052)) {
            _super.prototype.expireCache.call(this, projection, usedTiles);
            return;
        }
        var usedTileCache = this.getTileCacheForProjection(projection);
        this.tileCache.expireCache(this.tileCache == usedTileCache ? usedTiles : {});
        for(var id in this.tileCacheForProjection){
            var tileCache = this.tileCacheForProjection[id];
            tileCache.expireCache(tileCache == usedTileCache ? usedTiles : {});
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {number} Gutter.
     */ TileImage.prototype.getGutterForProjection = function(projection) {
        if ((0, $24791bdbb0fcec54$export$584433cc24140052) && this.getProjection() && projection && !(0, $d3bc250abc15fbce$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        else return this.getGutter();
    };
    /**
     * @return {number} Gutter.
     */ TileImage.prototype.getGutter = function() {
        return 0;
    };
    /**
     * Return the key to be used for all tiles in the source.
     * @return {string} The key for all tiles.
     */ TileImage.prototype.getKey = function() {
        var key = _super.prototype.getKey.call(this);
        if (!this.getInterpolate()) key += ':disable-interpolation';
        return key;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {boolean} Opaque.
     */ TileImage.prototype.getOpaque = function(projection) {
        if ((0, $24791bdbb0fcec54$export$584433cc24140052) && this.getProjection() && projection && !(0, $d3bc250abc15fbce$export$fe091d73a555748b)(this.getProjection(), projection)) return false;
        else return _super.prototype.getOpaque.call(this, projection);
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
     */ TileImage.prototype.getTileGridForProjection = function(projection) {
        if (!(0, $24791bdbb0fcec54$export$584433cc24140052)) return _super.prototype.getTileGridForProjection.call(this, projection);
        var thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $d3bc250abc15fbce$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        else {
            var projKey = (0, $61DUI.getUid)(projection);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $e7ff674aba025e93$export$1f4812384df8a9c5)(projection);
            return this.tileGridForProjection[projKey];
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../TileCache.js").default} Tile cache.
     */ TileImage.prototype.getTileCacheForProjection = function(projection) {
        if (!(0, $24791bdbb0fcec54$export$584433cc24140052)) return _super.prototype.getTileCacheForProjection.call(this, projection);
        var thisProj = this.getProjection();
        if (!thisProj || (0, $d3bc250abc15fbce$export$fe091d73a555748b)(thisProj, projection)) return this.tileCache;
        else {
            var projKey = (0, $61DUI.getUid)(projection);
            if (!(projKey in this.tileCacheForProjection)) this.tileCacheForProjection[projKey] = new (0, $55b0a576a8ff2994$export$2e2bcd8739ae039)(this.tileCache.highWaterMark);
            return this.tileCacheForProjection[projKey];
        }
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {string} key The key set on the tile.
     * @return {!ImageTile} Tile.
     * @private
     */ TileImage.prototype.createTile_ = function(z, x, y, pixelRatio, projection, key) {
        var tileCoord = [
            z,
            x,
            y
        ];
        var urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        var tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        var tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE : (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : '', this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $cFmyb.default).CHANGE, this.handleTileChange.bind(this));
        return tile;
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!(ImageTile|ReprojTile)} Tile.
     */ TileImage.prototype.getTile = function(z, x, y, pixelRatio, projection) {
        var sourceProjection = this.getProjection();
        if (!(0, $24791bdbb0fcec54$export$584433cc24140052) || !sourceProjection || !projection || (0, $d3bc250abc15fbce$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        else {
            var cache = this.getTileCacheForProjection(projection);
            var tileCoord = [
                z,
                x,
                y
            ];
            var tile = void 0;
            var tileCoordKey = (0, $dbbff40153ca9e51$export$a47fb462a08de82f)(tileCoord);
            if (cache.containsKey(tileCoordKey)) tile = cache.get(tileCoordKey);
            var key = this.getKey();
            if (tile && tile.key == key) return tile;
            else {
                var sourceTileGrid = this.getTileGridForProjection(sourceProjection);
                var targetTileGrid = this.getTileGridForProjection(projection);
                var wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
                var newTile = new (0, $c0536ebcb9f53884$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (function(z, x, y, pixelRatio) {
                    return this.getTileInternal(z, x, y, pixelRatio, sourceProjection);
                }).bind(this), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.getInterpolate());
                newTile.key = key;
                if (tile) {
                    newTile.interimTile = tile;
                    newTile.refreshInterimChain();
                    cache.replace(tileCoordKey, newTile);
                } else cache.set(tileCoordKey, newTile);
                return newTile;
            }
        }
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {!import("../proj/Projection.js").default} projection Projection.
     * @return {!(ImageTile|ReprojTile)} Tile.
     * @protected
     */ TileImage.prototype.getTileInternal = function(z, x, y, pixelRatio, projection) {
        var tile = null;
        var tileCoordKey = (0, $dbbff40153ca9e51$export$92d0df0f1d25c63c)(z, x, y);
        var key = this.getKey();
        if (!this.tileCache.containsKey(tileCoordKey)) {
            tile = this.createTile_(z, x, y, pixelRatio, projection, key);
            this.tileCache.set(tileCoordKey, tile);
        } else {
            tile = this.tileCache.get(tileCoordKey);
            if (tile.key != key) {
                // The source's params changed. If the tile has an interim tile and if we
                // can use it then we use it. Otherwise we create a new tile.  In both
                // cases we attempt to assign an interim tile to the new tile.
                var interimTile = tile;
                tile = this.createTile_(z, x, y, pixelRatio, projection, key);
                //make the new tile the head of the list,
                if (interimTile.getState() == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE) //the old tile hasn't begun loading yet, and is now outdated, so we can simply discard it
                tile.interimTile = interimTile.interimTile;
                else tile.interimTile = interimTile;
                tile.refreshInterimChain();
                this.tileCache.replace(tileCoordKey, tile);
            }
        }
        return tile;
    };
    /**
     * Sets whether to render reprojection edges or not (usually for debugging).
     * @param {boolean} render Render the edges.
     * @api
     */ TileImage.prototype.setRenderReprojectionEdges = function(render) {
        if (!(0, $24791bdbb0fcec54$export$584433cc24140052) || this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        for(var id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
        this.changed();
    };
    /**
     * Sets the tile grid to use when reprojecting the tiles to the given
     * projection instead of the default tile grid for the projection.
     *
     * This can be useful when the default tile grid cannot be created
     * (e.g. projection has no extent defined) or
     * for optimization reasons (custom tile size, resolutions, ...).
     *
     * @param {import("../proj.js").ProjectionLike} projection Projection.
     * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
     * @api
     */ TileImage.prototype.setTileGridForProjection = function(projection, tilegrid) {
        if (0, $24791bdbb0fcec54$export$584433cc24140052) {
            var proj = (0, $d3bc250abc15fbce$export$3988ae62b71be9a3)(projection);
            if (proj) {
                var projKey = (0, $61DUI.getUid)(proj);
                if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
            }
        }
    };
    return TileImage;
}((0, $17a75554b270d15e$export$2e2bcd8739ae039));
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $d8e615cd85c742f0$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $d8e615cd85c742f0$export$2e2bcd8739ae039 = $d8e615cd85c742f0$var$TileImage;



var $70db29c0424f6ec3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Deprecated.  Use the `interpolate` option instead.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get
 * tile URL given a tile coordinate and the projection.
 * Required if `url` or `urls` are not provided.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ var $70db29c0424f6ec3$var$XYZ = /** @class */ function(_super) {
    $70db29c0424f6ec3$var$__extends(XYZ, _super);
    /**
     * @param {Options} [opt_options] XYZ options.
     */ function XYZ(opt_options) {
        var _this = this;
        var options = opt_options || {};
        var interpolate = options.imageSmoothing !== undefined ? options.imageSmoothing : true;
        if (options.interpolate !== undefined) interpolate = options.interpolate;
        var projection = options.projection !== undefined ? options.projection : 'EPSG:3857';
        var tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $e7ff674aba025e93$export$38500bbeccc864ff)({
            extent: (0, $e7ff674aba025e93$export$7b5b6ef8fd55fac4)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: interpolate,
            opaque: options.opaque,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        }) || this;
        /**
         * @private
         * @type {number}
         */ _this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
        return _this;
    }
    /**
     * @return {number} Gutter.
     */ XYZ.prototype.getGutter = function() {
        return this.gutter_;
    };
    return XYZ;
}((0, $d8e615cd85c742f0$export$2e2bcd8739ae039));
var $70db29c0424f6ec3$export$2e2bcd8739ae039 = $70db29c0424f6ec3$var$XYZ;


var $937dc7db0d2828fe$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $937dc7db0d2828fe$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Deprecated.  Use the `interpolate` option instead.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {boolean} [opaque=true] Whether the layer is opaque.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ var $937dc7db0d2828fe$var$OSM = /** @class */ function(_super) {
    $937dc7db0d2828fe$var$__extends(OSM, _super);
    /**
     * @param {Options} [opt_options] Open Street Map options.
     */ function OSM(opt_options) {
        var options = opt_options || {};
        var interpolate = options.imageSmoothing !== undefined ? options.imageSmoothing : true;
        if (options.interpolate !== undefined) interpolate = options.interpolate;
        var attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $937dc7db0d2828fe$export$4de8a5e77eb994ad
        ];
        var crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous';
        var url = options.url !== undefined ? options.url : 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        return _super.call(this, {
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: crossOrigin,
            interpolate: interpolate,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            opaque: options.opaque !== undefined ? options.opaque : true,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection
        }) || this;
    }
    return OSM;
}((0, $70db29c0424f6ec3$export$2e2bcd8739ae039));
var $937dc7db0d2828fe$export$2e2bcd8739ae039 = $937dc7db0d2828fe$var$OSM;

/**
 * @module ol/source/Vector
 */ 
var $1IaXJ = parcelRequire("1IaXJ");

var $59kE1 = parcelRequire("59kE1");

var $bNM9R = parcelRequire("bNM9R");

var $cFmyb = parcelRequire("cFmyb");

var $48iCR = parcelRequire("48iCR");
/**
 * @module ol/structs/RBush
 */ var $fc2e28651a316465$exports = {};
!function(t, i) {
    $fc2e28651a316465$exports = i();
}($fc2e28651a316465$exports, function() {
    "use strict";
    function t(t, r, e, a, h) {
        !function t(n, r, e, a, h) {
            for(; a > e;){
                if (a - e > 600) {
                    var o = a - e + 1, s = r - e + 1, l = Math.log(o), f = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * f * (o - f) / o) * (s - o / 2 < 0 ? -1 : 1), m = Math.max(e, Math.floor(r - s * f / o + u)), c = Math.min(a, Math.floor(r + (o - s) * f / o + u));
                    t(n, r, m, c, h);
                }
                var p = n[r], d = e, x = a;
                for(i(n, e, r), h(n[a], p) > 0 && i(n, e, a); d < x;){
                    for(i(n, d, x), d++, x--; h(n[d], p) < 0;)d++;
                    for(; h(n[x], p) > 0;)x--;
                }
                0 === h(n[e], p) ? i(n, e, x) : i(n, ++x, a), x <= r && (e = x + 1), r <= x && (a = x - 1);
            }
        }(t, r, e || 0, a || t.length - 1, h || n);
    }
    function i(t, i, n) {
        var r = t[i];
        t[i] = t[n], t[n] = r;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    var r = function(t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
    };
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(var r = 0; r < i.length; r++)if (n(t, i[r])) return r;
        return -1;
    }
    function a(t, i) {
        h(t, 0, t.children.length, i, t);
    }
    function h(t, i, n, r, e) {
        e || (e = p(null)), e.minX = 1 / 0, e.minY = 1 / 0, e.maxX = -1 / 0, e.maxY = -1 / 0;
        for(var a = i; a < n; a++){
            var h = t.children[a];
            o(e, t.leaf ? r(h) : h);
        }
        return e;
    }
    function o(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function s(t, i) {
        return t.minX - i.minX;
    }
    function l(t, i) {
        return t.minY - i.minY;
    }
    function f(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function u(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function c(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function p(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function d(i, n, r, e, a) {
        for(var h = [
            n,
            r
        ]; h.length;)if (!((r = h.pop()) - (n = h.pop()) <= e)) {
            var o = n + Math.ceil((r - n) / e / 2) * e;
            t(i, o, n, r, a), h.push(n, o, o, r);
        }
    }
    return r.prototype.all = function() {
        return this._all(this.data, []);
    }, r.prototype.search = function(t) {
        var i = this.data, n = [];
        if (!c(t, i)) return n;
        for(var r = this.toBBox, e = []; i;){
            for(var a = 0; a < i.children.length; a++){
                var h = i.children[a], o = i.leaf ? r(h) : h;
                c(t, o) && (i.leaf ? n.push(h) : m(t, o) ? this._all(h, n) : e.push(h));
            }
            i = e.pop();
        }
        return n;
    }, r.prototype.collides = function(t) {
        var i = this.data;
        if (!c(t, i)) return !1;
        for(var n = []; i;){
            for(var r = 0; r < i.children.length; r++){
                var e = i.children[r], a = i.leaf ? this.toBBox(e) : e;
                if (c(t, a)) {
                    if (i.leaf || m(t, a)) return !0;
                    n.push(e);
                }
            }
            i = n.pop();
        }
        return !1;
    }, r.prototype.load = function(t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
            for(var i = 0; i < t.length; i++)this.insert(t[i]);
            return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
            if (this.data.height === n.height) this._splitRoot(this.data, n);
            else {
                if (this.data.height < n.height) {
                    var r = this.data;
                    this.data = n, n = r;
                }
                this._insert(n, this.data.height - n.height - 1, !0);
            }
        } else this.data = n;
        return this;
    }, r.prototype.insert = function(t) {
        return t && this._insert(t, this.data.height - 1), this;
    }, r.prototype.clear = function() {
        return this.data = p([]), this;
    }, r.prototype.remove = function(t, i) {
        if (!t) return this;
        for(var n, r, a, h = this.data, o = this.toBBox(t), s = [], l = []; h || s.length;){
            if (h || (h = s.pop(), r = s[s.length - 1], n = l.pop(), a = !0), h.leaf) {
                var f = e(t, h.children, i);
                if (-1 !== f) return h.children.splice(f, 1), s.push(h), this._condense(s), this;
            }
            a || h.leaf || !m(h, o) ? r ? (n++, h = r.children[n], a = !1) : h = null : (s.push(h), l.push(n), n = 0, r = h, h = h.children[0]);
        }
        return this;
    }, r.prototype.toBBox = function(t) {
        return t;
    }, r.prototype.compareMinX = function(t, i) {
        return t.minX - i.minX;
    }, r.prototype.compareMinY = function(t, i) {
        return t.minY - i.minY;
    }, r.prototype.toJSON = function() {
        return this.data;
    }, r.prototype.fromJSON = function(t) {
        return this.data = t, this;
    }, r.prototype._all = function(t, i) {
        for(var n = []; t;)t.leaf ? i.push.apply(i, t.children) : n.push.apply(n, t.children), t = n.pop();
        return i;
    }, r.prototype._build = function(t, i, n, r) {
        var e, h = n - i + 1, o = this._maxEntries;
        if (h <= o) return a(e = p(t.slice(i, n + 1)), this.toBBox), e;
        r || (r = Math.ceil(Math.log(h) / Math.log(o)), o = Math.ceil(h / Math.pow(o, r - 1))), (e = p([])).leaf = !1, e.height = r;
        var s = Math.ceil(h / o), l = s * Math.ceil(Math.sqrt(o));
        d(t, i, n, l, this.compareMinX);
        for(var f = i; f <= n; f += l){
            var u = Math.min(f + l - 1, n);
            d(t, f, u, s, this.compareMinY);
            for(var m = f; m <= u; m += s){
                var c = Math.min(m + s - 1, u);
                e.children.push(this._build(t, m, c, r - 1));
            }
        }
        return a(e, this.toBBox), e;
    }, r.prototype._chooseSubtree = function(t, i, n, r) {
        for(; r.push(i), !i.leaf && r.length - 1 !== n;){
            for(var e = 1 / 0, a = 1 / 0, h = void 0, o = 0; o < i.children.length; o++){
                var s = i.children[o], l = f(s), u = (m = t, c = s, (Math.max(c.maxX, m.maxX) - Math.min(c.minX, m.minX)) * (Math.max(c.maxY, m.maxY) - Math.min(c.minY, m.minY)) - l);
                u < a ? (a = u, e = l < e ? l : e, h = s) : u === a && l < e && (e = l, h = s);
            }
            i = h || i.children[0];
        }
        var m, c;
        return i;
    }, r.prototype._insert = function(t, i, n) {
        var r = n ? t : this.toBBox(t), e = [], a = this._chooseSubtree(r, this.data, i, e);
        for(a.children.push(t), o(a, r); i >= 0 && e[i].children.length > this._maxEntries;)this._split(e, i), i--;
        this._adjustParentBBoxes(r, e, i);
    }, r.prototype._split = function(t, i) {
        var n = t[i], r = n.children.length, e = this._minEntries;
        this._chooseSplitAxis(n, e, r);
        var h = this._chooseSplitIndex(n, e, r), o = p(n.children.splice(h, n.children.length - h));
        o.height = n.height, o.leaf = n.leaf, a(n, this.toBBox), a(o, this.toBBox), i ? t[i - 1].children.push(o) : this._splitRoot(n, o);
    }, r.prototype._splitRoot = function(t, i) {
        this.data = p([
            t,
            i
        ]), this.data.height = t.height + 1, this.data.leaf = !1, a(this.data, this.toBBox);
    }, r.prototype._chooseSplitIndex = function(t, i, n) {
        for(var r, e, a, o, s, l, u, m = 1 / 0, c = 1 / 0, p = i; p <= n - i; p++){
            var d = h(t, 0, p, this.toBBox), x = h(t, p, n, this.toBBox), v = (e = d, a = x, o = void 0, s = void 0, l = void 0, u = void 0, o = Math.max(e.minX, a.minX), s = Math.max(e.minY, a.minY), l = Math.min(e.maxX, a.maxX), u = Math.min(e.maxY, a.maxY), Math.max(0, l - o) * Math.max(0, u - s)), M = f(d) + f(x);
            v < m ? (m = v, r = p, c = M < c ? M : c) : v === m && M < c && (c = M, r = p);
        }
        return r || n - i;
    }, r.prototype._chooseSplitAxis = function(t, i, n) {
        var r = t.leaf ? this.compareMinX : s, e = t.leaf ? this.compareMinY : l;
        this._allDistMargin(t, i, n, r) < this._allDistMargin(t, i, n, e) && t.children.sort(r);
    }, r.prototype._allDistMargin = function(t, i, n, r) {
        t.children.sort(r);
        for(var e = this.toBBox, a = h(t, 0, i, e), s = h(t, n - i, n, e), l = u(a) + u(s), f = i; f < n - i; f++){
            var m = t.children[f];
            o(a, t.leaf ? e(m) : m), l += u(a);
        }
        for(var c = n - i - 1; c >= i; c--){
            var p = t.children[c];
            o(s, t.leaf ? e(p) : p), l += u(s);
        }
        return l;
    }, r.prototype._adjustParentBBoxes = function(t, i, n) {
        for(var r = n; r >= 0; r--)o(i[r], t);
    }, r.prototype._condense = function(t) {
        for(var i = t.length - 1, n = void 0; i >= 0; i--)0 === t[i].children.length ? i > 0 ? (n = t[i - 1].children).splice(n.indexOf(t[i]), 1) : this.clear() : a(t[i], this.toBBox);
    }, r;
});



var $2Jl0K = parcelRequire("2Jl0K");

var $61DUI = parcelRequire("61DUI");

var $9zTj4 = parcelRequire("9zTj4");
/**
 * @typedef {Object} Entry
 * @property {number} minX MinX.
 * @property {number} minY MinY.
 * @property {number} maxX MaxX.
 * @property {number} maxY MaxY.
 * @property {Object} [value] Value.
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template T
 */ var $272a32befa32f39d$var$RBush = /** @class */ function() {
    /**
     * @param {number} [opt_maxEntries] Max entries.
     */ function RBush(opt_maxEntries) {
        /**
         * @private
         */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($fc2e28651a316465$exports)))(opt_maxEntries);
        /**
         * A mapping between the objects added to this rbush wrapper
         * and the objects that are actually added to the internal rbush.
         * @private
         * @type {Object<string, Entry>}
         */ this.items_ = {};
    }
    /**
     * Insert a value into the RBush.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {T} value Value.
     */ RBush.prototype.insert = function(extent, value) {
        /** @type {Entry} */ var item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $61DUI.getUid)(value)] = item;
    };
    /**
     * Bulk-insert values into the RBush.
     * @param {Array<import("../extent.js").Extent>} extents Extents.
     * @param {Array<T>} values Values.
     */ RBush.prototype.load = function(extents, values) {
        var items = new Array(values.length);
        for(var i = 0, l = values.length; i < l; i++){
            var extent = extents[i];
            var value = values[i];
            /** @type {Entry} */ var item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $61DUI.getUid)(value)] = item;
        }
        this.rbush_.load(items);
    };
    /**
     * Remove a value from the RBush.
     * @param {T} value Value.
     * @return {boolean} Removed.
     */ RBush.prototype.remove = function(value) {
        var uid = (0, $61DUI.getUid)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        var item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    };
    /**
     * Update the extent of a value in the RBush.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {T} value Value.
     */ RBush.prototype.update = function(extent, value) {
        var item = this.items_[(0, $61DUI.getUid)(value)];
        var bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $2Jl0K.equals)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    };
    /**
     * Return all values in the RBush.
     * @return {Array<T>} All.
     */ RBush.prototype.getAll = function() {
        var items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    };
    /**
     * Return all values in the given extent.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {Array<T>} All in extent.
     */ RBush.prototype.getInExtent = function(extent) {
        /** @type {Entry} */ var bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        var items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    };
    /**
     * Calls a callback function with each value in the tree.
     * If the callback returns a truthy value, this value is returned without
     * checking the rest of the tree.
     * @param {function(T): *} callback Callback.
     * @return {*} Callback return value.
     */ RBush.prototype.forEach = function(callback) {
        return this.forEach_(this.getAll(), callback);
    };
    /**
     * Calls a callback function with each value in the provided extent.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {function(T): *} callback Callback.
     * @return {*} Callback return value.
     */ RBush.prototype.forEachInExtent = function(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    };
    /**
     * @param {Array<T>} values Values.
     * @param {function(T): *} callback Callback.
     * @private
     * @return {*} Callback return value.
     */ RBush.prototype.forEach_ = function(values, callback) {
        var result;
        for(var i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    };
    /**
     * @return {boolean} Is empty.
     */ RBush.prototype.isEmpty = function() {
        return (0, $9zTj4.isEmpty)(this.items_);
    };
    /**
     * Remove all values from the RBush.
     */ RBush.prototype.clear = function() {
        this.rbush_.clear();
        this.items_ = {};
    };
    /**
     * @param {import("../extent.js").Extent} [opt_extent] Extent.
     * @return {import("../extent.js").Extent} Extent.
     */ RBush.prototype.getExtent = function(opt_extent) {
        var data = this.rbush_.toJSON();
        return (0, $2Jl0K.createOrUpdate)(data.minX, data.minY, data.maxX, data.maxY, opt_extent);
    };
    /**
     * @param {RBush} rbush R-Tree.
     */ RBush.prototype.concat = function(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(var i in rbush.items_)this.items_[i] = rbush.items_[i];
    };
    return RBush;
}();
var $272a32befa32f39d$export$2e2bcd8739ae039 = $272a32befa32f39d$var$RBush;



/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $35b3e5a26bc6bba7$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
     * Triggered when a feature is added to the source.
     * @event module:ol/source/Vector.VectorSourceEvent#addfeature
     * @api
     */ ADDFEATURE: 'addfeature',
    /**
     * Triggered when a feature is updated.
     * @event module:ol/source/Vector.VectorSourceEvent#changefeature
     * @api
     */ CHANGEFEATURE: 'changefeature',
    /**
     * Triggered when the clear method is called on the source.
     * @event module:ol/source/Vector.VectorSourceEvent#clear
     * @api
     */ CLEAR: 'clear',
    /**
     * Triggered when a feature is removed from the source.
     * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
     * @event module:ol/source/Vector.VectorSourceEvent#removefeature
     * @api
     */ REMOVEFEATURE: 'removefeature',
    /**
     * Triggered when features starts loading.
     * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
     * @api
     */ FEATURESLOADSTART: 'featuresloadstart',
    /**
     * Triggered when features finishes loading.
     * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
     * @api
     */ FEATURESLOADEND: 'featuresloadend',
    /**
     * Triggered if feature loading results in an error.
     * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
     * @api
     */ FEATURESLOADERROR: 'featuresloaderror'
};



var $c8IGo = parcelRequire("c8IGo");
/**
 * @module ol/loadingstrategy
 */ 
function $cf3ec5b3f11f89d4$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $cf3ec5b3f11f89d4$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $cf3ec5b3f11f89d4$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        var z = tileGrid.getZForResolution((0, $d3bc250abc15fbce$export$bd1cd3b88140b906)(resolution, projection));
        var tileRange = tileGrid.getTileRangeForExtentAndZ((0, $d3bc250abc15fbce$export$494be3a3a25689ca)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ var extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ var tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $d3bc250abc15fbce$export$96bfd09e2cffb006)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}



var $3JLp3 = parcelRequire("3JLp3");

var $2Jl0K = parcelRequire("2Jl0K");

var $kzmGH = parcelRequire("kzmGH");

var $61DUI = parcelRequire("61DUI");

var $9zTj4 = parcelRequire("9zTj4");

var $1dBX3 = parcelRequire("1dBX3");
/**
 * @module ol/featureloader
 */ 
var $c8IGo = parcelRequire("c8IGo");
/**
 *
 * @type {boolean}
 * @private
 */ var $7038dca9b576390d$var$withCredentials = false;
function $7038dca9b576390d$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == 'arraybuffer') xhr.responseType = 'arraybuffer';
    xhr.withCredentials = $7038dca9b576390d$var$withCredentials;
    /**
     * @param {Event} event Event.
     * @private
     */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            var type = format.getType();
            /** @type {Document|Node|Object|string|undefined} */ var source = void 0;
            if (type == 'json' || type == 'text') source = xhr.responseText;
            else if (type == 'xml') {
                source = xhr.responseXML;
                if (!source) source = new DOMParser().parseFromString(xhr.responseText, 'application/xml');
            } else if (type == 'arraybuffer') source = /** @type {ArrayBuffer} */ xhr.response;
            if (source) success(/** @type {Array<import("./Feature.js").default>} */ format.readFeatures(source, {
                extent: extent,
                featureProjection: projection
            }), format.readProjection(source));
            else failure();
        } else failure();
    };
    /**
     * @private
     */ xhr.onerror = failure;
    xhr.send();
}
function $7038dca9b576390d$export$14cc81df70b6707e(url, format) {
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @param {function(Array<import("./Feature.js").default>): void} [success] Success
     *      Function called when loading succeeded.
     * @param {function(): void} [failure] Failure
     *      Function called when loading failed.
     * @this {import("./source/Vector").default}
     */ return function(extent, resolution, projection, success, failure) {
        var source = /** @type {import("./source/Vector").default} */ this;
        $7038dca9b576390d$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
         * @param {Array<import("./Feature.js").default>} features The loaded features.
         * @param {import("./proj/Projection.js").default} dataProjection Data
         * projection.
         */ function(features, dataProjection) {
            source.addFeatures(features);
            if (success !== undefined) success(features);
        }, /* FIXME handle error */ failure ? failure : (0, $c8IGo.VOID));
    };
}
function $7038dca9b576390d$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $7038dca9b576390d$var$withCredentials = xhrWithCredentials;
}


var $39da9044499339fe$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A function that takes an {@link module:ol/extent~Extent} and a resolution as arguments, and
 * returns an array of {@link module:ol/extent~Extent} with the extents to load. Usually this
 * is one of the standard {@link module:ol/loadingstrategy} strategies.
 *
 * @typedef {function(import("../extent.js").Extent, number, import("../proj/Projection.js").default): Array<import("../extent.js").Extent>} LoadingStrategy
 * @api
 */ /**
 * @classdesc
 * Events emitted by {@link module:ol/source/Vector~VectorSource} instances are instances of this
 * type.
 * @template {import("../geom/Geometry.js").default} [Geometry=import("../geom/Geometry.js").default]
 */ var $39da9044499339fe$export$d402fd02dc2b661c = /** @class */ function(_super) {
    $39da9044499339fe$var$__extends(VectorSourceEvent, _super);
    /**
     * @param {string} type Type.
     * @param {import("../Feature.js").default<Geometry>} [opt_feature] Feature.
     * @param {Array<import("../Feature.js").default<Geometry>>} [opt_features] Features.
     */ function VectorSourceEvent(type, opt_feature, opt_features) {
        var _this = _super.call(this, type) || this;
        /**
         * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
         * @type {import("../Feature.js").default<Geometry>|undefined}
         * @api
         */ _this.feature = opt_feature;
        /**
         * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
         * @type {Array<import("../Feature.js").default<Geometry>>|undefined}
         * @api
         */ _this.features = opt_features;
        return _this;
    }
    return VectorSourceEvent;
}((0, $bNM9R.default));
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<import("../Feature.js").default>|Collection<import("../Feature.js").default>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import {Vector} from 'ol/source';
 * import {GeoJSON} from 'ol/format';
 * import {bbox} from 'ol/loadingstrategy';
 *
 * var vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      var proj = projection.getCode();
 *      var url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      var xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      var onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          var features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../geom/Geometry.js").default} [Geometry=import("../geom/Geometry.js").default]
 */ var $39da9044499339fe$var$VectorSource = /** @class */ function(_super) {
    $39da9044499339fe$var$__extends(VectorSource, _super);
    /**
     * @param {Options} [opt_options] Vector source options.
     */ function VectorSource(opt_options) {
        var _this = this;
        var options = opt_options || {};
        _this = _super.call(this, {
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: 'ready',
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        }) || this;
        /***
         * @type {VectorSourceOnSignature<import("../events").EventsKey>}
         */ _this.on;
        /***
         * @type {VectorSourceOnSignature<import("../events").EventsKey>}
         */ _this.once;
        /***
         * @type {VectorSourceOnSignature<void>}
         */ _this.un;
        /**
         * @private
         * @type {import("../featureloader.js").FeatureLoader}
         */ _this.loader_ = (0, $c8IGo.VOID);
        /**
         * @private
         * @type {import("../format/Feature.js").default|undefined}
         */ _this.format_ = options.format;
        /**
         * @private
         * @type {boolean}
         */ _this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
         * @private
         * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
         */ _this.url_ = options.url;
        if (options.loader !== undefined) _this.loader_ = options.loader;
        else if (_this.url_ !== undefined) {
            (0, $3JLp3.assert)(_this.format_, 7); // `format` must be set when `url` is set
            // create a XHR feature loader for "url" and "format"
            _this.loader_ = (0, $7038dca9b576390d$export$14cc81df70b6707e)(_this.url_, /** @type {import("../format/Feature.js").default} */ _this.format_);
        }
        /**
         * @private
         * @type {LoadingStrategy}
         */ _this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $cf3ec5b3f11f89d4$export$84bf76cd7afc7469);
        var useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
         * @private
         * @type {RBush<import("../Feature.js").default<Geometry>>}
         */ _this.featuresRtree_ = useSpatialIndex ? new (0, $272a32befa32f39d$export$2e2bcd8739ae039)() : null;
        /**
         * @private
         * @type {RBush<{extent: import("../extent.js").Extent}>}
         */ _this.loadedExtentsRtree_ = new (0, $272a32befa32f39d$export$2e2bcd8739ae039)();
        /**
         * @type {number}
         * @private
         */ _this.loadingExtentsCount_ = 0;
        /**
         * @private
         * @type {!Object<string, import("../Feature.js").default<Geometry>>}
         */ _this.nullGeometryFeatures_ = {};
        /**
         * A lookup of features by id (the return from feature.getId()).
         * @private
         * @type {!Object<string, import("../Feature.js").default<Geometry>>}
         */ _this.idIndex_ = {};
        /**
         * A lookup of features by uid (using getUid(feature)).
         * @private
         * @type {!Object<string, import("../Feature.js").default<Geometry>>}
         */ _this.uidIndex_ = {};
        /**
         * @private
         * @type {Object<string, Array<import("../events.js").EventsKey>>}
         */ _this.featureChangeKeys_ = {};
        /**
         * @private
         * @type {Collection<import("../Feature.js").default<Geometry>>|null}
         */ _this.featuresCollection_ = null;
        var collection, features;
        if (Array.isArray(options.features)) features = /** @type {Array<import("../Feature.js").default<Geometry>>} */ options.features;
        else if (options.features) {
            collection = /** @type {Collection<import("../Feature.js").default<Geometry>>} */ options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $1IaXJ.default)(features);
        if (features !== undefined) _this.addFeaturesInternal(features);
        if (collection !== undefined) _this.bindFeaturesCollection_(collection);
        return _this;
    }
    /**
     * Add a single feature to the source.  If you want to add a batch of features
     * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
     * instead. A feature will not be added to the source if feature with
     * the same id is already there. The reason for this behavior is to avoid
     * feature duplication when using bbox or tile loading strategies.
     * Note: this also applies if an {@link module:ol/Collection~Collection} is used for features,
     * meaning that if a feature with a duplicate id is added in the collection, it will
     * be removed from it right away.
     * @param {import("../Feature.js").default<Geometry>} feature Feature to add.
     * @api
     */ VectorSource.prototype.addFeature = function(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    };
    /**
     * Add a feature without firing a `change` event.
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @protected
     */ VectorSource.prototype.addFeatureInternal = function(feature) {
        var featureKey = (0, $61DUI.getUid)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        var geometry = feature.getGeometry();
        if (geometry) {
            var extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $39da9044499339fe$export$d402fd02dc2b661c((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).ADDFEATURE, feature));
    };
    /**
     * @param {string} featureKey Unique identifier for the feature.
     * @param {import("../Feature.js").default<Geometry>} feature The feature.
     * @private
     */ VectorSource.prototype.setupChangeEvents_ = function(featureKey, feature) {
        this.featureChangeKeys_[featureKey] = [
            (0, $1dBX3.listen)(feature, (0, $cFmyb.default).CHANGE, this.handleFeatureChange_, this),
            (0, $1dBX3.listen)(feature, (0, $48iCR.default).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    };
    /**
     * @param {string} featureKey Unique identifier for the feature.
     * @param {import("../Feature.js").default<Geometry>} feature The feature.
     * @return {boolean} The feature is "valid", in the sense that it is also a
     *     candidate for insertion into the Rtree.
     * @private
     */ VectorSource.prototype.addToIndex_ = function(featureKey, feature) {
        var valid = true;
        var id = feature.getId();
        if (id !== undefined) {
            if (!(id.toString() in this.idIndex_)) this.idIndex_[id.toString()] = feature;
            else valid = false;
        }
        if (valid) {
            (0, $3JLp3.assert)(!(featureKey in this.uidIndex_), 30); // The passed `feature` was already added to the source
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    };
    /**
     * Add a batch of features to the source.
     * @param {Array<import("../Feature.js").default<Geometry>>} features Features to add.
     * @api
     */ VectorSource.prototype.addFeatures = function(features) {
        this.addFeaturesInternal(features);
        this.changed();
    };
    /**
     * Add features without firing a `change` event.
     * @param {Array<import("../Feature.js").default<Geometry>>} features Features.
     * @protected
     */ VectorSource.prototype.addFeaturesInternal = function(features) {
        var extents = [];
        var newFeatures = [];
        var geometryFeatures = [];
        for(var i = 0, length_1 = features.length; i < length_1; i++){
            var feature = features[i];
            var featureKey = (0, $61DUI.getUid)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(var i = 0, length_2 = newFeatures.length; i < length_2; i++){
            var feature = newFeatures[i];
            var featureKey = (0, $61DUI.getUid)(feature);
            this.setupChangeEvents_(featureKey, feature);
            var geometry = feature.getGeometry();
            if (geometry) {
                var extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).ADDFEATURE)) for(var i = 0, length_3 = newFeatures.length; i < length_3; i++)this.dispatchEvent(new $39da9044499339fe$export$d402fd02dc2b661c((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i]));
    };
    /**
     * @param {!Collection<import("../Feature.js").default<Geometry>>} collection Collection.
     * @private
     */ VectorSource.prototype.bindFeaturesCollection_ = function(collection) {
        var modifyingCollection = false;
        this.addEventListener((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).ADDFEATURE, /**
         * @param {VectorSourceEvent<Geometry>} evt The vector source event
         */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).REMOVEFEATURE, /**
         * @param {VectorSourceEvent<Geometry>} evt The vector source event
         */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $59kE1.default).ADD, /**
         * @param {import("../Collection.js").CollectionEvent} evt The collection event
         */ (function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(/** @type {import("../Feature.js").default<Geometry>} */ evt.element);
                modifyingCollection = false;
            }
        }).bind(this));
        collection.addEventListener((0, $59kE1.default).REMOVE, /**
         * @param {import("../Collection.js").CollectionEvent} evt The collection event
         */ (function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(/** @type {import("../Feature.js").default<Geometry>} */ evt.element);
                modifyingCollection = false;
            }
        }).bind(this));
        this.featuresCollection_ = collection;
    };
    /**
     * Remove all features from the source.
     * @param {boolean} [opt_fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature removefeature} events.
     * @api
     */ VectorSource.prototype.clear = function(opt_fast) {
        if (opt_fast) {
            for(var featureId in this.featureChangeKeys_){
                var keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $1dBX3.unlistenByKey));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            var removeAndIgnoreReturn = (function(feature) {
                this.removeFeatureInternal(feature);
            }).bind(this);
            this.featuresRtree_.forEach(removeAndIgnoreReturn);
            for(var id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        var clearEvent = new $39da9044499339fe$export$d402fd02dc2b661c((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    };
    /**
     * Iterate through all features on the source, calling the provided callback
     * with each one.  If the callback returns any "truthy" value, iteration will
     * stop and the function will return the same value.
     * Note: this function only iterate through the feature that have a defined geometry.
     *
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     on the source.  Return a truthy value to stop iteration.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     * @api
     */ VectorSource.prototype.forEachFeature = function(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        else if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    };
    /**
     * Iterate through all features whose geometries contain the provided
     * coordinate, calling the callback with each feature.  If the callback returns
     * a "truthy" value, iteration will stop and the function will return the same
     * value.
     *
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     whose goemetry contains the provided coordinate.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     */ VectorSource.prototype.forEachFeatureAtCoordinateDirect = function(coordinate, callback) {
        var extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            var geometry = feature.getGeometry();
            if (geometry.intersectsCoordinate(coordinate)) return callback(feature);
            else return undefined;
        });
    };
    /**
     * Iterate through all features whose bounding box intersects the provided
     * extent (note that the feature's geometry may not intersect the extent),
     * calling the callback with each feature.  If the callback returns a "truthy"
     * value, iteration will stop and the function will return the same value.
     *
     * If you are interested in features whose geometry intersects an extent, call
     * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
     *
     * When `useSpatialIndex` is set to false, this method will loop through all
     * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     whose bounding box intersects the provided extent.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     * @api
     */ VectorSource.prototype.forEachFeatureInExtent = function(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        else if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    };
    /**
     * Iterate through all features whose geometry intersects the provided extent,
     * calling the callback with each feature.  If the callback returns a "truthy"
     * value, iteration will stop and the function will return the same value.
     *
     * If you only want to test for bounding box intersection, call the
     * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     whose geometry intersects the provided extent.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     * @api
     */ VectorSource.prototype.forEachFeatureIntersectingExtent = function(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
         * @param {import("../Feature.js").default<Geometry>} feature Feature.
         * @return {T|undefined} The return value from the last call to the callback.
         */ function(feature) {
            var geometry = feature.getGeometry();
            if (geometry.intersectsExtent(extent)) {
                var result = callback(feature);
                if (result) return result;
            }
        });
    };
    /**
     * Get the features collection associated with this source. Will be `null`
     * unless the source was configured with `useSpatialIndex` set to `false`, or
     * with an {@link module:ol/Collection~Collection} as `features`.
     * @return {Collection<import("../Feature.js").default<Geometry>>|null} The collection of features.
     * @api
     */ VectorSource.prototype.getFeaturesCollection = function() {
        return this.featuresCollection_;
    };
    /**
     * Get a snapshot of the features currently on the source in random order. The returned array
     * is a copy, the features are references to the features in the source.
     * @return {Array<import("../Feature.js").default<Geometry>>} Features.
     * @api
     */ VectorSource.prototype.getFeatures = function() {
        var features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $9zTj4.isEmpty)(this.nullGeometryFeatures_)) (0, $kzmGH.extend)(features, (0, $9zTj4.getValues)(this.nullGeometryFeatures_));
        }
        return /** @type {Array<import("../Feature.js").default<Geometry>>} */ features;
    };
    /**
     * Get all features whose geometry intersects the provided coordinate.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {Array<import("../Feature.js").default<Geometry>>} Features.
     * @api
     */ VectorSource.prototype.getFeaturesAtCoordinate = function(coordinate) {
        var features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    };
    /**
     * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
     * all features intersecting the given extent in random order (so it may include
     * features whose geometries do not intersect the extent).
     *
     * When `useSpatialIndex` is set to false, this method will return all
     * features.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {import("../proj/Projection.js").default} [opt_projection] Include features
     * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
     * @return {Array<import("../Feature.js").default<Geometry>>} Features.
     * @api
     */ VectorSource.prototype.getFeaturesInExtent = function(extent, opt_projection) {
        var _this = this;
        if (this.featuresRtree_) {
            var multiWorld = opt_projection && opt_projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            var extents = (0, $2Jl0K.wrapAndSliceX)(extent, opt_projection);
            return [].concat.apply([], extents.map(function(anExtent) {
                return _this.featuresRtree_.getInExtent(anExtent);
            }));
        } else if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        else return [];
    };
    /**
     * Get the closest feature to the provided coordinate.
     *
     * This method is not available when the source is configured with
     * `useSpatialIndex` set to `false`.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {function(import("../Feature.js").default<Geometry>):boolean} [opt_filter] Feature filter function.
     *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
     *     and it should return a boolean value. By default, no filtering is made.
     * @return {import("../Feature.js").default<Geometry>} Closest feature.
     * @api
     */ VectorSource.prototype.getClosestFeatureToCoordinate = function(coordinate, opt_filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        var x = coordinate[0];
        var y = coordinate[1];
        var closestFeature = null;
        var closestPoint = [
            NaN,
            NaN
        ];
        var minSquaredDistance = Infinity;
        var extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        var filter = opt_filter ? opt_filter : (0, $c8IGo.TRUE);
        this.featuresRtree_.forEachInExtent(extent, /**
         * @param {import("../Feature.js").default<Geometry>} feature Feature.
         */ function(feature) {
            if (filter(feature)) {
                var geometry = feature.getGeometry();
                var previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    var minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    };
    /**
     * Get the extent of the features currently in the source.
     *
     * This method is not available when the source is configured with
     * `useSpatialIndex` set to `false`.
     * @param {import("../extent.js").Extent} [opt_extent] Destination extent. If provided, no new extent
     *     will be created. Instead, that extent's coordinates will be overwritten.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */ VectorSource.prototype.getExtent = function(opt_extent) {
        return this.featuresRtree_.getExtent(opt_extent);
    };
    /**
     * Get a feature by its identifier (the value returned by feature.getId()).
     * Note that the index treats string and numeric identifiers as the same.  So
     * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
     *
     * @param {string|number} id Feature identifier.
     * @return {import("../Feature.js").default<Geometry>|null} The feature (or `null` if not found).
     * @api
     */ VectorSource.prototype.getFeatureById = function(id) {
        var feature = this.idIndex_[id.toString()];
        return feature !== undefined ? feature : null;
    };
    /**
     * Get a feature by its internal unique identifier (using `getUid`).
     *
     * @param {string} uid Feature identifier.
     * @return {import("../Feature.js").default<Geometry>|null} The feature (or `null` if not found).
     */ VectorSource.prototype.getFeatureByUid = function(uid) {
        var feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    };
    /**
     * Get the format associated with this source.
     *
     * @return {import("../format/Feature.js").default|undefined} The feature format.
     * @api
     */ VectorSource.prototype.getFormat = function() {
        return this.format_;
    };
    /**
     * @return {boolean} The source can have overlapping geometries.
     */ VectorSource.prototype.getOverlaps = function() {
        return this.overlaps_;
    };
    /**
     * Get the url associated with this source.
     *
     * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
     * @api
     */ VectorSource.prototype.getUrl = function() {
        return this.url_;
    };
    /**
     * @param {Event} event Event.
     * @private
     */ VectorSource.prototype.handleFeatureChange_ = function(event) {
        var feature = /** @type {import("../Feature.js").default<Geometry>} */ event.target;
        var featureKey = (0, $61DUI.getUid)(feature);
        var geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            var extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        var id = feature.getId();
        if (id !== undefined) {
            var sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $39da9044499339fe$export$d402fd02dc2b661c((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    };
    /**
     * Returns true if the feature is contained within the source.
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @return {boolean} Has feature.
     * @api
     */ VectorSource.prototype.hasFeature = function(feature) {
        var id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        else return (0, $61DUI.getUid)(feature) in this.uidIndex_;
    };
    /**
     * @return {boolean} Is empty.
     */ VectorSource.prototype.isEmpty = function() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $9zTj4.isEmpty)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */ VectorSource.prototype.loadFeatures = function(extent, resolution, projection) {
        var loadedExtentsRtree = this.loadedExtentsRtree_;
        var extentsToLoad = this.strategy_(extent, resolution, projection);
        var _loop_1 = function(i, ii) {
            var extentToLoad = extentsToLoad[i];
            var alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
             * @param {{extent: import("../extent.js").Extent}} object Object.
             * @return {boolean} Contains.
             */ function(object) {
                return (0, $2Jl0K.containsExtent)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this_1.loadingExtentsCount_;
                this_1.dispatchEvent(new $39da9044499339fe$export$d402fd02dc2b661c((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).FEATURESLOADSTART));
                this_1.loader_.call(this_1, extentToLoad, resolution, projection, (function(features) {
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $39da9044499339fe$export$d402fd02dc2b661c((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                }).bind(this_1), (function() {
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $39da9044499339fe$export$d402fd02dc2b661c((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).FEATURESLOADERROR));
                }).bind(this_1));
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        };
        var this_1 = this;
        for(var i = 0, ii = extentsToLoad.length; i < ii; ++i)_loop_1(i, ii);
        this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
    };
    VectorSource.prototype.refresh = function() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        _super.prototype.refresh.call(this);
    };
    /**
     * Remove an extent from the list of loaded extents.
     * @param {import("../extent.js").Extent} extent Extent.
     * @api
     */ VectorSource.prototype.removeLoadedExtent = function(extent) {
        var loadedExtentsRtree = this.loadedExtentsRtree_;
        var obj;
        loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $2Jl0K.equals)(object.extent, extent)) {
                obj = object;
                return true;
            }
        });
        if (obj) loadedExtentsRtree.remove(obj);
    };
    /**
     * Remove a single feature from the source.  If you want to remove all features
     * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
     * instead.
     * @param {import("../Feature.js").default<Geometry>} feature Feature to remove.
     * @api
     */ VectorSource.prototype.removeFeature = function(feature) {
        if (!feature) return;
        var featureKey = (0, $61DUI.getUid)(feature);
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        var result = this.removeFeatureInternal(feature);
        if (result) this.changed();
    };
    /**
     * Remove feature without firing a `change` event.
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @return {import("../Feature.js").default<Geometry>|undefined} The removed feature
     *     (or undefined if the feature was not found).
     * @protected
     */ VectorSource.prototype.removeFeatureInternal = function(feature) {
        var featureKey = (0, $61DUI.getUid)(feature);
        var featureChangeKeys = this.featureChangeKeys_[featureKey];
        if (!featureChangeKeys) return;
        featureChangeKeys.forEach((0, $1dBX3.unlistenByKey));
        delete this.featureChangeKeys_[featureKey];
        var id = feature.getId();
        if (id !== undefined) delete this.idIndex_[id.toString()];
        delete this.uidIndex_[featureKey];
        this.dispatchEvent(new $39da9044499339fe$export$d402fd02dc2b661c((0, $35b3e5a26bc6bba7$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
        return feature;
    };
    /**
     * Remove a feature from the id index.  Called internally when the feature id
     * may have changed.
     * @param {import("../Feature.js").default<Geometry>} feature The feature.
     * @return {boolean} Removed the feature from the index.
     * @private
     */ VectorSource.prototype.removeFromIdIndex_ = function(feature) {
        var removed = false;
        for(var id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            removed = true;
            break;
        }
        return removed;
    };
    /**
     * Set the new loader of the source. The next render cycle will use the
     * new loader.
     * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
     * @api
     */ VectorSource.prototype.setLoader = function(loader) {
        this.loader_ = loader;
    };
    /**
     * Points the source to a new url. The next render cycle will use the new url.
     * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
     * @api
     */ VectorSource.prototype.setUrl = function(url) {
        (0, $3JLp3.assert)(this.format_, 7); // `format` must be set when `url` is set
        this.url_ = url;
        this.setLoader((0, $7038dca9b576390d$export$14cc81df70b6707e)(url, this.format_));
    };
    return VectorSource;
}((0, $1bd7756853fd0f39$export$2e2bcd8739ae039));
var $39da9044499339fe$export$2e2bcd8739ae039 = $39da9044499339fe$var$VectorSource;



var $827vD = parcelRequire("827vD");
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $852eb8a4e9d71200$export$2e2bcd8739ae039 = {
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};



var $9zTj4 = parcelRequire("9zTj4");
var $37e4dc0f78bbffaa$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:source'|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   'change:source'|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../PluggableMap.js").default#addLayer map.addLayer()}.
 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ var $37e4dc0f78bbffaa$var$BaseTileLayer = /** @class */ function(_super) {
    $37e4dc0f78bbffaa$var$__extends(BaseTileLayer, _super);
    /**
     * @param {Options<TileSourceType>} [opt_options] Tile layer options.
     */ function BaseTileLayer(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = (0, $9zTj4.assign)({}, options);
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        _this = _super.call(this, baseOptions) || this;
        /***
         * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
         */ _this.on;
        /***
         * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
         */ _this.once;
        /***
         * @type {BaseTileLayerOnSignature<void>}
         */ _this.un;
        _this.setPreload(options.preload !== undefined ? options.preload : 0);
        _this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
        return _this;
    }
    /**
     * Return the level as number to which we will preload tiles up to.
     * @return {number} The level to preload tiles up to.
     * @observable
     * @api
     */ BaseTileLayer.prototype.getPreload = function() {
        return /** @type {number} */ this.get((0, $852eb8a4e9d71200$export$2e2bcd8739ae039).PRELOAD);
    };
    /**
     * Set the level as number to which we will preload tiles up to.
     * @param {number} preload The level to preload tiles up to.
     * @observable
     * @api
     */ BaseTileLayer.prototype.setPreload = function(preload) {
        this.set((0, $852eb8a4e9d71200$export$2e2bcd8739ae039).PRELOAD, preload);
    };
    /**
     * Whether we use interim tiles on error.
     * @return {boolean} Use interim tiles on error.
     * @observable
     * @api
     */ BaseTileLayer.prototype.getUseInterimTilesOnError = function() {
        return /** @type {boolean} */ this.get((0, $852eb8a4e9d71200$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    };
    /**
     * Set whether we use interim tiles on error.
     * @param {boolean} useInterimTilesOnError Use interim tiles on error.
     * @observable
     * @api
     */ BaseTileLayer.prototype.setUseInterimTilesOnError = function(useInterimTilesOnError) {
        this.set((0, $852eb8a4e9d71200$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    };
    /**
     * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
     * a four element RGBA array will be returned.  For data tiles, the array length will match the
     * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
     * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
     *
     * ```js
     * // display layer data on every pointer move
     * map.on('pointermove', (event) => {
     *   console.log(layer.getData(event.pixel));
     * });
     * ```
     * @param {import("../pixel").Pixel} pixel Pixel.
     * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
     * @api
     */ BaseTileLayer.prototype.getData = function(pixel) {
        return _super.prototype.getData.call(this, pixel);
    };
    return BaseTileLayer;
}((0, $93a49300d1913509$export$2e2bcd8739ae039));
var $37e4dc0f78bbffaa$export$2e2bcd8739ae039 = $37e4dc0f78bbffaa$var$BaseTileLayer;



var $cFmyb = parcelRequire("cFmyb");


var $gpPIU = parcelRequire("gpPIU");

var $61DUI = parcelRequire("61DUI");
var $7851de07dc18f386$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ var $7851de07dc18f386$var$LayerRenderer = /** @class */ function(_super) {
    $7851de07dc18f386$var$__extends(LayerRenderer, _super);
    /**
     * @param {LayerType} layer Layer.
     */ function LayerRenderer(layer) {
        var _this = _super.call(this) || this;
        /**
         * The renderer is initialized and ready to render.
         * @type {boolean}
         */ _this.ready = true;
        /** @private */ _this.boundHandleImageChange_ = _this.handleImageChange_.bind(_this);
        /**
         * @protected
         * @type {LayerType}
         */ _this.layer_ = layer;
        /**
         * @type {import("../render/canvas/ExecutorGroup").default}
         */ _this.declutterExecutorGroup = null;
        return _this;
    }
    /**
     * Asynchronous layer level hit detection.
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with
     * an array of features.
     */ LayerRenderer.prototype.getFeatures = function(pixel) {
        return (0, $61DUI.abstract)();
    };
    /**
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
     */ LayerRenderer.prototype.getData = function(pixel) {
        return null;
    };
    /**
     * Determine whether render should be called.
     * @abstract
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */ LayerRenderer.prototype.prepareFrame = function(frameState) {
        return (0, $61DUI.abstract)();
    };
    /**
     * Render the layer.
     * @abstract
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */ LayerRenderer.prototype.renderFrame = function(frameState, target) {
        return (0, $61DUI.abstract)();
    };
    /**
     * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
     * @param {number} zoom Zoom level.
     * @param {import("../Tile.js").default} tile Tile.
     * @return {boolean|void} If `false`, the tile will not be considered loaded.
     */ LayerRenderer.prototype.loadedTileCallback = function(tiles, zoom, tile) {
        if (!tiles[zoom]) tiles[zoom] = {};
        tiles[zoom][tile.tileCoord.toString()] = tile;
        return undefined;
    };
    /**
     * Create a function that adds loaded tiles to the tile lookup.
     * @param {import("../source/Tile.js").default} source Tile source.
     * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
     * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
     * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
     *     called with a zoom level and a tile range to add loaded tiles to the lookup.
     * @protected
     */ LayerRenderer.prototype.createLoadedTileFinder = function(source, projection, tiles) {
        return(/**
         * @param {number} zoom Zoom level.
         * @param {import("../TileRange.js").default} tileRange Tile range.
         * @return {boolean} The tile range is fully loaded.
         * @this {LayerRenderer}
         */ (function(zoom, tileRange) {
            var callback = this.loadedTileCallback.bind(this, tiles, zoom);
            return source.forEachLoadedTile(projection, zoom, tileRange, callback);
        }).bind(this));
    };
    /**
     * @abstract
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */ LayerRenderer.prototype.forEachFeatureAtCoordinate = function(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    };
    /**
     * @abstract
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @return {Uint8ClampedArray|Uint8Array} The result.  If there is no data at the pixel
     *    location, null will be returned.  If there is data, but pixel values cannot be
     *    returned, and empty array will be returned.
     */ LayerRenderer.prototype.getDataAtPixel = function(pixel, frameState, hitTolerance) {
        return null;
    };
    /**
     * @return {LayerType} Layer.
     */ LayerRenderer.prototype.getLayer = function() {
        return this.layer_;
    };
    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     * @abstract
     */ LayerRenderer.prototype.handleFontsChanged = function() {};
    /**
     * Handle changes in image state.
     * @param {import("../events/Event.js").default} event Image change event.
     * @private
     */ LayerRenderer.prototype.handleImageChange_ = function(event) {
        var image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED) this.renderIfReadyAndVisible();
    };
    /**
     * Load the image if not already loaded, and register the image change
     * listener if needed.
     * @param {import("../ImageBase.js").default} image Image.
     * @return {boolean} `true` if the image is already loaded, `false` otherwise.
     * @protected
     */ LayerRenderer.prototype.loadImage = function(image) {
        var imageState = image.getState();
        if (imageState != (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED && imageState != (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $cFmyb.default).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED;
    };
    /**
     * @protected
     */ LayerRenderer.prototype.renderIfReadyAndVisible = function() {
        var layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === 'ready') layer.changed();
    };
    /**
     * Clean up.
     */ LayerRenderer.prototype.disposeInternal = function() {
        delete this.layer_;
        _super.prototype.disposeInternal.call(this);
    };
    return LayerRenderer;
}((0, $gpPIU.default));
var $7851de07dc18f386$export$2e2bcd8739ae039 = $7851de07dc18f386$var$LayerRenderer;







var $2Jl0K = parcelRequire("2Jl0K");

var $djuby = parcelRequire("djuby");

var $kzmGH = parcelRequire("kzmGH");
var $a8a7c34c558b8e6f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a8a7c34c558b8e6f$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D}
 */ var $a8a7c34c558b8e6f$var$pixelContext = null;
function $a8a7c34c558b8e6f$var$createPixelContext() {
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    $a8a7c34c558b8e6f$var$pixelContext = canvas.getContext('2d');
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ var $a8a7c34c558b8e6f$var$CanvasLayerRenderer = /** @class */ function(_super) {
    $a8a7c34c558b8e6f$var$__extends(CanvasLayerRenderer, _super);
    /**
     * @param {LayerType} layer Layer.
     */ function CanvasLayerRenderer(layer) {
        var _this = _super.call(this, layer) || this;
        /**
         * @protected
         * @type {HTMLElement}
         */ _this.container = null;
        /**
         * @protected
         * @type {number}
         */ _this.renderedResolution;
        /**
         * A temporary transform.  The values in this transform should only be used in a
         * function that sets the values.
         * @protected
         * @type {import("../../transform.js").Transform}
         */ _this.tempTransform = (0, $04c1ab69f17a669b$export$185802fd694ee1f5)();
        /**
         * The transform for rendered pixels to viewport CSS pixels.  This transform must
         * be set when rendering a frame and may be used by other functions after rendering.
         * @protected
         * @type {import("../../transform.js").Transform}
         */ _this.pixelTransform = (0, $04c1ab69f17a669b$export$185802fd694ee1f5)();
        /**
         * The transform for viewport CSS pixels to rendered pixels.  This transform must
         * be set when rendering a frame and may be used by other functions after rendering.
         * @protected
         * @type {import("../../transform.js").Transform}
         */ _this.inversePixelTransform = (0, $04c1ab69f17a669b$export$185802fd694ee1f5)();
        /**
         * @type {CanvasRenderingContext2D}
         */ _this.context = null;
        /**
         * @type {boolean}
         */ _this.containerReused = false;
        /**
         * @private
         * @type {CanvasRenderingContext2D}
         */ _this.pixelContext_ = null;
        /**
         * @protected
         * @type {import("../../PluggableMap.js").FrameState|null}
         */ _this.frameState = null;
        return _this;
    }
    /**
     * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image.
     * @param {number} col The column index.
     * @param {number} row The row index.
     * @return {Uint8ClampedArray|null} The image data.
     */ CanvasLayerRenderer.prototype.getImageData = function(image, col, row) {
        if (!$a8a7c34c558b8e6f$var$pixelContext) $a8a7c34c558b8e6f$var$createPixelContext();
        $a8a7c34c558b8e6f$var$pixelContext.clearRect(0, 0, 1, 1);
        var data;
        try {
            $a8a7c34c558b8e6f$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $a8a7c34c558b8e6f$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch (err) {
            $a8a7c34c558b8e6f$var$pixelContext = null;
            return null;
        }
        return data;
    };
    /**
     * @param {import('../../PluggableMap.js').FrameState} frameState Frame state.
     * @return {string} Background color.
     */ CanvasLayerRenderer.prototype.getBackground = function(frameState) {
        var layer = this.getLayer();
        var background = layer.getBackground();
        if (typeof background === 'function') background = background(frameState.viewState.resolution);
        return background || undefined;
    };
    /**
     * Get a rendering container from an existing target, if compatible.
     * @param {HTMLElement} target Potential render target.
     * @param {string} transform CSS Transform.
     * @param {string} [opt_backgroundColor] Background color.
     */ CanvasLayerRenderer.prototype.useContainer = function(target, transform, opt_backgroundColor) {
        var layerClassName = this.getLayer().getClassName();
        var container, context;
        if (target && target.className === layerClassName && (!opt_backgroundColor || target && target.style.backgroundColor && (0, $kzmGH.equals)((0, $520f75f61db85ab0$export$75093a47a9fa838d)(target.style.backgroundColor), (0, $520f75f61db85ab0$export$75093a47a9fa838d)(opt_backgroundColor)))) {
            var canvas = target.firstElementChild;
            if (canvas instanceof HTMLCanvasElement) context = canvas.getContext('2d');
        }
        if (context && context.canvas.style.transform === transform) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        }
        if (!this.container) {
            container = document.createElement('div');
            container.className = layerClassName;
            var style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = (0, $djuby.createCanvasContext2D)();
            var canvas = context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && opt_backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = opt_backgroundColor;
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../extent.js").Extent} extent Clip extent.
     * @protected
     */ CanvasLayerRenderer.prototype.clipUnrotated = function(context, frameState, extent) {
        var topLeft = (0, $2Jl0K.getTopLeft)(extent);
        var topRight = (0, $2Jl0K.getTopRight)(extent);
        var bottomRight = (0, $2Jl0K.getBottomRight)(extent);
        var bottomLeft = (0, $2Jl0K.getBottomLeft)(extent);
        (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        var inverted = this.inversePixelTransform;
        (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(inverted, topLeft);
        (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(inverted, topRight);
        (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(inverted, bottomRight);
        (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    };
    /**
     * @param {import("../../render/EventType.js").default} type Event type.
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @private
     */ CanvasLayerRenderer.prototype.dispatchRenderEvent_ = function(type, context, frameState) {
        var layer = this.getLayer();
        if (layer.hasListener(type)) {
            var event_1 = new (0, $2c154b5b5f327c1b$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event_1);
        }
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */ CanvasLayerRenderer.prototype.preRender = function(context, frameState) {
        this.frameState = frameState;
        this.dispatchRenderEvent_((0, $91e6c6ef4a46bd39$export$2e2bcd8739ae039).PRERENDER, context, frameState);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */ CanvasLayerRenderer.prototype.postRender = function(context, frameState) {
        this.dispatchRenderEvent_((0, $91e6c6ef4a46bd39$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
    };
    /**
     * Creates a transform for rendering to an element that will be rotated after rendering.
     * @param {import("../../coordinate.js").Coordinate} center Center.
     * @param {number} resolution Resolution.
     * @param {number} rotation Rotation.
     * @param {number} pixelRatio Pixel ratio.
     * @param {number} width Width of the rendered element (in pixels).
     * @param {number} height Height of the rendered element (in pixels).
     * @param {number} offsetX Offset on the x-axis in view coordinates.
     * @protected
     * @return {!import("../../transform.js").Transform} Transform.
     */ CanvasLayerRenderer.prototype.getRenderTransform = function(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        var dx1 = width / 2;
        var dy1 = height / 2;
        var sx = pixelRatio / resolution;
        var sy = -sx;
        var dx2 = -center[0] + offsetX;
        var dy2 = -center[1];
        return (0, $04c1ab69f17a669b$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    };
    /**
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @param {import("../../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @return {Uint8ClampedArray|Uint8Array} The result.  If there is no data at the pixel
     *    location, null will be returned.  If there is data, but pixel values cannot be
     *    returned, and empty array will be returned.
     */ CanvasLayerRenderer.prototype.getDataAtPixel = function(pixel, frameState, hitTolerance) {
        var renderPixel = (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(this.inversePixelTransform, pixel.slice());
        var context = this.context;
        var layer = this.getLayer();
        var layerExtent = layer.getExtent();
        if (layerExtent) {
            var renderCoordinate = (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
            /** get only data inside of the layer extent */ if (!(0, $2Jl0K.containsCoordinate)(layerExtent, renderCoordinate)) return null;
        }
        var x = Math.round(renderPixel[0]);
        var y = Math.round(renderPixel[1]);
        var pixelContext = this.pixelContext_;
        if (!pixelContext) {
            var pixelCanvas = document.createElement('canvas');
            pixelCanvas.width = 1;
            pixelCanvas.height = 1;
            pixelContext = pixelCanvas.getContext('2d');
            this.pixelContext_ = pixelContext;
        }
        pixelContext.clearRect(0, 0, 1, 1);
        var data;
        try {
            pixelContext.drawImage(context.canvas, x, y, 1, 1, 0, 0, 1, 1);
            data = pixelContext.getImageData(0, 0, 1, 1).data;
        } catch (err) {
            if (err.name === 'SecurityError') {
                // tainted canvas, we assume there is data at the given pixel (although there might not be)
                this.pixelContext_ = null;
                return new Uint8Array();
            }
            return data;
        }
        if (data[3] === 0) return null;
        return data;
    };
    /**
     * Clean up.
     */ CanvasLayerRenderer.prototype.disposeInternal = function() {
        delete this.frameState;
        _super.prototype.disposeInternal.call(this);
    };
    return CanvasLayerRenderer;
}((0, $7851de07dc18f386$export$2e2bcd8739ae039));
var $a8a7c34c558b8e6f$export$2e2bcd8739ae039 = $a8a7c34c558b8e6f$var$CanvasLayerRenderer;









var $9zTj4 = parcelRequire("9zTj4");

var $2Jl0K = parcelRequire("2Jl0K");


var $61DUI = parcelRequire("61DUI");

var $kzmGH = parcelRequire("kzmGH");

var $f3e6d3682ddafc95$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ var $f3e6d3682ddafc95$var$CanvasTileLayerRenderer = /** @class */ function(_super) {
    $f3e6d3682ddafc95$var$__extends(CanvasTileLayerRenderer, _super);
    /**
     * @param {LayerType} tileLayer Tile layer.
     */ function CanvasTileLayerRenderer(tileLayer) {
        var _this = _super.call(this, tileLayer) || this;
        /**
         * Rendered extent has changed since the previous `renderFrame()` call
         * @type {boolean}
         */ _this.extentChanged = true;
        /**
         * @private
         * @type {?import("../../extent.js").Extent}
         */ _this.renderedExtent_ = null;
        /**
         * @protected
         * @type {number}
         */ _this.renderedPixelRatio;
        /**
         * @protected
         * @type {import("../../proj/Projection.js").default}
         */ _this.renderedProjection = null;
        /**
         * @protected
         * @type {number}
         */ _this.renderedRevision;
        /**
         * @protected
         * @type {!Array<import("../../Tile.js").default>}
         */ _this.renderedTiles = [];
        /**
         * @private
         * @type {boolean}
         */ _this.newTiles_ = false;
        /**
         * @protected
         * @type {import("../../extent.js").Extent}
         */ _this.tmpExtent = (0, $2Jl0K.createEmpty)();
        /**
         * @private
         * @type {import("../../TileRange.js").default}
         */ _this.tmpTileRange_ = new (0, $58f9ac1efbf3c5ef$export$2e2bcd8739ae039)(0, 0, 0, 0);
        return _this;
    }
    /**
     * @protected
     * @param {import("../../Tile.js").default} tile Tile.
     * @return {boolean} Tile is drawable.
     */ CanvasTileLayerRenderer.prototype.isDrawableTile = function(tile) {
        var tileLayer = this.getLayer();
        var tileState = tile.getState();
        var useInterimTilesOnError = tileLayer.getUseInterimTilesOnError();
        return tileState == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED || tileState == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).EMPTY || tileState == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).ERROR && !useInterimTilesOnError;
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {!import("../../Tile.js").default} Tile.
     */ CanvasTileLayerRenderer.prototype.getTile = function(z, x, y, frameState) {
        var pixelRatio = frameState.pixelRatio;
        var projection = frameState.viewState.projection;
        var tileLayer = this.getLayer();
        var tileSource = tileLayer.getSource();
        var tile = tileSource.getTile(z, x, y, pixelRatio, projection);
        if (tile.getState() == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).ERROR) {
            if (!tileLayer.getUseInterimTilesOnError()) // When useInterimTilesOnError is false, we consider the error tile as loaded.
            tile.setState((0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED);
            else if (tileLayer.getPreload() > 0) // Preloaded tiles for lower resolutions might have finished loading.
            this.newTiles_ = true;
        }
        if (!this.isDrawableTile(tile)) tile = tile.getInterimTile();
        return tile;
    };
    /**
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @return {Uint8ClampedArray} Data at the pixel location.
     */ CanvasTileLayerRenderer.prototype.getData = function(pixel) {
        var frameState = this.frameState;
        if (!frameState) return null;
        var layer = this.getLayer();
        var coordinate = (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        var layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $2Jl0K.containsCoordinate)(layerExtent, coordinate)) return null;
        }
        var pixelRatio = frameState.pixelRatio;
        var projection = frameState.viewState.projection;
        var viewState = frameState.viewState;
        var source = layer.getRenderSource();
        var tileGrid = source.getTileGridForProjection(viewState.projection);
        var tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(var z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            var tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            var tile = source.getTile(z, tileCoord[1], tileCoord[2], pixelRatio, projection);
            if (!(tile instanceof (0, $101762da51c85679$export$2e2bcd8739ae039) || tile instanceof (0, $c0536ebcb9f53884$export$2e2bcd8739ae039))) return null;
            if (tile.getState() !== (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED) continue;
            var tileOrigin = tileGrid.getOrigin(z);
            var tileSize = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z));
            var tileResolution = tileGrid.getResolution(z);
            var col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            var row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            var gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(tile.getImage(), col + gutter, row + gutter);
        }
        return null;
    };
    /**
     * @param {Object<number, Object<string, import("../../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
     * @param {number} zoom Zoom level.
     * @param {import("../../Tile.js").default} tile Tile.
     * @return {boolean|void} If `false`, the tile will not be considered loaded.
     */ CanvasTileLayerRenderer.prototype.loadedTileCallback = function(tiles, zoom, tile) {
        if (this.isDrawableTile(tile)) return _super.prototype.loadedTileCallback.call(this, tiles, zoom, tile);
        return false;
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */ CanvasTileLayerRenderer.prototype.prepareFrame = function(frameState) {
        return !!this.getLayer().getSource();
    };
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */ CanvasTileLayerRenderer.prototype.renderFrame = function(frameState, target) {
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var viewResolution = viewState.resolution;
        var viewCenter = viewState.center;
        var rotation = viewState.rotation;
        var pixelRatio = frameState.pixelRatio;
        var tileLayer = this.getLayer();
        var tileSource = tileLayer.getSource();
        var sourceRevision = tileSource.getRevision();
        var tileGrid = tileSource.getTileGridForProjection(projection);
        var z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        var tileResolution = tileGrid.getResolution(z);
        var extent = frameState.extent;
        var resolution = frameState.viewState.resolution;
        var tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        // desired dimensions of the canvas in pixels
        var width = Math.round((0, $2Jl0K.getWidth)(extent) / resolution * pixelRatio);
        var height = Math.round((0, $2Jl0K.getHeight)(extent) / resolution * pixelRatio);
        var layerExtent = layerState.extent && (0, $d3bc250abc15fbce$export$494be3a3a25689ca)(layerState.extent, projection);
        if (layerExtent) extent = (0, $2Jl0K.getIntersection)(extent, (0, $d3bc250abc15fbce$export$494be3a3a25689ca)(layerState.extent, projection));
        var dx = tileResolution * width / 2 / tilePixelRatio;
        var dy = tileResolution * height / 2 / tilePixelRatio;
        var canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
        /**
         * @type {Object<number, Object<string, import("../../Tile.js").default>>}
         */ var tilesToDrawByZ = {};
        tilesToDrawByZ[z] = {};
        var findLoadedTiles = this.createLoadedTileFinder(tileSource, projection, tilesToDrawByZ);
        var tmpExtent = this.tmpExtent;
        var tmpTileRange = this.tmpTileRange_;
        this.newTiles_ = false;
        var viewport = rotation ? (0, $2Jl0K.getRotatedViewport)(viewState.center, resolution, rotation, frameState.size) : undefined;
        for(var x = tileRange.minX; x <= tileRange.maxX; ++x)for(var y = tileRange.minY; y <= tileRange.maxY; ++y){
            if (rotation && !tileGrid.tileCoordIntersectsViewport([
                z,
                x,
                y
            ], viewport)) continue;
            var tile = this.getTile(z, x, y, frameState);
            if (this.isDrawableTile(tile)) {
                var uid = (0, $61DUI.getUid)(this);
                if (tile.getState() == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).LOADED) {
                    tilesToDrawByZ[z][tile.tileCoord.toString()] = tile;
                    var inTransition = tile.inTransition(uid);
                    if (inTransition && layerState.opacity !== 1) {
                        // Skipping transition when layer is not fully opaque avoids visual artifacts.
                        tile.endTransition(uid);
                        inTransition = false;
                    }
                    if (!this.newTiles_ && (inTransition || this.renderedTiles.indexOf(tile) === -1)) this.newTiles_ = true;
                }
                if (tile.getAlpha(uid, frameState.time) === 1) continue;
            }
            var childTileRange = tileGrid.getTileCoordChildTileRange(tile.tileCoord, tmpTileRange, tmpExtent);
            var covered = false;
            if (childTileRange) covered = findLoadedTiles(z + 1, childTileRange);
            if (!covered) tileGrid.forEachTileCoordParentTileRange(tile.tileCoord, findLoadedTiles, tmpTileRange, tmpExtent);
        }
        var canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        // set forward and inverse pixel transforms
        (0, $04c1ab69f17a669b$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        var canvasTransform = (0, $04c1ab69f17a669b$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        var context = this.context;
        var canvas = context.canvas;
        (0, $04c1ab69f17a669b$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        // set scale transform for calculating tile positions on the canvas
        (0, $04c1ab69f17a669b$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (canvas.width != width || canvas.height != height) {
            canvas.width = width;
            canvas.height = height;
        } else if (!this.containerReused) context.clearRect(0, 0, width, height);
        if (layerExtent) this.clipUnrotated(context, frameState, layerExtent);
        if (!tileSource.getInterpolate()) (0, $9zTj4.assign)(context, (0, $9ef11b9472017ba4$export$ab6c91696bd3263e));
        this.preRender(context, frameState);
        this.renderedTiles.length = 0;
        /** @type {Array<number>} */ var zs = Object.keys(tilesToDrawByZ).map(Number);
        zs.sort((0, $kzmGH.numberSafeCompareFunction));
        var clips, clipZs, currentClip;
        if (layerState.opacity === 1 && (!this.containerReused || tileSource.getOpaque(frameState.viewState.projection))) zs = zs.reverse();
        else {
            clips = [];
            clipZs = [];
        }
        for(var i = zs.length - 1; i >= 0; --i){
            var currentZ = zs[i];
            var currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            var currentResolution = tileGrid.getResolution(currentZ);
            var currentScale = currentResolution / tileResolution;
            var dx_1 = currentTilePixelSize[0] * currentScale * canvasScale;
            var dy_1 = currentTilePixelSize[1] * currentScale * canvasScale;
            var originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $2Jl0K.getTopLeft)(canvasExtent), currentZ);
            var originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            var origin_1 = (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            var tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            var tilesToDraw = tilesToDrawByZ[currentZ];
            for(var tileCoordKey in tilesToDraw){
                var tile = /** @type {import("../../ImageTile.js").default} */ tilesToDraw[tileCoordKey];
                var tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                var xIndex = originTileCoord[1] - tileCoord[1];
                var nextX = Math.round(origin_1[0] - (xIndex - 1) * dx_1);
                var yIndex = originTileCoord[2] - tileCoord[2];
                var nextY = Math.round(origin_1[1] - (yIndex - 1) * dy_1);
                var x = Math.round(origin_1[0] - xIndex * dx_1);
                var y = Math.round(origin_1[1] - yIndex * dy_1);
                var w = nextX - x;
                var h = nextY - y;
                var transition = z === currentZ;
                var inTransition = transition && tile.getAlpha((0, $61DUI.getUid)(this), frameState.time) !== 1;
                var contextSaved = false;
                if (!inTransition) {
                    if (clips) {
                        // Clip mask for regions in this tile that already filled by a higher z tile
                        currentClip = [
                            x,
                            y,
                            x + w,
                            y,
                            x + w,
                            y + h,
                            x,
                            y + h
                        ];
                        for(var i_1 = 0, ii = clips.length; i_1 < ii; ++i_1)if (z !== currentZ && currentZ < clipZs[i_1]) {
                            var clip = clips[i_1];
                            if ((0, $2Jl0K.intersects)([
                                x,
                                y,
                                x + w,
                                y + h
                            ], [
                                clip[0],
                                clip[3],
                                clip[4],
                                clip[7]
                            ])) {
                                if (!contextSaved) {
                                    context.save();
                                    contextSaved = true;
                                }
                                context.beginPath();
                                // counter-clockwise (outer ring) for current tile
                                context.moveTo(currentClip[0], currentClip[1]);
                                context.lineTo(currentClip[2], currentClip[3]);
                                context.lineTo(currentClip[4], currentClip[5]);
                                context.lineTo(currentClip[6], currentClip[7]);
                                // clockwise (inner ring) for higher z tile
                                context.moveTo(clip[6], clip[7]);
                                context.lineTo(clip[4], clip[5]);
                                context.lineTo(clip[2], clip[3]);
                                context.lineTo(clip[0], clip[1]);
                                context.clip();
                            }
                        }
                        clips.push(currentClip);
                        clipZs.push(currentZ);
                    } else context.clearRect(x, y, w, h);
                }
                this.drawTileImage(tile, frameState, x, y, w, h, tileGutter, transition);
                if (clips && !inTransition) {
                    if (contextSaved) context.restore();
                    this.renderedTiles.unshift(tile);
                } else this.renderedTiles.push(tile);
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedRevision = sourceRevision;
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $2Jl0K.equals)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.renderedProjection = projection;
        this.manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, z, tileLayer.getPreload());
        this.scheduleExpireCache(frameState, tileSource);
        this.postRender(context, frameState);
        if (layerState.extent) context.restore();
        (0, $9zTj4.assign)(context, (0, $9ef11b9472017ba4$export$75f39f0ce198f93f));
        if (canvasTransform !== canvas.style.transform) canvas.style.transform = canvasTransform;
        return this.container;
    };
    /**
     * @param {import("../../ImageTile.js").default} tile Tile.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} x Left of the tile.
     * @param {number} y Top of the tile.
     * @param {number} w Width of the tile.
     * @param {number} h Height of the tile.
     * @param {number} gutter Tile gutter.
     * @param {boolean} transition Apply an alpha transition.
     */ CanvasTileLayerRenderer.prototype.drawTileImage = function(tile, frameState, x, y, w, h, gutter, transition) {
        var image = this.getTileImage(tile);
        if (!image) return;
        var uid = (0, $61DUI.getUid)(this);
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        var alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        var alphaChanged = alpha !== this.context.globalAlpha;
        if (alphaChanged) {
            this.context.save();
            this.context.globalAlpha = alpha;
        }
        this.context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) this.context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    };
    /**
     * @return {HTMLCanvasElement} Image
     */ CanvasTileLayerRenderer.prototype.getImage = function() {
        var context = this.context;
        return context ? context.canvas : null;
    };
    /**
     * Get the image from a tile.
     * @param {import("../../ImageTile.js").default} tile Tile.
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @protected
     */ CanvasTileLayerRenderer.prototype.getTileImage = function(tile) {
        return tile.getImage();
    };
    /**
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @protected
     */ CanvasTileLayerRenderer.prototype.scheduleExpireCache = function(frameState, tileSource) {
        if (tileSource.canExpireCache()) {
            /**
             * @param {import("../../source/Tile.js").default} tileSource Tile source.
             * @param {import("../../PluggableMap.js").default} map Map.
             * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
             */ var postRenderFunction = (function(tileSource, map, frameState) {
                var tileSourceKey = (0, $61DUI.getUid)(tileSource);
                if (tileSourceKey in frameState.usedTiles) tileSource.expireCache(frameState.viewState.projection, frameState.usedTiles[tileSourceKey]);
            }).bind(null, tileSource);
            frameState.postRenderFunctions.push(/** @type {import("../../PluggableMap.js").PostRenderFunction} */ postRenderFunction);
        }
    };
    /**
     * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @param {import('../../Tile.js').default} tile Tile.
     * @protected
     */ CanvasTileLayerRenderer.prototype.updateUsedTiles = function(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        var tileSourceKey = (0, $61DUI.getUid)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    };
    /**
     * Manage tile pyramid.
     * This function performs a number of functions related to the tiles at the
     * current zoom and lower zoom levels:
     * - registers idle tiles in frameState.wantedTiles so that they are not
     *   discarded by the tile queue
     * - enqueues missing tiles
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @param {import("../../tilegrid/TileGrid.js").default} tileGrid Tile grid.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../../proj/Projection.js").default} projection Projection.
     * @param {import("../../extent.js").Extent} extent Extent.
     * @param {number} currentZ Current Z.
     * @param {number} preload Load low resolution tiles up to `preload` levels.
     * @param {function(import("../../Tile.js").default):void} [opt_tileCallback] Tile callback.
     * @protected
     */ CanvasTileLayerRenderer.prototype.manageTilePyramid = function(frameState, tileSource, tileGrid, pixelRatio, projection, extent, currentZ, preload, opt_tileCallback) {
        var tileSourceKey = (0, $61DUI.getUid)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        var wantedTiles = frameState.wantedTiles[tileSourceKey];
        var tileQueue = frameState.tileQueue;
        var minZoom = tileGrid.getMinZoom();
        var rotation = frameState.viewState.rotation;
        var viewport = rotation ? (0, $2Jl0K.getRotatedViewport)(frameState.viewState.center, frameState.viewState.resolution, rotation, frameState.size) : undefined;
        var tileCount = 0;
        var tile, tileRange, tileResolution, x, y, z;
        for(z = minZoom; z <= currentZ; ++z){
            tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
            tileResolution = tileGrid.getResolution(z);
            for(x = tileRange.minX; x <= tileRange.maxX; ++x)for(y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                if (currentZ - z <= preload) {
                    ++tileCount;
                    tile = tileSource.getTile(z, x, y, pixelRatio, projection);
                    if (tile.getState() == (0, $b662dbd74afc801f$export$2e2bcd8739ae039).IDLE) {
                        wantedTiles[tile.getKey()] = true;
                        if (!tileQueue.isKeyQueued(tile.getKey())) tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tile.tileCoord),
                            tileResolution
                        ]);
                    }
                    if (opt_tileCallback !== undefined) opt_tileCallback(tile);
                } else tileSource.useTile(z, x, y, projection);
            }
        }
        tileSource.updateCacheSize(tileCount, projection);
    };
    return CanvasTileLayerRenderer;
}((0, $a8a7c34c558b8e6f$export$2e2bcd8739ae039));
var $f3e6d3682ddafc95$export$2e2bcd8739ae039 = $f3e6d3682ddafc95$var$CanvasTileLayerRenderer;


var $48eb5b5cbbaa3e86$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ var $48eb5b5cbbaa3e86$var$TileLayer = /** @class */ function(_super) {
    $48eb5b5cbbaa3e86$var$__extends(TileLayer, _super);
    /**
     * @param {import("./BaseTile.js").Options<TileSourceType>} [opt_options] Tile layer options.
     */ function TileLayer(opt_options) {
        return _super.call(this, opt_options) || this;
    }
    TileLayer.prototype.createRenderer = function() {
        return new (0, $f3e6d3682ddafc95$export$2e2bcd8739ae039)(this);
    };
    return TileLayer;
}((0, $37e4dc0f78bbffaa$export$2e2bcd8739ae039));
var $48eb5b5cbbaa3e86$export$2e2bcd8739ae039 = $48eb5b5cbbaa3e86$var$TileLayer;




var $9zTj4 = parcelRequire("9zTj4");
/**
 * @module ol/style/Style
 */ /**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ 
/**
 * @module ol/style/Image
 */ 
var $61DUI = parcelRequire("61DUI");

/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {"declutter"|"obstacle"|"none"|undefined} declutterMode Declutter mode: `declutter`, `obstacle`, 'none */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ var $dc2b88278baca076$var$ImageStyle = /** @class */ function() {
    /**
     * @param {Options} options Options.
     */ function ImageStyle(options) {
        /**
         * @private
         * @type {number}
         */ this.opacity_ = options.opacity;
        /**
         * @private
         * @type {boolean}
         */ this.rotateWithView_ = options.rotateWithView;
        /**
         * @private
         * @type {number}
         */ this.rotation_ = options.rotation;
        /**
         * @private
         * @type {number|import("../size.js").Size}
         */ this.scale_ = options.scale;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ this.scaleArray_ = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(options.scale);
        /**
         * @private
         * @type {Array<number>}
         */ this.displacement_ = options.displacement;
        /**
         * @private
         * @type {"declutter"|"obstacle"|"none"|undefined}
         */ this.declutterMode_ = options.declutterMode;
    }
    /**
     * Clones the style.
     * @return {ImageStyle} The cloned style.
     * @api
     */ ImageStyle.prototype.clone = function() {
        var scale = this.getScale();
        return new ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    };
    /**
     * Get the symbolizer opacity.
     * @return {number} Opacity.
     * @api
     */ ImageStyle.prototype.getOpacity = function() {
        return this.opacity_;
    };
    /**
     * Determine whether the symbolizer rotates with the map.
     * @return {boolean} Rotate with map.
     * @api
     */ ImageStyle.prototype.getRotateWithView = function() {
        return this.rotateWithView_;
    };
    /**
     * Get the symoblizer rotation.
     * @return {number} Rotation.
     * @api
     */ ImageStyle.prototype.getRotation = function() {
        return this.rotation_;
    };
    /**
     * Get the symbolizer scale.
     * @return {number|import("../size.js").Size} Scale.
     * @api
     */ ImageStyle.prototype.getScale = function() {
        return this.scale_;
    };
    /**
     * Get the symbolizer scale array.
     * @return {import("../size.js").Size} Scale array.
     */ ImageStyle.prototype.getScaleArray = function() {
        return this.scaleArray_;
    };
    /**
     * Get the displacement of the shape
     * @return {Array<number>} Shape's center displacement
     * @api
     */ ImageStyle.prototype.getDisplacement = function() {
        return this.displacement_;
    };
    /**
     * Get the declutter mode of the shape
     * @return {"declutter"|"obstacle"|"none"|undefined} Shape's declutter mode
     * @api
     */ ImageStyle.prototype.getDeclutterMode = function() {
        return this.declutterMode_;
    };
    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @abstract
     * @return {Array<number>} Anchor.
     */ ImageStyle.prototype.getAnchor = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * Get the image element for the symbolizer.
     * @abstract
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
     */ ImageStyle.prototype.getImage = function(pixelRatio) {
        return (0, $61DUI.abstract)();
    };
    /**
     * @abstract
     * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
     */ ImageStyle.prototype.getHitDetectionImage = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * Get the image pixel ratio.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Pixel ratio.
     */ ImageStyle.prototype.getPixelRatio = function(pixelRatio) {
        return 1;
    };
    /**
     * @abstract
     * @return {import("../ImageState.js").default} Image state.
     */ ImageStyle.prototype.getImageState = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * @abstract
     * @return {import("../size.js").Size} Image size.
     */ ImageStyle.prototype.getImageSize = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * Get the origin of the symbolizer.
     * @abstract
     * @return {Array<number>} Origin.
     */ ImageStyle.prototype.getOrigin = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * Get the size of the symbolizer (in pixels).
     * @abstract
     * @return {import("../size.js").Size} Size.
     */ ImageStyle.prototype.getSize = function() {
        return (0, $61DUI.abstract)();
    };
    /**
     * Set the displacement.
     *
     * @param {Array<number>} displacement Displacement.
     * @api
     */ ImageStyle.prototype.setDisplacement = function(displacement) {
        this.displacement_ = displacement;
    };
    /**
     * Set the opacity.
     *
     * @param {number} opacity Opacity.
     * @api
     */ ImageStyle.prototype.setOpacity = function(opacity) {
        this.opacity_ = opacity;
    };
    /**
     * Set whether to rotate the style with the view.
     *
     * @param {boolean} rotateWithView Rotate with map.
     * @api
     */ ImageStyle.prototype.setRotateWithView = function(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    };
    /**
     * Set the rotation.
     *
     * @param {number} rotation Rotation.
     * @api
     */ ImageStyle.prototype.setRotation = function(rotation) {
        this.rotation_ = rotation;
    };
    /**
     * Set the scale.
     *
     * @param {number|import("../size.js").Size} scale Scale.
     * @api
     */ ImageStyle.prototype.setScale = function(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(scale);
    };
    /**
     * @abstract
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ ImageStyle.prototype.listenImageChange = function(listener) {
        (0, $61DUI.abstract)();
    };
    /**
     * Load not yet loaded URI.
     * @abstract
     */ ImageStyle.prototype.load = function() {
        (0, $61DUI.abstract)();
    };
    /**
     * @abstract
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ ImageStyle.prototype.unlistenImageChange = function(listener) {
        (0, $61DUI.abstract)();
    };
    return ImageStyle;
}();
var $dc2b88278baca076$export$2e2bcd8739ae039 = $dc2b88278baca076$var$ImageStyle;



/**
 * @module ol/colorlike
 */ 
function $1ff9f2ef453cd345$export$dc5b1400ac3a10a8(color) {
    if (Array.isArray(color)) return (0, $520f75f61db85ab0$export$f84e8e69fd4488a5)(color);
    else return color;
}



var $djuby = parcelRequire("djuby");

var $9d34e7b97dc4a361$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Specify radius for regular polygons, or radius1 and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} [radius] Radius of a regular polygon.
 * @property {number} [radius1] First radius of a star. Ignored if radius is set.
 * @property {number} [radius2] Second radius of a star.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's point facing up.
 * @property {Array<number>} [displacement=[0,0]] Displacement of the shape
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius`, `radius1` and `radius2`.
 * @property {"declutter"|"obstacle"|"none"|undefined} [declutterMode] Declutter mode
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike} [strokeStyle] StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {Array<number>} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when `radius1` and
 * `radius2` are provided.
 * @api
 */ var $9d34e7b97dc4a361$var$RegularShape = /** @class */ function(_super) {
    $9d34e7b97dc4a361$var$__extends(RegularShape, _super);
    /**
     * @param {Options} options Options.
     */ function RegularShape(options) {
        var _this = this;
        /**
         * @type {boolean}
         */ var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        _this = _super.call(this, {
            opacity: 1,
            rotateWithView: rotateWithView,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        }) || this;
        /**
         * @private
         * @type {Object<number, HTMLCanvasElement>}
         */ _this.canvas_ = undefined;
        /**
         * @private
         * @type {HTMLCanvasElement}
         */ _this.hitDetectionCanvas_ = null;
        /**
         * @private
         * @type {import("./Fill.js").default}
         */ _this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
         * @private
         * @type {Array<number>}
         */ _this.origin_ = [
            0,
            0
        ];
        /**
         * @private
         * @type {number}
         */ _this.points_ = options.points;
        /**
         * @protected
         * @type {number}
         */ _this.radius_ = options.radius !== undefined ? options.radius : options.radius1;
        /**
         * @private
         * @type {number|undefined}
         */ _this.radius2_ = options.radius2;
        /**
         * @private
         * @type {number}
         */ _this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */ _this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ _this.size_ = null;
        /**
         * @private
         * @type {RenderOptions}
         */ _this.renderOptions_ = null;
        _this.render();
        return _this;
    }
    /**
     * Clones the style.
     * @return {RegularShape} The cloned style.
     * @api
     */ RegularShape.prototype.clone = function() {
        var scale = this.getScale();
        var style = new RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    };
    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @return {Array<number>} Anchor.
     * @api
     */ RegularShape.prototype.getAnchor = function() {
        var size = this.size_;
        if (!size) return null;
        var displacement = this.getDisplacement();
        return [
            size[0] / 2 - displacement[0],
            size[1] / 2 + displacement[1]
        ];
    };
    /**
     * Get the angle used in generating the shape.
     * @return {number} Shape's rotation in radians.
     * @api
     */ RegularShape.prototype.getAngle = function() {
        return this.angle_;
    };
    /**
     * Get the fill style for the shape.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */ RegularShape.prototype.getFill = function() {
        return this.fill_;
    };
    /**
     * Set the fill style.
     * @param {import("./Fill.js").default} fill Fill style.
     * @api
     */ RegularShape.prototype.setFill = function(fill) {
        this.fill_ = fill;
        this.render();
    };
    /**
     * @return {HTMLCanvasElement} Image element.
     */ RegularShape.prototype.getHitDetectionImage = function() {
        if (!this.hitDetectionCanvas_) this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    };
    /**
     * Get the image icon.
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLCanvasElement} Image or Canvas element.
     * @api
     */ RegularShape.prototype.getImage = function(pixelRatio) {
        var image = this.canvas_[pixelRatio];
        if (!image) {
            var renderOptions = this.renderOptions_;
            var context = (0, $djuby.createCanvasContext2D)(renderOptions.size * pixelRatio, renderOptions.size * pixelRatio);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            this.canvas_[pixelRatio] = image;
        }
        return image;
    };
    /**
     * Get the image pixel ratio.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Pixel ratio.
     */ RegularShape.prototype.getPixelRatio = function(pixelRatio) {
        return pixelRatio;
    };
    /**
     * @return {import("../size.js").Size} Image size.
     */ RegularShape.prototype.getImageSize = function() {
        return this.size_;
    };
    /**
     * @return {import("../ImageState.js").default} Image state.
     */ RegularShape.prototype.getImageState = function() {
        return (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED;
    };
    /**
     * Get the origin of the symbolizer.
     * @return {Array<number>} Origin.
     * @api
     */ RegularShape.prototype.getOrigin = function() {
        return this.origin_;
    };
    /**
     * Get the number of points for generating the shape.
     * @return {number} Number of points for stars and regular polygons.
     * @api
     */ RegularShape.prototype.getPoints = function() {
        return this.points_;
    };
    /**
     * Get the (primary) radius for the shape.
     * @return {number} Radius.
     * @api
     */ RegularShape.prototype.getRadius = function() {
        return this.radius_;
    };
    /**
     * Get the secondary radius for the shape.
     * @return {number|undefined} Radius2.
     * @api
     */ RegularShape.prototype.getRadius2 = function() {
        return this.radius2_;
    };
    /**
     * Get the size of the symbolizer (in pixels).
     * @return {import("../size.js").Size} Size.
     * @api
     */ RegularShape.prototype.getSize = function() {
        return this.size_;
    };
    /**
     * Get the stroke style for the shape.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */ RegularShape.prototype.getStroke = function() {
        return this.stroke_;
    };
    /**
     * Set the stroke style.
     * @param {import("./Stroke.js").default} stroke Stroke style.
     * @api
     */ RegularShape.prototype.setStroke = function(stroke) {
        this.stroke_ = stroke;
        this.render();
    };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ RegularShape.prototype.listenImageChange = function(listener) {};
    /**
     * Load not yet loaded URI.
     */ RegularShape.prototype.load = function() {};
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ RegularShape.prototype.unlistenImageChange = function(listener) {};
    /**
     * Calculate additional canvas size needed for the miter.
     * @param {string} lineJoin Line join
     * @param {number} strokeWidth Stroke width
     * @param {number} miterLimit Miter limit
     * @return {number} Additional canvas size needed
     * @private
     */ RegularShape.prototype.calculateLineJoinSize_ = function(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== 'bevel' && lineJoin !== 'miter') return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        var r1 = this.radius_;
        var r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            var tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        var points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        var alpha = 2 * Math.PI / points;
        var a = r2 * Math.sin(alpha);
        var b = Math.sqrt(r2 * r2 - a * a);
        var d = r1 - b;
        var e = Math.sqrt(a * a + d * d);
        var miterRatio = e / a;
        if (lineJoin === 'miter' && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distnce from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        var k = strokeWidth / 2 / miterRatio;
        var l = strokeWidth / 2 * (d / e);
        var maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        var bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === 'bevel') return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        var aa = r1 * Math.sin(alpha);
        var bb = Math.sqrt(r1 * r1 - aa * aa);
        var dd = r2 - bb;
        var ee = Math.sqrt(aa * aa + dd * dd);
        var innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            var innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    };
    /**
     * @return {RenderOptions}  The render options
     * @protected
     */ RegularShape.prototype.createRenderOptions = function() {
        var lineJoin = (0, $da04304be4865188$export$365eb9648cf19bd0);
        var miterLimit = 0;
        var lineDash = null;
        var lineDashOffset = 0;
        var strokeStyle;
        var strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = this.stroke_.getColor();
            if (strokeStyle === null) strokeStyle = (0, $da04304be4865188$export$1eb2eaecacf2031e);
            strokeStyle = (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(strokeStyle);
            strokeWidth = this.stroke_.getWidth();
            if (strokeWidth === undefined) strokeWidth = (0, $da04304be4865188$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset();
            lineJoin = this.stroke_.getLineJoin();
            if (lineJoin === undefined) lineJoin = (0, $da04304be4865188$export$365eb9648cf19bd0);
            miterLimit = this.stroke_.getMiterLimit();
            if (miterLimit === undefined) miterLimit = (0, $da04304be4865188$export$80c1c01844597b7b);
        }
        var add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        var maxRadius = Math.max(this.radius_, this.radius2_ || 0);
        var size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    };
    /**
     * @protected
     */ RegularShape.prototype.render = function() {
        this.renderOptions_ = this.createRenderOptions();
        var size = this.renderOptions_.size;
        this.canvas_ = {};
        this.size_ = [
            size,
            size
        ];
    };
    /**
     * @private
     * @param {RenderOptions} renderOptions Render options.
     * @param {CanvasRenderingContext2D} context The rendering context.
     * @param {number} pixelRatio The pixel ratio.
     */ RegularShape.prototype.draw_ = function(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            var color = this.fill_.getColor();
            if (color === null) color = (0, $da04304be4865188$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (context.setLineDash && renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    };
    /**
     * @private
     * @param {RenderOptions} renderOptions Render options.
     */ RegularShape.prototype.createHitDetectionCanvas_ = function(renderOptions) {
        if (this.fill_) {
            var color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            var opacity = 0;
            if (typeof color === 'string') color = (0, $520f75f61db85ab0$export$75093a47a9fa838d)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                var context = (0, $djuby.createCanvasContext2D)(renderOptions.size, renderOptions.size);
                this.hitDetectionCanvas_ = context.canvas;
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.getImage(1);
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context The context to draw in.
     */ RegularShape.prototype.createPath_ = function(context) {
        var points = this.points_;
        var radius = this.radius_;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            var radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            var startAngle = this.angle_ - Math.PI / 2;
            var step = 2 * Math.PI / points;
            for(var i = 0; i < points; i++){
                var angle0 = startAngle + i * step;
                var radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    };
    /**
     * @private
     * @param {RenderOptions} renderOptions Render options.
     * @param {CanvasRenderingContext2D} context The context.
     */ RegularShape.prototype.drawHitDetectionCanvas_ = function(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $da04304be4865188$export$c495d52ee3fd74b2);
        context.fill();
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    };
    return RegularShape;
}((0, $dc2b88278baca076$export$2e2bcd8739ae039));
var $9d34e7b97dc4a361$export$2e2bcd8739ae039 = $9d34e7b97dc4a361$var$RegularShape;


var $bc4c0f447f32ca45$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {"declutter"|"obstacle"|"none"|undefined} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ var $bc4c0f447f32ca45$var$CircleStyle = /** @class */ function(_super) {
    $bc4c0f447f32ca45$var$__extends(CircleStyle, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function CircleStyle(opt_options) {
        var options = opt_options ? opt_options : {};
        return _super.call(this, {
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        }) || this;
    }
    /**
     * Clones the style.
     * @return {CircleStyle} The cloned style.
     * @api
     */ CircleStyle.prototype.clone = function() {
        var scale = this.getScale();
        var style = new CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    };
    /**
     * Set the circle radius.
     *
     * @param {number} radius Circle radius.
     * @api
     */ CircleStyle.prototype.setRadius = function(radius) {
        this.radius_ = radius;
        this.render();
    };
    return CircleStyle;
}((0, $9d34e7b97dc4a361$export$2e2bcd8739ae039));
var $bc4c0f447f32ca45$export$2e2bcd8739ae039 = $bc4c0f447f32ca45$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|null} [color=null] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ var $423e8acaae3939a9$var$Fill = /** @class */ function() {
    /**
     * @param {Options} [opt_options] Options.
     */ function Fill(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|null}
         */ this.color_ = options.color !== undefined ? options.color : null;
    }
    /**
     * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
     * @return {Fill} The cloned style.
     * @api
     */ Fill.prototype.clone = function() {
        var color = this.getColor();
        return new Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    };
    /**
     * Get the fill color.
     * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|null} Color.
     * @api
     */ Fill.prototype.getColor = function() {
        return this.color_;
    };
    /**
     * Set the color.
     *
     * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|null} color Color.
     * @api
     */ Fill.prototype.setColor = function(color) {
        this.color_ = color;
    };
    return Fill;
}();
var $423e8acaae3939a9$export$2e2bcd8739ae039 = $423e8acaae3939a9$var$Fill;


/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * Please note that Internet Explorer 10 and lower do not support the `setLineDash` method on
 * the `CanvasRenderingContext2D` and therefore this option will have no visual effect in these browsers.
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ var $3937feddfc329913$var$Stroke = /** @class */ function() {
    /**
     * @param {Options} [opt_options] Options.
     */ function Stroke(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
         */ this.color_ = options.color !== undefined ? options.color : null;
        /**
         * @private
         * @type {CanvasLineCap|undefined}
         */ this.lineCap_ = options.lineCap;
        /**
         * @private
         * @type {Array<number>}
         */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
         * @private
         * @type {number|undefined}
         */ this.lineDashOffset_ = options.lineDashOffset;
        /**
         * @private
         * @type {CanvasLineJoin|undefined}
         */ this.lineJoin_ = options.lineJoin;
        /**
         * @private
         * @type {number|undefined}
         */ this.miterLimit_ = options.miterLimit;
        /**
         * @private
         * @type {number|undefined}
         */ this.width_ = options.width;
    }
    /**
     * Clones the style.
     * @return {Stroke} The cloned style.
     * @api
     */ Stroke.prototype.clone = function() {
        var color = this.getColor();
        return new Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            width: this.getWidth()
        });
    };
    /**
     * Get the stroke color.
     * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
     * @api
     */ Stroke.prototype.getColor = function() {
        return this.color_;
    };
    /**
     * Get the line cap type for the stroke.
     * @return {CanvasLineCap|undefined} Line cap.
     * @api
     */ Stroke.prototype.getLineCap = function() {
        return this.lineCap_;
    };
    /**
     * Get the line dash style for the stroke.
     * @return {Array<number>} Line dash.
     * @api
     */ Stroke.prototype.getLineDash = function() {
        return this.lineDash_;
    };
    /**
     * Get the line dash offset for the stroke.
     * @return {number|undefined} Line dash offset.
     * @api
     */ Stroke.prototype.getLineDashOffset = function() {
        return this.lineDashOffset_;
    };
    /**
     * Get the line join type for the stroke.
     * @return {CanvasLineJoin|undefined} Line join.
     * @api
     */ Stroke.prototype.getLineJoin = function() {
        return this.lineJoin_;
    };
    /**
     * Get the miter limit for the stroke.
     * @return {number|undefined} Miter limit.
     * @api
     */ Stroke.prototype.getMiterLimit = function() {
        return this.miterLimit_;
    };
    /**
     * Get the stroke width.
     * @return {number|undefined} Width.
     * @api
     */ Stroke.prototype.getWidth = function() {
        return this.width_;
    };
    /**
     * Set the color.
     *
     * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
     * @api
     */ Stroke.prototype.setColor = function(color) {
        this.color_ = color;
    };
    /**
     * Set the line cap.
     *
     * @param {CanvasLineCap|undefined} lineCap Line cap.
     * @api
     */ Stroke.prototype.setLineCap = function(lineCap) {
        this.lineCap_ = lineCap;
    };
    /**
     * Set the line dash.
     *
     * Please note that Internet Explorer 10 and lower [do not support][mdn] the
     * `setLineDash` method on the `CanvasRenderingContext2D` and therefore this
     * property will have no visual effect in these browsers.
     *
     * [mdn]: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility
     *
     * @param {Array<number>} lineDash Line dash.
     * @api
     */ Stroke.prototype.setLineDash = function(lineDash) {
        this.lineDash_ = lineDash;
    };
    /**
     * Set the line dash offset.
     *
     * @param {number|undefined} lineDashOffset Line dash offset.
     * @api
     */ Stroke.prototype.setLineDashOffset = function(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    };
    /**
     * Set the line join.
     *
     * @param {CanvasLineJoin|undefined} lineJoin Line join.
     * @api
     */ Stroke.prototype.setLineJoin = function(lineJoin) {
        this.lineJoin_ = lineJoin;
    };
    /**
     * Set the miter limit.
     *
     * @param {number|undefined} miterLimit Miter limit.
     * @api
     */ Stroke.prototype.setMiterLimit = function(miterLimit) {
        this.miterLimit_ = miterLimit;
    };
    /**
     * Set the width.
     *
     * @param {number|undefined} width Width.
     * @api
     */ Stroke.prototype.setWidth = function(width) {
        this.width_ = width;
    };
    return Stroke;
}();
var $3937feddfc329913$export$2e2bcd8739ae039 = $3937feddfc329913$var$Stroke;



var $3JLp3 = parcelRequire("3JLp3");
/**
 * A function that takes an {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes an {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ var $ef61ac9807995b8c$var$Style = /** @class */ function() {
    /**
     * @param {Options} [opt_options] Style options.
     */ function Style(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {string|import("../geom/Geometry.js").default|GeometryFunction}
         */ this.geometry_ = null;
        /**
         * @private
         * @type {!GeometryFunction}
         */ this.geometryFunction_ = $ef61ac9807995b8c$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
         * @private
         * @type {import("./Fill.js").default}
         */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
         * @private
         * @type {import("./Image.js").default}
         */ this.image_ = options.image !== undefined ? options.image : null;
        /**
         * @private
         * @type {RenderFunction|null}
         */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
         * @private
         * @type {RenderFunction|null}
         */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
         * @private
         * @type {import("./Text.js").default}
         */ this.text_ = options.text !== undefined ? options.text : null;
        /**
         * @private
         * @type {number|undefined}
         */ this.zIndex_ = options.zIndex;
    }
    /**
     * Clones the style.
     * @return {Style} The cloned style.
     * @api
     */ Style.prototype.clone = function() {
        var geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new Style({
            geometry: geometry,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    };
    /**
     * Get the custom renderer function that was configured with
     * {@link #setRenderer} or the `renderer` constructor option.
     * @return {RenderFunction|null} Custom renderer function.
     * @api
     */ Style.prototype.getRenderer = function() {
        return this.renderer_;
    };
    /**
     * Sets a custom renderer function for this style. When set, `fill`, `stroke`
     * and `image` options of the style will be ignored.
     * @param {RenderFunction|null} renderer Custom renderer function.
     * @api
     */ Style.prototype.setRenderer = function(renderer) {
        this.renderer_ = renderer;
    };
    /**
     * Sets a custom renderer function for this style used
     * in hit detection.
     * @param {RenderFunction|null} renderer Custom renderer function.
     * @api
     */ Style.prototype.setHitDetectionRenderer = function(renderer) {
        this.hitDetectionRenderer_ = renderer;
    };
    /**
     * Get the custom renderer function that was configured with
     * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
     * @return {RenderFunction|null} Custom renderer function.
     * @api
     */ Style.prototype.getHitDetectionRenderer = function() {
        return this.hitDetectionRenderer_;
    };
    /**
     * Get the geometry to be rendered.
     * @return {string|import("../geom/Geometry.js").default|GeometryFunction}
     * Feature property or geometry or function that returns the geometry that will
     * be rendered with this style.
     * @api
     */ Style.prototype.getGeometry = function() {
        return this.geometry_;
    };
    /**
     * Get the function used to generate a geometry for rendering.
     * @return {!GeometryFunction} Function that is called with a feature
     * and returns the geometry to render instead of the feature's geometry.
     * @api
     */ Style.prototype.getGeometryFunction = function() {
        return this.geometryFunction_;
    };
    /**
     * Get the fill style.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */ Style.prototype.getFill = function() {
        return this.fill_;
    };
    /**
     * Set the fill style.
     * @param {import("./Fill.js").default} fill Fill style.
     * @api
     */ Style.prototype.setFill = function(fill) {
        this.fill_ = fill;
    };
    /**
     * Get the image style.
     * @return {import("./Image.js").default} Image style.
     * @api
     */ Style.prototype.getImage = function() {
        return this.image_;
    };
    /**
     * Set the image style.
     * @param {import("./Image.js").default} image Image style.
     * @api
     */ Style.prototype.setImage = function(image) {
        this.image_ = image;
    };
    /**
     * Get the stroke style.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */ Style.prototype.getStroke = function() {
        return this.stroke_;
    };
    /**
     * Set the stroke style.
     * @param {import("./Stroke.js").default} stroke Stroke style.
     * @api
     */ Style.prototype.setStroke = function(stroke) {
        this.stroke_ = stroke;
    };
    /**
     * Get the text style.
     * @return {import("./Text.js").default} Text style.
     * @api
     */ Style.prototype.getText = function() {
        return this.text_;
    };
    /**
     * Set the text style.
     * @param {import("./Text.js").default} text Text style.
     * @api
     */ Style.prototype.setText = function(text) {
        this.text_ = text;
    };
    /**
     * Get the z-index for the style.
     * @return {number|undefined} ZIndex.
     * @api
     */ Style.prototype.getZIndex = function() {
        return this.zIndex_;
    };
    /**
     * Set a geometry that is rendered instead of the feature's geometry.
     *
     * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
     *     Feature property or geometry or function returning a geometry to render
     *     for this style.
     * @api
     */ Style.prototype.setGeometry = function(geometry) {
        if (typeof geometry === 'function') this.geometryFunction_ = geometry;
        else if (typeof geometry === 'string') this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $ef61ac9807995b8c$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    };
    /**
     * Set the z-index.
     *
     * @param {number|undefined} zIndex ZIndex.
     * @api
     */ Style.prototype.setZIndex = function(zIndex) {
        this.zIndex_ = zIndex;
    };
    return Style;
}();
function $ef61ac9807995b8c$export$c314ea3f6b164147(obj) {
    var styleFunction;
    if (typeof obj === 'function') styleFunction = obj;
    else {
        /**
         * @type {Array<Style>}
         */ var styles_1;
        if (Array.isArray(obj)) styles_1 = obj;
        else {
            (0, $3JLp3.assert)(typeof /** @type {?} */ obj.getZIndex === 'function', 41); // Expected an `Style` or an array of `Style`
            var style = /** @type {Style} */ obj;
            styles_1 = [
                style
            ];
        }
        styleFunction = function() {
            return styles_1;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ var $ef61ac9807995b8c$var$defaultStyles = null;
function $ef61ac9807995b8c$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$ef61ac9807995b8c$var$defaultStyles) {
        var fill = new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
            color: 'rgba(255,255,255,0.4)'
        });
        var stroke = new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
            color: '#3399CC',
            width: 1.25
        });
        $ef61ac9807995b8c$var$defaultStyles = [
            new $ef61ac9807995b8c$var$Style({
                image: new (0, $bc4c0f447f32ca45$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $ef61ac9807995b8c$var$defaultStyles;
}
function $ef61ac9807995b8c$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ var styles = {};
    var white = [
        255,
        255,
        255,
        1
    ];
    var blue = [
        0,
        153,
        255,
        1
    ];
    var width = 3;
    styles['Polygon'] = [
        new $ef61ac9807995b8c$var$Style({
            fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles['MultiPolygon'] = styles['Polygon'];
    styles['LineString'] = [
        new $ef61ac9807995b8c$var$Style({
            stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $ef61ac9807995b8c$var$Style({
            stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles['MultiLineString'] = styles['LineString'];
    styles['Circle'] = styles['Polygon'].concat(styles['LineString']);
    styles['Point'] = [
        new $ef61ac9807995b8c$var$Style({
            image: new (0, $bc4c0f447f32ca45$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles['MultiPoint'] = styles['Point'];
    styles['GeometryCollection'] = styles['Polygon'].concat(styles['LineString'], styles['Point']);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $ef61ac9807995b8c$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $ef61ac9807995b8c$export$2e2bcd8739ae039 = $ef61ac9807995b8c$var$Style;


var $4fa39677119aae30$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @template {import("../source/Vector.js").default|import("../source/VectorTile.js").default} VectorSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../PluggableMap.js").default#addLayer map.addLayer()}.
 * @property {boolean} [declutter=false] Declutter images and text. Decluttering is applied to all
 * image and text styles of all Vector and VectorTile layers that have set this to `true`. The priority
 * is defined by the z-index of the layer, the `zIndex` of the style and the render order of features.
 * Higher z-index means higher priority. Within the same z-index, a feature rendered before another has
 * higher priority.
 *
 * As an optimization decluttered features from layers with the same `className` are rendered above
 * the fill and stroke styles of all of those layers regardless of z-index.  To opt out of this
 * behavior and place declutterd features with their own layer configure the layer with a `className`
 * other than `ol-layer`.
 * @property {import("../style/Style.js").StyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ var $4fa39677119aae30$var$Property = {
    RENDER_ORDER: 'renderOrder'
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default|import("../source/VectorTile.js").default} VectorSourceType
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @extends {Layer<VectorSourceType, RendererType>}
 * @api
 */ var $4fa39677119aae30$var$BaseVectorLayer = /** @class */ function(_super) {
    $4fa39677119aae30$var$__extends(BaseVectorLayer, _super);
    /**
     * @param {Options<VectorSourceType>} [opt_options] Options.
     */ function BaseVectorLayer(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = (0, $9zTj4.assign)({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        _this = _super.call(this, baseOptions) || this;
        /**
         * @private
         * @type {boolean}
         */ _this.declutter_ = options.declutter !== undefined ? options.declutter : false;
        /**
         * @type {number}
         * @private
         */ _this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
         * User provided style.
         * @type {import("../style/Style.js").StyleLike}
         * @private
         */ _this.style_ = null;
        /**
         * Style function for use within the library.
         * @type {import("../style/Style.js").StyleFunction|undefined}
         * @private
         */ _this.styleFunction_ = undefined;
        _this.setStyle(options.style);
        /**
         * @type {boolean}
         * @private
         */ _this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
         * @type {boolean}
         * @private
         */ _this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
        return _this;
    }
    /**
     * @return {boolean} Declutter.
     */ BaseVectorLayer.prototype.getDeclutter = function() {
        return this.declutter_;
    };
    /**
     * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
     * that resolves with an array of features. The array will either contain the topmost feature
     * when a hit was detected, or it will be empty.
     *
     * The hit detection algorithm used for this method is optimized for performance, but is less
     * accurate than the one used in {@link import("../PluggableMap.js").default#getFeaturesAtPixel}: Text
     * is not considered, and icons are only represented by their bounding box instead of the exact
     * image.
     *
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with an array of features.
     * @api
     */ BaseVectorLayer.prototype.getFeatures = function(pixel) {
        return _super.prototype.getFeatures.call(this, pixel);
    };
    /**
     * @return {number|undefined} Render buffer.
     */ BaseVectorLayer.prototype.getRenderBuffer = function() {
        return this.renderBuffer_;
    };
    /**
     * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
     *     order.
     */ BaseVectorLayer.prototype.getRenderOrder = function() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($4fa39677119aae30$var$Property.RENDER_ORDER);
    };
    /**
     * Get the style for features.  This returns whatever was passed to the `style`
     * option at construction or to the `setStyle` method.
     * @return {import("../style/Style.js").StyleLike|null|undefined} Layer style.
     * @api
     */ BaseVectorLayer.prototype.getStyle = function() {
        return this.style_;
    };
    /**
     * Get the style function.
     * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
     * @api
     */ BaseVectorLayer.prototype.getStyleFunction = function() {
        return this.styleFunction_;
    };
    /**
     * @return {boolean} Whether the rendered layer should be updated while
     *     animating.
     */ BaseVectorLayer.prototype.getUpdateWhileAnimating = function() {
        return this.updateWhileAnimating_;
    };
    /**
     * @return {boolean} Whether the rendered layer should be updated while
     *     interacting.
     */ BaseVectorLayer.prototype.getUpdateWhileInteracting = function() {
        return this.updateWhileInteracting_;
    };
    /**
     * Render declutter items for this layer
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     */ BaseVectorLayer.prototype.renderDeclutter = function(frameState) {
        if (!frameState.declutterTree) frameState.declutterTree = new (0, (/*@__PURE__*/$parcel$interopDefault($fc2e28651a316465$exports)))(9);
        /** @type {*} */ this.getRenderer().renderDeclutter(frameState);
    };
    /**
     * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
     *     Render order.
     */ BaseVectorLayer.prototype.setRenderOrder = function(renderOrder) {
        this.set($4fa39677119aae30$var$Property.RENDER_ORDER, renderOrder);
    };
    /**
     * Set the style for features.  This can be a single style object, an array
     * of styles, or a function that takes a feature and resolution and returns
     * an array of styles. If set to `null`, the layer has no style (a `null` style),
     * so only features that have their own styles will be rendered in the layer. Call
     * `setStyle()` without arguments to reset to the default style. See
     * {@link module:ol/style/Style~Style} for information on the default style.
     * @param {import("../style/Style.js").StyleLike|null} [opt_style] Layer style.
     * @api
     */ BaseVectorLayer.prototype.setStyle = function(opt_style) {
        this.style_ = opt_style !== undefined ? opt_style : (0, $ef61ac9807995b8c$export$6865c5ac2f5ce8b6);
        this.styleFunction_ = opt_style === null ? undefined : (0, $ef61ac9807995b8c$export$c314ea3f6b164147)(this.style_);
        this.changed();
    };
    return BaseVectorLayer;
}((0, $93a49300d1913509$export$2e2bcd8739ae039));
var $4fa39677119aae30$export$2e2bcd8739ae039 = $4fa39677119aae30$var$BaseVectorLayer;


/**
 * @module ol/render/canvas/BuilderGroup
 */ /**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ var $7c01b5f7d070d555$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
var $7c01b5f7d070d555$export$f21891651e408226 = [
    $7c01b5f7d070d555$var$Instruction.FILL
];
var $7c01b5f7d070d555$export$7a98aa5364d62ba8 = [
    $7c01b5f7d070d555$var$Instruction.STROKE
];
var $7c01b5f7d070d555$export$9f746cc58a899a00 = [
    $7c01b5f7d070d555$var$Instruction.BEGIN_PATH
];
var $7c01b5f7d070d555$export$89b10f327e413e71 = [
    $7c01b5f7d070d555$var$Instruction.CLOSE_PATH
];
var $7c01b5f7d070d555$export$2e2bcd8739ae039 = $7c01b5f7d070d555$var$Instruction;



var $2mHhe = parcelRequire("2mHhe");
/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ var $a679a2d97e9b2dc2$var$VectorContext = /** @class */ function() {
    function VectorContext() {}
    /**
     * Render a geometry with a custom renderer.
     *
     * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {Function} renderer Renderer.
     * @param {Function} hitDetectionRenderer Renderer.
     */ VectorContext.prototype.drawCustom = function(geometry, feature, renderer, hitDetectionRenderer) {};
    /**
     * Render a geometry.
     *
     * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
     */ VectorContext.prototype.drawGeometry = function(geometry) {};
    /**
     * Set the rendering style.
     *
     * @param {import("../style/Style.js").default} style The rendering style.
     */ VectorContext.prototype.setStyle = function(style) {};
    /**
     * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
     * @param {import("../Feature.js").default} feature Feature.
     */ VectorContext.prototype.drawCircle = function(circleGeometry, feature) {};
    /**
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("../style/Style.js").default} style Style.
     */ VectorContext.prototype.drawFeature = function(feature, style) {};
    /**
     * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
     * @param {import("../Feature.js").default} feature Feature.
     */ VectorContext.prototype.drawGeometryCollection = function(geometryCollectionGeometry, feature) {};
    /**
     * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawLineString = function(lineStringGeometry, feature) {};
    /**
     * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawMultiLineString = function(multiLineStringGeometry, feature) {};
    /**
     * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawMultiPoint = function(multiPointGeometry, feature) {};
    /**
     * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawMultiPolygon = function(multiPolygonGeometry, feature) {};
    /**
     * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawPoint = function(pointGeometry, feature) {};
    /**
     * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawPolygon = function(polygonGeometry, feature) {};
    /**
     * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */ VectorContext.prototype.drawText = function(geometry, feature) {};
    /**
     * @param {import("../style/Fill.js").default} fillStyle Fill style.
     * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
     */ VectorContext.prototype.setFillStrokeStyle = function(fillStyle, strokeStyle) {};
    /**
     * @param {import("../style/Image.js").default} imageStyle Image style.
     * @param {import("../render/canvas.js").DeclutterImageWithText} [opt_declutterImageWithText] Shared data for combined decluttering with a text style.
     */ VectorContext.prototype.setImageStyle = function(imageStyle, opt_declutterImageWithText) {};
    /**
     * @param {import("../style/Text.js").default} textStyle Text style.
     * @param {import("../render/canvas.js").DeclutterImageWithText} [opt_declutterImageWithText] Shared data for combined decluttering with an image style.
     */ VectorContext.prototype.setTextStyle = function(textStyle, opt_declutterImageWithText) {};
    return VectorContext;
}();
var $a679a2d97e9b2dc2$export$2e2bcd8739ae039 = $a679a2d97e9b2dc2$var$VectorContext;




var $2Jl0K = parcelRequire("2Jl0K");


var $kzmGH = parcelRequire("kzmGH");

var $f0b297b41787b20a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f0b297b41787b20a$var$CanvasBuilder = /** @class */ function(_super) {
    $f0b297b41787b20a$var$__extends(CanvasBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {number}
         */ _this.tolerance = tolerance;
        /**
         * @protected
         * @const
         * @type {import("../../extent.js").Extent}
         */ _this.maxExtent = maxExtent;
        /**
         * @protected
         * @type {number}
         */ _this.pixelRatio = pixelRatio;
        /**
         * @protected
         * @type {number}
         */ _this.maxLineWidth = 0;
        /**
         * @protected
         * @const
         * @type {number}
         */ _this.resolution = resolution;
        /**
         * @private
         * @type {Array<*>}
         */ _this.beginGeometryInstruction1_ = null;
        /**
         * @private
         * @type {Array<*>}
         */ _this.beginGeometryInstruction2_ = null;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ _this.bufferedMaxExtent_ = null;
        /**
         * @protected
         * @type {Array<*>}
         */ _this.instructions = [];
        /**
         * @protected
         * @type {Array<number>}
         */ _this.coordinates = [];
        /**
         * @private
         * @type {import("../../coordinate.js").Coordinate}
         */ _this.tmpCoordinate_ = [];
        /**
         * @protected
         * @type {Array<*>}
         */ _this.hitDetectionInstructions = [];
        /**
         * @protected
         * @type {import("../canvas.js").FillStrokeState}
         */ _this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
        return _this;
    }
    /**
     * @protected
     * @param {Array<number>} dashArray Dash array.
     * @return {Array<number>} Dash array with pixel ratio applied
     */ CanvasBuilder.prototype.applyPixelRatio = function(dashArray) {
        var pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} stride Stride.
     * @protected
     * @return {number} My end
     */ CanvasBuilder.prototype.appendFlatPointCoordinates = function(flatCoordinates, stride) {
        var extent = this.getBufferedMaxExtent();
        var tmpCoord = this.tmpCoordinate_;
        var coordinates = this.coordinates;
        var myEnd = coordinates.length;
        for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $2Jl0K.containsCoordinate)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @param {boolean} closed Last input coordinate equals first.
     * @param {boolean} skipFirst Skip first coordinate.
     * @protected
     * @return {number} My end.
     */ CanvasBuilder.prototype.appendFlatLineCoordinates = function(flatCoordinates, offset, end, stride, closed, skipFirst) {
        var coordinates = this.coordinates;
        var myEnd = coordinates.length;
        var extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        var lastXCoord = flatCoordinates[offset];
        var lastYCoord = flatCoordinates[offset + 1];
        var nextCoord = this.tmpCoordinate_;
        var skipped = true;
        var i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $2Jl0K.coordinateRelationship)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $2mHhe.default).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {Array<number>} ends Ends.
     * @param {number} stride Stride.
     * @param {Array<number>} builderEnds Builder ends.
     * @return {number} Offset.
     */ CanvasBuilder.prototype.drawCustomCoordinates_ = function(flatCoordinates, offset, ends, stride, builderEnds) {
        for(var i = 0, ii = ends.length; i < ii; ++i){
            var end = ends[i];
            var builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    };
    /**
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {Function} renderer Renderer.
     * @param {Function} hitDetectionRenderer Renderer.
     */ CanvasBuilder.prototype.drawCustom = function(geometry, feature, renderer, hitDetectionRenderer) {
        this.beginGeometry(geometry, feature);
        var type = geometry.getType();
        var stride = geometry.getStride();
        var builderBegin = this.coordinates.length;
        var flatCoordinates, builderEnd, builderEnds, builderEndss;
        var offset;
        switch(type){
            case 'MultiPolygon':
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                var endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(var i = 0, ii = endss.length; i < ii; ++i){
                    var myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $f2531bda6eeb448c$export$915c7058aeb4dfeb)
                ]);
                this.hitDetectionInstructions.push([
                    (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $f2531bda6eeb448c$export$915c7058aeb4dfeb)
                ]);
                break;
            case 'Polygon':
            case 'MultiLineString':
                builderEnds = [];
                flatCoordinates = type == 'Polygon' ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $f2531bda6eeb448c$export$cbb9596fc0f40db2)
                ]);
                this.hitDetectionInstructions.push([
                    (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $f2531bda6eeb448c$export$cbb9596fc0f40db2)
                ]);
                break;
            case 'LineString':
            case 'Circle':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $f2531bda6eeb448c$export$9c0934e4e9c3f61e)
                ]);
                this.hitDetectionInstructions.push([
                    (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $f2531bda6eeb448c$export$9c0934e4e9c3f61e)
                ]);
                break;
            case 'MultiPoint':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $f2531bda6eeb448c$export$9c0934e4e9c3f61e)
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $f2531bda6eeb448c$export$9c0934e4e9c3f61e)
                    ]);
                }
                break;
            case 'Point':
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer
                ]);
                this.hitDetectionInstructions.push([
                    (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    };
    /**
     * @protected
     * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasBuilder.prototype.beginGeometry = function(geometry, feature) {
        this.beginGeometryInstruction1_ = [
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasBuilder.prototype.finish = function() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    };
    /**
     * Reverse the hit detection instructions.
     */ CanvasBuilder.prototype.reverseHitDetectionInstructions = function() {
        var hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        var i;
        var n = hitDetectionInstructions.length;
        var instruction;
        var type;
        var begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $kzmGH.reverseSubArray)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    };
    /**
     * @param {import("../../style/Fill.js").default} fillStyle Fill style.
     * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
     */ CanvasBuilder.prototype.setFillStrokeStyle = function(fillStyle, strokeStyle) {
        var state = this.state;
        if (fillStyle) {
            var fillStyleColor = fillStyle.getColor();
            state.fillStyle = (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $da04304be4865188$export$c495d52ee3fd74b2));
        } else state.fillStyle = undefined;
        if (strokeStyle) {
            var strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $da04304be4865188$export$1eb2eaecacf2031e));
            var strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $da04304be4865188$export$17bd0c38d6ae694e);
            var strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $da04304be4865188$export$e21b4112fdc612fc);
            var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $da04304be4865188$export$e06efc2409049f76);
            var strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $da04304be4865188$export$365eb9648cf19bd0);
            var strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $da04304be4865188$export$79661f132c62010e);
            var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $da04304be4865188$export$80c1c01844597b7b);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @return {Array<*>} Fill instruction.
     */ CanvasBuilder.prototype.createFill = function(state) {
        var fillStyle = state.fillStyle;
        /** @type {Array<*>} */ var fillInstruction = [
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== 'string') // Fill is a pattern or gradient - align it!
        fillInstruction.push(true);
        return fillInstruction;
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     */ CanvasBuilder.prototype.applyStroke = function(state) {
        this.instructions.push(this.createStroke(state));
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @return {Array<*>} Stroke instruction.
     */ CanvasBuilder.prototype.createStroke = function(state) {
        return [
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            this.applyPixelRatio(state.lineDash),
            state.lineDashOffset * this.pixelRatio
        ];
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
     */ CanvasBuilder.prototype.updateFillStyle = function(state, createFill) {
        var fillStyle = state.fillStyle;
        if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            if (fillStyle !== undefined) this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
     */ CanvasBuilder.prototype.updateStrokeStyle = function(state, applyStroke) {
        var strokeStyle = state.strokeStyle;
        var lineCap = state.lineCap;
        var lineDash = state.lineDash;
        var lineDashOffset = state.lineDashOffset;
        var lineJoin = state.lineJoin;
        var lineWidth = state.lineWidth;
        var miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $kzmGH.equals)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
            if (strokeStyle !== undefined) applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    };
    /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasBuilder.prototype.endGeometry = function(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        var endGeometryInstruction = [
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    };
    /**
     * Get the buffered rendering extent.  Rendering will be clipped to the extent
     * provided to the constructor.  To account for symbolizers that may intersect
     * this extent, we calculate a buffered extent (e.g. based on stroke width).
     * @return {import("../../extent.js").Extent} The buffered rendering extent.
     * @protected
     */ CanvasBuilder.prototype.getBufferedMaxExtent = function() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $2Jl0K.clone)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                var width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $2Jl0K.buffer)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    };
    return CanvasBuilder;
}((0, $a679a2d97e9b2dc2$export$2e2bcd8739ae039));
var $f0b297b41787b20a$export$2e2bcd8739ae039 = $f0b297b41787b20a$var$CanvasBuilder;




var $e5896bfb384f00b9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e5896bfb384f00b9$var$CanvasImageBuilder = /** @class */ function(_super) {
    $e5896bfb384f00b9$var$__extends(CanvasImageBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasImageBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        var _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
         */ _this.hitDetectionImage_ = null;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
         */ _this.image_ = null;
        /**
         * @private
         * @type {number|undefined}
         */ _this.imagePixelRatio_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.anchorX_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.anchorY_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.height_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.opacity_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.originX_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.originY_ = undefined;
        /**
         * @private
         * @type {boolean|undefined}
         */ _this.rotateWithView_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.rotation_ = undefined;
        /**
         * @private
         * @type {import("../../size.js").Size|undefined}
         */ _this.scale_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */ _this.width_ = undefined;
        /**
         * @private
         * @type {"declutter"|"obstacle"|"none"|undefined}
         */ _this.declutterMode_ = undefined;
        /**
         * Data shared with a text builder for combined decluttering.
         * @private
         * @type {import("../canvas.js").DeclutterImageWithText}
         */ _this.declutterImageWithText_ = undefined;
        return _this;
    }
    /**
     * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasImageBuilder.prototype.drawPoint = function(pointGeometry, feature) {
        if (!this.image_) return;
        this.beginGeometry(pointGeometry, feature);
        var flatCoordinates = pointGeometry.getFlatCoordinates();
        var stride = pointGeometry.getStride();
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasImageBuilder.prototype.drawMultiPoint = function(multiPointGeometry, feature) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature);
        var flatCoordinates = multiPointGeometry.getFlatCoordinates();
        var stride = multiPointGeometry.getStride();
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasImageBuilder.prototype.finish = function() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return _super.prototype.finish.call(this);
    };
    /**
     * @param {import("../../style/Image.js").default} imageStyle Image style.
     * @param {Object} [opt_sharedData] Shared data.
     */ CanvasImageBuilder.prototype.setImageStyle = function(imageStyle, opt_sharedData) {
        var anchor = imageStyle.getAnchor();
        var size = imageStyle.getSize();
        var origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = opt_sharedData;
    };
    return CanvasImageBuilder;
}((0, $f0b297b41787b20a$export$2e2bcd8739ae039));
var $e5896bfb384f00b9$export$2e2bcd8739ae039 = $e5896bfb384f00b9$var$CanvasImageBuilder;





var $f399d83850c08d74$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f399d83850c08d74$var$CanvasLineStringBuilder = /** @class */ function(_super) {
    $f399d83850c08d74$var$__extends(CanvasLineStringBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasLineStringBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        return _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
    }
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @private
     * @return {number} end.
     */ CanvasLineStringBuilder.prototype.drawFlatCoordinates_ = function(flatCoordinates, offset, end, stride) {
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        var moveToLineToInstruction = [
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    };
    /**
     * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasLineStringBuilder.prototype.drawLineString = function(lineStringGeometry, feature) {
        var state = this.state;
        var strokeStyle = state.strokeStyle;
        var lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature);
        this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $da04304be4865188$export$e21b4112fdc612fc),
            (0, $da04304be4865188$export$e06efc2409049f76)
        ], (0, $7c01b5f7d070d555$export$9f746cc58a899a00));
        var flatCoordinates = lineStringGeometry.getFlatCoordinates();
        var stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push((0, $7c01b5f7d070d555$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasLineStringBuilder.prototype.drawMultiLineString = function(multiLineStringGeometry, feature) {
        var state = this.state;
        var strokeStyle = state.strokeStyle;
        var lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature);
        this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ], (0, $7c01b5f7d070d555$export$9f746cc58a899a00));
        var ends = multiLineStringGeometry.getEnds();
        var flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        var stride = multiLineStringGeometry.getStride();
        var offset = 0;
        for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride);
        this.hitDetectionInstructions.push((0, $7c01b5f7d070d555$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasLineStringBuilder.prototype.finish = function() {
        var state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $7c01b5f7d070d555$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return _super.prototype.finish.call(this);
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     */ CanvasLineStringBuilder.prototype.applyStroke = function(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $7c01b5f7d070d555$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        _super.prototype.applyStroke.call(this, state);
        this.instructions.push((0, $7c01b5f7d070d555$export$9f746cc58a899a00));
    };
    return CanvasLineStringBuilder;
}((0, $f0b297b41787b20a$export$2e2bcd8739ae039));
var $f399d83850c08d74$export$2e2bcd8739ae039 = $f399d83850c08d74$var$CanvasLineStringBuilder;






var $ed7fbf0632309f25$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ed7fbf0632309f25$var$CanvasPolygonBuilder = /** @class */ function(_super) {
    $ed7fbf0632309f25$var$__extends(CanvasPolygonBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasPolygonBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        return _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
    }
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {Array<number>} ends Ends.
     * @param {number} stride Stride.
     * @private
     * @return {number} End.
     */ CanvasPolygonBuilder.prototype.drawFlatCoordinatess_ = function(flatCoordinates, offset, ends, stride) {
        var state = this.state;
        var fill = state.fillStyle !== undefined;
        var stroke = state.strokeStyle !== undefined;
        var numEnds = ends.length;
        this.instructions.push((0, $7c01b5f7d070d555$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $7c01b5f7d070d555$export$9f746cc58a899a00));
        for(var i = 0; i < numEnds; ++i){
            var end = ends[i];
            var myBegin = this.coordinates.length;
            var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            var moveToLineToInstruction = [
                (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $7c01b5f7d070d555$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $7c01b5f7d070d555$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $7c01b5f7d070d555$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $7c01b5f7d070d555$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $7c01b5f7d070d555$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $7c01b5f7d070d555$export$7a98aa5364d62ba8));
        }
        return offset;
    };
    /**
     * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
     * @param {import("../../Feature.js").default} feature Feature.
     */ CanvasPolygonBuilder.prototype.drawCircle = function(circleGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $da04304be4865188$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ]);
        var flatCoordinates = circleGeometry.getFlatCoordinates();
        var stride = circleGeometry.getStride();
        var myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        var circleInstruction = [
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CIRCLE,
            myBegin
        ];
        this.instructions.push((0, $7c01b5f7d070d555$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $7c01b5f7d070d555$export$9f746cc58a899a00), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $7c01b5f7d070d555$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $7c01b5f7d070d555$export$f21891651e408226));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $7c01b5f7d070d555$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $7c01b5f7d070d555$export$7a98aa5364d62ba8));
        }
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasPolygonBuilder.prototype.drawPolygon = function(polygonGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $da04304be4865188$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ]);
        var ends = polygonGeometry.getEnds();
        var flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        var stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride);
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasPolygonBuilder.prototype.drawMultiPolygon = function(multiPolygonGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $da04304be4865188$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset
        ]);
        var endss = multiPolygonGeometry.getEndss();
        var flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        var stride = multiPolygonGeometry.getStride();
        var offset = 0;
        for(var i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        this.endGeometry(feature);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasPolygonBuilder.prototype.finish = function() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        var tolerance = this.tolerance;
        if (tolerance !== 0) {
            var coordinates = this.coordinates;
            for(var i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $2c00e3f050ec1bce$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
        return _super.prototype.finish.call(this);
    };
    /**
     * @private
     */ CanvasPolygonBuilder.prototype.setFillStrokeStyles_ = function() {
        var state = this.state;
        var fillStyle = state.fillStyle;
        if (fillStyle !== undefined) this.updateFillStyle(state, this.createFill);
        if (state.strokeStyle !== undefined) this.updateStrokeStyle(state, this.applyStroke);
    };
    return CanvasPolygonBuilder;
}((0, $f0b297b41787b20a$export$2e2bcd8739ae039));
var $ed7fbf0632309f25$export$2e2bcd8739ae039 = $ed7fbf0632309f25$var$CanvasPolygonBuilder;




/**
 * @module ol/style/TextPlacement
 */ /**
 * Text placement. One of `'point'`, `'line'`. Default is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 * @enum {string}
 */ var $6920f9bb98c2b277$export$2e2bcd8739ae039 = {
    POINT: 'point',
    LINE: 'line'
};





var $61DUI = parcelRequire("61DUI");

var $2Jl0K = parcelRequire("2Jl0K");
/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $90737582d57f17e2$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    var chunkStart = offset;
    var chunkEnd = offset;
    var chunkM = 0;
    var m = 0;
    var start = offset;
    var acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}


var $f4b7a8419bdf1c80$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f4b7a8419bdf1c80$export$91a016276e4aee96 = {
    'left': 0,
    'end': 0,
    'center': 0.5,
    'right': 1,
    'start': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1
};
var $f4b7a8419bdf1c80$var$CanvasTextBuilder = /** @class */ function(_super) {
    $f4b7a8419bdf1c80$var$__extends(CanvasTextBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function CanvasTextBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        var _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
        /**
         * @private
         * @type {Array<HTMLCanvasElement>}
         */ _this.labels_ = null;
        /**
         * @private
         * @type {string|Array<string>}
         */ _this.text_ = '';
        /**
         * @private
         * @type {number}
         */ _this.textOffsetX_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.textOffsetY_ = 0;
        /**
         * @private
         * @type {boolean|undefined}
         */ _this.textRotateWithView_ = undefined;
        /**
         * @private
         * @type {number}
         */ _this.textRotation_ = 0;
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */ _this.textFillState_ = null;
        /**
         * @type {!Object<string, import("../canvas.js").FillState>}
         */ _this.fillStates = {};
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */ _this.textStrokeState_ = null;
        /**
         * @type {!Object<string, import("../canvas.js").StrokeState>}
         */ _this.strokeStates = {};
        /**
         * @private
         * @type {import("../canvas.js").TextState}
         */ _this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
         * @type {!Object<string, import("../canvas.js").TextState>}
         */ _this.textStates = {};
        /**
         * @private
         * @type {string}
         */ _this.textKey_ = '';
        /**
         * @private
         * @type {string}
         */ _this.fillKey_ = '';
        /**
         * @private
         * @type {string}
         */ _this.strokeKey_ = '';
        /**
         * Data shared with an image builder for combined decluttering.
         * @private
         * @type {import("../canvas.js").DeclutterImageWithText}
         */ _this.declutterImageWithText_ = undefined;
        return _this;
    }
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */ CanvasTextBuilder.prototype.finish = function() {
        var instructions = _super.prototype.finish.call(this);
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    };
    /**
     * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */ CanvasTextBuilder.prototype.drawText = function(geometry, feature) {
        var fillState = this.textFillState_;
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        if (this.text_ === '' || !textState || !fillState && !strokeState) return;
        var coordinates = this.coordinates;
        var begin = coordinates.length;
        var geometryType = geometry.getType();
        var flatCoordinates = null;
        var stride = geometry.getStride();
        if (textState.placement === (0, $6920f9bb98c2b277$export$2e2bcd8739ae039).LINE && (geometryType == 'LineString' || geometryType == 'MultiLineString' || geometryType == 'Polygon' || geometryType == 'MultiPolygon')) {
            if (!(0, $2Jl0K.intersects)(this.getBufferedMaxExtent(), geometry.getExtent())) return;
            var ends = void 0;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == 'LineString') ends = [
                flatCoordinates.length
            ];
            else if (geometryType == 'MultiLineString') ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == 'Polygon') ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == 'MultiPolygon') {
                var endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(var i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature);
            var textAlign = textState.textAlign;
            // No `justify` support for line placement.
            var flatOffset = 0;
            var flatEnd = void 0;
            for(var o = 0, oo = ends.length; o < oo; ++o){
                if (textAlign == undefined) {
                    var range = (0, $90737582d57f17e2$export$ed6c897eea07a254)(textState.maxAngle, flatCoordinates, flatOffset, ends[o], stride);
                    flatOffset = range[0];
                    flatEnd = range[1];
                } else flatEnd = ends[o];
                for(var i = flatOffset; i < flatEnd; i += stride)coordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
                var end = coordinates.length;
                flatOffset = ends[o];
                this.drawChars_(begin, end);
                begin = end;
            }
            this.endGeometry(feature);
        } else {
            var geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case 'Point':
                case 'MultiPoint':
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case 'LineString':
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case 'Circle':
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case 'MultiLineString':
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case 'Polygon':
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case 'MultiPolygon':
                    var interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(var i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            var end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                var beg_1 = begin / 2;
                geometryWidths = geometryWidths.filter(function(w, i) {
                    var keep = coordinates[(beg_1 + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg_1 + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg_1;
                    return keep;
                });
            }
            this.saveTextStates_();
            if (textState.backgroundFill || textState.backgroundStroke) {
                this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);
                if (textState.backgroundFill) {
                    this.updateFillStyle(this.state, this.createFill);
                    this.hitDetectionInstructions.push(this.createFill(this.state));
                }
                if (textState.backgroundStroke) {
                    this.updateStrokeStyle(this.state, this.applyStroke);
                    this.hitDetectionInstructions.push(this.createStroke(this.state));
                }
            }
            this.beginGeometry(geometry, feature);
            // adjust padding for negative scale
            var padding = textState.padding;
            if (padding != (0, $da04304be4865188$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                var p0 = textState.padding[0];
                var p1 = textState.padding[1];
                var p2 = textState.padding[2];
                var p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            var pixelRatio_1 = this.pixelRatio;
            this.instructions.push([
                (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                undefined,
                this.declutterImageWithText_,
                padding == (0, $da04304be4865188$export$40a9eeef55665a40) ? (0, $da04304be4865188$export$40a9eeef55665a40) : padding.map(function(p) {
                    return p * pixelRatio_1;
                }),
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            var scale = 1 / pixelRatio_1;
            this.hitDetectionInstructions.push([
                (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                undefined,
                this.declutterImageWithText_,
                padding,
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            this.endGeometry(feature);
        }
    };
    /**
     * @private
     */ CanvasTextBuilder.prototype.saveTextStates_ = function() {
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        var fillState = this.textFillState_;
        var strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        var textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $da04304be4865188$export$94d53b95641b5766),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $da04304be4865188$export$cf2279a1bff62eb),
            scale: textState.scale
        };
        var fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    };
    /**
     * @private
     * @param {number} begin Begin.
     * @param {number} end End.
     */ CanvasTextBuilder.prototype.drawChars_ = function(begin, end) {
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        var strokeKey = this.strokeKey_;
        var textKey = this.textKey_;
        var fillKey = this.fillKey_;
        this.saveTextStates_();
        var pixelRatio = this.pixelRatio;
        var baseline = $f4b7a8419bdf1c80$export$91a016276e4aee96[textState.textBaseline];
        var offsetY = this.textOffsetY_ * pixelRatio;
        var text = this.text_;
        var strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1
        ]);
        this.hitDetectionInstructions.push([
            (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            1,
            offsetY,
            strokeKey,
            strokeWidth,
            text,
            textKey,
            1 / pixelRatio
        ]);
    };
    /**
     * @param {import("../../style/Text.js").default} textStyle Text style.
     * @param {Object} [opt_sharedData] Shared data.
     */ CanvasTextBuilder.prototype.setTextStyle = function(textStyle, opt_sharedData) {
        var textState, fillState, strokeState;
        if (!textStyle) this.text_ = '';
        else {
            var textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $da04304be4865188$export$c495d52ee3fd74b2));
            }
            var textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                var lineDash = textStrokeStyle.getLineDash();
                var lineDashOffset = textStrokeStyle.getLineDashOffset();
                var lineWidth = textStrokeStyle.getWidth();
                var miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $da04304be4865188$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $da04304be4865188$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $da04304be4865188$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $da04304be4865188$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $da04304be4865188$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $da04304be4865188$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $da04304be4865188$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            var font = textStyle.getFont() || (0, $da04304be4865188$export$3847dfea4f8d4dfa);
            (0, $da04304be4865188$export$a534074a28fa87ff)(font);
            var textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $da04304be4865188$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $da04304be4865188$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            var textOffsetX = textStyle.getOffsetX();
            var textOffsetY = textStyle.getOffsetY();
            var textRotateWithView = textStyle.getRotateWithView();
            var textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, $61DUI.getUid)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.justify || '?') + (textState.textBaseline || '?');
            this.fillKey_ = fillState ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, $61DUI.getUid)(fillState.fillStyle) : '';
        }
        this.declutterImageWithText_ = opt_sharedData;
    };
    return CanvasTextBuilder;
}((0, $f0b297b41787b20a$export$2e2bcd8739ae039));
var $f4b7a8419bdf1c80$export$2e2bcd8739ae039 = $f4b7a8419bdf1c80$var$CanvasTextBuilder;


/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ var $5710853dffd2641f$var$BATCH_CONSTRUCTORS = {
    'Circle': (0, $ed7fbf0632309f25$export$2e2bcd8739ae039),
    'Default': (0, $f0b297b41787b20a$export$2e2bcd8739ae039),
    'Image': (0, $e5896bfb384f00b9$export$2e2bcd8739ae039),
    'LineString': (0, $f399d83850c08d74$export$2e2bcd8739ae039),
    'Polygon': (0, $ed7fbf0632309f25$export$2e2bcd8739ae039),
    'Text': (0, $f4b7a8419bdf1c80$export$2e2bcd8739ae039)
};
var $5710853dffd2641f$var$BuilderGroup = /** @class */ function() {
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Max extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */ function BuilderGroup(tolerance, maxExtent, resolution, pixelRatio) {
        /**
         * @private
         * @type {number}
         */ this.tolerance_ = tolerance;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ this.maxExtent_ = maxExtent;
        /**
         * @private
         * @type {number}
         */ this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {number}
         */ this.resolution_ = resolution;
        /**
         * @private
         * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
         */ this.buildersByZIndex_ = {};
    }
    /**
     * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
     */ BuilderGroup.prototype.finish = function() {
        var builderInstructions = {};
        for(var zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            var builders = this.buildersByZIndex_[zKey];
            for(var builderKey in builders){
                var builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    };
    /**
     * @param {number|undefined} zIndex Z index.
     * @param {import("../canvas.js").BuilderType} builderType Replay type.
     * @return {import("../VectorContext.js").default} Replay.
     */ BuilderGroup.prototype.getBuilder = function(zIndex, builderType) {
        var zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        var replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        var replay = replays[builderType];
        if (replay === undefined) {
            var Constructor = $5710853dffd2641f$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    };
    return BuilderGroup;
}();
var $5710853dffd2641f$export$2e2bcd8739ae039 = $5710853dffd2641f$var$BuilderGroup;



/**
 * @module ol/render/canvas/ExecutorGroup
 */ /**
 * @module ol/render/canvas/Executor
 */ 


var $bInFo = parcelRequire("bInFo");


var $2Jl0K = parcelRequire("2Jl0K");

/**
 * @module ol/geom/flat/textpath
 */ 
var $7aO1A = parcelRequire("7aO1A");

function $f5fff6fa9e14c8df$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation) {
    var x2 = flatCoordinates[offset];
    var y2 = flatCoordinates[offset + 1];
    var x1 = 0;
    var y1 = 0;
    var segmentLength = 0;
    var segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    var interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    var beginX = (0, $7aO1A.lerp)(x1, x2, interpolate);
    var beginY = (0, $7aO1A.lerp)(y1, y2, interpolate);
    var startOffset = offset - stride;
    var startLength = segmentM;
    var endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    var endX = (0, $7aO1A.lerp)(x1, x2, interpolate);
    var endY = (0, $7aO1A.lerp)(y1, y2, interpolate);
    // Keep text upright
    var reverse;
    if (rotation) {
        var flat = [
            beginX,
            beginY,
            endX,
            endY
        ];
        (0, $d8ffc49c60e9d646$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
        reverse = flat[0] > flat[2];
    } else reverse = beginX > endX;
    var PI = Math.PI;
    var result = [];
    var singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    var previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        var x = (endX + beginX) / 2;
        var y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, ' '); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(var i = 0, ii = text.length; i < ii;){
        advance();
        var angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            var delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        var iStart = i;
        var charLength = 0;
        for(; i < ii; ++i){
            var index = reverse ? ii - i - 1 : i;
            var len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        var chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        var x = (0, $7aO1A.lerp)(x1, x2, interpolate);
        var y = (0, $7aO1A.lerp)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}



var $kzmGH = parcelRequire("kzmGH");


/**
 * @typedef {Object} BBox
 * @property {number} minX Minimal x.
 * @property {number} minY Minimal y.
 * @property {number} maxX Maximal x.
 * @property {number} maxY Maximal y
 * @property {*} value Value.
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {BBox} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D, 1: number, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ var $3ae2fc894e7aef8c$var$tmpExtent = (0, $2Jl0K.createEmpty)();
/** @type {import("../../coordinate.js").Coordinate} */ var $3ae2fc894e7aef8c$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ var $3ae2fc894e7aef8c$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ var $3ae2fc894e7aef8c$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ var $3ae2fc894e7aef8c$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {BBox} Declutter bbox.
 */ function $3ae2fc894e7aef8c$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
var $3ae2fc894e7aef8c$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ '[' + String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) + ']');
/**
 * @param {string} text Text.
 * @param {string} align Alignment.
 * @return {number} Text alignment.
 */ function $3ae2fc894e7aef8c$var$horizontalTextAlign(text, align) {
    if ((align === 'start' || align === 'end') && !$3ae2fc894e7aef8c$var$rtlRegEx.test(text)) align = align === 'start' ? 'left' : 'right';
    return (0, $f4b7a8419bdf1c80$export$91a016276e4aee96)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $3ae2fc894e7aef8c$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push('\n', '');
    acc.push(line, '');
    return acc;
}
var $3ae2fc894e7aef8c$var$Executor = /** @class */ function() {
    /**
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {boolean} overlaps The replay can have overlapping geometries.
     * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions
     */ function Executor(resolution, pixelRatio, overlaps, instructions) {
        /**
         * @protected
         * @type {boolean}
         */ this.overlaps = overlaps;
        /**
         * @protected
         * @type {number}
         */ this.pixelRatio = pixelRatio;
        /**
         * @protected
         * @const
         * @type {number}
         */ this.resolution = resolution;
        /**
         * @private
         * @type {boolean}
         */ this.alignFill_;
        /**
         * @protected
         * @type {Array<*>}
         */ this.instructions = instructions.instructions;
        /**
         * @protected
         * @type {Array<number>}
         */ this.coordinates = instructions.coordinates;
        /**
         * @private
         * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
         */ this.coordinateCache_ = {};
        /**
         * @private
         * @type {!import("../../transform.js").Transform}
         */ this.renderedTransform_ = (0, $04c1ab69f17a669b$export$185802fd694ee1f5)();
        /**
         * @protected
         * @type {Array<*>}
         */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
         * @private
         * @type {Array<number>}
         */ this.pixelCoordinates_ = null;
        /**
         * @private
         * @type {number}
         */ this.viewRotation_ = 0;
        /**
         * @type {!Object<string, import("../canvas.js").FillState>}
         */ this.fillStates = instructions.fillStates || {};
        /**
         * @type {!Object<string, import("../canvas.js").StrokeState>}
         */ this.strokeStates = instructions.strokeStates || {};
        /**
         * @type {!Object<string, import("../canvas.js").TextState>}
         */ this.textStates = instructions.textStates || {};
        /**
         * @private
         * @type {Object<string, Object<string, number>>}
         */ this.widths_ = {};
        /**
         * @private
         * @type {Object<string, import("../canvas.js").Label>}
         */ this.labels_ = {};
    }
    /**
     * @param {string|Array<string>} text Text.
     * @param {string} textKey Text style key.
     * @param {string} fillKey Fill style key.
     * @param {string} strokeKey Stroke style key.
     * @return {import("../canvas.js").Label} Label.
     */ Executor.prototype.createLabel = function(text, textKey, fillKey, strokeKey) {
        var key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        var strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        var fillState = fillKey ? this.fillStates[fillKey] : null;
        var textState = this.textStates[textKey];
        var pixelRatio = this.pixelRatio;
        var scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        var textIsArray = Array.isArray(text);
        var align = textState.justify ? (0, $f4b7a8419bdf1c80$export$91a016276e4aee96)[textState.justify] : $3ae2fc894e7aef8c$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $da04304be4865188$export$94d53b95641b5766));
        var strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        var chunks = textIsArray ? text : text.split('\n').reduce($3ae2fc894e7aef8c$var$createTextChunks, []);
        var _a = (0, $da04304be4865188$export$7d7c13020df1e791)(textState, chunks), width = _a.width, height = _a.height, widths = _a.widths, heights = _a.heights, lineWidths = _a.lineWidths;
        var renderWidth = width + strokeWidth;
        var contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        var w = (renderWidth + 2) * scale[0];
        var h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ var label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push('scale', scale);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            // eslint-disable-next-line
            var Context = (0, $bInFo.WORKER_OFFSCREEN_CANVAS) ? OffscreenCanvasRenderingContext2D : CanvasRenderingContext2D;
            if (Context.prototype.setLineDash) {
                contextInstructions.push('setLineDash', [
                    strokeState.lineDash
                ]);
                contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
            }
        }
        if (fillKey) contextInstructions.push('fillStyle', fillState.fillStyle);
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        var leftRight = 0.5 - align;
        var x = align * renderWidth + leftRight * strokeWidth;
        var strokeInstructions = [];
        var fillInstructions = [];
        var lineHeight = 0;
        var lineOffset = 0;
        var widthHeightIndex = 0;
        var lineWidthIndex = 0;
        var previousFont;
        for(var i = 0, ii = chunks.length; i < ii; i += 2){
            var text_1 = chunks[i];
            if (text_1 === '\n') {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            var font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push('font', font);
                if (fillKey) fillInstructions.push('font', font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            var fillStrokeArgs = [
                text_1,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push('strokeText', fillStrokeArgs);
            if (fillKey) fillInstructions.push('fillText', fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
     * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
     * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
     * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
     * @param {Array<*>} fillInstruction Fill instruction.
     * @param {Array<*>} strokeInstruction Stroke instruction.
     */ Executor.prototype.replayTextBackground_ = function(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignFill_ = /** @type {boolean} */ fillInstruction[2];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    };
    /**
     * @private
     * @param {number} sheetWidth Width of the sprite sheet.
     * @param {number} sheetHeight Height of the sprite sheet.
     * @param {number} centerX X.
     * @param {number} centerY Y.
     * @param {number} width Width.
     * @param {number} height Height.
     * @param {number} anchorX Anchor X.
     * @param {number} anchorY Anchor Y.
     * @param {number} originX Origin X.
     * @param {number} originY Origin Y.
     * @param {number} rotation Rotation.
     * @param {import("../../size.js").Size} scale Scale.
     * @param {boolean} snapToPixel Snap to pixel.
     * @param {Array<number>} padding Padding.
     * @param {boolean} fillStroke Background fill or stroke.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
     */ Executor.prototype.calculateImageOrLabelDimensions_ = function(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        var x = centerX - anchorX;
        var y = centerY - anchorY;
        var w = width + originX > sheetWidth ? sheetWidth - originX : width;
        var h = height + originY > sheetHeight ? sheetHeight - originY : height;
        var boxW = padding[3] + w * scale[0] + padding[1];
        var boxH = padding[0] + h * scale[1] + padding[2];
        var boxX = x - padding[3];
        var boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $3ae2fc894e7aef8c$var$p1[0] = boxX;
            $3ae2fc894e7aef8c$var$p4[0] = boxX;
            $3ae2fc894e7aef8c$var$p1[1] = boxY;
            $3ae2fc894e7aef8c$var$p2[1] = boxY;
            $3ae2fc894e7aef8c$var$p2[0] = boxX + boxW;
            $3ae2fc894e7aef8c$var$p3[0] = $3ae2fc894e7aef8c$var$p2[0];
            $3ae2fc894e7aef8c$var$p3[1] = boxY + boxH;
            $3ae2fc894e7aef8c$var$p4[1] = $3ae2fc894e7aef8c$var$p3[1];
        }
        var transform;
        if (rotation !== 0) {
            transform = (0, $04c1ab69f17a669b$export$f672e0b6f7222cd7)((0, $04c1ab69f17a669b$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(transform, $3ae2fc894e7aef8c$var$p1);
            (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(transform, $3ae2fc894e7aef8c$var$p2);
            (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(transform, $3ae2fc894e7aef8c$var$p3);
            (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(transform, $3ae2fc894e7aef8c$var$p4);
            (0, $2Jl0K.createOrUpdate)(Math.min($3ae2fc894e7aef8c$var$p1[0], $3ae2fc894e7aef8c$var$p2[0], $3ae2fc894e7aef8c$var$p3[0], $3ae2fc894e7aef8c$var$p4[0]), Math.min($3ae2fc894e7aef8c$var$p1[1], $3ae2fc894e7aef8c$var$p2[1], $3ae2fc894e7aef8c$var$p3[1], $3ae2fc894e7aef8c$var$p4[1]), Math.max($3ae2fc894e7aef8c$var$p1[0], $3ae2fc894e7aef8c$var$p2[0], $3ae2fc894e7aef8c$var$p3[0], $3ae2fc894e7aef8c$var$p4[0]), Math.max($3ae2fc894e7aef8c$var$p1[1], $3ae2fc894e7aef8c$var$p2[1], $3ae2fc894e7aef8c$var$p3[1], $3ae2fc894e7aef8c$var$p4[1]), $3ae2fc894e7aef8c$var$tmpExtent);
        } else (0, $2Jl0K.createOrUpdate)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $3ae2fc894e7aef8c$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $3ae2fc894e7aef8c$var$tmpExtent[0],
                minY: $3ae2fc894e7aef8c$var$tmpExtent[1],
                maxX: $3ae2fc894e7aef8c$var$tmpExtent[2],
                maxY: $3ae2fc894e7aef8c$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
     * @param {ImageOrLabelDimensions} dimensions Dimensions.
     * @param {number} opacity Opacity.
     * @param {Array<*>} fillInstruction Fill instruction.
     * @param {Array<*>} strokeInstruction Stroke instruction.
     * @return {boolean} The image or label was rendered.
     */ Executor.prototype.replayImageOrLabel_ = function(context, contextScale, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        var fillStroke = !!(fillInstruction || strokeInstruction);
        var box = dimensions.declutterBox;
        var canvas = context.canvas;
        var strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        var intersects = box.minX - strokePadding <= canvas.width / contextScale && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= canvas.height / contextScale && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $3ae2fc894e7aef8c$var$p1, $3ae2fc894e7aef8c$var$p2, $3ae2fc894e7aef8c$var$p3, $3ae2fc894e7aef8c$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $da04304be4865188$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     */ Executor.prototype.fill_ = function(context) {
        if (this.alignFill_) {
            var origin_1 = (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            var repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin_1[0] % repeatSize, origin_1[1] % repeatSize);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (this.alignFill_) context.restore();
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     * @param {Array<*>} instruction Instruction.
     */ Executor.prototype.setStrokeStyle_ = function(context, instruction) {
        context['strokeStyle'] = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        if (context.setLineDash) {
            context.lineDashOffset = /** @type {number} */ instruction[7];
            context.setLineDash(/** @type {Array<number>} */ instruction[6]);
        }
    };
    /**
     * @private
     * @param {string|Array<string>} text The text to draw.
     * @param {string} textKey The key of the text state.
     * @param {string} strokeKey The key for the stroke state.
     * @param {string} fillKey The key for the fill state.
     * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
     */ Executor.prototype.drawLabelWithPointPlacement_ = function(text, textKey, strokeKey, fillKey) {
        var textState = this.textStates[textKey];
        var label = this.createLabel(text, textKey, fillKey, strokeKey);
        var strokeState = this.strokeStates[strokeKey];
        var pixelRatio = this.pixelRatio;
        var align = $3ae2fc894e7aef8c$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $da04304be4865188$export$94d53b95641b5766));
        var baseline = (0, $f4b7a8419bdf1c80$export$91a016276e4aee96)[textState.textBaseline || (0, $da04304be4865188$export$cf2279a1bff62eb)];
        var strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        var width = label.width / pixelRatio - 2 * textState.scale[0];
        var anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        var anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {Array<*>} instructions Instructions array.
     * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
     * @param {FeatureCallback<T>} [opt_featureCallback] Feature callback.
     * @param {import("../../extent.js").Extent} [opt_hitExtent] Only check
     *     features that intersect this extent.
     * @param {import("rbush").default} [opt_declutterTree] Declutter tree.
     * @return {T|undefined} Callback result.
     * @template T
     */ Executor.prototype.execute_ = function(context, contextScale, transform, instructions, snapToPixel, opt_featureCallback, opt_hitExtent, opt_declutterTree) {
        /** @type {Array<number>} */ var pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $kzmGH.equals)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $d8ffc49c60e9d646$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $04c1ab69f17a669b$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        var i = 0; // instruction index
        var ii = instructions.length; // end of instructions
        var d = 0; // data index
        var dd; // end of per-instruction data
        var anchorX, anchorY, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        var pendingFill = 0;
        var pendingStroke = 0;
        var lastFillInstruction = null;
        var lastStrokeInstruction = null;
        var coordinateCache = this.coordinateCache_;
        var viewRotation = this.viewRotation_;
        var viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        var state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        var /** @type {import("../../Feature.js").FeatureLike} */ feature;
        var x, y, currentGeometry;
        while(i < ii){
            var instruction = instructions[i];
            var type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (opt_hitExtent !== undefined && !(0, $2Jl0K.intersects)(opt_hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    var x1 = pixelCoordinates[d];
                    var y1 = pixelCoordinates[d + 1];
                    var x2 = pixelCoordinates[d + 2];
                    var y2 = pixelCoordinates[d + 3];
                    var dx = x2 - x1;
                    var dy = y2 - y1;
                    var r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    var geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    var renderer = instruction[4];
                    var fn = instruction.length == 6 ? instruction[5] : undefined;
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    var coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    var height = /** @type {number} */ instruction[6];
                    var opacity = /** @type {number} */ instruction[7];
                    var originX = /** @type {number} */ instruction[8];
                    var originY = /** @type {number} */ instruction[9];
                    var rotateWithView = /** @type {boolean} */ instruction[10];
                    var rotation = /** @type {number} */ instruction[11];
                    var scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    var width = /** @type {number} */ instruction[13];
                    var declutterMode = /** @type {"declutter"|"obstacle"|"none"|undefined} */ instruction[14];
                    var declutterImageWithText = /** @type {import("../canvas.js").DeclutterImageWithText} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        var labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        var textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        var textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    var geometryWidths = void 0;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    var padding = void 0, backgroundFill = void 0, backgroundStroke = void 0;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFill = /** @type {boolean} */ instruction[17];
                        backgroundStroke = /** @type {boolean} */ instruction[18];
                    } else {
                        padding = (0, $da04304be4865188$export$40a9eeef55665a40);
                        backgroundFill = false;
                        backgroundStroke = false;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    var widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        var dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, backgroundFill || backgroundStroke, feature);
                        /** @type {ReplayImageOrLabelArgs} */ var args = [
                            context,
                            contextScale,
                            image,
                            dimensions,
                            opacity,
                            backgroundFill ? /** @type {Array<*>} */ lastFillInstruction : null,
                            backgroundStroke ? /** @type {Array<*>} */ lastStrokeInstruction : null
                        ];
                        if (opt_declutterTree) {
                            if (declutterMode === 'none') continue;
                            else if (declutterMode === 'obstacle') {
                                // will always be drawn, thus no collision detection, but insert as obstacle
                                opt_declutterTree.insert(dimensions.declutterBox);
                                continue;
                            } else {
                                var imageArgs = void 0;
                                var imageDeclutterBox = void 0;
                                if (declutterImageWithText) {
                                    var index = dd - d;
                                    if (!declutterImageWithText[index]) {
                                        // We now have the image for an image+text combination.
                                        declutterImageWithText[index] = args;
                                        continue;
                                    }
                                    imageArgs = declutterImageWithText[index];
                                    delete declutterImageWithText[index];
                                    imageDeclutterBox = $3ae2fc894e7aef8c$var$getDeclutterBox(imageArgs);
                                    if (opt_declutterTree.collides(imageDeclutterBox)) continue;
                                }
                                if (opt_declutterTree.collides(dimensions.declutterBox)) continue;
                                if (imageArgs) {
                                    // We now have image and text for an image+text combination.
                                    opt_declutterTree.insert(imageDeclutterBox);
                                    // Render the image before we render the text.
                                    this.replayImageOrLabel_.apply(this, imageArgs);
                                }
                                opt_declutterTree.insert(dimensions.declutterBox);
                            }
                        }
                        this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).DRAW_CHARS:
                    var begin = /** @type {number} */ instruction[1];
                    var end = /** @type {number} */ instruction[2];
                    var baseline = /** @type {number} */ instruction[3];
                    var overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    var maxAngle = /** @type {number} */ instruction[6];
                    var measurePixelRatio = /** @type {number} */ instruction[7];
                    var offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    var strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string} */ instruction[11];
                    textKey = /** @type {string} */ instruction[12];
                    var pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    var textState = this.textStates[textKey];
                    var font = textState.font;
                    var textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    var cachedWidths = void 0;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    var pathLength = (0, $09978a897c458dd0$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    var textLength = Math.abs(textScale[0]) * (0, $da04304be4865188$export$915c7ba51467308f)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        var textAlign = this.textStates[textKey].textAlign;
                        var startM = (pathLength - textLength) * (0, $f4b7a8419bdf1c80$export$91a016276e4aee96)[textAlign];
                        var parts = (0, $f5fff6fa9e14c8df$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $da04304be4865188$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ var replayImageOrLabelArgs = [];
                            var c = void 0, cc = void 0, chars = void 0, label = void 0, part = void 0;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, '', strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                var dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $da04304be4865188$export$40a9eeef55665a40), false, feature);
                                if (opt_declutterTree && opt_declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    contextScale,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, '');
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                var dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $da04304be4865188$export$40a9eeef55665a40), false, feature);
                                if (opt_declutterTree && opt_declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    contextScale,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (opt_declutterTree) opt_declutterTree.load(replayImageOrLabelArgs.map($3ae2fc894e7aef8c$var$getDeclutterBox));
                            for(var i_1 = 0, ii_1 = replayImageOrLabelArgs.length; i_1 < ii_1; ++i_1)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i_1]);
                        }
                    }
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (opt_featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        var result = opt_featureCallback(feature, currentGeometry);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    roundX = x + 0.5 | 0;
                    roundY = y + 0.5 | 0;
                    if (roundX !== prevX || roundY !== prevY) {
                        context.moveTo(x, y);
                        prevX = roundX;
                        prevY = roundY;
                    }
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    lastFillInstruction = instruction;
                    this.alignFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    context.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    lastStrokeInstruction = instruction;
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $7c01b5f7d070d555$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
     * @param {import("rbush").default} [opt_declutterTree] Declutter tree.
     */ Executor.prototype.execute = function(context, contextScale, transform, viewRotation, snapToPixel, opt_declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, contextScale, transform, this.instructions, snapToPixel, undefined, undefined, opt_declutterTree);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {FeatureCallback<T>} [opt_featureCallback] Feature callback.
     * @param {import("../../extent.js").Extent} [opt_hitExtent] Only check
     *     features that intersect this extent.
     * @return {T|undefined} Callback result.
     * @template T
     */ Executor.prototype.executeHitDetection = function(context, transform, viewRotation, opt_featureCallback, opt_hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, 1, transform, this.hitDetectionInstructions, true, opt_featureCallback, opt_hitExtent);
    };
    return Executor;
}();
var $3ae2fc894e7aef8c$export$2e2bcd8739ae039 = $3ae2fc894e7aef8c$var$Executor;



var $2Jl0K = parcelRequire("2Jl0K");


var $djuby = parcelRequire("djuby");

var $9zTj4 = parcelRequire("9zTj4");

var $kzmGH = parcelRequire("kzmGH");

/**
 * @const
 * @type {Array<import("../canvas.js").BuilderType>}
 */ var $2a299879c9a46d4c$var$ORDER = [
    'Polygon',
    'Circle',
    'LineString',
    'Image',
    'Text',
    'Default'
];
var $2a299879c9a46d4c$var$ExecutorGroup = /** @class */ function() {
    /**
     * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
     * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
     * should be set here, unless the target context does not exceed that extent (which
     * can be the case when rendering to tiles).
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {boolean} overlaps The executor group can have overlapping geometries.
     * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
     * The serializable instructions.
     * @param {number} [opt_renderBuffer] Optional rendering buffer.
     */ function ExecutorGroup(maxExtent, resolution, pixelRatio, overlaps, allInstructions, opt_renderBuffer) {
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ this.maxExtent_ = maxExtent;
        /**
         * @private
         * @type {boolean}
         */ this.overlaps_ = overlaps;
        /**
         * @private
         * @type {number}
         */ this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {number}
         */ this.resolution_ = resolution;
        /**
         * @private
         * @type {number|undefined}
         */ this.renderBuffer_ = opt_renderBuffer;
        /**
         * @private
         * @type {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Executor").default>>}
         */ this.executorsByZIndex_ = {};
        /**
         * @private
         * @type {CanvasRenderingContext2D}
         */ this.hitDetectionContext_ = null;
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */ this.hitDetectionTransform_ = (0, $04c1ab69f17a669b$export$185802fd694ee1f5)();
        this.createExecutors_(allInstructions);
    }
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../transform.js").Transform} transform Transform.
     */ ExecutorGroup.prototype.clip = function(context, transform) {
        var flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    };
    /**
     * Create executors and populate them using the provided instructions.
     * @private
     * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
     */ ExecutorGroup.prototype.createExecutors_ = function(allInstructions) {
        for(var zIndex in allInstructions){
            var executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            var instructionByZindex = allInstructions[zIndex];
            for(var builderType in instructionByZindex){
                var instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $3ae2fc894e7aef8c$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions);
            }
        }
    };
    /**
     * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
     * @return {boolean} Has executors of the provided types.
     */ ExecutorGroup.prototype.hasExecutors = function(executors) {
        for(var zIndex in this.executorsByZIndex_){
            var candidates = this.executorsByZIndex_[zIndex];
            for(var i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} resolution Resolution.
     * @param {number} rotation Rotation.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
     * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
     * @return {T|undefined} Callback result.
     * @template T
     */ ExecutorGroup.prototype.forEachFeatureAtCoordinate = function(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        hitTolerance = Math.round(hitTolerance);
        var contextSize = hitTolerance * 2 + 1;
        var transform = (0, $04c1ab69f17a669b$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        var newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $djuby.createCanvasContext2D)(contextSize, contextSize);
        var context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /**
         * @type {import("../../extent.js").Extent}
         */ var hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $2Jl0K.createEmpty)();
            (0, $2Jl0K.extendCoordinate)(hitExtent, coordinate);
            (0, $2Jl0K.buffer)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        var indexes = $2a299879c9a46d4c$export$96fc84ea21b8269f(hitTolerance);
        var builderType;
        /**
         * @param {import("../../Feature.js").FeatureLike} feature Feature.
         * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
         * @return {T|undefined} Callback result.
         */ function featureCallback(feature, geometry) {
            var imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(var i_1 = 0, ii = indexes.length; i_1 < ii; i_1++)if (imageData[indexes[i_1]] > 0) {
                if (!declutteredFeatures || builderType !== 'Image' && builderType !== 'Text' || declutteredFeatures.indexOf(feature) !== -1) {
                    var idx = (indexes[i_1] - 3) / 4;
                    var x = hitTolerance - idx % contextSize;
                    var y = hitTolerance - (idx / contextSize | 0);
                    var result_1 = callback(feature, geometry, x * x + y * y);
                    if (result_1) return result_1;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ var zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $kzmGH.numberSafeCompareFunction));
        var i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            var zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $2a299879c9a46d4c$var$ORDER.length - 1; j >= 0; --j){
                builderType = $2a299879c9a46d4c$var$ORDER[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    };
    /**
     * @param {import("../../transform.js").Transform} transform Transform.
     * @return {Array<number>|null} Clip coordinates.
     */ ExecutorGroup.prototype.getClipCoords = function(transform) {
        var maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        var minX = maxExtent[0];
        var minY = maxExtent[1];
        var maxX = maxExtent[2];
        var maxY = maxExtent[3];
        var flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $d8ffc49c60e9d646$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    };
    /**
     * @return {boolean} Is empty.
     */ ExecutorGroup.prototype.isEmpty = function() {
        return (0, $9zTj4.isEmpty)(this.executorsByZIndex_);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
     * @param {Array<import("../canvas.js").BuilderType>} [opt_builderTypes] Ordered replay types to replay.
     *     Default is {@link module:ol/render/replay~ORDER}
     * @param {import("rbush").default} [opt_declutterTree] Declutter tree.
     */ ExecutorGroup.prototype.execute = function(context, contextScale, transform, viewRotation, snapToPixel, opt_builderTypes, opt_declutterTree) {
        /** @type {Array<number>} */ var zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $kzmGH.numberSafeCompareFunction));
        // setup clipping so that the parts of over-simplified geometries are not
        // visible outside the current extent when panning
        if (this.maxExtent_) {
            context.save();
            this.clip(context, transform);
        }
        var builderTypes = opt_builderTypes ? opt_builderTypes : $2a299879c9a46d4c$var$ORDER;
        var i, ii, j, jj, replays, replay;
        if (opt_declutterTree) zs.reverse();
        for(i = 0, ii = zs.length; i < ii; ++i){
            var zIndexKey = zs[i].toString();
            replays = this.executorsByZIndex_[zIndexKey];
            for(j = 0, jj = builderTypes.length; j < jj; ++j){
                var builderType = builderTypes[j];
                replay = replays[builderType];
                if (replay !== undefined) replay.execute(context, contextScale, transform, viewRotation, snapToPixel, opt_declutterTree);
            }
        }
        if (this.maxExtent_) context.restore();
    };
    return ExecutorGroup;
}();
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ var $2a299879c9a46d4c$var$circlePixelIndexArrayCache = {};
function $2a299879c9a46d4c$export$96fc84ea21b8269f(radius) {
    if ($2a299879c9a46d4c$var$circlePixelIndexArrayCache[radius] !== undefined) return $2a299879c9a46d4c$var$circlePixelIndexArrayCache[radius];
    var size = radius * 2 + 1;
    var maxDistanceSq = radius * radius;
    var distances = new Array(maxDistanceSq + 1);
    for(var i = 0; i <= radius; ++i)for(var j = 0; j <= radius; ++j){
        var distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        var distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    var pixelIndex = [];
    for(var i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push.apply(pixelIndex, distances[i]);
    $2a299879c9a46d4c$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $2a299879c9a46d4c$export$2e2bcd8739ae039 = $2a299879c9a46d4c$var$ExecutorGroup;



/**
 * @module ol/render/canvas/hitdetect
 */ /**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?





var $kzmGH = parcelRequire("kzmGH");

var $2Jl0K = parcelRequire("2Jl0K");


var $4d0ac5e66fa36232$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ var $4d0ac5e66fa36232$var$CanvasImmediateRenderer = /** @class */ function(_super) {
    $4d0ac5e66fa36232$var$__extends(CanvasImmediateRenderer, _super);
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../../extent.js").Extent} extent Extent.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {number} [opt_squaredTolerance] Optional squared tolerance for simplification.
     * @param {import("../../proj.js").TransformFunction} [opt_userTransform] Transform from user to view projection.
     */ function CanvasImmediateRenderer(context, pixelRatio, extent, transform, viewRotation, opt_squaredTolerance, opt_userTransform) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {CanvasRenderingContext2D}
         */ _this.context_ = context;
        /**
         * @private
         * @type {number}
         */ _this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ _this.extent_ = extent;
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */ _this.transform_ = transform;
        /**
         * @private
         * @type {number}
         */ _this.viewRotation_ = viewRotation;
        /**
         * @private
         * @type {number}
         */ _this.squaredTolerance_ = opt_squaredTolerance;
        /**
         * @private
         * @type {import("../../proj.js").TransformFunction}
         */ _this.userTransform_ = opt_userTransform;
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */ _this.contextFillState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */ _this.contextStrokeState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").TextState}
         */ _this.contextTextState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */ _this.fillState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */ _this.strokeState_ = null;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
         */ _this.image_ = null;
        /**
         * @private
         * @type {number}
         */ _this.imageAnchorX_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageAnchorY_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageHeight_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageOpacity_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageOriginX_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.imageOriginY_ = 0;
        /**
         * @private
         * @type {boolean}
         */ _this.imageRotateWithView_ = false;
        /**
         * @private
         * @type {number}
         */ _this.imageRotation_ = 0;
        /**
         * @private
         * @type {import("../../size.js").Size}
         */ _this.imageScale_ = [
            0,
            0
        ];
        /**
         * @private
         * @type {number}
         */ _this.imageWidth_ = 0;
        /**
         * @private
         * @type {string}
         */ _this.text_ = '';
        /**
         * @private
         * @type {number}
         */ _this.textOffsetX_ = 0;
        /**
         * @private
         * @type {number}
         */ _this.textOffsetY_ = 0;
        /**
         * @private
         * @type {boolean}
         */ _this.textRotateWithView_ = false;
        /**
         * @private
         * @type {number}
         */ _this.textRotation_ = 0;
        /**
         * @private
         * @type {import("../../size.js").Size}
         */ _this.textScale_ = [
            0,
            0
        ];
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */ _this.textFillState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */ _this.textStrokeState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").TextState}
         */ _this.textState_ = null;
        /**
         * @private
         * @type {Array<number>}
         */ _this.pixelCoordinates_ = [];
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */ _this.tmpLocalTransform_ = (0, $04c1ab69f17a669b$export$185802fd694ee1f5)();
        return _this;
    }
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @private
     */ CanvasImmediateRenderer.prototype.drawImages_ = function(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        var pixelCoordinates = (0, $d8ffc49c60e9d646$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        var context = this.context_;
        var localTransform = this.tmpLocalTransform_;
        var alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        var rotation = this.imageRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(var i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            var x = pixelCoordinates[i] - this.imageAnchorX_;
            var y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                var centerX = x + this.imageAnchorX_;
                var centerY = y + this.imageAnchorY_;
                (0, $04c1ab69f17a669b$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.setTransform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.setTransform(1, 0, 0, 1, 0, 0);
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @private
     */ CanvasImmediateRenderer.prototype.drawText_ = function(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        var pixelCoordinates = (0, $d8ffc49c60e9d646$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        var context = this.context_;
        var rotation = this.textRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            var x = pixelCoordinates[offset] + this.textOffsetX_;
            var y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                var localTransform = (0, $04c1ab69f17a669b$export$f672e0b6f7222cd7)(this.tmpLocalTransform_, x, y, 1, 1, rotation, -x, -y);
                context.setTransform.apply(context, localTransform);
                context.translate(x, y);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.setTransform(1, 0, 0, 1, 0, 0);
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @param {boolean} close Close.
     * @private
     * @return {number} end End.
     */ CanvasImmediateRenderer.prototype.moveToLineTo_ = function(flatCoordinates, offset, end, stride, close) {
        var context = this.context_;
        var pixelCoordinates = (0, $d8ffc49c60e9d646$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        var length = pixelCoordinates.length;
        if (close) length -= 2;
        for(var i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {Array<number>} ends Ends.
     * @param {number} stride Stride.
     * @private
     * @return {number} End.
     */ CanvasImmediateRenderer.prototype.drawRings_ = function(flatCoordinates, offset, ends, stride) {
        for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        return offset;
    };
    /**
     * Render a circle geometry into the canvas.  Rendering is immediate and uses
     * the current fill and stroke styles.
     *
     * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
     * @api
     */ CanvasImmediateRenderer.prototype.drawCircle = function(geometry) {
        if (!(0, $2Jl0K.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            var pixelCoordinates = (0, $29fd4fdf263dcdf4$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            var dx = pixelCoordinates[2] - pixelCoordinates[0];
            var dy = pixelCoordinates[3] - pixelCoordinates[1];
            var radius = Math.sqrt(dx * dx + dy * dy);
            var context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') this.drawText_(geometry.getCenter(), 0, 2, 2);
    };
    /**
     * Set the rendering style.  Note that since this is an immediate rendering API,
     * any `zIndex` on the provided style will be ignored.
     *
     * @param {import("../../style/Style.js").default} style The rendering style.
     * @api
     */ CanvasImmediateRenderer.prototype.setStyle = function(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    };
    /**
     * @param {import("../../transform.js").Transform} transform Transform.
     */ CanvasImmediateRenderer.prototype.setTransform = function(transform) {
        this.transform_ = transform;
    };
    /**
     * Render a geometry into the canvas.  Call
     * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
     *
     * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
     * @api
     */ CanvasImmediateRenderer.prototype.drawGeometry = function(geometry) {
        var type = geometry.getType();
        switch(type){
            case 'Point':
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case 'LineString':
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case 'Polygon':
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case 'MultiPoint':
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case 'MultiLineString':
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case 'MultiPolygon':
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case 'GeometryCollection':
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case 'Circle':
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    };
    /**
     * Render a feature into the canvas.  Note that any `zIndex` on the provided
     * style will be ignored - features are rendered immediately in the order that
     * this method is called.  If you need `zIndex` support, you should be using an
     * {@link module:ol/layer/Vector~VectorLayer VectorLayer} instead.
     *
     * @param {import("../../Feature.js").default} feature Feature.
     * @param {import("../../style/Style.js").default} style Style.
     * @api
     */ CanvasImmediateRenderer.prototype.drawFeature = function(feature, style) {
        var geometry = style.getGeometryFunction()(feature);
        if (!geometry || !(0, $2Jl0K.intersects)(this.extent_, geometry.getExtent())) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    };
    /**
     * Render a GeometryCollection to the canvas.  Rendering is immediate and
     * uses the current styles appropriate for each geometry in the collection.
     *
     * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
     */ CanvasImmediateRenderer.prototype.drawGeometryCollection = function(geometry) {
        var geometries = geometry.getGeometriesArray();
        for(var i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    };
    /**
     * Render a Point geometry into the canvas.  Rendering is immediate and uses
     * the current style.
     *
     * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
     */ CanvasImmediateRenderer.prototype.drawPoint = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        var flatCoordinates = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    };
    /**
     * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
     * uses the current style.
     *
     * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
     */ CanvasImmediateRenderer.prototype.drawMultiPoint = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        var flatCoordinates = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    };
    /**
     * Render a LineString into the canvas.  Rendering is immediate and uses
     * the current style.
     *
     * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
     */ CanvasImmediateRenderer.prototype.drawLineString = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $2Jl0K.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== '') {
            var flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    };
    /**
     * Render a MultiLineString geometry into the canvas.  Rendering is immediate
     * and uses the current style.
     *
     * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
     */ CanvasImmediateRenderer.prototype.drawMultiLineString = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        var geometryExtent = geometry.getExtent();
        if (!(0, $2Jl0K.intersects)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getFlatCoordinates();
            var offset = 0;
            var ends = /** @type {Array<number>} */ geometry.getEnds();
            var stride = geometry.getStride();
            context.beginPath();
            for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            context.stroke();
        }
        if (this.text_ !== '') {
            var flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    };
    /**
     * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
     * the current style.
     *
     * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
     */ CanvasImmediateRenderer.prototype.drawPolygon = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $2Jl0K.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            var flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    };
    /**
     * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
     * uses the current style.
     * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
     */ CanvasImmediateRenderer.prototype.drawMultiPolygon = function(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $2Jl0K.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getOrientedFlatCoordinates();
            var offset = 0;
            var endss = geometry.getEndss();
            var stride = geometry.getStride();
            context.beginPath();
            for(var i = 0, ii = endss.length; i < ii; ++i){
                var ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            var flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    };
    /**
     * @param {import("../canvas.js").FillState} fillState Fill state.
     * @private
     */ CanvasImmediateRenderer.prototype.setContextFillState_ = function(fillState) {
        var context = this.context_;
        var contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    };
    /**
     * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
     * @private
     */ CanvasImmediateRenderer.prototype.setContextStrokeState_ = function(strokeState) {
        var context = this.context_;
        var contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            if (context.setLineDash) {
                context.setLineDash(strokeState.lineDash);
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (context.setLineDash) {
                if (!(0, $kzmGH.equals)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
                if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                    contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                    context.lineDashOffset = strokeState.lineDashOffset;
                }
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    };
    /**
     * @param {import("../canvas.js").TextState} textState Text state.
     * @private
     */ CanvasImmediateRenderer.prototype.setContextTextState_ = function(textState) {
        var context = this.context_;
        var contextTextState = this.contextTextState_;
        var textAlign = textState.textAlign ? textState.textAlign : (0, $da04304be4865188$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = /** @type {CanvasTextAlign} */ textAlign;
            context.textBaseline = /** @type {CanvasTextBaseline} */ textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = /** @type {CanvasTextAlign} */ textAlign;
                context.textAlign = /** @type {CanvasTextAlign} */ textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = /** @type {CanvasTextBaseline} */ textState.textBaseline;
                context.textBaseline = /** @type {CanvasTextBaseline} */ textState.textBaseline;
            }
        }
    };
    /**
     * Set the fill and stroke style for subsequent draw operations.  To clear
     * either fill or stroke styles, pass null for the appropriate parameter.
     *
     * @param {import("../../style/Fill.js").default} fillStyle Fill style.
     * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
     */ CanvasImmediateRenderer.prototype.setFillStrokeStyle = function(fillStyle, strokeStyle) {
        var _this = this;
        if (!fillStyle) this.fillState_ = null;
        else {
            var fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $da04304be4865188$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            var strokeStyleColor = strokeStyle.getColor();
            var strokeStyleLineCap = strokeStyle.getLineCap();
            var strokeStyleLineDash = strokeStyle.getLineDash();
            var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            var strokeStyleLineJoin = strokeStyle.getLineJoin();
            var strokeStyleWidth = strokeStyle.getWidth();
            var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            var lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $da04304be4865188$export$e21b4112fdc612fc);
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $da04304be4865188$export$17bd0c38d6ae694e),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map(function(n) {
                    return n * _this.pixelRatio_;
                }),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $da04304be4865188$export$e06efc2409049f76)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $da04304be4865188$export$365eb9648cf19bd0),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $da04304be4865188$export$79661f132c62010e)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $da04304be4865188$export$80c1c01844597b7b),
                strokeStyle: (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $da04304be4865188$export$1eb2eaecacf2031e))
            };
        }
    };
    /**
     * Set the image style for subsequent draw operations.  Pass null to remove
     * the image style.
     *
     * @param {import("../../style/Image.js").default} imageStyle Image style.
     */ CanvasImmediateRenderer.prototype.setImageStyle = function(imageStyle) {
        var imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        var imageAnchor = imageStyle.getAnchor();
        var imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * this.pixelRatio_;
        this.imageAnchorY_ = imageAnchor[1] * this.pixelRatio_;
        this.imageHeight_ = imageSize[1] * this.pixelRatio_;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        this.imageScale_ = imageStyle.getScaleArray();
        this.imageWidth_ = imageSize[0] * this.pixelRatio_;
    };
    /**
     * Set the text style for subsequent draw operations.  Pass null to
     * remove the text style.
     *
     * @param {import("../../style/Text.js").default} textStyle Text style.
     */ CanvasImmediateRenderer.prototype.setTextStyle = function(textStyle) {
        if (!textStyle) this.text_ = '';
        else {
            var textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                var textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $da04304be4865188$export$c495d52ee3fd74b2))
                };
            }
            var textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                var textStrokeStyleColor = textStrokeStyle.getColor();
                var textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                var textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                var textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                var textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                var textStrokeStyleWidth = textStrokeStyle.getWidth();
                var textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $da04304be4865188$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $da04304be4865188$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $da04304be4865188$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $da04304be4865188$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $da04304be4865188$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $da04304be4865188$export$80c1c01844597b7b),
                    strokeStyle: (0, $1ff9f2ef453cd345$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $da04304be4865188$export$1eb2eaecacf2031e))
                };
            }
            var textFont = textStyle.getFont();
            var textOffsetX = textStyle.getOffsetX();
            var textOffsetY = textStyle.getOffsetY();
            var textRotateWithView = textStyle.getRotateWithView();
            var textRotation = textStyle.getRotation();
            var textScale = textStyle.getScaleArray();
            var textText = textStyle.getText();
            var textTextAlign = textStyle.getTextAlign();
            var textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $da04304be4865188$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $da04304be4865188$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $da04304be4865188$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce(function(acc, t, i) {
                return acc += i % 2 ? ' ' : t;
            }, '') : textText : '';
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    };
    return CanvasImmediateRenderer;
}((0, $a679a2d97e9b2dc2$export$2e2bcd8739ae039));
var $4d0ac5e66fa36232$export$2e2bcd8739ae039 = $4d0ac5e66fa36232$var$CanvasImmediateRenderer;


/**
 * @module ol/style/IconAnchorUnits
 */ /**
 * Icon anchor units. One of 'fraction', 'pixels'.
 * @enum {string}
 */ var $3ee40151c5a3526b$export$2e2bcd8739ae039 = {
    /**
     * Anchor is a fraction
     * @api
     */ FRACTION: 'fraction',
    /**
     * Anchor is in pixels
     * @api
     */ PIXELS: 'pixels'
};



var $cFmyb = parcelRequire("cFmyb");

/**
 * @module ol/style/IconOrigin
 */ /**
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 * @enum {string}
 */ var $f8fb29f3f4537f8a$export$2e2bcd8739ae039 = {
    /**
     * Origin is at bottom left
     * @api
     */ BOTTOM_LEFT: 'bottom-left',
    /**
     * Origin is at bottom right
     * @api
     */ BOTTOM_RIGHT: 'bottom-right',
    /**
     * Origin is at top left
     * @api
     */ TOP_LEFT: 'top-left',
    /**
     * Origin is at top right
     * @api
     */ TOP_RIGHT: 'top-right'
};






var $3JLp3 = parcelRequire("3JLp3");
/**
 * @module ol/style/IconImage
 */ 
var $gNCG1 = parcelRequire("gNCG1");

var $cFmyb = parcelRequire("cFmyb");



var $djuby = parcelRequire("djuby");


var $c57361bd5ae11623$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @type {CanvasRenderingContext2D}
 */ var $c57361bd5ae11623$var$taintedTestContext = null;
var $c57361bd5ae11623$var$IconImage = /** @class */ function(_super) {
    $c57361bd5ae11623$var$__extends(IconImage, _super);
    /**
     * @param {HTMLImageElement|HTMLCanvasElement} image Image.
     * @param {string|undefined} src Src.
     * @param {import("../size.js").Size} size Size.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../ImageState.js").default} imageState Image state.
     * @param {import("../color.js").Color} color Color.
     */ function IconImage(image, src, size, crossOrigin, imageState, color) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {HTMLImageElement|HTMLCanvasElement}
         */ _this.hitDetectionImage_ = null;
        /**
         * @private
         * @type {HTMLImageElement|HTMLCanvasElement}
         */ _this.image_ = !image ? new Image() : image;
        if (crossOrigin !== null) /** @type {HTMLImageElement} */ _this.image_.crossOrigin = crossOrigin;
        /**
         * @private
         * @type {Object<number, HTMLCanvasElement>}
         */ _this.canvas_ = {};
        /**
         * @private
         * @type {import("../color.js").Color}
         */ _this.color_ = color;
        /**
         * @private
         * @type {?function():void}
         */ _this.unlisten_ = null;
        /**
         * @private
         * @type {import("../ImageState.js").default}
         */ _this.imageState_ = imageState;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ _this.size_ = size;
        /**
         * @private
         * @type {string|undefined}
         */ _this.src_ = src;
        /**
         * @private
         */ _this.tainted_;
        return _this;
    }
    /**
     * @private
     * @return {boolean} The image canvas is tainted.
     */ IconImage.prototype.isTainted_ = function() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED) {
            if (!$c57361bd5ae11623$var$taintedTestContext) $c57361bd5ae11623$var$taintedTestContext = (0, $djuby.createCanvasContext2D)(1, 1);
            $c57361bd5ae11623$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $c57361bd5ae11623$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch (e) {
                $c57361bd5ae11623$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    };
    /**
     * @private
     */ IconImage.prototype.dispatchChangeEvent_ = function() {
        this.dispatchEvent((0, $cFmyb.default).CHANGE);
    };
    /**
     * @private
     */ IconImage.prototype.handleImageError_ = function() {
        this.imageState_ = (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.dispatchChangeEvent_();
    };
    /**
     * @private
     */ IconImage.prototype.handleImageLoad_ = function() {
        this.imageState_ = (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED;
        if (this.size_) {
            this.image_.width = this.size_[0];
            this.image_.height = this.size_[1];
        } else this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.unlistenImage_();
        this.dispatchChangeEvent_();
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
     */ IconImage.prototype.getImage = function(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Image or Canvas element.
     */ IconImage.prototype.getPixelRatio = function(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    };
    /**
     * @return {import("../ImageState.js").default} Image state.
     */ IconImage.prototype.getImageState = function() {
        return this.imageState_;
    };
    /**
     * @return {HTMLImageElement|HTMLCanvasElement} Image element.
     */ IconImage.prototype.getHitDetectionImage = function() {
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                var width = this.size_[0];
                var height = this.size_[1];
                var context = (0, $djuby.createCanvasContext2D)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    };
    /**
     * Get the size of the icon (in pixels).
     * @return {import("../size.js").Size} Image size.
     */ IconImage.prototype.getSize = function() {
        return this.size_;
    };
    /**
     * @return {string|undefined} Image src.
     */ IconImage.prototype.getSrc = function() {
        return this.src_;
    };
    /**
     * Load not yet loaded URI.
     */ IconImage.prototype.load = function() {
        if (this.imageState_ == (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).IDLE) {
            this.imageState_ = (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADING;
            try {
                /** @type {HTMLImageElement} */ this.image_.src = this.src_;
            } catch (e) {
                this.handleImageError_();
            }
            this.unlisten_ = (0, $1548b965f58c9226$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @private
     */ IconImage.prototype.replaceColor_ = function(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED) return;
        var canvas = document.createElement('canvas');
        this.canvas_[pixelRatio] = canvas;
        canvas.width = Math.ceil(this.image_.width * pixelRatio);
        canvas.height = Math.ceil(this.image_.height * pixelRatio);
        var ctx = canvas.getContext('2d');
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(this.image_, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        // Internet Explorer 11 does not support the multiply operation.
        // If the canvas is tainted in Internet Explorer this still produces
        // a solid color image with the shape of the icon.
        if (ctx.globalCompositeOperation === 'multiply' || this.isTainted_()) {
            ctx.fillStyle = (0, $520f75f61db85ab0$export$590567be997858b6)(this.color_);
            ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
            ctx.globalCompositeOperation = 'destination-in';
            ctx.drawImage(this.image_, 0, 0);
        } else {
            var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            var data = imgData.data;
            var r = this.color_[0] / 255.0;
            var g = this.color_[1] / 255.0;
            var b = this.color_[2] / 255.0;
            var a = this.color_[3];
            for(var i = 0, ii = data.length; i < ii; i += 4){
                data[i] *= r;
                data[i + 1] *= g;
                data[i + 2] *= b;
                data[i + 3] *= a;
            }
            ctx.putImageData(imgData, 0, 0);
        }
    };
    /**
     * Discards event handlers which listen for load completion or errors.
     *
     * @private
     */ IconImage.prototype.unlistenImage_ = function() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    };
    return IconImage;
}((0, $gNCG1.default));
function $c57361bd5ae11623$export$3988ae62b71be9a3(image, src, size, crossOrigin, imageState, color) {
    var iconImage = (0, $cb8fc27afe912dc5$export$747ccdf771a87ab8).get(src, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $c57361bd5ae11623$var$IconImage(image, src, size, crossOrigin, imageState, color);
        (0, $cb8fc27afe912dc5$export$747ccdf771a87ab8).set(src, crossOrigin, color, iconImage);
    }
    return iconImage;
}
var $c57361bd5ae11623$export$2e2bcd8739ae039 = $c57361bd5ae11623$var$IconImage;



var $61DUI = parcelRequire("61DUI");
var $4cbcbd646f2e2083$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {import("./IconOrigin.js").default} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("./IconAnchorUnits.js").default} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {import("./IconAnchorUnits.js").default} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement} [img] Image object for the icon. If the `src` option is not provided then the
 * provided image must already be loaded. And in that case, it is required
 * to provide the size of the image, with the `imgSize` option.
 * @property {Array<number>} [offset=[0, 0]] Offset, which, together with the size and the offset origin, define the
 * sub-rectangle to use from the original icon image.
 * @property {Array<number>} [displacement=[0,0]] Displacement of the icon.
 * @property {import("./IconOrigin.js").default} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {import("../size.js").Size} [size] Icon size in pixel. Can be used together with `offset` to define the
 * sub-rectangle to use from the origin (sprite) icon image.
 * @property {import("../size.js").Size} [imgSize] Image size in pixels. Only required if `img` is set and `src` is not, and
 * for SVG images in Internet Explorer 11. The provided `imgSize` needs to match the actual size of the image.
 * @property {string} [src] Image source URI.
 * @property {"declutter"|"obstacle"|"none"|undefined} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ var $4cbcbd646f2e2083$var$Icon = /** @class */ function(_super) {
    $4cbcbd646f2e2083$var$__extends(Icon, _super);
    /**
     * @param {Options} [opt_options] Options.
     */ function Icon(opt_options) {
        var _this = this;
        var options = opt_options || {};
        /**
         * @type {number}
         */ var opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
         * @type {number}
         */ var rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
         * @type {number|import("../size.js").Size}
         */ var scale = options.scale !== undefined ? options.scale : 1;
        /**
         * @type {boolean}
         */ var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        _this = _super.call(this, {
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        }) || this;
        /**
         * @private
         * @type {Array<number>}
         */ _this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
         * @private
         * @type {Array<number>}
         */ _this.normalizedAnchor_ = null;
        /**
         * @private
         * @type {import("./IconOrigin.js").default}
         */ _this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).TOP_LEFT;
        /**
         * @private
         * @type {import("./IconAnchorUnits.js").default}
         */ _this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : (0, $3ee40151c5a3526b$export$2e2bcd8739ae039).FRACTION;
        /**
         * @private
         * @type {import("./IconAnchorUnits.js").default}
         */ _this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : (0, $3ee40151c5a3526b$export$2e2bcd8739ae039).FRACTION;
        /**
         * @private
         * @type {?string}
         */ _this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
         * @type {HTMLImageElement|HTMLCanvasElement}
         */ var image = options.img !== undefined ? options.img : null;
        /**
         * @private
         * @type {import("../size.js").Size|undefined}
         */ _this.imgSize_ = options.imgSize;
        /**
         * @type {string|undefined}
         */ var src = options.src;
        (0, $3JLp3.assert)(!(src !== undefined && image), 4); // `image` and `src` cannot be provided at the same time
        (0, $3JLp3.assert)(!image || image && _this.imgSize_, 5); // `imgSize` must be set when `image` is provided
        if ((src === undefined || src.length === 0) && image) src = /** @type {HTMLImageElement} */ image.src || (0, $61DUI.getUid)(image);
        (0, $3JLp3.assert)(src !== undefined && src.length > 0, 6); // A defined and non-empty `src` or `image` must be provided
        /**
         * @type {import("../ImageState.js").default}
         */ var imageState = options.src !== undefined ? (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).IDLE : (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED;
        /**
         * @private
         * @type {import("../color.js").Color}
         */ _this.color_ = options.color !== undefined ? (0, $520f75f61db85ab0$export$75093a47a9fa838d)(options.color) : null;
        /**
         * @private
         * @type {import("./IconImage.js").default}
         */ _this.iconImage_ = (0, $c57361bd5ae11623$export$3988ae62b71be9a3)(image, /** @type {string} */ src, _this.imgSize_ !== undefined ? _this.imgSize_ : null, _this.crossOrigin_, imageState, _this.color_);
        /**
         * @private
         * @type {Array<number>}
         */ _this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
         * @private
         * @type {import("./IconOrigin.js").default}
         */ _this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).TOP_LEFT;
        /**
         * @private
         * @type {Array<number>}
         */ _this.origin_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ _this.size_ = options.size !== undefined ? options.size : null;
        return _this;
    }
    /**
     * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
     * @return {Icon} The cloned style.
     * @api
     */ Icon.prototype.clone = function() {
        var scale = this.getScale();
        return new Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            imgSize: this.imgSize_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    };
    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @return {Array<number>} Anchor.
     * @api
     */ Icon.prototype.getAnchor = function() {
        var anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            var size = this.getSize();
            if (this.anchorXUnits_ == (0, $3ee40151c5a3526b$export$2e2bcd8739ae039).FRACTION || this.anchorYUnits_ == (0, $3ee40151c5a3526b$export$2e2bcd8739ae039).FRACTION) {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == (0, $3ee40151c5a3526b$export$2e2bcd8739ae039).FRACTION) anchor[0] *= size[0];
                if (this.anchorYUnits_ == (0, $3ee40151c5a3526b$export$2e2bcd8739ae039).FRACTION) anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).TOP_LEFT) {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).TOP_RIGHT || this.anchorOrigin_ == (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).BOTTOM_RIGHT) anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).BOTTOM_LEFT || this.anchorOrigin_ == (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).BOTTOM_RIGHT) anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        var displacement = this.getDisplacement();
        return [
            anchor[0] - displacement[0],
            anchor[1] + displacement[1]
        ];
    };
    /**
     * Set the anchor point. The anchor determines the center point for the
     * symbolizer.
     *
     * @param {Array<number>} anchor Anchor.
     * @api
     */ Icon.prototype.setAnchor = function(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    };
    /**
     * Get the icon color.
     * @return {import("../color.js").Color} Color.
     * @api
     */ Icon.prototype.getColor = function() {
        return this.color_;
    };
    /**
     * Get the image icon.
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
     * @api
     */ Icon.prototype.getImage = function(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    };
    /**
     * Get the pixel ratio.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} The pixel ratio of the image.
     * @api
     */ Icon.prototype.getPixelRatio = function(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    };
    /**
     * @return {import("../size.js").Size} Image size.
     */ Icon.prototype.getImageSize = function() {
        return this.iconImage_.getSize();
    };
    /**
     * @return {import("../ImageState.js").default} Image state.
     */ Icon.prototype.getImageState = function() {
        return this.iconImage_.getImageState();
    };
    /**
     * @return {HTMLImageElement|HTMLCanvasElement} Image element.
     */ Icon.prototype.getHitDetectionImage = function() {
        return this.iconImage_.getHitDetectionImage();
    };
    /**
     * Get the origin of the symbolizer.
     * @return {Array<number>} Origin.
     * @api
     */ Icon.prototype.getOrigin = function() {
        if (this.origin_) return this.origin_;
        var offset = this.offset_;
        if (this.offsetOrigin_ != (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).TOP_LEFT) {
            var size = this.getSize();
            var iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).TOP_RIGHT || this.offsetOrigin_ == (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).BOTTOM_RIGHT) offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).BOTTOM_LEFT || this.offsetOrigin_ == (0, $f8fb29f3f4537f8a$export$2e2bcd8739ae039).BOTTOM_RIGHT) offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    };
    /**
     * Get the image URL.
     * @return {string|undefined} Image src.
     * @api
     */ Icon.prototype.getSrc = function() {
        return this.iconImage_.getSrc();
    };
    /**
     * Get the size of the icon (in pixels).
     * @return {import("../size.js").Size} Image size.
     * @api
     */ Icon.prototype.getSize = function() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ Icon.prototype.listenImageChange = function(listener) {
        this.iconImage_.addEventListener((0, $cFmyb.default).CHANGE, listener);
    };
    /**
     * Load not yet loaded URI.
     * When rendering a feature with an icon style, the vector renderer will
     * automatically call this method. However, you might want to call this
     * method yourself for preloading or other purposes.
     * @api
     */ Icon.prototype.load = function() {
        this.iconImage_.load();
    };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */ Icon.prototype.unlistenImageChange = function(listener) {
        this.iconImage_.removeEventListener((0, $cFmyb.default).CHANGE, listener);
    };
    return Icon;
}((0, $dc2b88278baca076$export$2e2bcd8739ae039));
var $4cbcbd646f2e2083$export$2e2bcd8739ae039 = $4cbcbd646f2e2083$var$Icon;



var $7aO1A = parcelRequire("7aO1A");

var $djuby = parcelRequire("djuby");

var $2Jl0K = parcelRequire("2Jl0K");

var $kzmGH = parcelRequire("kzmGH");
var $94715bcc7d6d2524$export$ab51038298418f25 = 0.5;
function $94715bcc7d6d2524$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation) {
    var width = size[0] * $94715bcc7d6d2524$export$ab51038298418f25;
    var height = size[1] * $94715bcc7d6d2524$export$ab51038298418f25;
    var context = (0, $djuby.createCanvasContext2D)(width, height);
    context.imageSmoothingEnabled = false;
    var canvas = context.canvas;
    var renderer = new (0, $4d0ac5e66fa36232$export$2e2bcd8739ae039)(context, $94715bcc7d6d2524$export$ab51038298418f25, extent, null, rotation);
    var featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    var indexFactor = Math.floor(16777215 / featureCount);
    var featuresByZIndex = {};
    for(var i = 1; i <= featureCount; ++i){
        var feature = features[i - 1];
        var featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!styleFunction) continue;
        var styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        var index = i * indexFactor;
        var color = '#' + ('000000' + index.toString(16)).slice(-6);
        for(var j = 0, jj = styles.length; j < jj; ++j){
            var originalStyle = styles[j];
            var geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $2Jl0K.intersects)(extent, geometry.getExtent())) continue;
            var style = originalStyle.clone();
            var fill = style.getFill();
            if (fill) fill.setColor(color);
            var stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            var image = originalStyle.getImage();
            if (image && image.getOpacity() !== 0) {
                var imgSize = image.getImageSize();
                if (!imgSize) continue;
                var imgContext = (0, $djuby.createCanvasContext2D)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                var img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $4cbcbd646f2e2083$export$2e2bcd8739ae039)({
                    img: img,
                    imgSize: imgSize,
                    anchor: image.getAnchor(),
                    anchorXUnits: (0, $3ee40151c5a3526b$export$2e2bcd8739ae039).PIXELS,
                    anchorYUnits: (0, $3ee40151c5a3526b$export$2e2bcd8739ae039).PIXELS,
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            var zIndex = style.getZIndex() || 0;
            var byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType['Polygon'] = [];
                byGeometryType['Circle'] = [];
                byGeometryType['LineString'] = [];
                byGeometryType['Point'] = [];
            }
            byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
        }
    }
    var zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $kzmGH.numberSafeCompareFunction));
    for(var i = 0, ii = zIndexKeys.length; i < ii; ++i){
        var byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(var type in byGeometryType){
            var geomAndStyle = byGeometryType[type];
            for(var j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(var k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $94715bcc7d6d2524$export$6d4d555ddbfffa32(pixel, features, imageData) {
    var resultFeatures = [];
    if (imageData) {
        var x = Math.floor(Math.round(pixel[0]) * $94715bcc7d6d2524$export$ab51038298418f25);
        var y = Math.floor(Math.round(pixel[1]) * $94715bcc7d6d2524$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        var index = ((0, $7aO1A.clamp)(x, 0, imageData.width - 1) + (0, $7aO1A.clamp)(y, 0, imageData.height - 1) * imageData.width) * 4;
        var r = imageData.data[index];
        var g = imageData.data[index + 1];
        var b = imageData.data[index + 2];
        var i = b + 256 * (g + 256 * r);
        var indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}




var $2Jl0K = parcelRequire("2Jl0K");

var $djuby = parcelRequire("djuby");
/**
 * @module ol/renderer/vector
 */ 

var $61DUI = parcelRequire("61DUI");
/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ var $2c19c3cc1ff25558$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ var $2c19c3cc1ff25558$var$GEOMETRY_RENDERERS = {
    'Point': $2c19c3cc1ff25558$var$renderPointGeometry,
    'LineString': $2c19c3cc1ff25558$var$renderLineStringGeometry,
    'Polygon': $2c19c3cc1ff25558$var$renderPolygonGeometry,
    'MultiPoint': $2c19c3cc1ff25558$var$renderMultiPointGeometry,
    'MultiLineString': $2c19c3cc1ff25558$var$renderMultiLineStringGeometry,
    'MultiPolygon': $2c19c3cc1ff25558$var$renderMultiPolygonGeometry,
    'GeometryCollection': $2c19c3cc1ff25558$var$renderGeometryCollectionGeometry,
    'Circle': $2c19c3cc1ff25558$var$renderCircleGeometry
};
function $2c19c3cc1ff25558$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $61DUI.getUid)(feature1), 10) - parseInt((0, $61DUI.getUid)(feature2), 10);
}
function $2c19c3cc1ff25558$export$75084a70d324c1e6(resolution, pixelRatio) {
    var tolerance = $2c19c3cc1ff25558$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $2c19c3cc1ff25558$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $2c19c3cc1ff25558$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */ function $2c19c3cc1ff25558$var$renderCircleGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var circleReplay = builderGroup.getBuilder(style.getZIndex(), 'Circle');
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $2c19c3cc1ff25558$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, opt_transform, opt_declutterBuilderGroup) {
    var loading = false;
    var imageStyle = style.getImage();
    if (imageStyle) {
        var imageState = imageStyle.getImageState();
        if (imageState == (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED || imageState == (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).ERROR) imageStyle.unlistenImageChange(listener);
        else {
            if (imageState == (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).IDLE) imageStyle.load();
            imageStyle.listenImageChange(listener);
            loading = true;
        }
    }
    $2c19c3cc1ff25558$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, opt_transform, opt_declutterBuilderGroup);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */ function $2c19c3cc1ff25558$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, opt_transform, opt_declutterBuilderGroup) {
    var geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    var simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, opt_transform);
    var renderer = style.getRenderer();
    if (renderer) $2c19c3cc1ff25558$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature);
    else {
        var geometryRenderer = $2c19c3cc1ff25558$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, opt_declutterBuilderGroup);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */ function $2c19c3cc1ff25558$var$renderGeometry(replayGroup, geometry, style, feature) {
    if (geometry.getType() == 'GeometryCollection') {
        var geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(var i = 0, ii = geometries.length; i < ii; ++i)$2c19c3cc1ff25558$var$renderGeometry(replayGroup, geometries[i], style, feature);
        return;
    }
    var replay = replayGroup.getBuilder(style.getZIndex(), 'Default');
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer());
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */ function $2c19c3cc1ff25558$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var geometries = geometry.getGeometriesArray();
    var i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        var geometryRenderer = $2c19c3cc1ff25558$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, opt_declutterBuilderGroup);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */ function $2c19c3cc1ff25558$var$renderLineStringGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */ function $2c19c3cc1ff25558$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */ function $2c19c3cc1ff25558$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        var polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */ function $2c19c3cc1ff25558$var$renderPointGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var imageStyle = style.getImage();
    var textStyle = style.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ var declutterImageWithText;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED) return;
        var imageBuilderGroup = builderGroup;
        if (opt_declutterBuilderGroup) {
            var declutterMode = imageStyle.getDeclutterMode();
            if (declutterMode !== 'none') {
                imageBuilderGroup = opt_declutterBuilderGroup;
                if (declutterMode === 'obstacle') {
                    // draw in non-declutter group:
                    var imageReplay_1 = builderGroup.getBuilder(style.getZIndex(), 'Image');
                    imageReplay_1.setImageStyle(imageStyle, declutterImageWithText);
                    imageReplay_1.drawPoint(geometry, feature);
                } else if (textStyle && textStyle.getText()) declutterImageWithText = {};
            }
        }
        var imageReplay = imageBuilderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature);
    }
    if (textStyle && textStyle.getText()) {
        var textBuilderGroup = builderGroup;
        if (opt_declutterBuilderGroup) textBuilderGroup = opt_declutterBuilderGroup;
        var textReplay = textBuilderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */ function $2c19c3cc1ff25558$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var imageStyle = style.getImage();
    var textStyle = style.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ var declutterImageWithText;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $a7eed36cc9f4d31d$export$2e2bcd8739ae039).LOADED) return;
        var imageBuilderGroup = builderGroup;
        if (opt_declutterBuilderGroup) {
            var declutterMode = imageStyle.getDeclutterMode();
            if (declutterMode !== 'none') {
                imageBuilderGroup = opt_declutterBuilderGroup;
                if (declutterMode === 'obstacle') {
                    // draw in non-declutter group:
                    var imageReplay_2 = builderGroup.getBuilder(style.getZIndex(), 'Image');
                    imageReplay_2.setImageStyle(imageStyle, declutterImageWithText);
                    imageReplay_2.drawMultiPoint(geometry, feature);
                } else if (textStyle && textStyle.getText()) declutterImageWithText = {};
            }
        }
        var imageReplay = imageBuilderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature);
    }
    if (textStyle && textStyle.getText()) {
        var textBuilderGroup = builderGroup;
        if (opt_declutterBuilderGroup) textBuilderGroup = opt_declutterBuilderGroup;
        var textReplay = textBuilderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */ function $2c19c3cc1ff25558$var$renderPolygonGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}



var $kzmGH = parcelRequire("kzmGH");


var $61DUI = parcelRequire("61DUI");

var $d60c04b96bd8ea74$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ var $d60c04b96bd8ea74$var$CanvasVectorLayerRenderer = /** @class */ function(_super) {
    $d60c04b96bd8ea74$var$__extends(CanvasVectorLayerRenderer, _super);
    /**
     * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
     */ function CanvasVectorLayerRenderer(vectorLayer) {
        var _this = _super.call(this, vectorLayer) || this;
        /** @private */ _this.boundHandleStyleImageChange_ = _this.handleStyleImageChange_.bind(_this);
        /**
         * @type {boolean}
         */ _this.animatingOrInteracting_;
        /**
         * @type {ImageData}
         */ _this.hitDetectionImageData_ = null;
        /**
         * @type {Array<import("../../Feature.js").default>}
         */ _this.renderedFeatures_ = null;
        /**
         * @private
         * @type {number}
         */ _this.renderedRevision_ = -1;
        /**
         * @private
         * @type {number}
         */ _this.renderedResolution_ = NaN;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ _this.renderedExtent_ = (0, $2Jl0K.createEmpty)();
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */ _this.wrappedRenderedExtent_ = (0, $2Jl0K.createEmpty)();
        /**
         * @private
         * @type {number}
         */ _this.renderedRotation_;
        /**
         * @private
         * @type {import("../../coordinate").Coordinate}
         */ _this.renderedCenter_ = null;
        /**
         * @private
         * @type {import("../../proj/Projection").default}
         */ _this.renderedProjection_ = null;
        /**
         * @private
         * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
         */ _this.renderedRenderOrder_ = null;
        /**
         * @private
         * @type {import("../../render/canvas/ExecutorGroup").default}
         */ _this.replayGroup_ = null;
        /**
         * A new replay group had to be created by `prepareFrame()`
         * @type {boolean}
         */ _this.replayGroupChanged = true;
        /**
         * @type {import("../../render/canvas/ExecutorGroup").default}
         */ _this.declutterExecutorGroup = null;
        /**
         * Clipping to be performed by `renderFrame()`
         * @type {boolean}
         */ _this.clipping = true;
        /**
         * @private
         * @type {CanvasRenderingContext2D}
         */ _this.compositionContext_ = null;
        /**
         * @private
         * @type {number}
         */ _this.opacity_ = 1;
        return _this;
    }
    /**
     * @param {ExecutorGroup} executorGroup Executor group.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("rbush").default} [opt_declutterTree] Declutter tree.
     */ CanvasVectorLayerRenderer.prototype.renderWorlds = function(executorGroup, frameState, opt_declutterTree) {
        var extent = frameState.extent;
        var viewState = frameState.viewState;
        var center = viewState.center;
        var resolution = viewState.resolution;
        var projection = viewState.projection;
        var rotation = viewState.rotation;
        var projectionExtent = projection.getExtent();
        var vectorSource = this.getLayer().getSource();
        var pixelRatio = frameState.pixelRatio;
        var viewHints = frameState.viewHints;
        var snapToPixel = !(viewHints[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).INTERACTING]);
        var context = this.compositionContext_;
        var width = Math.round(frameState.size[0] * pixelRatio);
        var height = Math.round(frameState.size[1] * pixelRatio);
        var multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        var worldWidth = multiWorld ? (0, $2Jl0K.getWidth)(projectionExtent) : null;
        var endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
        var world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;
        do {
            var transform = this.getRenderTransform(center, resolution, rotation, pixelRatio, width, height, world * worldWidth);
            executorGroup.execute(context, 1, transform, rotation, snapToPixel, undefined, opt_declutterTree);
        }while (++world < endWorld);
    };
    CanvasVectorLayerRenderer.prototype.setupCompositionContext_ = function() {
        if (this.opacity_ !== 1) {
            var compositionContext = (0, $djuby.createCanvasContext2D)(this.context.canvas.width, this.context.canvas.height, (0, $a8a7c34c558b8e6f$export$a166f0857c555517));
            this.compositionContext_ = compositionContext;
        } else this.compositionContext_ = this.context;
    };
    CanvasVectorLayerRenderer.prototype.releaseCompositionContext_ = function() {
        if (this.opacity_ !== 1) {
            var alpha = this.context.globalAlpha;
            this.context.globalAlpha = this.opacity_;
            this.context.drawImage(this.compositionContext_.canvas, 0, 0);
            this.context.globalAlpha = alpha;
            (0, $djuby.releaseCanvas)(this.compositionContext_);
            (0, $a8a7c34c558b8e6f$export$a166f0857c555517).push(this.compositionContext_.canvas);
            this.compositionContext_ = null;
        }
    };
    /**
     * Render declutter items for this layer
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     */ CanvasVectorLayerRenderer.prototype.renderDeclutter = function(frameState) {
        if (this.declutterExecutorGroup) {
            this.setupCompositionContext_();
            this.renderWorlds(this.declutterExecutorGroup, frameState, frameState.declutterTree);
            this.releaseCompositionContext_();
        }
    };
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */ CanvasVectorLayerRenderer.prototype.renderFrame = function(frameState, target) {
        var pixelRatio = frameState.pixelRatio;
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        // set forward and inverse pixel transforms
        (0, $04c1ab69f17a669b$export$3e4e33ea14aeb531)(this.pixelTransform, 1 / pixelRatio, 1 / pixelRatio);
        (0, $04c1ab69f17a669b$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        var canvasTransform = (0, $04c1ab69f17a669b$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        var context = this.context;
        var canvas = context.canvas;
        var replayGroup = this.replayGroup_;
        var declutterExecutorGroup = this.declutterExecutorGroup;
        if ((!replayGroup || replayGroup.isEmpty()) && (!declutterExecutorGroup || declutterExecutorGroup.isEmpty())) return null;
        // resize and clear
        var width = Math.round(frameState.size[0] * pixelRatio);
        var height = Math.round(frameState.size[1] * pixelRatio);
        if (canvas.width != width || canvas.height != height) {
            canvas.width = width;
            canvas.height = height;
            if (canvas.style.transform !== canvasTransform) canvas.style.transform = canvasTransform;
        } else if (!this.containerReused) context.clearRect(0, 0, width, height);
        this.preRender(context, frameState);
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        this.opacity_ = layerState.opacity;
        this.setupCompositionContext_();
        // clipped rendering if layer extent is set
        var clipped = false;
        var render = true;
        if (layerState.extent && this.clipping) {
            var layerExtent = (0, $d3bc250abc15fbce$export$494be3a3a25689ca)(layerState.extent, projection);
            render = (0, $2Jl0K.intersects)(layerExtent, frameState.extent);
            clipped = render && !(0, $2Jl0K.containsExtent)(layerExtent, frameState.extent);
            if (clipped) this.clipUnrotated(this.compositionContext_, frameState, layerExtent);
        }
        if (render) this.renderWorlds(replayGroup, frameState);
        if (clipped) this.compositionContext_.restore();
        this.releaseCompositionContext_();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        return this.container;
    };
    /**
     * Asynchronous layer level hit detection.
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../../Feature").default>>} Promise that resolves with an array of features.
     */ CanvasVectorLayerRenderer.prototype.getFeatures = function(pixel) {
        return new Promise(/**
         * @param {function(Array<import("../../Feature").default|import("../../render/Feature").default>): void} resolve Resolver function.
         * @this {CanvasVectorLayerRenderer}
         */ (function(resolve) {
            if (!this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                var size = [
                    this.context.canvas.width,
                    this.context.canvas.height
                ];
                (0, $04c1ab69f17a669b$export$5635d7ef4b8fee1c)(this.pixelTransform, size);
                var center = this.renderedCenter_;
                var resolution = this.renderedResolution_;
                var rotation = this.renderedRotation_;
                var projection = this.renderedProjection_;
                var extent = this.wrappedRenderedExtent_;
                var layer = this.getLayer();
                var transforms = [];
                var width = size[0] * (0, $94715bcc7d6d2524$export$ab51038298418f25);
                var height = size[1] * (0, $94715bcc7d6d2524$export$ab51038298418f25);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $94715bcc7d6d2524$export$ab51038298418f25), width, height, 0).slice());
                var source = layer.getSource();
                var projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $2Jl0K.containsExtent)(projectionExtent, extent)) {
                    var startX = extent[0];
                    var worldWidth = (0, $2Jl0K.getWidth)(projectionExtent);
                    var world = 0;
                    var offsetX = void 0;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $94715bcc7d6d2524$export$ab51038298418f25), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $94715bcc7d6d2524$export$ab51038298418f25), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                this.hitDetectionImageData_ = (0, $94715bcc7d6d2524$export$bd05e394339d469)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation);
            }
            resolve((0, $94715bcc7d6d2524$export$6d4d555ddbfffa32)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        }).bind(this));
    };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */ CanvasVectorLayerRenderer.prototype.forEachFeatureAtCoordinate = function(coordinate, frameState, hitTolerance, callback, matches) {
        var _this = this;
        if (!this.replayGroup_) return undefined;
        var resolution = frameState.viewState.resolution;
        var rotation = frameState.viewState.rotation;
        var layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ var features = {};
        /**
         * @param {import("../../Feature.js").FeatureLike} feature Feature.
         * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
         * @param {number} distanceSq The squared distance to the click position
         * @return {T|undefined} Callback result.
         */ var featureCallback = function(feature, geometry, distanceSq) {
            var key = (0, $61DUI.getUid)(feature);
            var match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        var result;
        var executorGroups = [
            this.replayGroup_
        ];
        if (this.declutterExecutorGroup) executorGroups.push(this.declutterExecutorGroup);
        executorGroups.some(function(executorGroup) {
            return result = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, executorGroup === _this.declutterExecutorGroup && frameState.declutterTree ? frameState.declutterTree.all().map(function(item) {
                return item.value;
            }) : null);
        });
        return result;
    };
    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     */ CanvasVectorLayerRenderer.prototype.handleFontsChanged = function() {
        var layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    };
    /**
     * Handle changes in image style state.
     * @param {import("../../events/Event.js").default} event Image style change event.
     * @private
     */ CanvasVectorLayerRenderer.prototype.handleStyleImageChange_ = function(event) {
        this.renderIfReadyAndVisible();
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */ CanvasVectorLayerRenderer.prototype.prepareFrame = function(frameState) {
        var vectorLayer = this.getLayer();
        var vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        var animating = frameState.viewHints[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).ANIMATING];
        var interacting = frameState.viewHints[(0, $ac276e5fd318403e$export$2e2bcd8739ae039).INTERACTING];
        var updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        var updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        var frameStateExtent = frameState.extent;
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var resolution = viewState.resolution;
        var pixelRatio = frameState.pixelRatio;
        var vectorLayerRevision = vectorLayer.getRevision();
        var vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        var vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $2c19c3cc1ff25558$export$531ddd8416d52dfc);
        var center = viewState.center.slice();
        var extent = (0, $2Jl0K.buffer)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        var renderedExtent = extent.slice();
        var loadExtents = [
            extent.slice()
        ];
        var projectionExtent = projection.getExtent();
        if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $2Jl0K.containsExtent)(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            var worldWidth = (0, $2Jl0K.getWidth)(projectionExtent);
            var gutter = Math.max((0, $2Jl0K.getWidth)(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
            (0, $12736e582a1ee05c$export$39a9ce3624977b84)(center, projection);
            var loadExtent = (0, $2Jl0K.wrapX)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && (0, $2Jl0K.containsExtent)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $kzmGH.equals)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        var replayGroup = new (0, $5710853dffd2641f$export$2e2bcd8739ae039)((0, $2c19c3cc1ff25558$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        var declutterBuilderGroup;
        if (this.getLayer().getDeclutter()) declutterBuilderGroup = new (0, $5710853dffd2641f$export$2e2bcd8739ae039)((0, $2c19c3cc1ff25558$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        var userProjection = (0, $d3bc250abc15fbce$export$3973b77d5f6f2790)();
        var userTransform;
        if (userProjection) {
            for(var i = 0, ii = loadExtents.length; i < ii; ++i){
                var extent_1 = loadExtents[i];
                var userExtent_1 = (0, $d3bc250abc15fbce$export$96bfd09e2cffb006)(extent_1, projection);
                vectorSource.loadFeatures(userExtent_1, (0, $d3bc250abc15fbce$export$b56bb8ad8b3a00e9)(resolution, projection), userProjection);
            }
            userTransform = (0, $d3bc250abc15fbce$export$e3c4995a701c26a3)(userProjection, projection);
        } else for(var i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        var squaredTolerance = (0, $2c19c3cc1ff25558$export$75084a70d324c1e6)(resolution, pixelRatio);
        var ready = true;
        var render = /**
         * @param {import("../../Feature.js").default} feature Feature.
         * @this {CanvasVectorLayerRenderer}
         */ (function(feature) {
            var styles;
            var styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                var dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, declutterBuilderGroup);
                ready = ready && !dirty;
            }
        }).bind(this);
        var userExtent = (0, $d3bc250abc15fbce$export$96bfd09e2cffb006)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ var features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(var i = 0, ii = features.length; i < ii; ++i)render(features[i]);
        this.renderedFeatures_ = features;
        this.ready = ready;
        var replayGroupInstructions = replayGroup.finish();
        var executorGroup = new (0, $2a299879c9a46d4c$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer());
        if (declutterBuilderGroup) this.declutterExecutorGroup = new (0, $2a299879c9a46d4c$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), declutterBuilderGroup.finish(), vectorLayer.getRenderBuffer());
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    };
    /**
     * @param {import("../../Feature.js").default} feature Feature.
     * @param {number} squaredTolerance Squared render tolerance.
     * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
     * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
     * @param {import("../../proj.js").TransformFunction} [opt_transform] Transform from user to view projection.
     * @param {import("../../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
     * @return {boolean} `true` if an image is loading.
     */ CanvasVectorLayerRenderer.prototype.renderFeature = function(feature, squaredTolerance, styles, builderGroup, opt_transform, opt_declutterBuilderGroup) {
        if (!styles) return false;
        var loading = false;
        if (Array.isArray(styles)) for(var i = 0, ii = styles.length; i < ii; ++i)loading = (0, $2c19c3cc1ff25558$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, opt_transform, opt_declutterBuilderGroup) || loading;
        else loading = (0, $2c19c3cc1ff25558$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, opt_transform, opt_declutterBuilderGroup);
        return loading;
    };
    return CanvasVectorLayerRenderer;
}((0, $a8a7c34c558b8e6f$export$2e2bcd8739ae039));
var $d60c04b96bd8ea74$export$2e2bcd8739ae039 = $d60c04b96bd8ea74$var$CanvasVectorLayerRenderer;


var $7caf9a9f13481091$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default} VectorSourceType
 * @extends {BaseVectorLayer<VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ var $7caf9a9f13481091$var$VectorLayer = /** @class */ function(_super) {
    $7caf9a9f13481091$var$__extends(VectorLayer, _super);
    /**
     * @param {import("./BaseVector.js").Options<VectorSourceType>} [opt_options] Options.
     */ function VectorLayer(opt_options) {
        return _super.call(this, opt_options) || this;
    }
    VectorLayer.prototype.createRenderer = function() {
        return new (0, $d60c04b96bd8ea74$export$2e2bcd8739ae039)(this);
    };
    return VectorLayer;
}((0, $4fa39677119aae30$export$2e2bcd8739ae039));
var $7caf9a9f13481091$export$2e2bcd8739ae039 = $7caf9a9f13481091$var$VectorLayer;


/**
 * @module ol/style/Text
 */ 


/**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ var $a6a08614ee8fc97a$var$DEFAULT_FILL_COLOR = '#333';
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS 'font' value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is '10px sans-serif'
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {import("./TextPlacement.js").default|string} [placement='point'] Text placement.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for the immediate rendering API.
 * @property {string} [textAlign] Text alignment. Possible values: 'left', 'right', 'center', 'end' or 'start'.
 * Default is 'center' for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {string} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {string} [textBaseline='middle'] Text base line. Possible values: 'bottom', 'top', 'middle', 'alphabetic',
 * 'hanging', 'ideographic'.
 * @property {import("./Fill.js").default} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333).
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ var $a6a08614ee8fc97a$var$Text = /** @class */ function() {
    /**
     * @param {Options} [opt_options] Options.
     */ function Text(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {string|undefined}
         */ this.font_ = options.font;
        /**
         * @private
         * @type {number|undefined}
         */ this.rotation_ = options.rotation;
        /**
         * @private
         * @type {boolean|undefined}
         */ this.rotateWithView_ = options.rotateWithView;
        /**
         * @private
         * @type {number|import("../size.js").Size|undefined}
         */ this.scale_ = options.scale;
        /**
         * @private
         * @type {import("../size.js").Size}
         */ this.scaleArray_ = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(options.scale !== undefined ? options.scale : 1);
        /**
         * @private
         * @type {string|Array<string>|undefined}
         */ this.text_ = options.text;
        /**
         * @private
         * @type {string|undefined}
         */ this.textAlign_ = options.textAlign;
        /**
         * @private
         * @type {string|undefined}
         */ this.justify_ = options.justify;
        /**
         * @private
         * @type {string|undefined}
         */ this.textBaseline_ = options.textBaseline;
        /**
         * @private
         * @type {import("./Fill.js").default}
         */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
            color: $a6a08614ee8fc97a$var$DEFAULT_FILL_COLOR
        });
        /**
         * @private
         * @type {number}
         */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
         * @private
         * @type {import("./TextPlacement.js").default|string}
         */ this.placement_ = options.placement !== undefined ? options.placement : (0, $6920f9bb98c2b277$export$2e2bcd8739ae039).POINT;
        /**
         * @private
         * @type {boolean}
         */ this.overflow_ = !!options.overflow;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
         * @private
         * @type {number}
         */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
         * @private
         * @type {number}
         */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
         * @private
         * @type {import("./Fill.js").default}
         */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
         * @private
         * @type {Array<number>|null}
         */ this.padding_ = options.padding === undefined ? null : options.padding;
    }
    /**
     * Clones the style.
     * @return {Text} The cloned style.
     * @api
     */ Text.prototype.clone = function() {
        var scale = this.getScale();
        return new Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined
        });
    };
    /**
     * Get the `overflow` configuration.
     * @return {boolean} Let text overflow the length of the path they follow.
     * @api
     */ Text.prototype.getOverflow = function() {
        return this.overflow_;
    };
    /**
     * Get the font name.
     * @return {string|undefined} Font.
     * @api
     */ Text.prototype.getFont = function() {
        return this.font_;
    };
    /**
     * Get the maximum angle between adjacent characters.
     * @return {number} Angle in radians.
     * @api
     */ Text.prototype.getMaxAngle = function() {
        return this.maxAngle_;
    };
    /**
     * Get the label placement.
     * @return {import("./TextPlacement.js").default|string} Text placement.
     * @api
     */ Text.prototype.getPlacement = function() {
        return this.placement_;
    };
    /**
     * Get the x-offset for the text.
     * @return {number} Horizontal text offset.
     * @api
     */ Text.prototype.getOffsetX = function() {
        return this.offsetX_;
    };
    /**
     * Get the y-offset for the text.
     * @return {number} Vertical text offset.
     * @api
     */ Text.prototype.getOffsetY = function() {
        return this.offsetY_;
    };
    /**
     * Get the fill style for the text.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */ Text.prototype.getFill = function() {
        return this.fill_;
    };
    /**
     * Determine whether the text rotates with the map.
     * @return {boolean|undefined} Rotate with map.
     * @api
     */ Text.prototype.getRotateWithView = function() {
        return this.rotateWithView_;
    };
    /**
     * Get the text rotation.
     * @return {number|undefined} Rotation.
     * @api
     */ Text.prototype.getRotation = function() {
        return this.rotation_;
    };
    /**
     * Get the text scale.
     * @return {number|import("../size.js").Size|undefined} Scale.
     * @api
     */ Text.prototype.getScale = function() {
        return this.scale_;
    };
    /**
     * Get the symbolizer scale array.
     * @return {import("../size.js").Size} Scale array.
     */ Text.prototype.getScaleArray = function() {
        return this.scaleArray_;
    };
    /**
     * Get the stroke style for the text.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */ Text.prototype.getStroke = function() {
        return this.stroke_;
    };
    /**
     * Get the text to be rendered.
     * @return {string|Array<string>|undefined} Text.
     * @api
     */ Text.prototype.getText = function() {
        return this.text_;
    };
    /**
     * Get the text alignment.
     * @return {string|undefined} Text align.
     * @api
     */ Text.prototype.getTextAlign = function() {
        return this.textAlign_;
    };
    /**
     * Get the justification.
     * @return {string|undefined} Justification.
     * @api
     */ Text.prototype.getJustify = function() {
        return this.justify_;
    };
    /**
     * Get the text baseline.
     * @return {string|undefined} Text baseline.
     * @api
     */ Text.prototype.getTextBaseline = function() {
        return this.textBaseline_;
    };
    /**
     * Get the background fill style for the text.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */ Text.prototype.getBackgroundFill = function() {
        return this.backgroundFill_;
    };
    /**
     * Get the background stroke style for the text.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */ Text.prototype.getBackgroundStroke = function() {
        return this.backgroundStroke_;
    };
    /**
     * Get the padding for the text.
     * @return {Array<number>|null} Padding.
     * @api
     */ Text.prototype.getPadding = function() {
        return this.padding_;
    };
    /**
     * Set the `overflow` property.
     *
     * @param {boolean} overflow Let text overflow the path that it follows.
     * @api
     */ Text.prototype.setOverflow = function(overflow) {
        this.overflow_ = overflow;
    };
    /**
     * Set the font.
     *
     * @param {string|undefined} font Font.
     * @api
     */ Text.prototype.setFont = function(font) {
        this.font_ = font;
    };
    /**
     * Set the maximum angle between adjacent characters.
     *
     * @param {number} maxAngle Angle in radians.
     * @api
     */ Text.prototype.setMaxAngle = function(maxAngle) {
        this.maxAngle_ = maxAngle;
    };
    /**
     * Set the x offset.
     *
     * @param {number} offsetX Horizontal text offset.
     * @api
     */ Text.prototype.setOffsetX = function(offsetX) {
        this.offsetX_ = offsetX;
    };
    /**
     * Set the y offset.
     *
     * @param {number} offsetY Vertical text offset.
     * @api
     */ Text.prototype.setOffsetY = function(offsetY) {
        this.offsetY_ = offsetY;
    };
    /**
     * Set the text placement.
     *
     * @param {import("./TextPlacement.js").default|string} placement Placement.
     * @api
     */ Text.prototype.setPlacement = function(placement) {
        this.placement_ = placement;
    };
    /**
     * Set whether to rotate the text with the view.
     *
     * @param {boolean} rotateWithView Rotate with map.
     * @api
     */ Text.prototype.setRotateWithView = function(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    };
    /**
     * Set the fill.
     *
     * @param {import("./Fill.js").default} fill Fill style.
     * @api
     */ Text.prototype.setFill = function(fill) {
        this.fill_ = fill;
    };
    /**
     * Set the rotation.
     *
     * @param {number|undefined} rotation Rotation.
     * @api
     */ Text.prototype.setRotation = function(rotation) {
        this.rotation_ = rotation;
    };
    /**
     * Set the scale.
     *
     * @param {number|import("../size.js").Size|undefined} scale Scale.
     * @api
     */ Text.prototype.setScale = function(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $defec9fd2d3eaefa$export$a71a825ff42fb8e1)(scale !== undefined ? scale : 1);
    };
    /**
     * Set the stroke.
     *
     * @param {import("./Stroke.js").default} stroke Stroke style.
     * @api
     */ Text.prototype.setStroke = function(stroke) {
        this.stroke_ = stroke;
    };
    /**
     * Set the text.
     *
     * @param {string|Array<string>|undefined} text Text.
     * @api
     */ Text.prototype.setText = function(text) {
        this.text_ = text;
    };
    /**
     * Set the text alignment.
     *
     * @param {string|undefined} textAlign Text align.
     * @api
     */ Text.prototype.setTextAlign = function(textAlign) {
        this.textAlign_ = textAlign;
    };
    /**
     * Set the justification.
     *
     * @param {string|undefined} justify Justification.
     * @api
     */ Text.prototype.setJustify = function(justify) {
        this.justify_ = justify;
    };
    /**
     * Set the text baseline.
     *
     * @param {string|undefined} textBaseline Text baseline.
     * @api
     */ Text.prototype.setTextBaseline = function(textBaseline) {
        this.textBaseline_ = textBaseline;
    };
    /**
     * Set the background fill.
     *
     * @param {import("./Fill.js").default} fill Fill style.
     * @api
     */ Text.prototype.setBackgroundFill = function(fill) {
        this.backgroundFill_ = fill;
    };
    /**
     * Set the background stroke.
     *
     * @param {import("./Stroke.js").default} stroke Stroke style.
     * @api
     */ Text.prototype.setBackgroundStroke = function(stroke) {
        this.backgroundStroke_ = stroke;
    };
    /**
     * Set the padding (`[top, right, bottom, left]`).
     *
     * @param {Array<number>|null} padding Padding.
     * @api
     */ Text.prototype.setPadding = function(padding) {
        this.padding_ = padding;
    };
    return Text;
}();
var $a6a08614ee8fc97a$export$2e2bcd8739ae039 = $a6a08614ee8fc97a$var$Text;





var $e88d1c230a05b77a$exports = {};
"use strict";
var $e88d1c230a05b77a$var$__assign = $e88d1c230a05b77a$exports && $e88d1c230a05b77a$exports.__assign || function() {
    $e88d1c230a05b77a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e88d1c230a05b77a$var$__assign.apply(this, arguments);
};
var $e88d1c230a05b77a$var$__createBinding = $e88d1c230a05b77a$exports && $e88d1c230a05b77a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e88d1c230a05b77a$var$__setModuleDefault = $e88d1c230a05b77a$exports && $e88d1c230a05b77a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e88d1c230a05b77a$var$__importStar = $e88d1c230a05b77a$exports && $e88d1c230a05b77a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e88d1c230a05b77a$var$__createBinding(result, mod, k);
    }
    $e88d1c230a05b77a$var$__setModuleDefault(result, mod);
    return result;
};
var $e88d1c230a05b77a$var$__awaiter = $e88d1c230a05b77a$exports && $e88d1c230a05b77a$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e88d1c230a05b77a$var$__generator = $e88d1c230a05b77a$exports && $e88d1c230a05b77a$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e88d1c230a05b77a$var$__rest = $e88d1c230a05b77a$exports && $e88d1c230a05b77a$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e88d1c230a05b77a$var$__importDefault = $e88d1c230a05b77a$exports && $e88d1c230a05b77a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($e88d1c230a05b77a$exports, "__esModule", {
    value: true
});
$e88d1c230a05b77a$exports.gql = $e88d1c230a05b77a$exports.batchRequests = $e88d1c230a05b77a$exports.request = $e88d1c230a05b77a$exports.rawRequest = $e88d1c230a05b77a$exports.GraphQLClient = $e88d1c230a05b77a$exports.ClientError = void 0;

var $e88d1c230a05b77a$var$cross_fetch_1 = $e88d1c230a05b77a$var$__importStar((parcelRequire("5pUgu"))), $e88d1c230a05b77a$var$CrossFetch = $e88d1c230a05b77a$var$cross_fetch_1;
var $0eaaa47dbfd8323d$exports = {};
'use strict';
Object.defineProperty($0eaaa47dbfd8323d$exports, '__esModule', {
    value: true
});
$0eaaa47dbfd8323d$exports.print = $0eaaa47dbfd8323d$var$print;
var $a2743ccee7abec05$exports = {};
'use strict';
Object.defineProperty($a2743ccee7abec05$exports, '__esModule', {
    value: true
});
$a2743ccee7abec05$exports.dedentBlockStringLines = $a2743ccee7abec05$var$dedentBlockStringLines;
$a2743ccee7abec05$exports.isPrintableAsBlockString = $a2743ccee7abec05$var$isPrintableAsBlockString;
$a2743ccee7abec05$exports.printBlockString = $a2743ccee7abec05$var$printBlockString;
var $e2d97f88ad0ee819$exports = {};
'use strict';
Object.defineProperty($e2d97f88ad0ee819$exports, '__esModule', {
    value: true
});
$e2d97f88ad0ee819$exports.isDigit = $e2d97f88ad0ee819$var$isDigit;
$e2d97f88ad0ee819$exports.isLetter = $e2d97f88ad0ee819$var$isLetter;
$e2d97f88ad0ee819$exports.isNameContinue = $e2d97f88ad0ee819$var$isNameContinue;
$e2d97f88ad0ee819$exports.isNameStart = $e2d97f88ad0ee819$var$isNameStart;
$e2d97f88ad0ee819$exports.isWhiteSpace = $e2d97f88ad0ee819$var$isWhiteSpace;
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $e2d97f88ad0ee819$var$isWhiteSpace(code) {
    return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */ function $e2d97f88ad0ee819$var$isDigit(code) {
    return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */ function $e2d97f88ad0ee819$var$isLetter(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */ function $e2d97f88ad0ee819$var$isNameStart(code) {
    return $e2d97f88ad0ee819$var$isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */ function $e2d97f88ad0ee819$var$isNameContinue(code) {
    return $e2d97f88ad0ee819$var$isLetter(code) || $e2d97f88ad0ee819$var$isDigit(code) || code === 0x005f;
}


/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $a2743ccee7abec05$var$dedentBlockStringLines(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $a2743ccee7abec05$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $a2743ccee7abec05$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $e2d97f88ad0ee819$exports.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
/** @internal */ function $a2743ccee7abec05$var$isPrintableAsBlockString(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $a2743ccee7abec05$var$printBlockString(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $e2d97f88ad0ee819$exports.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $e2d97f88ad0ee819$exports.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}


var $5b701fdb1eff895a$exports = {};
'use strict';
Object.defineProperty($5b701fdb1eff895a$exports, '__esModule', {
    value: true
});
$5b701fdb1eff895a$exports.printString = $5b701fdb1eff895a$var$printString;
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 *
 * @internal
 */ function $5b701fdb1eff895a$var$printString(str) {
    return `"${str.replace($5b701fdb1eff895a$var$escapedRegExp, $5b701fdb1eff895a$var$escapedReplacer)}"`;
}
/** @internal */ // eslint-disable-next-line no-control-regex
const $5b701fdb1eff895a$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $5b701fdb1eff895a$var$escapedReplacer(str) {
    return $5b701fdb1eff895a$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $5b701fdb1eff895a$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];


var $9d9cd39e01578f30$exports = {};
'use strict';
Object.defineProperty($9d9cd39e01578f30$exports, '__esModule', {
    value: true
});
$9d9cd39e01578f30$exports.BREAK = void 0;
$9d9cd39e01578f30$exports.getEnterLeaveForKind = $9d9cd39e01578f30$var$getEnterLeaveForKind;
$9d9cd39e01578f30$exports.getVisitFn = $9d9cd39e01578f30$var$getVisitFn;
$9d9cd39e01578f30$exports.visit = $9d9cd39e01578f30$var$visit;
$9d9cd39e01578f30$exports.visitInParallel = $9d9cd39e01578f30$var$visitInParallel;
var $26a869a3532a9ef3$exports = {};
'use strict';
Object.defineProperty($26a869a3532a9ef3$exports, '__esModule', {
    value: true
});
$26a869a3532a9ef3$exports.devAssert = $26a869a3532a9ef3$var$devAssert;
/** @internal */ function $26a869a3532a9ef3$var$devAssert(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


var $ff36344e5471842e$exports = {};
'use strict';
Object.defineProperty($ff36344e5471842e$exports, '__esModule', {
    value: true
});
$ff36344e5471842e$exports.inspect = $ff36344e5471842e$var$inspect;
const $ff36344e5471842e$var$MAX_ARRAY_LENGTH = 10;
const $ff36344e5471842e$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 *
 * @internal
 */ function $ff36344e5471842e$var$inspect(value) {
    return $ff36344e5471842e$var$formatValue(value, []);
}
function $ff36344e5471842e$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $ff36344e5471842e$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $ff36344e5471842e$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($ff36344e5471842e$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $ff36344e5471842e$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $ff36344e5471842e$var$formatArray(value, seenValues);
    return $ff36344e5471842e$var$formatObject(value, seenValues);
}
function $ff36344e5471842e$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $ff36344e5471842e$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $ff36344e5471842e$var$MAX_RECURSIVE_DEPTH) return '[' + $ff36344e5471842e$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $ff36344e5471842e$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $ff36344e5471842e$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $ff36344e5471842e$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($ff36344e5471842e$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($ff36344e5471842e$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $ff36344e5471842e$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}


var $c78854971616da02$exports = {};
'use strict';
Object.defineProperty($c78854971616da02$exports, '__esModule', {
    value: true
});
$c78854971616da02$exports.Token = $c78854971616da02$exports.QueryDocumentKeys = $c78854971616da02$exports.OperationTypeNode = $c78854971616da02$exports.Location = void 0;
$c78854971616da02$exports.isNode = $c78854971616da02$var$isNode;
/** @category AST */ /**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $c78854971616da02$var$Location {
    /** The character offset at which this Node begins. */ /** The character offset at which this Node ends. */ /** The Token at which this Node begins. */ /** The Token at which this Node ends. */ /** The Source document the AST represents. */ /**
   * Creates a Location instance.
   * @param startToken - The start token.
   * @param endToken - The end token.
   * @param source - Source document used to derive error locations.
   * @example
   * ```ts
   * import { Location, Source, Token, TokenKind } from 'graphql/language';
   *
   * const source = new Source('{ hello }');
   * const startToken = new Token(TokenKind.BRACE_L, 0, 1, 1, 1);
   * const endToken = new Token(TokenKind.BRACE_R, 8, 9, 1, 9);
   * const location = new Location(startToken, endToken, source);
   *
   * location.start; // => 0
   * location.end; // => 9
   * location.source.body; // => '{ hello }'
   * ```
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */ get [Symbol.toStringTag]() {
        return 'Location';
    }
    /**
   * Returns a JSON representation of this location.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { parse } from 'graphql/language';
   *
   * const document = parse('{ hello }');
   * const location = document.loc?.toJSON();
   *
   * location; // => { start: 0, end: 9 }
   * ```
   */ toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ $c78854971616da02$exports.Location = $c78854971616da02$var$Location;
class $c78854971616da02$var$Token {
    /** The kind of Token. */ /** The character offset at which this Node begins. */ /** The character offset at which this Node ends. */ /** The 1-indexed line number on which this Token appears. */ /** The 1-indexed column number at which this Token begins. */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ /** Next token in the token stream, including ignored tokens. */ /**
   * Creates a Token instance.
   * @param kind - Token kind produced by lexical analysis.
   * @param start - Character offset where this token begins.
   * @param end - Character offset where this token ends.
   * @param line - One-indexed line number where this token begins.
   * @param column - One-indexed column number where this token begins.
   * @param value - Interpreted value for non-punctuation tokens.
   * @example
   * ```ts
   * import { Token, TokenKind } from 'graphql/language';
   *
   * const token = new Token(TokenKind.NAME, 2, 7, 1, 3, 'hello');
   *
   * token.kind; // => TokenKind.NAME
   * token.value; // => 'hello'
   * token.toJSON(); // => { kind: 'Name', value: 'hello', line: 1, column: 3 }
   * ```
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */ get [Symbol.toStringTag]() {
        return 'Token';
    }
    /**
   * Returns a JSON representation of this token.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.advance().toJSON();
   *
   * token; // => { kind: '{', value: undefined, line: 1, column: 1 }
   * ```
   */ toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
/** The list of all possible AST node types. */ $c78854971616da02$exports.Token = $c78854971616da02$var$Token;
/** @internal */ const $c78854971616da02$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'description',
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'directives',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    DirectiveExtension: [
        'name',
        'directives'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    TypeCoordinate: [
        'name'
    ],
    MemberCoordinate: [
        'name',
        'memberName'
    ],
    ArgumentCoordinate: [
        'name',
        'fieldName',
        'argumentName'
    ],
    DirectiveCoordinate: [
        'name'
    ],
    DirectiveArgumentCoordinate: [
        'name',
        'argumentName'
    ]
};
$c78854971616da02$exports.QueryDocumentKeys = $c78854971616da02$var$QueryDocumentKeys;
const $c78854971616da02$var$kindValues = new Set(Object.keys($c78854971616da02$var$QueryDocumentKeys));
/** @internal */ function $c78854971616da02$var$isNode(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $c78854971616da02$var$kindValues.has(maybeKind);
}
/** An identifier in a GraphQL document. */ /**
 * The operation types supported by GraphQL executable definitions.
 * @category Kinds
 */ var $c78854971616da02$var$OperationTypeNode;
$c78854971616da02$exports.OperationTypeNode = $c78854971616da02$var$OperationTypeNode;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($c78854971616da02$var$OperationTypeNode || ($c78854971616da02$exports.OperationTypeNode = $c78854971616da02$var$OperationTypeNode = {})); /** A variable declaration in an operation or legacy fragment definition. */ 


var $6fa9cf76dbe88cee$exports = {};
'use strict';
Object.defineProperty($6fa9cf76dbe88cee$exports, '__esModule', {
    value: true
});
$6fa9cf76dbe88cee$exports.Kind = void 0;
/** @category Kinds */ /** The set of allowed kind values for AST nodes. */ var $6fa9cf76dbe88cee$var$Kind;
$6fa9cf76dbe88cee$exports.Kind = $6fa9cf76dbe88cee$var$Kind;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['DIRECTIVE_EXTENSION'] = 'DirectiveExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
    Kind['TYPE_COORDINATE'] = 'TypeCoordinate';
    Kind['MEMBER_COORDINATE'] = 'MemberCoordinate';
    Kind['ARGUMENT_COORDINATE'] = 'ArgumentCoordinate';
    Kind['DIRECTIVE_COORDINATE'] = 'DirectiveCoordinate';
    Kind['DIRECTIVE_ARGUMENT_COORDINATE'] = 'DirectiveArgumentCoordinate';
})($6fa9cf76dbe88cee$var$Kind || ($6fa9cf76dbe88cee$exports.Kind = $6fa9cf76dbe88cee$var$Kind = {})); /**
 * Deprecated legacy alias for the enum type representing the possible kind
 * values of AST nodes. This alias will be removed in v17. In v17, `Kind` is
 * exported as the single public symbol for both the runtime object and the
 * corresponding TypeScript type.
 * @deprecated Will be removed in v17. In v17, use `Kind` as both the runtime
 * value and the type.
 */ 


/** @category Visiting */ /** A value that can be returned from a visitor function to stop traversal. */ const $9d9cd39e01578f30$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 * @param root - The AST node at which to start traversal.
 * @param visitor - The visitor or reducer functions to call while traversing.
 * @param visitorKeys - Optional map of child keys to visit for each AST node kind.
 * @returns The original AST, an edited AST, or a reduced value depending on the visitor.
 * @typeParam N - The root AST node type returned when visiting without reducing.
 * @example
 * ```ts
 * // Return values control traversal: undefined makes no change, false skips
 * // a subtree, BREAK stops traversal, null removes a node, and any other
 * // value replaces the current node.
 * import { Kind, parse, print, visit } from 'graphql/language';
 *
 * const document = parse('{ hero { name } }');
 * const editedAST = visit(document, {
 *   Field: (node) => {
 *     if (node.name.value === 'hero') {
 *       return {
 *         ...node,
 *         name: { kind: Kind.NAME, value: 'human' },
 *       };
 *     }
 *   },
 * });
 *
 * print(editedAST); // => '{\n  human {\n    name\n  }\n}'
 * ```
 * @example
 * ```ts
 * // A named visitor function runs when entering nodes of that kind.
 * import { parse, visit } from 'graphql/language';
 *
 * const document = parse('{ hero { name } }');
 * const fieldNames = [];
 *
 * visit(document, {
 *   Field: (node) => {
 *     fieldNames.push(node.name.value);
 *   },
 * });
 *
 * fieldNames; // => ['hero', 'name']
 * ```
 * @example
 * ```ts
 * // A named visitor object can provide separate enter and leave handlers for
 * // nodes of that kind.
 * import { parse, visit } from 'graphql/language';
 *
 * const document = parse('{ hero { name } }');
 * const events = [];
 *
 * visit(document, {
 *   Field: {
 *     enter: (node) => {
 *       events.push(`enter:${node.name.value}`);
 *     },
 *     leave: (node) => {
 *       events.push(`leave:${node.name.value}`);
 *     },
 *   },
 * });
 *
 * events; // => ['enter:hero', 'enter:name', 'leave:name', 'leave:hero']
 * ```
 * @example
 * ```ts
 * // Generic enter and leave handlers run for every node.
 * import { parse, visit } from 'graphql/language';
 *
 * const document = parse('{ hero { name } }');
 * let enterCount = 0;
 * let leaveCount = 0;
 *
 * visit(document, {
 *   enter: (node) => {
 *     enterCount += 1;
 *   },
 *   leave: (node) => {
 *     leaveCount += 1;
 *   },
 * });
 *
 * enterCount; // => leaveCount
 * enterCount > 0; // => true
 * ```
 */ $9d9cd39e01578f30$exports.BREAK = $9d9cd39e01578f30$var$BREAK;
/** @internal */ function $9d9cd39e01578f30$var$visit(root, visitor, visitorKeys = $c78854971616da02$exports.QueryDocumentKeys) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values($6fa9cf76dbe88cee$exports.Kind))enterLeaveMap.set(kind, $9d9cd39e01578f30$var$getEnterLeaveForKind(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = {
                        ...node
                    };
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $c78854971616da02$exports.isNode)(node) || (0, $26a869a3532a9ef3$exports.devAssert)(false, `Invalid AST Node: ${(0, $ff36344e5471842e$exports.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $9d9cd39e01578f30$var$BREAK) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $c78854971616da02$exports.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 * @param visitors - The visitors to merge into one parallel visitor.
 * @returns A visitor that delegates traversal to each provided visitor.
 * @example
 * ```ts
 * import { parse, visit, visitInParallel } from 'graphql/language';
 *
 * const document = parse('{ hero { name } }');
 * const events = [];
 *
 * visit(
 *   document,
 *   visitInParallel([
 *     { Field: (node) => { events.push(`field:${node.name.value}`); } },
 *     { Name: (node) => { events.push(`name:${node.value}`); } },
 *   ]),
 * );
 *
 * events; // => ['field:hero', 'name:hero', 'field:name', 'name:name']
 * ```
 */ function $9d9cd39e01578f30$var$visitInParallel(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values($6fa9cf76dbe88cee$exports.Kind)){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $9d9cd39e01578f30$var$getEnterLeaveForKind(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $9d9cd39e01578f30$var$BREAK) skipping[i] = $9d9cd39e01578f30$var$BREAK;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $9d9cd39e01578f30$var$BREAK) skipping[i] = $9d9cd39e01578f30$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 * @param visitor - The visitor object to inspect.
 * @param kind - The AST node kind to resolve handlers for.
 * @returns The enter and leave handlers that apply for the given node kind.
 * @example
 * ```ts
 * import { Kind, getEnterLeaveForKind } from 'graphql/language';
 *
 * const handlers = getEnterLeaveForKind({ Field: () => {} }, Kind.FIELD);
 *
 * typeof handlers.enter; // => 'function'
 * handlers.leave; // => undefined
 * ```
 */ function $9d9cd39e01578f30$var$getEnterLeaveForKind(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call. This deprecated compatibility
 * helper delegates to `getEnterLeaveForKind`; call `getEnterLeaveForKind`
 * directly because getVisitFn will be removed in v17.
 * @param visitor - The visitor object to inspect.
 * @param kind - The AST node kind to resolve a handler for.
 * @param isLeaving - Whether to resolve the leave handler instead of the enter handler.
 * @returns The visit function that applies for the given node kind and traversal phase, if one exists.
 * @example
 * ```ts
 * import { Kind, getVisitFn } from 'graphql/language';
 *
 * const enter = getVisitFn({ Field: () => {} }, Kind.FIELD, false);
 * const leave = getVisitFn({ Field: () => {} }, Kind.FIELD, true);
 *
 * typeof enter; // => 'function'
 * leave; // => undefined
 * ```
 * @category Visiting
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */ /* c8 ignore next 8 */ function $9d9cd39e01578f30$var$getVisitFn(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $9d9cd39e01578f30$var$getEnterLeaveForKind(visitor, kind);
    return isLeaving ? leave : enter;
}


/** @category Printing */ /**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 * @param ast - The GraphQL AST node to print.
 * @returns A stable string representation of the AST.
 * @example
 * ```ts
 * import { parse, print } from 'graphql';
 *
 * const ast = parse('{ hero { name } }');
 * const text = print(ast);
 *
 * text; // => '{\n  hero {\n    name\n  }\n}'
 * ```
 */ function $0eaaa47dbfd8323d$var$print(ast) {
    return (0, $9d9cd39e01578f30$exports.visit)(ast, $0eaaa47dbfd8323d$var$printDocASTReducer);
}
const $0eaaa47dbfd8323d$var$MAX_LINE_LENGTH = 80;
const $0eaaa47dbfd8323d$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$0eaaa47dbfd8323d$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $0eaaa47dbfd8323d$var$hasMultilineItems(node.variableDefinitions) ? $0eaaa47dbfd8323d$var$wrap('(\n', $0eaaa47dbfd8323d$var$join(node.variableDefinitions, '\n'), '\n)') : $0eaaa47dbfd8323d$var$wrap('(', $0eaaa47dbfd8323d$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $0eaaa47dbfd8323d$var$wrap('', node.description, '\n') + $0eaaa47dbfd8323d$var$join([
                node.operation,
                $0eaaa47dbfd8323d$var$join([
                    node.name,
                    varDefs
                ]),
                $0eaaa47dbfd8323d$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives, description: description })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + variable + ': ' + type + $0eaaa47dbfd8323d$var$wrap(' = ', defaultValue) + $0eaaa47dbfd8323d$var$wrap(' ', $0eaaa47dbfd8323d$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$0eaaa47dbfd8323d$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $0eaaa47dbfd8323d$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $0eaaa47dbfd8323d$var$wrap('(', $0eaaa47dbfd8323d$var$join(args, ', '), ')');
            if (argsLine.length > $0eaaa47dbfd8323d$var$MAX_LINE_LENGTH) argsLine = prefix + $0eaaa47dbfd8323d$var$wrap('(\n', $0eaaa47dbfd8323d$var$indent($0eaaa47dbfd8323d$var$join(args, '\n')), '\n)');
            return $0eaaa47dbfd8323d$var$join([
                argsLine,
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $0eaaa47dbfd8323d$var$wrap(' ', $0eaaa47dbfd8323d$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$0eaaa47dbfd8323d$var$join([
                '...',
                $0eaaa47dbfd8323d$var$wrap('on ', typeCondition),
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet, description: description })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + // Note: fragment variable definitions are experimental and may be changed
            // or removed in the future.
            `fragment ${name}${$0eaaa47dbfd8323d$var$wrap('(', $0eaaa47dbfd8323d$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$0eaaa47dbfd8323d$var$wrap('', $0eaaa47dbfd8323d$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $a2743ccee7abec05$exports.printBlockString)(value) : (0, $5b701fdb1eff895a$exports.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $0eaaa47dbfd8323d$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $0eaaa47dbfd8323d$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $0eaaa47dbfd8323d$var$wrap('(', $0eaaa47dbfd8323d$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + $0eaaa47dbfd8323d$var$join([
                'schema',
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + $0eaaa47dbfd8323d$var$join([
                'scalar',
                name,
                $0eaaa47dbfd8323d$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + $0eaaa47dbfd8323d$var$join([
                'type',
                name,
                $0eaaa47dbfd8323d$var$wrap('implements ', $0eaaa47dbfd8323d$var$join(interfaces, ' & ')),
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + name + ($0eaaa47dbfd8323d$var$hasMultilineItems(args) ? $0eaaa47dbfd8323d$var$wrap('(\n', $0eaaa47dbfd8323d$var$indent($0eaaa47dbfd8323d$var$join(args, '\n')), '\n)') : $0eaaa47dbfd8323d$var$wrap('(', $0eaaa47dbfd8323d$var$join(args, ', '), ')')) + ': ' + type + $0eaaa47dbfd8323d$var$wrap(' ', $0eaaa47dbfd8323d$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + $0eaaa47dbfd8323d$var$join([
                name + ': ' + type,
                $0eaaa47dbfd8323d$var$wrap('= ', defaultValue),
                $0eaaa47dbfd8323d$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + $0eaaa47dbfd8323d$var$join([
                'interface',
                name,
                $0eaaa47dbfd8323d$var$wrap('implements ', $0eaaa47dbfd8323d$var$join(interfaces, ' & ')),
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + $0eaaa47dbfd8323d$var$join([
                'union',
                name,
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$wrap('= ', $0eaaa47dbfd8323d$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + $0eaaa47dbfd8323d$var$join([
                'enum',
                name,
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + $0eaaa47dbfd8323d$var$join([
                name,
                $0eaaa47dbfd8323d$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + $0eaaa47dbfd8323d$var$join([
                'input',
                name,
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, directives: directives, repeatable: repeatable, locations: locations })=>$0eaaa47dbfd8323d$var$wrap('', description, '\n') + 'directive @' + name + ($0eaaa47dbfd8323d$var$hasMultilineItems(args) ? $0eaaa47dbfd8323d$var$wrap('(\n', $0eaaa47dbfd8323d$var$indent($0eaaa47dbfd8323d$var$join(args, '\n')), '\n)') : $0eaaa47dbfd8323d$var$wrap('(', $0eaaa47dbfd8323d$var$join(args, ', '), ')')) + $0eaaa47dbfd8323d$var$wrap(' ', $0eaaa47dbfd8323d$var$join(directives, ' ')) + (repeatable ? ' repeatable' : '') + ' on ' + $0eaaa47dbfd8323d$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$0eaaa47dbfd8323d$var$join([
                'extend schema',
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$0eaaa47dbfd8323d$var$join([
                'extend scalar',
                name,
                $0eaaa47dbfd8323d$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$0eaaa47dbfd8323d$var$join([
                'extend type',
                name,
                $0eaaa47dbfd8323d$var$wrap('implements ', $0eaaa47dbfd8323d$var$join(interfaces, ' & ')),
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$0eaaa47dbfd8323d$var$join([
                'extend interface',
                name,
                $0eaaa47dbfd8323d$var$wrap('implements ', $0eaaa47dbfd8323d$var$join(interfaces, ' & ')),
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$0eaaa47dbfd8323d$var$join([
                'extend union',
                name,
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$wrap('= ', $0eaaa47dbfd8323d$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$0eaaa47dbfd8323d$var$join([
                'extend enum',
                name,
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$0eaaa47dbfd8323d$var$join([
                'extend input',
                name,
                $0eaaa47dbfd8323d$var$join(directives, ' '),
                $0eaaa47dbfd8323d$var$block(fields)
            ], ' ')
    },
    DirectiveExtension: {
        leave: ({ name: name, directives: directives })=>$0eaaa47dbfd8323d$var$join([
                'extend directive @' + name,
                $0eaaa47dbfd8323d$var$join(directives, ' ')
            ], ' ')
    },
    // Schema Coordinates
    TypeCoordinate: {
        leave: ({ name: name })=>name
    },
    MemberCoordinate: {
        leave: ({ name: name, memberName: memberName })=>$0eaaa47dbfd8323d$var$join([
                name,
                $0eaaa47dbfd8323d$var$wrap('.', memberName)
            ])
    },
    ArgumentCoordinate: {
        leave: ({ name: name, fieldName: fieldName, argumentName: argumentName })=>$0eaaa47dbfd8323d$var$join([
                name,
                $0eaaa47dbfd8323d$var$wrap('.', fieldName),
                $0eaaa47dbfd8323d$var$wrap('(', argumentName, ':)')
            ])
    },
    DirectiveCoordinate: {
        leave: ({ name: name })=>$0eaaa47dbfd8323d$var$join([
                '@',
                name
            ])
    },
    DirectiveArgumentCoordinate: {
        leave: ({ name: name, argumentName: argumentName })=>$0eaaa47dbfd8323d$var$join([
                '@',
                name,
                $0eaaa47dbfd8323d$var$wrap('(', argumentName, ':)')
            ])
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 *
 * @internal
 */ function $0eaaa47dbfd8323d$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 *
 * @internal
 */ function $0eaaa47dbfd8323d$var$block(array) {
    return $0eaaa47dbfd8323d$var$wrap('{\n', $0eaaa47dbfd8323d$var$indent($0eaaa47dbfd8323d$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 *
 * @internal
 */ function $0eaaa47dbfd8323d$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $0eaaa47dbfd8323d$var$indent(str) {
    return $0eaaa47dbfd8323d$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $0eaaa47dbfd8323d$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}



var $e88d1c230a05b77a$var$createRequestBody_1 = $e88d1c230a05b77a$var$__importDefault((parcelRequire("19Qft")));
var $4a06e01a444253cf$exports = {};
"use strict";
var $4a06e01a444253cf$var$__extends = $4a06e01a444253cf$exports && $4a06e01a444253cf$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($4a06e01a444253cf$exports, "__esModule", {
    value: true
});
$4a06e01a444253cf$exports.ClientError = void 0;
var $4a06e01a444253cf$var$ClientError = /** @class */ function(_super) {
    $4a06e01a444253cf$var$__extends(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = ClientError.extractMessage(response) + ": " + JSON.stringify({
            response: response,
            request: request
        });
        _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ClientError.prototype);
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(_this, ClientError);
        return _this;
    }
    ClientError.extractMessage = function(response) {
        try {
            return response.errors[0].message;
        } catch (e) {
            return "GraphQL Error (Code: " + response.status + ")";
        }
    };
    return ClientError;
}(Error);
$4a06e01a444253cf$exports.ClientError = $4a06e01a444253cf$var$ClientError;


Object.defineProperty($e88d1c230a05b77a$exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $4a06e01a444253cf$exports.ClientError;
    }
});
/**
 * Convert the given headers configuration into a plain object.
 */ var $e88d1c230a05b77a$var$resolveHeaders = function(headers) {
    var oHeaders = {};
    if (headers) {
        if (typeof Headers !== 'undefined' && headers instanceof Headers || headers instanceof $e88d1c230a05b77a$var$CrossFetch.Headers) oHeaders = $e88d1c230a05b77a$var$HeadersInstanceToPlainObject(headers);
        else if (Array.isArray(headers)) headers.forEach(function(_a) {
            var name = _a[0], value = _a[1];
            oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 *
 * @param {string} str GraphQL query
 * @returns {string} Cleaned query
 */ var $e88d1c230a05b77a$var$queryCleanner = function(str) {
    return str.replace(/([\s,]|#[^\n\r]+)+/g, ' ').trim();
};
/**
 * Create query string for GraphQL request
 *
 * @param {object} param0 -
 *
 * @param {string|string[]} param0.query the GraphQL document or array of document if it's a batch request
 * @param {string|undefined} param0.operationName the GraphQL operation name
 * @param {any|any[]} param0.variables the GraphQL variables to use
 */ var $e88d1c230a05b77a$var$buildGetQueryParams = function(_a) {
    var query = _a.query, variables = _a.variables, operationName = _a.operationName;
    if (!Array.isArray(query)) {
        var search = [
            "query=" + encodeURIComponent($e88d1c230a05b77a$var$queryCleanner(query))
        ];
        if (variables) search.push("variables=" + encodeURIComponent(JSON.stringify(variables)));
        if (operationName) search.push("operationName=" + encodeURIComponent(operationName));
        return search.join('&');
    }
    if (typeof variables !== 'undefined' && !Array.isArray(variables)) throw new Error('Cannot create query with given variable type, array expected');
    // Batch support
    var payload = query.reduce(function(accu, currentQuery, index) {
        accu.push({
            query: $e88d1c230a05b77a$var$queryCleanner(currentQuery),
            variables: variables ? JSON.stringify(variables[index]) : undefined
        });
        return accu;
    }, []);
    return "query=" + encodeURIComponent(JSON.stringify(payload));
};
/**
 * Fetch data using POST method
 */ var $e88d1c230a05b77a$var$post = function(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions;
    return $e88d1c230a05b77a$var$__awaiter(void 0, void 0, void 0, function() {
        var body;
        return $e88d1c230a05b77a$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    body = $e88d1c230a05b77a$var$createRequestBody_1.default(query, variables, operationName);
                    return [
                        4 /*yield*/ ,
                        fetch(url, $e88d1c230a05b77a$var$__assign({
                            method: 'POST',
                            headers: $e88d1c230a05b77a$var$__assign($e88d1c230a05b77a$var$__assign({}, typeof body === 'string' ? {
                                'Content-Type': 'application/json'
                            } : {}), headers),
                            body: body
                        }, fetchOptions))
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _b.sent()
                    ];
            }
        });
    });
};
/**
 * Fetch data using GET method
 */ var $e88d1c230a05b77a$var$get = function(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions;
    return $e88d1c230a05b77a$var$__awaiter(void 0, void 0, void 0, function() {
        var queryParams;
        return $e88d1c230a05b77a$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    queryParams = $e88d1c230a05b77a$var$buildGetQueryParams({
                        query: query,
                        variables: variables,
                        operationName: operationName
                    });
                    return [
                        4 /*yield*/ ,
                        fetch(url + "?" + queryParams, $e88d1c230a05b77a$var$__assign({
                            method: 'GET',
                            headers: headers
                        }, fetchOptions))
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _b.sent()
                    ];
            }
        });
    });
};
/**
 * todo
 */ var $e88d1c230a05b77a$var$GraphQLClient = /** @class */ function() {
    function GraphQLClient(url, options) {
        this.url = url;
        this.options = options || {};
    }
    GraphQLClient.prototype.rawRequest = function(query, variables, requestHeaders) {
        var _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $e88d1c230a05b77a$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? 'POST' : _c, fetchOptions = $e88d1c230a05b77a$var$__rest(_a, [
            "headers",
            "fetch",
            "method"
        ]);
        var url = this.url;
        return $e88d1c230a05b77a$var$makeRequest({
            url: url,
            query: query,
            variables: variables,
            headers: $e88d1c230a05b77a$var$__assign($e88d1c230a05b77a$var$__assign({}, $e88d1c230a05b77a$var$resolveHeaders(headers)), $e88d1c230a05b77a$var$resolveHeaders(requestHeaders)),
            operationName: undefined,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions
        });
    };
    /**
     * Send a GraphQL document to the server.
     */ GraphQLClient.prototype.request = function(document, variables, requestHeaders) {
        return $e88d1c230a05b77a$var$__awaiter(this, void 0, void 0, function() {
            var _a, headers, _b, fetch, _c, method, fetchOptions, url, _d, query, operationName, data;
            return $e88d1c230a05b77a$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $e88d1c230a05b77a$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? 'POST' : _c, fetchOptions = $e88d1c230a05b77a$var$__rest(_a, [
                            "headers",
                            "fetch",
                            "method"
                        ]);
                        url = this.url;
                        _d = $e88d1c230a05b77a$var$resolveRequestDocument(document), query = _d.query, operationName = _d.operationName;
                        return [
                            4 /*yield*/ ,
                            $e88d1c230a05b77a$var$makeRequest({
                                url: url,
                                query: query,
                                variables: variables,
                                headers: $e88d1c230a05b77a$var$__assign($e88d1c230a05b77a$var$__assign({}, $e88d1c230a05b77a$var$resolveHeaders(headers)), $e88d1c230a05b77a$var$resolveHeaders(requestHeaders)),
                                operationName: operationName,
                                fetch: fetch,
                                method: method,
                                fetchOptions: fetchOptions
                            })
                        ];
                    case 1:
                        data = _e.sent().data;
                        return [
                            2 /*return*/ ,
                            data
                        ];
                }
            });
        });
    };
    /**
     * Send a GraphQL document to the server.
     */ GraphQLClient.prototype.batchRequests = function(documents, requestHeaders) {
        return $e88d1c230a05b77a$var$__awaiter(this, void 0, void 0, function() {
            var _a, headers, _b, fetch, _c, method, fetchOptions, url, queries, variables, data;
            return $e88d1c230a05b77a$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $e88d1c230a05b77a$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? 'POST' : _c, fetchOptions = $e88d1c230a05b77a$var$__rest(_a, [
                            "headers",
                            "fetch",
                            "method"
                        ]);
                        url = this.url;
                        queries = documents.map(function(_a) {
                            var document = _a.document;
                            return $e88d1c230a05b77a$var$resolveRequestDocument(document).query;
                        });
                        variables = documents.map(function(_a) {
                            var variables = _a.variables;
                            return variables;
                        });
                        return [
                            4 /*yield*/ ,
                            $e88d1c230a05b77a$var$makeRequest({
                                url: url,
                                query: queries,
                                variables: variables,
                                headers: $e88d1c230a05b77a$var$__assign($e88d1c230a05b77a$var$__assign({}, $e88d1c230a05b77a$var$resolveHeaders(headers)), $e88d1c230a05b77a$var$resolveHeaders(requestHeaders)),
                                operationName: undefined,
                                fetch: fetch,
                                method: method,
                                fetchOptions: fetchOptions
                            })
                        ];
                    case 1:
                        data = _d.sent().data;
                        return [
                            2 /*return*/ ,
                            data
                        ];
                }
            });
        });
    };
    GraphQLClient.prototype.setHeaders = function(headers) {
        this.options.headers = headers;
        return this;
    };
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ GraphQLClient.prototype.setHeader = function(key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-ignore
        headers[key] = value;
        else this.options.headers = (_a = {}, _a[key] = value, _a);
        return this;
    };
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ GraphQLClient.prototype.setEndpoint = function(value) {
        this.url = value;
        return this;
    };
    return GraphQLClient;
}();
$e88d1c230a05b77a$exports.GraphQLClient = $e88d1c230a05b77a$var$GraphQLClient;
function $e88d1c230a05b77a$var$makeRequest(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, headers = _a.headers, operationName = _a.operationName, fetch = _a.fetch, _b = _a.method, method = _b === void 0 ? 'POST' : _b, fetchOptions = _a.fetchOptions;
    return $e88d1c230a05b77a$var$__awaiter(this, void 0, void 0, function() {
        var fetcher, isBathchingQuery, response, result, successfullyReceivedData, headers_1, status_1, errorResult;
        return $e88d1c230a05b77a$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    fetcher = method.toUpperCase() === 'POST' ? $e88d1c230a05b77a$var$post : $e88d1c230a05b77a$var$get;
                    isBathchingQuery = Array.isArray(query);
                    return [
                        4 /*yield*/ ,
                        fetcher({
                            url: url,
                            query: query,
                            variables: variables,
                            operationName: operationName,
                            headers: headers,
                            fetch: fetch,
                            fetchOptions: fetchOptions
                        })
                    ];
                case 1:
                    response = _c.sent();
                    return [
                        4 /*yield*/ ,
                        $e88d1c230a05b77a$var$getResult(response)
                    ];
                case 2:
                    result = _c.sent();
                    successfullyReceivedData = isBathchingQuery && Array.isArray(result) ? !result.some(function(_a) {
                        var data = _a.data;
                        return !data;
                    }) : !!result.data;
                    if (response.ok && !result.errors && successfullyReceivedData) {
                        headers_1 = response.headers, status_1 = response.status;
                        return [
                            2 /*return*/ ,
                            $e88d1c230a05b77a$var$__assign($e88d1c230a05b77a$var$__assign({}, isBathchingQuery ? {
                                data: result
                            } : result), {
                                headers: headers_1,
                                status: status_1
                            })
                        ];
                    } else {
                        errorResult = typeof result === 'string' ? {
                            error: result
                        } : result;
                        throw new $4a06e01a444253cf$exports.ClientError($e88d1c230a05b77a$var$__assign($e88d1c230a05b77a$var$__assign({}, errorResult), {
                            status: response.status,
                            headers: response.headers
                        }), {
                            query: query,
                            variables: variables
                        });
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * todo
 */ function $e88d1c230a05b77a$var$rawRequest(url, query, variables, requestHeaders) {
    return $e88d1c230a05b77a$var$__awaiter(this, void 0, void 0, function() {
        var client;
        return $e88d1c230a05b77a$var$__generator(this, function(_a) {
            client = new $e88d1c230a05b77a$var$GraphQLClient(url);
            return [
                2 /*return*/ ,
                client.rawRequest(query, variables, requestHeaders)
            ];
        });
    });
}
$e88d1c230a05b77a$exports.rawRequest = $e88d1c230a05b77a$var$rawRequest;
/**
 * Send a GraphQL Document to the GraphQL server for exectuion.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await request('https://foo.bar/graphql', `
 *   {
 *     query {
 *       users
 *     }
 *   }
 * `)
 *
 * // You can also pass a GraphQL DocumentNode. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * // If you don't actually care about using DocumentNode but just
 * // want the tooling support for gql template tag like IDE syntax
 * // coloring and prettier autoformat then note you can use the
 * // passthrough gql tag shipped with graphql-request to save a bit
 * // of performance and not have to install another dep into your project.
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 */ function $e88d1c230a05b77a$var$request(url, document, variables, requestHeaders) {
    return $e88d1c230a05b77a$var$__awaiter(this, void 0, void 0, function() {
        var client;
        return $e88d1c230a05b77a$var$__generator(this, function(_a) {
            client = new $e88d1c230a05b77a$var$GraphQLClient(url);
            return [
                2 /*return*/ ,
                client.request(document, variables, requestHeaders)
            ];
        });
    });
}
$e88d1c230a05b77a$exports.request = $e88d1c230a05b77a$var$request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for exectuion.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ function $e88d1c230a05b77a$var$batchRequests(url, documents, requestHeaders) {
    return $e88d1c230a05b77a$var$__awaiter(this, void 0, void 0, function() {
        var client;
        return $e88d1c230a05b77a$var$__generator(this, function(_a) {
            client = new $e88d1c230a05b77a$var$GraphQLClient(url);
            return [
                2 /*return*/ ,
                client.batchRequests(documents, requestHeaders)
            ];
        });
    });
}
$e88d1c230a05b77a$exports.batchRequests = $e88d1c230a05b77a$var$batchRequests;
$e88d1c230a05b77a$exports.default = $e88d1c230a05b77a$var$request;
/**
 * todo
 */ function $e88d1c230a05b77a$var$getResult(response) {
    var contentType = response.headers.get('Content-Type');
    if (contentType && contentType.startsWith('application/json')) return response.json();
    else return response.text();
}
/**
 * helpers
 */ function $e88d1c230a05b77a$var$resolveRequestDocument(document) {
    var _a;
    if (typeof document === 'string') return {
        query: document
    };
    var operationName = undefined;
    var operationDefinitions = document.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    });
    if (operationDefinitions.length === 1) operationName = (_a = operationDefinitions[0].name) === null || _a === void 0 ? void 0 : _a.value;
    return {
        query: $0eaaa47dbfd8323d$exports.print(document),
        operationName: operationName
    };
}
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ function $e88d1c230a05b77a$var$gql(chunks) {
    var variables = [];
    for(var _i = 1; _i < arguments.length; _i++)variables[_i - 1] = arguments[_i];
    return chunks.reduce(function(accumulator, chunk, index) {
        return "" + accumulator + chunk + (index in variables ? variables[index] : '');
    }, '');
}
$e88d1c230a05b77a$exports.gql = $e88d1c230a05b77a$var$gql;
/**
 * Convert Headers instance into regular object
 */ function $e88d1c230a05b77a$var$HeadersInstanceToPlainObject(headers) {
    var o = {};
    headers.forEach(function(v, k) {
        o[k] = v;
    });
    return o;
}


var $ff55be5ba06af622$exports = {};
$ff55be5ba06af622$exports = JSON.parse('{"data":{"allPois":[{"id":"55717249","shortName":"Harris Collection","fullName":"Harris Learning Collection","mapId":"harris","websiteUrl":"https://harris.fieldmuseum.org/","updatedAt":"2026-08-04T11:20:10-05:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<p>The N. W. Harris Learning Collection at the Field Museum gives educators and parents a chance to take the Museum\'s collection to their classroom or home. Borrow these specimens, items, and related curricular materials for up to three weeks, and when you return your borrowed treasures, peruse the over 100-year-old Learning Collection to take something new.</p>\\n<p><strong>Please note:</strong> The Harris Learning Collection will be closed from Wednesday, July 29 to Tuesday, November 3. for renovations. We will not be accepting any external reservations from Wednesday, July 29 to Tuesday, November 3.&nbsp;</p>","colorCategory":"Amenity","closed":"Open","image":{"id":"22440703","url":"https://www.datocms-assets.com/44232/1665071249-hlc_redfox-sittingadult_zm-004-3.jpg"}},{"id":"40217218","shortName":"Evolving Planet","fullName":"Griffin Halls of Evolving Planet & SUE the T. rex","mapId":"evolving_planet","websiteUrl":"https://www.fieldmuseum.org/exhibitions/evolving-planet","updatedAt":"2026-08-04T11:16:11-05:00","sponsorAcknowledgment":"<p>The <em>Griffin Halls of Evolving Planet</em> are part of the Griffin Dinosaur Experience, made possible by the generous support of the Kenneth C. Griffin Charitable Fund.</p>","labelOverride":"","labelAlignment":"center (default)","description":"<p>Discover the many creatures that have roamed the earth throughout history, from single-celled organisms to our extended human family. You can see a variety of real fossils and experience the story of evolution, the process that connects all living things on Earth. Don\u2019t miss the <em>Elizabeth Morse Genius Hall of Dinosaurs</em> to get up close and personal with more than a dozen of the biggest creatures in our history, and the <a href=\\"https://www.fieldmuseum.org/exhibition/halls-and-galleries/meet-the-chicago-archaeopteryx\\">Chicago <em>Archaeopteryx</em></a>, a rare fossil that reveals the evolutionary link between dinosaurs and birds. Then, experience the world of SUE the&nbsp;<em>T. rex</em>, our famous fossil with a big personality.</p>","colorCategory":"Dinosaurs","closed":"Open","image":{"id":"16582068","url":"https://www.datocms-assets.com/44232/1632764129-field2suevisitors1266-hewettwebexport.jpg"}},{"id":"40217238","shortName":"Mammals","fullName":"Mammals","mapId":"mammals","websiteUrl":"","updatedAt":"2026-08-04T11:11:01-05:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<p>Catch glimpse of mammals from Asia and Africa\u2014from giraffes at a watering hole to monkeys peeking out from the canopy. These halls include dioramas with meticulously crafted landscapes and carefully preserved specimens to immerse you in their unique habitats.</p>\\n<p><strong>Please note:</strong> <span>Beginning July 20, <em>What is an Animal? &amp; Animal Biology</em> and the adjoining galleries, will be closed as we complete a series of building improvements. The Bird Habitats gallery will close on July 20. <em>What is an Animal?</em> and the Mammals of Africa hall will close on August 3. Closures will remain in effect until October 23, 2026.</span></p>","colorCategory":"Nature","closed":"Open","image":{"id":"16584387","url":"https://www.datocms-assets.com/44232/1632763815-fieldmuseuminteractiveexhibitslhewett-201webexport.jpg"}},{"id":"40217224","shortName":"What is an Animal?","fullName":"What is an Animal? and Animal Biology ","mapId":"animals","websiteUrl":"https://www.fieldmuseum.org/exhibition/halls-and-galleries/what-animal-animal-biology","updatedAt":"2026-08-04T11:09:41-05:00","sponsorAcknowledgment":"","labelOverride":"What is\\nan Animal?","labelAlignment":"","description":"<p><span>Beginning July 20, <em>What is an Animal? &amp; Animal Biology</em> and the adjoining galleries, will be closed as we complete a series of building improvements. The Bird Habitats gallery will close on July 20. <em>What is an Animal?</em> and the Mammals of Africa hall will close on August 3. Closures will remain in effect until October 23, 2026.</span></p>","colorCategory":"Nature","closed":"Closed","image":{"id":"16582032","url":"https://www.datocms-assets.com/44232/1632764214-17-069-5583-andersonwebexport.jpg"}},{"id":"OvSFw1z8QYSOumDc5WuoZQ","shortName":"Pok\xe9mon","fullName":"Pok\xe9mon Fossil Museum","mapId":"hall_7","websiteUrl":"https://www.fieldmuseum.org/exhibition/Exhibition/pokemon","updatedAt":"2026-05-18T11:22:18-05:00","sponsorAcknowledgment":"<main class=\\"container-fluid\\">\\n<div class=\\"row\\">\\n<div class=\\"container\\" data-testid=\\"main-wrapper\\">\\n<div class=\\"row sponsor\\">\\n<div class=\\"col-12 copy text-center\\">\\n<div dir=\\"ltr\\">\\n<p></p>\\n</div>\\n</div>\\n</div>\\n</div>\\n</div>\\n</main>\\n<div class=\\"info-bar-full\\"></div>","labelOverride":"","labelAlignment":"","description":"<div class=\\"my-5\\">\\n<div class=\\"row\\">\\n<div class=\\"container\\" data-testid=\\"main-wrapper\\">\\n<div class=\\"copy\\">\\n<p><span>\u26A1\uFE0FThe&nbsp;</span><em>Pok&eacute;mon Fossil Museum</em><span>&nbsp;exhibition will make its North American debut at the Field Museum on May 22, 2026 &mdash; April 11, 2027! This one-of-a-kind experience brings together the worlds of Pok&eacute;mon and paleontology, inviting visitors to compare fossil Pok&eacute;mon like Tyrantrum and Archeops with real-world fossils&mdash;including SUE the&nbsp;</span><em>T. rex</em><span>.</span></p>\\n<p>From May 22, 2026&mdash;April 11, 2027!</p>\\n</div>\\n</div>\\n</div>\\n</div>\\n<div class=\\"my-5\\"></div>\\n<div class=\\"exhibition-higlights\\"></div>","colorCategory":"Nature","closed":"Open","image":{"id":"G3HvgTs_Q9mNEUUdLwqV1g","url":"https://www.datocms-assets.com/44232/1761855365-pokemon_header_blue.jpg"}},{"id":"40217243","shortName":"Jurassic Ocean","fullName":"Jurassic Oceans: Monsters of the Deep","mapId":"","websiteUrl":"https://www.fieldmuseum.org/exhibitions/jurassic-oceans-monsters-deep","updatedAt":"2026-05-18T10:29:46-05:00","sponsorAcknowledgment":"<p><em>Jurassic Oceans: Monsters of the Deep</em> was curated and produced by the Natural History Museum, London.</p>","labelOverride":"","labelAlignment":"","description":"<p>Dive into the prehistoric seas that were home to enormous marine reptiles, crocodiles, and sharks. In <em>Jurassic Oceans: Monsters of the Deep</em>, meet the underwater giants that lived 200 million years ago. As dinosaurs reached new heights, sea creatures became larger, faster, and fiercer. Experience what it&rsquo;s like to stand (or swim) next to top predators like a plesiosaur&mdash;a reptile with flippers, a very long neck, and super sharp teeth. <em>The exhibition is presented in both English and Spanish. La exhibici&oacute;n est&aacute; presentada en ingl&eacute;s y espa&ntilde;ol.</em></p>","colorCategory":"Dinosaurs","closed":"Closed","image":{"id":"16584634","url":"https://www.datocms-assets.com/44232/1646154810-bait_ball_cnicholls2009.jpg"}},{"id":"Ze4FBvc_SgyTRH6gjBxbdA","shortName":"Connecting Threads","fullName":"Connecting Threads","mapId":"","websiteUrl":"https://www.fieldmuseum.org/exhibition/connecting-threads-africa-fashion-in-chicago","updatedAt":"2026-04-01T09:42:19-05:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<div class=\\"exhibit-flyer-page__header-description\\">\\n<p>Opening February 28, 2025</p>\\n<p>In this exhibit, Chicago designers celebrate their heritage, culture, and communities by creating looks inspired by items in the Field Museum collections and the vibrant African design scene in Chicago.</p>\\n</div>","colorCategory":"Culture","closed":"Closed","image":{"id":"MyBy24TAQD-26t3aZqHpRw","url":"https://www.datocms-assets.com/44232/1771904002-connecting-threads-identity-image-7x5.webp"}},{"id":"40217245","shortName":"Mastaba","fullName":"Mastaba","mapId":"mastaba","websiteUrl":"","updatedAt":"2026-01-07T11:42:48-06:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<p>Step inside a three-story replica of a mastaba, a type of ancient Egyptian tomb. You can explore two authentic chamber rooms that are over 4,400 years old. They come from the burial site of Unis-Ankh, the son of Pharaoh Unis, who ruled in the 5th Dynasty. The original walls feature masterfully crafted reliefs, and the new walls are covered with hieroglyphs made using ancient methods. Continue your journey through the exhibition <em>Inside Ancient Egypt</em> by walking down the spiral staircase in the mastaba or taking the closest elevator to the ground level. There, you can see one of the largest collections of mummies in the United States: 23 human mummies and more than 30 animal mummies. And experience an ancient marketplace reconstructed from market scenes shown on tomb walls. The kid-friendly stalls are filled with goods, and the marketplace is filled with people engaged in everyday activities. <em>Inside Ancient Egypt</em> is an up-close look at the daily lives of ancient Egyptians and how they thought about death.</p>","colorCategory":"Culture","closed":"Closed","image":{"id":"16579657","url":"https://www.datocms-assets.com/44232/1642284170-17-069-5169-anderson_webexport.jpg"}},{"id":"40217222","shortName":"Africa","fullName":"Africa","mapId":"africa","websiteUrl":"https://www.fieldmuseum.org/exhibition/africa","updatedAt":"2025-11-19T09:44:51-06:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<p>The Field Museum closed its Africa Hall on October 6, 2025, in preparation for a reimagined gallery that will open in the spring of 2028.</p>","colorCategory":"Culture","closed":"Closed","image":{"id":"16584104","url":"https://www.datocms-assets.com/44232/1632764633-17-069-5047-andersonwebexport.jpg"}},{"id":"DZ_cG8UJTu2YJ79PVQvWXA","shortName":"After the Dinosaurs","fullName":"After the Age of Dinosaurs","mapId":"hall_5","websiteUrl":"https://www.fieldmuseum.org/exhibition/after-the-age-of-dinosaurs","updatedAt":"2025-11-19T09:42:44-06:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<div class=\\"my-5\\">\\n<div class=\\"row\\">\\n<div class=\\"container\\" data-testid=\\"main-wrapper\\">\\n<div class=\\"copy\\">\\n<p dir=\\"ltr\\" class=\\"zfr3Q CDt4Ke \\"><span>Discover how a colossal asteroid ended the dinosaurs\' reign and paved the way for life&rsquo;s astonishing comeback, shaping the world we know today. Meet unfamiliar creatures, explore immersive media experiences, and marvel at fossils from the Field Museum\'s renowned collections. Open from&nbsp;</span><span>Aug 29, 2025&mdash; Jan 3, 2027.</span></p>\\n</div>\\n</div>\\n</div>\\n</div>","colorCategory":"Dinosaurs","closed":"Open","image":{"id":"QXVxGqgUQh6mgjpQNbdQeA","url":"https://www.datocms-assets.com/44232/1762889612-atd_cretaceous_lowres-illustration-by-jay-ryan-field-museum.jpg"}},{"id":"PCZfWBL6QuWaGBunTEwepg","shortName":"Changing Face","fullName":"The Changing Face of Science","mapId":"comer_gallery","websiteUrl":"https://www.fieldmuseum.org/exhibition/the-changing-face-of-science","updatedAt":"2025-06-18T09:28:29-05:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<p>Engage with the captivating stories of women and people of color in science and find inspiration for your own exploration. Discover how diverse perspectives, identities, and backgrounds uniquely contribute to scientific advancement.</p>","colorCategory":"Culture","closed":"Open","image":{"id":"EcE0sTQWQRuvCy_3wP1IyQ","url":"https://www.datocms-assets.com/44232/1747422099-cfos_ruane_desouza.jpg"}},{"id":"40217225","shortName":"M\xe1ximo the Titanosaur","fullName":"M\xe1ximo the Titanosaur","mapId":"maximo","websiteUrl":"https://www.fieldmuseum.org/exhibitions/maximo-titanosaur","updatedAt":"2025-02-26T16:14:51-06:00","sponsorAcknowledgment":"","labelOverride":"M\xe1ximo\\nthe\\nTitanosaur","labelAlignment":"","description":"<p>Come face-to-face with the largest dinosaur ever discovered&mdash;the titanosaur <em>Patagotitan mayorum</em>. Named M&aacute;ximo, meaning &ldquo;maximum&rdquo; or &ldquo;most&rdquo; in Spanish. This long-necked, plant-eating dinosaur lived over 100 million years ago in what is now Patagonia, Argentina. Our titanosaur cast reaches 122 feet across and stands 28 feet tall at the head. Modeled from fossil bones, this cast conveys the sheer size of the biggest animal ever to live.&nbsp; <em>The exhibition is presented in both English and Spanish. La exhibici&oacute;n est&aacute; presentada en ingl&eacute;s y espa&ntilde;ol</em>.</p>","colorCategory":"Dinosaurs","closed":"Open","image":{"id":"16583049","url":"https://www.datocms-assets.com/44232/1632763919-fieldmuseummaximo-451-hewettwebexport.jpg"}},{"id":"40217208","shortName":"Jades","fullName":"Elizabeth Hubert Malott Hall of Jades","mapId":"jades","websiteUrl":"https://www.fieldmuseum.org/exhibition/elizabeth-hubert-malott-hall-of-jades","updatedAt":"2025-02-26T11:06:29-06:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"left","description":"Get a close look at more than 450 jade objects from our collection. They tell the story of jade\u2019s iconic role throughout China\'s history and how it has changed over time. In Neolithic China, the stone was used in burial rituals. During the Bronze Age, kings and warriors displayed jade objects as symbols of their status. Today artists create arresting jade pieces honoring the past, using intricate new techniques.\\n\\nFor millennia, jade has been described as possessing five virtues: benevolence, loyalty, wisdom, courage, and integrity. Discover more about its enduring importance to Chinese cultural traditions.","colorCategory":"Nature","closed":"Open","image":{"id":"16582198","url":"https://www.datocms-assets.com/44232/1632763538-17-069-1450-andersonwebexport.jpg"}},{"id":"CrHFwfSSSjmeLDNUXZ7mGQ","shortName":"Audubon\'s Birds ","fullName":"Audubon\'s Birds of America","mapId":"brooker_gallery","websiteUrl":"https://www.fieldmuseum.org/exhibition/audubon-s-birds-of-america","updatedAt":"2025-02-26T11:04:54-06:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<p><span>Art and science intersect on the three-foot-tall pages of one of the world&rsquo;s rarest books: Audubon\'s Birds of America.&nbsp;</span><span>Learn about the life of John James Audubon to uncover the complexities of his legacy, and soar through the 12-year process of creating these masterpieces of printmaking.</span></p>\\n<p><i><span>The exhibition is presented in both English and Spanish. La exhibici&oacute;n est&aacute; presentada en ingl&eacute;s y espa&ntilde;ol.</span></i></p>","colorCategory":"Nature","closed":"Open","image":{"id":"IEqzWTWmS5i5x1VF_IgrOw","url":"https://www.datocms-assets.com/44232/1730480835-gn90797_ofm_231_01d_edited.jpg"}},{"id":"40217207","shortName":"Family PlayLab","fullName":"Crown Family PlayLab","mapId":"playlab","websiteUrl":"https://www.fieldmuseum.org/exhibition/crown-family-playlab","updatedAt":"2025-02-26T11:01:21-06:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<p>Designed for children between two and six years old, the <em>Crown Family PlayLab</em> is an interactive, hands-on space that makes learning an adventure. Early learners can explore world cultures through music, experience everyday life in a recreated pueblo, or pretend to be a paleontologist with dinosaur bones, and that&rsquo;s just the beginning. With opportunities for discovery for young children, this exhibition presents a new adventure every time you visit. We strive to welcome everyone to the <em>PlayLab</em>, which has wheelchair access, a nursing room, and a quiet reading corner.</p>","colorCategory":"Amenity","closed":"Open","image":{"id":"16583633","url":"https://www.datocms-assets.com/44232/1632764187-17-069-2163-andersonwebexport.jpg"}},{"id":"40217226","shortName":"Ancient Egypt","fullName":"Inside Ancient Egypt","mapId":"egypt","websiteUrl":"https://www.fieldmuseum.org/exhibition/inside-ancient-egypt","updatedAt":"2025-02-26T11:00:24-06:00","sponsorAcknowledgment":"","labelOverride":"Ancient\\nEgypt","labelAlignment":"","description":"<p><em>Inside Ancient Egypt</em> is an up-close look at the daily lives of ancient Egyptians and how they thought about death. Enter through the ground level to see one of the largest collections of mummies in the United States: 23 human mummies and more than 30 animal mummies. And experience an ancient marketplace reconstructed from market scenes shown on tomb walls. The kid-friendly stalls are filled with goods, and the marketplace is filled with people engaged in everyday activities. Continue your journey to the main level of the museum and step inside a three-story replica of a mastaba, a type of ancient Egyptian tomb. You can explore two authentic chamber rooms that are over 4,400 years old. They come from the burial site of Unis-Ankh, the son of the pharaoh Unis who reigned during the 5th Dynasty. This exhibition offers clues to ancient Egyptians&rsquo; lives on Earth and everything we may have in common with them.</p>","colorCategory":"Culture","closed":"Open","image":{"id":"16579657","url":"https://www.datocms-assets.com/44232/1642284170-17-069-5169-anderson_webexport.jpg"}},{"id":"40217214","shortName":"Meteorites","fullName":"Meteorites","mapId":"meteorites","websiteUrl":"https://www.fieldmuseum.org/exhibitions/meteorites","updatedAt":"2025-01-30T13:50:24-06:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<p>This exhibition, located in the<span>&nbsp;</span><em>Grainger Gallery<span>&nbsp;</span></em>on the upper level, offers fascinating insight into where these objects came from and what they&rsquo;re made of. Meteorites can contain minerals that are older than the sun and the planets, and they help to give us an idea of Earth\'s geological makeup when it first formed.</p>","colorCategory":"Nature","closed":"Open","image":{"id":"16584242","url":"https://www.datocms-assets.com/44232/1632764010-meteoritesimg0759-knightdropboxwebexport0.jpg"}},{"id":"cWREduUkT62Ioyy1YDLBqQ","shortName":"Unseen Oceans","fullName":"Unseen Oceans","mapId":"","websiteUrl":"https://www.fieldmuseum.org/exhibitions/unseen-oceans","updatedAt":"2025-01-06T09:11:43-06:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<div class=\\"col-md-7 mb-md-0 mb-4 bg-white z-index-10\\">\\n  <div class=\\"mb-5 copy\\">\\n    <section class=\\"field field-name-body field-type-text-with-summary field-label-hidden\\">\\n      <p><span>Embark on a journey from the oceans&rsquo; white-capped waves to their inky depths as you discover the latest ocean science in an&nbsp;</span><span>immersive new exhibition that will make a splash with the whole family.</span></p>\\n    </section>\\n  </div>\\n</div>","colorCategory":"Nature","closed":"Closed","image":{"id":"OHEKICC2S7y1TmYGSKGB9A","url":"https://www.datocms-assets.com/44232/1703101418-9-triton-submersible_df.jpg"}},{"id":"8BMHPNbDRMOe5-iMy4zsMQ","shortName":"Bloodsuckers","fullName":"Bloodsuckers: Legends to Leeches","mapId":"","websiteUrl":"https://www.fieldmuseum.org/exhibitions/bloodsuckers-legends-to-leeches","updatedAt":"2024-12-03T13:53:15-06:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<p><span>Check out larger-than-life models of bloodsucking creatures and learn how different bloodsuckers earned their titles. Use magnifying glasses to see fossilized bloodsuckers up close. Step into the sounds of a Northwoods mosquito swarm, then play a game to discover which repellants best protect us from their bites. Take a journey through classic movies like&nbsp;</span><i><span>Dracula&nbsp;</span></i><span>in a mini movie theater and see a historical vampire hunting kit to discover where fact meets fiction.</span></p>","colorCategory":"Nature","closed":"Closed","image":{"id":"68363919","url":"https://www.datocms-assets.com/44232/1693232153-public-relations-bloodsuckers-rectangle.jpg"}},{"id":"55347922","shortName":"Changing Face","fullName":"The Changing Face of Science","mapId":"rice_gallery","websiteUrl":"https://www.fieldmuseum.org/exhibitions/changing-face-science","updatedAt":"2024-09-03T09:22:15-05:00","sponsorAcknowledgment":"","labelOverride":"","labelAlignment":"","description":"<div class=\\"col-12 mb-5 mb-md-0 col-md-5\\" data-testid=\\"check-left\\">\\n  <div class=\\"copy\\">\\n    <h3 id=\\"explore-jingmais-path-into-science-and-find-your-own\\">Explore Jingmai&rsquo;s path into science &mdash; and find your own.</h3>\\n    <p>Meet Jingmai O&rsquo;Connor, punk-rock paleontologist and the Field Museum&rsquo;s Associate Curator of Fossil Reptiles&mdash; aka the dinosaur curator. Come along on Jingmai\'s journey to learn how her interest in science began, see real fossils unearthed by Jingmai, and visit her fossil prep workspace. Discover the ways personal passions can overlap with science to create your own path toward becoming a scientist.</p>\\n    <ul>\\n      <li>Jingmai O\'Connor\'s exhibition is in Rice Hall on the main level through June 23, 2024</li>\\n    </ul>\\n  </div>\\n</div>\\n<div class=\\"col-12 mb-5 mb-md-0 col-md-6 offset-md-1\\" data-testid=\\"check-left\\">\\n  <div class=\\"row h-100 align-items-center\\">\\n    <div class=\\"container\\">\\n      <figure class=\\"row image-full \\">\\n        <div class=\\"col-12\\"></div>\\n      </figure>\\n    </div>\\n  </div>\\n</div>","colorCategory":"Culture","closed":"Closed","image":{"id":"64472026","url":"https://www.datocms-assets.com/44232/1691510663-copy-of-northern-alberta-fieldwork-2-edited.png"}}]}}');


/** Turn on debug mode during local development based on hostname
 Or when a query param "debug" is set (for CMS content previews)
 */ const $7831b43083ebf45c$var$hasDebugParam = new URLSearchParams(window.location.search).has('debug');
if (window.location.hostname === 'localhost' || window.location.hostname === 'tfm-map-preview.vercel.app' || $7831b43083ebf45c$var$hasDebugParam) window.tfmDebug = true;
/*** LOAD CMS CONTENT ***/ // First we preload the data from the cached JSON file, for faster loading and just in case our CMS is down
// fallback-data.json is generated MANUALLY every so often. Refresh it as you see fit by just grabbing the API response from the Chrome inspector
let $7831b43083ebf45c$var$CMSData = [
    ...(0, (/*@__PURE__*/$parcel$interopDefault($ff55be5ba06af622$exports))).data.allPois
];
// Then we load the data from the CMS
const $7831b43083ebf45c$var$DatoClient = new (0, $e88d1c230a05b77a$exports.GraphQLClient)('https://graphql.datocms.com/', {
    headers: {
        authorization: `Bearer ${"4c6ff75df27e925c4bceb89c4ffa2d"}`
    }
});
//language=graphql
const $7831b43083ebf45c$var$query = `
    query PoiQuery {
        allPois(first: "100") {
            id
            shortName
            fullName
            mapId
            websiteUrl
            updatedAt
            sponsorAcknowledgment(markdown: true)
            labelOverride
            labelAlignment
            description(markdown: true)
            colorCategory
            closed
            image {
                id
                url(imgixParams: {w: "500"})
            }
        }
    }

`;
$7831b43083ebf45c$var$DatoClient.request($7831b43083ebf45c$var$query).then((response)=>{
    if (response.allPois.length > 0) $7831b43083ebf45c$var$CMSData = [
        ...response.allPois
    ];
    else console.error('CMS data invalid', response);
}).catch((error)=>{
    console.error('Error while fetching from DatoCMS:', error);
});
/*** REUSABLE SETTINGS ***/ /*
 We show/hide different things depending on zoom level
 For example, important exhibitions and amenities (restrooms, etc.) are always visible,
 while others only appear at `medium` or `close`.

 Independently of zoom levels, some font and icon sizes scale as a function of the zoom level.
 This is so that they can remain constant sized to the visitor, i.e. as zoom level increases, their size decreases
 proportionally so that they remain the same on-screen size.
 */ const $7831b43083ebf45c$var$tfmZooms = {
    far: 17,
    medium: 18.5,
    close: 20
};
// Our brand colors. Our CMS uses these same string names in `color`
const $7831b43083ebf45c$var$tfmColors = {
    "Amenity": '#0a46e6',
    "Culture": '#F29F77',
    "Dinosaurs": '#B274A7',
    "Nature": '#AAC38A',
    "Field Blue": '#0a46e6',
    "Field Gray Lighter": '#F0F3F3',
    "Field Gray Light": '#C9CACC',
    "Field Gray": '#6a6a71',
    "Field Gray Darker": '#333336',
    "Field Black": '#0F0F14',
    "Success Green": '#53B59E',
    "Warning Red": '#D44235',
    "Map Dark Yellow": '#9a7e0b',
    "Map Brown": '#663300',
    "Map Light Blue": '#6FB4D6',
    "Map Yellow": '#C6AD59',
    "Map Magenta": '#A7197C',
    "Field Green": '#37816e',
    "Field Light Green": '#AAC38A',
    "Field Purple": '#B274A7',
    'Error Red': '#FF0000'
};
// Line widths
const $7831b43083ebf45c$var$tfmStrokes = {
    narrow: 1,
    thick: 4
};



















/*** LAYER SETUP ***/ // First read in the files
// Note that the `require()` function here is provided by our packer, Parcel, not OL or JS
// We do this because geoJSON files aren't ES6 modules and can't be properly `import()`ed.
// !!! SUPER IMPORTANT!!!
// Note that if you're editing these with QGIS, there's a bug that prevents saving geoJSON IDs properly
// QGIS saves IDs as inside `properties`, when the geoJSON spec says they should instead be a top-level member
// See https://github.com/qgis/QGIS/issues/40805 for details
// For now, the workaround is documented in that Github issue, or you can manually move IDs in the geoJSONs
// The IDs are used anywhere the OpenLayer `getId()` function is used, which is a lot of places.
const $7831b43083ebf45c$var$LayerFiles = {
    ground: {
        areas: (parcelRequire("hWw37")),
        labels: (parcelRequire("g5D4G")),
        amenities: (parcelRequire("gqxYO")),
        flows: (parcelRequire("aK4Zw")),
        pictograms: (parcelRequire("ahlg0")),
        outline: (parcelRequire("idVDg"))
    },
    main: {
        areas: (parcelRequire("3l695")),
        labels: (parcelRequire("jBI1A")),
        amenities: (parcelRequire("3cCOO")),
        flows: (parcelRequire("fU9Pp")),
        pictograms: (parcelRequire("fs4wn")),
        outline: (parcelRequire("eQkfl"))
    },
    upper: {
        areas: (parcelRequire("bUglM")),
        labels: (parcelRequire("9p6EU")),
        amenities: (parcelRequire("jq6OK")),
        flows: (parcelRequire("iwyia")),
        pictograms: (parcelRequire("c4azL")),
        outline: (parcelRequire("88e73")),
        easterEggs: (parcelRequire("fwaDN"))
    }
};
// Then load them into OpenLayer VectorSources
// In OpenLayers, each layer is a combination of both a geometry source (the VectorSource) and other data (styles, etc.)
const $7831b43083ebf45c$var$LayerSources = {};
Object.entries($7831b43083ebf45c$var$LayerFiles).forEach(([floor, layers])=>{
    $7831b43083ebf45c$var$LayerSources[floor] = {};
    Object.entries(layers).forEach(([layerName, layer])=>{
        $7831b43083ebf45c$var$LayerSources[floor][layerName] = new (0, $39da9044499339fe$export$2e2bcd8739ae039)({
            features: new (0, $263b744d74718533$export$2e2bcd8739ae039)().readFeatures(layer)
        });
    });
});
// Defining reusable layer styles shared by all the layers of the same type (exhibition areas, amenity icons, etc.)
// They get used and assigned to particular layers in the next section, LayerSettings{}
const $7831b43083ebf45c$var$LayerStyles = {
    // This is a hack to get around an issue with ol-layerswitcher: because our floor switcher "buttons" are actually
    // checkboxes, it's possible to unselect ALL of them and be left with nothing visible on the map.
    // In that case, this layer shows up and tells visitors to choose a floor.
    WarningLayer: [
        new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
            fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                color: 'white'
            }),
            // https://openlayers.org/en/latest/apidoc/module-ol_style_Text-Text.html
            text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                text: "You've unselected all the floors.\nPlease choose a floor to get back into the museum.\n\nPsst... did you know that Field Museum members\n can go behind the scenes of our\ncollections during Members' Nights?\n\nLearn more at fieldmuseum.org/membership.",
                font: '10pt Graphik, sans-serif',
                fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                    color: 'black'
                }),
                overflow: false
            })
        })
    ],
    // When you zoom out far enough, we replace the museum internals with just our name and a message to zoom further in
    ZoomedOutFootprint: [
        new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
            fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                color: $7831b43083ebf45c$var$tfmColors['Field Blue']
            }),
            stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                color: $7831b43083ebf45c$var$tfmColors['Field Blue'],
                width: 3
            }),
            // https://openlayers.org/en/latest/apidoc/module-ol_style_Text-Text.html
            text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                text: "FIELD MUSEUM     ",
                font: 'bold 16pt Druk, sans-serif',
                fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                    color: 'white'
                }),
                overflow: false
            })
        }),
        new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
            // https://openlayers.org/en/latest/apidoc/module-ol_style_Text-Text.html
            text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                text: "(zoom in)     ",
                offsetY: 15,
                font: '8pt Graphik, sans-serif',
                fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                    color: 'white'
                }),
                overflow: false
            })
        })
    ],
    // Various easter eggs
    easterEggs: (feature)=>{
        switch(feature.getId()){
            case 'tardigrade':
                const rawEgg = $7831b43083ebf45c$var$tfmIcons[feature.getId()];
                if (!rawEgg) return;
                const eggSrc = typeof rawEgg === 'string' ? rawEgg : rawEgg.default;
                if (!eggSrc || typeof eggSrc !== 'string') return;
                return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                    image: new (0, $4cbcbd646f2e2083$export$2e2bcd8739ae039)({
                        src: eggSrc,
                        color: 'black',
                        anchorOrigin: 'top-right',
                        anchor: [
                            0,
                            0
                        ],
                        scale: 0.005 / $7831b43083ebf45c$var$tfmView.getResolution()
                    }),
                    text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                        text: 'Hi Andrea!',
                        font: '12pt sans-serif',
                        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                            color: 'black'
                        }),
                        stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                            color: [
                                255,
                                255,
                                255,
                                0.75
                            ],
                            width: $7831b43083ebf45c$var$tfmStrokes.thick
                        }),
                        textAlign: 'left',
                        overflow: true,
                        scale: 0.005 / $7831b43083ebf45c$var$tfmView.getResolution()
                    })
                });
            case 'eye_of_the_lion':
                return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                    text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                        text: "Meow?\nWe love you, Leo,\nand RIP Ozzie",
                        font: '12pt sans-serif',
                        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                            color: $7831b43083ebf45c$var$tfmColors["Field Blue"]
                        }),
                        stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                            color: [
                                255,
                                255,
                                255,
                                0.75
                            ],
                            width: $7831b43083ebf45c$var$tfmStrokes.thick
                        }),
                        textAlign: 'right',
                        offsetX: -50,
                        offsetY: -35,
                        overflow: true,
                        scale: 0.01 / $7831b43083ebf45c$var$tfmView.getResolution()
                    })
                });
            default:
                return;
        }
    },
    // Amenity icons
    // `showAtFarZoom` is the list of amenity IDs (set in geoJSON) that will show up at the `far` zoom level
    // Others show up at `medium` and in
    // You can set zoom levels in the Reusable Settings section, near the top of this file
    amenities: (feature)=>{
        const type = feature.get('type');
        const showAtFarZoom = [
            'elevator',
            'stairs_up',
            'stairs_up_down',
            'stairs_down',
            'restroom',
            'restroom_male',
            'restroom_female',
            'restaurant'
        ];
        const important = showAtFarZoom.includes(feature.get('type'));
        if (!important && $7831b43083ebf45c$var$tfmView.getZoom() < $7831b43083ebf45c$var$tfmZooms.medium) return;
        const rawIcon = $7831b43083ebf45c$var$tfmIcons[type];
        if (!rawIcon) return;
        const iconSrc = typeof rawIcon === 'string' ? rawIcon : rawIcon.default;
        if (!iconSrc || typeof iconSrc !== 'string') {
            console.error(`[Map Error] Parcel returned an invalid asset for amenity "${type}". Got:`, rawIcon);
            return;
        }
        return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
            image: new (0, $4cbcbd646f2e2083$export$2e2bcd8739ae039)({
                src: iconSrc,
                color: 'white',
                scale: important ? $7831b43083ebf45c$var$tfmView.getZoom() < $7831b43083ebf45c$var$tfmZooms.close ? 0.05 : 0.01 / $7831b43083ebf45c$var$tfmView.getResolution() : 0.01 / $7831b43083ebf45c$var$tfmView.getResolution(),
                opacity: important ? 1 : 0.1 / $7831b43083ebf45c$var$tfmView.getResolution() + 0.25
            })
        });
    },
    // Animal glyphs (dinosaurs, lions, and birds, oh my)
    pictograms: (feature)=>{
        const id = feature.getId();
        const coords = feature.getGeometry().getCoordinates();
        const deskew = (angle)=>(angle + 0.95) * Math.PI / 180; // To account for Chicago skewing off true north
        const directions = {
            north: deskew(0),
            east: deskew(90),
            south: deskew(180),
            west: deskew(270)
        };
        switch(id){
            // North entrance
            case 'north_entrance':
                return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                    geometry: new (0, $112514a365e4f8fa$export$2e2bcd8739ae039)(coords),
                    image: new (0, $9d34e7b97dc4a361$export$2e2bcd8739ae039)({
                        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                            color: $7831b43083ebf45c$var$tfmColors["Field Blue"]
                        }),
                        points: 3,
                        radius: 2 / $7831b43083ebf45c$var$tfmView.getResolution(),
                        angle: directions.south
                    }),
                    text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                            color: $7831b43083ebf45c$var$tfmColors["Field Blue"]
                        }),
                        font: 'bold ' + 3 / $7831b43083ebf45c$var$tfmView.getResolution() + 'pt Graphik, sans-serif',
                        text: 'North Entrance',
                        offsetY: -5 / $7831b43083ebf45c$var$tfmView.getResolution()
                    })
                });
            case 'east_entrance':
                return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                    geometry: new (0, $112514a365e4f8fa$export$2e2bcd8739ae039)(coords),
                    image: new (0, $9d34e7b97dc4a361$export$2e2bcd8739ae039)({
                        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                            color: $7831b43083ebf45c$var$tfmColors["Field Blue"]
                        }),
                        points: 3,
                        radius: 2 / $7831b43083ebf45c$var$tfmView.getResolution(),
                        angle: directions.west
                    }),
                    text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                            color: $7831b43083ebf45c$var$tfmColors["Field Blue"]
                        }),
                        font: 'bold ' + 3 / $7831b43083ebf45c$var$tfmView.getResolution() + 'pt Graphik, sans-serif',
                        text: 'East Entrance\n(Accessible)',
                        offsetX: -15 / $7831b43083ebf45c$var$tfmView.getResolution(),
                        offsetY: -1 / $7831b43083ebf45c$var$tfmView.getResolution()
                    })
                });
            case 'south_entrance':
                return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                    geometry: new (0, $112514a365e4f8fa$export$2e2bcd8739ae039)(coords),
                    image: new (0, $9d34e7b97dc4a361$export$2e2bcd8739ae039)({
                        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                            color: $7831b43083ebf45c$var$tfmColors["Field Blue"]
                        }),
                        points: 3,
                        radius: 4 / $7831b43083ebf45c$var$tfmView.getResolution(),
                        angle: directions.north
                    }),
                    text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                            color: $7831b43083ebf45c$var$tfmColors["Field Blue"]
                        }),
                        font: 'bold ' + 6 / $7831b43083ebf45c$var$tfmView.getResolution() + 'pt Graphik, sans-serif',
                        text: 'Main (South) Entrance',
                        textAlign: 'center',
                        offsetY: 8 / $7831b43083ebf45c$var$tfmView.getResolution()
                    })
                });
            default:
                if ($7831b43083ebf45c$var$tfmView.getZoom() < $7831b43083ebf45c$var$tfmZooms.medium) return;
                const rawPicto = $7831b43083ebf45c$var$tfmPictograms[id];
                if (!rawPicto) return;
                const pictoSrc = typeof rawPicto === 'string' ? rawPicto : rawPicto.default;
                if (!pictoSrc || typeof pictoSrc !== 'string') return;
                return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                    image: new (0, $4cbcbd646f2e2083$export$2e2bcd8739ae039)({
                        src: pictoSrc,
                        color: 'white',
                        scale: $7831b43083ebf45c$var$tfmView.getZoom() < $7831b43083ebf45c$var$tfmZooms.close ? 0.1 / $7831b43083ebf45c$var$tfmView.getResolution() : 0.68,
                        opacity: 0.1 / $7831b43083ebf45c$var$tfmView.getResolution() + 0.25
                    })
                });
        }
    },
    // COVID one-way flow arrows
    flows: (feature)=>{
        if ($7831b43083ebf45c$var$tfmView.getZoom() < $7831b43083ebf45c$var$tfmZooms.medium) return;
        if (!$7831b43083ebf45c$var$getCMSDataById(feature.getId()) || $7831b43083ebf45c$var$getCMSDataById(feature.getId()).closed === 'Closed' || $7831b43083ebf45c$var$getCMSDataById(feature.getId()).closed === 'Staff-Only') {
            console.log(`Exhibition "${feature.getId()}" not found in CMS or is closed. Skipping.`, feature);
            return;
        }
        const coords = feature.getGeometry().getCoordinates()[0]; // Returns an array of coordinate pairs
        const endPoint = coords[coords.length - 1];
        const startPoint = coords[0];
        const secondToLastPoint = coords[coords.length - 2];
        // Calculating a rotation angle from two coordinate pairs:
        // https://gist.github.com/conorbuck/2606166
        const rotationAngle = Math.atan2(endPoint[0] - secondToLastPoint[0], endPoint[1] - secondToLastPoint[1]);
        let color;
        try {
            color = $7831b43083ebf45c$var$tfmColors[$7831b43083ebf45c$var$getCMSDataById(feature.getId()).colorCategory];
        } catch (e) {
            if (window.tfmDebug) console.warn(`Flow for exhibition ${$7831b43083ebf45c$var$getCMSDataById(feature.getId())} has no color, falling back to red.`, e, feature);
            color = $7831b43083ebf45c$var$tfmColors['Error Red'];
        }
        return [
            new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                    color: 'white',
                    width: 3 / $7831b43083ebf45c$var$tfmView.getResolution(),
                    lineJoin: 'miter'
                })
            }),
            new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                    color: color,
                    width: 1.5 / $7831b43083ebf45c$var$tfmView.getResolution(),
                    lineJoin: 'miter'
                })
            }),
            new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                geometry: new (0, $112514a365e4f8fa$export$2e2bcd8739ae039)(startPoint),
                image: new (0, $bc4c0f447f32ca45$export$2e2bcd8739ae039)({
                    fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                        color: color
                    }),
                    radius: 2 / $7831b43083ebf45c$var$tfmView.getResolution()
                })
            }),
            new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                geometry: new (0, $112514a365e4f8fa$export$2e2bcd8739ae039)(endPoint),
                image: new (0, $9d34e7b97dc4a361$export$2e2bcd8739ae039)({
                    fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                        color: color
                    }),
                    points: 3,
                    radius: 3 / $7831b43083ebf45c$var$tfmView.getResolution(),
                    angle: rotationAngle
                })
            })
        ];
    },
    // Major exhibition labels
    labels: (feature)=>{
        const labelData = $7831b43083ebf45c$var$getCMSDataById(feature.getId()) ?? undefined;
        if (!labelData) return; // Don't show this label unless it's explicitly added to our CMS
        if (!labelData.closed || labelData.closed === 'Closed' || labelData.closed === 'Staff-Only') return; // Don't show if closed or if the field was never set
        const name = labelData.labelOverride || labelData.shortName;
        let color = $7831b43083ebf45c$var$tfmColors[labelData.colorCategory] ?? $7831b43083ebf45c$var$tfmColors['Error Red']; // Fallback color
        const fontSize = $7831b43083ebf45c$var$tfmView.getZoom() < $7831b43083ebf45c$var$tfmZooms.close ? 10 : 1.5 / $7831b43083ebf45c$var$tfmView.getResolution();
        const labelWidth = $7831b43083ebf45c$var$tfmView.getZoom() < $7831b43083ebf45c$var$tfmZooms.close ? 20 : 3 / $7831b43083ebf45c$var$tfmView.getResolution();
        const labelHeight = $7831b43083ebf45c$var$tfmView.getZoom() < $7831b43083ebf45c$var$tfmZooms.close ? 8 : 1 / $7831b43083ebf45c$var$tfmView.getResolution();
        return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
            // Text parameters: https://openlayers.org/en/latest/apidoc/module-ol_style_Text-Text.html
            text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                text: name + " \xbb",
                font: 'bold ' + fontSize + 'pt Graphik, sans-serif',
                textAlign: labelData.labelAlignment === 'center (default)' ? 'center' : labelData.labelAlignment ?? 'center',
                fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                    color: 'white'
                }),
                backgroundFill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                    color: color
                }),
                padding: [
                    labelHeight,
                    labelWidth,
                    labelHeight,
                    labelWidth
                ],
                overflow: true
            })
        });
    },
    Footprint: new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
            color: 'white'
        })
    }),
    outline: new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
        stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
            color: $7831b43083ebf45c$var$tfmColors["Field Gray"],
            width: $7831b43083ebf45c$var$tfmStrokes.narrow
        })
    }),
    // Areas (exhibition, staff-only, etc.)
    areas: (feature)=>{
        let closed = feature.get('closed') ?? 0; // By default, use the feature's geoJSON "closed" property, or 0 (open) as a fallback
        // But if this feature is in our CMS, use that instead
        if ($7831b43083ebf45c$var$getCMSDataById(feature.getId())) switch($7831b43083ebf45c$var$getCMSDataById(feature.getId()).closed){
            case 'Open':
                closed = 0;
                break;
            case 'Staff-Only':
                closed = 2;
                break;
            case 'Closed':
                closed = 1;
                break;
        }
        switch(closed){
            /*

            // Diagonal gray stripes (not currently used)
            // Previously used for areas temporarily closed due to COVID, but it became too visually confusing
            // So we just mark all closed areas with the same solid gray
            case 1:
                return new Style({
                    // https://viglino.github.io/ol-ext/doc/doc-pages/ol.style.FillPattern.html
                    fill: new FillPattern({
                        pattern: 'hatch',
                        size: tfmStrokes.narrow,
                        angle: 45,
                        color: tfmColors["Field Gray Light"],
                        scale: 0.5,
                    }),

                    stroke: new Stroke({
                        color: tfmColors["Field Gray Light"],
                        width: tfmStrokes.narrow,
                    }),
                })
    */ // Solid gray (closed and staff areas)
            case 1:
            case 2:
                return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                    // https://viglino.github.io/ol-ext/doc/doc-pages/ol.style.FillPattern.html
                    fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                        color: $7831b43083ebf45c$var$tfmColors["Field Gray Light"]
                    }),
                    stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                        color: $7831b43083ebf45c$var$tfmColors["Field Gray Light"],
                        width: $7831b43083ebf45c$var$tfmStrokes.narrow
                    })
                });
            // Open (white background, gray label text if specified in the geoJSON)
            default:
                const color = $7831b43083ebf45c$var$getCMSDataById(feature.getId()) ? $7831b43083ebf45c$var$tfmColors[$7831b43083ebf45c$var$getCMSDataById(feature.getId()).colorCategory] + '88' : 'white';
                return new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
                    stroke: new (0, $3937feddfc329913$export$2e2bcd8739ae039)({
                        color: $7831b43083ebf45c$var$tfmColors["Field Gray Light"],
                        width: $7831b43083ebf45c$var$tfmStrokes.narrow
                    }),
                    fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                        color: 'white'
                    }),
                    text: new (0, $a6a08614ee8fc97a$export$2e2bcd8739ae039)({
                        text: feature.get('label') ? $7831b43083ebf45c$var$tfmView.getZoom() >= $7831b43083ebf45c$var$tfmZooms.medium ? feature.get('label') : '' : null,
                        font: ($7831b43083ebf45c$var$tfmView.getZoom() >= $7831b43083ebf45c$var$tfmZooms.close ? 1.2 / $7831b43083ebf45c$var$tfmView.getResolution() : 8) + 'pt Graphik, sans-serif',
                        fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                            color: $7831b43083ebf45c$var$tfmColors['Field Gray']
                        }),
                        overflow: true,
                        opacity: 0.1 / $7831b43083ebf45c$var$tfmView.getResolution() + 0.25
                    })
                });
        }
    }
};
// Layer settings by layer type
// This is where we define the settings per layer type
const $7831b43083ebf45c$var$LayerSettings = {
    labels: {
        tfmClickable: true,
        tfmLayerType: "label",
        minZoom: $7831b43083ebf45c$var$tfmZooms.far,
        updateWhileInteracting: true,
        updateWhileAnimating: true,
        style: (feature)=>$7831b43083ebf45c$var$LayerStyles.labels(feature)
    },
    pictograms: {
        minZoom: $7831b43083ebf45c$var$tfmZooms.far,
        tfmLayerType: "pictogram",
        tfmClickable: true,
        updateWhileInteracting: true,
        updateWhileAnimating: true,
        style: (feature)=>$7831b43083ebf45c$var$LayerStyles.pictograms(feature)
    },
    flows: {
        minZoom: $7831b43083ebf45c$var$tfmZooms.far,
        updateWhileInteracting: true,
        updateWhileAnimating: true,
        style: (feature)=>$7831b43083ebf45c$var$LayerStyles.flows(feature)
    },
    Footprint: {
        minZoom: $7831b43083ebf45c$var$tfmZooms.far,
        updateWhileInteracting: true,
        updateWhileAnimating: true,
        style: $7831b43083ebf45c$var$LayerStyles.Footprint
    },
    areas: {
        tfmClickable: true,
        tfmLayerType: "area",
        minZoom: $7831b43083ebf45c$var$tfmZooms.far,
        updateWhileInteracting: true,
        updateWhileAnimating: true,
        style: (feature)=>$7831b43083ebf45c$var$LayerStyles.areas(feature)
    },
    outline: {
        minZoom: $7831b43083ebf45c$var$tfmZooms.far,
        updateWhileInteracting: true,
        updateWhileAnimating: true,
        style: $7831b43083ebf45c$var$LayerStyles.outline
    },
    amenities: {
        minZoom: $7831b43083ebf45c$var$tfmZooms.far,
        updateWhileInteracting: true,
        updateWhileAnimating: true,
        style: (feature)=>$7831b43083ebf45c$var$LayerStyles.amenities(feature)
    },
    easterEggs: {
        minZoom: 22,
        tfmLayerType: "easteregg",
        updateWhileAnimating: true,
        updateWhileInteracting: true,
        style: (feature)=>$7831b43083ebf45c$var$LayerStyles.easterEggs(feature)
    }
};
/*
 This is where we actually initiate the layers, combining their sources and their settings (which also include their styles).

 A "floor" is a just a group of layers for a specific floor of the museum, but we group them for easy switching
 Each floor should at least have a solid footprint and areas, otherwise the base layer (OSM/Google Maps) will show through
 The other stuff (flows, labels, amenities, pictograms, etc.) are helpful for visitors but not strictly necessary if you want to disable them

 Once they are added here, they also automatically get added to the floor switcher based on `LayerGroups`. Setting a group's type to `base` will make them
 mutually exclusive (only one base can be selected at a time). This behavior is due to change in a future version of `ol-layerswitcher`.
*/ const $7831b43083ebf45c$var$Floors = {
    upper: new (0, $827vD.default)({
        title: 'Upper<br>Level',
        type: 'base',
        layers: [
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.upper.outline,
                ...$7831b43083ebf45c$var$LayerSettings.Footprint
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.upper.areas,
                ...$7831b43083ebf45c$var$LayerSettings.areas
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.upper.outline,
                ...$7831b43083ebf45c$var$LayerSettings.outline
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.upper.amenities,
                ...$7831b43083ebf45c$var$LayerSettings.amenities
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.upper.flows,
                ...$7831b43083ebf45c$var$LayerSettings.flows
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.upper.pictograms,
                ...$7831b43083ebf45c$var$LayerSettings.pictograms
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.upper.labels,
                ...$7831b43083ebf45c$var$LayerSettings.labels
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.upper.easterEggs,
                ...$7831b43083ebf45c$var$LayerSettings.easterEggs
            })
        ]
    }),
    main: new (0, $827vD.default)({
        title: 'Main<br>Level',
        type: 'base',
        layers: [
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.main.outline,
                ...$7831b43083ebf45c$var$LayerSettings.Footprint
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.main.areas,
                ...$7831b43083ebf45c$var$LayerSettings.areas
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.main.outline,
                ...$7831b43083ebf45c$var$LayerSettings.outline
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.main.amenities,
                ...$7831b43083ebf45c$var$LayerSettings.amenities
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.main.flows,
                ...$7831b43083ebf45c$var$LayerSettings.flows
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.main.pictograms,
                ...$7831b43083ebf45c$var$LayerSettings.pictograms
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.main.labels,
                ...$7831b43083ebf45c$var$LayerSettings.labels
            })
        ]
    }),
    ground: new (0, $827vD.default)({
        title: 'Ground<br>Level',
        type: 'base',
        layers: [
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.ground.outline,
                ...$7831b43083ebf45c$var$LayerSettings.Footprint
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.ground.areas,
                ...$7831b43083ebf45c$var$LayerSettings.areas
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.ground.outline,
                ...$7831b43083ebf45c$var$LayerSettings.outline
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.ground.amenities,
                ...$7831b43083ebf45c$var$LayerSettings.amenities
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.ground.flows,
                ...$7831b43083ebf45c$var$LayerSettings.flows
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.ground.pictograms,
                ...$7831b43083ebf45c$var$LayerSettings.pictograms
            }),
            new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
                source: $7831b43083ebf45c$var$LayerSources.ground.labels,
                ...$7831b43083ebf45c$var$LayerSettings.labels
            })
        ]
    })
};
















// Amenity & easter egg icons
// Note that the "require" functionality here comes from Parcel. If you were using webpack or another bundler, you may have to change this.
const $7831b43083ebf45c$var$tfmIcons = {
    atm: (parcelRequire("2AGdU")),
    picnic_area: (parcelRequire("dxhQh")),
    elevator: (parcelRequire("90N3t")),
    first_aid: (parcelRequire("7tgBd")),
    guest_services: (parcelRequire("eNxXC")),
    restaurant: (parcelRequire("cZ3ts")),
    restroom: (parcelRequire("bSt4G")),
    restroom_female: (parcelRequire("9aQ7c")),
    restroom_male: (parcelRequire("9JHfT")),
    stairs_down: (parcelRequire("jb1md")),
    stairs_up: (parcelRequire("1k6qE")),
    stairs_up_down: (parcelRequire("1DlVp")),
    store: (parcelRequire("kaL7w")),
    stroller: (parcelRequire("DczzH")),
    wheelchair: (parcelRequire("8cFji")),
    tardigrade: (parcelRequire("384Xa"))
};













// Pictograms (animals, dinosaurs, etc.)
// Note that the "require" functionality here comes from Parcel. If you were using webpack or another bundler, you may have to change this.
const $7831b43083ebf45c$var$tfmPictograms = {
    bird: (parcelRequire("iRhd6")),
    maximo: (parcelRequire("18Ryp")),
    lion: (parcelRequire("9fa7R")),
    totems: (parcelRequire("6Awgk")),
    elephant: (parcelRequire("1qupS")),
    mask: (parcelRequire("lPfbX")),
    pawnee_lodge: (parcelRequire("5xWGq")),
    bushman: (parcelRequire("bqkno")),
    sarcophagus: (parcelRequire("9GflJ")),
    sue: (parcelRequire("2c5rJ")),
    trike: (parcelRequire("lCHsg")),
    stone_lion: (parcelRequire("cALjL")),
    maori_house: (parcelRequire("hpcON"))
};
/*** SET UP THE VIEW AND MAP ***/ // Configure the starting view
// Desktop starts zoomed out and centered
let $7831b43083ebf45c$var$startingCenter = [
    -9753485.091128012,
    5140954.467297794
];
let $7831b43083ebf45c$var$startingZoom = $7831b43083ebf45c$var$tfmZooms.medium - 0.5;
// Mobile view starts at main entrance
if (window.innerWidth < 568) {
    $7831b43083ebf45c$var$startingCenter = [
        -9753482.603269964,
        5140884.392571496
    ];
    $7831b43083ebf45c$var$startingZoom = $7831b43083ebf45c$var$tfmZooms.medium + 0.5;
}
// Create the view
const $7831b43083ebf45c$var$tfmView = new (0, $2412fb7b3f599275$export$2e2bcd8739ae039)({
    center: $7831b43083ebf45c$var$startingCenter,
    zoom: $7831b43083ebf45c$var$startingZoom,
    maxZoom: 27,
    minZoom: 16,
    constrainRotation: false,
    rotation: 0.95 * Math.PI / 180,
    enableRotation: true
});
// Create the map
const $7831b43083ebf45c$var$tfmMap = new (0, $3b011be35c8c50b9$export$2e2bcd8739ae039)({
    layers: [
        // Exterior basemap
        new (0, $48eb5b5cbbaa3e86$export$2e2bcd8739ae039)({
            source: new (0, $937dc7db0d2828fe$export$2e2bcd8739ae039)({
                attributions: [
                    'Built with <a href="https://openlayers.org/" target="_blank">OpenLayers</a> and <a href="https://qgis.org/" target="_blank">QGIS</a><br>Exterior map \xa9 <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a>'
                ]
            }),
            opacity: 0.25
        }),
        // Warning/secret layer in case the floor picker accidentally unselects all floors
        // This is necessary due to https://github.com/walkermatt/ol-layerswitcher/pull/360
        new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
            minZoom: $7831b43083ebf45c$var$tfmZooms.far,
            source: $7831b43083ebf45c$var$LayerSources.upper.outline,
            style: $7831b43083ebf45c$var$LayerStyles.WarningLayer,
            updateWhileInteracting: true
        }),
        // Simple museum outline for zoom levels <=16
        new (0, $7caf9a9f13481091$export$2e2bcd8739ae039)({
            maxZoom: $7831b43083ebf45c$var$tfmZooms.far,
            source: $7831b43083ebf45c$var$LayerSources.ground.outline,
            updateWhileInteracting: true,
            style: $7831b43083ebf45c$var$LayerStyles.ZoomedOutFootprint
        }),
        $7831b43083ebf45c$var$Floors.upper,
        $7831b43083ebf45c$var$Floors.main,
        $7831b43083ebf45c$var$Floors.ground
    ],
    interactions: (0, $743928848f7f47be$export$ebe90cb607ad99e)({
        altShiftDragRotate: false,
        pinchRotate: false,
        doubleClickZoom: true
    }),
    target: 'map',
    keyboardEventTarget: document,
    view: $7831b43083ebf45c$var$tfmView
});
// Add layerswitcher controls
// https://github.com/walkermatt/ol-layerswitcher#api
// We use this as the floor switcher
let $7831b43083ebf45c$var$layerSwitcher = new (0, (/*@__PURE__*/$parcel$interopDefault($a3fba972a31f119a$exports)))({
    reverse: false,
    startActive: true,
    activationMode: 'click',
    groupSelectStyle: 'group'
});
$7831b43083ebf45c$var$tfmMap.addControl($7831b43083ebf45c$var$layerSwitcher);
$7831b43083ebf45c$var$layerSwitcher.showPanel();
// Once the map renders
$7831b43083ebf45c$var$tfmMap.once('rendercomplete', function(event) {
    $7831b43083ebf45c$var$switchFloors('main'); // Default to the main floor
    $7831b43083ebf45c$var$zoomToHash(); // Go to the area specified in the URL, if any
    // Preload sidebar images
    Object.entries($7831b43083ebf45c$var$CMSData).forEach(([k, v])=>{
        if (v && v.image?.url) {
            const thumbnailUrl = v.image.url;
            $7831b43083ebf45c$var$preloadImage(thumbnailUrl);
        }
    });
    $7831b43083ebf45c$var$tfmMap.renderSync(); // Redraw the map
});
window.addEventListener('hashchange', $7831b43083ebf45c$var$zoomToHash); // If someone manually types in a new hash with the map open
/*** CLICK HANDLER ***/ // We use map.onClick instead of OL's selection event because this seems more reliable... the selection event
// doesn't always catch clicks outside of features, so closing the sidebar becomes hard
$7831b43083ebf45c$var$tfmMap.on('click', (e)=>{
    if (window.tfmDebug) console.log('Click event:', e);
    let counter = 0; // Ideally we want to find one feature only, not zero or more than one, but there isn't a forFirstFeatureAtPixel event
    $7831b43083ebf45c$var$tfmMap.forEachFeatureAtPixel(e.pixel, (feature, layer)=>{
        if (counter > 0) return; // We only want the first feature, not all the ones beneath it
        counter++;
        // If nothing was clicked on, close the sidebar and return
        if (!feature && !layer || !feature.getId() || !$7831b43083ebf45c$var$getCMSDataById(feature.getId())) {
            $7831b43083ebf45c$var$closeSidebar();
            return;
        }
        // Setup
        const currentLevel = $7831b43083ebf45c$var$Floors.upper.getVisible() ? 'upper' : $7831b43083ebf45c$var$Floors.main.getVisible() ? 'main' : $7831b43083ebf45c$var$Floors.ground.getVisible() ? 'ground' : null;
        const tfmLayerType = layer.get('tfmLayerType');
        const id = feature.getId();
        const data = $7831b43083ebf45c$var$getCMSDataById(id) ?? null;
        // Debug info
        if (window.tfmDebug) {
            console.log(`Clicked on feature "${feature.getId()}", data:`, data);
            console.log(`Located in layer (type: ${tfmLayerType ?? undefined}):`, layer);
        }
        // Do different things depending on the layer type that was clicked on.
        // tfmLayerType is a custom parameter we set to each layer in LayerSettings{}
        switch(tfmLayerType){
            // Exhibitions and other areas
            case 'area':
                // Closed areas should not be clickable
                if (data && (data.closed === 'Closed' || data.closed === 'Staff-Only')) return; // Check CMS first
                else if (feature.get('closed') > 0) return;
                // Only focus if it's in our CMS (i.e. has content added by an editor)
                if (data) {
                    $7831b43083ebf45c$var$zoomToFeature(feature, currentLevel);
                    $7831b43083ebf45c$var$setHash(currentLevel, id);
                }
                break;
            case 'label':
                // Try to find a matching pictogram on this floor, with CMS data
                if ($7831b43083ebf45c$var$LayerSources[currentLevel].pictograms.getFeatureById(id) && data) {
                    $7831b43083ebf45c$var$zoomToFeature($7831b43083ebf45c$var$LayerSources[currentLevel].pictograms.getFeatureById(id));
                    $7831b43083ebf45c$var$setHash(currentLevel, id);
                } else {
                    $7831b43083ebf45c$var$zoomToFeature($7831b43083ebf45c$var$LayerSources[currentLevel].areas.getFeatureById(id), currentLevel);
                    $7831b43083ebf45c$var$setHash(currentLevel, id);
                }
                break;
            case 'pictogram':
                // Closed areas should not be clickable
                if (data && (data.closed === 'Closed' || data.closed === 'Staff-Only')) return;
                if (id && data) {
                    $7831b43083ebf45c$var$zoomToFeature(feature);
                    $7831b43083ebf45c$var$setHash(currentLevel, id);
                }
                break;
        }
    }, {
        layerFilter: (layer)=>{
            return layer.get('tfmClickable');
        }
    });
    if (!counter) $7831b43083ebf45c$var$closeSidebar(); // If no features were detected at all
});
/*** KEYBOARD SHORTCUTS ***/ document.onkeydown = function(evt) {
    evt = evt || window.event; // janky polyfill
    switch(evt.key){
        case "Escape":
        case "Esc":
            $7831b43083ebf45c$var$closeSidebar();
            break;
        case "1":
            $7831b43083ebf45c$var$closeSidebar();
            $7831b43083ebf45c$var$switchFloors('ground');
            $7831b43083ebf45c$var$fitFloor('ground');
            break;
        case "2":
            $7831b43083ebf45c$var$closeSidebar();
            $7831b43083ebf45c$var$switchFloors('main');
            $7831b43083ebf45c$var$fitFloor('main');
            break;
        case "3":
            $7831b43083ebf45c$var$closeSidebar();
            $7831b43083ebf45c$var$switchFloors('upper');
            $7831b43083ebf45c$var$fitFloor('upper');
            break;
        // By default, OpenLayers only uses the + sign for zooming. This code makes the = sign also emulate
        // that behavior so you don't have to hold down the shift key
        case "=":
            $7831b43083ebf45c$var$tfmView.animate({
                zoom: $7831b43083ebf45c$var$tfmView.getZoom() + 1,
                duration: 100
            });
            break;
        case "0":
            $7831b43083ebf45c$var$closeSidebar();
            break;
    }
};
/*** DEBUG HELPERS ***/ // For easier debugging inside the console
if (window.tfmDebug) {
    window.tfmMap = $7831b43083ebf45c$var$tfmMap;
    window.tfmView = $7831b43083ebf45c$var$tfmView;
    window.contentfulData = $7831b43083ebf45c$var$CMSData;
}
/*** HELPER FUNCTIONS ***/ // Zoom to a specified feature (usually an area or pictogram)
// In the case of areas, also highlight them with a different color, basically a desaturated version of its specified color
let $7831b43083ebf45c$var$lastZoomedFeature;
function $7831b43083ebf45c$var$zoomToFeature(feature, currentLevel = null) {
    const id = feature.getId();
    const geometry = feature.getGeometry();
    const data = $7831b43083ebf45c$var$getCMSDataById(id);
    $7831b43083ebf45c$var$resetHighlight();
    // Map padding
    let myPadding = [
        20,
        400,
        20,
        20
    ];
    let myZoom = $7831b43083ebf45c$var$tfmZooms.close;
    // For smaller devices
    if (window.innerWidth <= 500) {
        myZoom = $7831b43083ebf45c$var$tfmZooms.medium;
        // Set the bottom padding so the popup doesn't hide the exhibition
        myPadding = [
            10,
            10,
            window.innerHeight * .7 + 10,
            10
        ]; // Equal to the sidebar.open height (in vh units) in index.css, line 236 or so
    }
    // If there's an area with a matching ID, highlight it
    // We have to do this search because OpenLayers doesn't have an easy way to return a layer from a feature
    if (currentLevel && $7831b43083ebf45c$var$LayerSources[currentLevel].areas.getFeatureById(id)) {
        // Highlight areas with a lighter version of its color
        if (!data) return;
        if (!data.colorCategory) data.colorCategory = "Error Red"; // Set default color
        feature.setStyle(new (0, $ef61ac9807995b8c$export$2e2bcd8739ae039)({
            fill: new (0, $423e8acaae3939a9$export$2e2bcd8739ae039)({
                color: $7831b43083ebf45c$var$tfmColors[data.colorCategory] + '88'
            })
        }));
    }
    // Zoom to fit the feature
    $7831b43083ebf45c$var$tfmView.fit(geometry, {
        maxZoom: myZoom,
        duration: 500,
        padding: myPadding
    });
    $7831b43083ebf45c$var$createSidebar(data);
    $7831b43083ebf45c$var$openSidebar();
    $7831b43083ebf45c$var$lastZoomedFeature = feature;
}
// Create/re-create the sidebar with CMS data for a given POI
// Does NOT open it.
function $7831b43083ebf45c$var$createSidebar(poi) {
    // Don't open the sidebar if this is invalid
    if (!poi || !poi) {
        if (window.tfmDebug) console.warn('Invalid POI for sidebar creation. POI should be a Contentful API entry.', poi);
        return false;
    }
    // Resize image
    const imageURL = poi.image?.url ?? null;
    let sidebarText = "<div id='sidebar-close-button'>&#10005;</div>";
    sidebarText += "<div id='sidebar-content'>";
    sidebarText += "<h2>" + poi.fullName + "</h2>";
    if (window.tfmDebug === true) {
        sidebarText += '<hr>';
        sidebarText += '<h3>Debug info</h3>';
        sidebarText += `<a href="https://field-museum.admin.datocms.com/editor/item_types/1544690/items/${poi.id}/edit" target="_blank">Edit in DatoCMS: POI #${poi.id}</a>`;
        sidebarText += '<ul>';
        if (poi.mapId) sidebarText += `<li><b>Map ID:</b> ${poi.mapId}</li>`;
        sidebarText += `<li><b>Short Name:</b> ${poi.shortName}</li>`;
        if (poi.fullName) sidebarText += `<li><b>Full Name:</b> ${poi.fullName}</li>`;
        if (poi.labelOverride) sidebarText += `<li><b>Label Override:</b> <pre style="margin: 0">${poi.labelOverride}</pre></li>`;
        if (poi.labelAlignment) sidebarText += `<li><b>Label Alignment:</b> ${poi.labelAlignment}</li>`;
        if (poi.colorCategory) sidebarText += `<li><b>Color Category:</b> <span style="background-color: ${$7831b43083ebf45c$var$tfmColors[poi.colorCategory]}; color: white; padding: 0 5px">${poi.colorCategory}</span></li>`;
        sidebarText += '</ul>';
        sidebarText += '<hr>';
    }
    // Add a link if it's provided in the CMS
    const linkURL = poi && poi.websiteUrl && poi.websiteUrl.length ? new URL(poi.websiteUrl) : false;
    if (linkURL) {
        // Add UTM params to our outgoing URLs
        const utmParams = {
            source: "field",
            medium: "map"
        };
        Object.entries(utmParams).forEach(([k, v])=>linkURL.searchParams.set(`utm_${k}`, v));
        // Add the link
        sidebarText += `<p><a href='${linkURL.href}'><img src='${imageURL}'"></p>`;
        sidebarText += `<button style="background-color: ${$7831b43083ebf45c$var$tfmColors[poi.colorCategory]};" class="poi-learn-more-button">Learn More</button></a>`;
    } else if (imageURL) sidebarText += `<p><img src='${imageURL}'"></p>`;
    sidebarText += `<div id="sidebar-poi-description">${poi.description}</div>`;
    sidebarText += '<p><a href="#" id="sidebar-go-back-link">\xab Return to map</a></p>';
    sidebarText += "<div>";
    // Replace the sidebar
    document.getElementById('tfm-sidebar').dataset.featureId = poi.id;
    document.getElementById('tfm-sidebar').style.borderColor = $7831b43083ebf45c$var$tfmColors[poi.colorCategory];
    document.getElementById('tfm-sidebar').innerHTML = sidebarText;
    // Add event listeners
    document.getElementById('tfm-sidebar').scrollTop = 0; // Scroll back up to the top
    document.getElementById('sidebar-close-button').addEventListener('click', $7831b43083ebf45c$var$closeSidebar);
    document.getElementById('sidebar-go-back-link').addEventListener('click', $7831b43083ebf45c$var$closeSidebar);
    // Also set document title to indicate current sidebar
    document.title = poi.shortName + " - Field Museum Map";
}
// Open the sidebar. Use createSidebar() to create or update it first.
function $7831b43083ebf45c$var$openSidebar() {
    document.getElementById('tfm-sidebar').className = 'open';
}
// Close the sidebar, clear highlights, reset the title and hash
function $7831b43083ebf45c$var$closeSidebar() {
    $7831b43083ebf45c$var$resetHighlight();
    document.getElementById('tfm-sidebar').className = 'closed';
    document.title = "Field Museum Map";
    location.hash = '';
}
// Update the URL hash (like #ground.egypt)
function $7831b43083ebf45c$var$setHash(level, id) {
    location.hash = level + '.' + id;
}
// Reset previously selected feature if one already exists
function $7831b43083ebf45c$var$resetHighlight() {
    if ($7831b43083ebf45c$var$lastZoomedFeature) {
        $7831b43083ebf45c$var$lastZoomedFeature.setStyle(undefined); // Reset style
        $7831b43083ebf45c$var$lastZoomedFeature = null;
    }
}
// Manually switch to one floor or another
// Note that ol-layerswitcher does NOT do this; it has its own internal logic
// But it doesn't expose its methods, so we have to try to recreate it on our own
// We use this function in permalinks and keyboard shortcuts
function $7831b43083ebf45c$var$switchFloors(level) {
    Object.entries($7831b43083ebf45c$var$Floors).forEach(([floor, data])=>{
        $7831b43083ebf45c$var$Floors[floor].setVisible(floor === level);
    });
    $7831b43083ebf45c$var$layerSwitcher.renderPanel(); // Resync the layer switcher
}
// Fit the entire floor in the viewport
// Right now only used by the keyboard shortcuts
// You might want to use this to zoom back out to the whole floor whenever a sidebar is closed... maybe?
function $7831b43083ebf45c$var$fitFloor(level) {
    $7831b43083ebf45c$var$tfmMap.once('rendercomplete', ()=>{
        $7831b43083ebf45c$var$tfmView.fit($7831b43083ebf45c$var$LayerSources[level].outline.getExtent(), {
            padding: [
                50,
                50,
                100,
                50
            ],
            duration: 500
        });
    });
}
// Given a floor and/or exhibition (like #ground.egypt), zoom to it and pull up its sidebar, if relevant
function $7831b43083ebf45c$var$zoomToHash() {
    if (location.hash === undefined || location.hash === '') return;
    const hash = location.hash.substring(1);
    const matches = hash.match(/(.+?)(?:\.(.+))?$/); // expected format is #level.feature_id, like #main.maximo or #upper.evolving_planet
    const level = matches[1];
    const id = matches[2];
    // Make the specified level visible
    if (level && Object.keys($7831b43083ebf45c$var$Floors).includes(level)) {
        $7831b43083ebf45c$var$switchFloors(level);
        // If an ID was also specified, zoom to it
        if (id) $7831b43083ebf45c$var$tfmMap.once('rendercomplete', ()=>{
            if ($7831b43083ebf45c$var$LayerSources[level].areas.getFeatureById(id)) $7831b43083ebf45c$var$zoomToFeature($7831b43083ebf45c$var$LayerSources[level].areas.getFeatureById(id), level);
            else if ($7831b43083ebf45c$var$LayerSources[level].pictograms.getFeatureById(id)) $7831b43083ebf45c$var$zoomToFeature($7831b43083ebf45c$var$LayerSources[level].pictograms.getFeatureById(id));
            else console.warn(`Warning: Cannot zoom to invalid id "${id}" on ${level} floor`);
        });
        else $7831b43083ebf45c$var$fitFloor(level);
    } else {
        console.warn('Warning: Could not zoom to invalid floor: ', level);
        console.info('Valid floors are: ', Object.keys($7831b43083ebf45c$var$Floors).join(", "));
    }
}
// This preloads all the sidebar images
// Don't call this until the map is fully rendered, or you'd impact load time
function $7831b43083ebf45c$var$preloadImage(url = null) {
    if (!url) return;
    try {
        var _img = new Image();
        _img.src = url;
    } catch (e) {
        if (window.tfmDebug) console.warn(e);
    }
}
const $7831b43083ebf45c$var$getCMSDataById = (id)=>$7831b43083ebf45c$var$CMSData.find((item)=>item.mapId === id);


//# sourceMappingURL=path0.8db0bcdf.js.map
